//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class IConfig {
    getAuthorization!: () => Promise<string>;
    getAdditionalHeaders!: () => Headers;
}

export class AuthorizedApiBase {
    private readonly config: IConfig;

    protected constructor(config: IConfig) {
        this.config = config;
    }
    
    public getInstance(): AxiosInstance {
        return this.instance;
    }

    protected transformOptions = async (options: RequestInit): Promise<RequestInit> => {
        const additionalHeaders: Headers = this.config.getAdditionalHeaders(); 
        const headersCopy: Record<string, string> = {};
        if (additionalHeaders instanceof Headers) {
            additionalHeaders.forEach((value: string, name:string) => {
                headersCopy[name] = value;
            });
        }
        
        
        const token = await this.config.getAuthorization()
        options.headers = {
            ...options.headers,
            Authorization: token,
            ...headersCopy,
        };
        
        return Promise.resolve(options);
    };
}

export interface IAccountClient {
    /**
     * Collects primary account name and ax number with all ax references AxTitle and AxNumber.
     * @return Success
     */
    getAccountNamesAndAxNumbers(): Promise<AccountNameWithAxNumber[]>;
    /**
     * Collects all account names and ax numbers given the user is in the Cloud Onboarding team.
     * @param body (optional) 
     * @return Success
     */
    getAllAccountNamesAndAxNumbersForOnboarding(body: AccountSearchQuery | undefined): Promise<AccountNameWithAxNumber[]>;
    /**
     * @return Success
     */
    getAllAccountsForCrmAccountTeamSync(): Promise<AccountCRMAccountTeamSyncDTO[]>;
    /**
     * @return Success
     */
    getAccountsForCrmAccountTeamByAxAccountSync(axNumber: string): Promise<AccountCRMAccountTeamSyncDTO>;
    /**
     * @return Success
     */
    getAxNumberFromAccountId(accountId: number): Promise<string>;
}

export class AccountClient extends AuthorizedApiBase implements IAccountClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Collects primary account name and ax number with all ax references AxTitle and AxNumber.
     * @return Success
     */
    getAccountNamesAndAxNumbers( cancelToken?: CancelToken): Promise<AccountNameWithAxNumber[]> {
        let url_ = this.baseUrl + "/api/Account/account-names-with-ax";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccountNamesAndAxNumbers(_response);
        });
    }

    protected processGetAccountNamesAndAxNumbers(response: AxiosResponse): Promise<AccountNameWithAxNumber[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountNameWithAxNumber.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AccountNameWithAxNumber[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountNameWithAxNumber[]>(null as any);
    }

    /**
     * Collects all account names and ax numbers given the user is in the Cloud Onboarding team.
     * @param body (optional) 
     * @return Success
     */
    getAllAccountNamesAndAxNumbersForOnboarding(body: AccountSearchQuery | undefined, cancelToken?: CancelToken): Promise<AccountNameWithAxNumber[]> {
        let url_ = this.baseUrl + "/api/Account/all/account-names-with-ax-numbers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllAccountNamesAndAxNumbersForOnboarding(_response);
        });
    }

    protected processGetAllAccountNamesAndAxNumbersForOnboarding(response: AxiosResponse): Promise<AccountNameWithAxNumber[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountNameWithAxNumber.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AccountNameWithAxNumber[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountNameWithAxNumber[]>(null as any);
    }

    /**
     * @return Success
     */
    getAllAccountsForCrmAccountTeamSync( cancelToken?: CancelToken): Promise<AccountCRMAccountTeamSyncDTO[]> {
        let url_ = this.baseUrl + "/api/Account/all/crm-account-team-sync";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllAccountsForCrmAccountTeamSync(_response);
        });
    }

    protected processGetAllAccountsForCrmAccountTeamSync(response: AxiosResponse): Promise<AccountCRMAccountTeamSyncDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountCRMAccountTeamSyncDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AccountCRMAccountTeamSyncDTO[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountCRMAccountTeamSyncDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    getAccountsForCrmAccountTeamByAxAccountSync(axNumber: string, cancelToken?: CancelToken): Promise<AccountCRMAccountTeamSyncDTO> {
        let url_ = this.baseUrl + "/api/Account/account/{axNumber}/crm-account-team-sync";
        if (axNumber === undefined || axNumber === null)
            throw new Error("The parameter 'axNumber' must be defined.");
        url_ = url_.replace("{axNumber}", encodeURIComponent("" + axNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccountsForCrmAccountTeamByAxAccountSync(_response);
        });
    }

    protected processGetAccountsForCrmAccountTeamByAxAccountSync(response: AxiosResponse): Promise<AccountCRMAccountTeamSyncDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountCRMAccountTeamSyncDTO.fromJS(resultData200);
            return Promise.resolve<AccountCRMAccountTeamSyncDTO>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountCRMAccountTeamSyncDTO>(null as any);
    }

    /**
     * @return Success
     */
    getAxNumberFromAccountId(accountId: number, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Account/account/{accountId}/axnumber";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAxNumberFromAccountId(_response);
        });
    }

    protected processGetAxNumberFromAccountId(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface IAccountAdminClient {
    /**
     * @return Success
     */
    getAccountNotifications(): Promise<AccountNotifications>;
    /**
     * @return Success
     */
    getAccountReports(): Promise<AdminDashboardReports>;
    /**
     * @return Success
     */
    getOtherAccounts(accountId: number): Promise<AccountResponse>;
    /**
     * @return Success
     */
    getAccounts(): Promise<AccountResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    approveUsers(body: ProfileApprovals | undefined): Promise<ApprovalResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updatePermissionsOfMultipleUsers(body: BulkPermissionsUpdateDTO | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateUser(body: UpdateUserObject | undefined): Promise<ApprovalResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    rejectUser(body: number | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    createUser(body: Contact | undefined): Promise<ApprovalResponse>;
    /**
     * @return Success
     */
    getUserProfiles(): Promise<UserProfileManager>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getPagedUserProfiles(body: UserProfilesRequest | undefined): Promise<UserProfileManager>;
    /**
     * @return Success
     */
    getAccountAdminBasicInfo(): Promise<UserManagementBasicInfo>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getPagedInactiveUsers(body: UserProfilesRequest | undefined): Promise<PagedUserResponse_1OfContact>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getPagedActiveUsers(body: UserProfilesRequest | undefined): Promise<PagedUserResponse_1OfContact>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getApprovedUsers(body: UserProfilesRequest | undefined): Promise<PagedUserResponse_1OfUserProfileDTO>;
    /**
     * @return Success
     */
    getAwaitingApprovalUsers(): Promise<UserProfile[]>;
    /**
     * @return Success
     */
    getMappedUserProfiles(): Promise<UserProfile[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getAccountDevices(body: AccountDeviceRequest | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    setManualEmailRequired(body: ToggleManualEmailRequest | undefined): Promise<AccountResponse>;
}

export class AccountAdminClient extends AuthorizedApiBase implements IAccountAdminClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getAccountNotifications( cancelToken?: CancelToken): Promise<AccountNotifications> {
        let url_ = this.baseUrl + "/api/AccountAdmin/accountNotifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccountNotifications(_response);
        });
    }

    protected processGetAccountNotifications(response: AxiosResponse): Promise<AccountNotifications> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountNotifications.fromJS(resultData200);
            return Promise.resolve<AccountNotifications>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountNotifications>(null as any);
    }

    /**
     * @return Success
     */
    getAccountReports( cancelToken?: CancelToken): Promise<AdminDashboardReports> {
        let url_ = this.baseUrl + "/api/AccountAdmin/dashreports";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccountReports(_response);
        });
    }

    protected processGetAccountReports(response: AxiosResponse): Promise<AdminDashboardReports> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AdminDashboardReports.fromJS(resultData200);
            return Promise.resolve<AdminDashboardReports>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AdminDashboardReports>(null as any);
    }

    /**
     * @return Success
     */
    getOtherAccounts(accountId: number, cancelToken?: CancelToken): Promise<AccountResponse> {
        let url_ = this.baseUrl + "/api/AccountAdmin/accounts/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOtherAccounts(_response);
        });
    }

    protected processGetOtherAccounts(response: AxiosResponse): Promise<AccountResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountResponse.fromJS(resultData200);
            return Promise.resolve<AccountResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountResponse>(null as any);
    }

    /**
     * @return Success
     */
    getAccounts( cancelToken?: CancelToken): Promise<AccountResponse> {
        let url_ = this.baseUrl + "/api/AccountAdmin/accounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccounts(_response);
        });
    }

    protected processGetAccounts(response: AxiosResponse): Promise<AccountResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountResponse.fromJS(resultData200);
            return Promise.resolve<AccountResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approveUsers(body: ProfileApprovals | undefined, cancelToken?: CancelToken): Promise<ApprovalResponse> {
        let url_ = this.baseUrl + "/api/AccountAdmin/approve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApproveUsers(_response);
        });
    }

    protected processApproveUsers(response: AxiosResponse): Promise<ApprovalResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApprovalResponse.fromJS(resultData200);
            return Promise.resolve<ApprovalResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApprovalResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePermissionsOfMultipleUsers(body: BulkPermissionsUpdateDTO | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/AccountAdmin/users/permissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePermissionsOfMultipleUsers(_response);
        });
    }

    protected processUpdatePermissionsOfMultipleUsers(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUser(body: UpdateUserObject | undefined, cancelToken?: CancelToken): Promise<ApprovalResponse> {
        let url_ = this.baseUrl + "/api/AccountAdmin/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUser(_response);
        });
    }

    protected processUpdateUser(response: AxiosResponse): Promise<ApprovalResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApprovalResponse.fromJS(resultData200);
            return Promise.resolve<ApprovalResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApprovalResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    rejectUser(body: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/AccountAdmin/reject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRejectUser(_response);
        });
    }

    protected processRejectUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUser(body: Contact | undefined, cancelToken?: CancelToken): Promise<ApprovalResponse> {
        let url_ = this.baseUrl + "/api/AccountAdmin/user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUser(_response);
        });
    }

    protected processCreateUser(response: AxiosResponse): Promise<ApprovalResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApprovalResponse.fromJS(resultData200);
            return Promise.resolve<ApprovalResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApprovalResponse>(null as any);
    }

    /**
     * @return Success
     */
    getUserProfiles( cancelToken?: CancelToken): Promise<UserProfileManager> {
        let url_ = this.baseUrl + "/api/AccountAdmin/users";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserProfiles(_response);
        });
    }

    protected processGetUserProfiles(response: AxiosResponse): Promise<UserProfileManager> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserProfileManager.fromJS(resultData200);
            return Promise.resolve<UserProfileManager>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserProfileManager>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPagedUserProfiles(body: UserProfilesRequest | undefined, cancelToken?: CancelToken): Promise<UserProfileManager> {
        let url_ = this.baseUrl + "/api/AccountAdmin/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPagedUserProfiles(_response);
        });
    }

    protected processGetPagedUserProfiles(response: AxiosResponse): Promise<UserProfileManager> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserProfileManager.fromJS(resultData200);
            return Promise.resolve<UserProfileManager>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserProfileManager>(null as any);
    }

    /**
     * @return Success
     */
    getAccountAdminBasicInfo( cancelToken?: CancelToken): Promise<UserManagementBasicInfo> {
        let url_ = this.baseUrl + "/api/AccountAdmin/count";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccountAdminBasicInfo(_response);
        });
    }

    protected processGetAccountAdminBasicInfo(response: AxiosResponse): Promise<UserManagementBasicInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserManagementBasicInfo.fromJS(resultData200);
            return Promise.resolve<UserManagementBasicInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserManagementBasicInfo>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPagedInactiveUsers(body: UserProfilesRequest | undefined, cancelToken?: CancelToken): Promise<PagedUserResponse_1OfContact> {
        let url_ = this.baseUrl + "/api/AccountAdmin/inactive-users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPagedInactiveUsers(_response);
        });
    }

    protected processGetPagedInactiveUsers(response: AxiosResponse): Promise<PagedUserResponse_1OfContact> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedUserResponse_1OfContact.fromJS(resultData200);
            return Promise.resolve<PagedUserResponse_1OfContact>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedUserResponse_1OfContact>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPagedActiveUsers(body: UserProfilesRequest | undefined, cancelToken?: CancelToken): Promise<PagedUserResponse_1OfContact> {
        let url_ = this.baseUrl + "/api/AccountAdmin/active-users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPagedActiveUsers(_response);
        });
    }

    protected processGetPagedActiveUsers(response: AxiosResponse): Promise<PagedUserResponse_1OfContact> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedUserResponse_1OfContact.fromJS(resultData200);
            return Promise.resolve<PagedUserResponse_1OfContact>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedUserResponse_1OfContact>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getApprovedUsers(body: UserProfilesRequest | undefined, cancelToken?: CancelToken): Promise<PagedUserResponse_1OfUserProfileDTO> {
        let url_ = this.baseUrl + "/api/AccountAdmin/approved-users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetApprovedUsers(_response);
        });
    }

    protected processGetApprovedUsers(response: AxiosResponse): Promise<PagedUserResponse_1OfUserProfileDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedUserResponse_1OfUserProfileDTO.fromJS(resultData200);
            return Promise.resolve<PagedUserResponse_1OfUserProfileDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedUserResponse_1OfUserProfileDTO>(null as any);
    }

    /**
     * @return Success
     */
    getAwaitingApprovalUsers( cancelToken?: CancelToken): Promise<UserProfile[]> {
        let url_ = this.baseUrl + "/api/AccountAdmin/awaiting-approval-users";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAwaitingApprovalUsers(_response);
        });
    }

    protected processGetAwaitingApprovalUsers(response: AxiosResponse): Promise<UserProfile[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserProfile.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserProfile[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserProfile[]>(null as any);
    }

    /**
     * @return Success
     */
    getMappedUserProfiles( cancelToken?: CancelToken): Promise<UserProfile[]> {
        let url_ = this.baseUrl + "/api/AccountAdmin/mappedUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMappedUserProfiles(_response);
        });
    }

    protected processGetMappedUserProfiles(response: AxiosResponse): Promise<UserProfile[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserProfile.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserProfile[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserProfile[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAccountDevices(body: AccountDeviceRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/AccountAdmin/devices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccountDevices(_response);
        });
    }

    protected processGetAccountDevices(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setManualEmailRequired(body: ToggleManualEmailRequest | undefined, cancelToken?: CancelToken): Promise<AccountResponse> {
        let url_ = this.baseUrl + "/api/AccountAdmin/setManualEmailRequired";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetManualEmailRequired(_response);
        });
    }

    protected processSetManualEmailRequired(response: AxiosResponse): Promise<AccountResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountResponse.fromJS(resultData200);
            return Promise.resolve<AccountResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountResponse>(null as any);
    }
}

export interface IAccountSwitcherClient {
    /**
     * @param body (optional) 
     * @return Success
     */
    searchForAccountsByNameAndAx(body: AccountSearchQuery | undefined): Promise<AccountSwitcherResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getAllActiveAccounts(body: AccountSearchQuery | undefined): Promise<AccountSwitcherResponse>;
}

export class AccountSwitcherClient extends AuthorizedApiBase implements IAccountSwitcherClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchForAccountsByNameAndAx(body: AccountSearchQuery | undefined, cancelToken?: CancelToken): Promise<AccountSwitcherResponse> {
        let url_ = this.baseUrl + "/api/AccountSwitcher/shi/accounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchForAccountsByNameAndAx(_response);
        });
    }

    protected processSearchForAccountsByNameAndAx(response: AxiosResponse): Promise<AccountSwitcherResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountSwitcherResponse.fromJS(resultData200);
            return Promise.resolve<AccountSwitcherResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountSwitcherResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllActiveAccounts(body: AccountSearchQuery | undefined, cancelToken?: CancelToken): Promise<AccountSwitcherResponse> {
        let url_ = this.baseUrl + "/api/AccountSwitcher";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllActiveAccounts(_response);
        });
    }

    protected processGetAllActiveAccounts(response: AxiosResponse): Promise<AccountSwitcherResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountSwitcherResponse.fromJS(resultData200);
            return Promise.resolve<AccountSwitcherResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountSwitcherResponse>(null as any);
    }
}

export interface IAccountTeamMembersClient {
    /**
     * Updates a subset of CRM Account Teams. The list must not contain more than 500 items.
    Each item must include a full representation of the Account Team Members.
    If any users are missing from the list, they will be removed from that Account Team.
     * @param body (optional) 
     * @return Success
     */
    updateAccountTeams(body: AccountTeamMemberSyncDetails[] | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     * @deprecated
     */
    saveAccountTeamMember(body: CrmAccountTeamMember[] | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    saveAccountTeamMembers(body: SaveAccountTeamMembersRequest | undefined): Promise<void>;
    /**
     * @return Success
     */
    getAccountTeamLastSyncDateTime(accountId: number): Promise<AccountTeamLastSyncDateTime>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateCrmUsers(body: CrmUserDetails[] | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateCrmShiConnectionRoles(body: CrmShiConnectionRole[] | undefined): Promise<void>;
}

export class AccountTeamMembersClient extends AuthorizedApiBase implements IAccountTeamMembersClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Updates a subset of CRM Account Teams. The list must not contain more than 500 items.
    Each item must include a full representation of the Account Team Members.
    If any users are missing from the list, they will be removed from that Account Team.
     * @param body (optional) 
     * @return Success
     */
    updateAccountTeams(body: AccountTeamMemberSyncDetails[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/AccountTeamMembers/update/account-teams";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAccountTeams(_response);
        });
    }

    protected processUpdateAccountTeams(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     * @deprecated
     */
    saveAccountTeamMember(body: CrmAccountTeamMember[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/AccountTeamMembers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveAccountTeamMember(_response);
        });
    }

    protected processSaveAccountTeamMember(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveAccountTeamMembers(body: SaveAccountTeamMembersRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v2/accountTeamMembers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveAccountTeamMembers(_response);
        });
    }

    protected processSaveAccountTeamMembers(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getAccountTeamLastSyncDateTime(accountId: number, cancelToken?: CancelToken): Promise<AccountTeamLastSyncDateTime> {
        let url_ = this.baseUrl + "/api/AccountTeamMembers/account-team/{accountId}/last-sync";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccountTeamLastSyncDateTime(_response);
        });
    }

    protected processGetAccountTeamLastSyncDateTime(response: AxiosResponse): Promise<AccountTeamLastSyncDateTime> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountTeamLastSyncDateTime.fromJS(resultData200);
            return Promise.resolve<AccountTeamLastSyncDateTime>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountTeamLastSyncDateTime>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCrmUsers(body: CrmUserDetails[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/AccountTeamMembers/update/crm-users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCrmUsers(_response);
        });
    }

    protected processUpdateCrmUsers(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCrmShiConnectionRoles(body: CrmShiConnectionRole[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/AccountTeamMembers/update/connection-roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCrmShiConnectionRoles(_response);
        });
    }

    protected processUpdateCrmShiConnectionRoles(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IAlertClient {
    /**
     * @return Success
     */
    getAlertByTicketId(ticketId: number): Promise<TicketDTO>;
    /**
     * @return Success
     */
    getAlerts(): Promise<MonitoringAlert[]>;
}

export class AlertClient extends AuthorizedApiBase implements IAlertClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getAlertByTicketId(ticketId: number, cancelToken?: CancelToken): Promise<TicketDTO> {
        let url_ = this.baseUrl + "/api/Alert/{ticketId}";
        if (ticketId === undefined || ticketId === null)
            throw new Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAlertByTicketId(_response);
        });
    }

    protected processGetAlertByTicketId(response: AxiosResponse): Promise<TicketDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TicketDTO.fromJS(resultData200);
            return Promise.resolve<TicketDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TicketDTO>(null as any);
    }

    /**
     * @return Success
     */
    getAlerts( cancelToken?: CancelToken): Promise<MonitoringAlert[]> {
        let url_ = this.baseUrl + "/api/Alert";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAlerts(_response);
        });
    }

    protected processGetAlerts(response: AxiosResponse): Promise<MonitoringAlert[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MonitoringAlert.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MonitoringAlert[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MonitoringAlert[]>(null as any);
    }
}

export interface IArchbeeClient {
    /**
     * Retrieves the Archbee URL for SHI Internal Documentation
     * @return Success
     */
    getArchbeeLink(): Promise<string>;
}

export class ArchbeeClient extends AuthorizedApiBase implements IArchbeeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Retrieves the Archbee URL for SHI Internal Documentation
     * @return Success
     */
    getArchbeeLink( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Archbee";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetArchbeeLink(_response);
        });
    }

    protected processGetArchbeeLink(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface IAssessmentsClient {
    /**
     * @param program (optional) 
     * @return Success
     */
    getAssessments(program: AssessmentProgram | undefined): Promise<AssessmentDto[]>;
    /**
     * @param id (optional) 
     * @return Success
     */
    getAssessmentOverview(program: AssessmentProgram, id: string | undefined): Promise<AssessmentOverviewDto>;
    /**
     * @param id (optional) 
     * @return Success
     */
    getAssessmentMaturityChart(program: AssessmentProgram, id: string | undefined): Promise<AssessmentMaturityChartDto>;
    /**
     * @param id (optional) 
     * @return Success
     */
    getAssessmentRecommendations(program: AssessmentProgram, id: string | undefined): Promise<AssessmentRecommendationsDto>;
    /**
     * @return Success
     */
    requestAssessmentConsultation(program: AssessmentProgram): Promise<SendConsultationEmailsResponse>;
    /**
     * @param id (optional) 
     * @return Success
     */
    getPlatformInsights(program: AssessmentProgram, id: string | undefined): Promise<PlatformInsightsDto>;
    /**
     * @param id (optional) 
     * @return Success
     */
    getCapabilityInsights(program: AssessmentProgram, id: string | undefined): Promise<CapabilityInsightsDto>;
    /**
     * @return Success
     */
    getHarveyBallsByCapability(capabilityId: string): Promise<HarveyBallDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateHarveyBalls(body: HarveyBallsUpdate[] | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updatePlatforms(body: PlatformsUpdate[] | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    upsertAssessmentFromAirtable(body: UpsertAssessmentFromAirtableCommand | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    createGeneratedAssessmentFromMindspark(body: GeneratedAssessment | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    deleteAssessmentAndIntegration(body: DeleteAssessmentDto | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateAssessmentIntegration(body: UpdateAssessmentIntegration | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateAssessmentTemplate(body: AssessmentTemplateUpdate | undefined): Promise<void>;
    /**
     * @param program (optional) 
     * @return Success
     */
    getCapabilityChanges(program: AssessmentProgram | undefined): Promise<CapabilityChangesDto[]>;
    /**
     * @param program (optional) 
     * @param id (optional) 
     * @return Success
     */
    getMaturityComparison(program: AssessmentProgram | undefined, id: string | undefined): Promise<MaturityComparisonDto>;
    /**
     * @return Success
     */
    getRecommendationById(assessmentId: string, recommendationId: string): Promise<ResponseRecommendation>;
}

export class AssessmentsClient extends AuthorizedApiBase implements IAssessmentsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param program (optional) 
     * @return Success
     */
    getAssessments(program: AssessmentProgram | undefined, cancelToken?: CancelToken): Promise<AssessmentDto[]> {
        let url_ = this.baseUrl + "/api/Assessments?";
        if (program === null)
            throw new Error("The parameter 'program' cannot be null.");
        else if (program !== undefined)
            url_ += "program=" + encodeURIComponent("" + program) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssessments(_response);
        });
    }

    protected processGetAssessments(response: AxiosResponse): Promise<AssessmentDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssessmentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AssessmentDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssessmentDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAssessmentOverview(program: AssessmentProgram, id: string | undefined, cancelToken?: CancelToken): Promise<AssessmentOverviewDto> {
        let url_ = this.baseUrl + "/api/Assessments/{program}/overview?";
        if (program === undefined || program === null)
            throw new Error("The parameter 'program' must be defined.");
        url_ = url_.replace("{program}", encodeURIComponent("" + program));
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssessmentOverview(_response);
        });
    }

    protected processGetAssessmentOverview(response: AxiosResponse): Promise<AssessmentOverviewDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssessmentOverviewDto.fromJS(resultData200);
            return Promise.resolve<AssessmentOverviewDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssessmentOverviewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAssessmentMaturityChart(program: AssessmentProgram, id: string | undefined, cancelToken?: CancelToken): Promise<AssessmentMaturityChartDto> {
        let url_ = this.baseUrl + "/api/Assessments/{program}/maturity-chart?";
        if (program === undefined || program === null)
            throw new Error("The parameter 'program' must be defined.");
        url_ = url_.replace("{program}", encodeURIComponent("" + program));
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssessmentMaturityChart(_response);
        });
    }

    protected processGetAssessmentMaturityChart(response: AxiosResponse): Promise<AssessmentMaturityChartDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssessmentMaturityChartDto.fromJS(resultData200);
            return Promise.resolve<AssessmentMaturityChartDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssessmentMaturityChartDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAssessmentRecommendations(program: AssessmentProgram, id: string | undefined, cancelToken?: CancelToken): Promise<AssessmentRecommendationsDto> {
        let url_ = this.baseUrl + "/api/Assessments/{program}/recommendations?";
        if (program === undefined || program === null)
            throw new Error("The parameter 'program' must be defined.");
        url_ = url_.replace("{program}", encodeURIComponent("" + program));
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssessmentRecommendations(_response);
        });
    }

    protected processGetAssessmentRecommendations(response: AxiosResponse): Promise<AssessmentRecommendationsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssessmentRecommendationsDto.fromJS(resultData200);
            return Promise.resolve<AssessmentRecommendationsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssessmentRecommendationsDto>(null as any);
    }

    /**
     * @return Success
     */
    requestAssessmentConsultation(program: AssessmentProgram, cancelToken?: CancelToken): Promise<SendConsultationEmailsResponse> {
        let url_ = this.baseUrl + "/api/Assessments/{program}/consultation";
        if (program === undefined || program === null)
            throw new Error("The parameter 'program' must be defined.");
        url_ = url_.replace("{program}", encodeURIComponent("" + program));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequestAssessmentConsultation(_response);
        });
    }

    protected processRequestAssessmentConsultation(response: AxiosResponse): Promise<SendConsultationEmailsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SendConsultationEmailsResponse.fromJS(resultData200);
            return Promise.resolve<SendConsultationEmailsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SendConsultationEmailsResponse>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPlatformInsights(program: AssessmentProgram, id: string | undefined, cancelToken?: CancelToken): Promise<PlatformInsightsDto> {
        let url_ = this.baseUrl + "/api/Assessments/{program}/platform-insights?";
        if (program === undefined || program === null)
            throw new Error("The parameter 'program' must be defined.");
        url_ = url_.replace("{program}", encodeURIComponent("" + program));
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPlatformInsights(_response);
        });
    }

    protected processGetPlatformInsights(response: AxiosResponse): Promise<PlatformInsightsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PlatformInsightsDto.fromJS(resultData200);
            return Promise.resolve<PlatformInsightsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlatformInsightsDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCapabilityInsights(program: AssessmentProgram, id: string | undefined, cancelToken?: CancelToken): Promise<CapabilityInsightsDto> {
        let url_ = this.baseUrl + "/api/Assessments/{program}/capability-insights?";
        if (program === undefined || program === null)
            throw new Error("The parameter 'program' must be defined.");
        url_ = url_.replace("{program}", encodeURIComponent("" + program));
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCapabilityInsights(_response);
        });
    }

    protected processGetCapabilityInsights(response: AxiosResponse): Promise<CapabilityInsightsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CapabilityInsightsDto.fromJS(resultData200);
            return Promise.resolve<CapabilityInsightsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CapabilityInsightsDto>(null as any);
    }

    /**
     * @return Success
     */
    getHarveyBallsByCapability(capabilityId: string, cancelToken?: CancelToken): Promise<HarveyBallDto> {
        let url_ = this.baseUrl + "/api/Assessments/harvey-balls/{capabilityId}";
        if (capabilityId === undefined || capabilityId === null)
            throw new Error("The parameter 'capabilityId' must be defined.");
        url_ = url_.replace("{capabilityId}", encodeURIComponent("" + capabilityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHarveyBallsByCapability(_response);
        });
    }

    protected processGetHarveyBallsByCapability(response: AxiosResponse): Promise<HarveyBallDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HarveyBallDto.fromJS(resultData200);
            return Promise.resolve<HarveyBallDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HarveyBallDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateHarveyBalls(body: HarveyBallsUpdate[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Assessments/update-harvey-balls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateHarveyBalls(_response);
        });
    }

    protected processUpdateHarveyBalls(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePlatforms(body: PlatformsUpdate[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Assessments/update-platforms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePlatforms(_response);
        });
    }

    protected processUpdatePlatforms(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertAssessmentFromAirtable(body: UpsertAssessmentFromAirtableCommand | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Assessments/save-assessments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpsertAssessmentFromAirtable(_response);
        });
    }

    protected processUpsertAssessmentFromAirtable(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createGeneratedAssessmentFromMindspark(body: GeneratedAssessment | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Assessments/mindspark-assessments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateGeneratedAssessmentFromMindspark(_response);
        });
    }

    protected processCreateGeneratedAssessmentFromMindspark(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteAssessmentAndIntegration(body: DeleteAssessmentDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Assessments/delete-assessment-and-integration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAssessmentAndIntegration(_response);
        });
    }

    protected processDeleteAssessmentAndIntegration(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAssessmentIntegration(body: UpdateAssessmentIntegration | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Assessments/upsert-assessment-integration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAssessmentIntegration(_response);
        });
    }

    protected processUpdateAssessmentIntegration(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAssessmentTemplate(body: AssessmentTemplateUpdate | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Assessments/update-assessment-template";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAssessmentTemplate(_response);
        });
    }

    protected processUpdateAssessmentTemplate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param program (optional) 
     * @return Success
     */
    getCapabilityChanges(program: AssessmentProgram | undefined, cancelToken?: CancelToken): Promise<CapabilityChangesDto[]> {
        let url_ = this.baseUrl + "/api/Assessments/capability-changes?";
        if (program === null)
            throw new Error("The parameter 'program' cannot be null.");
        else if (program !== undefined)
            url_ += "program=" + encodeURIComponent("" + program) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCapabilityChanges(_response);
        });
    }

    protected processGetCapabilityChanges(response: AxiosResponse): Promise<CapabilityChangesDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CapabilityChangesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CapabilityChangesDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CapabilityChangesDto[]>(null as any);
    }

    /**
     * @param program (optional) 
     * @param id (optional) 
     * @return Success
     */
    getMaturityComparison(program: AssessmentProgram | undefined, id: string | undefined, cancelToken?: CancelToken): Promise<MaturityComparisonDto> {
        let url_ = this.baseUrl + "/api/Assessments/maturity-comparison?";
        if (program === null)
            throw new Error("The parameter 'program' cannot be null.");
        else if (program !== undefined)
            url_ += "program=" + encodeURIComponent("" + program) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMaturityComparison(_response);
        });
    }

    protected processGetMaturityComparison(response: AxiosResponse): Promise<MaturityComparisonDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MaturityComparisonDto.fromJS(resultData200);
            return Promise.resolve<MaturityComparisonDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MaturityComparisonDto>(null as any);
    }

    /**
     * @return Success
     */
    getRecommendationById(assessmentId: string, recommendationId: string, cancelToken?: CancelToken): Promise<ResponseRecommendation> {
        let url_ = this.baseUrl + "/api/Assessments/recommendation/{assessmentId}/{recommendationId}";
        if (assessmentId === undefined || assessmentId === null)
            throw new Error("The parameter 'assessmentId' must be defined.");
        url_ = url_.replace("{assessmentId}", encodeURIComponent("" + assessmentId));
        if (recommendationId === undefined || recommendationId === null)
            throw new Error("The parameter 'recommendationId' must be defined.");
        url_ = url_.replace("{recommendationId}", encodeURIComponent("" + recommendationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRecommendationById(_response);
        });
    }

    protected processGetRecommendationById(response: AxiosResponse): Promise<ResponseRecommendation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseRecommendation.fromJS(resultData200);
            return Promise.resolve<ResponseRecommendation>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseRecommendation>(null as any);
    }
}

export interface IAssetFilterByCategoryWidgetClient {
    /**
     * @param type (optional) 
     * @param category (optional) 
     * @return Success
     */
    getFilteredAssetByCategory(type: AssetWidgetType | undefined, category: FilterByCategory | undefined): Promise<WidgetContentResponseDto_1OfAssetWidgetFilterByCategoryResponse>;
}

export class AssetFilterByCategoryWidgetClient extends AuthorizedApiBase implements IAssetFilterByCategoryWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param type (optional) 
     * @param category (optional) 
     * @return Success
     */
    getFilteredAssetByCategory(type: AssetWidgetType | undefined, category: FilterByCategory | undefined, cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfAssetWidgetFilterByCategoryResponse> {
        let url_ = this.baseUrl + "/api/widget/assets-by-category-widget?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (category === null)
            throw new Error("The parameter 'category' cannot be null.");
        else if (category !== undefined)
            url_ += "category=" + encodeURIComponent("" + category) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFilteredAssetByCategory(_response);
        });
    }

    protected processGetFilteredAssetByCategory(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfAssetWidgetFilterByCategoryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfAssetWidgetFilterByCategoryResponse.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfAssetWidgetFilterByCategoryResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfAssetWidgetFilterByCategoryResponse>(null as any);
    }
}

export interface IAssetManagementClient {
    /**
     * Retrieves All Assets for the Customer
     * @param body (optional) 
     * @return Success
     */
    getMyAssets(body: AssetManagementSearchQueryDto | undefined): Promise<AssetManagementResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getAssetLocations(body: AssetLocationSearchQueryDto | undefined): Promise<AssetLocationsResponse>;
    /**
     * @return Success
     */
    getAssetLocationList(): Promise<AssetLocationsResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getAssetLifecycle(body: AssetLifecycleSearchRequestDto | undefined): Promise<AssetLifecycleResponseDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getProductCatalog(body: AssetProductCatalogSearchRequestDto | undefined): Promise<AssetProductCatalogResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getMyContracts(body: AssetContractSearchQueryDto | undefined): Promise<AssetContractsResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getDattoRmmData(body: AssetEndUserDevicesRequestDto | undefined): Promise<AssetEndUserDevicesResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getAssetTags(body: DynamicTagsGetRequest | undefined): Promise<DynamicTagsGetResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    postAssetTags(body: DynamicTagsRequest | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    deleteAssetTags(body: DynamicTagsRequest | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    putNotes(body: DynamicTagsRequest | undefined): Promise<void>;
}

export class AssetManagementClient extends AuthorizedApiBase implements IAssetManagementClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Retrieves All Assets for the Customer
     * @param body (optional) 
     * @return Success
     */
    getMyAssets(body: AssetManagementSearchQueryDto | undefined, cancelToken?: CancelToken): Promise<AssetManagementResponse> {
        let url_ = this.baseUrl + "/api/AssetManagement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyAssets(_response);
        });
    }

    protected processGetMyAssets(response: AxiosResponse): Promise<AssetManagementResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssetManagementResponse.fromJS(resultData200);
            return Promise.resolve<AssetManagementResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssetManagementResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAssetLocations(body: AssetLocationSearchQueryDto | undefined, cancelToken?: CancelToken): Promise<AssetLocationsResponse> {
        let url_ = this.baseUrl + "/api/AssetManagement/asset-locations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssetLocations(_response);
        });
    }

    protected processGetAssetLocations(response: AxiosResponse): Promise<AssetLocationsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssetLocationsResponse.fromJS(resultData200);
            return Promise.resolve<AssetLocationsResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssetLocationsResponse>(null as any);
    }

    /**
     * @return Success
     */
    getAssetLocationList( cancelToken?: CancelToken): Promise<AssetLocationsResponse> {
        let url_ = this.baseUrl + "/api/AssetManagement/asset-location-list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssetLocationList(_response);
        });
    }

    protected processGetAssetLocationList(response: AxiosResponse): Promise<AssetLocationsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssetLocationsResponse.fromJS(resultData200);
            return Promise.resolve<AssetLocationsResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssetLocationsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAssetLifecycle(body: AssetLifecycleSearchRequestDto | undefined, cancelToken?: CancelToken): Promise<AssetLifecycleResponseDto> {
        let url_ = this.baseUrl + "/api/AssetManagement/asset-lifecycle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssetLifecycle(_response);
        });
    }

    protected processGetAssetLifecycle(response: AxiosResponse): Promise<AssetLifecycleResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssetLifecycleResponseDto.fromJS(resultData200);
            return Promise.resolve<AssetLifecycleResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssetLifecycleResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getProductCatalog(body: AssetProductCatalogSearchRequestDto | undefined, cancelToken?: CancelToken): Promise<AssetProductCatalogResponse> {
        let url_ = this.baseUrl + "/api/AssetManagement/product-catalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductCatalog(_response);
        });
    }

    protected processGetProductCatalog(response: AxiosResponse): Promise<AssetProductCatalogResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssetProductCatalogResponse.fromJS(resultData200);
            return Promise.resolve<AssetProductCatalogResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssetProductCatalogResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMyContracts(body: AssetContractSearchQueryDto | undefined, cancelToken?: CancelToken): Promise<AssetContractsResponse> {
        let url_ = this.baseUrl + "/api/AssetManagement/active-contracts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyContracts(_response);
        });
    }

    protected processGetMyContracts(response: AxiosResponse): Promise<AssetContractsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssetContractsResponse.fromJS(resultData200);
            return Promise.resolve<AssetContractsResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssetContractsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getDattoRmmData(body: AssetEndUserDevicesRequestDto | undefined, cancelToken?: CancelToken): Promise<AssetEndUserDevicesResponse> {
        let url_ = this.baseUrl + "/api/AssetManagement/end-user-devices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDattoRmmData(_response);
        });
    }

    protected processGetDattoRmmData(response: AxiosResponse): Promise<AssetEndUserDevicesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssetEndUserDevicesResponse.fromJS(resultData200);
            return Promise.resolve<AssetEndUserDevicesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssetEndUserDevicesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAssetTags(body: DynamicTagsGetRequest | undefined, cancelToken?: CancelToken): Promise<DynamicTagsGetResponse> {
        let url_ = this.baseUrl + "/api/AssetManagement/get_tags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssetTags(_response);
        });
    }

    protected processGetAssetTags(response: AxiosResponse): Promise<DynamicTagsGetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DynamicTagsGetResponse.fromJS(resultData200);
            return Promise.resolve<DynamicTagsGetResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DynamicTagsGetResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    postAssetTags(body: DynamicTagsRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/AssetManagement/tags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostAssetTags(_response);
        });
    }

    protected processPostAssetTags(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteAssetTags(body: DynamicTagsRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/AssetManagement/tags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAssetTags(_response);
        });
    }

    protected processDeleteAssetTags(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    putNotes(body: DynamicTagsRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/AssetManagement/notes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPutNotes(_response);
        });
    }

    protected processPutNotes(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IAssetManagementDownloadClient {
    /**
     * @param body (optional) 
     * @return Success
     */
    downloadAssetContracts(body: AssetDownloadContractsRequest | undefined): Promise<FileDownloadResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    downloadAssetInventory(body: AssetDownloadInventoryRequest | undefined): Promise<FileDownloadResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    downloadAssetLifecycle(body: AssetDownloadLifecycleRequest | undefined): Promise<FileDownloadResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    downloadAssetProductCatalog(body: AssetDownloadProductCatalogRequest | undefined): Promise<FileDownloadResponse>;
}

export class AssetManagementDownloadClient extends AuthorizedApiBase implements IAssetManagementDownloadClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    downloadAssetContracts(body: AssetDownloadContractsRequest | undefined, cancelToken?: CancelToken): Promise<FileDownloadResponse> {
        let url_ = this.baseUrl + "/api/AssetManagementDownload/asset-contracts-download";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadAssetContracts(_response);
        });
    }

    protected processDownloadAssetContracts(response: AxiosResponse): Promise<FileDownloadResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDownloadResponse.fromJS(resultData200);
            return Promise.resolve<FileDownloadResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDownloadResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    downloadAssetInventory(body: AssetDownloadInventoryRequest | undefined, cancelToken?: CancelToken): Promise<FileDownloadResponse> {
        let url_ = this.baseUrl + "/api/AssetManagementDownload/asset-inventory-download";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadAssetInventory(_response);
        });
    }

    protected processDownloadAssetInventory(response: AxiosResponse): Promise<FileDownloadResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDownloadResponse.fromJS(resultData200);
            return Promise.resolve<FileDownloadResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDownloadResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    downloadAssetLifecycle(body: AssetDownloadLifecycleRequest | undefined, cancelToken?: CancelToken): Promise<FileDownloadResponse> {
        let url_ = this.baseUrl + "/api/AssetManagementDownload/asset-lifecycle-download";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadAssetLifecycle(_response);
        });
    }

    protected processDownloadAssetLifecycle(response: AxiosResponse): Promise<FileDownloadResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDownloadResponse.fromJS(resultData200);
            return Promise.resolve<FileDownloadResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDownloadResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    downloadAssetProductCatalog(body: AssetDownloadProductCatalogRequest | undefined, cancelToken?: CancelToken): Promise<FileDownloadResponse> {
        let url_ = this.baseUrl + "/api/AssetManagementDownload/asset-product-catalog-download";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadAssetProductCatalog(_response);
        });
    }

    protected processDownloadAssetProductCatalog(response: AxiosResponse): Promise<FileDownloadResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDownloadResponse.fromJS(resultData200);
            return Promise.resolve<FileDownloadResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDownloadResponse>(null as any);
    }
}

export interface IAssetManagementPicklistClient {
    /**
     * @return Success
     */
    getInventoryPicklist(): Promise<AssetInventoryAggregationDto>;
    /**
     * @return Success
     */
    getLocationPicklist(): Promise<AssetLocationAggregationDto>;
    /**
     * @return Success
     */
    getLifeCyclePicklist(): Promise<AssetLifecycleAggregationDto>;
    /**
     * @return Success
     */
    getProductCatalogPicklist(): Promise<ProductCatalogAggregationDto>;
    /**
     * @return Success
     */
    getContractPicklist(): Promise<AssetContractAggregationDto>;
}

export class AssetManagementPicklistClient extends AuthorizedApiBase implements IAssetManagementPicklistClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getInventoryPicklist( cancelToken?: CancelToken): Promise<AssetInventoryAggregationDto> {
        let url_ = this.baseUrl + "/api/AssetManagementPicklist/inventory-picklist";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInventoryPicklist(_response);
        });
    }

    protected processGetInventoryPicklist(response: AxiosResponse): Promise<AssetInventoryAggregationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssetInventoryAggregationDto.fromJS(resultData200);
            return Promise.resolve<AssetInventoryAggregationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssetInventoryAggregationDto>(null as any);
    }

    /**
     * @return Success
     */
    getLocationPicklist( cancelToken?: CancelToken): Promise<AssetLocationAggregationDto> {
        let url_ = this.baseUrl + "/api/AssetManagementPicklist/location-picklist";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLocationPicklist(_response);
        });
    }

    protected processGetLocationPicklist(response: AxiosResponse): Promise<AssetLocationAggregationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssetLocationAggregationDto.fromJS(resultData200);
            return Promise.resolve<AssetLocationAggregationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssetLocationAggregationDto>(null as any);
    }

    /**
     * @return Success
     */
    getLifeCyclePicklist( cancelToken?: CancelToken): Promise<AssetLifecycleAggregationDto> {
        let url_ = this.baseUrl + "/api/AssetManagementPicklist/lifecycle-picklist";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLifeCyclePicklist(_response);
        });
    }

    protected processGetLifeCyclePicklist(response: AxiosResponse): Promise<AssetLifecycleAggregationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssetLifecycleAggregationDto.fromJS(resultData200);
            return Promise.resolve<AssetLifecycleAggregationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssetLifecycleAggregationDto>(null as any);
    }

    /**
     * @return Success
     */
    getProductCatalogPicklist( cancelToken?: CancelToken): Promise<ProductCatalogAggregationDto> {
        let url_ = this.baseUrl + "/api/AssetManagementPicklist/product-catalog-picklist";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductCatalogPicklist(_response);
        });
    }

    protected processGetProductCatalogPicklist(response: AxiosResponse): Promise<ProductCatalogAggregationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductCatalogAggregationDto.fromJS(resultData200);
            return Promise.resolve<ProductCatalogAggregationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductCatalogAggregationDto>(null as any);
    }

    /**
     * @return Success
     */
    getContractPicklist( cancelToken?: CancelToken): Promise<AssetContractAggregationDto> {
        let url_ = this.baseUrl + "/api/AssetManagementPicklist/contract-picklist";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContractPicklist(_response);
        });
    }

    protected processGetContractPicklist(response: AxiosResponse): Promise<AssetContractAggregationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssetContractAggregationDto.fromJS(resultData200);
            return Promise.resolve<AssetContractAggregationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssetContractAggregationDto>(null as any);
    }
}

export interface IAssetOverviewWidgetClient {
    /**
     * @return Success
     */
    getAssetsOverviewWidgetData(): Promise<AssetOverviewWidgetResponse>;
}

export class AssetOverviewWidgetClient extends AuthorizedApiBase implements IAssetOverviewWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getAssetsOverviewWidgetData( cancelToken?: CancelToken): Promise<AssetOverviewWidgetResponse> {
        let url_ = this.baseUrl + "/api/widget/asset-overview-widget";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssetsOverviewWidgetData(_response);
        });
    }

    protected processGetAssetsOverviewWidgetData(response: AxiosResponse): Promise<AssetOverviewWidgetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssetOverviewWidgetResponse.fromJS(resultData200);
            return Promise.resolve<AssetOverviewWidgetResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssetOverviewWidgetResponse>(null as any);
    }
}

export interface IAssetsByProductOverviewWidgetClient {
    /**
     * @return Success
     */
    getAssetsProductOverviewWidgetData(): Promise<AssetsByProductOverviewWidgetResponse>;
}

export class AssetsByProductOverviewWidgetClient extends AuthorizedApiBase implements IAssetsByProductOverviewWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getAssetsProductOverviewWidgetData( cancelToken?: CancelToken): Promise<AssetsByProductOverviewWidgetResponse> {
        let url_ = this.baseUrl + "/api/widget/assets-product-overview-widget";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssetsProductOverviewWidgetData(_response);
        });
    }

    protected processGetAssetsProductOverviewWidgetData(response: AxiosResponse): Promise<AssetsByProductOverviewWidgetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssetsByProductOverviewWidgetResponse.fromJS(resultData200);
            return Promise.resolve<AssetsByProductOverviewWidgetResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssetsByProductOverviewWidgetResponse>(null as any);
    }
}

export interface IAssetsByUseStateWidgetClient {
    /**
     * @return Success
     */
    getAssetByUseStateData(): Promise<AssetsByUseStateWidgetResponse>;
}

export class AssetsByUseStateWidgetClient extends AuthorizedApiBase implements IAssetsByUseStateWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getAssetByUseStateData( cancelToken?: CancelToken): Promise<AssetsByUseStateWidgetResponse> {
        let url_ = this.baseUrl + "/api/widget/assets-by-use-state-widget";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssetByUseStateData(_response);
        });
    }

    protected processGetAssetByUseStateData(response: AxiosResponse): Promise<AssetsByUseStateWidgetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssetsByUseStateWidgetResponse.fromJS(resultData200);
            return Promise.resolve<AssetsByUseStateWidgetResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssetsByUseStateWidgetResponse>(null as any);
    }
}

export interface IAssetsLifecycleManagementClient {
    /**
     * @param months (optional) 
     * @return Success
     */
    getAssetsLifecycleManagementWidgetData(months: number | undefined): Promise<WidgetContentResponseDto_1OfAssetLifecycleManagementWidgetResponseDto>;
}

export class AssetsLifecycleManagementClient extends AuthorizedApiBase implements IAssetsLifecycleManagementClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param months (optional) 
     * @return Success
     */
    getAssetsLifecycleManagementWidgetData(months: number | undefined, cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfAssetLifecycleManagementWidgetResponseDto> {
        let url_ = this.baseUrl + "/api/widget/assets-lifecycle-management-widget?";
        if (months === null)
            throw new Error("The parameter 'months' cannot be null.");
        else if (months !== undefined)
            url_ += "months=" + encodeURIComponent("" + months) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssetsLifecycleManagementWidgetData(_response);
        });
    }

    protected processGetAssetsLifecycleManagementWidgetData(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfAssetLifecycleManagementWidgetResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfAssetLifecycleManagementWidgetResponseDto.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfAssetLifecycleManagementWidgetResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfAssetLifecycleManagementWidgetResponseDto>(null as any);
    }
}

export interface IAssetsWarehouseOrdersWidgetClient {
    /**
     * @return Success
     */
    getAssetsWarehouseOrdersWidgetData(): Promise<WidgetContentResponseDto_1OfGetWarehouseAggregatedOrdersResponse>;
}

export class AssetsWarehouseOrdersWidgetClient extends AuthorizedApiBase implements IAssetsWarehouseOrdersWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getAssetsWarehouseOrdersWidgetData( cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfGetWarehouseAggregatedOrdersResponse> {
        let url_ = this.baseUrl + "/api/widget/assets-warehouse-orders-widget";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssetsWarehouseOrdersWidgetData(_response);
        });
    }

    protected processGetAssetsWarehouseOrdersWidgetData(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfGetWarehouseAggregatedOrdersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfGetWarehouseAggregatedOrdersResponse.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfGetWarehouseAggregatedOrdersResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfGetWarehouseAggregatedOrdersResponse>(null as any);
    }
}

export interface IAssetsWarehouseStockWidgetClient {
    /**
     * @param projectId (optional) 
     * @return Success
     */
    getAssetsWarehouseStockWidgetData(projectId: string | undefined): Promise<WidgetContentResponseDto_1OfGetWarehouseAggregatedStockResponse>;
}

export class AssetsWarehouseStockWidgetClient extends AuthorizedApiBase implements IAssetsWarehouseStockWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param projectId (optional) 
     * @return Success
     */
    getAssetsWarehouseStockWidgetData(projectId: string | undefined, cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfGetWarehouseAggregatedStockResponse> {
        let url_ = this.baseUrl + "/api/widget/assets-warehouse-stock-widget?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssetsWarehouseStockWidgetData(_response);
        });
    }

    protected processGetAssetsWarehouseStockWidgetData(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfGetWarehouseAggregatedStockResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfGetWarehouseAggregatedStockResponse.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfGetWarehouseAggregatedStockResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfGetWarehouseAggregatedStockResponse>(null as any);
    }
}

export interface IAttachmentClient {
    /**
     * @return Success
     */
    downloadFile(guid: string): Promise<FileResponse>;
    /**
     * @return Success
     */
    getAttachmentsOnTicket(ticketId: string): Promise<void>;
    /**
     * @param filepond (optional) 
     * @param hello (optional) 
     * @return Success
     */
    uploadAttachmentImage(filepond: FileParameter | undefined, hello: string | undefined): Promise<void>;
}

export class AttachmentClient extends AuthorizedApiBase implements IAttachmentClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    downloadFile(guid: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/attachments/download/{guid}";
        if (guid === undefined || guid === null)
            throw new Error("The parameter 'guid' must be defined.");
        url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadFile(_response);
        });
    }

    protected processDownloadFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    getAttachmentsOnTicket(ticketId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/attachments/ticket/{ticketId}";
        if (ticketId === undefined || ticketId === null)
            throw new Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAttachmentsOnTicket(_response);
        });
    }

    protected processGetAttachmentsOnTicket(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param filepond (optional) 
     * @param hello (optional) 
     * @return Success
     */
    uploadAttachmentImage(filepond: FileParameter | undefined, hello: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/attachments/process";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (filepond === null || filepond === undefined)
            throw new Error("The parameter 'filepond' cannot be null.");
        else
            content_.append("filepond", filepond.data, filepond.fileName ? filepond.fileName : "filepond");
        if (hello === null || hello === undefined)
            throw new Error("The parameter 'hello' cannot be null.");
        else
            content_.append("Hello", hello.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadAttachmentImage(_response);
        });
    }

    protected processUploadAttachmentImage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IAuthorizationClient {
    /**
     * @return Success
     */
    getUserClaims(): Promise<ClaimDto[]>;
}

export class AuthorizationClient extends AuthorizedApiBase implements IAuthorizationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getUserClaims( cancelToken?: CancelToken): Promise<ClaimDto[]> {
        let url_ = this.baseUrl + "/api/Authorization/Claims";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserClaims(_response);
        });
    }

    protected processGetUserClaims(response: AxiosResponse): Promise<ClaimDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClaimDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ClaimDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClaimDto[]>(null as any);
    }
}

export interface IAutotaskDataExchangeClient {
    /**
     * @param idGreaterThanOrEqual (optional) 
     * @param idLessThanOrEqual (optional) 
     * @param lastActivityDateFrom (optional) 
     * @param lastActivityDateTo (optional) 
     * @param includeDeleted (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     * @return Success
     */
    getTicketsMetadata(idGreaterThanOrEqual: number | undefined, idLessThanOrEqual: number | undefined, lastActivityDateFrom: Date | undefined, lastActivityDateTo: Date | undefined, includeDeleted: boolean | undefined, pageSize: number | undefined, orderBy: OrderBy | undefined): Promise<TicketMetadataDto[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getTicketsMetadataByIds(body: number[] | undefined): Promise<TicketMetadataDto[]>;
    /**
     * @param idGreaterThanOrEqual (optional) 
     * @param idLessThanOrEqual (optional) 
     * @param lastActivityDateFrom (optional) 
     * @param lastActivityDateTo (optional) 
     * @param includeDeleted (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     * @return Success
     */
    getTicketNotesMetadata(idGreaterThanOrEqual: number | undefined, idLessThanOrEqual: number | undefined, lastActivityDateFrom: Date | undefined, lastActivityDateTo: Date | undefined, includeDeleted: boolean | undefined, pageSize: number | undefined, orderBy: OrderBy | undefined): Promise<TicketNoteMetadataDto[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getTicketNotesMetadataByIds(body: number[] | undefined): Promise<TicketNoteMetadataDto[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getTimeEntriesMetadataByIds(body: number[] | undefined): Promise<TimeEntryMetadataDto[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getServiceLevelAgreementResultsMetadataByIds(body: number[] | undefined): Promise<ServiceLevelAgreementResultMetadataDto[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getSurveyResultMetadataByIds(body: number[] | undefined): Promise<SurveyResultMetadataDto[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getBillingItemMetadataByIds(body: number[] | undefined): Promise<BillingItemMetadataDto[]>;
}

export class AutotaskDataExchangeClient extends AuthorizedApiBase implements IAutotaskDataExchangeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param idGreaterThanOrEqual (optional) 
     * @param idLessThanOrEqual (optional) 
     * @param lastActivityDateFrom (optional) 
     * @param lastActivityDateTo (optional) 
     * @param includeDeleted (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     * @return Success
     */
    getTicketsMetadata(idGreaterThanOrEqual: number | undefined, idLessThanOrEqual: number | undefined, lastActivityDateFrom: Date | undefined, lastActivityDateTo: Date | undefined, includeDeleted: boolean | undefined, pageSize: number | undefined, orderBy: OrderBy | undefined, cancelToken?: CancelToken): Promise<TicketMetadataDto[]> {
        let url_ = this.baseUrl + "/api/data/AutotaskDataExchange/tickets/metadata?";
        if (idGreaterThanOrEqual === null)
            throw new Error("The parameter 'idGreaterThanOrEqual' cannot be null.");
        else if (idGreaterThanOrEqual !== undefined)
            url_ += "IdGreaterThanOrEqual=" + encodeURIComponent("" + idGreaterThanOrEqual) + "&";
        if (idLessThanOrEqual === null)
            throw new Error("The parameter 'idLessThanOrEqual' cannot be null.");
        else if (idLessThanOrEqual !== undefined)
            url_ += "IdLessThanOrEqual=" + encodeURIComponent("" + idLessThanOrEqual) + "&";
        if (lastActivityDateFrom === null)
            throw new Error("The parameter 'lastActivityDateFrom' cannot be null.");
        else if (lastActivityDateFrom !== undefined)
            url_ += "LastActivityDateFrom=" + encodeURIComponent(lastActivityDateFrom ? "" + lastActivityDateFrom.toISOString() : "") + "&";
        if (lastActivityDateTo === null)
            throw new Error("The parameter 'lastActivityDateTo' cannot be null.");
        else if (lastActivityDateTo !== undefined)
            url_ += "LastActivityDateTo=" + encodeURIComponent(lastActivityDateTo ? "" + lastActivityDateTo.toISOString() : "") + "&";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "IncludeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTicketsMetadata(_response);
        });
    }

    protected processGetTicketsMetadata(response: AxiosResponse): Promise<TicketMetadataDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TicketMetadataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TicketMetadataDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TicketMetadataDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getTicketsMetadataByIds(body: number[] | undefined, cancelToken?: CancelToken): Promise<TicketMetadataDto[]> {
        let url_ = this.baseUrl + "/api/data/AutotaskDataExchange/tickets/metadata-by-ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTicketsMetadataByIds(_response);
        });
    }

    protected processGetTicketsMetadataByIds(response: AxiosResponse): Promise<TicketMetadataDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TicketMetadataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TicketMetadataDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TicketMetadataDto[]>(null as any);
    }

    /**
     * @param idGreaterThanOrEqual (optional) 
     * @param idLessThanOrEqual (optional) 
     * @param lastActivityDateFrom (optional) 
     * @param lastActivityDateTo (optional) 
     * @param includeDeleted (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     * @return Success
     */
    getTicketNotesMetadata(idGreaterThanOrEqual: number | undefined, idLessThanOrEqual: number | undefined, lastActivityDateFrom: Date | undefined, lastActivityDateTo: Date | undefined, includeDeleted: boolean | undefined, pageSize: number | undefined, orderBy: OrderBy | undefined, cancelToken?: CancelToken): Promise<TicketNoteMetadataDto[]> {
        let url_ = this.baseUrl + "/api/data/AutotaskDataExchange/ticket-notes/metadata?";
        if (idGreaterThanOrEqual === null)
            throw new Error("The parameter 'idGreaterThanOrEqual' cannot be null.");
        else if (idGreaterThanOrEqual !== undefined)
            url_ += "IdGreaterThanOrEqual=" + encodeURIComponent("" + idGreaterThanOrEqual) + "&";
        if (idLessThanOrEqual === null)
            throw new Error("The parameter 'idLessThanOrEqual' cannot be null.");
        else if (idLessThanOrEqual !== undefined)
            url_ += "IdLessThanOrEqual=" + encodeURIComponent("" + idLessThanOrEqual) + "&";
        if (lastActivityDateFrom === null)
            throw new Error("The parameter 'lastActivityDateFrom' cannot be null.");
        else if (lastActivityDateFrom !== undefined)
            url_ += "LastActivityDateFrom=" + encodeURIComponent(lastActivityDateFrom ? "" + lastActivityDateFrom.toISOString() : "") + "&";
        if (lastActivityDateTo === null)
            throw new Error("The parameter 'lastActivityDateTo' cannot be null.");
        else if (lastActivityDateTo !== undefined)
            url_ += "LastActivityDateTo=" + encodeURIComponent(lastActivityDateTo ? "" + lastActivityDateTo.toISOString() : "") + "&";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "IncludeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTicketNotesMetadata(_response);
        });
    }

    protected processGetTicketNotesMetadata(response: AxiosResponse): Promise<TicketNoteMetadataDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TicketNoteMetadataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TicketNoteMetadataDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TicketNoteMetadataDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getTicketNotesMetadataByIds(body: number[] | undefined, cancelToken?: CancelToken): Promise<TicketNoteMetadataDto[]> {
        let url_ = this.baseUrl + "/api/data/AutotaskDataExchange/ticket-notes/metadata-by-ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTicketNotesMetadataByIds(_response);
        });
    }

    protected processGetTicketNotesMetadataByIds(response: AxiosResponse): Promise<TicketNoteMetadataDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TicketNoteMetadataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TicketNoteMetadataDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TicketNoteMetadataDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getTimeEntriesMetadataByIds(body: number[] | undefined, cancelToken?: CancelToken): Promise<TimeEntryMetadataDto[]> {
        let url_ = this.baseUrl + "/api/data/AutotaskDataExchange/time-entries/metadata-by-ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTimeEntriesMetadataByIds(_response);
        });
    }

    protected processGetTimeEntriesMetadataByIds(response: AxiosResponse): Promise<TimeEntryMetadataDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TimeEntryMetadataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TimeEntryMetadataDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TimeEntryMetadataDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getServiceLevelAgreementResultsMetadataByIds(body: number[] | undefined, cancelToken?: CancelToken): Promise<ServiceLevelAgreementResultMetadataDto[]> {
        let url_ = this.baseUrl + "/api/data/AutotaskDataExchange/service-level-agreement-results/metadata-by-ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetServiceLevelAgreementResultsMetadataByIds(_response);
        });
    }

    protected processGetServiceLevelAgreementResultsMetadataByIds(response: AxiosResponse): Promise<ServiceLevelAgreementResultMetadataDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceLevelAgreementResultMetadataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ServiceLevelAgreementResultMetadataDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceLevelAgreementResultMetadataDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getSurveyResultMetadataByIds(body: number[] | undefined, cancelToken?: CancelToken): Promise<SurveyResultMetadataDto[]> {
        let url_ = this.baseUrl + "/api/data/AutotaskDataExchange/survey-results/metadata-by-ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSurveyResultMetadataByIds(_response);
        });
    }

    protected processGetSurveyResultMetadataByIds(response: AxiosResponse): Promise<SurveyResultMetadataDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SurveyResultMetadataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SurveyResultMetadataDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyResultMetadataDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getBillingItemMetadataByIds(body: number[] | undefined, cancelToken?: CancelToken): Promise<BillingItemMetadataDto[]> {
        let url_ = this.baseUrl + "/api/data/AutotaskDataExchange/billing-item-results/metadata-by-ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBillingItemMetadataByIds(_response);
        });
    }

    protected processGetBillingItemMetadataByIds(response: AxiosResponse): Promise<BillingItemMetadataDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BillingItemMetadataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<BillingItemMetadataDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BillingItemMetadataDto[]>(null as any);
    }
}

export interface IAutoTaskWebhookClient {
    /**
     * @param body (optional) 
     * @return Success
     */
    handleNewWebhookEvent(body: AutoTaskWebhookDTO | undefined): Promise<void>;
}

export class AutoTaskWebhookClient extends AuthorizedApiBase implements IAutoTaskWebhookClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    handleNewWebhookEvent(body: AutoTaskWebhookDTO | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/AutoTaskWebhook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHandleNewWebhookEvent(_response);
        });
    }

    protected processHandleNewWebhookEvent(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IAwsAccountClient {
    /**
     * Checks the status of a current aws account request.
     * @param body (optional) 
     * @return Success
     */
    getAccountStatus(body: LinkedAccount_StatusRequest | undefined): Promise<LinkedAccountResponse>;
    /**
     * Adds a brand new aws account to a specific organization
     * @param body (optional) 
     * @return Success
     */
    createAccount(body: LinkedAccount_CreateRequest | undefined): Promise<LinkedAccountResponse>;
    /**
     * Invites a created aws account to a specific organization.
     * @param body (optional) 
     * @return Success
     */
    inviteAccount(body: LinkedAccount_InviteRequest | undefined): Promise<LinkedAccountResponse>;
    /**
     * Requests a aws account operation to be cancelled.
     * @param body (optional) 
     * @return Success
     */
    cancelAccountAction(body: LinkedAccount_CancelRequest | undefined): Promise<LinkedAccountResponse>;
    /**
     * Gets all pending aws account requests
     * @return Success
     */
    getAllPendingAccounts(): Promise<LinkedAccountResponse_AllStatusesResponse>;
    /**
     * Acknowledges a canceled aws account request
     * @param body (optional) 
     * @return Success
     */
    completeCancel(body: LinkedAccount_CompleteCancelRequest | undefined): Promise<LinkedAccountResponse>;
    /**
     * Collector Endpoint to get list of Payeraccountnumbers and ax account records
     * @return Success
     */
    getCustomerAccountMappings(): Promise<CustomerAccountMappingResponse>;
}

export class AwsAccountClient extends AuthorizedApiBase implements IAwsAccountClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Checks the status of a current aws account request.
     * @param body (optional) 
     * @return Success
     */
    getAccountStatus(body: LinkedAccount_StatusRequest | undefined, cancelToken?: CancelToken): Promise<LinkedAccountResponse> {
        let url_ = this.baseUrl + "/api/aws/Account/status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccountStatus(_response);
        });
    }

    protected processGetAccountStatus(response: AxiosResponse): Promise<LinkedAccountResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LinkedAccountResponse.fromJS(resultData200);
            return Promise.resolve<LinkedAccountResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LinkedAccountResponse>(null as any);
    }

    /**
     * Adds a brand new aws account to a specific organization
     * @param body (optional) 
     * @return Success
     */
    createAccount(body: LinkedAccount_CreateRequest | undefined, cancelToken?: CancelToken): Promise<LinkedAccountResponse> {
        let url_ = this.baseUrl + "/api/aws/Account/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateAccount(_response);
        });
    }

    protected processCreateAccount(response: AxiosResponse): Promise<LinkedAccountResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LinkedAccountResponse.fromJS(resultData200);
            return Promise.resolve<LinkedAccountResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LinkedAccountResponse>(null as any);
    }

    /**
     * Invites a created aws account to a specific organization.
     * @param body (optional) 
     * @return Success
     */
    inviteAccount(body: LinkedAccount_InviteRequest | undefined, cancelToken?: CancelToken): Promise<LinkedAccountResponse> {
        let url_ = this.baseUrl + "/api/aws/Account/invite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInviteAccount(_response);
        });
    }

    protected processInviteAccount(response: AxiosResponse): Promise<LinkedAccountResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LinkedAccountResponse.fromJS(resultData200);
            return Promise.resolve<LinkedAccountResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LinkedAccountResponse>(null as any);
    }

    /**
     * Requests a aws account operation to be cancelled.
     * @param body (optional) 
     * @return Success
     */
    cancelAccountAction(body: LinkedAccount_CancelRequest | undefined, cancelToken?: CancelToken): Promise<LinkedAccountResponse> {
        let url_ = this.baseUrl + "/api/aws/Account/cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelAccountAction(_response);
        });
    }

    protected processCancelAccountAction(response: AxiosResponse): Promise<LinkedAccountResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LinkedAccountResponse.fromJS(resultData200);
            return Promise.resolve<LinkedAccountResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LinkedAccountResponse>(null as any);
    }

    /**
     * Gets all pending aws account requests
     * @return Success
     */
    getAllPendingAccounts( cancelToken?: CancelToken): Promise<LinkedAccountResponse_AllStatusesResponse> {
        let url_ = this.baseUrl + "/api/aws/Account/status/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllPendingAccounts(_response);
        });
    }

    protected processGetAllPendingAccounts(response: AxiosResponse): Promise<LinkedAccountResponse_AllStatusesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LinkedAccountResponse_AllStatusesResponse.fromJS(resultData200);
            return Promise.resolve<LinkedAccountResponse_AllStatusesResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LinkedAccountResponse_AllStatusesResponse>(null as any);
    }

    /**
     * Acknowledges a canceled aws account request
     * @param body (optional) 
     * @return Success
     */
    completeCancel(body: LinkedAccount_CompleteCancelRequest | undefined, cancelToken?: CancelToken): Promise<LinkedAccountResponse> {
        let url_ = this.baseUrl + "/api/aws/Account/complete-cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompleteCancel(_response);
        });
    }

    protected processCompleteCancel(response: AxiosResponse): Promise<LinkedAccountResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LinkedAccountResponse.fromJS(resultData200);
            return Promise.resolve<LinkedAccountResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LinkedAccountResponse>(null as any);
    }

    /**
     * Collector Endpoint to get list of Payeraccountnumbers and ax account records
     * @return Success
     */
    getCustomerAccountMappings( cancelToken?: CancelToken): Promise<CustomerAccountMappingResponse> {
        let url_ = this.baseUrl + "/api/aws/Account/customer-account-mappings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomerAccountMappings(_response);
        });
    }

    protected processGetCustomerAccountMappings(response: AxiosResponse): Promise<CustomerAccountMappingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerAccountMappingResponse.fromJS(resultData200);
            return Promise.resolve<CustomerAccountMappingResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerAccountMappingResponse>(null as any);
    }
}

export interface IAwsPotentialSavingsWidgetClient {
    /**
     * @return Success
     */
    getAwsPotentialSavingsWidget(): Promise<WidgetContentResponseDto_1OfAwsPotentialSavingsWidgetDto>;
}

export class AwsPotentialSavingsWidgetClient extends AuthorizedApiBase implements IAwsPotentialSavingsWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getAwsPotentialSavingsWidget( cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfAwsPotentialSavingsWidgetDto> {
        let url_ = this.baseUrl + "/api/widget/aws-potential-savings-widget";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAwsPotentialSavingsWidget(_response);
        });
    }

    protected processGetAwsPotentialSavingsWidget(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfAwsPotentialSavingsWidgetDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfAwsPotentialSavingsWidgetDto.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfAwsPotentialSavingsWidgetDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfAwsPotentialSavingsWidgetDto>(null as any);
    }
}

export interface IAwsSimpleRecommendationsClient {
    /**
     * Gets a Customers Trusted Advisor Check Results, Summaries and Descriptions.
     * @return Success
     */
    getTrustedAdvisor(): Promise<TrustedAdvisorResult[]>;
    /**
     * Gets Customers Reservation Purchase Recommendation data
     * @return Success
     */
    getReservationPurchaseRecommendations(): Promise<ReservationPurchaseResult[]>;
    /**
     * Gets Customer Rightsizing Recommendation data
     * @return Success
     */
    getRightsizingRecommendations(): Promise<RightSizingResult[]>;
    /**
     * Gets a customers Savings Plan Purchase Recommendation Data.
     * @return Success
     */
    getSavingsPlanRecommendations(): Promise<SavingsPlansPurchaseResult[]>;
}

export class AwsSimpleRecommendationsClient extends AuthorizedApiBase implements IAwsSimpleRecommendationsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets a Customers Trusted Advisor Check Results, Summaries and Descriptions.
     * @return Success
     */
    getTrustedAdvisor( cancelToken?: CancelToken): Promise<TrustedAdvisorResult[]> {
        let url_ = this.baseUrl + "/api/AwsSimpleRecommendations/trusted-advisor";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTrustedAdvisor(_response);
        });
    }

    protected processGetTrustedAdvisor(response: AxiosResponse): Promise<TrustedAdvisorResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrustedAdvisorResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TrustedAdvisorResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrustedAdvisorResult[]>(null as any);
    }

    /**
     * Gets Customers Reservation Purchase Recommendation data
     * @return Success
     */
    getReservationPurchaseRecommendations( cancelToken?: CancelToken): Promise<ReservationPurchaseResult[]> {
        let url_ = this.baseUrl + "/api/AwsSimpleRecommendations/reservation-purchase-recommendations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReservationPurchaseRecommendations(_response);
        });
    }

    protected processGetReservationPurchaseRecommendations(response: AxiosResponse): Promise<ReservationPurchaseResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReservationPurchaseResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ReservationPurchaseResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReservationPurchaseResult[]>(null as any);
    }

    /**
     * Gets Customer Rightsizing Recommendation data
     * @return Success
     */
    getRightsizingRecommendations( cancelToken?: CancelToken): Promise<RightSizingResult[]> {
        let url_ = this.baseUrl + "/api/AwsSimpleRecommendations/rightsizing-recommendations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRightsizingRecommendations(_response);
        });
    }

    protected processGetRightsizingRecommendations(response: AxiosResponse): Promise<RightSizingResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RightSizingResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<RightSizingResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RightSizingResult[]>(null as any);
    }

    /**
     * Gets a customers Savings Plan Purchase Recommendation Data.
     * @return Success
     */
    getSavingsPlanRecommendations( cancelToken?: CancelToken): Promise<SavingsPlansPurchaseResult[]> {
        let url_ = this.baseUrl + "/api/AwsSimpleRecommendations/savings-plan-recommendations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSavingsPlanRecommendations(_response);
        });
    }

    protected processGetSavingsPlanRecommendations(response: AxiosResponse): Promise<SavingsPlansPurchaseResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SavingsPlansPurchaseResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SavingsPlansPurchaseResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SavingsPlansPurchaseResult[]>(null as any);
    }
}

export interface IAXInvoiceClient {
    /**
     * @return Success
     */
    getInvoicesByTag(tag: string): Promise<Invoice_Response>;
    /**
     * @return Success
     */
    getInvoicesByTagAndProjectName(tag: string, projectName: string): Promise<Invoice_Response>;
    /**
     * @return Success
     */
    getInvoicesByMonth(): Promise<InvoicesByMonthResponseDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    requestInvoices(tag: string, projectName: string, body: InvoiceEmail_Request | undefined): Promise<InvoiceEmail_Response>;
    /**
     * @param body (optional) 
     * @return Success
     */
    sendInvoicesToEmail(body: EmailInvoicesDto | undefined): Promise<InvoiceEmail_Response>;
    /**
     * @return Success
     */
    lastMonthsInvoiceCost(lastMonthsCostType: LastMonthsCostType): Promise<LastMonthsCostDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    searchInvoices(body: InvoiceSearchFilterDto | undefined): Promise<PagedInvoiceResponseDto>;
}

export class AXInvoiceClient extends AuthorizedApiBase implements IAXInvoiceClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getInvoicesByTag(tag: string, cancelToken?: CancelToken): Promise<Invoice_Response> {
        let url_ = this.baseUrl + "/api/invoice/{tag}";
        if (tag === undefined || tag === null)
            throw new Error("The parameter 'tag' must be defined.");
        url_ = url_.replace("{tag}", encodeURIComponent("" + tag));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoicesByTag(_response);
        });
    }

    protected processGetInvoicesByTag(response: AxiosResponse): Promise<Invoice_Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Invoice_Response.fromJS(resultData200);
            return Promise.resolve<Invoice_Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Invoice_Response>(null as any);
    }

    /**
     * @return Success
     */
    getInvoicesByTagAndProjectName(tag: string, projectName: string, cancelToken?: CancelToken): Promise<Invoice_Response> {
        let url_ = this.baseUrl + "/api/invoice/{tag}/{projectName}";
        if (tag === undefined || tag === null)
            throw new Error("The parameter 'tag' must be defined.");
        url_ = url_.replace("{tag}", encodeURIComponent("" + tag));
        if (projectName === undefined || projectName === null)
            throw new Error("The parameter 'projectName' must be defined.");
        url_ = url_.replace("{projectName}", encodeURIComponent("" + projectName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoicesByTagAndProjectName(_response);
        });
    }

    protected processGetInvoicesByTagAndProjectName(response: AxiosResponse): Promise<Invoice_Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Invoice_Response.fromJS(resultData200);
            return Promise.resolve<Invoice_Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Invoice_Response>(null as any);
    }

    /**
     * @return Success
     */
    getInvoicesByMonth( cancelToken?: CancelToken): Promise<InvoicesByMonthResponseDto> {
        let url_ = this.baseUrl + "/api/invoice/month";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoicesByMonth(_response);
        });
    }

    protected processGetInvoicesByMonth(response: AxiosResponse): Promise<InvoicesByMonthResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InvoicesByMonthResponseDto.fromJS(resultData200);
            return Promise.resolve<InvoicesByMonthResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvoicesByMonthResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    requestInvoices(tag: string, projectName: string, body: InvoiceEmail_Request | undefined, cancelToken?: CancelToken): Promise<InvoiceEmail_Response> {
        let url_ = this.baseUrl + "/api/invoice/email/{tag}/{projectName}";
        if (tag === undefined || tag === null)
            throw new Error("The parameter 'tag' must be defined.");
        url_ = url_.replace("{tag}", encodeURIComponent("" + tag));
        if (projectName === undefined || projectName === null)
            throw new Error("The parameter 'projectName' must be defined.");
        url_ = url_.replace("{projectName}", encodeURIComponent("" + projectName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequestInvoices(_response);
        });
    }

    protected processRequestInvoices(response: AxiosResponse): Promise<InvoiceEmail_Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InvoiceEmail_Response.fromJS(resultData200);
            return Promise.resolve<InvoiceEmail_Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvoiceEmail_Response>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendInvoicesToEmail(body: EmailInvoicesDto | undefined, cancelToken?: CancelToken): Promise<InvoiceEmail_Response> {
        let url_ = this.baseUrl + "/api/invoice/email-invoices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendInvoicesToEmail(_response);
        });
    }

    protected processSendInvoicesToEmail(response: AxiosResponse): Promise<InvoiceEmail_Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InvoiceEmail_Response.fromJS(resultData200);
            return Promise.resolve<InvoiceEmail_Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvoiceEmail_Response>(null as any);
    }

    /**
     * @return Success
     */
    lastMonthsInvoiceCost(lastMonthsCostType: LastMonthsCostType, cancelToken?: CancelToken): Promise<LastMonthsCostDto> {
        let url_ = this.baseUrl + "/api/invoice/last-months-cost/{lastMonthsCostType}";
        if (lastMonthsCostType === undefined || lastMonthsCostType === null)
            throw new Error("The parameter 'lastMonthsCostType' must be defined.");
        url_ = url_.replace("{lastMonthsCostType}", encodeURIComponent("" + lastMonthsCostType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLastMonthsInvoiceCost(_response);
        });
    }

    protected processLastMonthsInvoiceCost(response: AxiosResponse): Promise<LastMonthsCostDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LastMonthsCostDto.fromJS(resultData200);
            return Promise.resolve<LastMonthsCostDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LastMonthsCostDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchInvoices(body: InvoiceSearchFilterDto | undefined, cancelToken?: CancelToken): Promise<PagedInvoiceResponseDto> {
        let url_ = this.baseUrl + "/api/invoice/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchInvoices(_response);
        });
    }

    protected processSearchInvoices(response: AxiosResponse): Promise<PagedInvoiceResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedInvoiceResponseDto.fromJS(resultData200);
            return Promise.resolve<PagedInvoiceResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedInvoiceResponseDto>(null as any);
    }
}

export interface IAzureBackupsClient {
    /**
     * Gets a given customer's Azure Backups by Subscription Id.
     * @return Success
     */
    getAzureBackups(): Promise<SimpleProtectedItemResource[]>;
}

export class AzureBackupsClient extends AuthorizedApiBase implements IAzureBackupsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets a given customer's Azure Backups by Subscription Id.
     * @return Success
     */
    getAzureBackups( cancelToken?: CancelToken): Promise<SimpleProtectedItemResource[]> {
        let url_ = this.baseUrl + "/api/AzureBackups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAzureBackups(_response);
        });
    }

    protected processGetAzureBackups(response: AxiosResponse): Promise<SimpleProtectedItemResource[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SimpleProtectedItemResource.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SimpleProtectedItemResource[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SimpleProtectedItemResource[]>(null as any);
    }
}

export interface IAzureComplianceClient {
    /**
     * Gets azure compliance data from the Collectors Web Api.
     * @return Success
     */
    getAzureComplianceData(): Promise<Subscription[]>;
    /**
     * Gets azure compliance data by subscription id from the Collectors Web Api.
     * @param subscriptionId The subscription id we will search with
     * @return Success
     */
    getAzureComplianceBySubscriptionData(subscriptionId: string): Promise<Subscription>;
}

export class AzureComplianceClient extends AuthorizedApiBase implements IAzureComplianceClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets azure compliance data from the Collectors Web Api.
     * @return Success
     */
    getAzureComplianceData( cancelToken?: CancelToken): Promise<Subscription[]> {
        let url_ = this.baseUrl + "/api/AzureCompliance/subscription";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAzureComplianceData(_response);
        });
    }

    protected processGetAzureComplianceData(response: AxiosResponse): Promise<Subscription[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Subscription.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Subscription[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Subscription[]>(null as any);
    }

    /**
     * Gets azure compliance data by subscription id from the Collectors Web Api.
     * @param subscriptionId The subscription id we will search with
     * @return Success
     */
    getAzureComplianceBySubscriptionData(subscriptionId: string, cancelToken?: CancelToken): Promise<Subscription> {
        let url_ = this.baseUrl + "/api/AzureCompliance/subscription/{subscriptionId}";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAzureComplianceBySubscriptionData(_response);
        });
    }

    protected processGetAzureComplianceBySubscriptionData(response: AxiosResponse): Promise<Subscription> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Subscription.fromJS(resultData200);
            return Promise.resolve<Subscription>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Subscription>(null as any);
    }
}

export interface IAzureSimpleRecommendationsClient {
    /**
     * Gets a given customer's Azure Recommendations by Subscription Id.
     * @return Success
     */
    getAzureSimpleRecommendations(): Promise<ResourceRecommendation[]>;
    /**
     * Gets Azure Recommendations by Subscription Id.
     * @param subscriptionId The subscription id we will search with
     * @return Success
     */
    getAzureSimpleRecommendationsBySubscriptionId(subscriptionId: string): Promise<ResourceRecommendation[]>;
}

export class AzureSimpleRecommendationsClient extends AuthorizedApiBase implements IAzureSimpleRecommendationsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets a given customer's Azure Recommendations by Subscription Id.
     * @return Success
     */
    getAzureSimpleRecommendations( cancelToken?: CancelToken): Promise<ResourceRecommendation[]> {
        let url_ = this.baseUrl + "/api/AzureSimpleRecommendations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAzureSimpleRecommendations(_response);
        });
    }

    protected processGetAzureSimpleRecommendations(response: AxiosResponse): Promise<ResourceRecommendation[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResourceRecommendation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ResourceRecommendation[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResourceRecommendation[]>(null as any);
    }

    /**
     * Gets Azure Recommendations by Subscription Id.
     * @param subscriptionId The subscription id we will search with
     * @return Success
     */
    getAzureSimpleRecommendationsBySubscriptionId(subscriptionId: string, cancelToken?: CancelToken): Promise<ResourceRecommendation[]> {
        let url_ = this.baseUrl + "/api/AzureSimpleRecommendations/simple/{subscriptionId}";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAzureSimpleRecommendationsBySubscriptionId(_response);
        });
    }

    protected processGetAzureSimpleRecommendationsBySubscriptionId(response: AxiosResponse): Promise<ResourceRecommendation[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResourceRecommendation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ResourceRecommendation[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResourceRecommendation[]>(null as any);
    }
}

export interface IAzureSubscriptionClient {
    /**
     * Creates a new Azure Subscription on behalf of a customer.
     * @param body (optional) 
     * @return Success
     */
    putSubscription(body: AzureCreateSubscriptionRequest | undefined): Promise<AzureSubscriptionResponse>;
    /**
     * Gets a list of pending subscriptions.
     * @return Success
     */
    getPendingSubscriptions(): Promise<AzureSubscriptionStatusResponse>;
}

export class AzureSubscriptionClient extends AuthorizedApiBase implements IAzureSubscriptionClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Creates a new Azure Subscription on behalf of a customer.
     * @param body (optional) 
     * @return Success
     */
    putSubscription(body: AzureCreateSubscriptionRequest | undefined, cancelToken?: CancelToken): Promise<AzureSubscriptionResponse> {
        let url_ = this.baseUrl + "/api/AzureSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPutSubscription(_response);
        });
    }

    protected processPutSubscription(response: AxiosResponse): Promise<AzureSubscriptionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AzureSubscriptionResponse.fromJS(resultData200);
            return Promise.resolve<AzureSubscriptionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AzureSubscriptionResponse>(null as any);
    }

    /**
     * Gets a list of pending subscriptions.
     * @return Success
     */
    getPendingSubscriptions( cancelToken?: CancelToken): Promise<AzureSubscriptionStatusResponse> {
        let url_ = this.baseUrl + "/api/AzureSubscription/status/pending";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPendingSubscriptions(_response);
        });
    }

    protected processGetPendingSubscriptions(response: AxiosResponse): Promise<AzureSubscriptionStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AzureSubscriptionStatusResponse.fromJS(resultData200);
            return Promise.resolve<AzureSubscriptionStatusResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AzureSubscriptionStatusResponse>(null as any);
    }
}

export interface IBackupClient {
    /**
     * @param body (optional) 
     * @return Success
     */
    getBackupStats(body: UsageDataReportRequest | undefined): Promise<void>;
    /**
     * @return Success
     */
    getAzureAlerts(): Promise<AzureBackupAlert[]>;
}

export class BackupClient extends AuthorizedApiBase implements IBackupClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getBackupStats(body: UsageDataReportRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/backup/order/backupstats";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBackupStats(_response);
        });
    }

    protected processGetBackupStats(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getAzureAlerts( cancelToken?: CancelToken): Promise<AzureBackupAlert[]> {
        let url_ = this.baseUrl + "/api/backup/azure/alerts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAzureAlerts(_response);
        });
    }

    protected processGetAzureAlerts(response: AxiosResponse): Promise<AzureBackupAlert[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AzureBackupAlert.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AzureBackupAlert[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AzureBackupAlert[]>(null as any);
    }
}

export interface IBookmarkClient {
    /**
     * @return Success
     */
    getAllBookmarks(reportId: string): Promise<BookmarksDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addBookmark(body: BookmarkDto | undefined): Promise<Bookmark>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateBookmark(body: BookmarkDto | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    deleteBookmark(body: BookmarkDto | undefined): Promise<void>;
}

export class BookmarkClient extends AuthorizedApiBase implements IBookmarkClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getAllBookmarks(reportId: string, cancelToken?: CancelToken): Promise<BookmarksDto> {
        let url_ = this.baseUrl + "/api/Bookmarks/{reportId}";
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllBookmarks(_response);
        });
    }

    protected processGetAllBookmarks(response: AxiosResponse): Promise<BookmarksDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BookmarksDto.fromJS(resultData200);
            return Promise.resolve<BookmarksDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookmarksDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addBookmark(body: BookmarkDto | undefined, cancelToken?: CancelToken): Promise<Bookmark> {
        let url_ = this.baseUrl + "/api/Bookmarks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddBookmark(_response);
        });
    }

    protected processAddBookmark(response: AxiosResponse): Promise<Bookmark> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Bookmark.fromJS(resultData200);
            return Promise.resolve<Bookmark>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Bookmark>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateBookmark(body: BookmarkDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Bookmarks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBookmark(_response);
        });
    }

    protected processUpdateBookmark(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteBookmark(body: BookmarkDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Bookmarks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteBookmark(_response);
        });
    }

    protected processDeleteBookmark(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IBusinessUnitClient {
    /**
     * @param body (optional) 
     * @return Success
     */
    updateBusinessPathAccount(body: BusinessPathAccount[] | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateBusinessPaths(body: BusinessPath[] | undefined): Promise<void>;
}

export class BusinessUnitClient extends AuthorizedApiBase implements IBusinessUnitClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateBusinessPathAccount(body: BusinessPathAccount[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/BusinessUnit/update-accounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBusinessPathAccount(_response);
        });
    }

    protected processUpdateBusinessPathAccount(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateBusinessPaths(body: BusinessPath[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/BusinessUnit/update-paths";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBusinessPaths(_response);
        });
    }

    protected processUpdateBusinessPaths(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICiscoReportClient {
    /**
     * @return Success
     */
    updatePbiRenewalReport(): Promise<void>;
}

export class CiscoReportClient extends AuthorizedApiBase implements ICiscoReportClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    updatePbiRenewalReport( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/CiscoReport/renewal-report";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePbiRenewalReport(_response);
        });
    }

    protected processUpdatePbiRenewalReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IClaimsClient {
    /**
     * @return Success
     */
    getClaimsBase64(email: string): Promise<string>;
    /**
     * @return Success
     */
    getClaims(email: string): Promise<string>;
}

export class ClaimsClient extends AuthorizedApiBase implements IClaimsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getClaimsBase64(email: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/claims/user/encoded/{email}";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetClaimsBase64(_response);
        });
    }

    protected processGetClaimsBase64(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Success
     */
    getClaims(email: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/claims/user/{email}";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetClaims(_response);
        });
    }

    protected processGetClaims(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface IClientManagementClient {
    /**
     * @param body (optional) 
     * @return Success
     */
    checkOnboardingStatus(body: number[] | undefined): Promise<AccountConfiguredStatus>;
    /**
     * @param body (optional) 
     * @return Success
     */
    createWelcomeLink(body: AccountWelcomeLink | undefined): Promise<AccountWelcomeLink>;
    /**
     * @param body (optional) 
     * @return Success
     */
    createGuestUserProfile(body: CreateGuestUserProfile | undefined): Promise<GuestUserProfile>;
    /**
     * @return Success
     */
    getClientAccount(id: number): Promise<ClientAccountDTO>;
    /**
     * @param body (optional) 
     * @return Success
     */
    editAxNumbers(body: AXNumberEdit | undefined): Promise<ClientAccountsDTO>;
    /**
     * @return Success
     */
    getAxReferences(accountId: number): Promise<ClientAccountsDTO>;
    /**
     * @return Success
     */
    getUser(id: number): Promise<ClientUsersDTO>;
    /**
     * @return Success
     */
    getAccountTeam(accountId: number): Promise<AccountTeamMemberResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateAccountTeamMember(body: AccountTeamMember | undefined): Promise<AccountTeamMemberResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    removeAccountTeamMember(body: AccountTeamMember | undefined): Promise<AccountTeamMemberResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addAccountTeamMember(body: AccountTeamMember | undefined): Promise<AccountTeamMemberResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateAccountType(body: AccountTypeUpdate | undefined): Promise<AccountTypeUpdate>;
}

export class ClientManagementClient extends AuthorizedApiBase implements IClientManagementClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkOnboardingStatus(body: number[] | undefined, cancelToken?: CancelToken): Promise<AccountConfiguredStatus> {
        let url_ = this.baseUrl + "/api/clientmanagement/checkOnboardingStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckOnboardingStatus(_response);
        });
    }

    protected processCheckOnboardingStatus(response: AxiosResponse): Promise<AccountConfiguredStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountConfiguredStatus.fromJS(resultData200);
            return Promise.resolve<AccountConfiguredStatus>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountConfiguredStatus>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createWelcomeLink(body: AccountWelcomeLink | undefined, cancelToken?: CancelToken): Promise<AccountWelcomeLink> {
        let url_ = this.baseUrl + "/api/clientmanagement/createWelcomeLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateWelcomeLink(_response);
        });
    }

    protected processCreateWelcomeLink(response: AxiosResponse): Promise<AccountWelcomeLink> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountWelcomeLink.fromJS(resultData200);
            return Promise.resolve<AccountWelcomeLink>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountWelcomeLink>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createGuestUserProfile(body: CreateGuestUserProfile | undefined, cancelToken?: CancelToken): Promise<GuestUserProfile> {
        let url_ = this.baseUrl + "/api/clientmanagement/guest-user-profile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateGuestUserProfile(_response);
        });
    }

    protected processCreateGuestUserProfile(response: AxiosResponse): Promise<GuestUserProfile> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GuestUserProfile.fromJS(resultData200);
            return Promise.resolve<GuestUserProfile>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GuestUserProfile>(null as any);
    }

    /**
     * @return Success
     */
    getClientAccount(id: number, cancelToken?: CancelToken): Promise<ClientAccountDTO> {
        let url_ = this.baseUrl + "/api/clientmanagement/clientbyid/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetClientAccount(_response);
        });
    }

    protected processGetClientAccount(response: AxiosResponse): Promise<ClientAccountDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ClientAccountDTO.fromJS(resultData200);
            return Promise.resolve<ClientAccountDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClientAccountDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editAxNumbers(body: AXNumberEdit | undefined, cancelToken?: CancelToken): Promise<ClientAccountsDTO> {
        let url_ = this.baseUrl + "/api/clientmanagement/client/addAxNumbers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditAxNumbers(_response);
        });
    }

    protected processEditAxNumbers(response: AxiosResponse): Promise<ClientAccountsDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ClientAccountsDTO.fromJS(resultData200);
            return Promise.resolve<ClientAccountsDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClientAccountsDTO>(null as any);
    }

    /**
     * @return Success
     */
    getAxReferences(accountId: number, cancelToken?: CancelToken): Promise<ClientAccountsDTO> {
        let url_ = this.baseUrl + "/api/clientmanagement/client/axReferences/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAxReferences(_response);
        });
    }

    protected processGetAxReferences(response: AxiosResponse): Promise<ClientAccountsDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ClientAccountsDTO.fromJS(resultData200);
            return Promise.resolve<ClientAccountsDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClientAccountsDTO>(null as any);
    }

    /**
     * @return Success
     */
    getUser(id: number, cancelToken?: CancelToken): Promise<ClientUsersDTO> {
        let url_ = this.baseUrl + "/api/clientmanagement/users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUser(_response);
        });
    }

    protected processGetUser(response: AxiosResponse): Promise<ClientUsersDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ClientUsersDTO.fromJS(resultData200);
            return Promise.resolve<ClientUsersDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClientUsersDTO>(null as any);
    }

    /**
     * @return Success
     */
    getAccountTeam(accountId: number, cancelToken?: CancelToken): Promise<AccountTeamMemberResponse> {
        let url_ = this.baseUrl + "/api/clientmanagement/accountTeam/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccountTeam(_response);
        });
    }

    protected processGetAccountTeam(response: AxiosResponse): Promise<AccountTeamMemberResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountTeamMemberResponse.fromJS(resultData200);
            return Promise.resolve<AccountTeamMemberResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountTeamMemberResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAccountTeamMember(body: AccountTeamMember | undefined, cancelToken?: CancelToken): Promise<AccountTeamMemberResponse> {
        let url_ = this.baseUrl + "/api/clientmanagement/accountTeam/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAccountTeamMember(_response);
        });
    }

    protected processUpdateAccountTeamMember(response: AxiosResponse): Promise<AccountTeamMemberResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountTeamMemberResponse.fromJS(resultData200);
            return Promise.resolve<AccountTeamMemberResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountTeamMemberResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    removeAccountTeamMember(body: AccountTeamMember | undefined, cancelToken?: CancelToken): Promise<AccountTeamMemberResponse> {
        let url_ = this.baseUrl + "/api/clientmanagement/accountTeam/remove";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveAccountTeamMember(_response);
        });
    }

    protected processRemoveAccountTeamMember(response: AxiosResponse): Promise<AccountTeamMemberResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountTeamMemberResponse.fromJS(resultData200);
            return Promise.resolve<AccountTeamMemberResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountTeamMemberResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addAccountTeamMember(body: AccountTeamMember | undefined, cancelToken?: CancelToken): Promise<AccountTeamMemberResponse> {
        let url_ = this.baseUrl + "/api/clientmanagement/accountTeam/add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddAccountTeamMember(_response);
        });
    }

    protected processAddAccountTeamMember(response: AxiosResponse): Promise<AccountTeamMemberResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountTeamMemberResponse.fromJS(resultData200);
            return Promise.resolve<AccountTeamMemberResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountTeamMemberResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAccountType(body: AccountTypeUpdate | undefined, cancelToken?: CancelToken): Promise<AccountTypeUpdate> {
        let url_ = this.baseUrl + "/api/clientmanagement/accountType/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAccountType(_response);
        });
    }

    protected processUpdateAccountType(response: AxiosResponse): Promise<AccountTypeUpdate> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountTypeUpdate.fromJS(resultData200);
            return Promise.resolve<AccountTypeUpdate>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountTypeUpdate>(null as any);
    }
}

export interface ICloudAssetsWidgetClient {
    /**
     * @param widgetRequestType (optional) 
     * @return Success
     */
    getCloudAssets(widgetRequestType: CloudAssetWidgetRequestType | undefined): Promise<WidgetContentResponseDto_1OfCloudAssetsWidgetDtoOf>;
}

export class CloudAssetsWidgetClient extends AuthorizedApiBase implements ICloudAssetsWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param widgetRequestType (optional) 
     * @return Success
     */
    getCloudAssets(widgetRequestType: CloudAssetWidgetRequestType | undefined, cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfCloudAssetsWidgetDtoOf> {
        let url_ = this.baseUrl + "/api/widget/cloud-assets-widget?";
        if (widgetRequestType === null)
            throw new Error("The parameter 'widgetRequestType' cannot be null.");
        else if (widgetRequestType !== undefined)
            url_ += "widgetRequestType=" + encodeURIComponent("" + widgetRequestType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCloudAssets(_response);
        });
    }

    protected processGetCloudAssets(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfCloudAssetsWidgetDtoOf> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfCloudAssetsWidgetDtoOf.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfCloudAssetsWidgetDtoOf>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfCloudAssetsWidgetDtoOf>(null as any);
    }
}

export interface ICloudConfigurationItemClient {
    /**
     * Creates or Updates a configuration item in Autotask
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateCloudConfigItem(body: ConfigurationItem_CreateUpdate | undefined): Promise<ConfigurationItemCacheResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    bulkCreateOrUpdateCloudConfig(body: ConfigurationItem_CreateUpdate[] | undefined): Promise<ConfigurationItemsCacheResponse>;
}

export class CloudConfigurationItemClient extends AuthorizedApiBase implements ICloudConfigurationItemClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Creates or Updates a configuration item in Autotask
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateCloudConfigItem(body: ConfigurationItem_CreateUpdate | undefined, cancelToken?: CancelToken): Promise<ConfigurationItemCacheResponse> {
        let url_ = this.baseUrl + "/api/CloudConfigurationItem/CreateUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateCloudConfigItem(_response);
        });
    }

    protected processCreateOrUpdateCloudConfigItem(response: AxiosResponse): Promise<ConfigurationItemCacheResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConfigurationItemCacheResponse.fromJS(resultData200);
            return Promise.resolve<ConfigurationItemCacheResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConfigurationItemCacheResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    bulkCreateOrUpdateCloudConfig(body: ConfigurationItem_CreateUpdate[] | undefined, cancelToken?: CancelToken): Promise<ConfigurationItemsCacheResponse> {
        let url_ = this.baseUrl + "/api/CloudConfigurationItem/CreateUpdateBulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBulkCreateOrUpdateCloudConfig(_response);
        });
    }

    protected processBulkCreateOrUpdateCloudConfig(response: AxiosResponse): Promise<ConfigurationItemsCacheResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConfigurationItemsCacheResponse.fromJS(resultData200);
            return Promise.resolve<ConfigurationItemsCacheResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Client Error", status, _responseText, _headers);

        } else if (status === 429) {
            const _responseText = response.data;
            return throwException("Too Many Requests", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConfigurationItemsCacheResponse>(null as any);
    }
}

export interface ICloudConsumptionHistoryWidgetClient {
    /**
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @return Success
     */
    getCloudConsumptionHistory(dateFrom: Date | undefined, dateTo: Date | undefined): Promise<WidgetContentResponseDto_1OfGetCloudConsumptionHistoryResponse>;
}

export class CloudConsumptionHistoryWidgetClient extends AuthorizedApiBase implements ICloudConsumptionHistoryWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @return Success
     */
    getCloudConsumptionHistory(dateFrom: Date | undefined, dateTo: Date | undefined, cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfGetCloudConsumptionHistoryResponse> {
        let url_ = this.baseUrl + "/api/widget/cloud-consumption-history-widget?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCloudConsumptionHistory(_response);
        });
    }

    protected processGetCloudConsumptionHistory(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfGetCloudConsumptionHistoryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfGetCloudConsumptionHistoryResponse.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfGetCloudConsumptionHistoryResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfGetCloudConsumptionHistoryResponse>(null as any);
    }
}

export interface ICloudPotentialSavingsWidgetClient {
    /**
     * @return Success
     */
    getCloudPotentialSavingsWidgetData(): Promise<WidgetContentResponseDto_1OfCloudPotentialSavingsWidgetDto>;
}

export class CloudPotentialSavingsWidgetClient extends AuthorizedApiBase implements ICloudPotentialSavingsWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getCloudPotentialSavingsWidgetData( cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfCloudPotentialSavingsWidgetDto> {
        let url_ = this.baseUrl + "/api/widget/cloud-potential-savings-widget";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCloudPotentialSavingsWidgetData(_response);
        });
    }

    protected processGetCloudPotentialSavingsWidgetData(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfCloudPotentialSavingsWidgetDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfCloudPotentialSavingsWidgetDto.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfCloudPotentialSavingsWidgetDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfCloudPotentialSavingsWidgetDto>(null as any);
    }
}

export interface ICloudTagsClient {
    /**
     * @return Success
     */
    getElasticSearchCloudTagsKeys(): Promise<GetCloudTagKeysResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getElasticSearchCloudTagKeyValues(body: GetCloudTagKeyValuesRequest | undefined): Promise<GetCloudTagKeyValuesResponse>;
    /**
     * @return Success
     */
    getTagGroups(): Promise<GetCloudTagGroupsResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    createTagGroup(body: CreateUpdateCloudTagGroupRequest | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateTagGroup(body: CreateUpdateCloudTagGroupRequest | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    deleteTagGroup(body: DeleteCloudTagGroupRequest | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getCloudTagGroupCosts(body: GetCloudTagGroupCostsRequest | undefined): Promise<TagGroupCostReportDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getCloudTagGroupResources(body: GetCloudTagGroupResourcesRequest | undefined): Promise<GetCloudTagGroupResourcesResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getResourcePicklist(body: TagGroupResourcePicklistQuery | undefined): Promise<TagGroupResourcePicklistDto>;
}

export class CloudTagsClient extends AuthorizedApiBase implements ICloudTagsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getElasticSearchCloudTagsKeys( cancelToken?: CancelToken): Promise<GetCloudTagKeysResponse> {
        let url_ = this.baseUrl + "/api/CloudTags/get/tag-keys";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetElasticSearchCloudTagsKeys(_response);
        });
    }

    protected processGetElasticSearchCloudTagsKeys(response: AxiosResponse): Promise<GetCloudTagKeysResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCloudTagKeysResponse.fromJS(resultData200);
            return Promise.resolve<GetCloudTagKeysResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCloudTagKeysResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getElasticSearchCloudTagKeyValues(body: GetCloudTagKeyValuesRequest | undefined, cancelToken?: CancelToken): Promise<GetCloudTagKeyValuesResponse> {
        let url_ = this.baseUrl + "/api/CloudTags/get/tag-values";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetElasticSearchCloudTagKeyValues(_response);
        });
    }

    protected processGetElasticSearchCloudTagKeyValues(response: AxiosResponse): Promise<GetCloudTagKeyValuesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCloudTagKeyValuesResponse.fromJS(resultData200);
            return Promise.resolve<GetCloudTagKeyValuesResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCloudTagKeyValuesResponse>(null as any);
    }

    /**
     * @return Success
     */
    getTagGroups( cancelToken?: CancelToken): Promise<GetCloudTagGroupsResponse> {
        let url_ = this.baseUrl + "/api/CloudTags/get/tag-groups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTagGroups(_response);
        });
    }

    protected processGetTagGroups(response: AxiosResponse): Promise<GetCloudTagGroupsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCloudTagGroupsResponse.fromJS(resultData200);
            return Promise.resolve<GetCloudTagGroupsResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCloudTagGroupsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTagGroup(body: CreateUpdateCloudTagGroupRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/CloudTags/create/tag-group";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateTagGroup(_response);
        });
    }

    protected processCreateTagGroup(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTagGroup(body: CreateUpdateCloudTagGroupRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/CloudTags/update/tag-group";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTagGroup(_response);
        });
    }

    protected processUpdateTagGroup(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteTagGroup(body: DeleteCloudTagGroupRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/CloudTags/delete/tag-group";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteTagGroup(_response);
        });
    }

    protected processDeleteTagGroup(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCloudTagGroupCosts(body: GetCloudTagGroupCostsRequest | undefined, cancelToken?: CancelToken): Promise<TagGroupCostReportDto> {
        let url_ = this.baseUrl + "/api/CloudTags/get/tag-group-costs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCloudTagGroupCosts(_response);
        });
    }

    protected processGetCloudTagGroupCosts(response: AxiosResponse): Promise<TagGroupCostReportDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TagGroupCostReportDto.fromJS(resultData200);
            return Promise.resolve<TagGroupCostReportDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TagGroupCostReportDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCloudTagGroupResources(body: GetCloudTagGroupResourcesRequest | undefined, cancelToken?: CancelToken): Promise<GetCloudTagGroupResourcesResponse> {
        let url_ = this.baseUrl + "/api/CloudTags/get/tag-group-resources";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCloudTagGroupResources(_response);
        });
    }

    protected processGetCloudTagGroupResources(response: AxiosResponse): Promise<GetCloudTagGroupResourcesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCloudTagGroupResourcesResponse.fromJS(resultData200);
            return Promise.resolve<GetCloudTagGroupResourcesResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCloudTagGroupResourcesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getResourcePicklist(body: TagGroupResourcePicklistQuery | undefined, cancelToken?: CancelToken): Promise<TagGroupResourcePicklistDto> {
        let url_ = this.baseUrl + "/api/CloudTags/tag-group-resources-picklist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetResourcePicklist(_response);
        });
    }

    protected processGetResourcePicklist(response: AxiosResponse): Promise<TagGroupResourcePicklistDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TagGroupResourcePicklistDto.fromJS(resultData200);
            return Promise.resolve<TagGroupResourcePicklistDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TagGroupResourcePicklistDto>(null as any);
    }
}

export interface ICollectorClient {
    /**
     * @return Success
     */
    getCustomerAzureSubscriptions(): Promise<CustomerSubscription[]>;
    /**
     * Gets a list of details around the last collection of a given customers integration data.
     * @return Success
     */
    getHistoricalCollectionProcessorDetails(): Promise<HistoricalCollectionDetails[]>;
    /**
     * Gets a list of customer account identifiers.
     * @param cloudType (optional) 
     * @param serviceLevel (optional) 
     * @return Returns list of customer account identifiers.
     */
    getCloudAccountIdentifiers(cloudType: string | undefined, serviceLevel: string | undefined): Promise<CloudAccountIdentifier[]>;
}

export class CollectorClient extends AuthorizedApiBase implements ICollectorClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getCustomerAzureSubscriptions( cancelToken?: CancelToken): Promise<CustomerSubscription[]> {
        let url_ = this.baseUrl + "/api/collector/subscriptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomerAzureSubscriptions(_response);
        });
    }

    protected processGetCustomerAzureSubscriptions(response: AxiosResponse): Promise<CustomerSubscription[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerSubscription.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CustomerSubscription[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerSubscription[]>(null as any);
    }

    /**
     * Gets a list of details around the last collection of a given customers integration data.
     * @return Success
     */
    getHistoricalCollectionProcessorDetails( cancelToken?: CancelToken): Promise<HistoricalCollectionDetails[]> {
        let url_ = this.baseUrl + "/api/collector/historical-collection-details";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHistoricalCollectionProcessorDetails(_response);
        });
    }

    protected processGetHistoricalCollectionProcessorDetails(response: AxiosResponse): Promise<HistoricalCollectionDetails[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HistoricalCollectionDetails.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<HistoricalCollectionDetails[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HistoricalCollectionDetails[]>(null as any);
    }

    /**
     * Gets a list of customer account identifiers.
     * @param cloudType (optional) 
     * @param serviceLevel (optional) 
     * @return Returns list of customer account identifiers.
     */
    getCloudAccountIdentifiers(cloudType: string | undefined, serviceLevel: string | undefined, cancelToken?: CancelToken): Promise<CloudAccountIdentifier[]> {
        let url_ = this.baseUrl + "/api/collector/cloud-accounts?";
        if (cloudType === null)
            throw new Error("The parameter 'cloudType' cannot be null.");
        else if (cloudType !== undefined)
            url_ += "CloudType=" + encodeURIComponent("" + cloudType) + "&";
        if (serviceLevel === null)
            throw new Error("The parameter 'serviceLevel' cannot be null.");
        else if (serviceLevel !== undefined)
            url_ += "ServiceLevel=" + encodeURIComponent("" + serviceLevel) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCloudAccountIdentifiers(_response);
        });
    }

    protected processGetCloudAccountIdentifiers(response: AxiosResponse): Promise<CloudAccountIdentifier[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CloudAccountIdentifier.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CloudAccountIdentifier[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Bearer token does not have required scope.", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Exception is logged, no customer list is returned.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CloudAccountIdentifier[]>(null as any);
    }
}

export interface ICollectorFunctionsClient {
    /**
     * Testing endpoint to validate if a customer account has access to collect their cloud account data.
     * @param body (optional) 
     * @return Success
     */
    checkCustomerCloudAccess(body: AccessValidationRequest | undefined): Promise<AccessValidationResponse>;
    /**
     * Endpoint to initial a CRM Account refresh for the indicated account ax number.
     * @return Success
     */
    refreshCrmAccountTeam(accountTeamAxNumber: string): Promise<HttpStatusCode>;
}

export class CollectorFunctionsClient extends AuthorizedApiBase implements ICollectorFunctionsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Testing endpoint to validate if a customer account has access to collect their cloud account data.
     * @param body (optional) 
     * @return Success
     */
    checkCustomerCloudAccess(body: AccessValidationRequest | undefined, cancelToken?: CancelToken): Promise<AccessValidationResponse> {
        let url_ = this.baseUrl + "/api/CollectorFunctions/validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckCustomerCloudAccess(_response);
        });
    }

    protected processCheckCustomerCloudAccess(response: AxiosResponse): Promise<AccessValidationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccessValidationResponse.fromJS(resultData200);
            return Promise.resolve<AccessValidationResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccessValidationResponse>(null as any);
    }

    /**
     * Endpoint to initial a CRM Account refresh for the indicated account ax number.
     * @return Success
     */
    refreshCrmAccountTeam(accountTeamAxNumber: string, cancelToken?: CancelToken): Promise<HttpStatusCode> {
        let url_ = this.baseUrl + "/api/CollectorFunctions/RefreshCrmAccountTeam/{accountTeamAxNumber}";
        if (accountTeamAxNumber === undefined || accountTeamAxNumber === null)
            throw new Error("The parameter 'accountTeamAxNumber' must be defined.");
        url_ = url_.replace("{accountTeamAxNumber}", encodeURIComponent("" + accountTeamAxNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshCrmAccountTeam(_response);
        });
    }

    protected processRefreshCrmAccountTeam(response: AxiosResponse): Promise<HttpStatusCode> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<HttpStatusCode>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HttpStatusCode>(null as any);
    }
}

export interface IContractClient {
    /**
     * @param body (optional) 
     * @return Success
     */
    getAccountContracts(includeContractsWithProjects: boolean, body: AccountContractRequest | undefined): Promise<AccountContractResponse>;
    /**
     * @return Success
     */
    getContractOverview(contractId: number, includeContractsWithProjects: boolean): Promise<ContractOverview>;
    /**
     * @return Success
     */
    getContract(contractId: number): Promise<ContractDto>;
    /**
     * @return Success
     */
    getFSAs(): Promise<FSACacheResponse>;
    /**
     * @return Success
     */
    getSLAs(): Promise<ContractSLA[]>;
    /**
     * @return Success
     */
    getCloudAccounts(): Promise<CloudAccount[]>;
    /**
     * @return Success
     */
    getCloudAccountsV2(): Promise<CloudAccountV2Dto[]>;
    /**
     * @return Success
     */
    picklistValues(): Promise<ContractSchema>;
    /**
     * @return Success
     */
    contractsByAccountAndCategory(): Promise<ContractCacheResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getContractsByAccountId(body: AccountContractRequest | undefined): Promise<AccountContractResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getContractsAggregatedData(body: number[] | undefined): Promise<AggregatedContractsResponse>;
}

export class ContractClient extends AuthorizedApiBase implements IContractClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAccountContracts(includeContractsWithProjects: boolean, body: AccountContractRequest | undefined, cancelToken?: CancelToken): Promise<AccountContractResponse> {
        let url_ = this.baseUrl + "/api/Contract/contracts/{includeContractsWithProjects}";
        if (includeContractsWithProjects === undefined || includeContractsWithProjects === null)
            throw new Error("The parameter 'includeContractsWithProjects' must be defined.");
        url_ = url_.replace("{includeContractsWithProjects}", encodeURIComponent("" + includeContractsWithProjects));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccountContracts(_response);
        });
    }

    protected processGetAccountContracts(response: AxiosResponse): Promise<AccountContractResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountContractResponse.fromJS(resultData200);
            return Promise.resolve<AccountContractResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountContractResponse>(null as any);
    }

    /**
     * @return Success
     */
    getContractOverview(contractId: number, includeContractsWithProjects: boolean, cancelToken?: CancelToken): Promise<ContractOverview> {
        let url_ = this.baseUrl + "/api/Contract/overview/{contractId}/{includeContractsWithProjects}";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        if (includeContractsWithProjects === undefined || includeContractsWithProjects === null)
            throw new Error("The parameter 'includeContractsWithProjects' must be defined.");
        url_ = url_.replace("{includeContractsWithProjects}", encodeURIComponent("" + includeContractsWithProjects));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContractOverview(_response);
        });
    }

    protected processGetContractOverview(response: AxiosResponse): Promise<ContractOverview> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ContractOverview.fromJS(resultData200);
            return Promise.resolve<ContractOverview>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContractOverview>(null as any);
    }

    /**
     * @return Success
     */
    getContract(contractId: number, cancelToken?: CancelToken): Promise<ContractDto> {
        let url_ = this.baseUrl + "/api/Contract/{contractId}";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContract(_response);
        });
    }

    protected processGetContract(response: AxiosResponse): Promise<ContractDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ContractDto.fromJS(resultData200);
            return Promise.resolve<ContractDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContractDto>(null as any);
    }

    /**
     * @return Success
     */
    getFSAs( cancelToken?: CancelToken): Promise<FSACacheResponse> {
        let url_ = this.baseUrl + "/api/Contract/fsa";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFSAs(_response);
        });
    }

    protected processGetFSAs(response: AxiosResponse): Promise<FSACacheResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FSACacheResponse.fromJS(resultData200);
            return Promise.resolve<FSACacheResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FSACacheResponse>(null as any);
    }

    /**
     * @return Success
     */
    getSLAs( cancelToken?: CancelToken): Promise<ContractSLA[]> {
        let url_ = this.baseUrl + "/api/Contract/getslas";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSLAs(_response);
        });
    }

    protected processGetSLAs(response: AxiosResponse): Promise<ContractSLA[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContractSLA.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ContractSLA[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContractSLA[]>(null as any);
    }

    /**
     * @return Success
     */
    getCloudAccounts( cancelToken?: CancelToken): Promise<CloudAccount[]> {
        let url_ = this.baseUrl + "/api/Contract/cloudaccounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCloudAccounts(_response);
        });
    }

    protected processGetCloudAccounts(response: AxiosResponse): Promise<CloudAccount[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CloudAccount.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CloudAccount[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CloudAccount[]>(null as any);
    }

    /**
     * @return Success
     */
    getCloudAccountsV2( cancelToken?: CancelToken): Promise<CloudAccountV2Dto[]> {
        let url_ = this.baseUrl + "/api/Contract/cloudAccountsV2";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCloudAccountsV2(_response);
        });
    }

    protected processGetCloudAccountsV2(response: AxiosResponse): Promise<CloudAccountV2Dto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CloudAccountV2Dto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CloudAccountV2Dto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CloudAccountV2Dto[]>(null as any);
    }

    /**
     * @return Success
     */
    picklistValues( cancelToken?: CancelToken): Promise<ContractSchema> {
        let url_ = this.baseUrl + "/api/Contract/picklist";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPicklistValues(_response);
        });
    }

    protected processPicklistValues(response: AxiosResponse): Promise<ContractSchema> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ContractSchema.fromJS(resultData200);
            return Promise.resolve<ContractSchema>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContractSchema>(null as any);
    }

    /**
     * @return Success
     */
    contractsByAccountAndCategory( cancelToken?: CancelToken): Promise<ContractCacheResponse> {
        let url_ = this.baseUrl + "/api/Contract/allCloud";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processContractsByAccountAndCategory(_response);
        });
    }

    protected processContractsByAccountAndCategory(response: AxiosResponse): Promise<ContractCacheResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ContractCacheResponse.fromJS(resultData200);
            return Promise.resolve<ContractCacheResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContractCacheResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getContractsByAccountId(body: AccountContractRequest | undefined, cancelToken?: CancelToken): Promise<AccountContractResponse> {
        let url_ = this.baseUrl + "/api/Contract/contracts/account";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContractsByAccountId(_response);
        });
    }

    protected processGetContractsByAccountId(response: AxiosResponse): Promise<AccountContractResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountContractResponse.fromJS(resultData200);
            return Promise.resolve<AccountContractResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountContractResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getContractsAggregatedData(body: number[] | undefined, cancelToken?: CancelToken): Promise<AggregatedContractsResponse> {
        let url_ = this.baseUrl + "/api/Contract/contracts/aggregations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContractsAggregatedData(_response);
        });
    }

    protected processGetContractsAggregatedData(response: AxiosResponse): Promise<AggregatedContractsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AggregatedContractsResponse.fromJS(resultData200);
            return Promise.resolve<AggregatedContractsResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AggregatedContractsResponse>(null as any);
    }
}

export interface IContractInvoiceClient {
    /**
     * @param contractId (optional) 
     * @return Success
     */
    getContractInvoices(contractId: number | undefined): Promise<Invoice[]>;
    /**
     * @return Success
     */
    getInvoiceContracts(): Promise<ContractDto[]>;
}

export class ContractInvoiceClient extends AuthorizedApiBase implements IContractInvoiceClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param contractId (optional) 
     * @return Success
     */
    getContractInvoices(contractId: number | undefined, cancelToken?: CancelToken): Promise<Invoice[]> {
        let url_ = this.baseUrl + "/api/ContractInvoice?";
        if (contractId === null)
            throw new Error("The parameter 'contractId' cannot be null.");
        else if (contractId !== undefined)
            url_ += "contractId=" + encodeURIComponent("" + contractId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContractInvoices(_response);
        });
    }

    protected processGetContractInvoices(response: AxiosResponse): Promise<Invoice[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Invoice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Invoice[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Invoice[]>(null as any);
    }

    /**
     * @return Success
     */
    getInvoiceContracts( cancelToken?: CancelToken): Promise<ContractDto[]> {
        let url_ = this.baseUrl + "/api/ContractInvoice/contracts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoiceContracts(_response);
        });
    }

    protected processGetInvoiceContracts(response: AxiosResponse): Promise<ContractDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContractDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ContractDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContractDto[]>(null as any);
    }
}

export interface IContractRequestRankingsWidgetClient {
    /**
     * @param dateFilterOption (optional) 
     * @return Success
     */
    getContractRequestRankingsWidgetData(dateFilterOption: DateFilterOption | undefined): Promise<WidgetContentResponseDto_1OfContractRequestRankingsVisualsDto>;
}

export class ContractRequestRankingsWidgetClient extends AuthorizedApiBase implements IContractRequestRankingsWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param dateFilterOption (optional) 
     * @return Success
     */
    getContractRequestRankingsWidgetData(dateFilterOption: DateFilterOption | undefined, cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfContractRequestRankingsVisualsDto> {
        let url_ = this.baseUrl + "/api/widget/contract-request-rankings-widget?";
        if (dateFilterOption === null)
            throw new Error("The parameter 'dateFilterOption' cannot be null.");
        else if (dateFilterOption !== undefined)
            url_ += "dateFilterOption=" + encodeURIComponent("" + dateFilterOption) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContractRequestRankingsWidgetData(_response);
        });
    }

    protected processGetContractRequestRankingsWidgetData(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfContractRequestRankingsVisualsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfContractRequestRankingsVisualsDto.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfContractRequestRankingsVisualsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfContractRequestRankingsVisualsDto>(null as any);
    }
}

export interface IContractRetainerSpendClient {
    /**
     * @return Success
     */
    getContractRetainerSpendByAccountId(accountId: number): Promise<ContractRetainerSpend[]>;
    /**
     * @return Success
     */
    getContractRetainerSpendByContractId(contractId: number): Promise<ContractRetainerSpend>;
    /**
     * @return Success
     */
    getDetailedRetainerExpenseByContractId(contractId: number): Promise<DetailedContractRetainerExpenseDto>;
}

export class ContractRetainerSpendClient extends AuthorizedApiBase implements IContractRetainerSpendClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getContractRetainerSpendByAccountId(accountId: number, cancelToken?: CancelToken): Promise<ContractRetainerSpend[]> {
        let url_ = this.baseUrl + "/api/ContractRetainerSpend/GetContractRetainerSpendByAccountId/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContractRetainerSpendByAccountId(_response);
        });
    }

    protected processGetContractRetainerSpendByAccountId(response: AxiosResponse): Promise<ContractRetainerSpend[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContractRetainerSpend.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ContractRetainerSpend[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContractRetainerSpend[]>(null as any);
    }

    /**
     * @return Success
     */
    getContractRetainerSpendByContractId(contractId: number, cancelToken?: CancelToken): Promise<ContractRetainerSpend> {
        let url_ = this.baseUrl + "/api/ContractRetainerSpend/GetContractRetainerSpendByContractId/{contractId}";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContractRetainerSpendByContractId(_response);
        });
    }

    protected processGetContractRetainerSpendByContractId(response: AxiosResponse): Promise<ContractRetainerSpend> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ContractRetainerSpend.fromJS(resultData200);
            return Promise.resolve<ContractRetainerSpend>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContractRetainerSpend>(null as any);
    }

    /**
     * @return Success
     */
    getDetailedRetainerExpenseByContractId(contractId: number, cancelToken?: CancelToken): Promise<DetailedContractRetainerExpenseDto> {
        let url_ = this.baseUrl + "/api/ContractRetainerSpend/GetDetailedRetainerExpenseByContractId/{contractId}";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDetailedRetainerExpenseByContractId(_response);
        });
    }

    protected processGetDetailedRetainerExpenseByContractId(response: AxiosResponse): Promise<DetailedContractRetainerExpenseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DetailedContractRetainerExpenseDto.fromJS(resultData200);
            return Promise.resolve<DetailedContractRetainerExpenseDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DetailedContractRetainerExpenseDto>(null as any);
    }
}

export interface ICostAnalyticsClient {
    /**
     * @param body (optional) 
     * @return Success
     */
    postAnalyticsForProvider(provider: CostAnalyticProviders, body: PostCostAnalyticsRequest | undefined): Promise<void>;
    /**
     * @return Success
     */
    searchAnalyticsByProvider(provider: CostAnalyticProviders): Promise<CostAnalyticsResponse>;
}

export class CostAnalyticsClient extends AuthorizedApiBase implements ICostAnalyticsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    postAnalyticsForProvider(provider: CostAnalyticProviders, body: PostCostAnalyticsRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/costanalytics/{provider}";
        if (provider === undefined || provider === null)
            throw new Error("The parameter 'provider' must be defined.");
        url_ = url_.replace("{provider}", encodeURIComponent("" + provider));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostAnalyticsForProvider(_response);
        });
    }

    protected processPostAnalyticsForProvider(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    searchAnalyticsByProvider(provider: CostAnalyticProviders, cancelToken?: CancelToken): Promise<CostAnalyticsResponse> {
        let url_ = this.baseUrl + "/api/costanalytics/{provider}";
        if (provider === undefined || provider === null)
            throw new Error("The parameter 'provider' must be defined.");
        url_ = url_.replace("{provider}", encodeURIComponent("" + provider));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchAnalyticsByProvider(_response);
        });
    }

    protected processSearchAnalyticsByProvider(response: AxiosResponse): Promise<CostAnalyticsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CostAnalyticsResponse.fromJS(resultData200);
            return Promise.resolve<CostAnalyticsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CostAnalyticsResponse>(null as any);
    }
}

export interface ICostCenterClient {
    /**
     * @return Success
     */
    getCostCenterByAccount(): Promise<CostCenterDTO[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    createCostCenter(body: CostCenterDTO | undefined): Promise<CostCenterDTO>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateCostCenter(body: CostCenterDTO | undefined): Promise<CostCenterDTO>;
    /**
     * @param body (optional) 
     * @return Success
     */
    deleteCostCenter(body: number | undefined): Promise<CostCenterDTO>;
    /**
     * @return Success
     */
    cloudAccountsByAccountId(): Promise<CloudAccountDTO[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addConfigurationItemToCostCenter(body: CostCenterCloudAccountRequest | undefined): Promise<CloudAccountDTO[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    removeConfigurationItemFromCostCenter(body: CostCenterCloudAccountRequest | undefined): Promise<CloudAccountDTO[]>;
}

export class CostCenterClient extends AuthorizedApiBase implements ICostCenterClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getCostCenterByAccount( cancelToken?: CancelToken): Promise<CostCenterDTO[]> {
        let url_ = this.baseUrl + "/api/CostCenter/getByAccount";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCostCenterByAccount(_response);
        });
    }

    protected processGetCostCenterByAccount(response: AxiosResponse): Promise<CostCenterDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CostCenterDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CostCenterDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CostCenterDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCostCenter(body: CostCenterDTO | undefined, cancelToken?: CancelToken): Promise<CostCenterDTO> {
        let url_ = this.baseUrl + "/api/CostCenter/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCostCenter(_response);
        });
    }

    protected processCreateCostCenter(response: AxiosResponse): Promise<CostCenterDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CostCenterDTO.fromJS(resultData200);
            return Promise.resolve<CostCenterDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CostCenterDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCostCenter(body: CostCenterDTO | undefined, cancelToken?: CancelToken): Promise<CostCenterDTO> {
        let url_ = this.baseUrl + "/api/CostCenter/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCostCenter(_response);
        });
    }

    protected processUpdateCostCenter(response: AxiosResponse): Promise<CostCenterDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CostCenterDTO.fromJS(resultData200);
            return Promise.resolve<CostCenterDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CostCenterDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteCostCenter(body: number | undefined, cancelToken?: CancelToken): Promise<CostCenterDTO> {
        let url_ = this.baseUrl + "/api/CostCenter/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCostCenter(_response);
        });
    }

    protected processDeleteCostCenter(response: AxiosResponse): Promise<CostCenterDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CostCenterDTO.fromJS(resultData200);
            return Promise.resolve<CostCenterDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CostCenterDTO>(null as any);
    }

    /**
     * @return Success
     */
    cloudAccountsByAccountId( cancelToken?: CancelToken): Promise<CloudAccountDTO[]> {
        let url_ = this.baseUrl + "/api/CostCenter/cloudAccountsByAccountId";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCloudAccountsByAccountId(_response);
        });
    }

    protected processCloudAccountsByAccountId(response: AxiosResponse): Promise<CloudAccountDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CloudAccountDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CloudAccountDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CloudAccountDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addConfigurationItemToCostCenter(body: CostCenterCloudAccountRequest | undefined, cancelToken?: CancelToken): Promise<CloudAccountDTO[]> {
        let url_ = this.baseUrl + "/api/CostCenter/configuration-item/add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddConfigurationItemToCostCenter(_response);
        });
    }

    protected processAddConfigurationItemToCostCenter(response: AxiosResponse): Promise<CloudAccountDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CloudAccountDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CloudAccountDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CloudAccountDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    removeConfigurationItemFromCostCenter(body: CostCenterCloudAccountRequest | undefined, cancelToken?: CancelToken): Promise<CloudAccountDTO[]> {
        let url_ = this.baseUrl + "/api/CostCenter/configuration-item/remove";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveConfigurationItemFromCostCenter(_response);
        });
    }

    protected processRemoveConfigurationItemFromCostCenter(response: AxiosResponse): Promise<CloudAccountDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CloudAccountDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CloudAccountDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CloudAccountDTO[]>(null as any);
    }
}

export interface ICoveredAssetsByProductWidgetClient {
    /**
     * @return Success
     */
    getCoveredAssetsByProductData(): Promise<WidgetContentResponseDto_1OfCoveredAssetsByProductWidgetResponse>;
}

export class CoveredAssetsByProductWidgetClient extends AuthorizedApiBase implements ICoveredAssetsByProductWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getCoveredAssetsByProductData( cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfCoveredAssetsByProductWidgetResponse> {
        let url_ = this.baseUrl + "/api/widget/covered-assets-by-product-widget";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCoveredAssetsByProductData(_response);
        });
    }

    protected processGetCoveredAssetsByProductData(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfCoveredAssetsByProductWidgetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfCoveredAssetsByProductWidgetResponse.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfCoveredAssetsByProductWidgetResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfCoveredAssetsByProductWidgetResponse>(null as any);
    }
}

export interface ICurrentMonthCloudConsumptionWidgetClient {
    /**
     * @return Success
     */
    getCurrentMonthCloudConsumption(): Promise<WidgetContentResponseDto_1OfGetCurrentMonthCloudConsumptionResponse>;
}

export class CurrentMonthCloudConsumptionWidgetClient extends AuthorizedApiBase implements ICurrentMonthCloudConsumptionWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getCurrentMonthCloudConsumption( cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfGetCurrentMonthCloudConsumptionResponse> {
        let url_ = this.baseUrl + "/api/widget/current-month-cloud-consumption-widget";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentMonthCloudConsumption(_response);
        });
    }

    protected processGetCurrentMonthCloudConsumption(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfGetCurrentMonthCloudConsumptionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfGetCurrentMonthCloudConsumptionResponse.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfGetCurrentMonthCloudConsumptionResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfGetCurrentMonthCloudConsumptionResponse>(null as any);
    }
}

export interface IDattoRmmClient {
    /**
     * @param body (optional) 
     * @return Success
     */
    updateIntegrations(body: DattoSite[] | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getDattoDevices(body: DattoRmmDevicesRequest | undefined): Promise<DattoRmmDevice>;
}

export class DattoRmmClient extends AuthorizedApiBase implements IDattoRmmClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateIntegrations(body: DattoSite[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/DattoRmm/update-integrations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateIntegrations(_response);
        });
    }

    protected processUpdateIntegrations(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getDattoDevices(body: DattoRmmDevicesRequest | undefined, cancelToken?: CancelToken): Promise<DattoRmmDevice> {
        let url_ = this.baseUrl + "/api/DattoRmm/devices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDattoDevices(_response);
        });
    }

    protected processGetDattoDevices(response: AxiosResponse): Promise<DattoRmmDevice> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DattoRmmDevice.fromJS(resultData200);
            return Promise.resolve<DattoRmmDevice>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DattoRmmDevice>(null as any);
    }
}

export interface IDeviceClient {
    /**
     * @return Success
     */
    getDevice(): Promise<ConfigurationItemDTO[]>;
}

export class DeviceClient extends AuthorizedApiBase implements IDeviceClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getDevice( cancelToken?: CancelToken): Promise<ConfigurationItemDTO[]> {
        let url_ = this.baseUrl + "/api/Device";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDevice(_response);
        });
    }

    protected processGetDevice(response: AxiosResponse): Promise<ConfigurationItemDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConfigurationItemDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ConfigurationItemDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConfigurationItemDTO[]>(null as any);
    }
}

export interface IDynamicTagClient {
    /**
     * @return Success
     */
    getAccountDynamicTags(): Promise<DynamicTag[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    createDynamicTag(body: DynamicTagRequest | undefined): Promise<DynamicTag[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateDynamicTag(body: DynamicTagRequest | undefined): Promise<DynamicTag[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    deleteDynamicTag(body: number[] | undefined): Promise<boolean>;
}

export class DynamicTagClient extends AuthorizedApiBase implements IDynamicTagClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getAccountDynamicTags( cancelToken?: CancelToken): Promise<DynamicTag[]> {
        let url_ = this.baseUrl + "/api/DynamicTag";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccountDynamicTags(_response);
        });
    }

    protected processGetAccountDynamicTags(response: AxiosResponse): Promise<DynamicTag[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DynamicTag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DynamicTag[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DynamicTag[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createDynamicTag(body: DynamicTagRequest | undefined, cancelToken?: CancelToken): Promise<DynamicTag[]> {
        let url_ = this.baseUrl + "/api/DynamicTag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateDynamicTag(_response);
        });
    }

    protected processCreateDynamicTag(response: AxiosResponse): Promise<DynamicTag[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DynamicTag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DynamicTag[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 424) {
            const _responseText = response.data;
            let result424: any = null;
            let resultData424  = _responseText;
            result424 = ProblemDetails.fromJS(resultData424);
            return throwException("Client Error", status, _responseText, _headers, result424);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DynamicTag[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDynamicTag(body: DynamicTagRequest | undefined, cancelToken?: CancelToken): Promise<DynamicTag[]> {
        let url_ = this.baseUrl + "/api/DynamicTag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateDynamicTag(_response);
        });
    }

    protected processUpdateDynamicTag(response: AxiosResponse): Promise<DynamicTag[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DynamicTag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DynamicTag[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 424) {
            const _responseText = response.data;
            let result424: any = null;
            let resultData424  = _responseText;
            result424 = ProblemDetails.fromJS(resultData424);
            return throwException("Client Error", status, _responseText, _headers, result424);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DynamicTag[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteDynamicTag(body: number[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DynamicTag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteDynamicTag(_response);
        });
    }

    protected processDeleteDynamicTag(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 424) {
            const _responseText = response.data;
            let result424: any = null;
            let resultData424  = _responseText;
            result424 = ProblemDetails.fromJS(resultData424);
            return throwException("Client Error", status, _responseText, _headers, result424);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IEnv0Client {
    /**
     * @param body (optional) 
     * @return Success
     */
    createEnvironment(body: CreateEnv0EnvironmentRequest | undefined): Promise<Env0EnvironmentDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getEnv0Environments(body: ListEnv0EnvironmentQueryParams | undefined): Promise<ListEnv0EnvironmentsDto>;
    /**
     * @return Success
     */
    getEnv0EnvironmentById(id: string): Promise<Env0EnvironmentDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateEnvironment(id: string, body: UpdateEnv0EnvironmentRequest | undefined): Promise<Env0EnvironmentDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateEnvironmentTimeToLive(id: string, body: TimeToLive | undefined): Promise<Env0EnvironmentDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    destroyEnvironment(id: string, body: DestroyEnv0EnvironmentRequest | undefined): Promise<DestroyEnv0EnvironmentResponseDto>;
}

export class Env0Client extends AuthorizedApiBase implements IEnv0Client {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createEnvironment(body: CreateEnv0EnvironmentRequest | undefined, cancelToken?: CancelToken): Promise<Env0EnvironmentDto> {
        let url_ = this.baseUrl + "/api/Env0/environment/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateEnvironment(_response);
        });
    }

    protected processCreateEnvironment(response: AxiosResponse): Promise<Env0EnvironmentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Env0EnvironmentDto.fromJS(resultData200);
            return Promise.resolve<Env0EnvironmentDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Env0EnvironmentDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getEnv0Environments(body: ListEnv0EnvironmentQueryParams | undefined, cancelToken?: CancelToken): Promise<ListEnv0EnvironmentsDto> {
        let url_ = this.baseUrl + "/api/Env0/list-environments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEnv0Environments(_response);
        });
    }

    protected processGetEnv0Environments(response: AxiosResponse): Promise<ListEnv0EnvironmentsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListEnv0EnvironmentsDto.fromJS(resultData200);
            return Promise.resolve<ListEnv0EnvironmentsDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListEnv0EnvironmentsDto>(null as any);
    }

    /**
     * @return Success
     */
    getEnv0EnvironmentById(id: string, cancelToken?: CancelToken): Promise<Env0EnvironmentDto> {
        let url_ = this.baseUrl + "/api/Env0/environment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEnv0EnvironmentById(_response);
        });
    }

    protected processGetEnv0EnvironmentById(response: AxiosResponse): Promise<Env0EnvironmentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Env0EnvironmentDto.fromJS(resultData200);
            return Promise.resolve<Env0EnvironmentDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Env0EnvironmentDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateEnvironment(id: string, body: UpdateEnv0EnvironmentRequest | undefined, cancelToken?: CancelToken): Promise<Env0EnvironmentDto> {
        let url_ = this.baseUrl + "/api/Env0/environment/{id}/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateEnvironment(_response);
        });
    }

    protected processUpdateEnvironment(response: AxiosResponse): Promise<Env0EnvironmentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Env0EnvironmentDto.fromJS(resultData200);
            return Promise.resolve<Env0EnvironmentDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Env0EnvironmentDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateEnvironmentTimeToLive(id: string, body: TimeToLive | undefined, cancelToken?: CancelToken): Promise<Env0EnvironmentDto> {
        let url_ = this.baseUrl + "/api/Env0/environment/{id}/update/ttl";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateEnvironmentTimeToLive(_response);
        });
    }

    protected processUpdateEnvironmentTimeToLive(response: AxiosResponse): Promise<Env0EnvironmentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Env0EnvironmentDto.fromJS(resultData200);
            return Promise.resolve<Env0EnvironmentDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Env0EnvironmentDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    destroyEnvironment(id: string, body: DestroyEnv0EnvironmentRequest | undefined, cancelToken?: CancelToken): Promise<DestroyEnv0EnvironmentResponseDto> {
        let url_ = this.baseUrl + "/api/Env0/environment/{id}/destroy";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDestroyEnvironment(_response);
        });
    }

    protected processDestroyEnvironment(response: AxiosResponse): Promise<DestroyEnv0EnvironmentResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DestroyEnv0EnvironmentResponseDto.fromJS(resultData200);
            return Promise.resolve<DestroyEnv0EnvironmentResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DestroyEnv0EnvironmentResponseDto>(null as any);
    }
}

export interface IEventsClient {
    /**
     * @param body (optional) 
     * @return Success
     */
    executeRuleEvent(body: RuleEventDto | undefined): Promise<string>;
    /**
     * @param body (optional) 
     * @return Success
     */
    executeRuleEvents(body: RuleEventDto[] | undefined): Promise<string>;
    /**
     * @param body (optional) 
     * @return Success
     */
    executeBroadcastEvent(body: EventsController_BroadcastModel | undefined): Promise<string>;
}

export class EventsClient extends AuthorizedApiBase implements IEventsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    executeRuleEvent(body: RuleEventDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/notifications/event";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExecuteRuleEvent(_response);
        });
    }

    protected processExecuteRuleEvent(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    executeRuleEvents(body: RuleEventDto[] | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/notifications/events";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExecuteRuleEvents(_response);
        });
    }

    protected processExecuteRuleEvents(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    executeBroadcastEvent(body: EventsController_BroadcastModel | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/notifications/broadcastEvent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExecuteBroadcastEvent(_response);
        });
    }

    protected processExecuteBroadcastEvent(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface IExpiringContractWidgetClient {
    /**
     * @param body (optional) 
     * @return Success
     */
    getExpiringContracts(body: AssetExpiringContractQuery | undefined): Promise<AssetContractsResponse>;
}

export class ExpiringContractWidgetClient extends AuthorizedApiBase implements IExpiringContractWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getExpiringContracts(body: AssetExpiringContractQuery | undefined, cancelToken?: CancelToken): Promise<AssetContractsResponse> {
        let url_ = this.baseUrl + "/api/widget/assets-expiring-contracts-widget/expiring-contracts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExpiringContracts(_response);
        });
    }

    protected processGetExpiringContracts(response: AxiosResponse): Promise<AssetContractsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssetContractsResponse.fromJS(resultData200);
            return Promise.resolve<AssetContractsResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssetContractsResponse>(null as any);
    }
}

export interface IFeatureFlagClient {
    /**
     * @return Success
     */
    validateFeatureIsEnabled(key: string): Promise<boolean>;
}

export class FeatureFlagClient extends AuthorizedApiBase implements IFeatureFlagClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    validateFeatureIsEnabled(key: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/FeatureFlag/validate/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateFeatureIsEnabled(_response);
        });
    }

    protected processValidateFeatureIsEnabled(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IFileClient {
    /**
     * @return Success
     */
    uploadInternalAdminFileToBlobStorage(): Promise<FileValidationDto>;
    /**
     * @return Success
     */
    deleteInternalAdminTmpFile(): Promise<void>;
    /**
     * @param fileType (optional) 
     * @param filepond (optional) 
     * @return Success
     */
    uploadInternalSHIFileToBlobStorage(fileType: FileTypes | undefined, filepond: FileParameter | undefined): Promise<void>;
    /**
     * @return Success
     */
    deleteInternalSHITmpFile(): Promise<void>;
    /**
     * @return Success
     */
    downloadBlobFile(containerName: string, guid: string): Promise<void>;
    /**
     * Downloads employee photos by entraId.
     * @param entraId The ID of the employee.
     * @return Success
     */
    downloadEmployeePhotos(entraId: string): Promise<FileResponse>;
}

export class FileClient extends AuthorizedApiBase implements IFileClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    uploadInternalAdminFileToBlobStorage( cancelToken?: CancelToken): Promise<FileValidationDto> {
        let url_ = this.baseUrl + "/api/FileController/InternalAdminTmp";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadInternalAdminFileToBlobStorage(_response);
        });
    }

    protected processUploadInternalAdminFileToBlobStorage(response: AxiosResponse): Promise<FileValidationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileValidationDto.fromJS(resultData200);
            return Promise.resolve<FileValidationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileValidationDto>(null as any);
    }

    /**
     * @return Success
     */
    deleteInternalAdminTmpFile( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/FileController/InternalAdminTmp";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteInternalAdminTmpFile(_response);
        });
    }

    protected processDeleteInternalAdminTmpFile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param fileType (optional) 
     * @param filepond (optional) 
     * @return Success
     */
    uploadInternalSHIFileToBlobStorage(fileType: FileTypes | undefined, filepond: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/FileController/InternalSHITmp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileType === null || fileType === undefined)
            throw new Error("The parameter 'fileType' cannot be null.");
        else
            content_.append("FileType", fileType.toString());
        if (filepond === null || filepond === undefined)
            throw new Error("The parameter 'filepond' cannot be null.");
        else
            content_.append("filepond", filepond.data, filepond.fileName ? filepond.fileName : "filepond");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadInternalSHIFileToBlobStorage(_response);
        });
    }

    protected processUploadInternalSHIFileToBlobStorage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteInternalSHITmpFile( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/FileController/InternalSHITmp";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteInternalSHITmpFile(_response);
        });
    }

    protected processDeleteInternalSHITmpFile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    downloadBlobFile(containerName: string, guid: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/FileController/Download/{containerName}/{guid}";
        if (containerName === undefined || containerName === null)
            throw new Error("The parameter 'containerName' must be defined.");
        url_ = url_.replace("{containerName}", encodeURIComponent("" + containerName));
        if (guid === undefined || guid === null)
            throw new Error("The parameter 'guid' must be defined.");
        url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadBlobFile(_response);
        });
    }

    protected processDownloadBlobFile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Downloads employee photos by entraId.
     * @param entraId The ID of the employee.
     * @return Success
     */
    downloadEmployeePhotos(entraId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/FileController/download/employee-photos/{entraId}";
        if (entraId === undefined || entraId === null)
            throw new Error("The parameter 'entraId' must be defined.");
        url_ = url_.replace("{entraId}", encodeURIComponent("" + entraId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadEmployeePhotos(_response);
        });
    }

    protected processDownloadEmployeePhotos(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IFileHandlerClient {
    /**
     * @param filepond (optional) 
     * @param hello (optional) 
     * @return Success
     */
    uploadCiscoSupplementalDataByAccountId(accountId: number, filepond: FileParameter | undefined, hello: string | undefined): Promise<FileUploadResponse_1OfCiscoSupplementalDataDto>;
    /**
     * @param filepond (optional) 
     * @param hello (optional) 
     * @return Success
     */
    uploadCiscoThirdPartyContractsByAccountId(accountId: number, filepond: FileParameter | undefined, hello: string | undefined): Promise<FileUploadResponse_1OfCiscoThirdPartyContractDataDto>;
    /**
     * @param filepond (optional) 
     * @param hello (optional) 
     * @return Success
     */
    uploadAssetManagementDataForFileHandler(accountId: number, filepond: FileParameter | undefined, hello: string | undefined): Promise<FileUploadResponse_1OfManualManagedAssetDataRecordDto>;
    /**
     * @param accountId (optional) 
     * @return Success
     */
    downloadAssetManagementData(accountId: number | undefined): Promise<FileDownloadResponse>;
    /**
     * @param filepond (optional) 
     * @param hello (optional) 
     * @return Success
     */
    uploadGcpCloudAssetServiceAccountKey(accountId: number, filepond: FileParameter | undefined, hello: string | undefined): Promise<string>;
}

export class FileHandlerClient extends AuthorizedApiBase implements IFileHandlerClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param filepond (optional) 
     * @param hello (optional) 
     * @return Success
     */
    uploadCiscoSupplementalDataByAccountId(accountId: number, filepond: FileParameter | undefined, hello: string | undefined, cancelToken?: CancelToken): Promise<FileUploadResponse_1OfCiscoSupplementalDataDto> {
        let url_ = this.baseUrl + "/api/FileHandler/cisco-supplemental-data/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (filepond === null || filepond === undefined)
            throw new Error("The parameter 'filepond' cannot be null.");
        else
            content_.append("filepond", filepond.data, filepond.fileName ? filepond.fileName : "filepond");
        if (hello === null || hello === undefined)
            throw new Error("The parameter 'hello' cannot be null.");
        else
            content_.append("Hello", hello.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadCiscoSupplementalDataByAccountId(_response);
        });
    }

    protected processUploadCiscoSupplementalDataByAccountId(response: AxiosResponse): Promise<FileUploadResponse_1OfCiscoSupplementalDataDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileUploadResponse_1OfCiscoSupplementalDataDto.fromJS(resultData200);
            return Promise.resolve<FileUploadResponse_1OfCiscoSupplementalDataDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileUploadResponse_1OfCiscoSupplementalDataDto>(null as any);
    }

    /**
     * @param filepond (optional) 
     * @param hello (optional) 
     * @return Success
     */
    uploadCiscoThirdPartyContractsByAccountId(accountId: number, filepond: FileParameter | undefined, hello: string | undefined, cancelToken?: CancelToken): Promise<FileUploadResponse_1OfCiscoThirdPartyContractDataDto> {
        let url_ = this.baseUrl + "/api/FileHandler/cisco-third-party-contracts/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (filepond === null || filepond === undefined)
            throw new Error("The parameter 'filepond' cannot be null.");
        else
            content_.append("filepond", filepond.data, filepond.fileName ? filepond.fileName : "filepond");
        if (hello === null || hello === undefined)
            throw new Error("The parameter 'hello' cannot be null.");
        else
            content_.append("Hello", hello.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadCiscoThirdPartyContractsByAccountId(_response);
        });
    }

    protected processUploadCiscoThirdPartyContractsByAccountId(response: AxiosResponse): Promise<FileUploadResponse_1OfCiscoThirdPartyContractDataDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileUploadResponse_1OfCiscoThirdPartyContractDataDto.fromJS(resultData200);
            return Promise.resolve<FileUploadResponse_1OfCiscoThirdPartyContractDataDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileUploadResponse_1OfCiscoThirdPartyContractDataDto>(null as any);
    }

    /**
     * @param filepond (optional) 
     * @param hello (optional) 
     * @return Success
     */
    uploadAssetManagementDataForFileHandler(accountId: number, filepond: FileParameter | undefined, hello: string | undefined, cancelToken?: CancelToken): Promise<FileUploadResponse_1OfManualManagedAssetDataRecordDto> {
        let url_ = this.baseUrl + "/api/FileHandler/asset-management/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (filepond === null || filepond === undefined)
            throw new Error("The parameter 'filepond' cannot be null.");
        else
            content_.append("filepond", filepond.data, filepond.fileName ? filepond.fileName : "filepond");
        if (hello === null || hello === undefined)
            throw new Error("The parameter 'hello' cannot be null.");
        else
            content_.append("Hello", hello.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadAssetManagementDataForFileHandler(_response);
        });
    }

    protected processUploadAssetManagementDataForFileHandler(response: AxiosResponse): Promise<FileUploadResponse_1OfManualManagedAssetDataRecordDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileUploadResponse_1OfManualManagedAssetDataRecordDto.fromJS(resultData200);
            return Promise.resolve<FileUploadResponse_1OfManualManagedAssetDataRecordDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileUploadResponse_1OfManualManagedAssetDataRecordDto>(null as any);
    }

    /**
     * @param accountId (optional) 
     * @return Success
     */
    downloadAssetManagementData(accountId: number | undefined, cancelToken?: CancelToken): Promise<FileDownloadResponse> {
        let url_ = this.baseUrl + "/api/FileHandler/asset-management?";
        if (accountId === null)
            throw new Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadAssetManagementData(_response);
        });
    }

    protected processDownloadAssetManagementData(response: AxiosResponse): Promise<FileDownloadResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDownloadResponse.fromJS(resultData200);
            return Promise.resolve<FileDownloadResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDownloadResponse>(null as any);
    }

    /**
     * @param filepond (optional) 
     * @param hello (optional) 
     * @return Success
     */
    uploadGcpCloudAssetServiceAccountKey(accountId: number, filepond: FileParameter | undefined, hello: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/FileHandler/gcp-cloud-asset-inventory/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (filepond === null || filepond === undefined)
            throw new Error("The parameter 'filepond' cannot be null.");
        else
            content_.append("filepond", filepond.data, filepond.fileName ? filepond.fileName : "filepond");
        if (hello === null || hello === undefined)
            throw new Error("The parameter 'hello' cannot be null.");
        else
            content_.append("Hello", hello.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadGcpCloudAssetServiceAccountKey(_response);
        });
    }

    protected processUploadGcpCloudAssetServiceAccountKey(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface IFunctionUpdateClient {
    /**
     * @return Success
     */
    updateAccountCache(): Promise<void>;
    /**
     * @return Success
     */
    getPicklistValues(): Promise<AutotaskPicklistEntity[]>;
    /**
     * @return Success
     */
    updatePicklistValues(): Promise<OldPicklistValue[]>;
}

export class FunctionUpdateClient extends AuthorizedApiBase implements IFunctionUpdateClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    updateAccountCache( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/FunctionUpdate/accountcache";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAccountCache(_response);
        });
    }

    protected processUpdateAccountCache(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getPicklistValues( cancelToken?: CancelToken): Promise<AutotaskPicklistEntity[]> {
        let url_ = this.baseUrl + "/api/FunctionUpdate/getpicklistvalues";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPicklistValues(_response);
        });
    }

    protected processGetPicklistValues(response: AxiosResponse): Promise<AutotaskPicklistEntity[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AutotaskPicklistEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AutotaskPicklistEntity[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AutotaskPicklistEntity[]>(null as any);
    }

    /**
     * @return Success
     */
    updatePicklistValues( cancelToken?: CancelToken): Promise<OldPicklistValue[]> {
        let url_ = this.baseUrl + "/api/FunctionUpdate/updatepicklistvalues";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePicklistValues(_response);
        });
    }

    protected processUpdatePicklistValues(response: AxiosResponse): Promise<OldPicklistValue[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OldPicklistValue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OldPicklistValue[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OldPicklistValue[]>(null as any);
    }
}

export interface IGuestUserClient {
    /**
     * @return Success
     */
    getGuestUserWithPermissions(): Promise<GuestUserWithPermissions[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateGuestUserPermission(body: UpdateGuestUsersRequest | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    deleteGuestUser(body: DeleteGuestUserRequest | undefined): Promise<void>;
    /**
     * @return Success
     */
    getAllowedGuestPermission(): Promise<GuestPermissionsDisplayDto[]>;
}

export class GuestUserClient extends AuthorizedApiBase implements IGuestUserClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getGuestUserWithPermissions( cancelToken?: CancelToken): Promise<GuestUserWithPermissions[]> {
        let url_ = this.baseUrl + "/api/GuestUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGuestUserWithPermissions(_response);
        });
    }

    protected processGetGuestUserWithPermissions(response: AxiosResponse): Promise<GuestUserWithPermissions[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuestUserWithPermissions.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GuestUserWithPermissions[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GuestUserWithPermissions[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateGuestUserPermission(body: UpdateGuestUsersRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/GuestUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateGuestUserPermission(_response);
        });
    }

    protected processUpdateGuestUserPermission(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteGuestUser(body: DeleteGuestUserRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/GuestUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteGuestUser(_response);
        });
    }

    protected processDeleteGuestUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getAllowedGuestPermission( cancelToken?: CancelToken): Promise<GuestPermissionsDisplayDto[]> {
        let url_ = this.baseUrl + "/api/GuestUser/permissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllowedGuestPermission(_response);
        });
    }

    protected processGetAllowedGuestPermission(response: AxiosResponse): Promise<GuestPermissionsDisplayDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuestPermissionsDisplayDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GuestPermissionsDisplayDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GuestPermissionsDisplayDto[]>(null as any);
    }
}

export interface IHardwareLifeCycleManagementClient {
    /**
     * @return Success
     */
    getHardwareLifecycleManagementStatuses(): Promise<AxCustomerHlmOrderDto>;
}

export class HardwareLifeCycleManagementClient extends AuthorizedApiBase implements IHardwareLifeCycleManagementClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getHardwareLifecycleManagementStatuses( cancelToken?: CancelToken): Promise<AxCustomerHlmOrderDto> {
        let url_ = this.baseUrl + "/api/HardwareLifeCycleManagement/order-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHardwareLifecycleManagementStatuses(_response);
        });
    }

    protected processGetHardwareLifecycleManagementStatuses(response: AxiosResponse): Promise<AxCustomerHlmOrderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AxCustomerHlmOrderDto.fromJS(resultData200);
            return Promise.resolve<AxCustomerHlmOrderDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AxCustomerHlmOrderDto>(null as any);
    }
}

export interface IIdcsClient {
    /**
     * @param body (optional) 
     * @return Success
     */
    createIdcsChangeRequest(body: CreateIdcsChangeRequestDto | undefined): Promise<void>;
}

export class IdcsClient extends AuthorizedApiBase implements IIdcsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createIdcsChangeRequest(body: CreateIdcsChangeRequestDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Idcs/idcs-change-request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateIdcsChangeRequest(_response);
        });
    }

    protected processCreateIdcsChangeRequest(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IIntegrationClient {
    /**
     * @return No Content
     */
    deleteIntegration(integrationId: number): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    registerIntegration(body: IntegrationDTO | undefined): Promise<IntegrationDTO>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateIntegration(body: IntegrationDTO | undefined): Promise<IntegrationDTO>;
    /**
     * Toggles activation of Integrations in the integrations table from active to inactive or inactive to active.
     * @param activate (optional) 
     * @param body (optional) 
     * @return Success
     */
    toggleIntegrationActivation(activate: boolean | undefined, body: IntegrationDTO[] | undefined): Promise<IntegrationDTO[]>;
    /**
     * @param filepond (optional) 
     * @param hello (optional) 
     * @return Success
     */
    uploadCiscoReadyReportByAccountId(accountId: string, filepond: FileParameter | undefined, hello: string | undefined): Promise<CiscoReadyReportUploadResponse>;
    /**
     * @param enabledOnly (optional) 
     * @return Success
     */
    getIntegrationDefinitions(enabledOnly: boolean | undefined): Promise<IntegrationDefinition[]>;
    /**
     * Get a list of all subscriptionIds along with display names for configured integration types
    Currently supports Azure tenant types
     * @return Success
     */
    getIntegrationAccounts(): Promise<CustomerAccount[]>;
    /**
     * @param activeOnly (optional) 
     * @return Success
     */
    getIntegrations(activeOnly: boolean | undefined): Promise<IntegrationDTO[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    postIntegration(body: IntegrationDTO | undefined): Promise<void>;
    /**
     * @return Success
     */
    doesAccountExists(axNumber: string): Promise<void>;
    /**
     * @return Success
     */
    getAxReferencesByAccountId(accountId: number): Promise<string[]>;
    /**
     * Get All Integrations by the IntegrationType
     * @param integrationType (optional) Type Of Integrations to retrieve
     * @param activeOnly (optional) True if only active integrations (true by default)
     * @return Success
     */
    getIntegrationsByType(integrationType: IntegrationType | undefined, activeOnly: boolean | undefined): Promise<IntegrationDTO[]>;
    /**
     * @param activeOnly (optional) 
     * @return Success
     */
    getCiscoSNTCIntegrations(activeOnly: boolean | undefined): Promise<CiscoSNTCIntegrationDTO[]>;
    /**
     * @param activeOnly (optional) 
     * @return Success
     */
    getCiscoEAIntegrations(activeOnly: boolean | undefined): Promise<CiscoEnterpriseAgreementIntegrationDTO[]>;
    /**
     * @param activeOnly (optional) 
     * @return Success
     */
    getAzureComplianceIntegrations(activeOnly: boolean | undefined): Promise<AzureComplianceIntegrationDTO[]>;
    /**
     * @param activeOnly (optional) 
     * @return Success
     */
    getAwsComplianceIntegrations(activeOnly: boolean | undefined): Promise<AwsComplianceIntegrationDTO[]>;
    /**
     * @param activeOnly (optional) 
     * @return Success
     */
    getAwsSimpleRecommendationsIntegrations(activeOnly: boolean | undefined): Promise<AwsSimpleRecommendationsIntegrationDTO[]>;
    /**
     * @param activeOnly (optional) 
     * @return Success
     */
    getAzureSimpleRecommendationsIntegrations(activeOnly: boolean | undefined): Promise<AzureSimpleRecommendationsIntegrationDTO[]>;
    /**
     * @param activeOnly (optional) 
     * @return Success
     */
    getAzureBackupsIntegrations(activeOnly: boolean | undefined): Promise<AzureBackupsIntegrationDTO[]>;
    /**
     * @return Success
     */
    allIntegrationsByAccountId(accountId: number): Promise<CustomerAccount[]>;
    /**
     * @param activeOnly (optional) 
     * @return Success
     */
    activeIntegrationsByAccountId(accountId: number, activeOnly: boolean | undefined): Promise<IntegrationDTO[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    uploadCiscoSNTCByAccountId(accountId: number, body: BasicCiscoSNTCIntegrationDTO | undefined): Promise<IntegrationDTO>;
    /**
     * @param body (optional) 
     * @return Success
     */
    uploadCiscoEAByAccountId(accountId: number, body: BasicCiscoEAIntegrationDTO | undefined): Promise<IntegrationDTO>;
    /**
     * @param body (optional) 
     * @return Success
     */
    registerSelfServiceReportingIntegration(accountId: number, body: SelfServiceReportingIntegrationDto | undefined): Promise<IntegrationDTO>;
    /**
     * @param body (optional) 
     * @return Success
     */
    registerHardwareLifecycleManagementIntegration(accountId: string, body: HardwareLifecycleManagementIntegrationDTO | undefined): Promise<IntegrationDTO>;
    /**
     * @param body (optional) 
     * @return Success
     */
    registerAwsGovernanceReportIntegration(accountId: string, body: AwsGovernanceReportsDto | undefined): Promise<IntegrationDTO>;
    /**
     * @param body (optional) 
     * @return Success
     */
    registerAzureGovernanceReportIntegration(accountId: string, body: AzureGovernanceReportsDto | undefined): Promise<IntegrationDTO>;
    /**
     * @return Success
     */
    registerDatadogUsageReportIntegration(accountId: string): Promise<IntegrationDTO>;
    /**
     * @param filepond (optional) 
     * @param hello (optional) 
     * @return Success
     */
    uploadLiveOpticsProjectByAccountId(accountId: string, filepond: FileParameter | undefined, hello: string | undefined): Promise<LiveOpticsProjectUploadResponse>;
}

export class IntegrationClient extends AuthorizedApiBase implements IIntegrationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return No Content
     */
    deleteIntegration(integrationId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Integration/{integrationId}";
        if (integrationId === undefined || integrationId === null)
            throw new Error("The parameter 'integrationId' must be defined.");
        url_ = url_.replace("{integrationId}", encodeURIComponent("" + integrationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteIntegration(_response);
        });
    }

    protected processDeleteIntegration(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    registerIntegration(body: IntegrationDTO | undefined, cancelToken?: CancelToken): Promise<IntegrationDTO> {
        let url_ = this.baseUrl + "/api/Integration/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegisterIntegration(_response);
        });
    }

    protected processRegisterIntegration(response: AxiosResponse): Promise<IntegrationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IntegrationDTO.fromJS(resultData200);
            return Promise.resolve<IntegrationDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntegrationDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateIntegration(body: IntegrationDTO | undefined, cancelToken?: CancelToken): Promise<IntegrationDTO> {
        let url_ = this.baseUrl + "/api/Integration/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateIntegration(_response);
        });
    }

    protected processUpdateIntegration(response: AxiosResponse): Promise<IntegrationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IntegrationDTO.fromJS(resultData200);
            return Promise.resolve<IntegrationDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntegrationDTO>(null as any);
    }

    /**
     * Toggles activation of Integrations in the integrations table from active to inactive or inactive to active.
     * @param activate (optional) 
     * @param body (optional) 
     * @return Success
     */
    toggleIntegrationActivation(activate: boolean | undefined, body: IntegrationDTO[] | undefined, cancelToken?: CancelToken): Promise<IntegrationDTO[]> {
        let url_ = this.baseUrl + "/api/Integration/toggle-activation?";
        if (activate === null)
            throw new Error("The parameter 'activate' cannot be null.");
        else if (activate !== undefined)
            url_ += "activate=" + encodeURIComponent("" + activate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processToggleIntegrationActivation(_response);
        });
    }

    protected processToggleIntegrationActivation(response: AxiosResponse): Promise<IntegrationDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntegrationDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<IntegrationDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntegrationDTO[]>(null as any);
    }

    /**
     * @param filepond (optional) 
     * @param hello (optional) 
     * @return Success
     */
    uploadCiscoReadyReportByAccountId(accountId: string, filepond: FileParameter | undefined, hello: string | undefined, cancelToken?: CancelToken): Promise<CiscoReadyReportUploadResponse> {
        let url_ = this.baseUrl + "/api/Integration/cisco-ready-report/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (filepond === null || filepond === undefined)
            throw new Error("The parameter 'filepond' cannot be null.");
        else
            content_.append("filepond", filepond.data, filepond.fileName ? filepond.fileName : "filepond");
        if (hello === null || hello === undefined)
            throw new Error("The parameter 'hello' cannot be null.");
        else
            content_.append("Hello", hello.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadCiscoReadyReportByAccountId(_response);
        });
    }

    protected processUploadCiscoReadyReportByAccountId(response: AxiosResponse): Promise<CiscoReadyReportUploadResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CiscoReadyReportUploadResponse.fromJS(resultData200);
            return Promise.resolve<CiscoReadyReportUploadResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CiscoReadyReportUploadResponse>(null as any);
    }

    /**
     * @param enabledOnly (optional) 
     * @return Success
     */
    getIntegrationDefinitions(enabledOnly: boolean | undefined, cancelToken?: CancelToken): Promise<IntegrationDefinition[]> {
        let url_ = this.baseUrl + "/api/Integration/definitions?";
        if (enabledOnly === null)
            throw new Error("The parameter 'enabledOnly' cannot be null.");
        else if (enabledOnly !== undefined)
            url_ += "enabledOnly=" + encodeURIComponent("" + enabledOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIntegrationDefinitions(_response);
        });
    }

    protected processGetIntegrationDefinitions(response: AxiosResponse): Promise<IntegrationDefinition[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntegrationDefinition.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<IntegrationDefinition[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntegrationDefinition[]>(null as any);
    }

    /**
     * Get a list of all subscriptionIds along with display names for configured integration types
    Currently supports Azure tenant types
     * @return Success
     */
    getIntegrationAccounts( cancelToken?: CancelToken): Promise<CustomerAccount[]> {
        let url_ = this.baseUrl + "/api/Integration/integration-accounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIntegrationAccounts(_response);
        });
    }

    protected processGetIntegrationAccounts(response: AxiosResponse): Promise<CustomerAccount[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerAccount.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CustomerAccount[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerAccount[]>(null as any);
    }

    /**
     * @param activeOnly (optional) 
     * @return Success
     */
    getIntegrations(activeOnly: boolean | undefined, cancelToken?: CancelToken): Promise<IntegrationDTO[]> {
        let url_ = this.baseUrl + "/api/Integration?";
        if (activeOnly === null)
            throw new Error("The parameter 'activeOnly' cannot be null.");
        else if (activeOnly !== undefined)
            url_ += "activeOnly=" + encodeURIComponent("" + activeOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIntegrations(_response);
        });
    }

    protected processGetIntegrations(response: AxiosResponse): Promise<IntegrationDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntegrationDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<IntegrationDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntegrationDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    postIntegration(body: IntegrationDTO | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Integration/integrations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostIntegration(_response);
        });
    }

    protected processPostIntegration(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    doesAccountExists(axNumber: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Integration/{axNumber}";
        if (axNumber === undefined || axNumber === null)
            throw new Error("The parameter 'axNumber' must be defined.");
        url_ = url_.replace("{axNumber}", encodeURIComponent("" + axNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "HEAD",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDoesAccountExists(_response);
        });
    }

    protected processDoesAccountExists(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getAxReferencesByAccountId(accountId: number, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Integration/account-ax-references/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAxReferencesByAccountId(_response);
        });
    }

    protected processGetAxReferencesByAccountId(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Get All Integrations by the IntegrationType
     * @param integrationType (optional) Type Of Integrations to retrieve
     * @param activeOnly (optional) True if only active integrations (true by default)
     * @return Success
     */
    getIntegrationsByType(integrationType: IntegrationType | undefined, activeOnly: boolean | undefined, cancelToken?: CancelToken): Promise<IntegrationDTO[]> {
        let url_ = this.baseUrl + "/api/Integration/integrations-by-type?";
        if (integrationType === null)
            throw new Error("The parameter 'integrationType' cannot be null.");
        else if (integrationType !== undefined)
            url_ += "integrationType=" + encodeURIComponent("" + integrationType) + "&";
        if (activeOnly === null)
            throw new Error("The parameter 'activeOnly' cannot be null.");
        else if (activeOnly !== undefined)
            url_ += "activeOnly=" + encodeURIComponent("" + activeOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIntegrationsByType(_response);
        });
    }

    protected processGetIntegrationsByType(response: AxiosResponse): Promise<IntegrationDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntegrationDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<IntegrationDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntegrationDTO[]>(null as any);
    }

    /**
     * @param activeOnly (optional) 
     * @return Success
     */
    getCiscoSNTCIntegrations(activeOnly: boolean | undefined, cancelToken?: CancelToken): Promise<CiscoSNTCIntegrationDTO[]> {
        let url_ = this.baseUrl + "/api/Integration/cisco-sntc?";
        if (activeOnly === null)
            throw new Error("The parameter 'activeOnly' cannot be null.");
        else if (activeOnly !== undefined)
            url_ += "activeOnly=" + encodeURIComponent("" + activeOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCiscoSNTCIntegrations(_response);
        });
    }

    protected processGetCiscoSNTCIntegrations(response: AxiosResponse): Promise<CiscoSNTCIntegrationDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CiscoSNTCIntegrationDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CiscoSNTCIntegrationDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CiscoSNTCIntegrationDTO[]>(null as any);
    }

    /**
     * @param activeOnly (optional) 
     * @return Success
     */
    getCiscoEAIntegrations(activeOnly: boolean | undefined, cancelToken?: CancelToken): Promise<CiscoEnterpriseAgreementIntegrationDTO[]> {
        let url_ = this.baseUrl + "/api/Integration/cisco-ea?";
        if (activeOnly === null)
            throw new Error("The parameter 'activeOnly' cannot be null.");
        else if (activeOnly !== undefined)
            url_ += "activeOnly=" + encodeURIComponent("" + activeOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCiscoEAIntegrations(_response);
        });
    }

    protected processGetCiscoEAIntegrations(response: AxiosResponse): Promise<CiscoEnterpriseAgreementIntegrationDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CiscoEnterpriseAgreementIntegrationDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CiscoEnterpriseAgreementIntegrationDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CiscoEnterpriseAgreementIntegrationDTO[]>(null as any);
    }

    /**
     * @param activeOnly (optional) 
     * @return Success
     */
    getAzureComplianceIntegrations(activeOnly: boolean | undefined, cancelToken?: CancelToken): Promise<AzureComplianceIntegrationDTO[]> {
        let url_ = this.baseUrl + "/api/Integration/azure-compliance?";
        if (activeOnly === null)
            throw new Error("The parameter 'activeOnly' cannot be null.");
        else if (activeOnly !== undefined)
            url_ += "activeOnly=" + encodeURIComponent("" + activeOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAzureComplianceIntegrations(_response);
        });
    }

    protected processGetAzureComplianceIntegrations(response: AxiosResponse): Promise<AzureComplianceIntegrationDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AzureComplianceIntegrationDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AzureComplianceIntegrationDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AzureComplianceIntegrationDTO[]>(null as any);
    }

    /**
     * @param activeOnly (optional) 
     * @return Success
     */
    getAwsComplianceIntegrations(activeOnly: boolean | undefined, cancelToken?: CancelToken): Promise<AwsComplianceIntegrationDTO[]> {
        let url_ = this.baseUrl + "/api/Integration/aws-compliance?";
        if (activeOnly === null)
            throw new Error("The parameter 'activeOnly' cannot be null.");
        else if (activeOnly !== undefined)
            url_ += "activeOnly=" + encodeURIComponent("" + activeOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAwsComplianceIntegrations(_response);
        });
    }

    protected processGetAwsComplianceIntegrations(response: AxiosResponse): Promise<AwsComplianceIntegrationDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AwsComplianceIntegrationDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AwsComplianceIntegrationDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AwsComplianceIntegrationDTO[]>(null as any);
    }

    /**
     * @param activeOnly (optional) 
     * @return Success
     */
    getAwsSimpleRecommendationsIntegrations(activeOnly: boolean | undefined, cancelToken?: CancelToken): Promise<AwsSimpleRecommendationsIntegrationDTO[]> {
        let url_ = this.baseUrl + "/api/Integration/aws-simple-recommendations?";
        if (activeOnly === null)
            throw new Error("The parameter 'activeOnly' cannot be null.");
        else if (activeOnly !== undefined)
            url_ += "activeOnly=" + encodeURIComponent("" + activeOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAwsSimpleRecommendationsIntegrations(_response);
        });
    }

    protected processGetAwsSimpleRecommendationsIntegrations(response: AxiosResponse): Promise<AwsSimpleRecommendationsIntegrationDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AwsSimpleRecommendationsIntegrationDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AwsSimpleRecommendationsIntegrationDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AwsSimpleRecommendationsIntegrationDTO[]>(null as any);
    }

    /**
     * @param activeOnly (optional) 
     * @return Success
     */
    getAzureSimpleRecommendationsIntegrations(activeOnly: boolean | undefined, cancelToken?: CancelToken): Promise<AzureSimpleRecommendationsIntegrationDTO[]> {
        let url_ = this.baseUrl + "/api/Integration/azure-simple-recommendations?";
        if (activeOnly === null)
            throw new Error("The parameter 'activeOnly' cannot be null.");
        else if (activeOnly !== undefined)
            url_ += "activeOnly=" + encodeURIComponent("" + activeOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAzureSimpleRecommendationsIntegrations(_response);
        });
    }

    protected processGetAzureSimpleRecommendationsIntegrations(response: AxiosResponse): Promise<AzureSimpleRecommendationsIntegrationDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AzureSimpleRecommendationsIntegrationDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AzureSimpleRecommendationsIntegrationDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AzureSimpleRecommendationsIntegrationDTO[]>(null as any);
    }

    /**
     * @param activeOnly (optional) 
     * @return Success
     */
    getAzureBackupsIntegrations(activeOnly: boolean | undefined, cancelToken?: CancelToken): Promise<AzureBackupsIntegrationDTO[]> {
        let url_ = this.baseUrl + "/api/Integration/azure-backups?";
        if (activeOnly === null)
            throw new Error("The parameter 'activeOnly' cannot be null.");
        else if (activeOnly !== undefined)
            url_ += "activeOnly=" + encodeURIComponent("" + activeOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAzureBackupsIntegrations(_response);
        });
    }

    protected processGetAzureBackupsIntegrations(response: AxiosResponse): Promise<AzureBackupsIntegrationDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AzureBackupsIntegrationDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AzureBackupsIntegrationDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AzureBackupsIntegrationDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    allIntegrationsByAccountId(accountId: number, cancelToken?: CancelToken): Promise<CustomerAccount[]> {
        let url_ = this.baseUrl + "/api/Integration/integration-accounts/account/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAllIntegrationsByAccountId(_response);
        });
    }

    protected processAllIntegrationsByAccountId(response: AxiosResponse): Promise<CustomerAccount[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerAccount.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CustomerAccount[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerAccount[]>(null as any);
    }

    /**
     * @param activeOnly (optional) 
     * @return Success
     */
    activeIntegrationsByAccountId(accountId: number, activeOnly: boolean | undefined, cancelToken?: CancelToken): Promise<IntegrationDTO[]> {
        let url_ = this.baseUrl + "/api/Integration/integration/account/{accountId}?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (activeOnly === null)
            throw new Error("The parameter 'activeOnly' cannot be null.");
        else if (activeOnly !== undefined)
            url_ += "activeOnly=" + encodeURIComponent("" + activeOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActiveIntegrationsByAccountId(_response);
        });
    }

    protected processActiveIntegrationsByAccountId(response: AxiosResponse): Promise<IntegrationDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntegrationDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<IntegrationDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntegrationDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadCiscoSNTCByAccountId(accountId: number, body: BasicCiscoSNTCIntegrationDTO | undefined, cancelToken?: CancelToken): Promise<IntegrationDTO> {
        let url_ = this.baseUrl + "/api/Integration/cisco-SNTC/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadCiscoSNTCByAccountId(_response);
        });
    }

    protected processUploadCiscoSNTCByAccountId(response: AxiosResponse): Promise<IntegrationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IntegrationDTO.fromJS(resultData200);
            return Promise.resolve<IntegrationDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntegrationDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadCiscoEAByAccountId(accountId: number, body: BasicCiscoEAIntegrationDTO | undefined, cancelToken?: CancelToken): Promise<IntegrationDTO> {
        let url_ = this.baseUrl + "/api/Integration/cisco-EA/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadCiscoEAByAccountId(_response);
        });
    }

    protected processUploadCiscoEAByAccountId(response: AxiosResponse): Promise<IntegrationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IntegrationDTO.fromJS(resultData200);
            return Promise.resolve<IntegrationDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntegrationDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    registerSelfServiceReportingIntegration(accountId: number, body: SelfServiceReportingIntegrationDto | undefined, cancelToken?: CancelToken): Promise<IntegrationDTO> {
        let url_ = this.baseUrl + "/api/Integration/ssr/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegisterSelfServiceReportingIntegration(_response);
        });
    }

    protected processRegisterSelfServiceReportingIntegration(response: AxiosResponse): Promise<IntegrationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IntegrationDTO.fromJS(resultData200);
            return Promise.resolve<IntegrationDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntegrationDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    registerHardwareLifecycleManagementIntegration(accountId: string, body: HardwareLifecycleManagementIntegrationDTO | undefined, cancelToken?: CancelToken): Promise<IntegrationDTO> {
        let url_ = this.baseUrl + "/api/Integration/hlm/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegisterHardwareLifecycleManagementIntegration(_response);
        });
    }

    protected processRegisterHardwareLifecycleManagementIntegration(response: AxiosResponse): Promise<IntegrationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IntegrationDTO.fromJS(resultData200);
            return Promise.resolve<IntegrationDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntegrationDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    registerAwsGovernanceReportIntegration(accountId: string, body: AwsGovernanceReportsDto | undefined, cancelToken?: CancelToken): Promise<IntegrationDTO> {
        let url_ = this.baseUrl + "/api/Integration/aws-governance-reports/register/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegisterAwsGovernanceReportIntegration(_response);
        });
    }

    protected processRegisterAwsGovernanceReportIntegration(response: AxiosResponse): Promise<IntegrationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IntegrationDTO.fromJS(resultData200);
            return Promise.resolve<IntegrationDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntegrationDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    registerAzureGovernanceReportIntegration(accountId: string, body: AzureGovernanceReportsDto | undefined, cancelToken?: CancelToken): Promise<IntegrationDTO> {
        let url_ = this.baseUrl + "/api/Integration/azure-governance-reports/register/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegisterAzureGovernanceReportIntegration(_response);
        });
    }

    protected processRegisterAzureGovernanceReportIntegration(response: AxiosResponse): Promise<IntegrationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IntegrationDTO.fromJS(resultData200);
            return Promise.resolve<IntegrationDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntegrationDTO>(null as any);
    }

    /**
     * @return Success
     */
    registerDatadogUsageReportIntegration(accountId: string, cancelToken?: CancelToken): Promise<IntegrationDTO> {
        let url_ = this.baseUrl + "/api/Integration/datadog-usage-report/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegisterDatadogUsageReportIntegration(_response);
        });
    }

    protected processRegisterDatadogUsageReportIntegration(response: AxiosResponse): Promise<IntegrationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IntegrationDTO.fromJS(resultData200);
            return Promise.resolve<IntegrationDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntegrationDTO>(null as any);
    }

    /**
     * @param filepond (optional) 
     * @param hello (optional) 
     * @return Success
     */
    uploadLiveOpticsProjectByAccountId(accountId: string, filepond: FileParameter | undefined, hello: string | undefined, cancelToken?: CancelToken): Promise<LiveOpticsProjectUploadResponse> {
        let url_ = this.baseUrl + "/api/Integration/liveoptics-project/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (filepond === null || filepond === undefined)
            throw new Error("The parameter 'filepond' cannot be null.");
        else
            content_.append("filepond", filepond.data, filepond.fileName ? filepond.fileName : "filepond");
        if (hello === null || hello === undefined)
            throw new Error("The parameter 'hello' cannot be null.");
        else
            content_.append("Hello", hello.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadLiveOpticsProjectByAccountId(_response);
        });
    }

    protected processUploadLiveOpticsProjectByAccountId(response: AxiosResponse): Promise<LiveOpticsProjectUploadResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LiveOpticsProjectUploadResponse.fromJS(resultData200);
            return Promise.resolve<LiveOpticsProjectUploadResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LiveOpticsProjectUploadResponse>(null as any);
    }
}

export interface IKnowledgebaseClient {
    /**
     * @return Success
     */
    getAllKb(): Promise<ContentUnitDto[]>;
}

export class KnowledgebaseClient extends AuthorizedApiBase implements IKnowledgebaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getAllKb( cancelToken?: CancelToken): Promise<ContentUnitDto[]> {
        let url_ = this.baseUrl + "/api/Knowledgebase/kb/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllKb(_response);
        });
    }

    protected processGetAllKb(response: AxiosResponse): Promise<ContentUnitDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContentUnitDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ContentUnitDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentUnitDto[]>(null as any);
    }
}

export interface ILabsClient {
    /**
     * Returns the complete SHI Lab list from sharepoint with all current available labs
     * @return Success
     */
    getAllLabsFromSharepoint(): Promise<LabDto[]>;
    /**
     * Returns the SHI Lab list with available labs based on the search value
     * @return Success
     */
    searchAvailableLabsFromSharepoint(searchTerm: string): Promise<LabDto[]>;
    /**
     * Paginates over labs from sharepoint cache
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param body (optional) 
     * @return Success
     */
    getPaginatedLabs(pageNumber: number | undefined, pageSize: number | undefined, body: SearchFilter | undefined): Promise<PaginatedResultDto_1OfLabDto>;
    /**
     * Returns the logo for the lab with the given imageId
     * @return Success
     */
    getLabLogo(imageId: string): Promise<void>;
    /**
     * @return Success
     */
    getUniqueLabPracticeList(): Promise<string[]>;
    /**
     * Returns the lab logo dto for the lab with the given imageId
     * @return Success
     */
    getLabLogoBytes(imageId: string): Promise<LabLogoDto>;
    /**
     * Returns documentation for a specific lab
     * @param body (optional) 
     * @return Success
     */
    downloadLabDocumentation(body: DownloadLabDocumentationByFileReference | undefined): Promise<DownloadLabDocumentationDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    requestLabAccess(body: Lab | undefined): Promise<LabAccessRequestResponse>;
}

export class LabsClient extends AuthorizedApiBase implements ILabsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Returns the complete SHI Lab list from sharepoint with all current available labs
     * @return Success
     */
    getAllLabsFromSharepoint( cancelToken?: CancelToken): Promise<LabDto[]> {
        let url_ = this.baseUrl + "/api/Labs/sharepoint";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllLabsFromSharepoint(_response);
        });
    }

    protected processGetAllLabsFromSharepoint(response: AxiosResponse): Promise<LabDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LabDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<LabDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LabDto[]>(null as any);
    }

    /**
     * Returns the SHI Lab list with available labs based on the search value
     * @return Success
     */
    searchAvailableLabsFromSharepoint(searchTerm: string, cancelToken?: CancelToken): Promise<LabDto[]> {
        let url_ = this.baseUrl + "/api/Labs/search/sharepoint/{searchTerm}";
        if (searchTerm === undefined || searchTerm === null)
            throw new Error("The parameter 'searchTerm' must be defined.");
        url_ = url_.replace("{searchTerm}", encodeURIComponent("" + searchTerm));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchAvailableLabsFromSharepoint(_response);
        });
    }

    protected processSearchAvailableLabsFromSharepoint(response: AxiosResponse): Promise<LabDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LabDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<LabDto[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LabDto[]>(null as any);
    }

    /**
     * Paginates over labs from sharepoint cache
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param body (optional) 
     * @return Success
     */
    getPaginatedLabs(pageNumber: number | undefined, pageSize: number | undefined, body: SearchFilter | undefined, cancelToken?: CancelToken): Promise<PaginatedResultDto_1OfLabDto> {
        let url_ = this.baseUrl + "/api/Labs/paging?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaginatedLabs(_response);
        });
    }

    protected processGetPaginatedLabs(response: AxiosResponse): Promise<PaginatedResultDto_1OfLabDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResultDto_1OfLabDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResultDto_1OfLabDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResultDto_1OfLabDto>(null as any);
    }

    /**
     * Returns the logo for the lab with the given imageId
     * @return Success
     */
    getLabLogo(imageId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Labs/logo/{imageId}";
        if (imageId === undefined || imageId === null)
            throw new Error("The parameter 'imageId' must be defined.");
        url_ = url_.replace("{imageId}", encodeURIComponent("" + imageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLabLogo(_response);
        });
    }

    protected processGetLabLogo(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getUniqueLabPracticeList( cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Labs/practices";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUniqueLabPracticeList(_response);
        });
    }

    protected processGetUniqueLabPracticeList(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Returns the lab logo dto for the lab with the given imageId
     * @return Success
     */
    getLabLogoBytes(imageId: string, cancelToken?: CancelToken): Promise<LabLogoDto> {
        let url_ = this.baseUrl + "/api/Labs/logo-bytes/{imageId}";
        if (imageId === undefined || imageId === null)
            throw new Error("The parameter 'imageId' must be defined.");
        url_ = url_.replace("{imageId}", encodeURIComponent("" + imageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLabLogoBytes(_response);
        });
    }

    protected processGetLabLogoBytes(response: AxiosResponse): Promise<LabLogoDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LabLogoDto.fromJS(resultData200);
            return Promise.resolve<LabLogoDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LabLogoDto>(null as any);
    }

    /**
     * Returns documentation for a specific lab
     * @param body (optional) 
     * @return Success
     */
    downloadLabDocumentation(body: DownloadLabDocumentationByFileReference | undefined, cancelToken?: CancelToken): Promise<DownloadLabDocumentationDto> {
        let url_ = this.baseUrl + "/api/Labs/documentation/download";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadLabDocumentation(_response);
        });
    }

    protected processDownloadLabDocumentation(response: AxiosResponse): Promise<DownloadLabDocumentationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DownloadLabDocumentationDto.fromJS(resultData200);
            return Promise.resolve<DownloadLabDocumentationDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DownloadLabDocumentationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    requestLabAccess(body: Lab | undefined, cancelToken?: CancelToken): Promise<LabAccessRequestResponse> {
        let url_ = this.baseUrl + "/api/Labs/request-access";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequestLabAccess(_response);
        });
    }

    protected processRequestLabAccess(response: AxiosResponse): Promise<LabAccessRequestResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LabAccessRequestResponse.fromJS(resultData200);
            return Promise.resolve<LabAccessRequestResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LabAccessRequestResponse>(null as any);
    }
}

export interface ILabsOnDemandClient {
    /**
     * @return Success
     */
    createOnDemandLabForUser(labId: string): Promise<UserLabsDto>;
    /**
     * @return Success
     */
    getUserLabsData(): Promise<UserLabsDto>;
    /**
     * @return Success
     */
    getUserOnDemandLabRequests(): Promise<UserOnDemandLabRequestDto[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    createUserOnDemandLabRequests(body: UserOnDemandLabRequestDto | undefined): Promise<UserOnDemandLabRequestDto[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateUserOnDemandLabRequests(body: UserOnDemandLabRequestDto | undefined): Promise<UserOnDemandLabRequestDto[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    removeUserOnDemandLabRequests(body: UserOnDemandLabRequestDto | undefined): Promise<UserOnDemandLabRequestDto>;
}

export class LabsOnDemandClient extends AuthorizedApiBase implements ILabsOnDemandClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    createOnDemandLabForUser(labId: string, cancelToken?: CancelToken): Promise<UserLabsDto> {
        let url_ = this.baseUrl + "/api/LabsOnDemand/lab/{labId}";
        if (labId === undefined || labId === null)
            throw new Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOnDemandLabForUser(_response);
        });
    }

    protected processCreateOnDemandLabForUser(response: AxiosResponse): Promise<UserLabsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserLabsDto.fromJS(resultData200);
            return Promise.resolve<UserLabsDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserLabsDto>(null as any);
    }

    /**
     * @return Success
     */
    getUserLabsData( cancelToken?: CancelToken): Promise<UserLabsDto> {
        let url_ = this.baseUrl + "/api/LabsOnDemand/user/labs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserLabsData(_response);
        });
    }

    protected processGetUserLabsData(response: AxiosResponse): Promise<UserLabsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserLabsDto.fromJS(resultData200);
            return Promise.resolve<UserLabsDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserLabsDto>(null as any);
    }

    /**
     * @return Success
     */
    getUserOnDemandLabRequests( cancelToken?: CancelToken): Promise<UserOnDemandLabRequestDto[]> {
        let url_ = this.baseUrl + "/api/LabsOnDemand/user/labs/requests";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserOnDemandLabRequests(_response);
        });
    }

    protected processGetUserOnDemandLabRequests(response: AxiosResponse): Promise<UserOnDemandLabRequestDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserOnDemandLabRequestDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserOnDemandLabRequestDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserOnDemandLabRequestDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUserOnDemandLabRequests(body: UserOnDemandLabRequestDto | undefined, cancelToken?: CancelToken): Promise<UserOnDemandLabRequestDto[]> {
        let url_ = this.baseUrl + "/api/LabsOnDemand/labs/requests/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUserOnDemandLabRequests(_response);
        });
    }

    protected processCreateUserOnDemandLabRequests(response: AxiosResponse): Promise<UserOnDemandLabRequestDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserOnDemandLabRequestDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserOnDemandLabRequestDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserOnDemandLabRequestDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUserOnDemandLabRequests(body: UserOnDemandLabRequestDto | undefined, cancelToken?: CancelToken): Promise<UserOnDemandLabRequestDto[]> {
        let url_ = this.baseUrl + "/api/LabsOnDemand/labs/requests/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUserOnDemandLabRequests(_response);
        });
    }

    protected processUpdateUserOnDemandLabRequests(response: AxiosResponse): Promise<UserOnDemandLabRequestDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserOnDemandLabRequestDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserOnDemandLabRequestDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserOnDemandLabRequestDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    removeUserOnDemandLabRequests(body: UserOnDemandLabRequestDto | undefined, cancelToken?: CancelToken): Promise<UserOnDemandLabRequestDto> {
        let url_ = this.baseUrl + "/api/LabsOnDemand/labs/requests/remove";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveUserOnDemandLabRequests(_response);
        });
    }

    protected processRemoveUserOnDemandLabRequests(response: AxiosResponse): Promise<UserOnDemandLabRequestDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserOnDemandLabRequestDto.fromJS(resultData200);
            return Promise.resolve<UserOnDemandLabRequestDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserOnDemandLabRequestDto>(null as any);
    }
}

export interface ILastMonthsCostsWidgetClient {
    /**
     * @return Success
     */
    costs(lastMonthsCostType: LastMonthsCostType): Promise<WidgetContentResponseDto_1OfLastMonthsCostDto>;
}

export class LastMonthsCostsWidgetClient extends AuthorizedApiBase implements ILastMonthsCostsWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    costs(lastMonthsCostType: LastMonthsCostType, cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfLastMonthsCostDto> {
        let url_ = this.baseUrl + "/api/widget/last-months-cost/{lastMonthsCostType}";
        if (lastMonthsCostType === undefined || lastMonthsCostType === null)
            throw new Error("The parameter 'lastMonthsCostType' must be defined.");
        url_ = url_.replace("{lastMonthsCostType}", encodeURIComponent("" + lastMonthsCostType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCosts(_response);
        });
    }

    protected processCosts(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfLastMonthsCostDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfLastMonthsCostDto.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfLastMonthsCostDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfLastMonthsCostDto>(null as any);
    }
}

export interface IMappingClient {
    /**
     * @return Success
     */
    getAllContractSLAs(): Promise<ConfigContractSLAsResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    createContractsLas(body: ConfigContractSLA | undefined): Promise<CreateConfigContractSLAResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateContractsLas(body: ConfigContractSLA | undefined): Promise<UpdateConfigContractSLAResponse>;
}

export class MappingClient extends AuthorizedApiBase implements IMappingClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getAllContractSLAs( cancelToken?: CancelToken): Promise<ConfigContractSLAsResponse> {
        let url_ = this.baseUrl + "/api/Mapping/contractslas/get";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllContractSLAs(_response);
        });
    }

    protected processGetAllContractSLAs(response: AxiosResponse): Promise<ConfigContractSLAsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConfigContractSLAsResponse.fromJS(resultData200);
            return Promise.resolve<ConfigContractSLAsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConfigContractSLAsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createContractsLas(body: ConfigContractSLA | undefined, cancelToken?: CancelToken): Promise<CreateConfigContractSLAResponse> {
        let url_ = this.baseUrl + "/api/Mapping/contractslas/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateContractsLas(_response);
        });
    }

    protected processCreateContractsLas(response: AxiosResponse): Promise<CreateConfigContractSLAResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateConfigContractSLAResponse.fromJS(resultData200);
            return Promise.resolve<CreateConfigContractSLAResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateConfigContractSLAResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateContractsLas(body: ConfigContractSLA | undefined, cancelToken?: CancelToken): Promise<UpdateConfigContractSLAResponse> {
        let url_ = this.baseUrl + "/api/Mapping/contractslas/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateContractsLas(_response);
        });
    }

    protected processUpdateContractsLas(response: AxiosResponse): Promise<UpdateConfigContractSLAResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateConfigContractSLAResponse.fromJS(resultData200);
            return Promise.resolve<UpdateConfigContractSLAResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateConfigContractSLAResponse>(null as any);
    }
}

export interface IMappingEngineClient {
    /**
     * @param manualHeadersAssignment (optional) 
     * @return Success
     */
    postHeaders(manualHeadersAssignment: string | undefined): Promise<MappingRowsResultDto>;
    /**
     * @param schemaType (optional) 
     * @return Success
     */
    getAllSchemasOrByType(schemaType: string | undefined): Promise<SchemaDto[]>;
    /**
     * @return Success
     */
    getMappingBySchemaId(schemaId: number): Promise<MappingDto>;
    /**
     * @return Success
     */
    getSchemaById(schemaId: number): Promise<SchemaDto>;
    /**
     * @param id (optional) 
     * @param name (optional) 
     * @param description (optional) 
     * @param schemaType (optional) 
     * @param targetSchemaUrl (optional) 
     * @return Success
     */
    createUpdateSchema(id: number | undefined, name: string | undefined, description: string | undefined, schemaType: string | undefined, targetSchemaUrl: string | undefined): Promise<SchemaDto>;
    /**
     * @param id (optional) 
     * @param schemaId (optional) 
     * @param version (optional) 
     * @param description (optional) 
     * @param mapping (optional) 
     * @param published (optional) 
     * @param uploadResponse_Guid (optional) 
     * @param uploadResponse_FileType (optional) 
     * @param uploadResponse_ExcelRowsList (optional) 
     * @param uploadResponse_CsvRowsList (optional) 
     * @return Success
     */
    createUpdateMapping(id: number | undefined, schemaId: number | undefined, version: number | undefined, description: string | undefined, mapping: string | undefined, published: boolean | undefined, uploadResponse_Guid: string | undefined, uploadResponse_FileType: MappingFileType | undefined, uploadResponse_ExcelRowsList: ExcelRows[] | undefined, uploadResponse_CsvRowsList: CsvRows[] | undefined): Promise<MappingDto>;
    /**
     * @param axNumber (optional) 
     * @param schemaId (optional) 
     * @param schemaType (optional) 
     * @param schemaName (optional) 
     * @return Success
     */
    uploadMappingEngineFile(axNumber: string | undefined, schemaId: string | undefined, schemaType: string | undefined, schemaName: string | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    deleteMetaData(body: MappingEngineMetadataDto | undefined): Promise<void>;
}

export class MappingEngineClient extends AuthorizedApiBase implements IMappingEngineClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param manualHeadersAssignment (optional) 
     * @return Success
     */
    postHeaders(manualHeadersAssignment: string | undefined, cancelToken?: CancelToken): Promise<MappingRowsResultDto> {
        let url_ = this.baseUrl + "/api/MappingEngine/headers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (manualHeadersAssignment === null || manualHeadersAssignment === undefined)
            throw new Error("The parameter 'manualHeadersAssignment' cannot be null.");
        else
            content_.append("manualHeadersAssignment", manualHeadersAssignment.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostHeaders(_response);
        });
    }

    protected processPostHeaders(response: AxiosResponse): Promise<MappingRowsResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MappingRowsResultDto.fromJS(resultData200);
            return Promise.resolve<MappingRowsResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MappingRowsResultDto>(null as any);
    }

    /**
     * @param schemaType (optional) 
     * @return Success
     */
    getAllSchemasOrByType(schemaType: string | undefined, cancelToken?: CancelToken): Promise<SchemaDto[]> {
        let url_ = this.baseUrl + "/api/MappingEngine/schemas?";
        if (schemaType === null)
            throw new Error("The parameter 'schemaType' cannot be null.");
        else if (schemaType !== undefined)
            url_ += "schemaType=" + encodeURIComponent("" + schemaType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllSchemasOrByType(_response);
        });
    }

    protected processGetAllSchemasOrByType(response: AxiosResponse): Promise<SchemaDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SchemaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SchemaDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SchemaDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getMappingBySchemaId(schemaId: number, cancelToken?: CancelToken): Promise<MappingDto> {
        let url_ = this.baseUrl + "/api/MappingEngine/mappingBySchema/{schemaId}";
        if (schemaId === undefined || schemaId === null)
            throw new Error("The parameter 'schemaId' must be defined.");
        url_ = url_.replace("{schemaId}", encodeURIComponent("" + schemaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMappingBySchemaId(_response);
        });
    }

    protected processGetMappingBySchemaId(response: AxiosResponse): Promise<MappingDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MappingDto.fromJS(resultData200);
            return Promise.resolve<MappingDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MappingDto>(null as any);
    }

    /**
     * @return Success
     */
    getSchemaById(schemaId: number, cancelToken?: CancelToken): Promise<SchemaDto> {
        let url_ = this.baseUrl + "/api/MappingEngine/schema/{schemaId}";
        if (schemaId === undefined || schemaId === null)
            throw new Error("The parameter 'schemaId' must be defined.");
        url_ = url_.replace("{schemaId}", encodeURIComponent("" + schemaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSchemaById(_response);
        });
    }

    protected processGetSchemaById(response: AxiosResponse): Promise<SchemaDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SchemaDto.fromJS(resultData200);
            return Promise.resolve<SchemaDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SchemaDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param name (optional) 
     * @param description (optional) 
     * @param schemaType (optional) 
     * @param targetSchemaUrl (optional) 
     * @return Success
     */
    createUpdateSchema(id: number | undefined, name: string | undefined, description: string | undefined, schemaType: string | undefined, targetSchemaUrl: string | undefined, cancelToken?: CancelToken): Promise<SchemaDto> {
        let url_ = this.baseUrl + "/api/MappingEngine/createUpdateSchema";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (description === null || description === undefined)
            throw new Error("The parameter 'description' cannot be null.");
        else
            content_.append("Description", description.toString());
        if (schemaType === null || schemaType === undefined)
            throw new Error("The parameter 'schemaType' cannot be null.");
        else
            content_.append("SchemaType", schemaType.toString());
        if (targetSchemaUrl === null || targetSchemaUrl === undefined)
            throw new Error("The parameter 'targetSchemaUrl' cannot be null.");
        else
            content_.append("TargetSchemaUrl", targetSchemaUrl.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUpdateSchema(_response);
        });
    }

    protected processCreateUpdateSchema(response: AxiosResponse): Promise<SchemaDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SchemaDto.fromJS(resultData200);
            return Promise.resolve<SchemaDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SchemaDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param schemaId (optional) 
     * @param version (optional) 
     * @param description (optional) 
     * @param mapping (optional) 
     * @param published (optional) 
     * @param uploadResponse_Guid (optional) 
     * @param uploadResponse_FileType (optional) 
     * @param uploadResponse_ExcelRowsList (optional) 
     * @param uploadResponse_CsvRowsList (optional) 
     * @return Success
     */
    createUpdateMapping(id: number | undefined, schemaId: number | undefined, version: number | undefined, description: string | undefined, mapping: string | undefined, published: boolean | undefined, uploadResponse_Guid: string | undefined, uploadResponse_FileType: MappingFileType | undefined, uploadResponse_ExcelRowsList: ExcelRows[] | undefined, uploadResponse_CsvRowsList: CsvRows[] | undefined, cancelToken?: CancelToken): Promise<MappingDto> {
        let url_ = this.baseUrl + "/api/MappingEngine/createUpdateMapping";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (schemaId === null || schemaId === undefined)
            throw new Error("The parameter 'schemaId' cannot be null.");
        else
            content_.append("SchemaId", schemaId.toString());
        if (version === null || version === undefined)
            throw new Error("The parameter 'version' cannot be null.");
        else
            content_.append("Version", version.toString());
        if (description === null || description === undefined)
            throw new Error("The parameter 'description' cannot be null.");
        else
            content_.append("Description", description.toString());
        if (mapping === null || mapping === undefined)
            throw new Error("The parameter 'mapping' cannot be null.");
        else
            content_.append("Mapping", mapping.toString());
        if (published === null || published === undefined)
            throw new Error("The parameter 'published' cannot be null.");
        else
            content_.append("Published", published.toString());
        if (uploadResponse_Guid === null || uploadResponse_Guid === undefined)
            throw new Error("The parameter 'uploadResponse_Guid' cannot be null.");
        else
            content_.append("UploadResponse.Guid", uploadResponse_Guid.toString());
        if (uploadResponse_FileType === null || uploadResponse_FileType === undefined)
            throw new Error("The parameter 'uploadResponse_FileType' cannot be null.");
        else
            content_.append("UploadResponse.FileType", uploadResponse_FileType.toString());
        if (uploadResponse_ExcelRowsList === null || uploadResponse_ExcelRowsList === undefined)
            throw new Error("The parameter 'uploadResponse_ExcelRowsList' cannot be null.");
        else
            uploadResponse_ExcelRowsList.forEach(item_ => content_.append("UploadResponse.ExcelRowsList", item_.toString()));
        if (uploadResponse_CsvRowsList === null || uploadResponse_CsvRowsList === undefined)
            throw new Error("The parameter 'uploadResponse_CsvRowsList' cannot be null.");
        else
            uploadResponse_CsvRowsList.forEach(item_ => content_.append("UploadResponse.CsvRowsList", item_.toString()));

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUpdateMapping(_response);
        });
    }

    protected processCreateUpdateMapping(response: AxiosResponse): Promise<MappingDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MappingDto.fromJS(resultData200);
            return Promise.resolve<MappingDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MappingDto>(null as any);
    }

    /**
     * @param axNumber (optional) 
     * @param schemaId (optional) 
     * @param schemaType (optional) 
     * @param schemaName (optional) 
     * @return Success
     */
    uploadMappingEngineFile(axNumber: string | undefined, schemaId: string | undefined, schemaType: string | undefined, schemaName: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/MappingEngine/validateAndUploadFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (axNumber === null || axNumber === undefined)
            throw new Error("The parameter 'axNumber' cannot be null.");
        else
            content_.append("AxNumber", axNumber.toString());
        if (schemaId === null || schemaId === undefined)
            throw new Error("The parameter 'schemaId' cannot be null.");
        else
            content_.append("SchemaId", schemaId.toString());
        if (schemaType === null || schemaType === undefined)
            throw new Error("The parameter 'schemaType' cannot be null.");
        else
            content_.append("SchemaType", schemaType.toString());
        if (schemaName === null || schemaName === undefined)
            throw new Error("The parameter 'schemaName' cannot be null.");
        else
            content_.append("SchemaName", schemaName.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadMappingEngineFile(_response);
        });
    }

    protected processUploadMappingEngineFile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteMetaData(body: MappingEngineMetadataDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/MappingEngine/removeMetadata";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMetaData(_response);
        });
    }

    protected processDeleteMetaData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IMarketplaceMappingClient {
    /**
     * Collects a given customers available tenants and their associated subscriptions from MongoDB.
     * @param unmappedOnly (optional) 
     * @return Success
     */
    getCustomerTenantSubscriptions(unmappedOnly: boolean | undefined): Promise<TenantSubscriptions[]>;
    /**
     * Assign an array of subscription IDs to an AX# by creating the appropriate integrations (Azure Compliance + Recs)
     * @param body (optional) 
     * @return Success
     */
    submitSubscriptionMapping(body: SubscriptionMapping | undefined): Promise<void>;
}

export class MarketplaceMappingClient extends AuthorizedApiBase implements IMarketplaceMappingClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Collects a given customers available tenants and their associated subscriptions from MongoDB.
     * @param unmappedOnly (optional) 
     * @return Success
     */
    getCustomerTenantSubscriptions(unmappedOnly: boolean | undefined, cancelToken?: CancelToken): Promise<TenantSubscriptions[]> {
        let url_ = this.baseUrl + "/api/MarketplaceMapping?";
        if (unmappedOnly === null)
            throw new Error("The parameter 'unmappedOnly' cannot be null.");
        else if (unmappedOnly !== undefined)
            url_ += "unmappedOnly=" + encodeURIComponent("" + unmappedOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomerTenantSubscriptions(_response);
        });
    }

    protected processGetCustomerTenantSubscriptions(response: AxiosResponse): Promise<TenantSubscriptions[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenantSubscriptions.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TenantSubscriptions[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantSubscriptions[]>(null as any);
    }

    /**
     * Assign an array of subscription IDs to an AX# by creating the appropriate integrations (Azure Compliance + Recs)
     * @param body (optional) 
     * @return Success
     */
    submitSubscriptionMapping(body: SubscriptionMapping | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/MarketplaceMapping";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitSubscriptionMapping(_response);
        });
    }

    protected processSubmitSubscriptionMapping(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IMicrosoft365IntegrationClient {
    /**
     * @param body (optional) 
     * @return Success
     */
    register(accountId: number, body: Microsoft365ReportsIntegrationDTO | undefined): Promise<void>;
    /**
     * @return Success
     */
    getTenantIdFromDomain(domain: string): Promise<string>;
    /**
     * @param body (optional) 
     * @return Success
     */
    validateRegistrationCallback(body: Microsoft365CallbackDetails | undefined): Promise<boolean>;
    /**
     * @param body (optional) 
     * @return Success
     */
    logRegistrationError(body: RegistrationError | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getAppRegistrationUrl(body: Microsoft365ReportsIntegrationMetadata | undefined): Promise<string>;
}

export class Microsoft365IntegrationClient extends AuthorizedApiBase implements IMicrosoft365IntegrationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    register(accountId: number, body: Microsoft365ReportsIntegrationDTO | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Integration/Microsoft365/register/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegister(_response);
        });
    }

    protected processRegister(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getTenantIdFromDomain(domain: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Integration/Microsoft365/tenant-id-from-domain/{domain}";
        if (domain === undefined || domain === null)
            throw new Error("The parameter 'domain' must be defined.");
        url_ = url_.replace("{domain}", encodeURIComponent("" + domain));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenantIdFromDomain(_response);
        });
    }

    protected processGetTenantIdFromDomain(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateRegistrationCallback(body: Microsoft365CallbackDetails | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Integration/Microsoft365/registration-callback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateRegistrationCallback(_response);
        });
    }

    protected processValidateRegistrationCallback(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    logRegistrationError(body: RegistrationError | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Integration/Microsoft365/registration-error";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogRegistrationError(_response);
        });
    }

    protected processLogRegistrationError(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAppRegistrationUrl(body: Microsoft365ReportsIntegrationMetadata | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Integration/Microsoft365/get-app-registration-url";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAppRegistrationUrl(_response);
        });
    }

    protected processGetAppRegistrationUrl(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface IMicrosoftAdoptionWidgetsClient {
    /**
     * @param dateOption (optional) 
     * @return Success
     */
    getActiveUsersByServiceWidget(dateOption: string | undefined): Promise<ActiveUsersByServiceWidgetResponse>;
    /**
     * @param frequency (optional) 
     * @return Success
     */
    getActiveUserTrendsWidget(frequency: string | undefined): Promise<ActiveUserTrendsWidgetResponse>;
    /**
     * @param service (optional) 
     * @return Success
     */
    getFeatureAdoptionWidget(service: string | undefined): Promise<FeatureAdoptionWidgetResponse>;
    /**
     * @return Success
     */
    getLicenseUtilizationWidget(): Promise<LicenseUtilizationWidgetResponse>;
    /**
     * @param service (optional) 
     * @return Success
     */
    getProductivityWidget(service: string | undefined): Promise<ProductivityWidgetResponse>;
    /**
     * @return Success
     */
    getUserEngagementWidget(): Promise<ActiveUsersByServiceWidgetResponse>;
    /**
     * @param type (optional) 
     * @return Success
     */
    getLicenseBreakdownWidget(type: string | undefined): Promise<ActiveUsersByServiceWidgetResponse>;
}

export class MicrosoftAdoptionWidgetsClient extends AuthorizedApiBase implements IMicrosoftAdoptionWidgetsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param dateOption (optional) 
     * @return Success
     */
    getActiveUsersByServiceWidget(dateOption: string | undefined, cancelToken?: CancelToken): Promise<ActiveUsersByServiceWidgetResponse> {
        let url_ = this.baseUrl + "/api/widgets/microsoft-adoption/active-users-by-service-widget?";
        if (dateOption === null)
            throw new Error("The parameter 'dateOption' cannot be null.");
        else if (dateOption !== undefined)
            url_ += "dateOption=" + encodeURIComponent("" + dateOption) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActiveUsersByServiceWidget(_response);
        });
    }

    protected processGetActiveUsersByServiceWidget(response: AxiosResponse): Promise<ActiveUsersByServiceWidgetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ActiveUsersByServiceWidgetResponse.fromJS(resultData200);
            return Promise.resolve<ActiveUsersByServiceWidgetResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActiveUsersByServiceWidgetResponse>(null as any);
    }

    /**
     * @param frequency (optional) 
     * @return Success
     */
    getActiveUserTrendsWidget(frequency: string | undefined, cancelToken?: CancelToken): Promise<ActiveUserTrendsWidgetResponse> {
        let url_ = this.baseUrl + "/api/widgets/microsoft-adoption/active-user-trends-widget?";
        if (frequency === null)
            throw new Error("The parameter 'frequency' cannot be null.");
        else if (frequency !== undefined)
            url_ += "frequency=" + encodeURIComponent("" + frequency) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActiveUserTrendsWidget(_response);
        });
    }

    protected processGetActiveUserTrendsWidget(response: AxiosResponse): Promise<ActiveUserTrendsWidgetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ActiveUserTrendsWidgetResponse.fromJS(resultData200);
            return Promise.resolve<ActiveUserTrendsWidgetResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActiveUserTrendsWidgetResponse>(null as any);
    }

    /**
     * @param service (optional) 
     * @return Success
     */
    getFeatureAdoptionWidget(service: string | undefined, cancelToken?: CancelToken): Promise<FeatureAdoptionWidgetResponse> {
        let url_ = this.baseUrl + "/api/widgets/microsoft-adoption/feature-adoption-widget?";
        if (service === null)
            throw new Error("The parameter 'service' cannot be null.");
        else if (service !== undefined)
            url_ += "service=" + encodeURIComponent("" + service) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFeatureAdoptionWidget(_response);
        });
    }

    protected processGetFeatureAdoptionWidget(response: AxiosResponse): Promise<FeatureAdoptionWidgetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FeatureAdoptionWidgetResponse.fromJS(resultData200);
            return Promise.resolve<FeatureAdoptionWidgetResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FeatureAdoptionWidgetResponse>(null as any);
    }

    /**
     * @return Success
     */
    getLicenseUtilizationWidget( cancelToken?: CancelToken): Promise<LicenseUtilizationWidgetResponse> {
        let url_ = this.baseUrl + "/api/widgets/microsoft-adoption/license-utilization-widget";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLicenseUtilizationWidget(_response);
        });
    }

    protected processGetLicenseUtilizationWidget(response: AxiosResponse): Promise<LicenseUtilizationWidgetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LicenseUtilizationWidgetResponse.fromJS(resultData200);
            return Promise.resolve<LicenseUtilizationWidgetResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LicenseUtilizationWidgetResponse>(null as any);
    }

    /**
     * @param service (optional) 
     * @return Success
     */
    getProductivityWidget(service: string | undefined, cancelToken?: CancelToken): Promise<ProductivityWidgetResponse> {
        let url_ = this.baseUrl + "/api/widgets/microsoft-adoption/productivity-widget?";
        if (service === null)
            throw new Error("The parameter 'service' cannot be null.");
        else if (service !== undefined)
            url_ += "service=" + encodeURIComponent("" + service) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductivityWidget(_response);
        });
    }

    protected processGetProductivityWidget(response: AxiosResponse): Promise<ProductivityWidgetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductivityWidgetResponse.fromJS(resultData200);
            return Promise.resolve<ProductivityWidgetResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductivityWidgetResponse>(null as any);
    }

    /**
     * @return Success
     */
    getUserEngagementWidget( cancelToken?: CancelToken): Promise<ActiveUsersByServiceWidgetResponse> {
        let url_ = this.baseUrl + "/api/widgets/microsoft-adoption/user-engagement-widget";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserEngagementWidget(_response);
        });
    }

    protected processGetUserEngagementWidget(response: AxiosResponse): Promise<ActiveUsersByServiceWidgetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ActiveUsersByServiceWidgetResponse.fromJS(resultData200);
            return Promise.resolve<ActiveUsersByServiceWidgetResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActiveUsersByServiceWidgetResponse>(null as any);
    }

    /**
     * @param type (optional) 
     * @return Success
     */
    getLicenseBreakdownWidget(type: string | undefined, cancelToken?: CancelToken): Promise<ActiveUsersByServiceWidgetResponse> {
        let url_ = this.baseUrl + "/api/widgets/microsoft-adoption/license-breakdown-widget?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLicenseBreakdownWidget(_response);
        });
    }

    protected processGetLicenseBreakdownWidget(response: AxiosResponse): Promise<ActiveUsersByServiceWidgetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ActiveUsersByServiceWidgetResponse.fromJS(resultData200);
            return Promise.resolve<ActiveUsersByServiceWidgetResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActiveUsersByServiceWidgetResponse>(null as any);
    }
}

export interface INewsCenterClient {
    /**
     * @param articleId (optional) 
     * @return Success
     */
    getNewsCenterDetail(articleId: number | undefined): Promise<ArticleDetailDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getNewsCenter(body: NewsCenterQuery | undefined): Promise<NewsCenterArticlesResponse>;
}

export class NewsCenterClient extends AuthorizedApiBase implements INewsCenterClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param articleId (optional) 
     * @return Success
     */
    getNewsCenterDetail(articleId: number | undefined, cancelToken?: CancelToken): Promise<ArticleDetailDto> {
        let url_ = this.baseUrl + "/api/NewsCenter/newscenter/detail?";
        if (articleId === null)
            throw new Error("The parameter 'articleId' cannot be null.");
        else if (articleId !== undefined)
            url_ += "articleId=" + encodeURIComponent("" + articleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNewsCenterDetail(_response);
        });
    }

    protected processGetNewsCenterDetail(response: AxiosResponse): Promise<ArticleDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ArticleDetailDto.fromJS(resultData200);
            return Promise.resolve<ArticleDetailDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleDetailDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getNewsCenter(body: NewsCenterQuery | undefined, cancelToken?: CancelToken): Promise<NewsCenterArticlesResponse> {
        let url_ = this.baseUrl + "/api/NewsCenter/newscenter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNewsCenter(_response);
        });
    }

    protected processGetNewsCenter(response: AxiosResponse): Promise<NewsCenterArticlesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NewsCenterArticlesResponse.fromJS(resultData200);
            return Promise.resolve<NewsCenterArticlesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NewsCenterArticlesResponse>(null as any);
    }
}

export interface IOnboardingClient {
    /**
     * @return Success
     */
    getWelcomeInformation(guid: string): Promise<AccountWelcomeLinkDto>;
    /**
     * @return Success
     */
    getOnboardingStatus(guid: string): Promise<OnboardingStatus>;
    /**
     * @param body (optional) 
     * @return Success
     */
    generateEmailCode(body: EmailVerificationRequest | undefined): Promise<ValidateEmailStatus>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateWelcomeOptions(body: AccountWelcomeLinkDto | undefined): Promise<AccountWelcomeLinkDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    verifyEmailCode(body: EmailVerificationRequest | undefined): Promise<ValidateEmailStatus>;
    /**
     * @param body (optional) 
     * @return Success
     */
    submitOnboardingAdmins(body: OnboardingStatus | undefined): Promise<OnboardingStatus>;
}

export class OnboardingClient extends AuthorizedApiBase implements IOnboardingClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getWelcomeInformation(guid: string, cancelToken?: CancelToken): Promise<AccountWelcomeLinkDto> {
        let url_ = this.baseUrl + "/api/onboarding/welcome/{guid}";
        if (guid === undefined || guid === null)
            throw new Error("The parameter 'guid' must be defined.");
        url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWelcomeInformation(_response);
        });
    }

    protected processGetWelcomeInformation(response: AxiosResponse): Promise<AccountWelcomeLinkDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountWelcomeLinkDto.fromJS(resultData200);
            return Promise.resolve<AccountWelcomeLinkDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountWelcomeLinkDto>(null as any);
    }

    /**
     * @return Success
     */
    getOnboardingStatus(guid: string, cancelToken?: CancelToken): Promise<OnboardingStatus> {
        let url_ = this.baseUrl + "/api/onboarding/status/{guid}";
        if (guid === undefined || guid === null)
            throw new Error("The parameter 'guid' must be defined.");
        url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOnboardingStatus(_response);
        });
    }

    protected processGetOnboardingStatus(response: AxiosResponse): Promise<OnboardingStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OnboardingStatus.fromJS(resultData200);
            return Promise.resolve<OnboardingStatus>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OnboardingStatus>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generateEmailCode(body: EmailVerificationRequest | undefined, cancelToken?: CancelToken): Promise<ValidateEmailStatus> {
        let url_ = this.baseUrl + "/api/onboarding/generateCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateEmailCode(_response);
        });
    }

    protected processGenerateEmailCode(response: AxiosResponse): Promise<ValidateEmailStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ValidateEmailStatus.fromJS(resultData200);
            return Promise.resolve<ValidateEmailStatus>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidateEmailStatus>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateWelcomeOptions(body: AccountWelcomeLinkDto | undefined, cancelToken?: CancelToken): Promise<AccountWelcomeLinkDto> {
        let url_ = this.baseUrl + "/api/onboarding/updateWelcomeOptions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateWelcomeOptions(_response);
        });
    }

    protected processUpdateWelcomeOptions(response: AxiosResponse): Promise<AccountWelcomeLinkDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountWelcomeLinkDto.fromJS(resultData200);
            return Promise.resolve<AccountWelcomeLinkDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountWelcomeLinkDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    verifyEmailCode(body: EmailVerificationRequest | undefined, cancelToken?: CancelToken): Promise<ValidateEmailStatus> {
        let url_ = this.baseUrl + "/api/onboarding/verifyCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerifyEmailCode(_response);
        });
    }

    protected processVerifyEmailCode(response: AxiosResponse): Promise<ValidateEmailStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ValidateEmailStatus.fromJS(resultData200);
            return Promise.resolve<ValidateEmailStatus>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidateEmailStatus>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    submitOnboardingAdmins(body: OnboardingStatus | undefined, cancelToken?: CancelToken): Promise<OnboardingStatus> {
        let url_ = this.baseUrl + "/api/onboarding/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitOnboardingAdmins(_response);
        });
    }

    protected processSubmitOnboardingAdmins(response: AxiosResponse): Promise<OnboardingStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OnboardingStatus.fromJS(resultData200);
            return Promise.resolve<OnboardingStatus>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OnboardingStatus>(null as any);
    }
}

export interface IPageLayoutClient {
    /**
     * @return Success
     */
    getPageLayout(pageLayoutId: string): Promise<PageLayoutDto>;
}

export class PageLayoutClient extends AuthorizedApiBase implements IPageLayoutClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getPageLayout(pageLayoutId: string, cancelToken?: CancelToken): Promise<PageLayoutDto> {
        let url_ = this.baseUrl + "/api/pagelayout/{pageLayoutId}";
        if (pageLayoutId === undefined || pageLayoutId === null)
            throw new Error("The parameter 'pageLayoutId' must be defined.");
        url_ = url_.replace("{pageLayoutId}", encodeURIComponent("" + pageLayoutId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPageLayout(_response);
        });
    }

    protected processGetPageLayout(response: AxiosResponse): Promise<PageLayoutDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PageLayoutDto.fromJS(resultData200);
            return Promise.resolve<PageLayoutDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageLayoutDto>(null as any);
    }
}

export interface IPingClient {
    /**
     * @return Success
     */
    getPing(): Promise<void>;
    /**
     * @return Success
     */
    headPing(): Promise<void>;
}

export class PingClient extends AuthorizedApiBase implements IPingClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getPing( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPing(_response);
        });
    }

    protected processGetPing(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    headPing( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "HEAD",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHeadPing(_response);
        });
    }

    protected processHeadPing(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IProjectClient {
    /**
     * @return Success
     */
    getProjectList(): Promise<ProjectListResponse>;
    /**
     * @return Success
     */
    getProjectById(id: number): Promise<ProjectIndividualResponse>;
    /**
     * @return Success
     */
    getProjectsByYourUser(): Promise<ProjectCacheResponse>;
    /**
     * @return Success
     */
    getActiveProjectsByAccount(): Promise<ProjectWidgetItemDto[]>;
}

export class ProjectClient extends AuthorizedApiBase implements IProjectClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getProjectList( cancelToken?: CancelToken): Promise<ProjectListResponse> {
        let url_ = this.baseUrl + "/api/Project/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectList(_response);
        });
    }

    protected processGetProjectList(response: AxiosResponse): Promise<ProjectListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProjectListResponse.fromJS(resultData200);
            return Promise.resolve<ProjectListResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectListResponse>(null as any);
    }

    /**
     * @return Success
     */
    getProjectById(id: number, cancelToken?: CancelToken): Promise<ProjectIndividualResponse> {
        let url_ = this.baseUrl + "/api/Project/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectById(_response);
        });
    }

    protected processGetProjectById(response: AxiosResponse): Promise<ProjectIndividualResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProjectIndividualResponse.fromJS(resultData200);
            return Promise.resolve<ProjectIndividualResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectIndividualResponse>(null as any);
    }

    /**
     * @return Success
     */
    getProjectsByYourUser( cancelToken?: CancelToken): Promise<ProjectCacheResponse> {
        let url_ = this.baseUrl + "/api/Project";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectsByYourUser(_response);
        });
    }

    protected processGetProjectsByYourUser(response: AxiosResponse): Promise<ProjectCacheResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProjectCacheResponse.fromJS(resultData200);
            return Promise.resolve<ProjectCacheResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectCacheResponse>(null as any);
    }

    /**
     * @return Success
     */
    getActiveProjectsByAccount( cancelToken?: CancelToken): Promise<ProjectWidgetItemDto[]> {
        let url_ = this.baseUrl + "/api/Project/active-projects-widget";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActiveProjectsByAccount(_response);
        });
    }

    protected processGetActiveProjectsByAccount(response: AxiosResponse): Promise<ProjectWidgetItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectWidgetItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProjectWidgetItemDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectWidgetItemDto[]>(null as any);
    }
}

export interface IProjectInvoiceClient {
    /**
     * @return Success
     */
    getProjectInvoices(): Promise<AXProjectInvoicesResponse>;
}

export class ProjectInvoiceClient extends AuthorizedApiBase implements IProjectInvoiceClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getProjectInvoices( cancelToken?: CancelToken): Promise<AXProjectInvoicesResponse> {
        let url_ = this.baseUrl + "/api/projectinvoice";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectInvoices(_response);
        });
    }

    protected processGetProjectInvoices(response: AxiosResponse): Promise<AXProjectInvoicesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AXProjectInvoicesResponse.fromJS(resultData200);
            return Promise.resolve<AXProjectInvoicesResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AXProjectInvoicesResponse>(null as any);
    }
}

export interface IRegistrationsClient {
    /**
     * @return Success
     */
    getRegistrationRules(ruleName: string): Promise<MyExternalUserNotificationSettingsResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    registerRule(body: RuleDto | undefined): Promise<FeatureRulesDto[]>;
}

export class RegistrationsClient extends AuthorizedApiBase implements IRegistrationsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getRegistrationRules(ruleName: string, cancelToken?: CancelToken): Promise<MyExternalUserNotificationSettingsResponse> {
        let url_ = this.baseUrl + "/api/notifications/GetRulesAndRegisterUser/{ruleName}";
        if (ruleName === undefined || ruleName === null)
            throw new Error("The parameter 'ruleName' must be defined.");
        url_ = url_.replace("{ruleName}", encodeURIComponent("" + ruleName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRegistrationRules(_response);
        });
    }

    protected processGetRegistrationRules(response: AxiosResponse): Promise<MyExternalUserNotificationSettingsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MyExternalUserNotificationSettingsResponse.fromJS(resultData200);
            return Promise.resolve<MyExternalUserNotificationSettingsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MyExternalUserNotificationSettingsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    registerRule(body: RuleDto | undefined, cancelToken?: CancelToken): Promise<FeatureRulesDto[]> {
        let url_ = this.baseUrl + "/api/notifications/RegisterRule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegisterRule(_response);
        });
    }

    protected processRegisterRule(response: AxiosResponse): Promise<FeatureRulesDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FeatureRulesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<FeatureRulesDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FeatureRulesDto[]>(null as any);
    }
}

export interface IReportClient {
    /**
     * Retrieves the EmbedParams of the specified report
     * @param reportKey The unique key of a report
     * @param filter (optional) An optional report filter
     * @return Success
     */
    getEmbedParams(reportKey: string, filter: string | undefined): Promise<EmbedParams>;
    /**
     * @param filter (optional) 
     * @return Success
     */
    getNewAccessToken(reportKey: string, filter: string | undefined): Promise<EmbedToken>;
}

export class ReportClient extends AuthorizedApiBase implements IReportClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Retrieves the EmbedParams of the specified report
     * @param reportKey The unique key of a report
     * @param filter (optional) An optional report filter
     * @return Success
     */
    getEmbedParams(reportKey: string, filter: string | undefined, cancelToken?: CancelToken): Promise<EmbedParams> {
        let url_ = this.baseUrl + "/api/Report/{reportKey}?";
        if (reportKey === undefined || reportKey === null)
            throw new Error("The parameter 'reportKey' must be defined.");
        url_ = url_.replace("{reportKey}", encodeURIComponent("" + reportKey));
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmbedParams(_response);
        });
    }

    protected processGetEmbedParams(response: AxiosResponse): Promise<EmbedParams> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmbedParams.fromJS(resultData200);
            return Promise.resolve<EmbedParams>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmbedParams>(null as any);
    }

    /**
     * @param filter (optional) 
     * @return Success
     */
    getNewAccessToken(reportKey: string, filter: string | undefined, cancelToken?: CancelToken): Promise<EmbedToken> {
        let url_ = this.baseUrl + "/api/Report/{reportKey}?";
        if (reportKey === undefined || reportKey === null)
            throw new Error("The parameter 'reportKey' must be defined.");
        url_ = url_.replace("{reportKey}", encodeURIComponent("" + reportKey));
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNewAccessToken(_response);
        });
    }

    protected processGetNewAccessToken(response: AxiosResponse): Promise<EmbedToken> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmbedToken.fromJS(resultData200);
            return Promise.resolve<EmbedToken>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmbedToken>(null as any);
    }
}

export interface IReportCenterClient {
    /**
     * @param body (optional) 
     * @return Success
     */
    getCiscoIbaProducts(body: CiscoIbaSearchRequestDto | undefined): Promise<CiscoIbaProductResponse>;
    /**
     * @return Success
     */
    getCiscoIbaPicklist(): Promise<CiscoIbaPicklistResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getSmartNetSlasWidget(body: SmartNetSlasWidgetRequestDto | undefined): Promise<SmartNetSlasWidgetResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getCiscoGuidsWidget(body: GuidsWidgetRequestDto | undefined): Promise<GuidsWidgetResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getCiscoIbaLocationData(body: CiscoIbaSearchRequestDto | undefined): Promise<CiscoIbaLocationResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getCiscoIbaShippedHardware(body: CiscoIbaShippedHardwareRequestDto | undefined): Promise<CiscoIbaShippedHardwareResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getCiscoIbaBaseInsightsData(body: CiscoIbaSearchRequestDto | undefined): Promise<CiscoIbaBaseInsightsResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getCiscoExpiringAssetsData(body: CiscoIbaSearchRequestDto | undefined): Promise<CiscoIbaExpiringAssetsResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getCiscoIbaAssets(body: CiscoIbaAssetsSearchRequestDto | undefined): Promise<CiscoIbaAssetsSearchResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getCiscoIbaLdos(body: CiscoIbaLdosRequestDto | undefined): Promise<CiscoIbaLdosResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getCiscoIbaAssetsArchitectureLdos(body: CiscoIbaAssetsArchitectureLdosRequestDto | undefined): Promise<CiscoIbaAssetsArchitectureLdosResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    downloadCiscoIbaProductTable(body: CiscoIbaTableDownloadRequestDto | undefined): Promise<FileDownloadResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    downloadCiscoIbaLocationTable(body: CiscoIbaTableDownloadRequestDto | undefined): Promise<FileDownloadResponse>;
}

export class ReportCenterClient extends AuthorizedApiBase implements IReportCenterClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCiscoIbaProducts(body: CiscoIbaSearchRequestDto | undefined, cancelToken?: CancelToken): Promise<CiscoIbaProductResponse> {
        let url_ = this.baseUrl + "/api/ReportCenter/cisco-iba/products";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCiscoIbaProducts(_response);
        });
    }

    protected processGetCiscoIbaProducts(response: AxiosResponse): Promise<CiscoIbaProductResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CiscoIbaProductResponse.fromJS(resultData200);
            return Promise.resolve<CiscoIbaProductResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CiscoIbaProductResponse>(null as any);
    }

    /**
     * @return Success
     */
    getCiscoIbaPicklist( cancelToken?: CancelToken): Promise<CiscoIbaPicklistResponse> {
        let url_ = this.baseUrl + "/api/ReportCenter/cisco-iba-picklist";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCiscoIbaPicklist(_response);
        });
    }

    protected processGetCiscoIbaPicklist(response: AxiosResponse): Promise<CiscoIbaPicklistResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CiscoIbaPicklistResponse.fromJS(resultData200);
            return Promise.resolve<CiscoIbaPicklistResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CiscoIbaPicklistResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getSmartNetSlasWidget(body: SmartNetSlasWidgetRequestDto | undefined, cancelToken?: CancelToken): Promise<SmartNetSlasWidgetResponse> {
        let url_ = this.baseUrl + "/api/ReportCenter/cisco-iba/smart-net-slas-widget";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSmartNetSlasWidget(_response);
        });
    }

    protected processGetSmartNetSlasWidget(response: AxiosResponse): Promise<SmartNetSlasWidgetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SmartNetSlasWidgetResponse.fromJS(resultData200);
            return Promise.resolve<SmartNetSlasWidgetResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SmartNetSlasWidgetResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCiscoGuidsWidget(body: GuidsWidgetRequestDto | undefined, cancelToken?: CancelToken): Promise<GuidsWidgetResponse> {
        let url_ = this.baseUrl + "/api/ReportCenter/cisco-iba/guids-widget";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCiscoGuidsWidget(_response);
        });
    }

    protected processGetCiscoGuidsWidget(response: AxiosResponse): Promise<GuidsWidgetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GuidsWidgetResponse.fromJS(resultData200);
            return Promise.resolve<GuidsWidgetResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GuidsWidgetResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCiscoIbaLocationData(body: CiscoIbaSearchRequestDto | undefined, cancelToken?: CancelToken): Promise<CiscoIbaLocationResponse> {
        let url_ = this.baseUrl + "/api/ReportCenter/cisco-iba/locations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCiscoIbaLocationData(_response);
        });
    }

    protected processGetCiscoIbaLocationData(response: AxiosResponse): Promise<CiscoIbaLocationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CiscoIbaLocationResponse.fromJS(resultData200);
            return Promise.resolve<CiscoIbaLocationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CiscoIbaLocationResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCiscoIbaShippedHardware(body: CiscoIbaShippedHardwareRequestDto | undefined, cancelToken?: CancelToken): Promise<CiscoIbaShippedHardwareResponse> {
        let url_ = this.baseUrl + "/api/ReportCenter/cisco-iba/shipped-hardware";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCiscoIbaShippedHardware(_response);
        });
    }

    protected processGetCiscoIbaShippedHardware(response: AxiosResponse): Promise<CiscoIbaShippedHardwareResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CiscoIbaShippedHardwareResponse.fromJS(resultData200);
            return Promise.resolve<CiscoIbaShippedHardwareResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CiscoIbaShippedHardwareResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCiscoIbaBaseInsightsData(body: CiscoIbaSearchRequestDto | undefined, cancelToken?: CancelToken): Promise<CiscoIbaBaseInsightsResponse> {
        let url_ = this.baseUrl + "/api/ReportCenter/cisco-iba/base-insights";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCiscoIbaBaseInsightsData(_response);
        });
    }

    protected processGetCiscoIbaBaseInsightsData(response: AxiosResponse): Promise<CiscoIbaBaseInsightsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CiscoIbaBaseInsightsResponse.fromJS(resultData200);
            return Promise.resolve<CiscoIbaBaseInsightsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CiscoIbaBaseInsightsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCiscoExpiringAssetsData(body: CiscoIbaSearchRequestDto | undefined, cancelToken?: CancelToken): Promise<CiscoIbaExpiringAssetsResponse> {
        let url_ = this.baseUrl + "/api/ReportCenter/cisco-iba/expiring-assets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCiscoExpiringAssetsData(_response);
        });
    }

    protected processGetCiscoExpiringAssetsData(response: AxiosResponse): Promise<CiscoIbaExpiringAssetsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CiscoIbaExpiringAssetsResponse.fromJS(resultData200);
            return Promise.resolve<CiscoIbaExpiringAssetsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CiscoIbaExpiringAssetsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCiscoIbaAssets(body: CiscoIbaAssetsSearchRequestDto | undefined, cancelToken?: CancelToken): Promise<CiscoIbaAssetsSearchResponse> {
        let url_ = this.baseUrl + "/api/ReportCenter/cisco-iba/assets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCiscoIbaAssets(_response);
        });
    }

    protected processGetCiscoIbaAssets(response: AxiosResponse): Promise<CiscoIbaAssetsSearchResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CiscoIbaAssetsSearchResponse.fromJS(resultData200);
            return Promise.resolve<CiscoIbaAssetsSearchResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CiscoIbaAssetsSearchResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCiscoIbaLdos(body: CiscoIbaLdosRequestDto | undefined, cancelToken?: CancelToken): Promise<CiscoIbaLdosResponse> {
        let url_ = this.baseUrl + "/api/ReportCenter/cisco-iba/ldos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCiscoIbaLdos(_response);
        });
    }

    protected processGetCiscoIbaLdos(response: AxiosResponse): Promise<CiscoIbaLdosResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CiscoIbaLdosResponse.fromJS(resultData200);
            return Promise.resolve<CiscoIbaLdosResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CiscoIbaLdosResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCiscoIbaAssetsArchitectureLdos(body: CiscoIbaAssetsArchitectureLdosRequestDto | undefined, cancelToken?: CancelToken): Promise<CiscoIbaAssetsArchitectureLdosResponse> {
        let url_ = this.baseUrl + "/api/ReportCenter/cisco-iba/assets-architecture-ldos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCiscoIbaAssetsArchitectureLdos(_response);
        });
    }

    protected processGetCiscoIbaAssetsArchitectureLdos(response: AxiosResponse): Promise<CiscoIbaAssetsArchitectureLdosResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CiscoIbaAssetsArchitectureLdosResponse.fromJS(resultData200);
            return Promise.resolve<CiscoIbaAssetsArchitectureLdosResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CiscoIbaAssetsArchitectureLdosResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    downloadCiscoIbaProductTable(body: CiscoIbaTableDownloadRequestDto | undefined, cancelToken?: CancelToken): Promise<FileDownloadResponse> {
        let url_ = this.baseUrl + "/api/ReportCenter/cisco-iba/product-table-download";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadCiscoIbaProductTable(_response);
        });
    }

    protected processDownloadCiscoIbaProductTable(response: AxiosResponse): Promise<FileDownloadResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDownloadResponse.fromJS(resultData200);
            return Promise.resolve<FileDownloadResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDownloadResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    downloadCiscoIbaLocationTable(body: CiscoIbaTableDownloadRequestDto | undefined, cancelToken?: CancelToken): Promise<FileDownloadResponse> {
        let url_ = this.baseUrl + "/api/ReportCenter/cisco-iba/location-table-download";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadCiscoIbaLocationTable(_response);
        });
    }

    protected processDownloadCiscoIbaLocationTable(response: AxiosResponse): Promise<FileDownloadResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDownloadResponse.fromJS(resultData200);
            return Promise.resolve<FileDownloadResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDownloadResponse>(null as any);
    }
}

export interface IRequestConsultationClient {
    /**
     * @return Success
     */
    createRequestConsultation(applicationContext: string): Promise<boolean>;
}

export class RequestConsultationClient extends AuthorizedApiBase implements IRequestConsultationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    createRequestConsultation(applicationContext: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/RequestConsultation/create-request-consultation/{applicationContext}";
        if (applicationContext === undefined || applicationContext === null)
            throw new Error("The parameter 'applicationContext' must be defined.");
        url_ = url_.replace("{applicationContext}", encodeURIComponent("" + applicationContext));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRequestConsultation(_response);
        });
    }

    protected processCreateRequestConsultation(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IRequesterRankingsWidgetClient {
    /**
     * @param dateFilterOption (optional) 
     * @return Success
     */
    getRequesterRankings(dateFilterOption: DateFilterOption | undefined): Promise<WidgetContentResponseDto_1OfRequesterRankingsVisualsDto>;
}

export class RequesterRankingsWidgetClient extends AuthorizedApiBase implements IRequesterRankingsWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param dateFilterOption (optional) 
     * @return Success
     */
    getRequesterRankings(dateFilterOption: DateFilterOption | undefined, cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfRequesterRankingsVisualsDto> {
        let url_ = this.baseUrl + "/api/widget/requestor-rankings-widget?";
        if (dateFilterOption === null)
            throw new Error("The parameter 'dateFilterOption' cannot be null.");
        else if (dateFilterOption !== undefined)
            url_ += "dateFilterOption=" + encodeURIComponent("" + dateFilterOption) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRequesterRankings(_response);
        });
    }

    protected processGetRequesterRankings(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfRequesterRankingsVisualsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfRequesterRankingsVisualsDto.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfRequesterRankingsVisualsDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfRequesterRankingsVisualsDto>(null as any);
    }
}

export interface IRequestsMetricsWidgetClient {
    /**
     * @param dateFilterOption (optional) 
     * @return Success
     */
    getRequestMetrics(dateFilterOption: DateFilterOption | undefined): Promise<WidgetContentResponseDto_1OfRequestMetricsVisualsDto>;
}

export class RequestsMetricsWidgetClient extends AuthorizedApiBase implements IRequestsMetricsWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param dateFilterOption (optional) 
     * @return Success
     */
    getRequestMetrics(dateFilterOption: DateFilterOption | undefined, cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfRequestMetricsVisualsDto> {
        let url_ = this.baseUrl + "/api/widget/requests-metrics-widget?";
        if (dateFilterOption === null)
            throw new Error("The parameter 'dateFilterOption' cannot be null.");
        else if (dateFilterOption !== undefined)
            url_ += "dateFilterOption=" + encodeURIComponent("" + dateFilterOption) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRequestMetrics(_response);
        });
    }

    protected processGetRequestMetrics(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfRequestMetricsVisualsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfRequestMetricsVisualsDto.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfRequestMetricsVisualsDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfRequestMetricsVisualsDto>(null as any);
    }
}

export interface IRoadmapsClient {
    /**
     * @return Success
     */
    getRoadmaps(): Promise<GetRoadmapsByCustomerResponse>;
    /**
     * @return Success
     */
    getRoadmap(roadmapId: string): Promise<GetRoadmapByIdResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    createRoadmap(body: RoadmapDto | undefined): Promise<CreateRoadmapResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateRoadmap(body: RoadmapDto | undefined): Promise<UpdateRoadmapResponse>;
    /**
     * @return Success
     */
    deleteRoadmap(roadmapId: string): Promise<DeleteRoadmapResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    createRoadmapItem(body: RoadmapItemDto | undefined): Promise<CreateRoadmapItemResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateRoadmapItem(body: RoadmapItemDto | undefined): Promise<UpdateRoadmapItemResponse>;
    /**
     * @return Success
     */
    deleteRoadmapItem(roadmapItemId: string): Promise<DeleteRoadmapItemResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    checkSourceLinks(body: string[] | undefined): Promise<CheckSourceIdsRoadmapLinkResponse>;
}

export class RoadmapsClient extends AuthorizedApiBase implements IRoadmapsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getRoadmaps( cancelToken?: CancelToken): Promise<GetRoadmapsByCustomerResponse> {
        let url_ = this.baseUrl + "/api/Roadmaps";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRoadmaps(_response);
        });
    }

    protected processGetRoadmaps(response: AxiosResponse): Promise<GetRoadmapsByCustomerResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRoadmapsByCustomerResponse.fromJS(resultData200);
            return Promise.resolve<GetRoadmapsByCustomerResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRoadmapsByCustomerResponse>(null as any);
    }

    /**
     * @return Success
     */
    getRoadmap(roadmapId: string, cancelToken?: CancelToken): Promise<GetRoadmapByIdResponse> {
        let url_ = this.baseUrl + "/api/Roadmaps/{roadmapId}";
        if (roadmapId === undefined || roadmapId === null)
            throw new Error("The parameter 'roadmapId' must be defined.");
        url_ = url_.replace("{roadmapId}", encodeURIComponent("" + roadmapId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRoadmap(_response);
        });
    }

    protected processGetRoadmap(response: AxiosResponse): Promise<GetRoadmapByIdResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRoadmapByIdResponse.fromJS(resultData200);
            return Promise.resolve<GetRoadmapByIdResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRoadmapByIdResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createRoadmap(body: RoadmapDto | undefined, cancelToken?: CancelToken): Promise<CreateRoadmapResponse> {
        let url_ = this.baseUrl + "/api/Roadmaps/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRoadmap(_response);
        });
    }

    protected processCreateRoadmap(response: AxiosResponse): Promise<CreateRoadmapResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateRoadmapResponse.fromJS(resultData200);
            return Promise.resolve<CreateRoadmapResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateRoadmapResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateRoadmap(body: RoadmapDto | undefined, cancelToken?: CancelToken): Promise<UpdateRoadmapResponse> {
        let url_ = this.baseUrl + "/api/Roadmaps/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRoadmap(_response);
        });
    }

    protected processUpdateRoadmap(response: AxiosResponse): Promise<UpdateRoadmapResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateRoadmapResponse.fromJS(resultData200);
            return Promise.resolve<UpdateRoadmapResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateRoadmapResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteRoadmap(roadmapId: string, cancelToken?: CancelToken): Promise<DeleteRoadmapResponse> {
        let url_ = this.baseUrl + "/api/Roadmaps/delete/{roadmapId}";
        if (roadmapId === undefined || roadmapId === null)
            throw new Error("The parameter 'roadmapId' must be defined.");
        url_ = url_.replace("{roadmapId}", encodeURIComponent("" + roadmapId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRoadmap(_response);
        });
    }

    protected processDeleteRoadmap(response: AxiosResponse): Promise<DeleteRoadmapResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteRoadmapResponse.fromJS(resultData200);
            return Promise.resolve<DeleteRoadmapResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteRoadmapResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createRoadmapItem(body: RoadmapItemDto | undefined, cancelToken?: CancelToken): Promise<CreateRoadmapItemResponse> {
        let url_ = this.baseUrl + "/api/Roadmaps/roadmap-item/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRoadmapItem(_response);
        });
    }

    protected processCreateRoadmapItem(response: AxiosResponse): Promise<CreateRoadmapItemResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateRoadmapItemResponse.fromJS(resultData200);
            return Promise.resolve<CreateRoadmapItemResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateRoadmapItemResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateRoadmapItem(body: RoadmapItemDto | undefined, cancelToken?: CancelToken): Promise<UpdateRoadmapItemResponse> {
        let url_ = this.baseUrl + "/api/Roadmaps/roadmap-item/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRoadmapItem(_response);
        });
    }

    protected processUpdateRoadmapItem(response: AxiosResponse): Promise<UpdateRoadmapItemResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateRoadmapItemResponse.fromJS(resultData200);
            return Promise.resolve<UpdateRoadmapItemResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateRoadmapItemResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteRoadmapItem(roadmapItemId: string, cancelToken?: CancelToken): Promise<DeleteRoadmapItemResponse> {
        let url_ = this.baseUrl + "/api/Roadmaps/roadmap-item/delete/{roadmapItemId}";
        if (roadmapItemId === undefined || roadmapItemId === null)
            throw new Error("The parameter 'roadmapItemId' must be defined.");
        url_ = url_.replace("{roadmapItemId}", encodeURIComponent("" + roadmapItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRoadmapItem(_response);
        });
    }

    protected processDeleteRoadmapItem(response: AxiosResponse): Promise<DeleteRoadmapItemResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteRoadmapItemResponse.fromJS(resultData200);
            return Promise.resolve<DeleteRoadmapItemResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteRoadmapItemResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkSourceLinks(body: string[] | undefined, cancelToken?: CancelToken): Promise<CheckSourceIdsRoadmapLinkResponse> {
        let url_ = this.baseUrl + "/api/Roadmaps/check-source-links";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckSourceLinks(_response);
        });
    }

    protected processCheckSourceLinks(response: AxiosResponse): Promise<CheckSourceIdsRoadmapLinkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CheckSourceIdsRoadmapLinkResponse.fromJS(resultData200);
            return Promise.resolve<CheckSourceIdsRoadmapLinkResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckSourceIdsRoadmapLinkResponse>(null as any);
    }
}

export interface ISampleEmptyWidgetClient {
    /**
     * @return Success
     */
    getSampleEmptyWidget(): Promise<WidgetContentResponseDto_1OfPieChartDto>;
}

export class SampleEmptyWidgetClient extends AuthorizedApiBase implements ISampleEmptyWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getSampleEmptyWidget( cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfPieChartDto> {
        let url_ = this.baseUrl + "/api/widget/sample-empty-widget";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSampleEmptyWidget(_response);
        });
    }

    protected processGetSampleEmptyWidget(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfPieChartDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfPieChartDto.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfPieChartDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfPieChartDto>(null as any);
    }
}

export interface ISampleErrorWidgetClient {
    /**
     * @return Success
     */
    getSampleErrorWidget(): Promise<WidgetContentResponseDto_1OfPieChartDto>;
}

export class SampleErrorWidgetClient extends AuthorizedApiBase implements ISampleErrorWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getSampleErrorWidget( cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfPieChartDto> {
        let url_ = this.baseUrl + "/api/widget/sample-error-widget";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSampleErrorWidget(_response);
        });
    }

    protected processGetSampleErrorWidget(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfPieChartDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfPieChartDto.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfPieChartDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfPieChartDto>(null as any);
    }
}

export interface ISamplesClient {
    /**
     * @return Success
     */
    testGetResponse(): Promise<TestConsumerResult>;
    /**
     * @return Success
     */
    testPublish(): Promise<TestConsumerResult>;
    /**
     * @return Success
     */
    getNestedData(): Promise<TestNestedDataResultDto>;
}

export class SamplesClient extends AuthorizedApiBase implements ISamplesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    testGetResponse( cancelToken?: CancelToken): Promise<TestConsumerResult> {
        let url_ = this.baseUrl + "/api/samples/testGetResponse";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestGetResponse(_response);
        });
    }

    protected processTestGetResponse(response: AxiosResponse): Promise<TestConsumerResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TestConsumerResult.fromJS(resultData200);
            return Promise.resolve<TestConsumerResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TestConsumerResult>(null as any);
    }

    /**
     * @return Success
     */
    testPublish( cancelToken?: CancelToken): Promise<TestConsumerResult> {
        let url_ = this.baseUrl + "/api/samples/testPublish";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestPublish(_response);
        });
    }

    protected processTestPublish(response: AxiosResponse): Promise<TestConsumerResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TestConsumerResult.fromJS(resultData200);
            return Promise.resolve<TestConsumerResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TestConsumerResult>(null as any);
    }

    /**
     * @return Success
     */
    getNestedData( cancelToken?: CancelToken): Promise<TestNestedDataResultDto> {
        let url_ = this.baseUrl + "/api/samples/getNestedData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNestedData(_response);
        });
    }

    protected processGetNestedData(response: AxiosResponse): Promise<TestNestedDataResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TestNestedDataResultDto.fromJS(resultData200);
            return Promise.resolve<TestNestedDataResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TestNestedDataResultDto>(null as any);
    }
}

export interface ISampleWidgetAClient {
    /**
     * @return Success
     */
    getSampleWidgetA(): Promise<WidgetContentResponseDto_1OfString>;
}

export class SampleWidgetAClient extends AuthorizedApiBase implements ISampleWidgetAClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getSampleWidgetA( cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfString> {
        let url_ = this.baseUrl + "/api/widget/sample-widget-a";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSampleWidgetA(_response);
        });
    }

    protected processGetSampleWidgetA(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfString.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfString>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfString>(null as any);
    }
}

export interface ISampleWidgetBClient {
    /**
     * @return Success
     */
    getSampleWidgetB(): Promise<WidgetContentResponseDto_1OfSampleWidgetBResponseDto>;
}

export class SampleWidgetBClient extends AuthorizedApiBase implements ISampleWidgetBClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getSampleWidgetB( cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfSampleWidgetBResponseDto> {
        let url_ = this.baseUrl + "/api/widget/sample-widget-b";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSampleWidgetB(_response);
        });
    }

    protected processGetSampleWidgetB(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfSampleWidgetBResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfSampleWidgetBResponseDto.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfSampleWidgetBResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfSampleWidgetBResponseDto>(null as any);
    }
}

export interface ISampleWidgetCClient {
    /**
     * @return Success
     */
    getSampleWidgetC(): Promise<WidgetContentResponseDto_1OfPieChartDto>;
}

export class SampleWidgetCClient extends AuthorizedApiBase implements ISampleWidgetCClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getSampleWidgetC( cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfPieChartDto> {
        let url_ = this.baseUrl + "/api/widget/sample-widget-c";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSampleWidgetC(_response);
        });
    }

    protected processGetSampleWidgetC(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfPieChartDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfPieChartDto.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfPieChartDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfPieChartDto>(null as any);
    }
}

export interface ISecretManagerClient {
    /**
     * @param body (optional) 
     * @return Success
     */
    createUpdateSecret(body: CreateUpdateSecretDto | undefined): Promise<string>;
    /**
     * @param body (optional) 
     * @return Success
     */
    deleteSecret(body: DeleteSecretDto | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getSecret(body: GetSecretDto | undefined): Promise<string>;
}

export class SecretManagerClient extends AuthorizedApiBase implements ISecretManagerClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUpdateSecret(body: CreateUpdateSecretDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/SecretManager";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUpdateSecret(_response);
        });
    }

    protected processCreateUpdateSecret(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteSecret(body: DeleteSecretDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/SecretManager";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSecret(_response);
        });
    }

    protected processDeleteSecret(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getSecret(body: GetSecretDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/SecretManager/getsecret";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSecret(_response);
        });
    }

    protected processGetSecret(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface ISelfServiceDatasetClient {
    /**
     * @param body (optional) 
     * @return Success
     */
    createSelfReportingDataset(body: SelfServiceDatasetRequest | undefined): Promise<SelfServiceDatasetDto>;
    /**
     * @return Success
     */
    getDatasets(): Promise<SelfServiceDatasetsDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateSelfServiceDataset(body: SelfServiceDatasetDto | undefined): Promise<SelfServiceDatasetDto>;
}

export class SelfServiceDatasetClient extends AuthorizedApiBase implements ISelfServiceDatasetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createSelfReportingDataset(body: SelfServiceDatasetRequest | undefined, cancelToken?: CancelToken): Promise<SelfServiceDatasetDto> {
        let url_ = this.baseUrl + "/api/SelfServiceDataset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateSelfReportingDataset(_response);
        });
    }

    protected processCreateSelfReportingDataset(response: AxiosResponse): Promise<SelfServiceDatasetDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SelfServiceDatasetDto.fromJS(resultData200);
            return Promise.resolve<SelfServiceDatasetDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SelfServiceDatasetDto>(null as any);
    }

    /**
     * @return Success
     */
    getDatasets( cancelToken?: CancelToken): Promise<SelfServiceDatasetsDto> {
        let url_ = this.baseUrl + "/api/SelfServiceDataset";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDatasets(_response);
        });
    }

    protected processGetDatasets(response: AxiosResponse): Promise<SelfServiceDatasetsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SelfServiceDatasetsDto.fromJS(resultData200);
            return Promise.resolve<SelfServiceDatasetsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SelfServiceDatasetsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSelfServiceDataset(body: SelfServiceDatasetDto | undefined, cancelToken?: CancelToken): Promise<SelfServiceDatasetDto> {
        let url_ = this.baseUrl + "/api/SelfServiceDataset/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSelfServiceDataset(_response);
        });
    }

    protected processUpdateSelfServiceDataset(response: AxiosResponse): Promise<SelfServiceDatasetDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SelfServiceDatasetDto.fromJS(resultData200);
            return Promise.resolve<SelfServiceDatasetDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SelfServiceDatasetDto>(null as any);
    }
}

export interface ISelfServiceEnvironmentsClient {
    /**
     * @param body (optional) 
     * @return Success
     */
    createSelfReportingEnvironment(body: SelfServiceEnvironmentRequest | undefined): Promise<SelfServiceEnvironmentDto>;
    /**
     * @return Success
     */
    getAccountsPendingEnvironments(): Promise<AccountsPendingSelfServiceEnvironmentCreationDto>;
}

export class SelfServiceEnvironmentsClient extends AuthorizedApiBase implements ISelfServiceEnvironmentsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createSelfReportingEnvironment(body: SelfServiceEnvironmentRequest | undefined, cancelToken?: CancelToken): Promise<SelfServiceEnvironmentDto> {
        let url_ = this.baseUrl + "/api/SelfServiceEnvironments/self-service-environment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateSelfReportingEnvironment(_response);
        });
    }

    protected processCreateSelfReportingEnvironment(response: AxiosResponse): Promise<SelfServiceEnvironmentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SelfServiceEnvironmentDto.fromJS(resultData200);
            return Promise.resolve<SelfServiceEnvironmentDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SelfServiceEnvironmentDto>(null as any);
    }

    /**
     * @return Success
     */
    getAccountsPendingEnvironments( cancelToken?: CancelToken): Promise<AccountsPendingSelfServiceEnvironmentCreationDto> {
        let url_ = this.baseUrl + "/api/SelfServiceEnvironments/account-details-for-environments";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccountsPendingEnvironments(_response);
        });
    }

    protected processGetAccountsPendingEnvironments(response: AxiosResponse): Promise<AccountsPendingSelfServiceEnvironmentCreationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountsPendingSelfServiceEnvironmentCreationDto.fromJS(resultData200);
            return Promise.resolve<AccountsPendingSelfServiceEnvironmentCreationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountsPendingSelfServiceEnvironmentCreationDto>(null as any);
    }
}

export interface ISelfServiceIntegrationsClient {
    /**
     * @return Success
     */
    getActiveSelfServiceIntegrations(): Promise<ActiveSelfServiceIntegrationDto[]>;
}

export class SelfServiceIntegrationsClient extends AuthorizedApiBase implements ISelfServiceIntegrationsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getActiveSelfServiceIntegrations( cancelToken?: CancelToken): Promise<ActiveSelfServiceIntegrationDto[]> {
        let url_ = this.baseUrl + "/api/SelfServiceIntegrations/active-integrations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActiveSelfServiceIntegrations(_response);
        });
    }

    protected processGetActiveSelfServiceIntegrations(response: AxiosResponse): Promise<ActiveSelfServiceIntegrationDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActiveSelfServiceIntegrationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ActiveSelfServiceIntegrationDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActiveSelfServiceIntegrationDto[]>(null as any);
    }
}

export interface ISelfServiceReportClient {
    /**
     * @return Success
     */
    getReports(): Promise<ReportsDto>;
    /**
     * @return Success
     */
    getReport(reportId: string): Promise<ReportDto>;
    /**
     * @return Success
     */
    createReport(reportId: string): Promise<ReportDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    publishReport(body: ReportDto | undefined): Promise<ReportsDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    unpublishReport(body: ReportDto | undefined): Promise<ReportsDto>;
    /**
     * @return Success
     */
    deleteReport(reportId: number): Promise<ReportsDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    discardChanges(body: number | undefined): Promise<ReportsDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    discardChangesAndTakeOwnership(body: number | undefined): Promise<ReportsDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    fallBackToDraftVersion(body: number | undefined): Promise<ReportDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    beginEditReport(body: number | undefined): Promise<ReportDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    duplicateReport(body: DuplicateReportRequest | undefined): Promise<ReportDto>;
    /**
     * @return Success
     */
    getEmbedToken(): Promise<EmbedToken>;
    /**
     * @return Success
     */
    getReportHistory(reportId: number): Promise<GetReportHistory>;
}

export class SelfServiceReportClient extends AuthorizedApiBase implements ISelfServiceReportClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getReports( cancelToken?: CancelToken): Promise<ReportsDto> {
        let url_ = this.baseUrl + "/api/SelfServiceReport/reports";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReports(_response);
        });
    }

    protected processGetReports(response: AxiosResponse): Promise<ReportsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportsDto.fromJS(resultData200);
            return Promise.resolve<ReportsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportsDto>(null as any);
    }

    /**
     * @return Success
     */
    getReport(reportId: string, cancelToken?: CancelToken): Promise<ReportDto> {
        let url_ = this.baseUrl + "/api/SelfServiceReport/report/{reportId}";
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReport(_response);
        });
    }

    protected processGetReport(response: AxiosResponse): Promise<ReportDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportDto.fromJS(resultData200);
            return Promise.resolve<ReportDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportDto>(null as any);
    }

    /**
     * @return Success
     */
    createReport(reportId: string, cancelToken?: CancelToken): Promise<ReportDto> {
        let url_ = this.baseUrl + "/api/SelfServiceReport/report/{reportId}";
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateReport(_response);
        });
    }

    protected processCreateReport(response: AxiosResponse): Promise<ReportDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportDto.fromJS(resultData200);
            return Promise.resolve<ReportDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    publishReport(body: ReportDto | undefined, cancelToken?: CancelToken): Promise<ReportsDto> {
        let url_ = this.baseUrl + "/api/SelfServiceReport/publish";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPublishReport(_response);
        });
    }

    protected processPublishReport(response: AxiosResponse): Promise<ReportsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportsDto.fromJS(resultData200);
            return Promise.resolve<ReportsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unpublishReport(body: ReportDto | undefined, cancelToken?: CancelToken): Promise<ReportsDto> {
        let url_ = this.baseUrl + "/api/SelfServiceReport/unpublish";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnpublishReport(_response);
        });
    }

    protected processUnpublishReport(response: AxiosResponse): Promise<ReportsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportsDto.fromJS(resultData200);
            return Promise.resolve<ReportsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportsDto>(null as any);
    }

    /**
     * @return Success
     */
    deleteReport(reportId: number, cancelToken?: CancelToken): Promise<ReportsDto> {
        let url_ = this.baseUrl + "/api/SelfServiceReport/delete/{reportId}";
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteReport(_response);
        });
    }

    protected processDeleteReport(response: AxiosResponse): Promise<ReportsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportsDto.fromJS(resultData200);
            return Promise.resolve<ReportsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    discardChanges(body: number | undefined, cancelToken?: CancelToken): Promise<ReportsDto> {
        let url_ = this.baseUrl + "/api/SelfServiceReport/discard-changes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDiscardChanges(_response);
        });
    }

    protected processDiscardChanges(response: AxiosResponse): Promise<ReportsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportsDto.fromJS(resultData200);
            return Promise.resolve<ReportsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    discardChangesAndTakeOwnership(body: number | undefined, cancelToken?: CancelToken): Promise<ReportsDto> {
        let url_ = this.baseUrl + "/api/SelfServiceReport/discard-changes-and-take-ownership";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDiscardChangesAndTakeOwnership(_response);
        });
    }

    protected processDiscardChangesAndTakeOwnership(response: AxiosResponse): Promise<ReportsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportsDto.fromJS(resultData200);
            return Promise.resolve<ReportsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    fallBackToDraftVersion(body: number | undefined, cancelToken?: CancelToken): Promise<ReportDto> {
        let url_ = this.baseUrl + "/api/SelfServiceReport/report/fall-back";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFallBackToDraftVersion(_response);
        });
    }

    protected processFallBackToDraftVersion(response: AxiosResponse): Promise<ReportDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportDto.fromJS(resultData200);
            return Promise.resolve<ReportDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    beginEditReport(body: number | undefined, cancelToken?: CancelToken): Promise<ReportDto> {
        let url_ = this.baseUrl + "/api/SelfServiceReport/report/begin-edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBeginEditReport(_response);
        });
    }

    protected processBeginEditReport(response: AxiosResponse): Promise<ReportDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportDto.fromJS(resultData200);
            return Promise.resolve<ReportDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    duplicateReport(body: DuplicateReportRequest | undefined, cancelToken?: CancelToken): Promise<ReportDto> {
        let url_ = this.baseUrl + "/api/SelfServiceReport/report/duplicate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDuplicateReport(_response);
        });
    }

    protected processDuplicateReport(response: AxiosResponse): Promise<ReportDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportDto.fromJS(resultData200);
            return Promise.resolve<ReportDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportDto>(null as any);
    }

    /**
     * @return Success
     */
    getEmbedToken( cancelToken?: CancelToken): Promise<EmbedToken> {
        let url_ = this.baseUrl + "/api/SelfServiceReport/token";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmbedToken(_response);
        });
    }

    protected processGetEmbedToken(response: AxiosResponse): Promise<EmbedToken> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmbedToken.fromJS(resultData200);
            return Promise.resolve<EmbedToken>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmbedToken>(null as any);
    }

    /**
     * @return Success
     */
    getReportHistory(reportId: number, cancelToken?: CancelToken): Promise<GetReportHistory> {
        let url_ = this.baseUrl + "/api/SelfServiceReport/report/history/{reportId}";
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReportHistory(_response);
        });
    }

    protected processGetReportHistory(response: AxiosResponse): Promise<GetReportHistory> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetReportHistory.fromJS(resultData200);
            return Promise.resolve<GetReportHistory>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetReportHistory>(null as any);
    }
}

export interface IServiceCatalogClient {
    /**
     * @return Success
     */
    getAllServiceCatalogsFromSharepoint(): Promise<ServiceCatalogDto[]>;
    /**
     * @return Success
     */
    getLogo(imageId: string): Promise<void>;
    /**
     * @return Success
     */
    searchAvailableServiceCatalogsFromSharepoint(searchTerm: string): Promise<ServiceCatalogDto[]>;
    /**
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param body (optional) 
     * @return Success
     */
    getPaginatedServiceCatalog(pageNumber: number | undefined, pageSize: number | undefined, body: SearchFilter | undefined): Promise<PaginatedResultDto_1OfServiceCatalogDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    requestAccess(body: ServiceCatalogDto | undefined): Promise<ServiceCatalogAccessResponse>;
}

export class ServiceCatalogClient extends AuthorizedApiBase implements IServiceCatalogClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getAllServiceCatalogsFromSharepoint( cancelToken?: CancelToken): Promise<ServiceCatalogDto[]> {
        let url_ = this.baseUrl + "/api/ServiceCatalog/getAllServiceCatalogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllServiceCatalogsFromSharepoint(_response);
        });
    }

    protected processGetAllServiceCatalogsFromSharepoint(response: AxiosResponse): Promise<ServiceCatalogDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceCatalogDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ServiceCatalogDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceCatalogDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getLogo(imageId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ServiceCatalog/logo/{imageId}";
        if (imageId === undefined || imageId === null)
            throw new Error("The parameter 'imageId' must be defined.");
        url_ = url_.replace("{imageId}", encodeURIComponent("" + imageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLogo(_response);
        });
    }

    protected processGetLogo(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    searchAvailableServiceCatalogsFromSharepoint(searchTerm: string, cancelToken?: CancelToken): Promise<ServiceCatalogDto[]> {
        let url_ = this.baseUrl + "/api/ServiceCatalog/search/sharepoint/{searchTerm}";
        if (searchTerm === undefined || searchTerm === null)
            throw new Error("The parameter 'searchTerm' must be defined.");
        url_ = url_.replace("{searchTerm}", encodeURIComponent("" + searchTerm));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchAvailableServiceCatalogsFromSharepoint(_response);
        });
    }

    protected processSearchAvailableServiceCatalogsFromSharepoint(response: AxiosResponse): Promise<ServiceCatalogDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceCatalogDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ServiceCatalogDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceCatalogDto[]>(null as any);
    }

    /**
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param body (optional) 
     * @return Success
     */
    getPaginatedServiceCatalog(pageNumber: number | undefined, pageSize: number | undefined, body: SearchFilter | undefined, cancelToken?: CancelToken): Promise<PaginatedResultDto_1OfServiceCatalogDto> {
        let url_ = this.baseUrl + "/api/ServiceCatalog/paging?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaginatedServiceCatalog(_response);
        });
    }

    protected processGetPaginatedServiceCatalog(response: AxiosResponse): Promise<PaginatedResultDto_1OfServiceCatalogDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResultDto_1OfServiceCatalogDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResultDto_1OfServiceCatalogDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResultDto_1OfServiceCatalogDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    requestAccess(body: ServiceCatalogDto | undefined, cancelToken?: CancelToken): Promise<ServiceCatalogAccessResponse> {
        let url_ = this.baseUrl + "/api/ServiceCatalog/request-access";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequestAccess(_response);
        });
    }

    protected processRequestAccess(response: AxiosResponse): Promise<ServiceCatalogAccessResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceCatalogAccessResponse.fromJS(resultData200);
            return Promise.resolve<ServiceCatalogAccessResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceCatalogAccessResponse>(null as any);
    }
}

export interface IServiceContractsWidgetClient {
    /**
     * @return Success
     */
    getServiceContractsWidgetData(): Promise<WidgetContentResponseDto_1OfServiceContractsWidgetDto>;
    /**
     * @param expirationDate (optional) 
     * @return Success
     */
    getServicesExpiringContractsWidgetData(expirationDate: Date | undefined): Promise<WidgetContentResponseDto_1OfServicesExpiringContractsWidgetDto>;
}

export class ServiceContractsWidgetClient extends AuthorizedApiBase implements IServiceContractsWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getServiceContractsWidgetData( cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfServiceContractsWidgetDto> {
        let url_ = this.baseUrl + "/api/widget/service-contracts-widget";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetServiceContractsWidgetData(_response);
        });
    }

    protected processGetServiceContractsWidgetData(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfServiceContractsWidgetDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfServiceContractsWidgetDto.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfServiceContractsWidgetDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfServiceContractsWidgetDto>(null as any);
    }

    /**
     * @param expirationDate (optional) 
     * @return Success
     */
    getServicesExpiringContractsWidgetData(expirationDate: Date | undefined, cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfServicesExpiringContractsWidgetDto> {
        let url_ = this.baseUrl + "/api/widget/services-expiring-contracts-widget?";
        if (expirationDate === null)
            throw new Error("The parameter 'expirationDate' cannot be null.");
        else if (expirationDate !== undefined)
            url_ += "expirationDate=" + encodeURIComponent(expirationDate ? "" + expirationDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetServicesExpiringContractsWidgetData(_response);
        });
    }

    protected processGetServicesExpiringContractsWidgetData(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfServicesExpiringContractsWidgetDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfServicesExpiringContractsWidgetDto.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfServicesExpiringContractsWidgetDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfServicesExpiringContractsWidgetDto>(null as any);
    }
}

export interface IServiceRequestClient {
    /**
     * @param body (optional) 
     * @return Success
     */
    getAllAccountServiceRequests(body: AllServiceRequestsRequest | undefined): Promise<AllServiceRequestsResponse>;
    /**
     * @return Success
     */
    getMyServiceRequests(): Promise<ServiceRequestDTO[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    createNewServiceRequest(body: ServiceRequestDTO | undefined): Promise<ServiceRequestResponse>;
    /**
     * @return Success
     */
    getMyAdditionalContactServiceRequests(): Promise<ServiceRequestDTO[]>;
    /**
     * @return Success
     */
    getServiceRequestByServiceRequestId(serviceRequestId: string): Promise<ServiceRequestDTO>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateServiceRequest(serviceRequestId: number, body: ServiceRequestDTO | undefined): Promise<ServiceRequestResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    allRequests(body: ServiceRequestsRequest | undefined): Promise<ServiceRequestsResponseDTO>;
    /**
     * @return Success
     */
    getServiceRequestsByAccount(accountId: number): Promise<ServiceRequestDto[]>;
    /**
     * @return Success
     */
    createBulkIndexes(): Promise<ServiceRequestDto[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    uniqueFilterValues(body: GetUniqueFilterValuesRequestBase | undefined): Promise<UniqueFilterValuesDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    searchServiceRequests(body: ServiceRequestBaseElasticQueryRequest | undefined): Promise<ServiceRequestListDocumentDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    serviceRequestVisuals(body: GetServiceRequestVisuals | undefined): Promise<ServiceRequestVisualsDto>;
    /**
     * @return Success
     */
    serviceRequestTabCounts(activeOnly: boolean): Promise<ServiceRequestTabCountsDto>;
    /**
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @return Success
     */
    issueRankingsWidget(dateFrom: Date | undefined, dateTo: Date | undefined): Promise<ServiceRequestIssueRankingsWidgetDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    myRequests(body: ServiceRequestsRequest | undefined): Promise<ServiceRequestsResponseDTO>;
    /**
     * @param body (optional) 
     * @return Success
     */
    secondaryContact(body: ServiceRequestsRequest | undefined): Promise<ServiceRequestsResponseDTO>;
    /**
     * @return Success
     */
    summary(): Promise<ServiceRequestSummaryDTO>;
    /**
     * @return Success
     */
    requestHistory(months: number): Promise<MonthlyReportsDto>;
    /**
     * @return Success
     */
    serviceRequestDetails(serviceRequestId: string): Promise<ServiceRequestDetailsDto>;
    /**
     * @return Success
     */
    additionalContacts(serviceRequestId: number): Promise<ContactDto[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateAdditionalContacts(serviceRequestId: string, body: ContactDto[] | undefined): Promise<ContactDto[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    additionalContactsBulk(body: number[] | undefined): Promise<ContactDtoWithServiceRequestIdAndAxNumber[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updatePreferredContactMethod(serviceRequestId: number, body: string | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addServiceRequestMessage(body: ServiceRequestMessageDto | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    serviceRequestsDownload(body: ServiceRequestDownloadRequest | undefined): Promise<FileDownloadResponse>;
}

export class ServiceRequestClient extends AuthorizedApiBase implements IServiceRequestClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllAccountServiceRequests(body: AllServiceRequestsRequest | undefined, cancelToken?: CancelToken): Promise<AllServiceRequestsResponse> {
        let url_ = this.baseUrl + "/api/ServiceRequest/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllAccountServiceRequests(_response);
        });
    }

    protected processGetAllAccountServiceRequests(response: AxiosResponse): Promise<AllServiceRequestsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AllServiceRequestsResponse.fromJS(resultData200);
            return Promise.resolve<AllServiceRequestsResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AllServiceRequestsResponse>(null as any);
    }

    /**
     * @return Success
     */
    getMyServiceRequests( cancelToken?: CancelToken): Promise<ServiceRequestDTO[]> {
        let url_ = this.baseUrl + "/api/ServiceRequest";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyServiceRequests(_response);
        });
    }

    protected processGetMyServiceRequests(response: AxiosResponse): Promise<ServiceRequestDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceRequestDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ServiceRequestDTO[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createNewServiceRequest(body: ServiceRequestDTO | undefined, cancelToken?: CancelToken): Promise<ServiceRequestResponse> {
        let url_ = this.baseUrl + "/api/ServiceRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateNewServiceRequest(_response);
        });
    }

    protected processCreateNewServiceRequest(response: AxiosResponse): Promise<ServiceRequestResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceRequestResponse.fromJS(resultData200);
            return Promise.resolve<ServiceRequestResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestResponse>(null as any);
    }

    /**
     * @return Success
     */
    getMyAdditionalContactServiceRequests( cancelToken?: CancelToken): Promise<ServiceRequestDTO[]> {
        let url_ = this.baseUrl + "/api/ServiceRequest/additional-contact";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyAdditionalContactServiceRequests(_response);
        });
    }

    protected processGetMyAdditionalContactServiceRequests(response: AxiosResponse): Promise<ServiceRequestDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceRequestDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ServiceRequestDTO[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    getServiceRequestByServiceRequestId(serviceRequestId: string, cancelToken?: CancelToken): Promise<ServiceRequestDTO> {
        let url_ = this.baseUrl + "/api/ServiceRequest/{serviceRequestId}";
        if (serviceRequestId === undefined || serviceRequestId === null)
            throw new Error("The parameter 'serviceRequestId' must be defined.");
        url_ = url_.replace("{serviceRequestId}", encodeURIComponent("" + serviceRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetServiceRequestByServiceRequestId(_response);
        });
    }

    protected processGetServiceRequestByServiceRequestId(response: AxiosResponse): Promise<ServiceRequestDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceRequestDTO.fromJS(resultData200);
            return Promise.resolve<ServiceRequestDTO>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateServiceRequest(serviceRequestId: number, body: ServiceRequestDTO | undefined, cancelToken?: CancelToken): Promise<ServiceRequestResponse> {
        let url_ = this.baseUrl + "/api/ServiceRequest/{serviceRequestId}";
        if (serviceRequestId === undefined || serviceRequestId === null)
            throw new Error("The parameter 'serviceRequestId' must be defined.");
        url_ = url_.replace("{serviceRequestId}", encodeURIComponent("" + serviceRequestId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateServiceRequest(_response);
        });
    }

    protected processUpdateServiceRequest(response: AxiosResponse): Promise<ServiceRequestResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceRequestResponse.fromJS(resultData200);
            return Promise.resolve<ServiceRequestResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    allRequests(body: ServiceRequestsRequest | undefined, cancelToken?: CancelToken): Promise<ServiceRequestsResponseDTO> {
        let url_ = this.baseUrl + "/api/ServiceRequest/all-requests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAllRequests(_response);
        });
    }

    protected processAllRequests(response: AxiosResponse): Promise<ServiceRequestsResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceRequestsResponseDTO.fromJS(resultData200);
            return Promise.resolve<ServiceRequestsResponseDTO>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestsResponseDTO>(null as any);
    }

    /**
     * @return Success
     */
    getServiceRequestsByAccount(accountId: number, cancelToken?: CancelToken): Promise<ServiceRequestDto[]> {
        let url_ = this.baseUrl + "/api/ServiceRequest/elastic/account/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetServiceRequestsByAccount(_response);
        });
    }

    protected processGetServiceRequestsByAccount(response: AxiosResponse): Promise<ServiceRequestDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceRequestDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ServiceRequestDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestDto[]>(null as any);
    }

    /**
     * @return Success
     */
    createBulkIndexes( cancelToken?: CancelToken): Promise<ServiceRequestDto[]> {
        let url_ = this.baseUrl + "/api/ServiceRequest/elastic/createBulkIndexes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateBulkIndexes(_response);
        });
    }

    protected processCreateBulkIndexes(response: AxiosResponse): Promise<ServiceRequestDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceRequestDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ServiceRequestDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uniqueFilterValues(body: GetUniqueFilterValuesRequestBase | undefined, cancelToken?: CancelToken): Promise<UniqueFilterValuesDto> {
        let url_ = this.baseUrl + "/api/ServiceRequest/elastic/query/unique-filter-values";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUniqueFilterValues(_response);
        });
    }

    protected processUniqueFilterValues(response: AxiosResponse): Promise<UniqueFilterValuesDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UniqueFilterValuesDto.fromJS(resultData200);
            return Promise.resolve<UniqueFilterValuesDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UniqueFilterValuesDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchServiceRequests(body: ServiceRequestBaseElasticQueryRequest | undefined, cancelToken?: CancelToken): Promise<ServiceRequestListDocumentDto> {
        let url_ = this.baseUrl + "/api/ServiceRequest/elastic/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchServiceRequests(_response);
        });
    }

    protected processSearchServiceRequests(response: AxiosResponse): Promise<ServiceRequestListDocumentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceRequestListDocumentDto.fromJS(resultData200);
            return Promise.resolve<ServiceRequestListDocumentDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestListDocumentDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    serviceRequestVisuals(body: GetServiceRequestVisuals | undefined, cancelToken?: CancelToken): Promise<ServiceRequestVisualsDto> {
        let url_ = this.baseUrl + "/api/ServiceRequest/elastic/visuals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processServiceRequestVisuals(_response);
        });
    }

    protected processServiceRequestVisuals(response: AxiosResponse): Promise<ServiceRequestVisualsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceRequestVisualsDto.fromJS(resultData200);
            return Promise.resolve<ServiceRequestVisualsDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestVisualsDto>(null as any);
    }

    /**
     * @return Success
     */
    serviceRequestTabCounts(activeOnly: boolean, cancelToken?: CancelToken): Promise<ServiceRequestTabCountsDto> {
        let url_ = this.baseUrl + "/api/ServiceRequest/elastic/tabCounts/{activeOnly}";
        if (activeOnly === undefined || activeOnly === null)
            throw new Error("The parameter 'activeOnly' must be defined.");
        url_ = url_.replace("{activeOnly}", encodeURIComponent("" + activeOnly));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processServiceRequestTabCounts(_response);
        });
    }

    protected processServiceRequestTabCounts(response: AxiosResponse): Promise<ServiceRequestTabCountsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceRequestTabCountsDto.fromJS(resultData200);
            return Promise.resolve<ServiceRequestTabCountsDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestTabCountsDto>(null as any);
    }

    /**
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @return Success
     */
    issueRankingsWidget(dateFrom: Date | undefined, dateTo: Date | undefined, cancelToken?: CancelToken): Promise<ServiceRequestIssueRankingsWidgetDto> {
        let url_ = this.baseUrl + "/api/ServiceRequest/issue-rankings-widget?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIssueRankingsWidget(_response);
        });
    }

    protected processIssueRankingsWidget(response: AxiosResponse): Promise<ServiceRequestIssueRankingsWidgetDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceRequestIssueRankingsWidgetDto.fromJS(resultData200);
            return Promise.resolve<ServiceRequestIssueRankingsWidgetDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestIssueRankingsWidgetDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    myRequests(body: ServiceRequestsRequest | undefined, cancelToken?: CancelToken): Promise<ServiceRequestsResponseDTO> {
        let url_ = this.baseUrl + "/api/ServiceRequest/my-requests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMyRequests(_response);
        });
    }

    protected processMyRequests(response: AxiosResponse): Promise<ServiceRequestsResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceRequestsResponseDTO.fromJS(resultData200);
            return Promise.resolve<ServiceRequestsResponseDTO>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestsResponseDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    secondaryContact(body: ServiceRequestsRequest | undefined, cancelToken?: CancelToken): Promise<ServiceRequestsResponseDTO> {
        let url_ = this.baseUrl + "/api/ServiceRequest/secondary-contact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSecondaryContact(_response);
        });
    }

    protected processSecondaryContact(response: AxiosResponse): Promise<ServiceRequestsResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceRequestsResponseDTO.fromJS(resultData200);
            return Promise.resolve<ServiceRequestsResponseDTO>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestsResponseDTO>(null as any);
    }

    /**
     * @return Success
     */
    summary( cancelToken?: CancelToken): Promise<ServiceRequestSummaryDTO> {
        let url_ = this.baseUrl + "/api/ServiceRequest/request-summary";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSummary(_response);
        });
    }

    protected processSummary(response: AxiosResponse): Promise<ServiceRequestSummaryDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceRequestSummaryDTO.fromJS(resultData200);
            return Promise.resolve<ServiceRequestSummaryDTO>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestSummaryDTO>(null as any);
    }

    /**
     * @return Success
     */
    requestHistory(months: number, cancelToken?: CancelToken): Promise<MonthlyReportsDto> {
        let url_ = this.baseUrl + "/api/ServiceRequest/elastic/history/{months}";
        if (months === undefined || months === null)
            throw new Error("The parameter 'months' must be defined.");
        url_ = url_.replace("{months}", encodeURIComponent("" + months));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequestHistory(_response);
        });
    }

    protected processRequestHistory(response: AxiosResponse): Promise<MonthlyReportsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MonthlyReportsDto.fromJS(resultData200);
            return Promise.resolve<MonthlyReportsDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MonthlyReportsDto>(null as any);
    }

    /**
     * @return Success
     */
    serviceRequestDetails(serviceRequestId: string, cancelToken?: CancelToken): Promise<ServiceRequestDetailsDto> {
        let url_ = this.baseUrl + "/api/ServiceRequest/details/{serviceRequestId}";
        if (serviceRequestId === undefined || serviceRequestId === null)
            throw new Error("The parameter 'serviceRequestId' must be defined.");
        url_ = url_.replace("{serviceRequestId}", encodeURIComponent("" + serviceRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processServiceRequestDetails(_response);
        });
    }

    protected processServiceRequestDetails(response: AxiosResponse): Promise<ServiceRequestDetailsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceRequestDetailsDto.fromJS(resultData200);
            return Promise.resolve<ServiceRequestDetailsDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestDetailsDto>(null as any);
    }

    /**
     * @return Success
     */
    additionalContacts(serviceRequestId: number, cancelToken?: CancelToken): Promise<ContactDto[]> {
        let url_ = this.baseUrl + "/api/ServiceRequest/additionalContacts/{serviceRequestId}";
        if (serviceRequestId === undefined || serviceRequestId === null)
            throw new Error("The parameter 'serviceRequestId' must be defined.");
        url_ = url_.replace("{serviceRequestId}", encodeURIComponent("" + serviceRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdditionalContacts(_response);
        });
    }

    protected processAdditionalContacts(response: AxiosResponse): Promise<ContactDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContactDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ContactDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContactDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAdditionalContacts(serviceRequestId: string, body: ContactDto[] | undefined, cancelToken?: CancelToken): Promise<ContactDto[]> {
        let url_ = this.baseUrl + "/api/ServiceRequest/additionalContacts/{serviceRequestId}";
        if (serviceRequestId === undefined || serviceRequestId === null)
            throw new Error("The parameter 'serviceRequestId' must be defined.");
        url_ = url_.replace("{serviceRequestId}", encodeURIComponent("" + serviceRequestId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAdditionalContacts(_response);
        });
    }

    protected processUpdateAdditionalContacts(response: AxiosResponse): Promise<ContactDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContactDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ContactDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContactDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    additionalContactsBulk(body: number[] | undefined, cancelToken?: CancelToken): Promise<ContactDtoWithServiceRequestIdAndAxNumber[]> {
        let url_ = this.baseUrl + "/api/ServiceRequest/additionalContacts/bulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdditionalContactsBulk(_response);
        });
    }

    protected processAdditionalContactsBulk(response: AxiosResponse): Promise<ContactDtoWithServiceRequestIdAndAxNumber[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContactDtoWithServiceRequestIdAndAxNumber.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ContactDtoWithServiceRequestIdAndAxNumber[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContactDtoWithServiceRequestIdAndAxNumber[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePreferredContactMethod(serviceRequestId: number, body: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ServiceRequest/details/{serviceRequestId}/preferredContactMethod";
        if (serviceRequestId === undefined || serviceRequestId === null)
            throw new Error("The parameter 'serviceRequestId' must be defined.");
        url_ = url_.replace("{serviceRequestId}", encodeURIComponent("" + serviceRequestId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePreferredContactMethod(_response);
        });
    }

    protected processUpdatePreferredContactMethod(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addServiceRequestMessage(body: ServiceRequestMessageDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ServiceRequest/message";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddServiceRequestMessage(_response);
        });
    }

    protected processAddServiceRequestMessage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    serviceRequestsDownload(body: ServiceRequestDownloadRequest | undefined, cancelToken?: CancelToken): Promise<FileDownloadResponse> {
        let url_ = this.baseUrl + "/api/ServiceRequest/elastic/download";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processServiceRequestsDownload(_response);
        });
    }

    protected processServiceRequestsDownload(response: AxiosResponse): Promise<FileDownloadResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDownloadResponse.fromJS(resultData200);
            return Promise.resolve<FileDownloadResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDownloadResponse>(null as any);
    }
}

export interface IServiceRequestLandingPageClient {
    /**
     * @return Success
     */
    getLandingPageTiles(): Promise<ServiceRequestLandingPageItemDto[]>;
}

export class ServiceRequestLandingPageClient extends AuthorizedApiBase implements IServiceRequestLandingPageClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getLandingPageTiles( cancelToken?: CancelToken): Promise<ServiceRequestLandingPageItemDto[]> {
        let url_ = this.baseUrl + "/api/ServiceRequestLandingPage";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLandingPageTiles(_response);
        });
    }

    protected processGetLandingPageTiles(response: AxiosResponse): Promise<ServiceRequestLandingPageItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceRequestLandingPageItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ServiceRequestLandingPageItemDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestLandingPageItemDto[]>(null as any);
    }
}

export interface IServiceRequestMappingClient {
    /**
     * @return Success
     */
    getServiceRequestMappings(): Promise<ServiceRequestMapping[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    createServiceRequestMapping(body: ServiceRequestMapping | undefined): Promise<ServiceRequestMapping[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateServiceRequestMapping(body: ServiceRequestMapping | undefined): Promise<ServiceRequestMapping[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    deleteServiceRequestMapping(body: ServiceRequestMapping | undefined): Promise<void>;
    /**
     * @return Success
     */
    setApprovalServiceRequestMapping(mappingId: string, revision: number, status: boolean): Promise<ServiceRequestMapping>;
}

export class ServiceRequestMappingClient extends AuthorizedApiBase implements IServiceRequestMappingClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getServiceRequestMappings( cancelToken?: CancelToken): Promise<ServiceRequestMapping[]> {
        let url_ = this.baseUrl + "/api/ServiceRequestMapping";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetServiceRequestMappings(_response);
        });
    }

    protected processGetServiceRequestMappings(response: AxiosResponse): Promise<ServiceRequestMapping[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceRequestMapping.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ServiceRequestMapping[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestMapping[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createServiceRequestMapping(body: ServiceRequestMapping | undefined, cancelToken?: CancelToken): Promise<ServiceRequestMapping[]> {
        let url_ = this.baseUrl + "/api/ServiceRequestMapping";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateServiceRequestMapping(_response);
        });
    }

    protected processCreateServiceRequestMapping(response: AxiosResponse): Promise<ServiceRequestMapping[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceRequestMapping.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ServiceRequestMapping[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestMapping[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateServiceRequestMapping(body: ServiceRequestMapping | undefined, cancelToken?: CancelToken): Promise<ServiceRequestMapping[]> {
        let url_ = this.baseUrl + "/api/ServiceRequestMapping";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateServiceRequestMapping(_response);
        });
    }

    protected processUpdateServiceRequestMapping(response: AxiosResponse): Promise<ServiceRequestMapping[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceRequestMapping.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ServiceRequestMapping[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestMapping[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteServiceRequestMapping(body: ServiceRequestMapping | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ServiceRequestMapping";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteServiceRequestMapping(_response);
        });
    }

    protected processDeleteServiceRequestMapping(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    setApprovalServiceRequestMapping(mappingId: string, revision: number, status: boolean, cancelToken?: CancelToken): Promise<ServiceRequestMapping> {
        let url_ = this.baseUrl + "/api/ServiceRequestMapping/set-approval/{mappingId}/{revision}/{status}";
        if (mappingId === undefined || mappingId === null)
            throw new Error("The parameter 'mappingId' must be defined.");
        url_ = url_.replace("{mappingId}", encodeURIComponent("" + mappingId));
        if (revision === undefined || revision === null)
            throw new Error("The parameter 'revision' must be defined.");
        url_ = url_.replace("{revision}", encodeURIComponent("" + revision));
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetApprovalServiceRequestMapping(_response);
        });
    }

    protected processSetApprovalServiceRequestMapping(response: AxiosResponse): Promise<ServiceRequestMapping> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceRequestMapping.fromJS(resultData200);
            return Promise.resolve<ServiceRequestMapping>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestMapping>(null as any);
    }
}

export interface IServiceRequestTemplateClient {
    /**
     * @return Success
     */
    getAvailableContacts(accountId: number): Promise<ServiceRequestContactDTO[]>;
    /**
     * @return Success
     */
    getAvailableAccountLocations(accountId: number): Promise<ServiceRequestAccountLocationDTO[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    uploadAttachments(body: Body | undefined): Promise<string[]>;
    /**
     * @return Success
     */
    getShiAccountDetails(axAccountNumber: string): Promise<AXAccountDetailsDTO>;
    /**
     * @return Success
     */
    getAllBillingUsersByAxAccountNumber(axAccountNumber: string): Promise<AXAccountBillingUsersDTO[]>;
    /**
     * @return Success
     */
    getShiBillingAddressesByAxAccountNumberAndCloudType(axAccountNumber: string, cloudType: ServiceRequestCloudTypes): Promise<AXBillingAddressDTO>;
    /**
     * @return Success
     */
    getShiBillingAddressesByAxAccountNumber(axAccountNumber: string): Promise<AXBillingAddressDTO>;
}

export class ServiceRequestTemplateClient extends AuthorizedApiBase implements IServiceRequestTemplateClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getAvailableContacts(accountId: number, cancelToken?: CancelToken): Promise<ServiceRequestContactDTO[]> {
        let url_ = this.baseUrl + "/api/ServiceRequestTemplate/contacts/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAvailableContacts(_response);
        });
    }

    protected processGetAvailableContacts(response: AxiosResponse): Promise<ServiceRequestContactDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceRequestContactDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ServiceRequestContactDTO[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestContactDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    getAvailableAccountLocations(accountId: number, cancelToken?: CancelToken): Promise<ServiceRequestAccountLocationDTO[]> {
        let url_ = this.baseUrl + "/api/ServiceRequestTemplate/accountLocations/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAvailableAccountLocations(_response);
        });
    }

    protected processGetAvailableAccountLocations(response: AxiosResponse): Promise<ServiceRequestAccountLocationDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceRequestAccountLocationDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ServiceRequestAccountLocationDTO[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestAccountLocationDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadAttachments(body: Body | undefined, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/ServiceRequestTemplate/attachments/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadAttachments(_response);
        });
    }

    protected processUploadAttachments(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @return Success
     */
    getShiAccountDetails(axAccountNumber: string, cancelToken?: CancelToken): Promise<AXAccountDetailsDTO> {
        let url_ = this.baseUrl + "/api/ServiceRequestTemplate/account-details/{axAccountNumber}";
        if (axAccountNumber === undefined || axAccountNumber === null)
            throw new Error("The parameter 'axAccountNumber' must be defined.");
        url_ = url_.replace("{axAccountNumber}", encodeURIComponent("" + axAccountNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShiAccountDetails(_response);
        });
    }

    protected processGetShiAccountDetails(response: AxiosResponse): Promise<AXAccountDetailsDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AXAccountDetailsDTO.fromJS(resultData200);
            return Promise.resolve<AXAccountDetailsDTO>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AXAccountDetailsDTO>(null as any);
    }

    /**
     * @return Success
     */
    getAllBillingUsersByAxAccountNumber(axAccountNumber: string, cancelToken?: CancelToken): Promise<AXAccountBillingUsersDTO[]> {
        let url_ = this.baseUrl + "/api/ServiceRequestTemplate/billing-users/{axAccountNumber}";
        if (axAccountNumber === undefined || axAccountNumber === null)
            throw new Error("The parameter 'axAccountNumber' must be defined.");
        url_ = url_.replace("{axAccountNumber}", encodeURIComponent("" + axAccountNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllBillingUsersByAxAccountNumber(_response);
        });
    }

    protected processGetAllBillingUsersByAxAccountNumber(response: AxiosResponse): Promise<AXAccountBillingUsersDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AXAccountBillingUsersDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AXAccountBillingUsersDTO[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AXAccountBillingUsersDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    getShiBillingAddressesByAxAccountNumberAndCloudType(axAccountNumber: string, cloudType: ServiceRequestCloudTypes, cancelToken?: CancelToken): Promise<AXBillingAddressDTO> {
        let url_ = this.baseUrl + "/api/ServiceRequestTemplate/billing-address/{cloudType}/{axAccountNumber}";
        if (axAccountNumber === undefined || axAccountNumber === null)
            throw new Error("The parameter 'axAccountNumber' must be defined.");
        url_ = url_.replace("{axAccountNumber}", encodeURIComponent("" + axAccountNumber));
        if (cloudType === undefined || cloudType === null)
            throw new Error("The parameter 'cloudType' must be defined.");
        url_ = url_.replace("{cloudType}", encodeURIComponent("" + cloudType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShiBillingAddressesByAxAccountNumberAndCloudType(_response);
        });
    }

    protected processGetShiBillingAddressesByAxAccountNumberAndCloudType(response: AxiosResponse): Promise<AXBillingAddressDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AXBillingAddressDTO.fromJS(resultData200);
            return Promise.resolve<AXBillingAddressDTO>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AXBillingAddressDTO>(null as any);
    }

    /**
     * @return Success
     */
    getShiBillingAddressesByAxAccountNumber(axAccountNumber: string, cancelToken?: CancelToken): Promise<AXBillingAddressDTO> {
        let url_ = this.baseUrl + "/api/ServiceRequestTemplate/billing-address/{axAccountNumber}";
        if (axAccountNumber === undefined || axAccountNumber === null)
            throw new Error("The parameter 'axAccountNumber' must be defined.");
        url_ = url_.replace("{axAccountNumber}", encodeURIComponent("" + axAccountNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShiBillingAddressesByAxAccountNumber(_response);
        });
    }

    protected processGetShiBillingAddressesByAxAccountNumber(response: AxiosResponse): Promise<AXBillingAddressDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AXBillingAddressDTO.fromJS(resultData200);
            return Promise.resolve<AXBillingAddressDTO>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AXBillingAddressDTO>(null as any);
    }
}

export interface ISiteClient {
    /**
     * @param body (optional) 
     * @return Success
     */
    setSubdomain(body: WhiteLabelResult | undefined): Promise<string>;
    /**
     * @return Success
     */
    uploadNewSiteLogo(): Promise<FileUploadResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    setWhitelabel(body: WhiteLabelResult | undefined): Promise<string>;
    /**
     * @return Success
     */
    getLogoUrl(prefix: string): Promise<string>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getSubdomainFromPrefix(body: CurrentPrefix | undefined): Promise<string>;
}

export class SiteClient extends AuthorizedApiBase implements ISiteClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setSubdomain(body: WhiteLabelResult | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Site/subdomain";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetSubdomain(_response);
        });
    }

    protected processSetSubdomain(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Success
     */
    uploadNewSiteLogo( cancelToken?: CancelToken): Promise<FileUploadResponse> {
        let url_ = this.baseUrl + "/api/Site/uploadimage";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadNewSiteLogo(_response);
        });
    }

    protected processUploadNewSiteLogo(response: AxiosResponse): Promise<FileUploadResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileUploadResponse.fromJS(resultData200);
            return Promise.resolve<FileUploadResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileUploadResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setWhitelabel(body: WhiteLabelResult | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Site/whitelabel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetWhitelabel(_response);
        });
    }

    protected processSetWhitelabel(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Success
     */
    getLogoUrl(prefix: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Site/logo/{prefix}";
        if (prefix === undefined || prefix === null)
            throw new Error("The parameter 'prefix' must be defined.");
        url_ = url_.replace("{prefix}", encodeURIComponent("" + prefix));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLogoUrl(_response);
        });
    }

    protected processGetLogoUrl(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getSubdomainFromPrefix(body: CurrentPrefix | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Site/getsite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSubdomainFromPrefix(_response);
        });
    }

    protected processGetSubdomainFromPrefix(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface ISupportOverviewWidgetClient {
    /**
     * @param dateFilter (optional) 
     * @return Success
     */
    getSupportRequestsOverview(dateFilter: DateFilterOption | undefined): Promise<WidgetContentResponseDto_1OfSupportOverviewDto>;
}

export class SupportOverviewWidgetClient extends AuthorizedApiBase implements ISupportOverviewWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param dateFilter (optional) 
     * @return Success
     */
    getSupportRequestsOverview(dateFilter: DateFilterOption | undefined, cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfSupportOverviewDto> {
        let url_ = this.baseUrl + "/api/widget/support-requests_overview-widgets?";
        if (dateFilter === null)
            throw new Error("The parameter 'dateFilter' cannot be null.");
        else if (dateFilter !== undefined)
            url_ += "dateFilter=" + encodeURIComponent("" + dateFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSupportRequestsOverview(_response);
        });
    }

    protected processGetSupportRequestsOverview(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfSupportOverviewDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfSupportOverviewDto.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfSupportOverviewDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfSupportOverviewDto>(null as any);
    }
}

export interface ISupportRequestWidgetsClient {
    /**
     * @param visualKey (optional) 
     * @param dateFilterOption (optional) 
     * @param activeOnly (optional) 
     * @return Success
     */
    getSupportRequestsData(visualKey: ServiceRequestVisualsTypes | undefined, dateFilterOption: DateFilterOption | undefined, activeOnly: boolean | undefined): Promise<WidgetContentResponseDto_1OfPieChartDto>;
    /**
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @return Success
     */
    getCompletedRequestsMeetingSlaWidget(dateFrom: Date | undefined, dateTo: Date | undefined): Promise<WidgetContentResponseDto_1OfServiceRequestCompletedMeetingSlaWidgetDto>;
}

export class SupportRequestWidgetsClient extends AuthorizedApiBase implements ISupportRequestWidgetsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param visualKey (optional) 
     * @param dateFilterOption (optional) 
     * @param activeOnly (optional) 
     * @return Success
     */
    getSupportRequestsData(visualKey: ServiceRequestVisualsTypes | undefined, dateFilterOption: DateFilterOption | undefined, activeOnly: boolean | undefined, cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfPieChartDto> {
        let url_ = this.baseUrl + "/api/widget/support-requests-widgets/support-request-data?";
        if (visualKey === null)
            throw new Error("The parameter 'visualKey' cannot be null.");
        else if (visualKey !== undefined)
            url_ += "visualKey=" + encodeURIComponent("" + visualKey) + "&";
        if (dateFilterOption === null)
            throw new Error("The parameter 'dateFilterOption' cannot be null.");
        else if (dateFilterOption !== undefined)
            url_ += "dateFilterOption=" + encodeURIComponent("" + dateFilterOption) + "&";
        if (activeOnly === null)
            throw new Error("The parameter 'activeOnly' cannot be null.");
        else if (activeOnly !== undefined)
            url_ += "activeOnly=" + encodeURIComponent("" + activeOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSupportRequestsData(_response);
        });
    }

    protected processGetSupportRequestsData(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfPieChartDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfPieChartDto.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfPieChartDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfPieChartDto>(null as any);
    }

    /**
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @return Success
     */
    getCompletedRequestsMeetingSlaWidget(dateFrom: Date | undefined, dateTo: Date | undefined, cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfServiceRequestCompletedMeetingSlaWidgetDto> {
        let url_ = this.baseUrl + "/api/widget/support-requests-widgets/completed-requests-meeting-sla-widget?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompletedRequestsMeetingSlaWidget(_response);
        });
    }

    protected processGetCompletedRequestsMeetingSlaWidget(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfServiceRequestCompletedMeetingSlaWidgetDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfServiceRequestCompletedMeetingSlaWidgetDto.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfServiceRequestCompletedMeetingSlaWidgetDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfServiceRequestCompletedMeetingSlaWidgetDto>(null as any);
    }
}

export interface ITeamClient {
    /**
     * @param body (optional) 
     * @return Success
     */
    createTeam(body: CreateTeam | undefined): Promise<Team>;
    /**
     * @return Success
     */
    enableAccountTeams(accountId: number): Promise<Team[]>;
    /**
     * @return Success
     */
    accountTeams(accountId: number): Promise<Team[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addContracts(body: AddContracts | undefined): Promise<Team>;
    /**
     * @return Success
     */
    deleteTeam(id: number): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    renameTeam(body: RenameTeamObject | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    removeContact(body: AddContacts | undefined): Promise<Team>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addContacts(body: AddContacts | undefined): Promise<Team>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addTicketCategoryMappings(body: AddTicketCategoryMappings | undefined): Promise<Team>;
    /**
     * @param body (optional) 
     * @return Success
     */
    removeContractFromTeam(body: AddContracts | undefined): Promise<Team>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addConfigItemsToTeam(body: AddConfigItems | undefined): Promise<Team>;
    /**
     * @param body (optional) 
     * @return Success
     */
    removeConfigItemsFromTeam(body: AddConfigItems | undefined): Promise<Team>;
    /**
     * @return Success
     */
    getMyTeams(): Promise<AccountTeamReponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    setContactTeamRole(body: SetUserRole | undefined): Promise<ContactTeamRole>;
    /**
     * @return Success
     */
    getSecurityGroupPermissions(accountId: number, teamId: number): Promise<PermissionsReturn>;
    /**
     * @param body (optional) 
     * @return Success
     */
    setSecurityGroupPermissions(accountId: number, body: PermissionsReturn | undefined): Promise<PermissionsReturn>;
    /**
     * @return Success
     */
    getTeamContracts(): Promise<TeamContractReponse>;
}

export class TeamClient extends AuthorizedApiBase implements ITeamClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTeam(body: CreateTeam | undefined, cancelToken?: CancelToken): Promise<Team> {
        let url_ = this.baseUrl + "/api/Team/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateTeam(_response);
        });
    }

    protected processCreateTeam(response: AxiosResponse): Promise<Team> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Team.fromJS(resultData200);
            return Promise.resolve<Team>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Team>(null as any);
    }

    /**
     * @return Success
     */
    enableAccountTeams(accountId: number, cancelToken?: CancelToken): Promise<Team[]> {
        let url_ = this.baseUrl + "/api/Team/enableteams/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnableAccountTeams(_response);
        });
    }

    protected processEnableAccountTeams(response: AxiosResponse): Promise<Team[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Team.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Team[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Team[]>(null as any);
    }

    /**
     * @return Success
     */
    accountTeams(accountId: number, cancelToken?: CancelToken): Promise<Team[]> {
        let url_ = this.baseUrl + "/api/Team/accountteams/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAccountTeams(_response);
        });
    }

    protected processAccountTeams(response: AxiosResponse): Promise<Team[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Team.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Team[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Team[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addContracts(body: AddContracts | undefined, cancelToken?: CancelToken): Promise<Team> {
        let url_ = this.baseUrl + "/api/Team/accountteams/addcontracts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddContracts(_response);
        });
    }

    protected processAddContracts(response: AxiosResponse): Promise<Team> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Team.fromJS(resultData200);
            return Promise.resolve<Team>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Team>(null as any);
    }

    /**
     * @return Success
     */
    deleteTeam(id: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Team/accountteams/delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteTeam(_response);
        });
    }

    protected processDeleteTeam(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    renameTeam(body: RenameTeamObject | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Team/accountteams/renameteam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRenameTeam(_response);
        });
    }

    protected processRenameTeam(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    removeContact(body: AddContacts | undefined, cancelToken?: CancelToken): Promise<Team> {
        let url_ = this.baseUrl + "/api/Team/accountteams/removeuser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveContact(_response);
        });
    }

    protected processRemoveContact(response: AxiosResponse): Promise<Team> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Team.fromJS(resultData200);
            return Promise.resolve<Team>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Team>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addContacts(body: AddContacts | undefined, cancelToken?: CancelToken): Promise<Team> {
        let url_ = this.baseUrl + "/api/Team/accountteams/addusers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddContacts(_response);
        });
    }

    protected processAddContacts(response: AxiosResponse): Promise<Team> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Team.fromJS(resultData200);
            return Promise.resolve<Team>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Team>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addTicketCategoryMappings(body: AddTicketCategoryMappings | undefined, cancelToken?: CancelToken): Promise<Team> {
        let url_ = this.baseUrl + "/api/Team/accountteams/addticketmapping";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddTicketCategoryMappings(_response);
        });
    }

    protected processAddTicketCategoryMappings(response: AxiosResponse): Promise<Team> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Team.fromJS(resultData200);
            return Promise.resolve<Team>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Team>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    removeContractFromTeam(body: AddContracts | undefined, cancelToken?: CancelToken): Promise<Team> {
        let url_ = this.baseUrl + "/api/Team/accountteams/removecontract";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveContractFromTeam(_response);
        });
    }

    protected processRemoveContractFromTeam(response: AxiosResponse): Promise<Team> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Team.fromJS(resultData200);
            return Promise.resolve<Team>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Team>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addConfigItemsToTeam(body: AddConfigItems | undefined, cancelToken?: CancelToken): Promise<Team> {
        let url_ = this.baseUrl + "/api/Team/accountteams/addConfigItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddConfigItemsToTeam(_response);
        });
    }

    protected processAddConfigItemsToTeam(response: AxiosResponse): Promise<Team> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Team.fromJS(resultData200);
            return Promise.resolve<Team>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Team>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    removeConfigItemsFromTeam(body: AddConfigItems | undefined, cancelToken?: CancelToken): Promise<Team> {
        let url_ = this.baseUrl + "/api/Team/accountteams/removeConfigItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveConfigItemsFromTeam(_response);
        });
    }

    protected processRemoveConfigItemsFromTeam(response: AxiosResponse): Promise<Team> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Team.fromJS(resultData200);
            return Promise.resolve<Team>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Team>(null as any);
    }

    /**
     * @return Success
     */
    getMyTeams( cancelToken?: CancelToken): Promise<AccountTeamReponse> {
        let url_ = this.baseUrl + "/api/Team/accountteams/mine";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyTeams(_response);
        });
    }

    protected processGetMyTeams(response: AxiosResponse): Promise<AccountTeamReponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountTeamReponse.fromJS(resultData200);
            return Promise.resolve<AccountTeamReponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountTeamReponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setContactTeamRole(body: SetUserRole | undefined, cancelToken?: CancelToken): Promise<ContactTeamRole> {
        let url_ = this.baseUrl + "/api/Team/setContactTeamRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetContactTeamRole(_response);
        });
    }

    protected processSetContactTeamRole(response: AxiosResponse): Promise<ContactTeamRole> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ContactTeamRole.fromJS(resultData200);
            return Promise.resolve<ContactTeamRole>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContactTeamRole>(null as any);
    }

    /**
     * @return Success
     */
    getSecurityGroupPermissions(accountId: number, teamId: number, cancelToken?: CancelToken): Promise<PermissionsReturn> {
        let url_ = this.baseUrl + "/api/Team/sgPermissions/{accountId}/{teamId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (teamId === undefined || teamId === null)
            throw new Error("The parameter 'teamId' must be defined.");
        url_ = url_.replace("{teamId}", encodeURIComponent("" + teamId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSecurityGroupPermissions(_response);
        });
    }

    protected processGetSecurityGroupPermissions(response: AxiosResponse): Promise<PermissionsReturn> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PermissionsReturn.fromJS(resultData200);
            return Promise.resolve<PermissionsReturn>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PermissionsReturn>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setSecurityGroupPermissions(accountId: number, body: PermissionsReturn | undefined, cancelToken?: CancelToken): Promise<PermissionsReturn> {
        let url_ = this.baseUrl + "/api/Team/sgPermissions/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetSecurityGroupPermissions(_response);
        });
    }

    protected processSetSecurityGroupPermissions(response: AxiosResponse): Promise<PermissionsReturn> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PermissionsReturn.fromJS(resultData200);
            return Promise.resolve<PermissionsReturn>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PermissionsReturn>(null as any);
    }

    /**
     * @return Success
     */
    getTeamContracts( cancelToken?: CancelToken): Promise<TeamContractReponse> {
        let url_ = this.baseUrl + "/api/Team/teamContracts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTeamContracts(_response);
        });
    }

    protected processGetTeamContracts(response: AxiosResponse): Promise<TeamContractReponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TeamContractReponse.fromJS(resultData200);
            return Promise.resolve<TeamContractReponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TeamContractReponse>(null as any);
    }
}

export interface ITestClient {
    /**
     * @return Success
     */
    testEmailAddress(emailAddress: string): Promise<void>;
}

export class TestClient extends AuthorizedApiBase implements ITestClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    testEmailAddress(emailAddress: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Test/testProfile/{emailAddress}";
        if (emailAddress === undefined || emailAddress === null)
            throw new Error("The parameter 'emailAddress' must be defined.");
        url_ = url_.replace("{emailAddress}", encodeURIComponent("" + emailAddress));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestEmailAddress(_response);
        });
    }

    protected processTestEmailAddress(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ITicketClient {
    /**
     * @param body (optional) 
     * @return Success
     */
    createBackupTicket(body: TicketDTO | undefined): Promise<TicketCacheResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    postTicketNote(body: TicketNoteDTO | undefined): Promise<TicketCacheResponse>;
    /**
     * @return Success
     */
    getCurrentTicket(): Promise<TicketCacheResponse>;
    /**
     * @return Success
     */
    checkDeleted(): Promise<TicketCacheResponse>;
    /**
     * @return Success
     */
    getTicketByTicketNumber(ticketNumber: string): Promise<TicketDTO>;
    /**
     * @param body (optional) 
     * @return Success
     */
    postTicketAdditionalContacts(ticketId: number, body: number[] | undefined): Promise<TicketAdditionalContactDTO[]>;
    /**
     * @return Success
     */
    getTicketAdditionalContactsByTicket(ticketId: number): Promise<TicketAdditionalContactDTO[]>;
    /**
     * @return Success
     */
    getTicketAdditionalContactsByContact(contactId: number): Promise<TicketAdditionalContactDTO[]>;
    /**
     * @return Success
     */
    issueTypesByAccountId(): Promise<number[]>;
    /**
     * @return Success
     */
    ticketTypesByAccountId(): Promise<number[]>;
    /**
     * @return Success
     */
    ticketCategoriesByAccountId(): Promise<number[]>;
}

export class TicketClient extends AuthorizedApiBase implements ITicketClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createBackupTicket(body: TicketDTO | undefined, cancelToken?: CancelToken): Promise<TicketCacheResponse> {
        let url_ = this.baseUrl + "/api/Ticket/createBackupTicket";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateBackupTicket(_response);
        });
    }

    protected processCreateBackupTicket(response: AxiosResponse): Promise<TicketCacheResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TicketCacheResponse.fromJS(resultData200);
            return Promise.resolve<TicketCacheResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TicketCacheResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    postTicketNote(body: TicketNoteDTO | undefined, cancelToken?: CancelToken): Promise<TicketCacheResponse> {
        let url_ = this.baseUrl + "/api/Ticket/ticketnote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostTicketNote(_response);
        });
    }

    protected processPostTicketNote(response: AxiosResponse): Promise<TicketCacheResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TicketCacheResponse.fromJS(resultData200);
            return Promise.resolve<TicketCacheResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TicketCacheResponse>(null as any);
    }

    /**
     * @return Success
     */
    getCurrentTicket( cancelToken?: CancelToken): Promise<TicketCacheResponse> {
        let url_ = this.baseUrl + "/api/Ticket/current";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentTicket(_response);
        });
    }

    protected processGetCurrentTicket(response: AxiosResponse): Promise<TicketCacheResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TicketCacheResponse.fromJS(resultData200);
            return Promise.resolve<TicketCacheResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TicketCacheResponse>(null as any);
    }

    /**
     * @return Success
     */
    checkDeleted( cancelToken?: CancelToken): Promise<TicketCacheResponse> {
        let url_ = this.baseUrl + "/api/Ticket/checkdeleted";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckDeleted(_response);
        });
    }

    protected processCheckDeleted(response: AxiosResponse): Promise<TicketCacheResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TicketCacheResponse.fromJS(resultData200);
            return Promise.resolve<TicketCacheResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TicketCacheResponse>(null as any);
    }

    /**
     * @return Success
     */
    getTicketByTicketNumber(ticketNumber: string, cancelToken?: CancelToken): Promise<TicketDTO> {
        let url_ = this.baseUrl + "/api/Ticket/{ticketNumber}";
        if (ticketNumber === undefined || ticketNumber === null)
            throw new Error("The parameter 'ticketNumber' must be defined.");
        url_ = url_.replace("{ticketNumber}", encodeURIComponent("" + ticketNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTicketByTicketNumber(_response);
        });
    }

    protected processGetTicketByTicketNumber(response: AxiosResponse): Promise<TicketDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TicketDTO.fromJS(resultData200);
            return Promise.resolve<TicketDTO>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TicketDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    postTicketAdditionalContacts(ticketId: number, body: number[] | undefined, cancelToken?: CancelToken): Promise<TicketAdditionalContactDTO[]> {
        let url_ = this.baseUrl + "/api/Ticket/additional-contacts/{ticketId}";
        if (ticketId === undefined || ticketId === null)
            throw new Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostTicketAdditionalContacts(_response);
        });
    }

    protected processPostTicketAdditionalContacts(response: AxiosResponse): Promise<TicketAdditionalContactDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TicketAdditionalContactDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TicketAdditionalContactDTO[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TicketAdditionalContactDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    getTicketAdditionalContactsByTicket(ticketId: number, cancelToken?: CancelToken): Promise<TicketAdditionalContactDTO[]> {
        let url_ = this.baseUrl + "/api/Ticket/additional-contacts/ticket/{ticketId}";
        if (ticketId === undefined || ticketId === null)
            throw new Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTicketAdditionalContactsByTicket(_response);
        });
    }

    protected processGetTicketAdditionalContactsByTicket(response: AxiosResponse): Promise<TicketAdditionalContactDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TicketAdditionalContactDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TicketAdditionalContactDTO[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TicketAdditionalContactDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    getTicketAdditionalContactsByContact(contactId: number, cancelToken?: CancelToken): Promise<TicketAdditionalContactDTO[]> {
        let url_ = this.baseUrl + "/api/Ticket/additional-contacts/contact/{contactId}";
        if (contactId === undefined || contactId === null)
            throw new Error("The parameter 'contactId' must be defined.");
        url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTicketAdditionalContactsByContact(_response);
        });
    }

    protected processGetTicketAdditionalContactsByContact(response: AxiosResponse): Promise<TicketAdditionalContactDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TicketAdditionalContactDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TicketAdditionalContactDTO[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TicketAdditionalContactDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    issueTypesByAccountId( cancelToken?: CancelToken): Promise<number[]> {
        let url_ = this.baseUrl + "/api/Ticket/issue-types-filter";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIssueTypesByAccountId(_response);
        });
    }

    protected processIssueTypesByAccountId(response: AxiosResponse): Promise<number[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<number[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * @return Success
     */
    ticketTypesByAccountId( cancelToken?: CancelToken): Promise<number[]> {
        let url_ = this.baseUrl + "/api/Ticket/ticket-types-filter";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTicketTypesByAccountId(_response);
        });
    }

    protected processTicketTypesByAccountId(response: AxiosResponse): Promise<number[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<number[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * @return Success
     */
    ticketCategoriesByAccountId( cancelToken?: CancelToken): Promise<number[]> {
        let url_ = this.baseUrl + "/api/Ticket/ticket-categories-filter";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTicketCategoriesByAccountId(_response);
        });
    }

    protected processTicketCategoriesByAccountId(response: AxiosResponse): Promise<number[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<number[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number[]>(null as any);
    }
}

export interface ITicketIntegrationClient {
    /**
     * @param body (optional) 
     * @return Success
     */
    submitTicket(body: any | undefined): Promise<void>;
    /**
     * @return Success
     */
    deleteTicket(ticketId: string): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addNoteToTicket(ticketId: string, body: any | undefined): Promise<void>;
    /**
     * @return Success
     */
    deleteNoteFromTicket(ticketId: string, noteId: string): Promise<void>;
    /**
     * @param fileName (optional) 
     * @return Success
     */
    addAttachmentToTicket(ticketId: string, fileName: string | undefined): Promise<void>;
}

export class TicketIntegrationClient extends AuthorizedApiBase implements ITicketIntegrationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    submitTicket(body: any | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/TicketIntegration/tickets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitTicket(_response);
        });
    }

    protected processSubmitTicket(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteTicket(ticketId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/TicketIntegration/tickets/{ticketId}";
        if (ticketId === undefined || ticketId === null)
            throw new Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteTicket(_response);
        });
    }

    protected processDeleteTicket(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addNoteToTicket(ticketId: string, body: any | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/TicketIntegration/tickets/{ticketId}/notes";
        if (ticketId === undefined || ticketId === null)
            throw new Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddNoteToTicket(_response);
        });
    }

    protected processAddNoteToTicket(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteNoteFromTicket(ticketId: string, noteId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/TicketIntegration/tickets/{ticketId}/notes/{noteId}";
        if (ticketId === undefined || ticketId === null)
            throw new Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteNoteFromTicket(_response);
        });
    }

    protected processDeleteNoteFromTicket(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param fileName (optional) 
     * @return Success
     */
    addAttachmentToTicket(ticketId: string, fileName: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/TicketIntegration/tickets/{ticketId}/attachments?";
        if (ticketId === undefined || ticketId === null)
            throw new Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        if (fileName === null)
            throw new Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddAttachmentToTicket(_response);
        });
    }

    protected processAddAttachmentToTicket(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ITotalRequestsCompletedWidgetClient {
    /**
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @return Success
     */
    getTotalRequestsCompletedData(dateFrom: Date | undefined, dateTo: Date | undefined): Promise<WidgetContentResponseDto_1OfBarChartDto>;
}

export class TotalRequestsCompletedWidgetClient extends AuthorizedApiBase implements ITotalRequestsCompletedWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @return Success
     */
    getTotalRequestsCompletedData(dateFrom: Date | undefined, dateTo: Date | undefined, cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfBarChartDto> {
        let url_ = this.baseUrl + "/api/widget/total-requests-completed-widget?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTotalRequestsCompletedData(_response);
        });
    }

    protected processGetTotalRequestsCompletedData(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfBarChartDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfBarChartDto.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfBarChartDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfBarChartDto>(null as any);
    }
}

export interface IUserProfileClient {
    /**
     * @return Success
     */
    getCurrentUserProfile(): Promise<UserProfileCacheResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateProfile(body: CreateProfile | undefined): Promise<UserProfileCacheResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    validateShiOneProfile(body: UserProfileValidation | undefined): Promise<UserProfileValidation>;
}

export class UserProfileClient extends AuthorizedApiBase implements IUserProfileClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getCurrentUserProfile( cancelToken?: CancelToken): Promise<UserProfileCacheResponse> {
        let url_ = this.baseUrl + "/api/Profile/currentUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentUserProfile(_response);
        });
    }

    protected processGetCurrentUserProfile(response: AxiosResponse): Promise<UserProfileCacheResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserProfileCacheResponse.fromJS(resultData200);
            return Promise.resolve<UserProfileCacheResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserProfileCacheResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProfile(body: CreateProfile | undefined, cancelToken?: CancelToken): Promise<UserProfileCacheResponse> {
        let url_ = this.baseUrl + "/api/Profile/updateprofile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateProfile(_response);
        });
    }

    protected processUpdateProfile(response: AxiosResponse): Promise<UserProfileCacheResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserProfileCacheResponse.fromJS(resultData200);
            return Promise.resolve<UserProfileCacheResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserProfileCacheResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateShiOneProfile(body: UserProfileValidation | undefined, cancelToken?: CancelToken): Promise<UserProfileValidation> {
        let url_ = this.baseUrl + "/api/Profile/validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateShiOneProfile(_response);
        });
    }

    protected processValidateShiOneProfile(response: AxiosResponse): Promise<UserProfileValidation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserProfileValidation.fromJS(resultData200);
            return Promise.resolve<UserProfileValidation>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserProfileValidation>(null as any);
    }
}

export interface IUserSettingsClient {
    /**
     * @param body (optional) 
     * @return Success
     */
    postUserConfig(body: UserConfigDto | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    deleteUserConfig(body: UserConfigDto | undefined): Promise<void>;
    /**
     * @return Success
     */
    getUserConfigs(): Promise<UserConfigDto[]>;
}

export class UserSettingsClient extends AuthorizedApiBase implements IUserSettingsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    postUserConfig(body: UserConfigDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/UserSettings/user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostUserConfig(_response);
        });
    }

    protected processPostUserConfig(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteUserConfig(body: UserConfigDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/UserSettings/user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteUserConfig(_response);
        });
    }

    protected processDeleteUserConfig(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getUserConfigs( cancelToken?: CancelToken): Promise<UserConfigDto[]> {
        let url_ = this.baseUrl + "/api/UserSettings/user";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserConfigs(_response);
        });
    }

    protected processGetUserConfigs(response: AxiosResponse): Promise<UserConfigDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserConfigDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserConfigDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserConfigDto[]>(null as any);
    }
}

export interface IWarehouseClient {
    /**
     * @return Success
     */
    getWarehouseStock(): Promise<GetWarehouseStockResponse>;
    /**
     * @return Success
     */
    getWarehouseOrders(): Promise<GetWarehouseOrdersResponse>;
}

export class WarehouseClient extends AuthorizedApiBase implements IWarehouseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getWarehouseStock( cancelToken?: CancelToken): Promise<GetWarehouseStockResponse> {
        let url_ = this.baseUrl + "/api/Warehouse/stock";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWarehouseStock(_response);
        });
    }

    protected processGetWarehouseStock(response: AxiosResponse): Promise<GetWarehouseStockResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetWarehouseStockResponse.fromJS(resultData200);
            return Promise.resolve<GetWarehouseStockResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetWarehouseStockResponse>(null as any);
    }

    /**
     * @return Success
     */
    getWarehouseOrders( cancelToken?: CancelToken): Promise<GetWarehouseOrdersResponse> {
        let url_ = this.baseUrl + "/api/Warehouse/orders";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWarehouseOrders(_response);
        });
    }

    protected processGetWarehouseOrders(response: AxiosResponse): Promise<GetWarehouseOrdersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetWarehouseOrdersResponse.fromJS(resultData200);
            return Promise.resolve<GetWarehouseOrdersResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetWarehouseOrdersResponse>(null as any);
    }
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class EmbedToken implements IEmbedToken {
    token?: string | undefined;
    tokenId?: string;
    expiration?: Date;

    constructor(data?: IEmbedToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.tokenId = _data["tokenId"];
            this.expiration = _data["expiration"] ? new Date(_data["expiration"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EmbedToken {
        data = typeof data === 'object' ? data : {};
        let result = new EmbedToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["tokenId"] = this.tokenId;
        data["expiration"] = this.expiration ? this.expiration.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEmbedToken {
    token?: string | undefined;
    tokenId?: string;
    expiration?: Date;
}

export class DateMath implements IDateMath {

    constructor(data?: IDateMath) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DateMath {
        data = typeof data === 'object' ? data : {};
        let result = new DateMath();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IDateMath {
}

export enum SortOrder {
    Asc = "asc",
    Desc = "desc",
}

export class Response implements IResponse {
    statusCode?: HttpStatusCode;
    readonly isSuccessStatusCode?: boolean;
    body?: HttpContent;
    headers?: KeyValuePair_2OfStringAndIEnumerable_1OfString[] | undefined;

    constructor(data?: IResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            (<any>this).isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.body = _data["body"] ? HttpContent.fromJS(_data["body"]) : <any>undefined;
            if (Array.isArray(_data["headers"])) {
                this.headers = [] as any;
                for (let item of _data["headers"])
                    this.headers!.push(KeyValuePair_2OfStringAndIEnumerable_1OfString.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Response {
        data = typeof data === 'object' ? data : {};
        let result = new Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["body"] = this.body ? this.body.toJSON() : <any>undefined;
        if (Array.isArray(this.headers)) {
            data["headers"] = [];
            for (let item of this.headers)
                data["headers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponse {
    statusCode?: HttpStatusCode;
    isSuccessStatusCode?: boolean;
    body?: HttpContent;
    headers?: KeyValuePair_2OfStringAndIEnumerable_1OfString[] | undefined;
}

export class DattoDevicesStatus implements IDattoDevicesStatus {
    numberOfDevices?: number;
    numberOfOnlineDevices?: number;
    numberOfOfflineDevices?: number;

    constructor(data?: IDattoDevicesStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numberOfDevices = _data["numberOfDevices"];
            this.numberOfOnlineDevices = _data["numberOfOnlineDevices"];
            this.numberOfOfflineDevices = _data["numberOfOfflineDevices"];
        }
    }

    static fromJS(data: any): DattoDevicesStatus {
        data = typeof data === 'object' ? data : {};
        let result = new DattoDevicesStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numberOfDevices"] = this.numberOfDevices;
        data["numberOfOnlineDevices"] = this.numberOfOnlineDevices;
        data["numberOfOfflineDevices"] = this.numberOfOfflineDevices;
        return data;
    }
}

export interface IDattoDevicesStatus {
    numberOfDevices?: number;
    numberOfOnlineDevices?: number;
    numberOfOfflineDevices?: number;
}

export class DattoSite implements IDattoSite {
    id?: number;
    uid?: string | undefined;
    accountUid?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    onDemand?: boolean;
    splashtopAutoInstall?: boolean;
    devicesStatus?: DattoDevicesStatus;
    autotaskCompanyName?: string | undefined;
    autotaskCompanyId?: string | undefined;
    portalUrl?: string | undefined;

    constructor(data?: IDattoSite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.uid = _data["uid"];
            this.accountUid = _data["accountUid"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.onDemand = _data["onDemand"];
            this.splashtopAutoInstall = _data["splashtopAutoInstall"];
            this.devicesStatus = _data["devicesStatus"] ? DattoDevicesStatus.fromJS(_data["devicesStatus"]) : <any>undefined;
            this.autotaskCompanyName = _data["autotaskCompanyName"];
            this.autotaskCompanyId = _data["autotaskCompanyId"];
            this.portalUrl = _data["portalUrl"];
        }
    }

    static fromJS(data: any): DattoSite {
        data = typeof data === 'object' ? data : {};
        let result = new DattoSite();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["uid"] = this.uid;
        data["accountUid"] = this.accountUid;
        data["name"] = this.name;
        data["description"] = this.description;
        data["onDemand"] = this.onDemand;
        data["splashtopAutoInstall"] = this.splashtopAutoInstall;
        data["devicesStatus"] = this.devicesStatus ? this.devicesStatus.toJSON() : <any>undefined;
        data["autotaskCompanyName"] = this.autotaskCompanyName;
        data["autotaskCompanyId"] = this.autotaskCompanyId;
        data["portalUrl"] = this.portalUrl;
        return data;
    }
}

export interface IDattoSite {
    id?: number;
    uid?: string | undefined;
    accountUid?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    onDemand?: boolean;
    splashtopAutoInstall?: boolean;
    devicesStatus?: DattoDevicesStatus;
    autotaskCompanyName?: string | undefined;
    autotaskCompanyId?: string | undefined;
    portalUrl?: string | undefined;
}

export class CurrentInstance implements ICurrentInstance {
    currencyCode?: string | undefined;
    instanceName?: string | undefined;
    monthlyCost?: string | undefined;
    onDemandHoursInLookbackPeriod?: string | undefined;
    reservationCoveredHoursInLookbackPeriod?: string | undefined;
    resourceDetails?: ResourceDetails;
    resourceId?: string | undefined;
    resourceUtilization?: ResourceUtilization;
    savingsPlansCoveredHoursInLookbackPeriod?: string | undefined;
    tags?: TagValues[] | undefined;
    totalRunningHoursInLookbackPeriod?: string | undefined;

    constructor(data?: ICurrentInstance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currencyCode = _data["currencyCode"];
            this.instanceName = _data["instanceName"];
            this.monthlyCost = _data["monthlyCost"];
            this.onDemandHoursInLookbackPeriod = _data["onDemandHoursInLookbackPeriod"];
            this.reservationCoveredHoursInLookbackPeriod = _data["reservationCoveredHoursInLookbackPeriod"];
            this.resourceDetails = _data["resourceDetails"] ? ResourceDetails.fromJS(_data["resourceDetails"]) : <any>undefined;
            this.resourceId = _data["resourceId"];
            this.resourceUtilization = _data["resourceUtilization"] ? ResourceUtilization.fromJS(_data["resourceUtilization"]) : <any>undefined;
            this.savingsPlansCoveredHoursInLookbackPeriod = _data["savingsPlansCoveredHoursInLookbackPeriod"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagValues.fromJS(item));
            }
            this.totalRunningHoursInLookbackPeriod = _data["totalRunningHoursInLookbackPeriod"];
        }
    }

    static fromJS(data: any): CurrentInstance {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentInstance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyCode"] = this.currencyCode;
        data["instanceName"] = this.instanceName;
        data["monthlyCost"] = this.monthlyCost;
        data["onDemandHoursInLookbackPeriod"] = this.onDemandHoursInLookbackPeriod;
        data["reservationCoveredHoursInLookbackPeriod"] = this.reservationCoveredHoursInLookbackPeriod;
        data["resourceDetails"] = this.resourceDetails ? this.resourceDetails.toJSON() : <any>undefined;
        data["resourceId"] = this.resourceId;
        data["resourceUtilization"] = this.resourceUtilization ? this.resourceUtilization.toJSON() : <any>undefined;
        data["savingsPlansCoveredHoursInLookbackPeriod"] = this.savingsPlansCoveredHoursInLookbackPeriod;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        data["totalRunningHoursInLookbackPeriod"] = this.totalRunningHoursInLookbackPeriod;
        return data;
    }
}

export interface ICurrentInstance {
    currencyCode?: string | undefined;
    instanceName?: string | undefined;
    monthlyCost?: string | undefined;
    onDemandHoursInLookbackPeriod?: string | undefined;
    reservationCoveredHoursInLookbackPeriod?: string | undefined;
    resourceDetails?: ResourceDetails;
    resourceId?: string | undefined;
    resourceUtilization?: ResourceUtilization;
    savingsPlansCoveredHoursInLookbackPeriod?: string | undefined;
    tags?: TagValues[] | undefined;
    totalRunningHoursInLookbackPeriod?: string | undefined;
}

export class EBSResourceUtilization implements IEBSResourceUtilization {
    ebsReadBytesPerSecond?: string | undefined;
    ebsReadOpsPerSecond?: string | undefined;
    ebsWriteBytesPerSecond?: string | undefined;
    ebsWriteOpsPerSecond?: string | undefined;

    constructor(data?: IEBSResourceUtilization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ebsReadBytesPerSecond = _data["ebsReadBytesPerSecond"];
            this.ebsReadOpsPerSecond = _data["ebsReadOpsPerSecond"];
            this.ebsWriteBytesPerSecond = _data["ebsWriteBytesPerSecond"];
            this.ebsWriteOpsPerSecond = _data["ebsWriteOpsPerSecond"];
        }
    }

    static fromJS(data: any): EBSResourceUtilization {
        data = typeof data === 'object' ? data : {};
        let result = new EBSResourceUtilization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ebsReadBytesPerSecond"] = this.ebsReadBytesPerSecond;
        data["ebsReadOpsPerSecond"] = this.ebsReadOpsPerSecond;
        data["ebsWriteBytesPerSecond"] = this.ebsWriteBytesPerSecond;
        data["ebsWriteOpsPerSecond"] = this.ebsWriteOpsPerSecond;
        return data;
    }
}

export interface IEBSResourceUtilization {
    ebsReadBytesPerSecond?: string | undefined;
    ebsReadOpsPerSecond?: string | undefined;
    ebsWriteBytesPerSecond?: string | undefined;
    ebsWriteOpsPerSecond?: string | undefined;
}

export class EC2InstanceDetails implements IEC2InstanceDetails {
    availabilityZone?: string | undefined;
    currentGeneration?: boolean;
    family?: string | undefined;
    instanceType?: string | undefined;
    platform?: string | undefined;
    region?: string | undefined;
    sizeFlexEligible?: boolean;
    tenancy?: string | undefined;

    constructor(data?: IEC2InstanceDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.availabilityZone = _data["availabilityZone"];
            this.currentGeneration = _data["currentGeneration"];
            this.family = _data["family"];
            this.instanceType = _data["instanceType"];
            this.platform = _data["platform"];
            this.region = _data["region"];
            this.sizeFlexEligible = _data["sizeFlexEligible"];
            this.tenancy = _data["tenancy"];
        }
    }

    static fromJS(data: any): EC2InstanceDetails {
        data = typeof data === 'object' ? data : {};
        let result = new EC2InstanceDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["availabilityZone"] = this.availabilityZone;
        data["currentGeneration"] = this.currentGeneration;
        data["family"] = this.family;
        data["instanceType"] = this.instanceType;
        data["platform"] = this.platform;
        data["region"] = this.region;
        data["sizeFlexEligible"] = this.sizeFlexEligible;
        data["tenancy"] = this.tenancy;
        return data;
    }
}

export interface IEC2InstanceDetails {
    availabilityZone?: string | undefined;
    currentGeneration?: boolean;
    family?: string | undefined;
    instanceType?: string | undefined;
    platform?: string | undefined;
    region?: string | undefined;
    sizeFlexEligible?: boolean;
    tenancy?: string | undefined;
}

export class EC2ResourceDetails implements IEC2ResourceDetails {
    hourlyOnDemandRate?: string | undefined;
    instanceType?: string | undefined;
    memory?: string | undefined;
    networkPerformance?: string | undefined;
    platform?: string | undefined;
    region?: string | undefined;
    sku?: string | undefined;
    storage?: string | undefined;
    vcpu?: string | undefined;

    constructor(data?: IEC2ResourceDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hourlyOnDemandRate = _data["hourlyOnDemandRate"];
            this.instanceType = _data["instanceType"];
            this.memory = _data["memory"];
            this.networkPerformance = _data["networkPerformance"];
            this.platform = _data["platform"];
            this.region = _data["region"];
            this.sku = _data["sku"];
            this.storage = _data["storage"];
            this.vcpu = _data["vcpu"];
        }
    }

    static fromJS(data: any): EC2ResourceDetails {
        data = typeof data === 'object' ? data : {};
        let result = new EC2ResourceDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hourlyOnDemandRate"] = this.hourlyOnDemandRate;
        data["instanceType"] = this.instanceType;
        data["memory"] = this.memory;
        data["networkPerformance"] = this.networkPerformance;
        data["platform"] = this.platform;
        data["region"] = this.region;
        data["sku"] = this.sku;
        data["storage"] = this.storage;
        data["vcpu"] = this.vcpu;
        return data;
    }
}

export interface IEC2ResourceDetails {
    hourlyOnDemandRate?: string | undefined;
    instanceType?: string | undefined;
    memory?: string | undefined;
    networkPerformance?: string | undefined;
    platform?: string | undefined;
    region?: string | undefined;
    sku?: string | undefined;
    storage?: string | undefined;
    vcpu?: string | undefined;
}

export class EC2ResourceUtilization implements IEC2ResourceUtilization {
    ebsResourceUtilization?: EBSResourceUtilization;
    maxCpuUtilizationPercentage?: string | undefined;
    maxMemoryUtilizationPercentage?: string | undefined;
    maxStorageUtilizationPercentage?: string | undefined;

    constructor(data?: IEC2ResourceUtilization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ebsResourceUtilization = _data["ebsResourceUtilization"] ? EBSResourceUtilization.fromJS(_data["ebsResourceUtilization"]) : <any>undefined;
            this.maxCpuUtilizationPercentage = _data["maxCpuUtilizationPercentage"];
            this.maxMemoryUtilizationPercentage = _data["maxMemoryUtilizationPercentage"];
            this.maxStorageUtilizationPercentage = _data["maxStorageUtilizationPercentage"];
        }
    }

    static fromJS(data: any): EC2ResourceUtilization {
        data = typeof data === 'object' ? data : {};
        let result = new EC2ResourceUtilization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ebsResourceUtilization"] = this.ebsResourceUtilization ? this.ebsResourceUtilization.toJSON() : <any>undefined;
        data["maxCpuUtilizationPercentage"] = this.maxCpuUtilizationPercentage;
        data["maxMemoryUtilizationPercentage"] = this.maxMemoryUtilizationPercentage;
        data["maxStorageUtilizationPercentage"] = this.maxStorageUtilizationPercentage;
        return data;
    }
}

export interface IEC2ResourceUtilization {
    ebsResourceUtilization?: EBSResourceUtilization;
    maxCpuUtilizationPercentage?: string | undefined;
    maxMemoryUtilizationPercentage?: string | undefined;
    maxStorageUtilizationPercentage?: string | undefined;
}

export class EC2Specification implements IEC2Specification {
    offeringClass?: string | undefined;

    constructor(data?: IEC2Specification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offeringClass = _data["offeringClass"];
        }
    }

    static fromJS(data: any): EC2Specification {
        data = typeof data === 'object' ? data : {};
        let result = new EC2Specification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offeringClass"] = this.offeringClass;
        return data;
    }
}

export interface IEC2Specification {
    offeringClass?: string | undefined;
}

export class ESInstanceDetails implements IESInstanceDetails {
    currentGeneration?: boolean;
    instanceClass?: string | undefined;
    instanceSize?: string | undefined;
    region?: string | undefined;
    sizeFlexEligible?: boolean;

    constructor(data?: IESInstanceDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentGeneration = _data["currentGeneration"];
            this.instanceClass = _data["instanceClass"];
            this.instanceSize = _data["instanceSize"];
            this.region = _data["region"];
            this.sizeFlexEligible = _data["sizeFlexEligible"];
        }
    }

    static fromJS(data: any): ESInstanceDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ESInstanceDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentGeneration"] = this.currentGeneration;
        data["instanceClass"] = this.instanceClass;
        data["instanceSize"] = this.instanceSize;
        data["region"] = this.region;
        data["sizeFlexEligible"] = this.sizeFlexEligible;
        return data;
    }
}

export interface IESInstanceDetails {
    currentGeneration?: boolean;
    instanceClass?: string | undefined;
    instanceSize?: string | undefined;
    region?: string | undefined;
    sizeFlexEligible?: boolean;
}

export class ElastiCacheInstanceDetails implements IElastiCacheInstanceDetails {
    currentGeneration?: boolean;
    family?: string | undefined;
    nodeType?: string | undefined;
    productDescription?: string | undefined;
    region?: string | undefined;
    sizeFlexEligible?: boolean;

    constructor(data?: IElastiCacheInstanceDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentGeneration = _data["currentGeneration"];
            this.family = _data["family"];
            this.nodeType = _data["nodeType"];
            this.productDescription = _data["productDescription"];
            this.region = _data["region"];
            this.sizeFlexEligible = _data["sizeFlexEligible"];
        }
    }

    static fromJS(data: any): ElastiCacheInstanceDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ElastiCacheInstanceDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentGeneration"] = this.currentGeneration;
        data["family"] = this.family;
        data["nodeType"] = this.nodeType;
        data["productDescription"] = this.productDescription;
        data["region"] = this.region;
        data["sizeFlexEligible"] = this.sizeFlexEligible;
        return data;
    }
}

export interface IElastiCacheInstanceDetails {
    currentGeneration?: boolean;
    family?: string | undefined;
    nodeType?: string | undefined;
    productDescription?: string | undefined;
    region?: string | undefined;
    sizeFlexEligible?: boolean;
}

export class InstanceDetails implements IInstanceDetails {
    eC2InstanceDetails?: EC2InstanceDetails;
    elastiCacheInstanceDetails?: ElastiCacheInstanceDetails;
    esInstanceDetails?: ESInstanceDetails;
    rdsInstanceDetails?: RDSInstanceDetails;
    redshiftInstanceDetails?: RedshiftInstanceDetails;

    constructor(data?: IInstanceDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eC2InstanceDetails = _data["eC2InstanceDetails"] ? EC2InstanceDetails.fromJS(_data["eC2InstanceDetails"]) : <any>undefined;
            this.elastiCacheInstanceDetails = _data["elastiCacheInstanceDetails"] ? ElastiCacheInstanceDetails.fromJS(_data["elastiCacheInstanceDetails"]) : <any>undefined;
            this.esInstanceDetails = _data["esInstanceDetails"] ? ESInstanceDetails.fromJS(_data["esInstanceDetails"]) : <any>undefined;
            this.rdsInstanceDetails = _data["rdsInstanceDetails"] ? RDSInstanceDetails.fromJS(_data["rdsInstanceDetails"]) : <any>undefined;
            this.redshiftInstanceDetails = _data["redshiftInstanceDetails"] ? RedshiftInstanceDetails.fromJS(_data["redshiftInstanceDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InstanceDetails {
        data = typeof data === 'object' ? data : {};
        let result = new InstanceDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eC2InstanceDetails"] = this.eC2InstanceDetails ? this.eC2InstanceDetails.toJSON() : <any>undefined;
        data["elastiCacheInstanceDetails"] = this.elastiCacheInstanceDetails ? this.elastiCacheInstanceDetails.toJSON() : <any>undefined;
        data["esInstanceDetails"] = this.esInstanceDetails ? this.esInstanceDetails.toJSON() : <any>undefined;
        data["rdsInstanceDetails"] = this.rdsInstanceDetails ? this.rdsInstanceDetails.toJSON() : <any>undefined;
        data["redshiftInstanceDetails"] = this.redshiftInstanceDetails ? this.redshiftInstanceDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IInstanceDetails {
    eC2InstanceDetails?: EC2InstanceDetails;
    elastiCacheInstanceDetails?: ElastiCacheInstanceDetails;
    esInstanceDetails?: ESInstanceDetails;
    rdsInstanceDetails?: RDSInstanceDetails;
    redshiftInstanceDetails?: RedshiftInstanceDetails;
}

export class ModifyRecommendationDetail implements IModifyRecommendationDetail {
    targetInstances?: TargetInstance[] | undefined;

    constructor(data?: IModifyRecommendationDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["targetInstances"])) {
                this.targetInstances = [] as any;
                for (let item of _data["targetInstances"])
                    this.targetInstances!.push(TargetInstance.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ModifyRecommendationDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ModifyRecommendationDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.targetInstances)) {
            data["targetInstances"] = [];
            for (let item of this.targetInstances)
                data["targetInstances"].push(item.toJSON());
        }
        return data;
    }
}

export interface IModifyRecommendationDetail {
    targetInstances?: TargetInstance[] | undefined;
}

export class RDSInstanceDetails implements IRDSInstanceDetails {
    currentGeneration?: boolean;
    databaseEdition?: string | undefined;
    databaseEngine?: string | undefined;
    deploymentOption?: string | undefined;
    family?: string | undefined;
    instanceType?: string | undefined;
    licenseModel?: string | undefined;
    region?: string | undefined;
    sizeFlexEligible?: boolean;

    constructor(data?: IRDSInstanceDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentGeneration = _data["currentGeneration"];
            this.databaseEdition = _data["databaseEdition"];
            this.databaseEngine = _data["databaseEngine"];
            this.deploymentOption = _data["deploymentOption"];
            this.family = _data["family"];
            this.instanceType = _data["instanceType"];
            this.licenseModel = _data["licenseModel"];
            this.region = _data["region"];
            this.sizeFlexEligible = _data["sizeFlexEligible"];
        }
    }

    static fromJS(data: any): RDSInstanceDetails {
        data = typeof data === 'object' ? data : {};
        let result = new RDSInstanceDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentGeneration"] = this.currentGeneration;
        data["databaseEdition"] = this.databaseEdition;
        data["databaseEngine"] = this.databaseEngine;
        data["deploymentOption"] = this.deploymentOption;
        data["family"] = this.family;
        data["instanceType"] = this.instanceType;
        data["licenseModel"] = this.licenseModel;
        data["region"] = this.region;
        data["sizeFlexEligible"] = this.sizeFlexEligible;
        return data;
    }
}

export interface IRDSInstanceDetails {
    currentGeneration?: boolean;
    databaseEdition?: string | undefined;
    databaseEngine?: string | undefined;
    deploymentOption?: string | undefined;
    family?: string | undefined;
    instanceType?: string | undefined;
    licenseModel?: string | undefined;
    region?: string | undefined;
    sizeFlexEligible?: boolean;
}

export class RedshiftInstanceDetails implements IRedshiftInstanceDetails {
    currentGeneration?: boolean;
    family?: string | undefined;
    nodeType?: string | undefined;
    region?: string | undefined;
    sizeFlexEligible?: boolean;

    constructor(data?: IRedshiftInstanceDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentGeneration = _data["currentGeneration"];
            this.family = _data["family"];
            this.nodeType = _data["nodeType"];
            this.region = _data["region"];
            this.sizeFlexEligible = _data["sizeFlexEligible"];
        }
    }

    static fromJS(data: any): RedshiftInstanceDetails {
        data = typeof data === 'object' ? data : {};
        let result = new RedshiftInstanceDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentGeneration"] = this.currentGeneration;
        data["family"] = this.family;
        data["nodeType"] = this.nodeType;
        data["region"] = this.region;
        data["sizeFlexEligible"] = this.sizeFlexEligible;
        return data;
    }
}

export interface IRedshiftInstanceDetails {
    currentGeneration?: boolean;
    family?: string | undefined;
    nodeType?: string | undefined;
    region?: string | undefined;
    sizeFlexEligible?: boolean;
}

export class ReservationPurchaseRecommendation implements IReservationPurchaseRecommendation {
    accountScope?: string | undefined;
    lookbackPeriodInDays?: string | undefined;
    paymentOption?: string | undefined;
    recommendationDetails?: ReservationPurchaseRecommendationDetail[] | undefined;
    recommendationSummary?: ReservationPurchaseRecommendationSummary;
    serviceSpecification?: ServiceSpecification;
    termInYears?: string | undefined;

    constructor(data?: IReservationPurchaseRecommendation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountScope = _data["accountScope"];
            this.lookbackPeriodInDays = _data["lookbackPeriodInDays"];
            this.paymentOption = _data["paymentOption"];
            if (Array.isArray(_data["recommendationDetails"])) {
                this.recommendationDetails = [] as any;
                for (let item of _data["recommendationDetails"])
                    this.recommendationDetails!.push(ReservationPurchaseRecommendationDetail.fromJS(item));
            }
            this.recommendationSummary = _data["recommendationSummary"] ? ReservationPurchaseRecommendationSummary.fromJS(_data["recommendationSummary"]) : <any>undefined;
            this.serviceSpecification = _data["serviceSpecification"] ? ServiceSpecification.fromJS(_data["serviceSpecification"]) : <any>undefined;
            this.termInYears = _data["termInYears"];
        }
    }

    static fromJS(data: any): ReservationPurchaseRecommendation {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationPurchaseRecommendation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountScope"] = this.accountScope;
        data["lookbackPeriodInDays"] = this.lookbackPeriodInDays;
        data["paymentOption"] = this.paymentOption;
        if (Array.isArray(this.recommendationDetails)) {
            data["recommendationDetails"] = [];
            for (let item of this.recommendationDetails)
                data["recommendationDetails"].push(item.toJSON());
        }
        data["recommendationSummary"] = this.recommendationSummary ? this.recommendationSummary.toJSON() : <any>undefined;
        data["serviceSpecification"] = this.serviceSpecification ? this.serviceSpecification.toJSON() : <any>undefined;
        data["termInYears"] = this.termInYears;
        return data;
    }
}

export interface IReservationPurchaseRecommendation {
    accountScope?: string | undefined;
    lookbackPeriodInDays?: string | undefined;
    paymentOption?: string | undefined;
    recommendationDetails?: ReservationPurchaseRecommendationDetail[] | undefined;
    recommendationSummary?: ReservationPurchaseRecommendationSummary;
    serviceSpecification?: ServiceSpecification;
    termInYears?: string | undefined;
}

export class ReservationPurchaseRecommendationDetail implements IReservationPurchaseRecommendationDetail {
    accountId?: string | undefined;
    averageNormalizedUnitsUsedPerHour?: string | undefined;
    averageNumberOfInstancesUsedPerHour?: string | undefined;
    averageUtilization?: string | undefined;
    currencyCode?: string | undefined;
    estimatedBreakEvenInMonths?: string | undefined;
    estimatedMonthlyOnDemandCost?: string | undefined;
    estimatedMonthlySavingsAmount?: string | undefined;
    estimatedMonthlySavingsPercentage?: string | undefined;
    estimatedReservationCostForLookbackPeriod?: string | undefined;
    instanceDetails?: InstanceDetails;
    maximumNormalizedUnitsUsedPerHour?: string | undefined;
    maximumNumberOfInstancesUsedPerHour?: string | undefined;
    minimumNormalizedUnitsUsedPerHour?: string | undefined;
    minimumNumberOfInstancesUsedPerHour?: string | undefined;
    recommendedNormalizedUnitsToPurchase?: string | undefined;
    recommendedNumberOfInstancesToPurchase?: string | undefined;
    recurringStandardMonthlyCost?: string | undefined;
    upfrontCost?: string | undefined;

    constructor(data?: IReservationPurchaseRecommendationDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.averageNormalizedUnitsUsedPerHour = _data["averageNormalizedUnitsUsedPerHour"];
            this.averageNumberOfInstancesUsedPerHour = _data["averageNumberOfInstancesUsedPerHour"];
            this.averageUtilization = _data["averageUtilization"];
            this.currencyCode = _data["currencyCode"];
            this.estimatedBreakEvenInMonths = _data["estimatedBreakEvenInMonths"];
            this.estimatedMonthlyOnDemandCost = _data["estimatedMonthlyOnDemandCost"];
            this.estimatedMonthlySavingsAmount = _data["estimatedMonthlySavingsAmount"];
            this.estimatedMonthlySavingsPercentage = _data["estimatedMonthlySavingsPercentage"];
            this.estimatedReservationCostForLookbackPeriod = _data["estimatedReservationCostForLookbackPeriod"];
            this.instanceDetails = _data["instanceDetails"] ? InstanceDetails.fromJS(_data["instanceDetails"]) : <any>undefined;
            this.maximumNormalizedUnitsUsedPerHour = _data["maximumNormalizedUnitsUsedPerHour"];
            this.maximumNumberOfInstancesUsedPerHour = _data["maximumNumberOfInstancesUsedPerHour"];
            this.minimumNormalizedUnitsUsedPerHour = _data["minimumNormalizedUnitsUsedPerHour"];
            this.minimumNumberOfInstancesUsedPerHour = _data["minimumNumberOfInstancesUsedPerHour"];
            this.recommendedNormalizedUnitsToPurchase = _data["recommendedNormalizedUnitsToPurchase"];
            this.recommendedNumberOfInstancesToPurchase = _data["recommendedNumberOfInstancesToPurchase"];
            this.recurringStandardMonthlyCost = _data["recurringStandardMonthlyCost"];
            this.upfrontCost = _data["upfrontCost"];
        }
    }

    static fromJS(data: any): ReservationPurchaseRecommendationDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationPurchaseRecommendationDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["averageNormalizedUnitsUsedPerHour"] = this.averageNormalizedUnitsUsedPerHour;
        data["averageNumberOfInstancesUsedPerHour"] = this.averageNumberOfInstancesUsedPerHour;
        data["averageUtilization"] = this.averageUtilization;
        data["currencyCode"] = this.currencyCode;
        data["estimatedBreakEvenInMonths"] = this.estimatedBreakEvenInMonths;
        data["estimatedMonthlyOnDemandCost"] = this.estimatedMonthlyOnDemandCost;
        data["estimatedMonthlySavingsAmount"] = this.estimatedMonthlySavingsAmount;
        data["estimatedMonthlySavingsPercentage"] = this.estimatedMonthlySavingsPercentage;
        data["estimatedReservationCostForLookbackPeriod"] = this.estimatedReservationCostForLookbackPeriod;
        data["instanceDetails"] = this.instanceDetails ? this.instanceDetails.toJSON() : <any>undefined;
        data["maximumNormalizedUnitsUsedPerHour"] = this.maximumNormalizedUnitsUsedPerHour;
        data["maximumNumberOfInstancesUsedPerHour"] = this.maximumNumberOfInstancesUsedPerHour;
        data["minimumNormalizedUnitsUsedPerHour"] = this.minimumNormalizedUnitsUsedPerHour;
        data["minimumNumberOfInstancesUsedPerHour"] = this.minimumNumberOfInstancesUsedPerHour;
        data["recommendedNormalizedUnitsToPurchase"] = this.recommendedNormalizedUnitsToPurchase;
        data["recommendedNumberOfInstancesToPurchase"] = this.recommendedNumberOfInstancesToPurchase;
        data["recurringStandardMonthlyCost"] = this.recurringStandardMonthlyCost;
        data["upfrontCost"] = this.upfrontCost;
        return data;
    }
}

export interface IReservationPurchaseRecommendationDetail {
    accountId?: string | undefined;
    averageNormalizedUnitsUsedPerHour?: string | undefined;
    averageNumberOfInstancesUsedPerHour?: string | undefined;
    averageUtilization?: string | undefined;
    currencyCode?: string | undefined;
    estimatedBreakEvenInMonths?: string | undefined;
    estimatedMonthlyOnDemandCost?: string | undefined;
    estimatedMonthlySavingsAmount?: string | undefined;
    estimatedMonthlySavingsPercentage?: string | undefined;
    estimatedReservationCostForLookbackPeriod?: string | undefined;
    instanceDetails?: InstanceDetails;
    maximumNormalizedUnitsUsedPerHour?: string | undefined;
    maximumNumberOfInstancesUsedPerHour?: string | undefined;
    minimumNormalizedUnitsUsedPerHour?: string | undefined;
    minimumNumberOfInstancesUsedPerHour?: string | undefined;
    recommendedNormalizedUnitsToPurchase?: string | undefined;
    recommendedNumberOfInstancesToPurchase?: string | undefined;
    recurringStandardMonthlyCost?: string | undefined;
    upfrontCost?: string | undefined;
}

export class ReservationPurchaseRecommendationSummary implements IReservationPurchaseRecommendationSummary {
    currencyCode?: string | undefined;
    totalEstimatedMonthlySavingsAmount?: string | undefined;
    totalEstimatedMonthlySavingsPercentage?: string | undefined;

    constructor(data?: IReservationPurchaseRecommendationSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currencyCode = _data["currencyCode"];
            this.totalEstimatedMonthlySavingsAmount = _data["totalEstimatedMonthlySavingsAmount"];
            this.totalEstimatedMonthlySavingsPercentage = _data["totalEstimatedMonthlySavingsPercentage"];
        }
    }

    static fromJS(data: any): ReservationPurchaseRecommendationSummary {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationPurchaseRecommendationSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyCode"] = this.currencyCode;
        data["totalEstimatedMonthlySavingsAmount"] = this.totalEstimatedMonthlySavingsAmount;
        data["totalEstimatedMonthlySavingsPercentage"] = this.totalEstimatedMonthlySavingsPercentage;
        return data;
    }
}

export interface IReservationPurchaseRecommendationSummary {
    currencyCode?: string | undefined;
    totalEstimatedMonthlySavingsAmount?: string | undefined;
    totalEstimatedMonthlySavingsPercentage?: string | undefined;
}

export class ResourceDetails implements IResourceDetails {
    eC2ResourceDetails?: EC2ResourceDetails;

    constructor(data?: IResourceDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eC2ResourceDetails = _data["eC2ResourceDetails"] ? EC2ResourceDetails.fromJS(_data["eC2ResourceDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResourceDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eC2ResourceDetails"] = this.eC2ResourceDetails ? this.eC2ResourceDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResourceDetails {
    eC2ResourceDetails?: EC2ResourceDetails;
}

export class ResourceUtilization implements IResourceUtilization {
    eC2ResourceUtilization?: EC2ResourceUtilization;

    constructor(data?: IResourceUtilization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eC2ResourceUtilization = _data["eC2ResourceUtilization"] ? EC2ResourceUtilization.fromJS(_data["eC2ResourceUtilization"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResourceUtilization {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceUtilization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eC2ResourceUtilization"] = this.eC2ResourceUtilization ? this.eC2ResourceUtilization.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResourceUtilization {
    eC2ResourceUtilization?: EC2ResourceUtilization;
}

export class RightsizingRecommendation implements IRightsizingRecommendation {
    accountId?: string | undefined;
    currentInstance?: CurrentInstance;
    modifyRecommendationDetail?: ModifyRecommendationDetail;
    rightsizingType?: string | undefined;
    terminateRecommendationDetail?: TerminateRecommendationDetail;

    constructor(data?: IRightsizingRecommendation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.currentInstance = _data["currentInstance"] ? CurrentInstance.fromJS(_data["currentInstance"]) : <any>undefined;
            this.modifyRecommendationDetail = _data["modifyRecommendationDetail"] ? ModifyRecommendationDetail.fromJS(_data["modifyRecommendationDetail"]) : <any>undefined;
            this.rightsizingType = _data["rightsizingType"];
            this.terminateRecommendationDetail = _data["terminateRecommendationDetail"] ? TerminateRecommendationDetail.fromJS(_data["terminateRecommendationDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RightsizingRecommendation {
        data = typeof data === 'object' ? data : {};
        let result = new RightsizingRecommendation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["currentInstance"] = this.currentInstance ? this.currentInstance.toJSON() : <any>undefined;
        data["modifyRecommendationDetail"] = this.modifyRecommendationDetail ? this.modifyRecommendationDetail.toJSON() : <any>undefined;
        data["rightsizingType"] = this.rightsizingType;
        data["terminateRecommendationDetail"] = this.terminateRecommendationDetail ? this.terminateRecommendationDetail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRightsizingRecommendation {
    accountId?: string | undefined;
    currentInstance?: CurrentInstance;
    modifyRecommendationDetail?: ModifyRecommendationDetail;
    rightsizingType?: string | undefined;
    terminateRecommendationDetail?: TerminateRecommendationDetail;
}

export class SavingsPlansDetails implements ISavingsPlansDetails {
    instanceFamily?: string | undefined;
    offeringId?: string | undefined;
    region?: string | undefined;

    constructor(data?: ISavingsPlansDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.instanceFamily = _data["instanceFamily"];
            this.offeringId = _data["offeringId"];
            this.region = _data["region"];
        }
    }

    static fromJS(data: any): SavingsPlansDetails {
        data = typeof data === 'object' ? data : {};
        let result = new SavingsPlansDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["instanceFamily"] = this.instanceFamily;
        data["offeringId"] = this.offeringId;
        data["region"] = this.region;
        return data;
    }
}

export interface ISavingsPlansDetails {
    instanceFamily?: string | undefined;
    offeringId?: string | undefined;
    region?: string | undefined;
}

export class SavingsPlansPurchaseRecommendation implements ISavingsPlansPurchaseRecommendation {
    accountScope?: string | undefined;
    lookbackPeriodInDays?: string | undefined;
    paymentOption?: string | undefined;
    savingsPlansPurchaseRecommendationDetails?: SavingsPlansPurchaseRecommendationDetail[] | undefined;
    savingsPlansPurchaseRecommendationSummary?: SavingsPlansPurchaseRecommendationSummary;
    savingsPlansType?: string | undefined;
    termInYears?: string | undefined;

    constructor(data?: ISavingsPlansPurchaseRecommendation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountScope = _data["accountScope"];
            this.lookbackPeriodInDays = _data["lookbackPeriodInDays"];
            this.paymentOption = _data["paymentOption"];
            if (Array.isArray(_data["savingsPlansPurchaseRecommendationDetails"])) {
                this.savingsPlansPurchaseRecommendationDetails = [] as any;
                for (let item of _data["savingsPlansPurchaseRecommendationDetails"])
                    this.savingsPlansPurchaseRecommendationDetails!.push(SavingsPlansPurchaseRecommendationDetail.fromJS(item));
            }
            this.savingsPlansPurchaseRecommendationSummary = _data["savingsPlansPurchaseRecommendationSummary"] ? SavingsPlansPurchaseRecommendationSummary.fromJS(_data["savingsPlansPurchaseRecommendationSummary"]) : <any>undefined;
            this.savingsPlansType = _data["savingsPlansType"];
            this.termInYears = _data["termInYears"];
        }
    }

    static fromJS(data: any): SavingsPlansPurchaseRecommendation {
        data = typeof data === 'object' ? data : {};
        let result = new SavingsPlansPurchaseRecommendation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountScope"] = this.accountScope;
        data["lookbackPeriodInDays"] = this.lookbackPeriodInDays;
        data["paymentOption"] = this.paymentOption;
        if (Array.isArray(this.savingsPlansPurchaseRecommendationDetails)) {
            data["savingsPlansPurchaseRecommendationDetails"] = [];
            for (let item of this.savingsPlansPurchaseRecommendationDetails)
                data["savingsPlansPurchaseRecommendationDetails"].push(item.toJSON());
        }
        data["savingsPlansPurchaseRecommendationSummary"] = this.savingsPlansPurchaseRecommendationSummary ? this.savingsPlansPurchaseRecommendationSummary.toJSON() : <any>undefined;
        data["savingsPlansType"] = this.savingsPlansType;
        data["termInYears"] = this.termInYears;
        return data;
    }
}

export interface ISavingsPlansPurchaseRecommendation {
    accountScope?: string | undefined;
    lookbackPeriodInDays?: string | undefined;
    paymentOption?: string | undefined;
    savingsPlansPurchaseRecommendationDetails?: SavingsPlansPurchaseRecommendationDetail[] | undefined;
    savingsPlansPurchaseRecommendationSummary?: SavingsPlansPurchaseRecommendationSummary;
    savingsPlansType?: string | undefined;
    termInYears?: string | undefined;
}

export class SavingsPlansPurchaseRecommendationDetail implements ISavingsPlansPurchaseRecommendationDetail {
    accountId?: string | undefined;
    currencyCode?: string | undefined;
    currentAverageHourlyOnDemandSpend?: string | undefined;
    currentMaximumHourlyOnDemandSpend?: string | undefined;
    currentMinimumHourlyOnDemandSpend?: string | undefined;
    estimatedAverageUtilization?: string | undefined;
    estimatedMonthlySavingsAmount?: string | undefined;
    estimatedOnDemandCost?: string | undefined;
    estimatedOnDemandCostWithCurrentCommitment?: string | undefined;
    estimatedROI?: string | undefined;
    estimatedSavingsAmount?: string | undefined;
    estimatedSavingsPercentage?: string | undefined;
    estimatedSPCost?: string | undefined;
    hourlyCommitmentToPurchase?: string | undefined;
    savingsPlansDetails?: SavingsPlansDetails;
    upfrontCost?: string | undefined;

    constructor(data?: ISavingsPlansPurchaseRecommendationDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.currencyCode = _data["currencyCode"];
            this.currentAverageHourlyOnDemandSpend = _data["currentAverageHourlyOnDemandSpend"];
            this.currentMaximumHourlyOnDemandSpend = _data["currentMaximumHourlyOnDemandSpend"];
            this.currentMinimumHourlyOnDemandSpend = _data["currentMinimumHourlyOnDemandSpend"];
            this.estimatedAverageUtilization = _data["estimatedAverageUtilization"];
            this.estimatedMonthlySavingsAmount = _data["estimatedMonthlySavingsAmount"];
            this.estimatedOnDemandCost = _data["estimatedOnDemandCost"];
            this.estimatedOnDemandCostWithCurrentCommitment = _data["estimatedOnDemandCostWithCurrentCommitment"];
            this.estimatedROI = _data["estimatedROI"];
            this.estimatedSavingsAmount = _data["estimatedSavingsAmount"];
            this.estimatedSavingsPercentage = _data["estimatedSavingsPercentage"];
            this.estimatedSPCost = _data["estimatedSPCost"];
            this.hourlyCommitmentToPurchase = _data["hourlyCommitmentToPurchase"];
            this.savingsPlansDetails = _data["savingsPlansDetails"] ? SavingsPlansDetails.fromJS(_data["savingsPlansDetails"]) : <any>undefined;
            this.upfrontCost = _data["upfrontCost"];
        }
    }

    static fromJS(data: any): SavingsPlansPurchaseRecommendationDetail {
        data = typeof data === 'object' ? data : {};
        let result = new SavingsPlansPurchaseRecommendationDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["currencyCode"] = this.currencyCode;
        data["currentAverageHourlyOnDemandSpend"] = this.currentAverageHourlyOnDemandSpend;
        data["currentMaximumHourlyOnDemandSpend"] = this.currentMaximumHourlyOnDemandSpend;
        data["currentMinimumHourlyOnDemandSpend"] = this.currentMinimumHourlyOnDemandSpend;
        data["estimatedAverageUtilization"] = this.estimatedAverageUtilization;
        data["estimatedMonthlySavingsAmount"] = this.estimatedMonthlySavingsAmount;
        data["estimatedOnDemandCost"] = this.estimatedOnDemandCost;
        data["estimatedOnDemandCostWithCurrentCommitment"] = this.estimatedOnDemandCostWithCurrentCommitment;
        data["estimatedROI"] = this.estimatedROI;
        data["estimatedSavingsAmount"] = this.estimatedSavingsAmount;
        data["estimatedSavingsPercentage"] = this.estimatedSavingsPercentage;
        data["estimatedSPCost"] = this.estimatedSPCost;
        data["hourlyCommitmentToPurchase"] = this.hourlyCommitmentToPurchase;
        data["savingsPlansDetails"] = this.savingsPlansDetails ? this.savingsPlansDetails.toJSON() : <any>undefined;
        data["upfrontCost"] = this.upfrontCost;
        return data;
    }
}

export interface ISavingsPlansPurchaseRecommendationDetail {
    accountId?: string | undefined;
    currencyCode?: string | undefined;
    currentAverageHourlyOnDemandSpend?: string | undefined;
    currentMaximumHourlyOnDemandSpend?: string | undefined;
    currentMinimumHourlyOnDemandSpend?: string | undefined;
    estimatedAverageUtilization?: string | undefined;
    estimatedMonthlySavingsAmount?: string | undefined;
    estimatedOnDemandCost?: string | undefined;
    estimatedOnDemandCostWithCurrentCommitment?: string | undefined;
    estimatedROI?: string | undefined;
    estimatedSavingsAmount?: string | undefined;
    estimatedSavingsPercentage?: string | undefined;
    estimatedSPCost?: string | undefined;
    hourlyCommitmentToPurchase?: string | undefined;
    savingsPlansDetails?: SavingsPlansDetails;
    upfrontCost?: string | undefined;
}

export class SavingsPlansPurchaseRecommendationSummary implements ISavingsPlansPurchaseRecommendationSummary {
    currencyCode?: string | undefined;
    currentOnDemandSpend?: string | undefined;
    dailyCommitmentToPurchase?: string | undefined;
    estimatedMonthlySavingsAmount?: string | undefined;
    estimatedOnDemandCostWithCurrentCommitment?: string | undefined;
    estimatedROI?: string | undefined;
    estimatedSavingsAmount?: string | undefined;
    estimatedSavingsPercentage?: string | undefined;
    estimatedTotalCost?: string | undefined;
    hourlyCommitmentToPurchase?: string | undefined;
    totalRecommendationCount?: string | undefined;

    constructor(data?: ISavingsPlansPurchaseRecommendationSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currencyCode = _data["currencyCode"];
            this.currentOnDemandSpend = _data["currentOnDemandSpend"];
            this.dailyCommitmentToPurchase = _data["dailyCommitmentToPurchase"];
            this.estimatedMonthlySavingsAmount = _data["estimatedMonthlySavingsAmount"];
            this.estimatedOnDemandCostWithCurrentCommitment = _data["estimatedOnDemandCostWithCurrentCommitment"];
            this.estimatedROI = _data["estimatedROI"];
            this.estimatedSavingsAmount = _data["estimatedSavingsAmount"];
            this.estimatedSavingsPercentage = _data["estimatedSavingsPercentage"];
            this.estimatedTotalCost = _data["estimatedTotalCost"];
            this.hourlyCommitmentToPurchase = _data["hourlyCommitmentToPurchase"];
            this.totalRecommendationCount = _data["totalRecommendationCount"];
        }
    }

    static fromJS(data: any): SavingsPlansPurchaseRecommendationSummary {
        data = typeof data === 'object' ? data : {};
        let result = new SavingsPlansPurchaseRecommendationSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyCode"] = this.currencyCode;
        data["currentOnDemandSpend"] = this.currentOnDemandSpend;
        data["dailyCommitmentToPurchase"] = this.dailyCommitmentToPurchase;
        data["estimatedMonthlySavingsAmount"] = this.estimatedMonthlySavingsAmount;
        data["estimatedOnDemandCostWithCurrentCommitment"] = this.estimatedOnDemandCostWithCurrentCommitment;
        data["estimatedROI"] = this.estimatedROI;
        data["estimatedSavingsAmount"] = this.estimatedSavingsAmount;
        data["estimatedSavingsPercentage"] = this.estimatedSavingsPercentage;
        data["estimatedTotalCost"] = this.estimatedTotalCost;
        data["hourlyCommitmentToPurchase"] = this.hourlyCommitmentToPurchase;
        data["totalRecommendationCount"] = this.totalRecommendationCount;
        return data;
    }
}

export interface ISavingsPlansPurchaseRecommendationSummary {
    currencyCode?: string | undefined;
    currentOnDemandSpend?: string | undefined;
    dailyCommitmentToPurchase?: string | undefined;
    estimatedMonthlySavingsAmount?: string | undefined;
    estimatedOnDemandCostWithCurrentCommitment?: string | undefined;
    estimatedROI?: string | undefined;
    estimatedSavingsAmount?: string | undefined;
    estimatedSavingsPercentage?: string | undefined;
    estimatedTotalCost?: string | undefined;
    hourlyCommitmentToPurchase?: string | undefined;
    totalRecommendationCount?: string | undefined;
}

export class ServiceSpecification implements IServiceSpecification {
    eC2Specification?: EC2Specification;

    constructor(data?: IServiceSpecification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eC2Specification = _data["eC2Specification"] ? EC2Specification.fromJS(_data["eC2Specification"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceSpecification {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceSpecification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eC2Specification"] = this.eC2Specification ? this.eC2Specification.toJSON() : <any>undefined;
        return data;
    }
}

export interface IServiceSpecification {
    eC2Specification?: EC2Specification;
}

export class TagValues implements ITagValues {
    key?: string | undefined;
    matchOptions?: string[] | undefined;
    values?: string[] | undefined;

    constructor(data?: ITagValues) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            if (Array.isArray(_data["matchOptions"])) {
                this.matchOptions = [] as any;
                for (let item of _data["matchOptions"])
                    this.matchOptions!.push(item);
            }
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
        }
    }

    static fromJS(data: any): TagValues {
        data = typeof data === 'object' ? data : {};
        let result = new TagValues();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        if (Array.isArray(this.matchOptions)) {
            data["matchOptions"] = [];
            for (let item of this.matchOptions)
                data["matchOptions"].push(item);
        }
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        return data;
    }
}

export interface ITagValues {
    key?: string | undefined;
    matchOptions?: string[] | undefined;
    values?: string[] | undefined;
}

export class TargetInstance implements ITargetInstance {
    currencyCode?: string | undefined;
    defaultTargetInstance?: boolean;
    estimatedMonthlyCost?: string | undefined;
    estimatedMonthlySavings?: string | undefined;
    expectedResourceUtilization?: ResourceUtilization;
    resourceDetails?: ResourceDetails;

    constructor(data?: ITargetInstance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currencyCode = _data["currencyCode"];
            this.defaultTargetInstance = _data["defaultTargetInstance"];
            this.estimatedMonthlyCost = _data["estimatedMonthlyCost"];
            this.estimatedMonthlySavings = _data["estimatedMonthlySavings"];
            this.expectedResourceUtilization = _data["expectedResourceUtilization"] ? ResourceUtilization.fromJS(_data["expectedResourceUtilization"]) : <any>undefined;
            this.resourceDetails = _data["resourceDetails"] ? ResourceDetails.fromJS(_data["resourceDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TargetInstance {
        data = typeof data === 'object' ? data : {};
        let result = new TargetInstance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyCode"] = this.currencyCode;
        data["defaultTargetInstance"] = this.defaultTargetInstance;
        data["estimatedMonthlyCost"] = this.estimatedMonthlyCost;
        data["estimatedMonthlySavings"] = this.estimatedMonthlySavings;
        data["expectedResourceUtilization"] = this.expectedResourceUtilization ? this.expectedResourceUtilization.toJSON() : <any>undefined;
        data["resourceDetails"] = this.resourceDetails ? this.resourceDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITargetInstance {
    currencyCode?: string | undefined;
    defaultTargetInstance?: boolean;
    estimatedMonthlyCost?: string | undefined;
    estimatedMonthlySavings?: string | undefined;
    expectedResourceUtilization?: ResourceUtilization;
    resourceDetails?: ResourceDetails;
}

export class TerminateRecommendationDetail implements ITerminateRecommendationDetail {
    currencyCode?: string | undefined;
    estimatedMonthlySavings?: string | undefined;

    constructor(data?: ITerminateRecommendationDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currencyCode = _data["currencyCode"];
            this.estimatedMonthlySavings = _data["estimatedMonthlySavings"];
        }
    }

    static fromJS(data: any): TerminateRecommendationDetail {
        data = typeof data === 'object' ? data : {};
        let result = new TerminateRecommendationDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyCode"] = this.currencyCode;
        data["estimatedMonthlySavings"] = this.estimatedMonthlySavings;
        return data;
    }
}

export interface ITerminateRecommendationDetail {
    currencyCode?: string | undefined;
    estimatedMonthlySavings?: string | undefined;
}

export class TrustedAdvisorCategorySpecificSummary implements ITrustedAdvisorCategorySpecificSummary {
    costOptimizing?: TrustedAdvisorCostOptimizingSummary;

    constructor(data?: ITrustedAdvisorCategorySpecificSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.costOptimizing = _data["costOptimizing"] ? TrustedAdvisorCostOptimizingSummary.fromJS(_data["costOptimizing"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TrustedAdvisorCategorySpecificSummary {
        data = typeof data === 'object' ? data : {};
        let result = new TrustedAdvisorCategorySpecificSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["costOptimizing"] = this.costOptimizing ? this.costOptimizing.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITrustedAdvisorCategorySpecificSummary {
    costOptimizing?: TrustedAdvisorCostOptimizingSummary;
}

export class TrustedAdvisorCheckDescription implements ITrustedAdvisorCheckDescription {
    category?: string | undefined;
    description?: string | undefined;
    id?: string | undefined;
    metadata?: string[] | undefined;
    name?: string | undefined;

    constructor(data?: ITrustedAdvisorCheckDescription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.description = _data["description"];
            this.id = _data["id"];
            if (Array.isArray(_data["metadata"])) {
                this.metadata = [] as any;
                for (let item of _data["metadata"])
                    this.metadata!.push(item);
            }
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TrustedAdvisorCheckDescription {
        data = typeof data === 'object' ? data : {};
        let result = new TrustedAdvisorCheckDescription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["description"] = this.description;
        data["id"] = this.id;
        if (Array.isArray(this.metadata)) {
            data["metadata"] = [];
            for (let item of this.metadata)
                data["metadata"].push(item);
        }
        data["name"] = this.name;
        return data;
    }
}

export interface ITrustedAdvisorCheckDescription {
    category?: string | undefined;
    description?: string | undefined;
    id?: string | undefined;
    metadata?: string[] | undefined;
    name?: string | undefined;
}

export class TrustedAdvisorCheckResult implements ITrustedAdvisorCheckResult {
    categorySpecificSummary?: TrustedAdvisorCategorySpecificSummary;
    checkId?: string | undefined;
    flaggedResources?: TrustedAdvisorResourceDetail[] | undefined;
    resourcesSummary?: TrustedAdvisorResourcesSummary;
    status?: string | undefined;
    timestamp?: string | undefined;

    constructor(data?: ITrustedAdvisorCheckResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categorySpecificSummary = _data["categorySpecificSummary"] ? TrustedAdvisorCategorySpecificSummary.fromJS(_data["categorySpecificSummary"]) : <any>undefined;
            this.checkId = _data["checkId"];
            if (Array.isArray(_data["flaggedResources"])) {
                this.flaggedResources = [] as any;
                for (let item of _data["flaggedResources"])
                    this.flaggedResources!.push(TrustedAdvisorResourceDetail.fromJS(item));
            }
            this.resourcesSummary = _data["resourcesSummary"] ? TrustedAdvisorResourcesSummary.fromJS(_data["resourcesSummary"]) : <any>undefined;
            this.status = _data["status"];
            this.timestamp = _data["timestamp"];
        }
    }

    static fromJS(data: any): TrustedAdvisorCheckResult {
        data = typeof data === 'object' ? data : {};
        let result = new TrustedAdvisorCheckResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categorySpecificSummary"] = this.categorySpecificSummary ? this.categorySpecificSummary.toJSON() : <any>undefined;
        data["checkId"] = this.checkId;
        if (Array.isArray(this.flaggedResources)) {
            data["flaggedResources"] = [];
            for (let item of this.flaggedResources)
                data["flaggedResources"].push(item.toJSON());
        }
        data["resourcesSummary"] = this.resourcesSummary ? this.resourcesSummary.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["timestamp"] = this.timestamp;
        return data;
    }
}

export interface ITrustedAdvisorCheckResult {
    categorySpecificSummary?: TrustedAdvisorCategorySpecificSummary;
    checkId?: string | undefined;
    flaggedResources?: TrustedAdvisorResourceDetail[] | undefined;
    resourcesSummary?: TrustedAdvisorResourcesSummary;
    status?: string | undefined;
    timestamp?: string | undefined;
}

export class TrustedAdvisorCheckSummary implements ITrustedAdvisorCheckSummary {
    categorySpecificSummary?: TrustedAdvisorCategorySpecificSummary;
    checkId?: string | undefined;
    hasFlaggedResources?: boolean;
    resourcesSummary?: TrustedAdvisorResourcesSummary;
    status?: string | undefined;
    timestamp?: string | undefined;

    constructor(data?: ITrustedAdvisorCheckSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categorySpecificSummary = _data["categorySpecificSummary"] ? TrustedAdvisorCategorySpecificSummary.fromJS(_data["categorySpecificSummary"]) : <any>undefined;
            this.checkId = _data["checkId"];
            this.hasFlaggedResources = _data["hasFlaggedResources"];
            this.resourcesSummary = _data["resourcesSummary"] ? TrustedAdvisorResourcesSummary.fromJS(_data["resourcesSummary"]) : <any>undefined;
            this.status = _data["status"];
            this.timestamp = _data["timestamp"];
        }
    }

    static fromJS(data: any): TrustedAdvisorCheckSummary {
        data = typeof data === 'object' ? data : {};
        let result = new TrustedAdvisorCheckSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categorySpecificSummary"] = this.categorySpecificSummary ? this.categorySpecificSummary.toJSON() : <any>undefined;
        data["checkId"] = this.checkId;
        data["hasFlaggedResources"] = this.hasFlaggedResources;
        data["resourcesSummary"] = this.resourcesSummary ? this.resourcesSummary.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["timestamp"] = this.timestamp;
        return data;
    }
}

export interface ITrustedAdvisorCheckSummary {
    categorySpecificSummary?: TrustedAdvisorCategorySpecificSummary;
    checkId?: string | undefined;
    hasFlaggedResources?: boolean;
    resourcesSummary?: TrustedAdvisorResourcesSummary;
    status?: string | undefined;
    timestamp?: string | undefined;
}

export class TrustedAdvisorCostOptimizingSummary implements ITrustedAdvisorCostOptimizingSummary {
    estimatedMonthlySavings?: number;
    estimatedPercentMonthlySavings?: number;

    constructor(data?: ITrustedAdvisorCostOptimizingSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.estimatedMonthlySavings = _data["estimatedMonthlySavings"];
            this.estimatedPercentMonthlySavings = _data["estimatedPercentMonthlySavings"];
        }
    }

    static fromJS(data: any): TrustedAdvisorCostOptimizingSummary {
        data = typeof data === 'object' ? data : {};
        let result = new TrustedAdvisorCostOptimizingSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["estimatedMonthlySavings"] = this.estimatedMonthlySavings;
        data["estimatedPercentMonthlySavings"] = this.estimatedPercentMonthlySavings;
        return data;
    }
}

export interface ITrustedAdvisorCostOptimizingSummary {
    estimatedMonthlySavings?: number;
    estimatedPercentMonthlySavings?: number;
}

export class TrustedAdvisorResourceDetail implements ITrustedAdvisorResourceDetail {
    isSuppressed?: boolean;
    metadata?: string[] | undefined;
    region?: string | undefined;
    resourceId?: string | undefined;
    status?: string | undefined;

    constructor(data?: ITrustedAdvisorResourceDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuppressed = _data["isSuppressed"];
            if (Array.isArray(_data["metadata"])) {
                this.metadata = [] as any;
                for (let item of _data["metadata"])
                    this.metadata!.push(item);
            }
            this.region = _data["region"];
            this.resourceId = _data["resourceId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): TrustedAdvisorResourceDetail {
        data = typeof data === 'object' ? data : {};
        let result = new TrustedAdvisorResourceDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuppressed"] = this.isSuppressed;
        if (Array.isArray(this.metadata)) {
            data["metadata"] = [];
            for (let item of this.metadata)
                data["metadata"].push(item);
        }
        data["region"] = this.region;
        data["resourceId"] = this.resourceId;
        data["status"] = this.status;
        return data;
    }
}

export interface ITrustedAdvisorResourceDetail {
    isSuppressed?: boolean;
    metadata?: string[] | undefined;
    region?: string | undefined;
    resourceId?: string | undefined;
    status?: string | undefined;
}

export class TrustedAdvisorResourcesSummary implements ITrustedAdvisorResourcesSummary {
    resourcesFlagged?: number;
    resourcesIgnored?: number;
    resourcesProcessed?: number;
    resourcesSuppressed?: number;

    constructor(data?: ITrustedAdvisorResourcesSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resourcesFlagged = _data["resourcesFlagged"];
            this.resourcesIgnored = _data["resourcesIgnored"];
            this.resourcesProcessed = _data["resourcesProcessed"];
            this.resourcesSuppressed = _data["resourcesSuppressed"];
        }
    }

    static fromJS(data: any): TrustedAdvisorResourcesSummary {
        data = typeof data === 'object' ? data : {};
        let result = new TrustedAdvisorResourcesSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resourcesFlagged"] = this.resourcesFlagged;
        data["resourcesIgnored"] = this.resourcesIgnored;
        data["resourcesProcessed"] = this.resourcesProcessed;
        data["resourcesSuppressed"] = this.resourcesSuppressed;
        return data;
    }
}

export interface ITrustedAdvisorResourcesSummary {
    resourcesFlagged?: number;
    resourcesIgnored?: number;
    resourcesProcessed?: number;
    resourcesSuppressed?: number;
}

export class AssessmentStatus implements IAssessmentStatus {
    code?: string | undefined;
    cause?: string | undefined;
    description?: string | undefined;

    constructor(data?: IAssessmentStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.cause = _data["cause"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): AssessmentStatus {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["cause"] = this.cause;
        data["description"] = this.description;
        return data;
    }
}

export interface IAssessmentStatus {
    code?: string | undefined;
    cause?: string | undefined;
    description?: string | undefined;
}

export class AzureResourceLink implements IAzureResourceLink {
    id?: string | undefined;
    securityAssessmentMetadata?: SecurityAssessmentMetadata;

    constructor(data?: IAzureResourceLink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.securityAssessmentMetadata = _data["securityAssessmentMetadata"] ? SecurityAssessmentMetadata.fromJS(_data["securityAssessmentMetadata"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AzureResourceLink {
        data = typeof data === 'object' ? data : {};
        let result = new AzureResourceLink();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["securityAssessmentMetadata"] = this.securityAssessmentMetadata ? this.securityAssessmentMetadata.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAzureResourceLink {
    id?: string | undefined;
    securityAssessmentMetadata?: SecurityAssessmentMetadata;
}

export class ErrorDetail implements IErrorDetail {
    code?: string | undefined;
    message?: string | undefined;
    recommendations?: string[] | undefined;

    constructor(data?: IErrorDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.message = _data["message"];
            if (Array.isArray(_data["recommendations"])) {
                this.recommendations = [] as any;
                for (let item of _data["recommendations"])
                    this.recommendations!.push(item);
            }
        }
    }

    static fromJS(data: any): ErrorDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        if (Array.isArray(this.recommendations)) {
            data["recommendations"] = [];
            for (let item of this.recommendations)
                data["recommendations"].push(item);
        }
        return data;
    }
}

export interface IErrorDetail {
    code?: string | undefined;
    message?: string | undefined;
    recommendations?: string[] | undefined;
}

export class RegulatoryComplianceAssessment implements IRegulatoryComplianceAssessment {
    description?: string | undefined;
    assessmentType?: string | undefined;
    assessmentDetailsLink?: string | undefined;
    state?: string | undefined;
    passedResources?: number | undefined;
    failedResources?: number | undefined;
    skippedResources?: number | undefined;
    unsupportedResources?: number | undefined;
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;

    constructor(data?: IRegulatoryComplianceAssessment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.assessmentType = _data["assessmentType"];
            this.assessmentDetailsLink = _data["assessmentDetailsLink"];
            this.state = _data["state"];
            this.passedResources = _data["passedResources"];
            this.failedResources = _data["failedResources"];
            this.skippedResources = _data["skippedResources"];
            this.unsupportedResources = _data["unsupportedResources"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): RegulatoryComplianceAssessment {
        data = typeof data === 'object' ? data : {};
        let result = new RegulatoryComplianceAssessment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["assessmentType"] = this.assessmentType;
        data["assessmentDetailsLink"] = this.assessmentDetailsLink;
        data["state"] = this.state;
        data["passedResources"] = this.passedResources;
        data["failedResources"] = this.failedResources;
        data["skippedResources"] = this.skippedResources;
        data["unsupportedResources"] = this.unsupportedResources;
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        return data;
    }
}

export interface IRegulatoryComplianceAssessment {
    description?: string | undefined;
    assessmentType?: string | undefined;
    assessmentDetailsLink?: string | undefined;
    state?: string | undefined;
    passedResources?: number | undefined;
    failedResources?: number | undefined;
    skippedResources?: number | undefined;
    unsupportedResources?: number | undefined;
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
}

export class RegulatoryComplianceControl implements IRegulatoryComplianceControl {
    description?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    state?: string | undefined;
    passedAssessments?: number | undefined;
    failedAssessments?: number | undefined;
    skippedAssessments?: number | undefined;
    complianceAssessments?: RegulatoryComplianceAssessment[] | undefined;

    constructor(data?: IRegulatoryComplianceControl) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.state = _data["state"];
            this.passedAssessments = _data["passedAssessments"];
            this.failedAssessments = _data["failedAssessments"];
            this.skippedAssessments = _data["skippedAssessments"];
            if (Array.isArray(_data["complianceAssessments"])) {
                this.complianceAssessments = [] as any;
                for (let item of _data["complianceAssessments"])
                    this.complianceAssessments!.push(RegulatoryComplianceAssessment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RegulatoryComplianceControl {
        data = typeof data === 'object' ? data : {};
        let result = new RegulatoryComplianceControl();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["state"] = this.state;
        data["passedAssessments"] = this.passedAssessments;
        data["failedAssessments"] = this.failedAssessments;
        data["skippedAssessments"] = this.skippedAssessments;
        if (Array.isArray(this.complianceAssessments)) {
            data["complianceAssessments"] = [];
            for (let item of this.complianceAssessments)
                data["complianceAssessments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRegulatoryComplianceControl {
    description?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    state?: string | undefined;
    passedAssessments?: number | undefined;
    failedAssessments?: number | undefined;
    skippedAssessments?: number | undefined;
    complianceAssessments?: RegulatoryComplianceAssessment[] | undefined;
}

export class RegulatoryComplianceStandard implements IRegulatoryComplianceStandard {
    state?: string | undefined;
    passedControls?: number | undefined;
    failedControls?: number | undefined;
    skippedControls?: number | undefined;
    unsupportedControls?: number | undefined;
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    complianceControls?: RegulatoryComplianceControl[] | undefined;

    constructor(data?: IRegulatoryComplianceStandard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.passedControls = _data["passedControls"];
            this.failedControls = _data["failedControls"];
            this.skippedControls = _data["skippedControls"];
            this.unsupportedControls = _data["unsupportedControls"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            if (Array.isArray(_data["complianceControls"])) {
                this.complianceControls = [] as any;
                for (let item of _data["complianceControls"])
                    this.complianceControls!.push(RegulatoryComplianceControl.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RegulatoryComplianceStandard {
        data = typeof data === 'object' ? data : {};
        let result = new RegulatoryComplianceStandard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["passedControls"] = this.passedControls;
        data["failedControls"] = this.failedControls;
        data["skippedControls"] = this.skippedControls;
        data["unsupportedControls"] = this.unsupportedControls;
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        if (Array.isArray(this.complianceControls)) {
            data["complianceControls"] = [];
            for (let item of this.complianceControls)
                data["complianceControls"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRegulatoryComplianceStandard {
    state?: string | undefined;
    passedControls?: number | undefined;
    failedControls?: number | undefined;
    skippedControls?: number | undefined;
    unsupportedControls?: number | undefined;
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    complianceControls?: RegulatoryComplianceControl[] | undefined;
}

export class ResourceRecommendation implements IResourceRecommendation {
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    category?: string | undefined;
    impact?: string | undefined;
    impactedField?: string | undefined;
    impactedValue?: string | undefined;
    lastUpdated?: Date | undefined;
    metadata?: { [key: string]: any; } | undefined;
    recommendationTypeId?: string | undefined;
    risk?: string | undefined;
    shortDescription?: ShortDescription;
    suppressionIds?: string[] | undefined;
    extendedProperties?: { [key: string]: string; } | undefined;

    constructor(data?: IResourceRecommendation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.category = _data["category"];
            this.impact = _data["impact"];
            this.impactedField = _data["impactedField"];
            this.impactedValue = _data["impactedValue"];
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : <any>undefined;
            if (_data["metadata"]) {
                this.metadata = {} as any;
                for (let key in _data["metadata"]) {
                    if (_data["metadata"].hasOwnProperty(key))
                        (<any>this.metadata)![key] = _data["metadata"][key];
                }
            }
            this.recommendationTypeId = _data["recommendationTypeId"];
            this.risk = _data["risk"];
            this.shortDescription = _data["shortDescription"] ? ShortDescription.fromJS(_data["shortDescription"]) : <any>undefined;
            if (Array.isArray(_data["suppressionIds"])) {
                this.suppressionIds = [] as any;
                for (let item of _data["suppressionIds"])
                    this.suppressionIds!.push(item);
            }
            if (_data["extendedProperties"]) {
                this.extendedProperties = {} as any;
                for (let key in _data["extendedProperties"]) {
                    if (_data["extendedProperties"].hasOwnProperty(key))
                        (<any>this.extendedProperties)![key] = _data["extendedProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): ResourceRecommendation {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceRecommendation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["category"] = this.category;
        data["impact"] = this.impact;
        data["impactedField"] = this.impactedField;
        data["impactedValue"] = this.impactedValue;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : <any>undefined;
        if (this.metadata) {
            data["metadata"] = {};
            for (let key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    (<any>data["metadata"])[key] = (<any>this.metadata)[key];
            }
        }
        data["recommendationTypeId"] = this.recommendationTypeId;
        data["risk"] = this.risk;
        data["shortDescription"] = this.shortDescription ? this.shortDescription.toJSON() : <any>undefined;
        if (Array.isArray(this.suppressionIds)) {
            data["suppressionIds"] = [];
            for (let item of this.suppressionIds)
                data["suppressionIds"].push(item);
        }
        if (this.extendedProperties) {
            data["extendedProperties"] = {};
            for (let key in this.extendedProperties) {
                if (this.extendedProperties.hasOwnProperty(key))
                    (<any>data["extendedProperties"])[key] = (<any>this.extendedProperties)[key];
            }
        }
        return data;
    }
}

export interface IResourceRecommendation {
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    category?: string | undefined;
    impact?: string | undefined;
    impactedField?: string | undefined;
    impactedValue?: string | undefined;
    lastUpdated?: Date | undefined;
    metadata?: { [key: string]: any; } | undefined;
    recommendationTypeId?: string | undefined;
    risk?: string | undefined;
    shortDescription?: ShortDescription;
    suppressionIds?: string[] | undefined;
    extendedProperties?: { [key: string]: string; } | undefined;
}

export class AzureComplianceSubscriptionSummary implements IAzureComplianceSubscriptionSummary {
    regulatoryComplianceSummaries?: RegulatoryComplianceSummary[] | undefined;
    securityAssessmentSummary?: SecurityAssessmentSummary;

    constructor(data?: IAzureComplianceSubscriptionSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["regulatoryComplianceSummaries"])) {
                this.regulatoryComplianceSummaries = [] as any;
                for (let item of _data["regulatoryComplianceSummaries"])
                    this.regulatoryComplianceSummaries!.push(RegulatoryComplianceSummary.fromJS(item));
            }
            this.securityAssessmentSummary = _data["securityAssessmentSummary"] ? SecurityAssessmentSummary.fromJS(_data["securityAssessmentSummary"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AzureComplianceSubscriptionSummary {
        data = typeof data === 'object' ? data : {};
        let result = new AzureComplianceSubscriptionSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.regulatoryComplianceSummaries)) {
            data["regulatoryComplianceSummaries"] = [];
            for (let item of this.regulatoryComplianceSummaries)
                data["regulatoryComplianceSummaries"].push(item.toJSON());
        }
        data["securityAssessmentSummary"] = this.securityAssessmentSummary ? this.securityAssessmentSummary.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAzureComplianceSubscriptionSummary {
    regulatoryComplianceSummaries?: RegulatoryComplianceSummary[] | undefined;
    securityAssessmentSummary?: SecurityAssessmentSummary;
}

export class RegulatoryComplianceSummary implements IRegulatoryComplianceSummary {
    name?: string | undefined;
    passedControls?: number | undefined;
    totalControls?: number;

    constructor(data?: IRegulatoryComplianceSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.passedControls = _data["passedControls"];
            this.totalControls = _data["totalControls"];
        }
    }

    static fromJS(data: any): RegulatoryComplianceSummary {
        data = typeof data === 'object' ? data : {};
        let result = new RegulatoryComplianceSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["passedControls"] = this.passedControls;
        data["totalControls"] = this.totalControls;
        return data;
    }
}

export interface IRegulatoryComplianceSummary {
    name?: string | undefined;
    passedControls?: number | undefined;
    totalControls?: number;
}

export class SecurityAssessmentSummary implements ISecurityAssessmentSummary {
    healthyAssessments?: number;
    totalAssessments?: number;

    constructor(data?: ISecurityAssessmentSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthyAssessments = _data["healthyAssessments"];
            this.totalAssessments = _data["totalAssessments"];
        }
    }

    static fromJS(data: any): SecurityAssessmentSummary {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityAssessmentSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthyAssessments"] = this.healthyAssessments;
        data["totalAssessments"] = this.totalAssessments;
        return data;
    }
}

export interface ISecurityAssessmentSummary {
    healthyAssessments?: number;
    totalAssessments?: number;
}

export class Subscription implements ISubscription {
    subscriptionId?: string | undefined;
    data?: SubscriptionData;

    constructor(data?: ISubscription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionId = _data["subscriptionId"];
            this.data = _data["data"] ? SubscriptionData.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Subscription {
        data = typeof data === 'object' ? data : {};
        let result = new Subscription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionId"] = this.subscriptionId;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISubscription {
    subscriptionId?: string | undefined;
    data?: SubscriptionData;
}

export class SubscriptionData implements ISubscriptionData {
    summary?: AzureComplianceSubscriptionSummary;
    secureScoreItem?: SecureScoreItem[] | undefined;
    regulatoryComplianceStandard?: RegulatoryComplianceStandard[] | undefined;
    securityAssessment?: SecurityAssessment[] | undefined;

    constructor(data?: ISubscriptionData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.summary = _data["summary"] ? AzureComplianceSubscriptionSummary.fromJS(_data["summary"]) : <any>undefined;
            if (Array.isArray(_data["secureScoreItem"])) {
                this.secureScoreItem = [] as any;
                for (let item of _data["secureScoreItem"])
                    this.secureScoreItem!.push(SecureScoreItem.fromJS(item));
            }
            if (Array.isArray(_data["regulatoryComplianceStandard"])) {
                this.regulatoryComplianceStandard = [] as any;
                for (let item of _data["regulatoryComplianceStandard"])
                    this.regulatoryComplianceStandard!.push(RegulatoryComplianceStandard.fromJS(item));
            }
            if (Array.isArray(_data["securityAssessment"])) {
                this.securityAssessment = [] as any;
                for (let item of _data["securityAssessment"])
                    this.securityAssessment!.push(SecurityAssessment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubscriptionData {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        if (Array.isArray(this.secureScoreItem)) {
            data["secureScoreItem"] = [];
            for (let item of this.secureScoreItem)
                data["secureScoreItem"].push(item.toJSON());
        }
        if (Array.isArray(this.regulatoryComplianceStandard)) {
            data["regulatoryComplianceStandard"] = [];
            for (let item of this.regulatoryComplianceStandard)
                data["regulatoryComplianceStandard"].push(item.toJSON());
        }
        if (Array.isArray(this.securityAssessment)) {
            data["securityAssessment"] = [];
            for (let item of this.securityAssessment)
                data["securityAssessment"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISubscriptionData {
    summary?: AzureComplianceSubscriptionSummary;
    secureScoreItem?: SecureScoreItem[] | undefined;
    regulatoryComplianceStandard?: RegulatoryComplianceStandard[] | undefined;
    securityAssessment?: SecurityAssessment[] | undefined;
}

export class SecureScoreControlDefinitionItem implements ISecureScoreControlDefinitionItem {
    displayName?: string | undefined;
    description?: string | undefined;
    maxScore?: number | undefined;
    source?: SecureScoreControlDefinitionSource;
    assessmentDefinitions?: AzureResourceLink[] | undefined;
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;

    constructor(data?: ISecureScoreControlDefinitionItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.maxScore = _data["maxScore"];
            this.source = _data["source"] ? SecureScoreControlDefinitionSource.fromJS(_data["source"]) : <any>undefined;
            if (Array.isArray(_data["assessmentDefinitions"])) {
                this.assessmentDefinitions = [] as any;
                for (let item of _data["assessmentDefinitions"])
                    this.assessmentDefinitions!.push(AzureResourceLink.fromJS(item));
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): SecureScoreControlDefinitionItem {
        data = typeof data === 'object' ? data : {};
        let result = new SecureScoreControlDefinitionItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["maxScore"] = this.maxScore;
        data["source"] = this.source ? this.source.toJSON() : <any>undefined;
        if (Array.isArray(this.assessmentDefinitions)) {
            data["assessmentDefinitions"] = [];
            for (let item of this.assessmentDefinitions)
                data["assessmentDefinitions"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        return data;
    }
}

export interface ISecureScoreControlDefinitionItem {
    displayName?: string | undefined;
    description?: string | undefined;
    maxScore?: number | undefined;
    source?: SecureScoreControlDefinitionSource;
    assessmentDefinitions?: AzureResourceLink[] | undefined;
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
}

export class SecureScoreControlDefinitionSource implements ISecureScoreControlDefinitionSource {
    sourceType?: string | undefined;

    constructor(data?: ISecureScoreControlDefinitionSource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceType = _data["sourceType"];
        }
    }

    static fromJS(data: any): SecureScoreControlDefinitionSource {
        data = typeof data === 'object' ? data : {};
        let result = new SecureScoreControlDefinitionSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceType"] = this.sourceType;
        return data;
    }
}

export interface ISecureScoreControlDefinitionSource {
    sourceType?: string | undefined;
}

export class SecureScoreControlDetails implements ISecureScoreControlDetails {
    displayName?: string | undefined;
    max?: number | undefined;
    current?: number | undefined;
    percentage?: number | undefined;
    healthyResourceCount?: number | undefined;
    unhealthyResourceCount?: number | undefined;
    notApplicableResourceCount?: number | undefined;
    weight?: number | undefined;
    definition?: SecureScoreControlDefinitionItem;
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;

    constructor(data?: ISecureScoreControlDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.max = _data["max"];
            this.current = _data["current"];
            this.percentage = _data["percentage"];
            this.healthyResourceCount = _data["healthyResourceCount"];
            this.unhealthyResourceCount = _data["unhealthyResourceCount"];
            this.notApplicableResourceCount = _data["notApplicableResourceCount"];
            this.weight = _data["weight"];
            this.definition = _data["definition"] ? SecureScoreControlDefinitionItem.fromJS(_data["definition"]) : <any>undefined;
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): SecureScoreControlDetails {
        data = typeof data === 'object' ? data : {};
        let result = new SecureScoreControlDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["max"] = this.max;
        data["current"] = this.current;
        data["percentage"] = this.percentage;
        data["healthyResourceCount"] = this.healthyResourceCount;
        data["unhealthyResourceCount"] = this.unhealthyResourceCount;
        data["notApplicableResourceCount"] = this.notApplicableResourceCount;
        data["weight"] = this.weight;
        data["definition"] = this.definition ? this.definition.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        return data;
    }
}

export interface ISecureScoreControlDetails {
    displayName?: string | undefined;
    max?: number | undefined;
    current?: number | undefined;
    percentage?: number | undefined;
    healthyResourceCount?: number | undefined;
    unhealthyResourceCount?: number | undefined;
    notApplicableResourceCount?: number | undefined;
    weight?: number | undefined;
    definition?: SecureScoreControlDefinitionItem;
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
}

export class SecureScoreItem implements ISecureScoreItem {
    percentage?: number | undefined;
    current?: number | undefined;
    max?: number | undefined;
    weight?: number | undefined;
    displayName?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    controlDetails?: SecureScoreControlDetails[] | undefined;

    constructor(data?: ISecureScoreItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.percentage = _data["percentage"];
            this.current = _data["current"];
            this.max = _data["max"];
            this.weight = _data["weight"];
            this.displayName = _data["displayName"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            if (Array.isArray(_data["controlDetails"])) {
                this.controlDetails = [] as any;
                for (let item of _data["controlDetails"])
                    this.controlDetails!.push(SecureScoreControlDetails.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SecureScoreItem {
        data = typeof data === 'object' ? data : {};
        let result = new SecureScoreItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["percentage"] = this.percentage;
        data["current"] = this.current;
        data["max"] = this.max;
        data["weight"] = this.weight;
        data["displayName"] = this.displayName;
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        if (Array.isArray(this.controlDetails)) {
            data["controlDetails"] = [];
            for (let item of this.controlDetails)
                data["controlDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISecureScoreItem {
    percentage?: number | undefined;
    current?: number | undefined;
    max?: number | undefined;
    weight?: number | undefined;
    displayName?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    controlDetails?: SecureScoreControlDetails[] | undefined;
}

export class SecurityAssessment implements ISecurityAssessment {
    displayName?: string | undefined;
    status?: AssessmentStatus;
    additionalData?: { [key: string]: string; } | undefined;
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    subAssessments?: SecuritySubAssessment[] | undefined;

    constructor(data?: ISecurityAssessment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.status = _data["status"] ? AssessmentStatus.fromJS(_data["status"]) : <any>undefined;
            if (_data["additionalData"]) {
                this.additionalData = {} as any;
                for (let key in _data["additionalData"]) {
                    if (_data["additionalData"].hasOwnProperty(key))
                        (<any>this.additionalData)![key] = _data["additionalData"][key];
                }
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            if (Array.isArray(_data["subAssessments"])) {
                this.subAssessments = [] as any;
                for (let item of _data["subAssessments"])
                    this.subAssessments!.push(SecuritySubAssessment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SecurityAssessment {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityAssessment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    (<any>data["additionalData"])[key] = (<any>this.additionalData)[key];
            }
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        if (Array.isArray(this.subAssessments)) {
            data["subAssessments"] = [];
            for (let item of this.subAssessments)
                data["subAssessments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISecurityAssessment {
    displayName?: string | undefined;
    status?: AssessmentStatus;
    additionalData?: { [key: string]: string; } | undefined;
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    subAssessments?: SecuritySubAssessment[] | undefined;
}

export class SecurityAssessmentMetadata implements ISecurityAssessmentMetadata {
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    displayName?: string | undefined;
    policyDefinitionId?: string | undefined;
    description?: string | undefined;
    remediationDescription?: string | undefined;
    category?: string[] | undefined;
    severity?: string | undefined;
    userImpact?: string | undefined;
    implementationEffort?: string | undefined;
    threats?: string[] | undefined;
    preview?: boolean | undefined;
    assessmentType?: string | undefined;
    partnerData?: SecurityAssessmentMetadataPartnerData;

    constructor(data?: ISecurityAssessmentMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.displayName = _data["displayName"];
            this.policyDefinitionId = _data["policyDefinitionId"];
            this.description = _data["description"];
            this.remediationDescription = _data["remediationDescription"];
            if (Array.isArray(_data["category"])) {
                this.category = [] as any;
                for (let item of _data["category"])
                    this.category!.push(item);
            }
            this.severity = _data["severity"];
            this.userImpact = _data["userImpact"];
            this.implementationEffort = _data["implementationEffort"];
            if (Array.isArray(_data["threats"])) {
                this.threats = [] as any;
                for (let item of _data["threats"])
                    this.threats!.push(item);
            }
            this.preview = _data["preview"];
            this.assessmentType = _data["assessmentType"];
            this.partnerData = _data["partnerData"] ? SecurityAssessmentMetadataPartnerData.fromJS(_data["partnerData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SecurityAssessmentMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityAssessmentMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["displayName"] = this.displayName;
        data["policyDefinitionId"] = this.policyDefinitionId;
        data["description"] = this.description;
        data["remediationDescription"] = this.remediationDescription;
        if (Array.isArray(this.category)) {
            data["category"] = [];
            for (let item of this.category)
                data["category"].push(item);
        }
        data["severity"] = this.severity;
        data["userImpact"] = this.userImpact;
        data["implementationEffort"] = this.implementationEffort;
        if (Array.isArray(this.threats)) {
            data["threats"] = [];
            for (let item of this.threats)
                data["threats"].push(item);
        }
        data["preview"] = this.preview;
        data["assessmentType"] = this.assessmentType;
        data["partnerData"] = this.partnerData ? this.partnerData.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISecurityAssessmentMetadata {
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    displayName?: string | undefined;
    policyDefinitionId?: string | undefined;
    description?: string | undefined;
    remediationDescription?: string | undefined;
    category?: string[] | undefined;
    severity?: string | undefined;
    userImpact?: string | undefined;
    implementationEffort?: string | undefined;
    threats?: string[] | undefined;
    preview?: boolean | undefined;
    assessmentType?: string | undefined;
    partnerData?: SecurityAssessmentMetadataPartnerData;
}

export class SecurityAssessmentMetadataPartnerData implements ISecurityAssessmentMetadataPartnerData {
    partnerName?: string | undefined;
    productName?: string | undefined;
    secret?: string | undefined;

    constructor(data?: ISecurityAssessmentMetadataPartnerData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerName = _data["partnerName"];
            this.productName = _data["productName"];
            this.secret = _data["secret"];
        }
    }

    static fromJS(data: any): SecurityAssessmentMetadataPartnerData {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityAssessmentMetadataPartnerData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerName"] = this.partnerName;
        data["productName"] = this.productName;
        data["secret"] = this.secret;
        return data;
    }
}

export interface ISecurityAssessmentMetadataPartnerData {
    partnerName?: string | undefined;
    productName?: string | undefined;
    secret?: string | undefined;
}

export class SecuritySubAssessment implements ISecuritySubAssessment {
    securitySubAssessmentId?: string | undefined;
    displayName?: string | undefined;
    status?: SubAssessmentStatus;
    remediation?: string | undefined;
    impact?: string | undefined;
    category?: string | undefined;
    description?: string | undefined;
    timeGenerated?: Date | undefined;
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;

    constructor(data?: ISecuritySubAssessment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.securitySubAssessmentId = _data["securitySubAssessmentId"];
            this.displayName = _data["displayName"];
            this.status = _data["status"] ? SubAssessmentStatus.fromJS(_data["status"]) : <any>undefined;
            this.remediation = _data["remediation"];
            this.impact = _data["impact"];
            this.category = _data["category"];
            this.description = _data["description"];
            this.timeGenerated = _data["timeGenerated"] ? new Date(_data["timeGenerated"].toString()) : <any>undefined;
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): SecuritySubAssessment {
        data = typeof data === 'object' ? data : {};
        let result = new SecuritySubAssessment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securitySubAssessmentId"] = this.securitySubAssessmentId;
        data["displayName"] = this.displayName;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["remediation"] = this.remediation;
        data["impact"] = this.impact;
        data["category"] = this.category;
        data["description"] = this.description;
        data["timeGenerated"] = this.timeGenerated ? this.timeGenerated.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        return data;
    }
}

export interface ISecuritySubAssessment {
    securitySubAssessmentId?: string | undefined;
    displayName?: string | undefined;
    status?: SubAssessmentStatus;
    remediation?: string | undefined;
    impact?: string | undefined;
    category?: string | undefined;
    description?: string | undefined;
    timeGenerated?: Date | undefined;
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
}

export class ShortDescription implements IShortDescription {
    problem?: string | undefined;
    solution?: string | undefined;

    constructor(data?: IShortDescription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.problem = _data["problem"];
            this.solution = _data["solution"];
        }
    }

    static fromJS(data: any): ShortDescription {
        data = typeof data === 'object' ? data : {};
        let result = new ShortDescription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["problem"] = this.problem;
        data["solution"] = this.solution;
        return data;
    }
}

export interface IShortDescription {
    problem?: string | undefined;
    solution?: string | undefined;
}

export class SimpleProtectedItemResource implements ISimpleProtectedItemResource {
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    location?: string | undefined;
    tags?: { [key: string]: string; } | undefined;
    eTag?: string | undefined;
    backupManagementType?: string | undefined;
    workloadType?: string | undefined;
    containerName?: string | undefined;
    sourceResourceId?: string | undefined;
    policyId?: string | undefined;
    lastRecoveryPoint?: Date | undefined;
    backupSetName?: string | undefined;
    createMode?: string | undefined;
    deferredDeleteTimeInUTC?: Date | undefined;
    isScheduledForDeferredDelete?: boolean | undefined;
    deferredDeleteTimeRemaining?: string | undefined;
    isDeferredDeleteScheduleUpcoming?: boolean | undefined;
    isRehydrate?: boolean | undefined;
    friendlyName?: string | undefined;
    protectionStatus?: string | undefined;
    protectionState?: string | undefined;
    lastBackupStatus?: string | undefined;
    lastBackupTime?: Date | undefined;
    healthStatus?: string | undefined;
    lastBackupErrorDetail?: ErrorDetail;
    virtualMachineId?: string | undefined;
    oldestRecoveryPoint?: Date | undefined;
    recoveryPointCount?: number | undefined;

    constructor(data?: ISimpleProtectedItemResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.location = _data["location"];
            if (_data["tags"]) {
                this.tags = {} as any;
                for (let key in _data["tags"]) {
                    if (_data["tags"].hasOwnProperty(key))
                        (<any>this.tags)![key] = _data["tags"][key];
                }
            }
            this.eTag = _data["eTag"];
            this.backupManagementType = _data["backupManagementType"];
            this.workloadType = _data["workloadType"];
            this.containerName = _data["containerName"];
            this.sourceResourceId = _data["sourceResourceId"];
            this.policyId = _data["policyId"];
            this.lastRecoveryPoint = _data["lastRecoveryPoint"] ? new Date(_data["lastRecoveryPoint"].toString()) : <any>undefined;
            this.backupSetName = _data["backupSetName"];
            this.createMode = _data["createMode"];
            this.deferredDeleteTimeInUTC = _data["deferredDeleteTimeInUTC"] ? new Date(_data["deferredDeleteTimeInUTC"].toString()) : <any>undefined;
            this.isScheduledForDeferredDelete = _data["isScheduledForDeferredDelete"];
            this.deferredDeleteTimeRemaining = _data["deferredDeleteTimeRemaining"];
            this.isDeferredDeleteScheduleUpcoming = _data["isDeferredDeleteScheduleUpcoming"];
            this.isRehydrate = _data["isRehydrate"];
            this.friendlyName = _data["friendlyName"];
            this.protectionStatus = _data["protectionStatus"];
            this.protectionState = _data["protectionState"];
            this.lastBackupStatus = _data["lastBackupStatus"];
            this.lastBackupTime = _data["lastBackupTime"] ? new Date(_data["lastBackupTime"].toString()) : <any>undefined;
            this.healthStatus = _data["healthStatus"];
            this.lastBackupErrorDetail = _data["lastBackupErrorDetail"] ? ErrorDetail.fromJS(_data["lastBackupErrorDetail"]) : <any>undefined;
            this.virtualMachineId = _data["virtualMachineId"];
            this.oldestRecoveryPoint = _data["oldestRecoveryPoint"] ? new Date(_data["oldestRecoveryPoint"].toString()) : <any>undefined;
            this.recoveryPointCount = _data["recoveryPointCount"];
        }
    }

    static fromJS(data: any): SimpleProtectedItemResource {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleProtectedItemResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["location"] = this.location;
        if (this.tags) {
            data["tags"] = {};
            for (let key in this.tags) {
                if (this.tags.hasOwnProperty(key))
                    (<any>data["tags"])[key] = (<any>this.tags)[key];
            }
        }
        data["eTag"] = this.eTag;
        data["backupManagementType"] = this.backupManagementType;
        data["workloadType"] = this.workloadType;
        data["containerName"] = this.containerName;
        data["sourceResourceId"] = this.sourceResourceId;
        data["policyId"] = this.policyId;
        data["lastRecoveryPoint"] = this.lastRecoveryPoint ? this.lastRecoveryPoint.toISOString() : <any>undefined;
        data["backupSetName"] = this.backupSetName;
        data["createMode"] = this.createMode;
        data["deferredDeleteTimeInUTC"] = this.deferredDeleteTimeInUTC ? this.deferredDeleteTimeInUTC.toISOString() : <any>undefined;
        data["isScheduledForDeferredDelete"] = this.isScheduledForDeferredDelete;
        data["deferredDeleteTimeRemaining"] = this.deferredDeleteTimeRemaining;
        data["isDeferredDeleteScheduleUpcoming"] = this.isDeferredDeleteScheduleUpcoming;
        data["isRehydrate"] = this.isRehydrate;
        data["friendlyName"] = this.friendlyName;
        data["protectionStatus"] = this.protectionStatus;
        data["protectionState"] = this.protectionState;
        data["lastBackupStatus"] = this.lastBackupStatus;
        data["lastBackupTime"] = this.lastBackupTime ? this.lastBackupTime.toISOString() : <any>undefined;
        data["healthStatus"] = this.healthStatus;
        data["lastBackupErrorDetail"] = this.lastBackupErrorDetail ? this.lastBackupErrorDetail.toJSON() : <any>undefined;
        data["virtualMachineId"] = this.virtualMachineId;
        data["oldestRecoveryPoint"] = this.oldestRecoveryPoint ? this.oldestRecoveryPoint.toISOString() : <any>undefined;
        data["recoveryPointCount"] = this.recoveryPointCount;
        return data;
    }
}

export interface ISimpleProtectedItemResource {
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    location?: string | undefined;
    tags?: { [key: string]: string; } | undefined;
    eTag?: string | undefined;
    backupManagementType?: string | undefined;
    workloadType?: string | undefined;
    containerName?: string | undefined;
    sourceResourceId?: string | undefined;
    policyId?: string | undefined;
    lastRecoveryPoint?: Date | undefined;
    backupSetName?: string | undefined;
    createMode?: string | undefined;
    deferredDeleteTimeInUTC?: Date | undefined;
    isScheduledForDeferredDelete?: boolean | undefined;
    deferredDeleteTimeRemaining?: string | undefined;
    isDeferredDeleteScheduleUpcoming?: boolean | undefined;
    isRehydrate?: boolean | undefined;
    friendlyName?: string | undefined;
    protectionStatus?: string | undefined;
    protectionState?: string | undefined;
    lastBackupStatus?: string | undefined;
    lastBackupTime?: Date | undefined;
    healthStatus?: string | undefined;
    lastBackupErrorDetail?: ErrorDetail;
    virtualMachineId?: string | undefined;
    oldestRecoveryPoint?: Date | undefined;
    recoveryPointCount?: number | undefined;
}

export class SubAssessmentStatus implements ISubAssessmentStatus {
    code?: string | undefined;
    cause?: string | undefined;
    description?: string | undefined;
    severity?: string | undefined;

    constructor(data?: ISubAssessmentStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.cause = _data["cause"];
            this.description = _data["description"];
            this.severity = _data["severity"];
        }
    }

    static fromJS(data: any): SubAssessmentStatus {
        data = typeof data === 'object' ? data : {};
        let result = new SubAssessmentStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["cause"] = this.cause;
        data["description"] = this.description;
        data["severity"] = this.severity;
        return data;
    }
}

export interface ISubAssessmentStatus {
    code?: string | undefined;
    cause?: string | undefined;
    description?: string | undefined;
    severity?: string | undefined;
}

export enum CollectionProcessingStatus {
    Failed = "Failed",
    Success = "Success",
}

export class HistoricalCollectionDetails implements IHistoricalCollectionDetails {
    customerId?: string | undefined;
    startTime?: Date;
    endTime?: Date;
    status?: CollectionProcessingStatus;
    duration?: string;
    integrationType?: number;
    exceptionMessage?: string | undefined;
    exceptionTime?: Date | undefined;
    _ts?: Date;

    constructor(data?: IHistoricalCollectionDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.duration = _data["duration"];
            this.integrationType = _data["integrationType"];
            this.exceptionMessage = _data["exceptionMessage"];
            this.exceptionTime = _data["exceptionTime"] ? new Date(_data["exceptionTime"].toString()) : <any>undefined;
            this._ts = _data["_ts"] ? new Date(_data["_ts"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HistoricalCollectionDetails {
        data = typeof data === 'object' ? data : {};
        let result = new HistoricalCollectionDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["duration"] = this.duration;
        data["integrationType"] = this.integrationType;
        data["exceptionMessage"] = this.exceptionMessage;
        data["exceptionTime"] = this.exceptionTime ? this.exceptionTime.toISOString() : <any>undefined;
        data["_ts"] = this._ts ? this._ts.toISOString() : <any>undefined;
        return data;
    }
}

export interface IHistoricalCollectionDetails {
    customerId?: string | undefined;
    startTime?: Date;
    endTime?: Date;
    status?: CollectionProcessingStatus;
    duration?: string;
    integrationType?: number;
    exceptionMessage?: string | undefined;
    exceptionTime?: Date | undefined;
    _ts?: Date;
}

export class AccountDto implements IAccountDto {
    id?: string;
    name?: string | undefined;
    axAccountNumber?: string | undefined;
    address1City?: string | undefined;
    address1Country?: string | undefined;
    address1Line1?: string | undefined;
    address1Line2?: string | undefined;
    address1PostalCode?: string | undefined;
    address1StateOrProvince?: string | undefined;
    address1Telephone?: string | undefined;
    customerType?: number | undefined;
    owningTeamId?: string | undefined;
    owningTeam?: TeamDto;
    parentAccountId?: string | undefined;
    parentAccount?: AccountDto;
    reportingBusinessUnitId?: string | undefined;
    reportingBusinessUnit?: ReportingBusinessUnitDto;
    createdOnInCrm?: Date;
    modifiedInCrm?: Date;
    roleConnections?: ResourceAlignmentDto[] | undefined;

    constructor(data?: IAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.axAccountNumber = _data["axAccountNumber"];
            this.address1City = _data["address1City"];
            this.address1Country = _data["address1Country"];
            this.address1Line1 = _data["address1Line1"];
            this.address1Line2 = _data["address1Line2"];
            this.address1PostalCode = _data["address1PostalCode"];
            this.address1StateOrProvince = _data["address1StateOrProvince"];
            this.address1Telephone = _data["address1Telephone"];
            this.customerType = _data["customerType"];
            this.owningTeamId = _data["owningTeamId"];
            this.owningTeam = _data["owningTeam"] ? TeamDto.fromJS(_data["owningTeam"]) : <any>undefined;
            this.parentAccountId = _data["parentAccountId"];
            this.parentAccount = _data["parentAccount"] ? AccountDto.fromJS(_data["parentAccount"]) : <any>undefined;
            this.reportingBusinessUnitId = _data["reportingBusinessUnitId"];
            this.reportingBusinessUnit = _data["reportingBusinessUnit"] ? ReportingBusinessUnitDto.fromJS(_data["reportingBusinessUnit"]) : <any>undefined;
            this.createdOnInCrm = _data["createdOnInCrm"] ? new Date(_data["createdOnInCrm"].toString()) : <any>undefined;
            this.modifiedInCrm = _data["modifiedInCrm"] ? new Date(_data["modifiedInCrm"].toString()) : <any>undefined;
            if (Array.isArray(_data["roleConnections"])) {
                this.roleConnections = [] as any;
                for (let item of _data["roleConnections"])
                    this.roleConnections!.push(ResourceAlignmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["axAccountNumber"] = this.axAccountNumber;
        data["address1City"] = this.address1City;
        data["address1Country"] = this.address1Country;
        data["address1Line1"] = this.address1Line1;
        data["address1Line2"] = this.address1Line2;
        data["address1PostalCode"] = this.address1PostalCode;
        data["address1StateOrProvince"] = this.address1StateOrProvince;
        data["address1Telephone"] = this.address1Telephone;
        data["customerType"] = this.customerType;
        data["owningTeamId"] = this.owningTeamId;
        data["owningTeam"] = this.owningTeam ? this.owningTeam.toJSON() : <any>undefined;
        data["parentAccountId"] = this.parentAccountId;
        data["parentAccount"] = this.parentAccount ? this.parentAccount.toJSON() : <any>undefined;
        data["reportingBusinessUnitId"] = this.reportingBusinessUnitId;
        data["reportingBusinessUnit"] = this.reportingBusinessUnit ? this.reportingBusinessUnit.toJSON() : <any>undefined;
        data["createdOnInCrm"] = this.createdOnInCrm ? this.createdOnInCrm.toISOString() : <any>undefined;
        data["modifiedInCrm"] = this.modifiedInCrm ? this.modifiedInCrm.toISOString() : <any>undefined;
        if (Array.isArray(this.roleConnections)) {
            data["roleConnections"] = [];
            for (let item of this.roleConnections)
                data["roleConnections"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAccountDto {
    id?: string;
    name?: string | undefined;
    axAccountNumber?: string | undefined;
    address1City?: string | undefined;
    address1Country?: string | undefined;
    address1Line1?: string | undefined;
    address1Line2?: string | undefined;
    address1PostalCode?: string | undefined;
    address1StateOrProvince?: string | undefined;
    address1Telephone?: string | undefined;
    customerType?: number | undefined;
    owningTeamId?: string | undefined;
    owningTeam?: TeamDto;
    parentAccountId?: string | undefined;
    parentAccount?: AccountDto;
    reportingBusinessUnitId?: string | undefined;
    reportingBusinessUnit?: ReportingBusinessUnitDto;
    createdOnInCrm?: Date;
    modifiedInCrm?: Date;
    roleConnections?: ResourceAlignmentDto[] | undefined;
}

export class ConnectionRole implements IConnectionRole {
    id?: string;
    name?: string | undefined;
    roleActive?: number;
    modifiedInCrm?: Date | undefined;
    createdOnInCrm?: Date | undefined;

    constructor(data?: IConnectionRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.roleActive = _data["roleActive"];
            this.modifiedInCrm = _data["modifiedInCrm"] ? new Date(_data["modifiedInCrm"].toString()) : <any>undefined;
            this.createdOnInCrm = _data["createdOnInCrm"] ? new Date(_data["createdOnInCrm"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ConnectionRole {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectionRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["roleActive"] = this.roleActive;
        data["modifiedInCrm"] = this.modifiedInCrm ? this.modifiedInCrm.toISOString() : <any>undefined;
        data["createdOnInCrm"] = this.createdOnInCrm ? this.createdOnInCrm.toISOString() : <any>undefined;
        return data;
    }
}

export interface IConnectionRole {
    id?: string;
    name?: string | undefined;
    roleActive?: number;
    modifiedInCrm?: Date | undefined;
    createdOnInCrm?: Date | undefined;
}

export class ReportingBusinessUnitDto implements IReportingBusinessUnitDto {
    id?: string;
    levelOneOutsideManagerId?: string | undefined;
    levelOneOutsideManager?: SystemUserDto;
    levelTwoOutsideManagerId?: string | undefined;
    levelTwoOutsideManager?: SystemUserDto;
    levelThreeOutsideManagerId?: string | undefined;
    levelThreeOutsideManager?: SystemUserDto;
    levelFourOutsideManagerId?: string | undefined;
    levelFourOutsideManager?: SystemUserDto;
    levelFiveOutsideManagerId?: string | undefined;
    levelFiveOutsideManager?: SystemUserDto;
    parentReportingBusinessUnitId?: string | undefined;
    parentReportingBusinessUnit?: ReportingBusinessUnitDto;
    createdOnInCrm?: Date;
    modifiedInCrm?: Date;
    name?: string | undefined;
    pathName?: string | undefined;
    roleConnections?: ResourceAlignmentDto[] | undefined;

    constructor(data?: IReportingBusinessUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.levelOneOutsideManagerId = _data["levelOneOutsideManagerId"];
            this.levelOneOutsideManager = _data["levelOneOutsideManager"] ? SystemUserDto.fromJS(_data["levelOneOutsideManager"]) : <any>undefined;
            this.levelTwoOutsideManagerId = _data["levelTwoOutsideManagerId"];
            this.levelTwoOutsideManager = _data["levelTwoOutsideManager"] ? SystemUserDto.fromJS(_data["levelTwoOutsideManager"]) : <any>undefined;
            this.levelThreeOutsideManagerId = _data["levelThreeOutsideManagerId"];
            this.levelThreeOutsideManager = _data["levelThreeOutsideManager"] ? SystemUserDto.fromJS(_data["levelThreeOutsideManager"]) : <any>undefined;
            this.levelFourOutsideManagerId = _data["levelFourOutsideManagerId"];
            this.levelFourOutsideManager = _data["levelFourOutsideManager"] ? SystemUserDto.fromJS(_data["levelFourOutsideManager"]) : <any>undefined;
            this.levelFiveOutsideManagerId = _data["levelFiveOutsideManagerId"];
            this.levelFiveOutsideManager = _data["levelFiveOutsideManager"] ? SystemUserDto.fromJS(_data["levelFiveOutsideManager"]) : <any>undefined;
            this.parentReportingBusinessUnitId = _data["parentReportingBusinessUnitId"];
            this.parentReportingBusinessUnit = _data["parentReportingBusinessUnit"] ? ReportingBusinessUnitDto.fromJS(_data["parentReportingBusinessUnit"]) : <any>undefined;
            this.createdOnInCrm = _data["createdOnInCrm"] ? new Date(_data["createdOnInCrm"].toString()) : <any>undefined;
            this.modifiedInCrm = _data["modifiedInCrm"] ? new Date(_data["modifiedInCrm"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.pathName = _data["pathName"];
            if (Array.isArray(_data["roleConnections"])) {
                this.roleConnections = [] as any;
                for (let item of _data["roleConnections"])
                    this.roleConnections!.push(ResourceAlignmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReportingBusinessUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportingBusinessUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["levelOneOutsideManagerId"] = this.levelOneOutsideManagerId;
        data["levelOneOutsideManager"] = this.levelOneOutsideManager ? this.levelOneOutsideManager.toJSON() : <any>undefined;
        data["levelTwoOutsideManagerId"] = this.levelTwoOutsideManagerId;
        data["levelTwoOutsideManager"] = this.levelTwoOutsideManager ? this.levelTwoOutsideManager.toJSON() : <any>undefined;
        data["levelThreeOutsideManagerId"] = this.levelThreeOutsideManagerId;
        data["levelThreeOutsideManager"] = this.levelThreeOutsideManager ? this.levelThreeOutsideManager.toJSON() : <any>undefined;
        data["levelFourOutsideManagerId"] = this.levelFourOutsideManagerId;
        data["levelFourOutsideManager"] = this.levelFourOutsideManager ? this.levelFourOutsideManager.toJSON() : <any>undefined;
        data["levelFiveOutsideManagerId"] = this.levelFiveOutsideManagerId;
        data["levelFiveOutsideManager"] = this.levelFiveOutsideManager ? this.levelFiveOutsideManager.toJSON() : <any>undefined;
        data["parentReportingBusinessUnitId"] = this.parentReportingBusinessUnitId;
        data["parentReportingBusinessUnit"] = this.parentReportingBusinessUnit ? this.parentReportingBusinessUnit.toJSON() : <any>undefined;
        data["createdOnInCrm"] = this.createdOnInCrm ? this.createdOnInCrm.toISOString() : <any>undefined;
        data["modifiedInCrm"] = this.modifiedInCrm ? this.modifiedInCrm.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["pathName"] = this.pathName;
        if (Array.isArray(this.roleConnections)) {
            data["roleConnections"] = [];
            for (let item of this.roleConnections)
                data["roleConnections"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReportingBusinessUnitDto {
    id?: string;
    levelOneOutsideManagerId?: string | undefined;
    levelOneOutsideManager?: SystemUserDto;
    levelTwoOutsideManagerId?: string | undefined;
    levelTwoOutsideManager?: SystemUserDto;
    levelThreeOutsideManagerId?: string | undefined;
    levelThreeOutsideManager?: SystemUserDto;
    levelFourOutsideManagerId?: string | undefined;
    levelFourOutsideManager?: SystemUserDto;
    levelFiveOutsideManagerId?: string | undefined;
    levelFiveOutsideManager?: SystemUserDto;
    parentReportingBusinessUnitId?: string | undefined;
    parentReportingBusinessUnit?: ReportingBusinessUnitDto;
    createdOnInCrm?: Date;
    modifiedInCrm?: Date;
    name?: string | undefined;
    pathName?: string | undefined;
    roleConnections?: ResourceAlignmentDto[] | undefined;
}

export class ResourceAlignmentDto implements IResourceAlignmentDto {
    id?: string;
    connectionRoleId?: string | undefined;
    connectionRole?: ConnectionRole;
    modifiedInCrm?: Date | undefined;
    createdOnInCrm?: Date | undefined;
    resourceAlignmentName?: string | undefined;
    systemUserId?: string | undefined;
    systemUser?: SystemUserDto;
    accountId?: string | undefined;
    account?: AccountDto;
    teamId?: string | undefined;
    team?: TeamDto;
    reportingBusinessUnitId?: string | undefined;
    reportingBusinessUnit?: ReportingBusinessUnitDto;

    constructor(data?: IResourceAlignmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.connectionRoleId = _data["connectionRoleId"];
            this.connectionRole = _data["connectionRole"] ? ConnectionRole.fromJS(_data["connectionRole"]) : <any>undefined;
            this.modifiedInCrm = _data["modifiedInCrm"] ? new Date(_data["modifiedInCrm"].toString()) : <any>undefined;
            this.createdOnInCrm = _data["createdOnInCrm"] ? new Date(_data["createdOnInCrm"].toString()) : <any>undefined;
            this.resourceAlignmentName = _data["resourceAlignmentName"];
            this.systemUserId = _data["systemUserId"];
            this.systemUser = _data["systemUser"] ? SystemUserDto.fromJS(_data["systemUser"]) : <any>undefined;
            this.accountId = _data["accountId"];
            this.account = _data["account"] ? AccountDto.fromJS(_data["account"]) : <any>undefined;
            this.teamId = _data["teamId"];
            this.team = _data["team"] ? TeamDto.fromJS(_data["team"]) : <any>undefined;
            this.reportingBusinessUnitId = _data["reportingBusinessUnitId"];
            this.reportingBusinessUnit = _data["reportingBusinessUnit"] ? ReportingBusinessUnitDto.fromJS(_data["reportingBusinessUnit"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResourceAlignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceAlignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["connectionRoleId"] = this.connectionRoleId;
        data["connectionRole"] = this.connectionRole ? this.connectionRole.toJSON() : <any>undefined;
        data["modifiedInCrm"] = this.modifiedInCrm ? this.modifiedInCrm.toISOString() : <any>undefined;
        data["createdOnInCrm"] = this.createdOnInCrm ? this.createdOnInCrm.toISOString() : <any>undefined;
        data["resourceAlignmentName"] = this.resourceAlignmentName;
        data["systemUserId"] = this.systemUserId;
        data["systemUser"] = this.systemUser ? this.systemUser.toJSON() : <any>undefined;
        data["accountId"] = this.accountId;
        data["account"] = this.account ? this.account.toJSON() : <any>undefined;
        data["teamId"] = this.teamId;
        data["team"] = this.team ? this.team.toJSON() : <any>undefined;
        data["reportingBusinessUnitId"] = this.reportingBusinessUnitId;
        data["reportingBusinessUnit"] = this.reportingBusinessUnit ? this.reportingBusinessUnit.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResourceAlignmentDto {
    id?: string;
    connectionRoleId?: string | undefined;
    connectionRole?: ConnectionRole;
    modifiedInCrm?: Date | undefined;
    createdOnInCrm?: Date | undefined;
    resourceAlignmentName?: string | undefined;
    systemUserId?: string | undefined;
    systemUser?: SystemUserDto;
    accountId?: string | undefined;
    account?: AccountDto;
    teamId?: string | undefined;
    team?: TeamDto;
    reportingBusinessUnitId?: string | undefined;
    reportingBusinessUnit?: ReportingBusinessUnitDto;
}

export class ShiEmployeeDto implements IShiEmployeeDto {
    id?: string;
    displayName?: string | undefined;
    email?: string | undefined;
    jobTitle?: string | undefined;
    lastRetrievedFromEntra?: Date;
    managerId?: string | undefined;
    manager?: ShiEmployeeDto;
    directReports?: ShiEmployeeDto[] | undefined;
    systemUser?: SystemUserDto;
    systemUserId?: string | undefined;

    constructor(data?: IShiEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.email = _data["email"];
            this.jobTitle = _data["jobTitle"];
            this.lastRetrievedFromEntra = _data["lastRetrievedFromEntra"] ? new Date(_data["lastRetrievedFromEntra"].toString()) : <any>undefined;
            this.managerId = _data["managerId"];
            this.manager = _data["manager"] ? ShiEmployeeDto.fromJS(_data["manager"]) : <any>undefined;
            if (Array.isArray(_data["directReports"])) {
                this.directReports = [] as any;
                for (let item of _data["directReports"])
                    this.directReports!.push(ShiEmployeeDto.fromJS(item));
            }
            this.systemUser = _data["systemUser"] ? SystemUserDto.fromJS(_data["systemUser"]) : <any>undefined;
            this.systemUserId = _data["systemUserId"];
        }
    }

    static fromJS(data: any): ShiEmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShiEmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["email"] = this.email;
        data["jobTitle"] = this.jobTitle;
        data["lastRetrievedFromEntra"] = this.lastRetrievedFromEntra ? this.lastRetrievedFromEntra.toISOString() : <any>undefined;
        data["managerId"] = this.managerId;
        data["manager"] = this.manager ? this.manager.toJSON() : <any>undefined;
        if (Array.isArray(this.directReports)) {
            data["directReports"] = [];
            for (let item of this.directReports)
                data["directReports"].push(item.toJSON());
        }
        data["systemUser"] = this.systemUser ? this.systemUser.toJSON() : <any>undefined;
        data["systemUserId"] = this.systemUserId;
        return data;
    }
}

export interface IShiEmployeeDto {
    id?: string;
    displayName?: string | undefined;
    email?: string | undefined;
    jobTitle?: string | undefined;
    lastRetrievedFromEntra?: Date;
    managerId?: string | undefined;
    manager?: ShiEmployeeDto;
    directReports?: ShiEmployeeDto[] | undefined;
    systemUser?: SystemUserDto;
    systemUserId?: string | undefined;
}

export class SystemUserDto implements ISystemUserDto {
    id?: string;
    reportingBusinessUnitId?: string | undefined;
    reportingBusinessUnit?: ReportingBusinessUnitDto;
    connectionRoleId?: string | undefined;
    connectionRoleName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleName?: string | undefined;
    fullName?: string | undefined;
    shiLocalDomainName?: string | undefined;
    title?: string | undefined;
    internalEmailAddress?: string | undefined;
    isDisabledInCrm?: boolean;
    shiEmployee?: ShiEmployeeDto;
    shiEmployeeId?: string | undefined;
    modifiedInCrm?: Date;
    createdOnInCrm?: Date;
    teamMemberships?: TeamMembershipDto[] | undefined;
    roleConnections?: ResourceAlignmentDto[] | undefined;

    constructor(data?: ISystemUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reportingBusinessUnitId = _data["reportingBusinessUnitId"];
            this.reportingBusinessUnit = _data["reportingBusinessUnit"] ? ReportingBusinessUnitDto.fromJS(_data["reportingBusinessUnit"]) : <any>undefined;
            this.connectionRoleId = _data["connectionRoleId"];
            this.connectionRoleName = _data["connectionRoleName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.fullName = _data["fullName"];
            this.shiLocalDomainName = _data["shiLocalDomainName"];
            this.title = _data["title"];
            this.internalEmailAddress = _data["internalEmailAddress"];
            this.isDisabledInCrm = _data["isDisabledInCrm"];
            this.shiEmployee = _data["shiEmployee"] ? ShiEmployeeDto.fromJS(_data["shiEmployee"]) : <any>undefined;
            this.shiEmployeeId = _data["shiEmployeeId"];
            this.modifiedInCrm = _data["modifiedInCrm"] ? new Date(_data["modifiedInCrm"].toString()) : <any>undefined;
            this.createdOnInCrm = _data["createdOnInCrm"] ? new Date(_data["createdOnInCrm"].toString()) : <any>undefined;
            if (Array.isArray(_data["teamMemberships"])) {
                this.teamMemberships = [] as any;
                for (let item of _data["teamMemberships"])
                    this.teamMemberships!.push(TeamMembershipDto.fromJS(item));
            }
            if (Array.isArray(_data["roleConnections"])) {
                this.roleConnections = [] as any;
                for (let item of _data["roleConnections"])
                    this.roleConnections!.push(ResourceAlignmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SystemUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reportingBusinessUnitId"] = this.reportingBusinessUnitId;
        data["reportingBusinessUnit"] = this.reportingBusinessUnit ? this.reportingBusinessUnit.toJSON() : <any>undefined;
        data["connectionRoleId"] = this.connectionRoleId;
        data["connectionRoleName"] = this.connectionRoleName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["fullName"] = this.fullName;
        data["shiLocalDomainName"] = this.shiLocalDomainName;
        data["title"] = this.title;
        data["internalEmailAddress"] = this.internalEmailAddress;
        data["isDisabledInCrm"] = this.isDisabledInCrm;
        data["shiEmployee"] = this.shiEmployee ? this.shiEmployee.toJSON() : <any>undefined;
        data["shiEmployeeId"] = this.shiEmployeeId;
        data["modifiedInCrm"] = this.modifiedInCrm ? this.modifiedInCrm.toISOString() : <any>undefined;
        data["createdOnInCrm"] = this.createdOnInCrm ? this.createdOnInCrm.toISOString() : <any>undefined;
        if (Array.isArray(this.teamMemberships)) {
            data["teamMemberships"] = [];
            for (let item of this.teamMemberships)
                data["teamMemberships"].push(item.toJSON());
        }
        if (Array.isArray(this.roleConnections)) {
            data["roleConnections"] = [];
            for (let item of this.roleConnections)
                data["roleConnections"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISystemUserDto {
    id?: string;
    reportingBusinessUnitId?: string | undefined;
    reportingBusinessUnit?: ReportingBusinessUnitDto;
    connectionRoleId?: string | undefined;
    connectionRoleName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleName?: string | undefined;
    fullName?: string | undefined;
    shiLocalDomainName?: string | undefined;
    title?: string | undefined;
    internalEmailAddress?: string | undefined;
    isDisabledInCrm?: boolean;
    shiEmployee?: ShiEmployeeDto;
    shiEmployeeId?: string | undefined;
    modifiedInCrm?: Date;
    createdOnInCrm?: Date;
    teamMemberships?: TeamMembershipDto[] | undefined;
    roleConnections?: ResourceAlignmentDto[] | undefined;
}

export class TeamDto implements ITeamDto {
    id?: string;
    name?: string | undefined;
    salesKey?: string | undefined;
    createdOnInCrm?: Date;
    modifiedInCrm?: Date;
    teamMemberships?: TeamMembershipDto[] | undefined;
    roleConnections?: ResourceAlignmentDto[] | undefined;

    constructor(data?: ITeamDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.salesKey = _data["salesKey"];
            this.createdOnInCrm = _data["createdOnInCrm"] ? new Date(_data["createdOnInCrm"].toString()) : <any>undefined;
            this.modifiedInCrm = _data["modifiedInCrm"] ? new Date(_data["modifiedInCrm"].toString()) : <any>undefined;
            if (Array.isArray(_data["teamMemberships"])) {
                this.teamMemberships = [] as any;
                for (let item of _data["teamMemberships"])
                    this.teamMemberships!.push(TeamMembershipDto.fromJS(item));
            }
            if (Array.isArray(_data["roleConnections"])) {
                this.roleConnections = [] as any;
                for (let item of _data["roleConnections"])
                    this.roleConnections!.push(ResourceAlignmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TeamDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["salesKey"] = this.salesKey;
        data["createdOnInCrm"] = this.createdOnInCrm ? this.createdOnInCrm.toISOString() : <any>undefined;
        data["modifiedInCrm"] = this.modifiedInCrm ? this.modifiedInCrm.toISOString() : <any>undefined;
        if (Array.isArray(this.teamMemberships)) {
            data["teamMemberships"] = [];
            for (let item of this.teamMemberships)
                data["teamMemberships"].push(item.toJSON());
        }
        if (Array.isArray(this.roleConnections)) {
            data["roleConnections"] = [];
            for (let item of this.roleConnections)
                data["roleConnections"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITeamDto {
    id?: string;
    name?: string | undefined;
    salesKey?: string | undefined;
    createdOnInCrm?: Date;
    modifiedInCrm?: Date;
    teamMemberships?: TeamMembershipDto[] | undefined;
    roleConnections?: ResourceAlignmentDto[] | undefined;
}

export class TeamMembershipDto implements ITeamMembershipDto {
    id?: string;
    systemUserId?: string;
    systemUser?: SystemUserDto;
    teamId?: string;
    team?: TeamDto;
    isPrimaryTeamOwner?: boolean;

    constructor(data?: ITeamMembershipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.systemUserId = _data["systemUserId"];
            this.systemUser = _data["systemUser"] ? SystemUserDto.fromJS(_data["systemUser"]) : <any>undefined;
            this.teamId = _data["teamId"];
            this.team = _data["team"] ? TeamDto.fromJS(_data["team"]) : <any>undefined;
            this.isPrimaryTeamOwner = _data["isPrimaryTeamOwner"];
        }
    }

    static fromJS(data: any): TeamMembershipDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamMembershipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["systemUserId"] = this.systemUserId;
        data["systemUser"] = this.systemUser ? this.systemUser.toJSON() : <any>undefined;
        data["teamId"] = this.teamId;
        data["team"] = this.team ? this.team.toJSON() : <any>undefined;
        data["isPrimaryTeamOwner"] = this.isPrimaryTeamOwner;
        return data;
    }
}

export interface ITeamMembershipDto {
    id?: string;
    systemUserId?: string;
    systemUser?: SystemUserDto;
    teamId?: string;
    team?: TeamDto;
    isPrimaryTeamOwner?: boolean;
}

export class UpsertAssessmentFromAirtableCommand implements IUpsertAssessmentFromAirtableCommand {
    id?: string | undefined;
    program?: string | undefined;
    name?: string | undefined;
    customerAx?: string | undefined;
    customerCrmGuid?: string | undefined;
    status?: string | undefined;
    assessmentDate?: string | undefined;
    assessorEmail?: string | undefined;
    createdDate?: string | undefined;
    lastModifiedBy?: string | undefined;
    responses?: UpsertAssessmentFromAirtableCommand_Response[] | undefined;

    constructor(data?: IUpsertAssessmentFromAirtableCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.program = _data["program"];
            this.name = _data["name"];
            this.customerAx = _data["customerAx"];
            this.customerCrmGuid = _data["customerCrmGuid"];
            this.status = _data["status"];
            this.assessmentDate = _data["assessmentDate"];
            this.assessorEmail = _data["assessorEmail"];
            this.createdDate = _data["createdDate"];
            this.lastModifiedBy = _data["lastModifiedBy"];
            if (Array.isArray(_data["responses"])) {
                this.responses = [] as any;
                for (let item of _data["responses"])
                    this.responses!.push(UpsertAssessmentFromAirtableCommand_Response.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpsertAssessmentFromAirtableCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertAssessmentFromAirtableCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["program"] = this.program;
        data["name"] = this.name;
        data["customerAx"] = this.customerAx;
        data["customerCrmGuid"] = this.customerCrmGuid;
        data["status"] = this.status;
        data["assessmentDate"] = this.assessmentDate;
        data["assessorEmail"] = this.assessorEmail;
        data["createdDate"] = this.createdDate;
        data["lastModifiedBy"] = this.lastModifiedBy;
        if (Array.isArray(this.responses)) {
            data["responses"] = [];
            for (let item of this.responses)
                data["responses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpsertAssessmentFromAirtableCommand {
    id?: string | undefined;
    program?: string | undefined;
    name?: string | undefined;
    customerAx?: string | undefined;
    customerCrmGuid?: string | undefined;
    status?: string | undefined;
    assessmentDate?: string | undefined;
    assessorEmail?: string | undefined;
    createdDate?: string | undefined;
    lastModifiedBy?: string | undefined;
    responses?: UpsertAssessmentFromAirtableCommand_Response[] | undefined;
}

export class UpsertAssessmentFromAirtableCommand_Response implements IUpsertAssessmentFromAirtableCommand_Response {
    id?: string | undefined;
    name?: string | undefined;
    key?: string | undefined;
    category?: string | undefined;
    subcategory?: string | undefined;
    orderedCategory?: string | undefined;
    capabilityId?: string | undefined;
    capabilityName?: string | undefined;
    knownTools?: string | undefined;
    otherTools?: string | undefined;
    maturity?: string | undefined;
    targetMaturity?: string | undefined;
    notes?: string | undefined;
    recommendations?: string | undefined;
    operationalPriority?: string | undefined;
    compliancePriority?: string | undefined;
    showRecommendationToCustomer?: string | undefined;
    showHarveyBallToCustomer?: string | undefined;
    submitResponseToMindspark?: string | undefined;
    optOut?: string | undefined;
    recommendationPriority?: string | undefined;
    recommendationImpact?: string | undefined;
    unknownTools?: string | undefined;
    capabilityOrder?: string | undefined;
    capabilityShortName?: string | undefined;
    customerAx?: string | undefined;
    customerCrmGuid?: string | undefined;
    recommendationsSummary?: string | undefined;

    constructor(data?: IUpsertAssessmentFromAirtableCommand_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.key = _data["key"];
            this.category = _data["category"];
            this.subcategory = _data["subcategory"];
            this.orderedCategory = _data["orderedCategory"];
            this.capabilityId = _data["capabilityId"];
            this.capabilityName = _data["capabilityName"];
            this.knownTools = _data["knownTools"];
            this.otherTools = _data["otherTools"];
            this.maturity = _data["maturity"];
            this.targetMaturity = _data["targetMaturity"];
            this.notes = _data["notes"];
            this.recommendations = _data["recommendations"];
            this.operationalPriority = _data["operationalPriority"];
            this.compliancePriority = _data["compliancePriority"];
            this.showRecommendationToCustomer = _data["showRecommendationToCustomer"];
            this.showHarveyBallToCustomer = _data["showHarveyBallToCustomer"];
            this.submitResponseToMindspark = _data["submitResponseToMindspark"];
            this.optOut = _data["optOut"];
            this.recommendationPriority = _data["recommendationPriority"];
            this.recommendationImpact = _data["recommendationImpact"];
            this.unknownTools = _data["unknownTools"];
            this.capabilityOrder = _data["capabilityOrder"];
            this.capabilityShortName = _data["capabilityShortName"];
            this.customerAx = _data["customerAx"];
            this.customerCrmGuid = _data["customerCrmGuid"];
            this.recommendationsSummary = _data["recommendationsSummary"];
        }
    }

    static fromJS(data: any): UpsertAssessmentFromAirtableCommand_Response {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertAssessmentFromAirtableCommand_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["key"] = this.key;
        data["category"] = this.category;
        data["subcategory"] = this.subcategory;
        data["orderedCategory"] = this.orderedCategory;
        data["capabilityId"] = this.capabilityId;
        data["capabilityName"] = this.capabilityName;
        data["knownTools"] = this.knownTools;
        data["otherTools"] = this.otherTools;
        data["maturity"] = this.maturity;
        data["targetMaturity"] = this.targetMaturity;
        data["notes"] = this.notes;
        data["recommendations"] = this.recommendations;
        data["operationalPriority"] = this.operationalPriority;
        data["compliancePriority"] = this.compliancePriority;
        data["showRecommendationToCustomer"] = this.showRecommendationToCustomer;
        data["showHarveyBallToCustomer"] = this.showHarveyBallToCustomer;
        data["submitResponseToMindspark"] = this.submitResponseToMindspark;
        data["optOut"] = this.optOut;
        data["recommendationPriority"] = this.recommendationPriority;
        data["recommendationImpact"] = this.recommendationImpact;
        data["unknownTools"] = this.unknownTools;
        data["capabilityOrder"] = this.capabilityOrder;
        data["capabilityShortName"] = this.capabilityShortName;
        data["customerAx"] = this.customerAx;
        data["customerCrmGuid"] = this.customerCrmGuid;
        data["recommendationsSummary"] = this.recommendationsSummary;
        return data;
    }
}

export interface IUpsertAssessmentFromAirtableCommand_Response {
    id?: string | undefined;
    name?: string | undefined;
    key?: string | undefined;
    category?: string | undefined;
    subcategory?: string | undefined;
    orderedCategory?: string | undefined;
    capabilityId?: string | undefined;
    capabilityName?: string | undefined;
    knownTools?: string | undefined;
    otherTools?: string | undefined;
    maturity?: string | undefined;
    targetMaturity?: string | undefined;
    notes?: string | undefined;
    recommendations?: string | undefined;
    operationalPriority?: string | undefined;
    compliancePriority?: string | undefined;
    showRecommendationToCustomer?: string | undefined;
    showHarveyBallToCustomer?: string | undefined;
    submitResponseToMindspark?: string | undefined;
    optOut?: string | undefined;
    recommendationPriority?: string | undefined;
    recommendationImpact?: string | undefined;
    unknownTools?: string | undefined;
    capabilityOrder?: string | undefined;
    capabilityShortName?: string | undefined;
    customerAx?: string | undefined;
    customerCrmGuid?: string | undefined;
    recommendationsSummary?: string | undefined;
}

export class SendConsultationEmailsResponse implements ISendConsultationEmailsResponse {
    sendGridResponse?: Response;

    constructor(data?: ISendConsultationEmailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sendGridResponse = _data["sendGridResponse"] ? Response.fromJS(_data["sendGridResponse"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SendConsultationEmailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendConsultationEmailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sendGridResponse"] = this.sendGridResponse ? this.sendGridResponse.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISendConsultationEmailsResponse {
    sendGridResponse?: Response;
}

export enum AssessmentProgram {
    Unknown = "Unknown",
    SecurityPostureReview = "SecurityPostureReview",
    MicrosoftAdoptionAssessment = "MicrosoftAdoptionAssessment",
    AiReadiness = "AiReadiness",
    DevOpsPostureReview = "DevOpsPostureReview",
    AwsMaturity = "AwsMaturity",
}

export class AssessmentSummary implements IAssessmentSummary {
    maturityScore?: number;
    capabilityAreas?: CapabilityAreas;
    recommendations?: number;

    constructor(data?: IAssessmentSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maturityScore = _data["maturityScore"];
            this.capabilityAreas = _data["capabilityAreas"] ? CapabilityAreas.fromJS(_data["capabilityAreas"]) : <any>undefined;
            this.recommendations = _data["recommendations"];
        }
    }

    static fromJS(data: any): AssessmentSummary {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maturityScore"] = this.maturityScore;
        data["capabilityAreas"] = this.capabilityAreas ? this.capabilityAreas.toJSON() : <any>undefined;
        data["recommendations"] = this.recommendations;
        return data;
    }
}

export interface IAssessmentSummary {
    maturityScore?: number;
    capabilityAreas?: CapabilityAreas;
    recommendations?: number;
}

export class AssessmentTemplateRow implements IAssessmentTemplateRow {
    category?: string | undefined;
    subcategory?: string | undefined;
    capability?: string | undefined;

    constructor(data?: IAssessmentTemplateRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.subcategory = _data["subcategory"];
            this.capability = _data["capability"];
        }
    }

    static fromJS(data: any): AssessmentTemplateRow {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentTemplateRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["subcategory"] = this.subcategory;
        data["capability"] = this.capability;
        return data;
    }
}

export interface IAssessmentTemplateRow {
    category?: string | undefined;
    subcategory?: string | undefined;
    capability?: string | undefined;
}

export class AssessmentTemplateUpdate implements IAssessmentTemplateUpdate {
    assessmentProgram?: string | undefined;
    assessmentTemplateRows?: AssessmentTemplateRow[] | undefined;

    constructor(data?: IAssessmentTemplateUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assessmentProgram = _data["assessmentProgram"];
            if (Array.isArray(_data["assessmentTemplateRows"])) {
                this.assessmentTemplateRows = [] as any;
                for (let item of _data["assessmentTemplateRows"])
                    this.assessmentTemplateRows!.push(AssessmentTemplateRow.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssessmentTemplateUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentTemplateUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assessmentProgram"] = this.assessmentProgram;
        if (Array.isArray(this.assessmentTemplateRows)) {
            data["assessmentTemplateRows"] = [];
            for (let item of this.assessmentTemplateRows)
                data["assessmentTemplateRows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAssessmentTemplateUpdate {
    assessmentProgram?: string | undefined;
    assessmentTemplateRows?: AssessmentTemplateRow[] | undefined;
}

export class CapabilityAreas implements ICapabilityAreas {
    optimizedAreas?: number;
    operationalAreas?: number;
    functionalAreas?: number;
    evaluatingAreas?: number;
    areasWithGaps?: number;
    unknown?: number;

    constructor(data?: ICapabilityAreas) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.optimizedAreas = _data["optimizedAreas"];
            this.operationalAreas = _data["operationalAreas"];
            this.functionalAreas = _data["functionalAreas"];
            this.evaluatingAreas = _data["evaluatingAreas"];
            this.areasWithGaps = _data["areasWithGaps"];
            this.unknown = _data["unknown"];
        }
    }

    static fromJS(data: any): CapabilityAreas {
        data = typeof data === 'object' ? data : {};
        let result = new CapabilityAreas();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["optimizedAreas"] = this.optimizedAreas;
        data["operationalAreas"] = this.operationalAreas;
        data["functionalAreas"] = this.functionalAreas;
        data["evaluatingAreas"] = this.evaluatingAreas;
        data["areasWithGaps"] = this.areasWithGaps;
        data["unknown"] = this.unknown;
        return data;
    }
}

export interface ICapabilityAreas {
    optimizedAreas?: number;
    operationalAreas?: number;
    functionalAreas?: number;
    evaluatingAreas?: number;
    areasWithGaps?: number;
    unknown?: number;
}

export class CapabilityInsightsProduct implements ICapabilityInsightsProduct {
    productName?: string | undefined;
    productId?: string | undefined;
    productLogo?: string | undefined;
    featureScoresList?: FeatureScores[] | undefined;

    constructor(data?: ICapabilityInsightsProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productName = _data["productName"];
            this.productId = _data["productId"];
            this.productLogo = _data["productLogo"];
            if (Array.isArray(_data["featureScoresList"])) {
                this.featureScoresList = [] as any;
                for (let item of _data["featureScoresList"])
                    this.featureScoresList!.push(FeatureScores.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CapabilityInsightsProduct {
        data = typeof data === 'object' ? data : {};
        let result = new CapabilityInsightsProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productName"] = this.productName;
        data["productId"] = this.productId;
        data["productLogo"] = this.productLogo;
        if (Array.isArray(this.featureScoresList)) {
            data["featureScoresList"] = [];
            for (let item of this.featureScoresList)
                data["featureScoresList"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICapabilityInsightsProduct {
    productName?: string | undefined;
    productId?: string | undefined;
    productLogo?: string | undefined;
    featureScoresList?: FeatureScores[] | undefined;
}

export class CapabilityWithCategories implements ICapabilityWithCategories {
    name?: string | undefined;
    shortName?: string | undefined;
    maturity?: string | undefined;
    products?: CapabilityInsightsProduct[] | undefined;
    harveyBallCategories?: string[] | undefined;
    knownProductIds?: string[] | undefined;
    hasHarveyBall?: boolean | undefined;

    constructor(data?: ICapabilityWithCategories) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.maturity = _data["maturity"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(CapabilityInsightsProduct.fromJS(item));
            }
            if (Array.isArray(_data["harveyBallCategories"])) {
                this.harveyBallCategories = [] as any;
                for (let item of _data["harveyBallCategories"])
                    this.harveyBallCategories!.push(item);
            }
            if (Array.isArray(_data["knownProductIds"])) {
                this.knownProductIds = [] as any;
                for (let item of _data["knownProductIds"])
                    this.knownProductIds!.push(item);
            }
            this.hasHarveyBall = _data["hasHarveyBall"];
        }
    }

    static fromJS(data: any): CapabilityWithCategories {
        data = typeof data === 'object' ? data : {};
        let result = new CapabilityWithCategories();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["maturity"] = this.maturity;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        if (Array.isArray(this.harveyBallCategories)) {
            data["harveyBallCategories"] = [];
            for (let item of this.harveyBallCategories)
                data["harveyBallCategories"].push(item);
        }
        if (Array.isArray(this.knownProductIds)) {
            data["knownProductIds"] = [];
            for (let item of this.knownProductIds)
                data["knownProductIds"].push(item);
        }
        data["hasHarveyBall"] = this.hasHarveyBall;
        return data;
    }
}

export interface ICapabilityWithCategories {
    name?: string | undefined;
    shortName?: string | undefined;
    maturity?: string | undefined;
    products?: CapabilityInsightsProduct[] | undefined;
    harveyBallCategories?: string[] | undefined;
    knownProductIds?: string[] | undefined;
    hasHarveyBall?: boolean | undefined;
}

export class AssessmentDto implements IAssessmentDto {
    id?: string | undefined;
    program?: string | undefined;
    name?: string | undefined;
    assessorEmail?: string | undefined;
    assessor?: ShiEmployeeDto;
    assessmentDate?: Date | undefined;
    createdDate?: Date | undefined;
    lastModifiedBy?: string | undefined;
    maturity?: number;

    constructor(data?: IAssessmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.program = _data["program"];
            this.name = _data["name"];
            this.assessorEmail = _data["assessorEmail"];
            this.assessor = _data["assessor"] ? ShiEmployeeDto.fromJS(_data["assessor"]) : <any>undefined;
            this.assessmentDate = _data["assessmentDate"] ? new Date(_data["assessmentDate"].toString()) : <any>undefined;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.maturity = _data["maturity"];
        }
    }

    static fromJS(data: any): AssessmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["program"] = this.program;
        data["name"] = this.name;
        data["assessorEmail"] = this.assessorEmail;
        data["assessor"] = this.assessor ? this.assessor.toJSON() : <any>undefined;
        data["assessmentDate"] = this.assessmentDate ? this.assessmentDate.toISOString() : <any>undefined;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["maturity"] = this.maturity;
        return data;
    }
}

export interface IAssessmentDto {
    id?: string | undefined;
    program?: string | undefined;
    name?: string | undefined;
    assessorEmail?: string | undefined;
    assessor?: ShiEmployeeDto;
    assessmentDate?: Date | undefined;
    createdDate?: Date | undefined;
    lastModifiedBy?: string | undefined;
    maturity?: number;
}

export class AssessmentMaturityChartDto implements IAssessmentMaturityChartDto {
    responseCategories?: ResponseCategory[] | undefined;

    constructor(data?: IAssessmentMaturityChartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["responseCategories"])) {
                this.responseCategories = [] as any;
                for (let item of _data["responseCategories"])
                    this.responseCategories!.push(ResponseCategory.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssessmentMaturityChartDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentMaturityChartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.responseCategories)) {
            data["responseCategories"] = [];
            for (let item of this.responseCategories)
                data["responseCategories"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAssessmentMaturityChartDto {
    responseCategories?: ResponseCategory[] | undefined;
}

export class AssessmentOverviewDto implements IAssessmentOverviewDto {
    program?: AssessmentProgram;
    targetMaturityBreakdown?: TargetMaturityBreakdown[] | undefined;
    summary?: AssessmentSummary;

    constructor(data?: IAssessmentOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.program = _data["program"];
            if (Array.isArray(_data["targetMaturityBreakdown"])) {
                this.targetMaturityBreakdown = [] as any;
                for (let item of _data["targetMaturityBreakdown"])
                    this.targetMaturityBreakdown!.push(TargetMaturityBreakdown.fromJS(item));
            }
            this.summary = _data["summary"] ? AssessmentSummary.fromJS(_data["summary"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AssessmentOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["program"] = this.program;
        if (Array.isArray(this.targetMaturityBreakdown)) {
            data["targetMaturityBreakdown"] = [];
            for (let item of this.targetMaturityBreakdown)
                data["targetMaturityBreakdown"].push(item.toJSON());
        }
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAssessmentOverviewDto {
    program?: AssessmentProgram;
    targetMaturityBreakdown?: TargetMaturityBreakdown[] | undefined;
    summary?: AssessmentSummary;
}

export class AssessmentRecommendationsDto implements IAssessmentRecommendationsDto {
    prioritizedRecommendations?: PrioritizedRecommendation[] | undefined;

    constructor(data?: IAssessmentRecommendationsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["prioritizedRecommendations"])) {
                this.prioritizedRecommendations = [] as any;
                for (let item of _data["prioritizedRecommendations"])
                    this.prioritizedRecommendations!.push(PrioritizedRecommendation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssessmentRecommendationsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentRecommendationsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.prioritizedRecommendations)) {
            data["prioritizedRecommendations"] = [];
            for (let item of this.prioritizedRecommendations)
                data["prioritizedRecommendations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAssessmentRecommendationsDto {
    prioritizedRecommendations?: PrioritizedRecommendation[] | undefined;
}

export class CapabilityChangesDto implements ICapabilityChangesDto {
    assessmentId?: string | undefined;
    capabilityChangesScoresList?: any[] | undefined;
    date?: Date;

    constructor(data?: ICapabilityChangesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assessmentId = _data["assessmentId"];
            if (Array.isArray(_data["capabilityChangesScoresList"])) {
                this.capabilityChangesScoresList = [] as any;
                for (let item of _data["capabilityChangesScoresList"])
                    this.capabilityChangesScoresList!.push(item);
            }
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CapabilityChangesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CapabilityChangesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assessmentId"] = this.assessmentId;
        if (Array.isArray(this.capabilityChangesScoresList)) {
            data["capabilityChangesScoresList"] = [];
            for (let item of this.capabilityChangesScoresList)
                data["capabilityChangesScoresList"].push(item);
        }
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICapabilityChangesDto {
    assessmentId?: string | undefined;
    capabilityChangesScoresList?: any[] | undefined;
    date?: Date;
}

export class CapabilityInsightsDto implements ICapabilityInsightsDto {
    capabilityWithCategoriesList?: CapabilityWithCategories[] | undefined;

    constructor(data?: ICapabilityInsightsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["capabilityWithCategoriesList"])) {
                this.capabilityWithCategoriesList = [] as any;
                for (let item of _data["capabilityWithCategoriesList"])
                    this.capabilityWithCategoriesList!.push(CapabilityWithCategories.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CapabilityInsightsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CapabilityInsightsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.capabilityWithCategoriesList)) {
            data["capabilityWithCategoriesList"] = [];
            for (let item of this.capabilityWithCategoriesList)
                data["capabilityWithCategoriesList"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICapabilityInsightsDto {
    capabilityWithCategoriesList?: CapabilityWithCategories[] | undefined;
}

export class DeleteAssessmentDto implements IDeleteAssessmentDto {
    airtableId?: string | undefined;
    axNumber?: string | undefined;

    constructor(data?: IDeleteAssessmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.airtableId = _data["airtableId"];
            this.axNumber = _data["axNumber"];
        }
    }

    static fromJS(data: any): DeleteAssessmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteAssessmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["airtableId"] = this.airtableId;
        data["axNumber"] = this.axNumber;
        return data;
    }
}

export interface IDeleteAssessmentDto {
    airtableId?: string | undefined;
    axNumber?: string | undefined;
}

export class HarveyBallDto implements IHarveyBallDto {
    harveyBallScoresCollection?: HarveyBallScores[] | undefined;
    harveyBallRowsCollection?: HarveyBallRows[] | undefined;
    harveyBallProductsCollection?: HarveyBallProducts[] | undefined;

    constructor(data?: IHarveyBallDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["harveyBallScoresCollection"])) {
                this.harveyBallScoresCollection = [] as any;
                for (let item of _data["harveyBallScoresCollection"])
                    this.harveyBallScoresCollection!.push(HarveyBallScores.fromJS(item));
            }
            if (Array.isArray(_data["harveyBallRowsCollection"])) {
                this.harveyBallRowsCollection = [] as any;
                for (let item of _data["harveyBallRowsCollection"])
                    this.harveyBallRowsCollection!.push(HarveyBallRows.fromJS(item));
            }
            if (Array.isArray(_data["harveyBallProductsCollection"])) {
                this.harveyBallProductsCollection = [] as any;
                for (let item of _data["harveyBallProductsCollection"])
                    this.harveyBallProductsCollection!.push(HarveyBallProducts.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HarveyBallDto {
        data = typeof data === 'object' ? data : {};
        let result = new HarveyBallDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.harveyBallScoresCollection)) {
            data["harveyBallScoresCollection"] = [];
            for (let item of this.harveyBallScoresCollection)
                data["harveyBallScoresCollection"].push(item.toJSON());
        }
        if (Array.isArray(this.harveyBallRowsCollection)) {
            data["harveyBallRowsCollection"] = [];
            for (let item of this.harveyBallRowsCollection)
                data["harveyBallRowsCollection"].push(item.toJSON());
        }
        if (Array.isArray(this.harveyBallProductsCollection)) {
            data["harveyBallProductsCollection"] = [];
            for (let item of this.harveyBallProductsCollection)
                data["harveyBallProductsCollection"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHarveyBallDto {
    harveyBallScoresCollection?: HarveyBallScores[] | undefined;
    harveyBallRowsCollection?: HarveyBallRows[] | undefined;
    harveyBallProductsCollection?: HarveyBallProducts[] | undefined;
}

export class HarveyBallProducts implements IHarveyBallProducts {
    productName?: string | undefined;
    productId?: string | undefined;
    productLogo?: string | undefined;

    constructor(data?: IHarveyBallProducts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productName = _data["productName"];
            this.productId = _data["productId"];
            this.productLogo = _data["productLogo"];
        }
    }

    static fromJS(data: any): HarveyBallProducts {
        data = typeof data === 'object' ? data : {};
        let result = new HarveyBallProducts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productName"] = this.productName;
        data["productId"] = this.productId;
        data["productLogo"] = this.productLogo;
        return data;
    }
}

export interface IHarveyBallProducts {
    productName?: string | undefined;
    productId?: string | undefined;
    productLogo?: string | undefined;
}

export class HarveyBallRows implements IHarveyBallRows {
    sectionName?: string | undefined;
    harveyBallCategory?: string | undefined;
    relatedFeaturesCollection?: RelatedFeatures[] | undefined;

    constructor(data?: IHarveyBallRows) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sectionName = _data["sectionName"];
            this.harveyBallCategory = _data["harveyBallCategory"];
            if (Array.isArray(_data["relatedFeaturesCollection"])) {
                this.relatedFeaturesCollection = [] as any;
                for (let item of _data["relatedFeaturesCollection"])
                    this.relatedFeaturesCollection!.push(RelatedFeatures.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HarveyBallRows {
        data = typeof data === 'object' ? data : {};
        let result = new HarveyBallRows();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sectionName"] = this.sectionName;
        data["harveyBallCategory"] = this.harveyBallCategory;
        if (Array.isArray(this.relatedFeaturesCollection)) {
            data["relatedFeaturesCollection"] = [];
            for (let item of this.relatedFeaturesCollection)
                data["relatedFeaturesCollection"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHarveyBallRows {
    sectionName?: string | undefined;
    harveyBallCategory?: string | undefined;
    relatedFeaturesCollection?: RelatedFeatures[] | undefined;
}

export class HarveyBallScores implements IHarveyBallScores {
    productId?: string | undefined;
    score?: number;
    featureName?: string | undefined;

    constructor(data?: IHarveyBallScores) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.score = _data["score"];
            this.featureName = _data["featureName"];
        }
    }

    static fromJS(data: any): HarveyBallScores {
        data = typeof data === 'object' ? data : {};
        let result = new HarveyBallScores();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["score"] = this.score;
        data["featureName"] = this.featureName;
        return data;
    }
}

export interface IHarveyBallScores {
    productId?: string | undefined;
    score?: number;
    featureName?: string | undefined;
}

export class MaturityComparisonData implements IMaturityComparisonData {
    date?: Date;
    maturityData?: MaturityComparison[] | undefined;

    constructor(data?: IMaturityComparisonData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            if (Array.isArray(_data["maturityData"])) {
                this.maturityData = [] as any;
                for (let item of _data["maturityData"])
                    this.maturityData!.push(MaturityComparison.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MaturityComparisonData {
        data = typeof data === 'object' ? data : {};
        let result = new MaturityComparisonData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        if (Array.isArray(this.maturityData)) {
            data["maturityData"] = [];
            for (let item of this.maturityData)
                data["maturityData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMaturityComparisonData {
    date?: Date;
    maturityData?: MaturityComparison[] | undefined;
}

export class MaturityComparisonDto implements IMaturityComparisonDto {
    current?: MaturityComparisonData;
    previous?: MaturityComparisonData;
    first?: MaturityComparisonData;

    constructor(data?: IMaturityComparisonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.current = _data["current"] ? MaturityComparisonData.fromJS(_data["current"]) : <any>undefined;
            this.previous = _data["previous"] ? MaturityComparisonData.fromJS(_data["previous"]) : <any>undefined;
            this.first = _data["first"] ? MaturityComparisonData.fromJS(_data["first"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MaturityComparisonDto {
        data = typeof data === 'object' ? data : {};
        let result = new MaturityComparisonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current ? this.current.toJSON() : <any>undefined;
        data["previous"] = this.previous ? this.previous.toJSON() : <any>undefined;
        data["first"] = this.first ? this.first.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMaturityComparisonDto {
    current?: MaturityComparisonData;
    previous?: MaturityComparisonData;
    first?: MaturityComparisonData;
}

export class PlatformInsightsDto implements IPlatformInsightsDto {
    products?: PlatformInsightProduct[] | undefined;

    constructor(data?: IPlatformInsightsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(PlatformInsightProduct.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlatformInsightsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlatformInsightsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPlatformInsightsDto {
    products?: PlatformInsightProduct[] | undefined;
}

export class RelatedFeatures implements IRelatedFeatures {
    featureName?: string | undefined;

    constructor(data?: IRelatedFeatures) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.featureName = _data["featureName"];
        }
    }

    static fromJS(data: any): RelatedFeatures {
        data = typeof data === 'object' ? data : {};
        let result = new RelatedFeatures();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["featureName"] = this.featureName;
        return data;
    }
}

export interface IRelatedFeatures {
    featureName?: string | undefined;
}

export class FeatureScores implements IFeatureScores {
    averageFeatureScore?: number;
    harveyBallCategory?: string | undefined;

    constructor(data?: IFeatureScores) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.averageFeatureScore = _data["averageFeatureScore"];
            this.harveyBallCategory = _data["harveyBallCategory"];
        }
    }

    static fromJS(data: any): FeatureScores {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureScores();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["averageFeatureScore"] = this.averageFeatureScore;
        data["harveyBallCategory"] = this.harveyBallCategory;
        return data;
    }
}

export interface IFeatureScores {
    averageFeatureScore?: number;
    harveyBallCategory?: string | undefined;
}

export class GeneratedAssessment implements IGeneratedAssessment {
    generatedResponsesList?: GeneratedAssessment_GeneratedResponses[] | undefined;
    error?: string | undefined;
    filename?: string | undefined;

    constructor(data?: IGeneratedAssessment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["generatedResponsesList"])) {
                this.generatedResponsesList = [] as any;
                for (let item of _data["generatedResponsesList"])
                    this.generatedResponsesList!.push(GeneratedAssessment_GeneratedResponses.fromJS(item));
            }
            this.error = _data["error"];
            this.filename = _data["filename"];
        }
    }

    static fromJS(data: any): GeneratedAssessment {
        data = typeof data === 'object' ? data : {};
        let result = new GeneratedAssessment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.generatedResponsesList)) {
            data["generatedResponsesList"] = [];
            for (let item of this.generatedResponsesList)
                data["generatedResponsesList"].push(item.toJSON());
        }
        data["error"] = this.error;
        data["filename"] = this.filename;
        return data;
    }
}

export interface IGeneratedAssessment {
    generatedResponsesList?: GeneratedAssessment_GeneratedResponses[] | undefined;
    error?: string | undefined;
    filename?: string | undefined;
}

export class GeneratedAssessment_GeneratedResponses implements IGeneratedAssessment_GeneratedResponses {
    name?: string | undefined;
    notes?: string | undefined;
    category?: string | undefined;
    subcategory?: string | undefined;
    recommendations?: string | undefined;
    operationalPriority?: string | undefined;
    compliancePriority?: string | undefined;
    currentMaturity?: string | undefined;
    targetMaturity?: string | undefined;
    tools?: string | undefined;
    capability?: string | undefined;

    constructor(data?: IGeneratedAssessment_GeneratedResponses) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.notes = _data["notes"];
            this.category = _data["category"];
            this.subcategory = _data["subcategory"];
            this.recommendations = _data["recommendations"];
            this.operationalPriority = _data["operationalPriority"];
            this.compliancePriority = _data["compliancePriority"];
            this.currentMaturity = _data["currentMaturity"];
            this.targetMaturity = _data["targetMaturity"];
            this.tools = _data["tools"];
            this.capability = _data["capability"];
        }
    }

    static fromJS(data: any): GeneratedAssessment_GeneratedResponses {
        data = typeof data === 'object' ? data : {};
        let result = new GeneratedAssessment_GeneratedResponses();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["notes"] = this.notes;
        data["category"] = this.category;
        data["subcategory"] = this.subcategory;
        data["recommendations"] = this.recommendations;
        data["operationalPriority"] = this.operationalPriority;
        data["compliancePriority"] = this.compliancePriority;
        data["currentMaturity"] = this.currentMaturity;
        data["targetMaturity"] = this.targetMaturity;
        data["tools"] = this.tools;
        data["capability"] = this.capability;
        return data;
    }
}

export interface IGeneratedAssessment_GeneratedResponses {
    name?: string | undefined;
    notes?: string | undefined;
    category?: string | undefined;
    subcategory?: string | undefined;
    recommendations?: string | undefined;
    operationalPriority?: string | undefined;
    compliancePriority?: string | undefined;
    currentMaturity?: string | undefined;
    targetMaturity?: string | undefined;
    tools?: string | undefined;
    capability?: string | undefined;
}

export class HarveyBallsUpdate implements IHarveyBallsUpdate {
    harveyBallName?: string | undefined;
    harveyBallId?: string | undefined;
    harveyBallProgram?: string | undefined;
    harveyBallCategory?: string | undefined;
    harveyBallCategoryId?: string | undefined;
    harveyBallCategorySection?: string | undefined;
    feature?: string | undefined;
    featureId?: string | undefined;
    featureScoreId?: string | undefined;
    productName?: string | undefined;
    productId?: string | undefined;
    partnerId?: string | undefined;
    partnerName?: string | undefined;
    platformId?: string | undefined;
    platformName?: string | undefined;
    productScore?: string | undefined;
    harveyBallCapability?: string | undefined;
    harveyBallCapabilityId?: string | undefined;
    productLogo?: string | undefined;

    constructor(data?: IHarveyBallsUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.harveyBallName = _data["harveyBallName"];
            this.harveyBallId = _data["harveyBallId"];
            this.harveyBallProgram = _data["harveyBallProgram"];
            this.harveyBallCategory = _data["harveyBallCategory"];
            this.harveyBallCategoryId = _data["harveyBallCategoryId"];
            this.harveyBallCategorySection = _data["harveyBallCategorySection"];
            this.feature = _data["feature"];
            this.featureId = _data["featureId"];
            this.featureScoreId = _data["featureScoreId"];
            this.productName = _data["productName"];
            this.productId = _data["productId"];
            this.partnerId = _data["partnerId"];
            this.partnerName = _data["partnerName"];
            this.platformId = _data["platformId"];
            this.platformName = _data["platformName"];
            this.productScore = _data["productScore"];
            this.harveyBallCapability = _data["harveyBallCapability"];
            this.harveyBallCapabilityId = _data["harveyBallCapabilityId"];
            this.productLogo = _data["productLogo"];
        }
    }

    static fromJS(data: any): HarveyBallsUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new HarveyBallsUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["harveyBallName"] = this.harveyBallName;
        data["harveyBallId"] = this.harveyBallId;
        data["harveyBallProgram"] = this.harveyBallProgram;
        data["harveyBallCategory"] = this.harveyBallCategory;
        data["harveyBallCategoryId"] = this.harveyBallCategoryId;
        data["harveyBallCategorySection"] = this.harveyBallCategorySection;
        data["feature"] = this.feature;
        data["featureId"] = this.featureId;
        data["featureScoreId"] = this.featureScoreId;
        data["productName"] = this.productName;
        data["productId"] = this.productId;
        data["partnerId"] = this.partnerId;
        data["partnerName"] = this.partnerName;
        data["platformId"] = this.platformId;
        data["platformName"] = this.platformName;
        data["productScore"] = this.productScore;
        data["harveyBallCapability"] = this.harveyBallCapability;
        data["harveyBallCapabilityId"] = this.harveyBallCapabilityId;
        data["productLogo"] = this.productLogo;
        return data;
    }
}

export interface IHarveyBallsUpdate {
    harveyBallName?: string | undefined;
    harveyBallId?: string | undefined;
    harveyBallProgram?: string | undefined;
    harveyBallCategory?: string | undefined;
    harveyBallCategoryId?: string | undefined;
    harveyBallCategorySection?: string | undefined;
    feature?: string | undefined;
    featureId?: string | undefined;
    featureScoreId?: string | undefined;
    productName?: string | undefined;
    productId?: string | undefined;
    partnerId?: string | undefined;
    partnerName?: string | undefined;
    platformId?: string | undefined;
    platformName?: string | undefined;
    productScore?: string | undefined;
    harveyBallCapability?: string | undefined;
    harveyBallCapabilityId?: string | undefined;
    productLogo?: string | undefined;
}

export class MaturityComparison implements IMaturityComparison {
    subCategory?: string | undefined;
    currentMaturity?: number;

    constructor(data?: IMaturityComparison) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subCategory = _data["subCategory"];
            this.currentMaturity = _data["currentMaturity"];
        }
    }

    static fromJS(data: any): MaturityComparison {
        data = typeof data === 'object' ? data : {};
        let result = new MaturityComparison();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subCategory"] = this.subCategory;
        data["currentMaturity"] = this.currentMaturity;
        return data;
    }
}

export interface IMaturityComparison {
    subCategory?: string | undefined;
    currentMaturity?: number;
}

export class PlatformInsightCapability implements IPlatformInsightCapability {
    capabilityId?: string | undefined;
    capabilityName?: string | undefined;
    shortName?: string | undefined;
    currentMaturity?: string | undefined;
    hasHarveyBallData?: boolean;
    currentlyUsingProductNames?: string[] | undefined;
    alsoUsingProductNames?: string[] | undefined;

    constructor(data?: IPlatformInsightCapability) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.capabilityId = _data["capabilityId"];
            this.capabilityName = _data["capabilityName"];
            this.shortName = _data["shortName"];
            this.currentMaturity = _data["currentMaturity"];
            this.hasHarveyBallData = _data["hasHarveyBallData"];
            if (Array.isArray(_data["currentlyUsingProductNames"])) {
                this.currentlyUsingProductNames = [] as any;
                for (let item of _data["currentlyUsingProductNames"])
                    this.currentlyUsingProductNames!.push(item);
            }
            if (Array.isArray(_data["alsoUsingProductNames"])) {
                this.alsoUsingProductNames = [] as any;
                for (let item of _data["alsoUsingProductNames"])
                    this.alsoUsingProductNames!.push(item);
            }
        }
    }

    static fromJS(data: any): PlatformInsightCapability {
        data = typeof data === 'object' ? data : {};
        let result = new PlatformInsightCapability();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["capabilityId"] = this.capabilityId;
        data["capabilityName"] = this.capabilityName;
        data["shortName"] = this.shortName;
        data["currentMaturity"] = this.currentMaturity;
        data["hasHarveyBallData"] = this.hasHarveyBallData;
        if (Array.isArray(this.currentlyUsingProductNames)) {
            data["currentlyUsingProductNames"] = [];
            for (let item of this.currentlyUsingProductNames)
                data["currentlyUsingProductNames"].push(item);
        }
        if (Array.isArray(this.alsoUsingProductNames)) {
            data["alsoUsingProductNames"] = [];
            for (let item of this.alsoUsingProductNames)
                data["alsoUsingProductNames"].push(item);
        }
        return data;
    }
}

export interface IPlatformInsightCapability {
    capabilityId?: string | undefined;
    capabilityName?: string | undefined;
    shortName?: string | undefined;
    currentMaturity?: string | undefined;
    hasHarveyBallData?: boolean;
    currentlyUsingProductNames?: string[] | undefined;
    alsoUsingProductNames?: string[] | undefined;
}

export class PlatformInsightProduct implements IPlatformInsightProduct {
    partnerId?: string | undefined;
    partnerName?: string | undefined;
    productId?: string | undefined;
    productName?: string | undefined;
    platformId?: string | undefined;
    platformName?: string | undefined;
    isKnownProduct?: boolean;
    logo?: string | undefined;
    capabilities?: PlatformInsightCapability[] | undefined;

    constructor(data?: IPlatformInsightProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data["partnerId"];
            this.partnerName = _data["partnerName"];
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.platformId = _data["platformId"];
            this.platformName = _data["platformName"];
            this.isKnownProduct = _data["isKnownProduct"];
            this.logo = _data["logo"];
            if (Array.isArray(_data["capabilities"])) {
                this.capabilities = [] as any;
                for (let item of _data["capabilities"])
                    this.capabilities!.push(PlatformInsightCapability.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlatformInsightProduct {
        data = typeof data === 'object' ? data : {};
        let result = new PlatformInsightProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerId"] = this.partnerId;
        data["partnerName"] = this.partnerName;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["platformId"] = this.platformId;
        data["platformName"] = this.platformName;
        data["isKnownProduct"] = this.isKnownProduct;
        data["logo"] = this.logo;
        if (Array.isArray(this.capabilities)) {
            data["capabilities"] = [];
            for (let item of this.capabilities)
                data["capabilities"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPlatformInsightProduct {
    partnerId?: string | undefined;
    partnerName?: string | undefined;
    productId?: string | undefined;
    productName?: string | undefined;
    platformId?: string | undefined;
    platformName?: string | undefined;
    isKnownProduct?: boolean;
    logo?: string | undefined;
    capabilities?: PlatformInsightCapability[] | undefined;
}

export class PlatformsUpdate implements IPlatformsUpdate {
    platformId?: string | undefined;
    platformName?: string | undefined;
    platformProgram?: string | undefined;
    productId?: string | undefined;
    productName?: string | undefined;
    partnerId?: string | undefined;
    partnerName?: string | undefined;
    productLogo?: string | undefined;
    capabilities?: string | undefined;

    constructor(data?: IPlatformsUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.platformId = _data["platformId"];
            this.platformName = _data["platformName"];
            this.platformProgram = _data["platformProgram"];
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.partnerId = _data["partnerId"];
            this.partnerName = _data["partnerName"];
            this.productLogo = _data["productLogo"];
            this.capabilities = _data["capabilities"];
        }
    }

    static fromJS(data: any): PlatformsUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new PlatformsUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["platformId"] = this.platformId;
        data["platformName"] = this.platformName;
        data["platformProgram"] = this.platformProgram;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["partnerId"] = this.partnerId;
        data["partnerName"] = this.partnerName;
        data["productLogo"] = this.productLogo;
        data["capabilities"] = this.capabilities;
        return data;
    }
}

export interface IPlatformsUpdate {
    platformId?: string | undefined;
    platformName?: string | undefined;
    platformProgram?: string | undefined;
    productId?: string | undefined;
    productName?: string | undefined;
    partnerId?: string | undefined;
    partnerName?: string | undefined;
    productLogo?: string | undefined;
    capabilities?: string | undefined;
}

export class PrioritizedRecommendation implements IPrioritizedRecommendation {
    priority?: string | undefined;
    responseRecommendations?: ResponseRecommendation[] | undefined;

    constructor(data?: IPrioritizedRecommendation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.priority = _data["priority"];
            if (Array.isArray(_data["responseRecommendations"])) {
                this.responseRecommendations = [] as any;
                for (let item of _data["responseRecommendations"])
                    this.responseRecommendations!.push(ResponseRecommendation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PrioritizedRecommendation {
        data = typeof data === 'object' ? data : {};
        let result = new PrioritizedRecommendation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["priority"] = this.priority;
        if (Array.isArray(this.responseRecommendations)) {
            data["responseRecommendations"] = [];
            for (let item of this.responseRecommendations)
                data["responseRecommendations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPrioritizedRecommendation {
    priority?: string | undefined;
    responseRecommendations?: ResponseRecommendation[] | undefined;
}

export class ResponseCapability implements IResponseCapability {
    order?: number;
    name?: string | undefined;
    maturity?: string | undefined;
    tools?: string[] | undefined;
    hasRecommendation?: boolean;

    constructor(data?: IResponseCapability) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
            this.name = _data["name"];
            this.maturity = _data["maturity"];
            if (Array.isArray(_data["tools"])) {
                this.tools = [] as any;
                for (let item of _data["tools"])
                    this.tools!.push(item);
            }
            this.hasRecommendation = _data["hasRecommendation"];
        }
    }

    static fromJS(data: any): ResponseCapability {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseCapability();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["name"] = this.name;
        data["maturity"] = this.maturity;
        if (Array.isArray(this.tools)) {
            data["tools"] = [];
            for (let item of this.tools)
                data["tools"].push(item);
        }
        data["hasRecommendation"] = this.hasRecommendation;
        return data;
    }
}

export interface IResponseCapability {
    order?: number;
    name?: string | undefined;
    maturity?: string | undefined;
    tools?: string[] | undefined;
    hasRecommendation?: boolean;
}

export class ResponseCategory implements IResponseCategory {
    order?: number;
    name?: string | undefined;
    responseSubcategories?: ResponseSubcategory[] | undefined;

    constructor(data?: IResponseCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
            this.name = _data["name"];
            if (Array.isArray(_data["responseSubcategories"])) {
                this.responseSubcategories = [] as any;
                for (let item of _data["responseSubcategories"])
                    this.responseSubcategories!.push(ResponseSubcategory.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseCategory {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["name"] = this.name;
        if (Array.isArray(this.responseSubcategories)) {
            data["responseSubcategories"] = [];
            for (let item of this.responseSubcategories)
                data["responseSubcategories"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseCategory {
    order?: number;
    name?: string | undefined;
    responseSubcategories?: ResponseSubcategory[] | undefined;
}

export class ResponseRecommendation implements IResponseRecommendation {
    recommendationId?: string | undefined;
    assessmentId?: string | undefined;
    impact?: string | undefined;
    capability?: string | undefined;
    capabilityId?: string | undefined;
    category?: string | undefined;
    subcategory?: string | undefined;
    recommendationsSummary?: string | undefined;
    recommendations?: string | undefined;
    knownTools?: string[] | undefined;
    otherTools?: string[] | undefined;
    knownToolsLogos?: string[] | undefined;
    otherToolsLogos?: string[] | undefined;
    hasHarveyBallData?: boolean;
    isLinkedToRoadmap?: boolean;

    constructor(data?: IResponseRecommendation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recommendationId = _data["recommendationId"];
            this.assessmentId = _data["assessmentId"];
            this.impact = _data["impact"];
            this.capability = _data["capability"];
            this.capabilityId = _data["capabilityId"];
            this.category = _data["category"];
            this.subcategory = _data["subcategory"];
            this.recommendationsSummary = _data["recommendationsSummary"];
            this.recommendations = _data["recommendations"];
            if (Array.isArray(_data["knownTools"])) {
                this.knownTools = [] as any;
                for (let item of _data["knownTools"])
                    this.knownTools!.push(item);
            }
            if (Array.isArray(_data["otherTools"])) {
                this.otherTools = [] as any;
                for (let item of _data["otherTools"])
                    this.otherTools!.push(item);
            }
            if (Array.isArray(_data["knownToolsLogos"])) {
                this.knownToolsLogos = [] as any;
                for (let item of _data["knownToolsLogos"])
                    this.knownToolsLogos!.push(item);
            }
            if (Array.isArray(_data["otherToolsLogos"])) {
                this.otherToolsLogos = [] as any;
                for (let item of _data["otherToolsLogos"])
                    this.otherToolsLogos!.push(item);
            }
            this.hasHarveyBallData = _data["hasHarveyBallData"];
            this.isLinkedToRoadmap = _data["isLinkedToRoadmap"];
        }
    }

    static fromJS(data: any): ResponseRecommendation {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseRecommendation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recommendationId"] = this.recommendationId;
        data["assessmentId"] = this.assessmentId;
        data["impact"] = this.impact;
        data["capability"] = this.capability;
        data["capabilityId"] = this.capabilityId;
        data["category"] = this.category;
        data["subcategory"] = this.subcategory;
        data["recommendationsSummary"] = this.recommendationsSummary;
        data["recommendations"] = this.recommendations;
        if (Array.isArray(this.knownTools)) {
            data["knownTools"] = [];
            for (let item of this.knownTools)
                data["knownTools"].push(item);
        }
        if (Array.isArray(this.otherTools)) {
            data["otherTools"] = [];
            for (let item of this.otherTools)
                data["otherTools"].push(item);
        }
        if (Array.isArray(this.knownToolsLogos)) {
            data["knownToolsLogos"] = [];
            for (let item of this.knownToolsLogos)
                data["knownToolsLogos"].push(item);
        }
        if (Array.isArray(this.otherToolsLogos)) {
            data["otherToolsLogos"] = [];
            for (let item of this.otherToolsLogos)
                data["otherToolsLogos"].push(item);
        }
        data["hasHarveyBallData"] = this.hasHarveyBallData;
        data["isLinkedToRoadmap"] = this.isLinkedToRoadmap;
        return data;
    }
}

export interface IResponseRecommendation {
    recommendationId?: string | undefined;
    assessmentId?: string | undefined;
    impact?: string | undefined;
    capability?: string | undefined;
    capabilityId?: string | undefined;
    category?: string | undefined;
    subcategory?: string | undefined;
    recommendationsSummary?: string | undefined;
    recommendations?: string | undefined;
    knownTools?: string[] | undefined;
    otherTools?: string[] | undefined;
    knownToolsLogos?: string[] | undefined;
    otherToolsLogos?: string[] | undefined;
    hasHarveyBallData?: boolean;
    isLinkedToRoadmap?: boolean;
}

export class ResponseSubcategory implements IResponseSubcategory {
    name?: string | undefined;
    responseCapabilities?: ResponseCapability[] | undefined;

    constructor(data?: IResponseSubcategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["responseCapabilities"])) {
                this.responseCapabilities = [] as any;
                for (let item of _data["responseCapabilities"])
                    this.responseCapabilities!.push(ResponseCapability.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseSubcategory {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseSubcategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.responseCapabilities)) {
            data["responseCapabilities"] = [];
            for (let item of this.responseCapabilities)
                data["responseCapabilities"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseSubcategory {
    name?: string | undefined;
    responseCapabilities?: ResponseCapability[] | undefined;
}

export class TargetMaturityBreakdown implements ITargetMaturityBreakdown {
    subCategory?: string | undefined;
    currentMaturity?: number;
    targetMaturity?: number;

    constructor(data?: ITargetMaturityBreakdown) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subCategory = _data["subCategory"];
            this.currentMaturity = _data["currentMaturity"];
            this.targetMaturity = _data["targetMaturity"];
        }
    }

    static fromJS(data: any): TargetMaturityBreakdown {
        data = typeof data === 'object' ? data : {};
        let result = new TargetMaturityBreakdown();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subCategory"] = this.subCategory;
        data["currentMaturity"] = this.currentMaturity;
        data["targetMaturity"] = this.targetMaturity;
        return data;
    }
}

export interface ITargetMaturityBreakdown {
    subCategory?: string | undefined;
    currentMaturity?: number;
    targetMaturity?: number;
}

export class UpdateAssessmentIntegration implements IUpdateAssessmentIntegration {
    airtableAssessmentLink?: string | undefined;
    axAccountNumber?: string | undefined;
    crmGuid?: string | undefined;
    assessmentProgram?: string | undefined;
    status?: string | undefined;
    airtableId?: string | undefined;
    assessmentGuid?: string | undefined;

    constructor(data?: IUpdateAssessmentIntegration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.airtableAssessmentLink = _data["airtableAssessmentLink"];
            this.axAccountNumber = _data["axAccountNumber"];
            this.crmGuid = _data["crmGuid"];
            this.assessmentProgram = _data["assessmentProgram"];
            this.status = _data["status"];
            this.airtableId = _data["airtableId"];
            this.assessmentGuid = _data["assessmentGuid"];
        }
    }

    static fromJS(data: any): UpdateAssessmentIntegration {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAssessmentIntegration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["airtableAssessmentLink"] = this.airtableAssessmentLink;
        data["axAccountNumber"] = this.axAccountNumber;
        data["crmGuid"] = this.crmGuid;
        data["assessmentProgram"] = this.assessmentProgram;
        data["status"] = this.status;
        data["airtableId"] = this.airtableId;
        data["assessmentGuid"] = this.assessmentGuid;
        return data;
    }
}

export interface IUpdateAssessmentIntegration {
    airtableAssessmentLink?: string | undefined;
    axAccountNumber?: string | undefined;
    crmGuid?: string | undefined;
    assessmentProgram?: string | undefined;
    status?: string | undefined;
    airtableId?: string | undefined;
    assessmentGuid?: string | undefined;
}

export class AssetByCategory implements IAssetByCategory {
    category?: string | undefined;
    assetsUseStates?: AssetByUseState[] | undefined;

    constructor(data?: IAssetByCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            if (Array.isArray(_data["assetsUseStates"])) {
                this.assetsUseStates = [] as any;
                for (let item of _data["assetsUseStates"])
                    this.assetsUseStates!.push(AssetByUseState.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssetByCategory {
        data = typeof data === 'object' ? data : {};
        let result = new AssetByCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        if (Array.isArray(this.assetsUseStates)) {
            data["assetsUseStates"] = [];
            for (let item of this.assetsUseStates)
                data["assetsUseStates"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAssetByCategory {
    category?: string | undefined;
    assetsUseStates?: AssetByUseState[] | undefined;
}

export class AssetByUseState implements IAssetByUseState {
    useStateType?: string | undefined;
    assetsCount?: number;

    constructor(data?: IAssetByUseState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.useStateType = _data["useStateType"];
            this.assetsCount = _data["assetsCount"];
        }
    }

    static fromJS(data: any): AssetByUseState {
        data = typeof data === 'object' ? data : {};
        let result = new AssetByUseState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["useStateType"] = this.useStateType;
        data["assetsCount"] = this.assetsCount;
        return data;
    }
}

export interface IAssetByUseState {
    useStateType?: string | undefined;
    assetsCount?: number;
}

export class AssetContractsResponse implements IAssetContractsResponse {
    contracts?: AssetContract[] | undefined;
    readonly totalCount?: number;

    constructor(data?: IAssetContractsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["contracts"])) {
                this.contracts = [] as any;
                for (let item of _data["contracts"])
                    this.contracts!.push(AssetContract.fromJS(item));
            }
            (<any>this).totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AssetContractsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AssetContractsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contracts)) {
            data["contracts"] = [];
            for (let item of this.contracts)
                data["contracts"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IAssetContractsResponse {
    contracts?: AssetContract[] | undefined;
    totalCount?: number;
}

export class AssetEndUserDevicesSummary implements IAssetEndUserDevicesSummary {
    rebootStatus?: TitleValue[] | undefined;
    patchStatus?: TitleValue[] | undefined;
    antivirusStatus?: TitleValue[] | undefined;
    count?: number;

    constructor(data?: IAssetEndUserDevicesSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rebootStatus"])) {
                this.rebootStatus = [] as any;
                for (let item of _data["rebootStatus"])
                    this.rebootStatus!.push(TitleValue.fromJS(item));
            }
            if (Array.isArray(_data["patchStatus"])) {
                this.patchStatus = [] as any;
                for (let item of _data["patchStatus"])
                    this.patchStatus!.push(TitleValue.fromJS(item));
            }
            if (Array.isArray(_data["antivirusStatus"])) {
                this.antivirusStatus = [] as any;
                for (let item of _data["antivirusStatus"])
                    this.antivirusStatus!.push(TitleValue.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): AssetEndUserDevicesSummary {
        data = typeof data === 'object' ? data : {};
        let result = new AssetEndUserDevicesSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rebootStatus)) {
            data["rebootStatus"] = [];
            for (let item of this.rebootStatus)
                data["rebootStatus"].push(item.toJSON());
        }
        if (Array.isArray(this.patchStatus)) {
            data["patchStatus"] = [];
            for (let item of this.patchStatus)
                data["patchStatus"].push(item.toJSON());
        }
        if (Array.isArray(this.antivirusStatus)) {
            data["antivirusStatus"] = [];
            for (let item of this.antivirusStatus)
                data["antivirusStatus"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data;
    }
}

export interface IAssetEndUserDevicesSummary {
    rebootStatus?: TitleValue[] | undefined;
    patchStatus?: TitleValue[] | undefined;
    antivirusStatus?: TitleValue[] | undefined;
    count?: number;
}

export class AssetInventorySummary implements IAssetInventorySummary {
    totalRows?: number;
    childrenCounts?: { [key: string]: number; } | undefined;

    constructor(data?: IAssetInventorySummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (_data["childrenCounts"]) {
                this.childrenCounts = {} as any;
                for (let key in _data["childrenCounts"]) {
                    if (_data["childrenCounts"].hasOwnProperty(key))
                        (<any>this.childrenCounts)![key] = _data["childrenCounts"][key];
                }
            }
        }
    }

    static fromJS(data: any): AssetInventorySummary {
        data = typeof data === 'object' ? data : {};
        let result = new AssetInventorySummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (this.childrenCounts) {
            data["childrenCounts"] = {};
            for (let key in this.childrenCounts) {
                if (this.childrenCounts.hasOwnProperty(key))
                    (<any>data["childrenCounts"])[key] = (<any>this.childrenCounts)[key];
            }
        }
        return data;
    }
}

export interface IAssetInventorySummary {
    totalRows?: number;
    childrenCounts?: { [key: string]: number; } | undefined;
}

export class AssetLifecycleManagementWidgetResponseDto implements IAssetLifecycleManagementWidgetResponseDto {
    assetsGoingEndOfLife?: number;
    assetsGoingEndOfSale?: number;
    assetsGoingEndOfSoftwareMaintenance?: number;
    assetsGoingEndOfSupport?: number;

    constructor(data?: IAssetLifecycleManagementWidgetResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetsGoingEndOfLife = _data["assetsGoingEndOfLife"];
            this.assetsGoingEndOfSale = _data["assetsGoingEndOfSale"];
            this.assetsGoingEndOfSoftwareMaintenance = _data["assetsGoingEndOfSoftwareMaintenance"];
            this.assetsGoingEndOfSupport = _data["assetsGoingEndOfSupport"];
        }
    }

    static fromJS(data: any): AssetLifecycleManagementWidgetResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetLifecycleManagementWidgetResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetsGoingEndOfLife"] = this.assetsGoingEndOfLife;
        data["assetsGoingEndOfSale"] = this.assetsGoingEndOfSale;
        data["assetsGoingEndOfSoftwareMaintenance"] = this.assetsGoingEndOfSoftwareMaintenance;
        data["assetsGoingEndOfSupport"] = this.assetsGoingEndOfSupport;
        return data;
    }
}

export interface IAssetLifecycleManagementWidgetResponseDto {
    assetsGoingEndOfLife?: number;
    assetsGoingEndOfSale?: number;
    assetsGoingEndOfSoftwareMaintenance?: number;
    assetsGoingEndOfSupport?: number;
}

export class AssetLifecycleResponseDto implements IAssetLifecycleResponseDto {
    summary?: AssetLifecycleSummaryDto;
    inventory?: Asset[] | undefined;

    constructor(data?: IAssetLifecycleResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.summary = _data["summary"] ? AssetLifecycleSummaryDto.fromJS(_data["summary"]) : <any>undefined;
            if (Array.isArray(_data["inventory"])) {
                this.inventory = [] as any;
                for (let item of _data["inventory"])
                    this.inventory!.push(Asset.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssetLifecycleResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetLifecycleResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        if (Array.isArray(this.inventory)) {
            data["inventory"] = [];
            for (let item of this.inventory)
                data["inventory"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAssetLifecycleResponseDto {
    summary?: AssetLifecycleSummaryDto;
    inventory?: Asset[] | undefined;
}

export class AssetLocationSearchQueryDto implements IAssetLocationSearchQueryDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    excludeSearchFilter?: boolean;
    searchFilter?: AssetLocationsSearchFilterDto;

    constructor(data?: IAssetLocationSearchQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountIdentifier = _data["accountIdentifier"];
            if (Array.isArray(_data["accountReferences"])) {
                this.accountReferences = [] as any;
                for (let item of _data["accountReferences"])
                    this.accountReferences!.push(item);
            }
            this.excludeSearchFilter = _data["excludeSearchFilter"];
            this.searchFilter = _data["searchFilter"] ? AssetLocationsSearchFilterDto.fromJS(_data["searchFilter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AssetLocationSearchQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetLocationSearchQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountIdentifier"] = this.accountIdentifier;
        if (Array.isArray(this.accountReferences)) {
            data["accountReferences"] = [];
            for (let item of this.accountReferences)
                data["accountReferences"].push(item);
        }
        data["excludeSearchFilter"] = this.excludeSearchFilter;
        data["searchFilter"] = this.searchFilter ? this.searchFilter.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAssetLocationSearchQueryDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    excludeSearchFilter?: boolean;
    searchFilter?: AssetLocationsSearchFilterDto;
}

export class AssetLocationsResponse implements IAssetLocationsResponse {
    assetLocations?: AssetLocationDto[] | undefined;
    totalCount?: number;

    constructor(data?: IAssetLocationsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["assetLocations"])) {
                this.assetLocations = [] as any;
                for (let item of _data["assetLocations"])
                    this.assetLocations!.push(AssetLocationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AssetLocationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AssetLocationsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assetLocations)) {
            data["assetLocations"] = [];
            for (let item of this.assetLocations)
                data["assetLocations"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IAssetLocationsResponse {
    assetLocations?: AssetLocationDto[] | undefined;
    totalCount?: number;
}

export class AssetManagementResponse implements IAssetManagementResponse {
    assets?: Asset[] | undefined;
    summary?: AssetInventorySummary;

    constructor(data?: IAssetManagementResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["assets"])) {
                this.assets = [] as any;
                for (let item of _data["assets"])
                    this.assets!.push(Asset.fromJS(item));
            }
            this.summary = _data["summary"] ? AssetInventorySummary.fromJS(_data["summary"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AssetManagementResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AssetManagementResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assets)) {
            data["assets"] = [];
            for (let item of this.assets)
                data["assets"].push(item.toJSON());
        }
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAssetManagementResponse {
    assets?: Asset[] | undefined;
    summary?: AssetInventorySummary;
}

export class AssetOverviewWidgetResponse implements IAssetOverviewWidgetResponse {
    totalProducts?: number;
    productTypes?: AssetWidgetBaseRecord[] | undefined;
    productCategories?: AssetWidgetBaseRecord[] | undefined;
    lifecycleStates?: AssetWidgetBaseRecord[] | undefined;
    contractCoverage?: AssetWidgetBaseRecord[] | undefined;

    constructor(data?: IAssetOverviewWidgetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalProducts = _data["totalProducts"];
            if (Array.isArray(_data["productTypes"])) {
                this.productTypes = [] as any;
                for (let item of _data["productTypes"])
                    this.productTypes!.push(AssetWidgetBaseRecord.fromJS(item));
            }
            if (Array.isArray(_data["productCategories"])) {
                this.productCategories = [] as any;
                for (let item of _data["productCategories"])
                    this.productCategories!.push(AssetWidgetBaseRecord.fromJS(item));
            }
            if (Array.isArray(_data["lifecycleStates"])) {
                this.lifecycleStates = [] as any;
                for (let item of _data["lifecycleStates"])
                    this.lifecycleStates!.push(AssetWidgetBaseRecord.fromJS(item));
            }
            if (Array.isArray(_data["contractCoverage"])) {
                this.contractCoverage = [] as any;
                for (let item of _data["contractCoverage"])
                    this.contractCoverage!.push(AssetWidgetBaseRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssetOverviewWidgetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AssetOverviewWidgetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalProducts"] = this.totalProducts;
        if (Array.isArray(this.productTypes)) {
            data["productTypes"] = [];
            for (let item of this.productTypes)
                data["productTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.productCategories)) {
            data["productCategories"] = [];
            for (let item of this.productCategories)
                data["productCategories"].push(item.toJSON());
        }
        if (Array.isArray(this.lifecycleStates)) {
            data["lifecycleStates"] = [];
            for (let item of this.lifecycleStates)
                data["lifecycleStates"].push(item.toJSON());
        }
        if (Array.isArray(this.contractCoverage)) {
            data["contractCoverage"] = [];
            for (let item of this.contractCoverage)
                data["contractCoverage"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAssetOverviewWidgetResponse {
    totalProducts?: number;
    productTypes?: AssetWidgetBaseRecord[] | undefined;
    productCategories?: AssetWidgetBaseRecord[] | undefined;
    lifecycleStates?: AssetWidgetBaseRecord[] | undefined;
    contractCoverage?: AssetWidgetBaseRecord[] | undefined;
}

export class AssetProductCatalogResponse implements IAssetProductCatalogResponse {
    assetProductCatalog?: AssetProductCatalogDto[] | undefined;

    constructor(data?: IAssetProductCatalogResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["assetProductCatalog"])) {
                this.assetProductCatalog = [] as any;
                for (let item of _data["assetProductCatalog"])
                    this.assetProductCatalog!.push(AssetProductCatalogDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssetProductCatalogResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AssetProductCatalogResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assetProductCatalog)) {
            data["assetProductCatalog"] = [];
            for (let item of this.assetProductCatalog)
                data["assetProductCatalog"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAssetProductCatalogResponse {
    assetProductCatalog?: AssetProductCatalogDto[] | undefined;
}

export class AssetInventorySearchFilterDto implements IAssetInventorySearchFilterDto {
    searchFor?: string | undefined;
    parentId?: string[] | undefined;
    assetType?: string[] | undefined;
    displayName?: string[] | undefined;
    manufacturer?: string[] | undefined;
    managingPartner?: string[] | undefined;
    product?: string[] | undefined;
    shiCategory?: string[] | undefined;
    subCategory?: string[] | undefined;
    microCategory?: string[] | undefined;
    shiUseState?: string[] | undefined;
    shiLifecycleState?: string[] | undefined;
    contractId?: string[] | undefined;
    shiContractType?: string[] | undefined;
    coveredStatus?: string[] | undefined;
    contractVendor?: string[] | undefined;
    displayLocationName?: string[] | undefined;
    locationAddress?: string[] | undefined;
    locationCity?: string[] | undefined;
    locationState?: string[] | undefined;
    locationCountry?: string[] | undefined;
    discoveredOnNet?: string[] | undefined;
    tags?: string[] | undefined;
    coveredStartDateStart?: Date | undefined;
    coveredStartDateEnd?: Date | undefined;
    coveredEndDateStart?: Date | undefined;
    coveredEndDateEnd?: Date | undefined;

    protected _discriminator: string;

    constructor(data?: IAssetInventorySearchFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "AssetInventorySearchFilterDto";
    }

    init(_data?: any) {
        if (_data) {
            this.searchFor = _data["searchFor"];
            if (Array.isArray(_data["parentId"])) {
                this.parentId = [] as any;
                for (let item of _data["parentId"])
                    this.parentId!.push(item);
            }
            if (Array.isArray(_data["assetType"])) {
                this.assetType = [] as any;
                for (let item of _data["assetType"])
                    this.assetType!.push(item);
            }
            if (Array.isArray(_data["displayName"])) {
                this.displayName = [] as any;
                for (let item of _data["displayName"])
                    this.displayName!.push(item);
            }
            if (Array.isArray(_data["manufacturer"])) {
                this.manufacturer = [] as any;
                for (let item of _data["manufacturer"])
                    this.manufacturer!.push(item);
            }
            if (Array.isArray(_data["managingPartner"])) {
                this.managingPartner = [] as any;
                for (let item of _data["managingPartner"])
                    this.managingPartner!.push(item);
            }
            if (Array.isArray(_data["product"])) {
                this.product = [] as any;
                for (let item of _data["product"])
                    this.product!.push(item);
            }
            if (Array.isArray(_data["shiCategory"])) {
                this.shiCategory = [] as any;
                for (let item of _data["shiCategory"])
                    this.shiCategory!.push(item);
            }
            if (Array.isArray(_data["subCategory"])) {
                this.subCategory = [] as any;
                for (let item of _data["subCategory"])
                    this.subCategory!.push(item);
            }
            if (Array.isArray(_data["microCategory"])) {
                this.microCategory = [] as any;
                for (let item of _data["microCategory"])
                    this.microCategory!.push(item);
            }
            if (Array.isArray(_data["shiUseState"])) {
                this.shiUseState = [] as any;
                for (let item of _data["shiUseState"])
                    this.shiUseState!.push(item);
            }
            if (Array.isArray(_data["shiLifecycleState"])) {
                this.shiLifecycleState = [] as any;
                for (let item of _data["shiLifecycleState"])
                    this.shiLifecycleState!.push(item);
            }
            if (Array.isArray(_data["contractId"])) {
                this.contractId = [] as any;
                for (let item of _data["contractId"])
                    this.contractId!.push(item);
            }
            if (Array.isArray(_data["shiContractType"])) {
                this.shiContractType = [] as any;
                for (let item of _data["shiContractType"])
                    this.shiContractType!.push(item);
            }
            if (Array.isArray(_data["coveredStatus"])) {
                this.coveredStatus = [] as any;
                for (let item of _data["coveredStatus"])
                    this.coveredStatus!.push(item);
            }
            if (Array.isArray(_data["contractVendor"])) {
                this.contractVendor = [] as any;
                for (let item of _data["contractVendor"])
                    this.contractVendor!.push(item);
            }
            if (Array.isArray(_data["displayLocationName"])) {
                this.displayLocationName = [] as any;
                for (let item of _data["displayLocationName"])
                    this.displayLocationName!.push(item);
            }
            if (Array.isArray(_data["locationAddress"])) {
                this.locationAddress = [] as any;
                for (let item of _data["locationAddress"])
                    this.locationAddress!.push(item);
            }
            if (Array.isArray(_data["locationCity"])) {
                this.locationCity = [] as any;
                for (let item of _data["locationCity"])
                    this.locationCity!.push(item);
            }
            if (Array.isArray(_data["locationState"])) {
                this.locationState = [] as any;
                for (let item of _data["locationState"])
                    this.locationState!.push(item);
            }
            if (Array.isArray(_data["locationCountry"])) {
                this.locationCountry = [] as any;
                for (let item of _data["locationCountry"])
                    this.locationCountry!.push(item);
            }
            if (Array.isArray(_data["discoveredOnNet"])) {
                this.discoveredOnNet = [] as any;
                for (let item of _data["discoveredOnNet"])
                    this.discoveredOnNet!.push(item);
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.coveredStartDateStart = _data["coveredStartDateStart"] ? new Date(_data["coveredStartDateStart"].toString()) : <any>undefined;
            this.coveredStartDateEnd = _data["coveredStartDateEnd"] ? new Date(_data["coveredStartDateEnd"].toString()) : <any>undefined;
            this.coveredEndDateStart = _data["coveredEndDateStart"] ? new Date(_data["coveredEndDateStart"].toString()) : <any>undefined;
            this.coveredEndDateEnd = _data["coveredEndDateEnd"] ? new Date(_data["coveredEndDateEnd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AssetInventorySearchFilterDto {
        data = typeof data === 'object' ? data : {};
        if (data["typeName"] === "AssetSearchFilter") {
            let result = new AssetSearchFilter();
            result.init(data);
            return result;
        }
        let result = new AssetInventorySearchFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeName"] = this._discriminator;
        data["searchFor"] = this.searchFor;
        if (Array.isArray(this.parentId)) {
            data["parentId"] = [];
            for (let item of this.parentId)
                data["parentId"].push(item);
        }
        if (Array.isArray(this.assetType)) {
            data["assetType"] = [];
            for (let item of this.assetType)
                data["assetType"].push(item);
        }
        if (Array.isArray(this.displayName)) {
            data["displayName"] = [];
            for (let item of this.displayName)
                data["displayName"].push(item);
        }
        if (Array.isArray(this.manufacturer)) {
            data["manufacturer"] = [];
            for (let item of this.manufacturer)
                data["manufacturer"].push(item);
        }
        if (Array.isArray(this.managingPartner)) {
            data["managingPartner"] = [];
            for (let item of this.managingPartner)
                data["managingPartner"].push(item);
        }
        if (Array.isArray(this.product)) {
            data["product"] = [];
            for (let item of this.product)
                data["product"].push(item);
        }
        if (Array.isArray(this.shiCategory)) {
            data["shiCategory"] = [];
            for (let item of this.shiCategory)
                data["shiCategory"].push(item);
        }
        if (Array.isArray(this.subCategory)) {
            data["subCategory"] = [];
            for (let item of this.subCategory)
                data["subCategory"].push(item);
        }
        if (Array.isArray(this.microCategory)) {
            data["microCategory"] = [];
            for (let item of this.microCategory)
                data["microCategory"].push(item);
        }
        if (Array.isArray(this.shiUseState)) {
            data["shiUseState"] = [];
            for (let item of this.shiUseState)
                data["shiUseState"].push(item);
        }
        if (Array.isArray(this.shiLifecycleState)) {
            data["shiLifecycleState"] = [];
            for (let item of this.shiLifecycleState)
                data["shiLifecycleState"].push(item);
        }
        if (Array.isArray(this.contractId)) {
            data["contractId"] = [];
            for (let item of this.contractId)
                data["contractId"].push(item);
        }
        if (Array.isArray(this.shiContractType)) {
            data["shiContractType"] = [];
            for (let item of this.shiContractType)
                data["shiContractType"].push(item);
        }
        if (Array.isArray(this.coveredStatus)) {
            data["coveredStatus"] = [];
            for (let item of this.coveredStatus)
                data["coveredStatus"].push(item);
        }
        if (Array.isArray(this.contractVendor)) {
            data["contractVendor"] = [];
            for (let item of this.contractVendor)
                data["contractVendor"].push(item);
        }
        if (Array.isArray(this.displayLocationName)) {
            data["displayLocationName"] = [];
            for (let item of this.displayLocationName)
                data["displayLocationName"].push(item);
        }
        if (Array.isArray(this.locationAddress)) {
            data["locationAddress"] = [];
            for (let item of this.locationAddress)
                data["locationAddress"].push(item);
        }
        if (Array.isArray(this.locationCity)) {
            data["locationCity"] = [];
            for (let item of this.locationCity)
                data["locationCity"].push(item);
        }
        if (Array.isArray(this.locationState)) {
            data["locationState"] = [];
            for (let item of this.locationState)
                data["locationState"].push(item);
        }
        if (Array.isArray(this.locationCountry)) {
            data["locationCountry"] = [];
            for (let item of this.locationCountry)
                data["locationCountry"].push(item);
        }
        if (Array.isArray(this.discoveredOnNet)) {
            data["discoveredOnNet"] = [];
            for (let item of this.discoveredOnNet)
                data["discoveredOnNet"].push(item);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["coveredStartDateStart"] = this.coveredStartDateStart ? this.coveredStartDateStart.toISOString() : <any>undefined;
        data["coveredStartDateEnd"] = this.coveredStartDateEnd ? this.coveredStartDateEnd.toISOString() : <any>undefined;
        data["coveredEndDateStart"] = this.coveredEndDateStart ? this.coveredEndDateStart.toISOString() : <any>undefined;
        data["coveredEndDateEnd"] = this.coveredEndDateEnd ? this.coveredEndDateEnd.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAssetInventorySearchFilterDto {
    searchFor?: string | undefined;
    parentId?: string[] | undefined;
    assetType?: string[] | undefined;
    displayName?: string[] | undefined;
    manufacturer?: string[] | undefined;
    managingPartner?: string[] | undefined;
    product?: string[] | undefined;
    shiCategory?: string[] | undefined;
    subCategory?: string[] | undefined;
    microCategory?: string[] | undefined;
    shiUseState?: string[] | undefined;
    shiLifecycleState?: string[] | undefined;
    contractId?: string[] | undefined;
    shiContractType?: string[] | undefined;
    coveredStatus?: string[] | undefined;
    contractVendor?: string[] | undefined;
    displayLocationName?: string[] | undefined;
    locationAddress?: string[] | undefined;
    locationCity?: string[] | undefined;
    locationState?: string[] | undefined;
    locationCountry?: string[] | undefined;
    discoveredOnNet?: string[] | undefined;
    tags?: string[] | undefined;
    coveredStartDateStart?: Date | undefined;
    coveredStartDateEnd?: Date | undefined;
    coveredEndDateStart?: Date | undefined;
    coveredEndDateEnd?: Date | undefined;
}

export class AssetSearchFilter extends AssetInventorySearchFilterDto implements IAssetSearchFilter {
    quarter?: number | undefined;
    year?: number | undefined;

    constructor(data?: IAssetSearchFilter) {
        super(data);
        this._discriminator = "AssetSearchFilter";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.quarter = _data["quarter"];
            this.year = _data["year"];
        }
    }

    static override fromJS(data: any): AssetSearchFilter {
        data = typeof data === 'object' ? data : {};
        let result = new AssetSearchFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quarter"] = this.quarter;
        data["year"] = this.year;
        super.toJSON(data);
        return data;
    }
}

export interface IAssetSearchFilter extends IAssetInventorySearchFilterDto {
    quarter?: number | undefined;
    year?: number | undefined;
}

export class AssetWidgetFilterByCategoryResponse implements IAssetWidgetFilterByCategoryResponse {
    records?: AssetWidgetBaseRecord[] | undefined;

    constructor(data?: IAssetWidgetFilterByCategoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(AssetWidgetBaseRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssetWidgetFilterByCategoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AssetWidgetFilterByCategoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAssetWidgetFilterByCategoryResponse {
    records?: AssetWidgetBaseRecord[] | undefined;
}

export class AssetsByProductOverviewWidgetResponse implements IAssetsByProductOverviewWidgetResponse {
    totalProducts?: number;
    productTypes?: AssetWidgetBaseRecord[] | undefined;
    productCategories?: AssetWidgetBaseRecord[] | undefined;
    lifecycleStates?: AssetWidgetBaseRecord[] | undefined;

    constructor(data?: IAssetsByProductOverviewWidgetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalProducts = _data["totalProducts"];
            if (Array.isArray(_data["productTypes"])) {
                this.productTypes = [] as any;
                for (let item of _data["productTypes"])
                    this.productTypes!.push(AssetWidgetBaseRecord.fromJS(item));
            }
            if (Array.isArray(_data["productCategories"])) {
                this.productCategories = [] as any;
                for (let item of _data["productCategories"])
                    this.productCategories!.push(AssetWidgetBaseRecord.fromJS(item));
            }
            if (Array.isArray(_data["lifecycleStates"])) {
                this.lifecycleStates = [] as any;
                for (let item of _data["lifecycleStates"])
                    this.lifecycleStates!.push(AssetWidgetBaseRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssetsByProductOverviewWidgetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AssetsByProductOverviewWidgetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalProducts"] = this.totalProducts;
        if (Array.isArray(this.productTypes)) {
            data["productTypes"] = [];
            for (let item of this.productTypes)
                data["productTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.productCategories)) {
            data["productCategories"] = [];
            for (let item of this.productCategories)
                data["productCategories"].push(item.toJSON());
        }
        if (Array.isArray(this.lifecycleStates)) {
            data["lifecycleStates"] = [];
            for (let item of this.lifecycleStates)
                data["lifecycleStates"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAssetsByProductOverviewWidgetResponse {
    totalProducts?: number;
    productTypes?: AssetWidgetBaseRecord[] | undefined;
    productCategories?: AssetWidgetBaseRecord[] | undefined;
    lifecycleStates?: AssetWidgetBaseRecord[] | undefined;
}

export class AssetsByUseStateWidgetResponse implements IAssetsByUseStateWidgetResponse {
    totalAssets?: number;
    assets?: AssetByCategory[] | undefined;
    useStateList?: string[] | undefined;

    constructor(data?: IAssetsByUseStateWidgetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalAssets = _data["totalAssets"];
            if (Array.isArray(_data["assets"])) {
                this.assets = [] as any;
                for (let item of _data["assets"])
                    this.assets!.push(AssetByCategory.fromJS(item));
            }
            if (Array.isArray(_data["useStateList"])) {
                this.useStateList = [] as any;
                for (let item of _data["useStateList"])
                    this.useStateList!.push(item);
            }
        }
    }

    static fromJS(data: any): AssetsByUseStateWidgetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AssetsByUseStateWidgetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalAssets"] = this.totalAssets;
        if (Array.isArray(this.assets)) {
            data["assets"] = [];
            for (let item of this.assets)
                data["assets"].push(item.toJSON());
        }
        if (Array.isArray(this.useStateList)) {
            data["useStateList"] = [];
            for (let item of this.useStateList)
                data["useStateList"].push(item);
        }
        return data;
    }
}

export interface IAssetsByUseStateWidgetResponse {
    totalAssets?: number;
    assets?: AssetByCategory[] | undefined;
    useStateList?: string[] | undefined;
}

export class CoveredAssetsByProduct implements ICoveredAssetsByProduct {
    identifier?: number | undefined;
    product?: string | undefined;
    manufacturer?: string | undefined;
    assetsCount?: number;

    constructor(data?: ICoveredAssetsByProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
            this.product = _data["product"];
            this.manufacturer = _data["manufacturer"];
            this.assetsCount = _data["assetsCount"];
        }
    }

    static fromJS(data: any): CoveredAssetsByProduct {
        data = typeof data === 'object' ? data : {};
        let result = new CoveredAssetsByProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["product"] = this.product;
        data["manufacturer"] = this.manufacturer;
        data["assetsCount"] = this.assetsCount;
        return data;
    }
}

export interface ICoveredAssetsByProduct {
    identifier?: number | undefined;
    product?: string | undefined;
    manufacturer?: string | undefined;
    assetsCount?: number;
}

export class CoveredAssetsByProductWidgetResponse implements ICoveredAssetsByProductWidgetResponse {
    totalCoveredAssets?: number;
    products?: CoveredAssetsByProduct[] | undefined;

    constructor(data?: ICoveredAssetsByProductWidgetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCoveredAssets = _data["totalCoveredAssets"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(CoveredAssetsByProduct.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CoveredAssetsByProductWidgetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CoveredAssetsByProductWidgetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCoveredAssets"] = this.totalCoveredAssets;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICoveredAssetsByProductWidgetResponse {
    totalCoveredAssets?: number;
    products?: CoveredAssetsByProduct[] | undefined;
}

export class TitleValue implements ITitleValue {
    title?: string | undefined;
    value?: number;

    constructor(data?: ITitleValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): TitleValue {
        data = typeof data === 'object' ? data : {};
        let result = new TitleValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["value"] = this.value;
        return data;
    }
}

export interface ITitleValue {
    title?: string | undefined;
    value?: number;
}

export class AssetContractAggregationDto implements IAssetContractAggregationDto {
    axAccountNumber?: string | undefined;
    contractVendor?: string[] | undefined;
    contractId?: string[] | undefined;
    serviceLevelAgreement?: string[] | undefined;
    serviceLevelDescription?: string[] | undefined;
    coveredStatus?: string[] | undefined;
    managingPartner?: string[] | undefined;

    constructor(data?: IAssetContractAggregationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.axAccountNumber = _data["axAccountNumber"];
            if (Array.isArray(_data["contractVendor"])) {
                this.contractVendor = [] as any;
                for (let item of _data["contractVendor"])
                    this.contractVendor!.push(item);
            }
            if (Array.isArray(_data["contractId"])) {
                this.contractId = [] as any;
                for (let item of _data["contractId"])
                    this.contractId!.push(item);
            }
            if (Array.isArray(_data["serviceLevelAgreement"])) {
                this.serviceLevelAgreement = [] as any;
                for (let item of _data["serviceLevelAgreement"])
                    this.serviceLevelAgreement!.push(item);
            }
            if (Array.isArray(_data["serviceLevelDescription"])) {
                this.serviceLevelDescription = [] as any;
                for (let item of _data["serviceLevelDescription"])
                    this.serviceLevelDescription!.push(item);
            }
            if (Array.isArray(_data["coveredStatus"])) {
                this.coveredStatus = [] as any;
                for (let item of _data["coveredStatus"])
                    this.coveredStatus!.push(item);
            }
            if (Array.isArray(_data["managingPartner"])) {
                this.managingPartner = [] as any;
                for (let item of _data["managingPartner"])
                    this.managingPartner!.push(item);
            }
        }
    }

    static fromJS(data: any): AssetContractAggregationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetContractAggregationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccountNumber"] = this.axAccountNumber;
        if (Array.isArray(this.contractVendor)) {
            data["contractVendor"] = [];
            for (let item of this.contractVendor)
                data["contractVendor"].push(item);
        }
        if (Array.isArray(this.contractId)) {
            data["contractId"] = [];
            for (let item of this.contractId)
                data["contractId"].push(item);
        }
        if (Array.isArray(this.serviceLevelAgreement)) {
            data["serviceLevelAgreement"] = [];
            for (let item of this.serviceLevelAgreement)
                data["serviceLevelAgreement"].push(item);
        }
        if (Array.isArray(this.serviceLevelDescription)) {
            data["serviceLevelDescription"] = [];
            for (let item of this.serviceLevelDescription)
                data["serviceLevelDescription"].push(item);
        }
        if (Array.isArray(this.coveredStatus)) {
            data["coveredStatus"] = [];
            for (let item of this.coveredStatus)
                data["coveredStatus"].push(item);
        }
        if (Array.isArray(this.managingPartner)) {
            data["managingPartner"] = [];
            for (let item of this.managingPartner)
                data["managingPartner"].push(item);
        }
        return data;
    }
}

export interface IAssetContractAggregationDto {
    axAccountNumber?: string | undefined;
    contractVendor?: string[] | undefined;
    contractId?: string[] | undefined;
    serviceLevelAgreement?: string[] | undefined;
    serviceLevelDescription?: string[] | undefined;
    coveredStatus?: string[] | undefined;
    managingPartner?: string[] | undefined;
}

export class AssetInventoryAggregationDto implements IAssetInventoryAggregationDto {
    axAccountNumber?: string | undefined;
    assetType?: string[] | undefined;
    displayName?: string[] | undefined;
    manufacturer?: string[] | undefined;
    managingPartner?: string[] | undefined;
    product?: string[] | undefined;
    shiCategory?: string[] | undefined;
    subCategory?: string[] | undefined;
    microCategory?: string[] | undefined;
    shiUseState?: string[] | undefined;
    shiLifecycleState?: string[] | undefined;
    contractId?: string[] | undefined;
    shiContractType?: string[] | undefined;
    coveredStatus?: string[] | undefined;
    contractVendor?: string[] | undefined;
    displayLocationName?: string[] | undefined;
    locationCity?: string[] | undefined;
    locationState?: string[] | undefined;
    locationCountry?: string[] | undefined;
    discoveredOnNet?: string[] | undefined;
    tags?: string[] | undefined;

    constructor(data?: IAssetInventoryAggregationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.axAccountNumber = _data["axAccountNumber"];
            if (Array.isArray(_data["assetType"])) {
                this.assetType = [] as any;
                for (let item of _data["assetType"])
                    this.assetType!.push(item);
            }
            if (Array.isArray(_data["displayName"])) {
                this.displayName = [] as any;
                for (let item of _data["displayName"])
                    this.displayName!.push(item);
            }
            if (Array.isArray(_data["manufacturer"])) {
                this.manufacturer = [] as any;
                for (let item of _data["manufacturer"])
                    this.manufacturer!.push(item);
            }
            if (Array.isArray(_data["managingPartner"])) {
                this.managingPartner = [] as any;
                for (let item of _data["managingPartner"])
                    this.managingPartner!.push(item);
            }
            if (Array.isArray(_data["product"])) {
                this.product = [] as any;
                for (let item of _data["product"])
                    this.product!.push(item);
            }
            if (Array.isArray(_data["shiCategory"])) {
                this.shiCategory = [] as any;
                for (let item of _data["shiCategory"])
                    this.shiCategory!.push(item);
            }
            if (Array.isArray(_data["subCategory"])) {
                this.subCategory = [] as any;
                for (let item of _data["subCategory"])
                    this.subCategory!.push(item);
            }
            if (Array.isArray(_data["microCategory"])) {
                this.microCategory = [] as any;
                for (let item of _data["microCategory"])
                    this.microCategory!.push(item);
            }
            if (Array.isArray(_data["shiUseState"])) {
                this.shiUseState = [] as any;
                for (let item of _data["shiUseState"])
                    this.shiUseState!.push(item);
            }
            if (Array.isArray(_data["shiLifecycleState"])) {
                this.shiLifecycleState = [] as any;
                for (let item of _data["shiLifecycleState"])
                    this.shiLifecycleState!.push(item);
            }
            if (Array.isArray(_data["contractId"])) {
                this.contractId = [] as any;
                for (let item of _data["contractId"])
                    this.contractId!.push(item);
            }
            if (Array.isArray(_data["shiContractType"])) {
                this.shiContractType = [] as any;
                for (let item of _data["shiContractType"])
                    this.shiContractType!.push(item);
            }
            if (Array.isArray(_data["coveredStatus"])) {
                this.coveredStatus = [] as any;
                for (let item of _data["coveredStatus"])
                    this.coveredStatus!.push(item);
            }
            if (Array.isArray(_data["contractVendor"])) {
                this.contractVendor = [] as any;
                for (let item of _data["contractVendor"])
                    this.contractVendor!.push(item);
            }
            if (Array.isArray(_data["displayLocationName"])) {
                this.displayLocationName = [] as any;
                for (let item of _data["displayLocationName"])
                    this.displayLocationName!.push(item);
            }
            if (Array.isArray(_data["locationCity"])) {
                this.locationCity = [] as any;
                for (let item of _data["locationCity"])
                    this.locationCity!.push(item);
            }
            if (Array.isArray(_data["locationState"])) {
                this.locationState = [] as any;
                for (let item of _data["locationState"])
                    this.locationState!.push(item);
            }
            if (Array.isArray(_data["locationCountry"])) {
                this.locationCountry = [] as any;
                for (let item of _data["locationCountry"])
                    this.locationCountry!.push(item);
            }
            if (Array.isArray(_data["discoveredOnNet"])) {
                this.discoveredOnNet = [] as any;
                for (let item of _data["discoveredOnNet"])
                    this.discoveredOnNet!.push(item);
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
        }
    }

    static fromJS(data: any): AssetInventoryAggregationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetInventoryAggregationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccountNumber"] = this.axAccountNumber;
        if (Array.isArray(this.assetType)) {
            data["assetType"] = [];
            for (let item of this.assetType)
                data["assetType"].push(item);
        }
        if (Array.isArray(this.displayName)) {
            data["displayName"] = [];
            for (let item of this.displayName)
                data["displayName"].push(item);
        }
        if (Array.isArray(this.manufacturer)) {
            data["manufacturer"] = [];
            for (let item of this.manufacturer)
                data["manufacturer"].push(item);
        }
        if (Array.isArray(this.managingPartner)) {
            data["managingPartner"] = [];
            for (let item of this.managingPartner)
                data["managingPartner"].push(item);
        }
        if (Array.isArray(this.product)) {
            data["product"] = [];
            for (let item of this.product)
                data["product"].push(item);
        }
        if (Array.isArray(this.shiCategory)) {
            data["shiCategory"] = [];
            for (let item of this.shiCategory)
                data["shiCategory"].push(item);
        }
        if (Array.isArray(this.subCategory)) {
            data["subCategory"] = [];
            for (let item of this.subCategory)
                data["subCategory"].push(item);
        }
        if (Array.isArray(this.microCategory)) {
            data["microCategory"] = [];
            for (let item of this.microCategory)
                data["microCategory"].push(item);
        }
        if (Array.isArray(this.shiUseState)) {
            data["shiUseState"] = [];
            for (let item of this.shiUseState)
                data["shiUseState"].push(item);
        }
        if (Array.isArray(this.shiLifecycleState)) {
            data["shiLifecycleState"] = [];
            for (let item of this.shiLifecycleState)
                data["shiLifecycleState"].push(item);
        }
        if (Array.isArray(this.contractId)) {
            data["contractId"] = [];
            for (let item of this.contractId)
                data["contractId"].push(item);
        }
        if (Array.isArray(this.shiContractType)) {
            data["shiContractType"] = [];
            for (let item of this.shiContractType)
                data["shiContractType"].push(item);
        }
        if (Array.isArray(this.coveredStatus)) {
            data["coveredStatus"] = [];
            for (let item of this.coveredStatus)
                data["coveredStatus"].push(item);
        }
        if (Array.isArray(this.contractVendor)) {
            data["contractVendor"] = [];
            for (let item of this.contractVendor)
                data["contractVendor"].push(item);
        }
        if (Array.isArray(this.displayLocationName)) {
            data["displayLocationName"] = [];
            for (let item of this.displayLocationName)
                data["displayLocationName"].push(item);
        }
        if (Array.isArray(this.locationCity)) {
            data["locationCity"] = [];
            for (let item of this.locationCity)
                data["locationCity"].push(item);
        }
        if (Array.isArray(this.locationState)) {
            data["locationState"] = [];
            for (let item of this.locationState)
                data["locationState"].push(item);
        }
        if (Array.isArray(this.locationCountry)) {
            data["locationCountry"] = [];
            for (let item of this.locationCountry)
                data["locationCountry"].push(item);
        }
        if (Array.isArray(this.discoveredOnNet)) {
            data["discoveredOnNet"] = [];
            for (let item of this.discoveredOnNet)
                data["discoveredOnNet"].push(item);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data;
    }
}

export interface IAssetInventoryAggregationDto {
    axAccountNumber?: string | undefined;
    assetType?: string[] | undefined;
    displayName?: string[] | undefined;
    manufacturer?: string[] | undefined;
    managingPartner?: string[] | undefined;
    product?: string[] | undefined;
    shiCategory?: string[] | undefined;
    subCategory?: string[] | undefined;
    microCategory?: string[] | undefined;
    shiUseState?: string[] | undefined;
    shiLifecycleState?: string[] | undefined;
    contractId?: string[] | undefined;
    shiContractType?: string[] | undefined;
    coveredStatus?: string[] | undefined;
    contractVendor?: string[] | undefined;
    displayLocationName?: string[] | undefined;
    locationCity?: string[] | undefined;
    locationState?: string[] | undefined;
    locationCountry?: string[] | undefined;
    discoveredOnNet?: string[] | undefined;
    tags?: string[] | undefined;
}

export class AssetLifecycleAggregationDto implements IAssetLifecycleAggregationDto {
    axAccountNumber?: string | undefined;
    assetType?: string[] | undefined;
    displayName?: string[] | undefined;
    manufacturer?: string[] | undefined;
    managingPartner?: string[] | undefined;
    product?: string[] | undefined;
    shiCategory?: string[] | undefined;
    subCategory?: string[] | undefined;
    microCategory?: string[] | undefined;
    shiUseState?: string[] | undefined;
    shiLifecycleState?: string[] | undefined;
    contractId?: string[] | undefined;
    shiContractType?: string[] | undefined;
    coveredStatus?: string[] | undefined;
    contractVendor?: string[] | undefined;
    displayLocationName?: string[] | undefined;
    locationCity?: string[] | undefined;
    locationState?: string[] | undefined;
    locationCountry?: string[] | undefined;
    discoveredOnNet?: string[] | undefined;
    tags?: string[] | undefined;

    constructor(data?: IAssetLifecycleAggregationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.axAccountNumber = _data["axAccountNumber"];
            if (Array.isArray(_data["assetType"])) {
                this.assetType = [] as any;
                for (let item of _data["assetType"])
                    this.assetType!.push(item);
            }
            if (Array.isArray(_data["displayName"])) {
                this.displayName = [] as any;
                for (let item of _data["displayName"])
                    this.displayName!.push(item);
            }
            if (Array.isArray(_data["manufacturer"])) {
                this.manufacturer = [] as any;
                for (let item of _data["manufacturer"])
                    this.manufacturer!.push(item);
            }
            if (Array.isArray(_data["managingPartner"])) {
                this.managingPartner = [] as any;
                for (let item of _data["managingPartner"])
                    this.managingPartner!.push(item);
            }
            if (Array.isArray(_data["product"])) {
                this.product = [] as any;
                for (let item of _data["product"])
                    this.product!.push(item);
            }
            if (Array.isArray(_data["shiCategory"])) {
                this.shiCategory = [] as any;
                for (let item of _data["shiCategory"])
                    this.shiCategory!.push(item);
            }
            if (Array.isArray(_data["subCategory"])) {
                this.subCategory = [] as any;
                for (let item of _data["subCategory"])
                    this.subCategory!.push(item);
            }
            if (Array.isArray(_data["microCategory"])) {
                this.microCategory = [] as any;
                for (let item of _data["microCategory"])
                    this.microCategory!.push(item);
            }
            if (Array.isArray(_data["shiUseState"])) {
                this.shiUseState = [] as any;
                for (let item of _data["shiUseState"])
                    this.shiUseState!.push(item);
            }
            if (Array.isArray(_data["shiLifecycleState"])) {
                this.shiLifecycleState = [] as any;
                for (let item of _data["shiLifecycleState"])
                    this.shiLifecycleState!.push(item);
            }
            if (Array.isArray(_data["contractId"])) {
                this.contractId = [] as any;
                for (let item of _data["contractId"])
                    this.contractId!.push(item);
            }
            if (Array.isArray(_data["shiContractType"])) {
                this.shiContractType = [] as any;
                for (let item of _data["shiContractType"])
                    this.shiContractType!.push(item);
            }
            if (Array.isArray(_data["coveredStatus"])) {
                this.coveredStatus = [] as any;
                for (let item of _data["coveredStatus"])
                    this.coveredStatus!.push(item);
            }
            if (Array.isArray(_data["contractVendor"])) {
                this.contractVendor = [] as any;
                for (let item of _data["contractVendor"])
                    this.contractVendor!.push(item);
            }
            if (Array.isArray(_data["displayLocationName"])) {
                this.displayLocationName = [] as any;
                for (let item of _data["displayLocationName"])
                    this.displayLocationName!.push(item);
            }
            if (Array.isArray(_data["locationCity"])) {
                this.locationCity = [] as any;
                for (let item of _data["locationCity"])
                    this.locationCity!.push(item);
            }
            if (Array.isArray(_data["locationState"])) {
                this.locationState = [] as any;
                for (let item of _data["locationState"])
                    this.locationState!.push(item);
            }
            if (Array.isArray(_data["locationCountry"])) {
                this.locationCountry = [] as any;
                for (let item of _data["locationCountry"])
                    this.locationCountry!.push(item);
            }
            if (Array.isArray(_data["discoveredOnNet"])) {
                this.discoveredOnNet = [] as any;
                for (let item of _data["discoveredOnNet"])
                    this.discoveredOnNet!.push(item);
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
        }
    }

    static fromJS(data: any): AssetLifecycleAggregationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetLifecycleAggregationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccountNumber"] = this.axAccountNumber;
        if (Array.isArray(this.assetType)) {
            data["assetType"] = [];
            for (let item of this.assetType)
                data["assetType"].push(item);
        }
        if (Array.isArray(this.displayName)) {
            data["displayName"] = [];
            for (let item of this.displayName)
                data["displayName"].push(item);
        }
        if (Array.isArray(this.manufacturer)) {
            data["manufacturer"] = [];
            for (let item of this.manufacturer)
                data["manufacturer"].push(item);
        }
        if (Array.isArray(this.managingPartner)) {
            data["managingPartner"] = [];
            for (let item of this.managingPartner)
                data["managingPartner"].push(item);
        }
        if (Array.isArray(this.product)) {
            data["product"] = [];
            for (let item of this.product)
                data["product"].push(item);
        }
        if (Array.isArray(this.shiCategory)) {
            data["shiCategory"] = [];
            for (let item of this.shiCategory)
                data["shiCategory"].push(item);
        }
        if (Array.isArray(this.subCategory)) {
            data["subCategory"] = [];
            for (let item of this.subCategory)
                data["subCategory"].push(item);
        }
        if (Array.isArray(this.microCategory)) {
            data["microCategory"] = [];
            for (let item of this.microCategory)
                data["microCategory"].push(item);
        }
        if (Array.isArray(this.shiUseState)) {
            data["shiUseState"] = [];
            for (let item of this.shiUseState)
                data["shiUseState"].push(item);
        }
        if (Array.isArray(this.shiLifecycleState)) {
            data["shiLifecycleState"] = [];
            for (let item of this.shiLifecycleState)
                data["shiLifecycleState"].push(item);
        }
        if (Array.isArray(this.contractId)) {
            data["contractId"] = [];
            for (let item of this.contractId)
                data["contractId"].push(item);
        }
        if (Array.isArray(this.shiContractType)) {
            data["shiContractType"] = [];
            for (let item of this.shiContractType)
                data["shiContractType"].push(item);
        }
        if (Array.isArray(this.coveredStatus)) {
            data["coveredStatus"] = [];
            for (let item of this.coveredStatus)
                data["coveredStatus"].push(item);
        }
        if (Array.isArray(this.contractVendor)) {
            data["contractVendor"] = [];
            for (let item of this.contractVendor)
                data["contractVendor"].push(item);
        }
        if (Array.isArray(this.displayLocationName)) {
            data["displayLocationName"] = [];
            for (let item of this.displayLocationName)
                data["displayLocationName"].push(item);
        }
        if (Array.isArray(this.locationCity)) {
            data["locationCity"] = [];
            for (let item of this.locationCity)
                data["locationCity"].push(item);
        }
        if (Array.isArray(this.locationState)) {
            data["locationState"] = [];
            for (let item of this.locationState)
                data["locationState"].push(item);
        }
        if (Array.isArray(this.locationCountry)) {
            data["locationCountry"] = [];
            for (let item of this.locationCountry)
                data["locationCountry"].push(item);
        }
        if (Array.isArray(this.discoveredOnNet)) {
            data["discoveredOnNet"] = [];
            for (let item of this.discoveredOnNet)
                data["discoveredOnNet"].push(item);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data;
    }
}

export interface IAssetLifecycleAggregationDto {
    axAccountNumber?: string | undefined;
    assetType?: string[] | undefined;
    displayName?: string[] | undefined;
    manufacturer?: string[] | undefined;
    managingPartner?: string[] | undefined;
    product?: string[] | undefined;
    shiCategory?: string[] | undefined;
    subCategory?: string[] | undefined;
    microCategory?: string[] | undefined;
    shiUseState?: string[] | undefined;
    shiLifecycleState?: string[] | undefined;
    contractId?: string[] | undefined;
    shiContractType?: string[] | undefined;
    coveredStatus?: string[] | undefined;
    contractVendor?: string[] | undefined;
    displayLocationName?: string[] | undefined;
    locationCity?: string[] | undefined;
    locationState?: string[] | undefined;
    locationCountry?: string[] | undefined;
    discoveredOnNet?: string[] | undefined;
    tags?: string[] | undefined;
}

export class AssetLocationAggregationDto implements IAssetLocationAggregationDto {
    axAccountNumber?: string | undefined;
    displayLocationName?: string[] | undefined;
    locationAddress?: string[] | undefined;
    locationCity?: string[] | undefined;
    locationState?: string[] | undefined;
    locationCountry?: string[] | undefined;
    manufacturer?: string[] | undefined;

    constructor(data?: IAssetLocationAggregationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.axAccountNumber = _data["axAccountNumber"];
            if (Array.isArray(_data["displayLocationName"])) {
                this.displayLocationName = [] as any;
                for (let item of _data["displayLocationName"])
                    this.displayLocationName!.push(item);
            }
            if (Array.isArray(_data["locationAddress"])) {
                this.locationAddress = [] as any;
                for (let item of _data["locationAddress"])
                    this.locationAddress!.push(item);
            }
            if (Array.isArray(_data["locationCity"])) {
                this.locationCity = [] as any;
                for (let item of _data["locationCity"])
                    this.locationCity!.push(item);
            }
            if (Array.isArray(_data["locationState"])) {
                this.locationState = [] as any;
                for (let item of _data["locationState"])
                    this.locationState!.push(item);
            }
            if (Array.isArray(_data["locationCountry"])) {
                this.locationCountry = [] as any;
                for (let item of _data["locationCountry"])
                    this.locationCountry!.push(item);
            }
            if (Array.isArray(_data["manufacturer"])) {
                this.manufacturer = [] as any;
                for (let item of _data["manufacturer"])
                    this.manufacturer!.push(item);
            }
        }
    }

    static fromJS(data: any): AssetLocationAggregationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetLocationAggregationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccountNumber"] = this.axAccountNumber;
        if (Array.isArray(this.displayLocationName)) {
            data["displayLocationName"] = [];
            for (let item of this.displayLocationName)
                data["displayLocationName"].push(item);
        }
        if (Array.isArray(this.locationAddress)) {
            data["locationAddress"] = [];
            for (let item of this.locationAddress)
                data["locationAddress"].push(item);
        }
        if (Array.isArray(this.locationCity)) {
            data["locationCity"] = [];
            for (let item of this.locationCity)
                data["locationCity"].push(item);
        }
        if (Array.isArray(this.locationState)) {
            data["locationState"] = [];
            for (let item of this.locationState)
                data["locationState"].push(item);
        }
        if (Array.isArray(this.locationCountry)) {
            data["locationCountry"] = [];
            for (let item of this.locationCountry)
                data["locationCountry"].push(item);
        }
        if (Array.isArray(this.manufacturer)) {
            data["manufacturer"] = [];
            for (let item of this.manufacturer)
                data["manufacturer"].push(item);
        }
        return data;
    }
}

export interface IAssetLocationAggregationDto {
    axAccountNumber?: string | undefined;
    displayLocationName?: string[] | undefined;
    locationAddress?: string[] | undefined;
    locationCity?: string[] | undefined;
    locationState?: string[] | undefined;
    locationCountry?: string[] | undefined;
    manufacturer?: string[] | undefined;
}

export class ProductCatalogAggregationDto implements IProductCatalogAggregationDto {
    accountIdentifier?: string | undefined;
    manufacturer?: string[] | undefined;
    assetType?: string[] | undefined;
    shiCategory?: string[] | undefined;
    shiLifecycleState?: string[] | undefined;

    constructor(data?: IProductCatalogAggregationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountIdentifier = _data["accountIdentifier"];
            if (Array.isArray(_data["manufacturer"])) {
                this.manufacturer = [] as any;
                for (let item of _data["manufacturer"])
                    this.manufacturer!.push(item);
            }
            if (Array.isArray(_data["assetType"])) {
                this.assetType = [] as any;
                for (let item of _data["assetType"])
                    this.assetType!.push(item);
            }
            if (Array.isArray(_data["shiCategory"])) {
                this.shiCategory = [] as any;
                for (let item of _data["shiCategory"])
                    this.shiCategory!.push(item);
            }
            if (Array.isArray(_data["shiLifecycleState"])) {
                this.shiLifecycleState = [] as any;
                for (let item of _data["shiLifecycleState"])
                    this.shiLifecycleState!.push(item);
            }
        }
    }

    static fromJS(data: any): ProductCatalogAggregationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductCatalogAggregationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountIdentifier"] = this.accountIdentifier;
        if (Array.isArray(this.manufacturer)) {
            data["manufacturer"] = [];
            for (let item of this.manufacturer)
                data["manufacturer"].push(item);
        }
        if (Array.isArray(this.assetType)) {
            data["assetType"] = [];
            for (let item of this.assetType)
                data["assetType"].push(item);
        }
        if (Array.isArray(this.shiCategory)) {
            data["shiCategory"] = [];
            for (let item of this.shiCategory)
                data["shiCategory"].push(item);
        }
        if (Array.isArray(this.shiLifecycleState)) {
            data["shiLifecycleState"] = [];
            for (let item of this.shiLifecycleState)
                data["shiLifecycleState"].push(item);
        }
        return data;
    }
}

export interface IProductCatalogAggregationDto {
    accountIdentifier?: string | undefined;
    manufacturer?: string[] | undefined;
    assetType?: string[] | undefined;
    shiCategory?: string[] | undefined;
    shiLifecycleState?: string[] | undefined;
}

export class Asset implements IAsset {
    uniqueIdentifier?: string | undefined;
    accountIdentifier?: string | undefined;
    assetId?: string | undefined;
    parentId?: string | undefined;
    displayName?: string | undefined;
    productDescription?: string | undefined;
    manufacturer?: string | undefined;
    manufacturerGlobalCustomerName?: string | undefined;
    manufacturerGlobalCustomerId?: string | undefined;
    manufacturerCustomerName?: string | undefined;
    serialNumber?: string | undefined;
    managingPartner?: string | undefined;
    itemQuantity?: number;
    assetType?: string | undefined;
    product?: string | undefined;
    productFamily?: string | undefined;
    shiCategory?: string | undefined;
    subCategory?: string | undefined;
    microCategory?: string | undefined;
    listPrice?: number | undefined;
    contractId?: string | undefined;
    contractType?: string | undefined;
    shiContractType?: string | undefined;
    coveredStatus?: string | undefined;
    coveredEndDate?: Date | undefined;
    coveredStartDate?: Date | undefined;
    contractVendor?: string | undefined;
    serviceLevelAgreement?: string | undefined;
    serviceLevelDescription?: string | undefined;
    shiUseState?: string | undefined;
    shiLifecycleState?: string | undefined;
    nextLifecycleState?: string | undefined;
    closeToNextState?: string | undefined;
    endOfLife?: Date | undefined;
    endOfSaleDate?: Date | undefined;
    endOfSaleYear?: number | undefined;
    endOfSaleQuarter?: number | undefined;
    endOfSaleInRange?: string | undefined;
    endOfSoftwareMaintenanceDate?: Date | undefined;
    endOfSoftwareMaintenanceYear?: number | undefined;
    endOfSoftwareMaintenanceQuarter?: number | undefined;
    endOfSoftwareMaintenanceInRange?: string | undefined;
    lastDateOfSupport?: Date | undefined;
    lastDateOfSupportYear?: number | undefined;
    lastDateOfSupportQuarter?: number | undefined;
    lastDateOfSupportInRange?: string | undefined;
    endOfVulnerabilityDate?: Date | undefined;
    endOfSupport?: Date | undefined;
    warrantyEndDate?: Date | undefined;
    warrantyType?: string | undefined;
    userLocationName?: string | undefined;
    readonly displayLocationName?: string | undefined;
    locationName?: string | undefined;
    locationAddress?: string | undefined;
    locationCity?: string | undefined;
    locationState?: string | undefined;
    locationCountry?: string | undefined;
    locationId?: string | undefined;
    readonly siteLocation?: string | undefined;
    shipDate?: Date | undefined;
    licensesUsed?: number | undefined;
    licensesPurchased?: number | undefined;
    licensesAvailable?: number | undefined;
    growthAllowance?: number | undefined;
    renewalDate?: Date | undefined;
    antivirusStatus?: string | undefined;
    assignedOn?: Date | undefined;
    installDate?: Date | undefined;
    lastSeenOn?: Date | undefined;
    discoveredOnNet?: string | undefined;
    networkId?: string | undefined;
    networkAddress?: string | undefined;
    assignedTo?: string | undefined;
    companyName?: string | undefined;
    contactOwner?: string | undefined;
    datasource?: string | undefined;
    department?: string | undefined;
    firmware?: string | undefined;
    lastUser?: string | undefined;
    operatingSystem?: string | undefined;
    patchStatus?: string | undefined;
    rebootStatus?: string | undefined;
    cloudPlatform?: string | undefined;
    region?: string | undefined;
    cloudAccount?: string | undefined;
    cloudAccountId?: string | undefined;
    parentAccountId?: string | undefined;
    resourceGroup?: string | undefined;
    readonly tagsString?: string | undefined;
    tags?: string[] | undefined;
    notes?: string | undefined;
    ingestedOn?: Date;

    constructor(data?: IAsset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueIdentifier = _data["uniqueIdentifier"];
            this.accountIdentifier = _data["accountIdentifier"];
            this.assetId = _data["assetId"];
            this.parentId = _data["parentId"];
            this.displayName = _data["displayName"];
            this.productDescription = _data["productDescription"];
            this.manufacturer = _data["manufacturer"];
            this.manufacturerGlobalCustomerName = _data["manufacturerGlobalCustomerName"];
            this.manufacturerGlobalCustomerId = _data["manufacturerGlobalCustomerId"];
            this.manufacturerCustomerName = _data["manufacturerCustomerName"];
            this.serialNumber = _data["serialNumber"];
            this.managingPartner = _data["managingPartner"];
            this.itemQuantity = _data["itemQuantity"];
            this.assetType = _data["assetType"];
            this.product = _data["product"];
            this.productFamily = _data["productFamily"];
            this.shiCategory = _data["shiCategory"];
            this.subCategory = _data["subCategory"];
            this.microCategory = _data["microCategory"];
            this.listPrice = _data["listPrice"];
            this.contractId = _data["contractId"];
            this.contractType = _data["contractType"];
            this.shiContractType = _data["shiContractType"];
            this.coveredStatus = _data["coveredStatus"];
            this.coveredEndDate = _data["coveredEndDate"] ? new Date(_data["coveredEndDate"].toString()) : <any>undefined;
            this.coveredStartDate = _data["coveredStartDate"] ? new Date(_data["coveredStartDate"].toString()) : <any>undefined;
            this.contractVendor = _data["contractVendor"];
            this.serviceLevelAgreement = _data["serviceLevelAgreement"];
            this.serviceLevelDescription = _data["serviceLevelDescription"];
            this.shiUseState = _data["shiUseState"];
            this.shiLifecycleState = _data["shiLifecycleState"];
            this.nextLifecycleState = _data["nextLifecycleState"];
            this.closeToNextState = _data["closeToNextState"];
            this.endOfLife = _data["endOfLife"] ? new Date(_data["endOfLife"].toString()) : <any>undefined;
            this.endOfSaleDate = _data["endOfSaleDate"] ? new Date(_data["endOfSaleDate"].toString()) : <any>undefined;
            this.endOfSaleYear = _data["endOfSaleYear"];
            this.endOfSaleQuarter = _data["endOfSaleQuarter"];
            this.endOfSaleInRange = _data["endOfSaleInRange"];
            this.endOfSoftwareMaintenanceDate = _data["endOfSoftwareMaintenanceDate"] ? new Date(_data["endOfSoftwareMaintenanceDate"].toString()) : <any>undefined;
            this.endOfSoftwareMaintenanceYear = _data["endOfSoftwareMaintenanceYear"];
            this.endOfSoftwareMaintenanceQuarter = _data["endOfSoftwareMaintenanceQuarter"];
            this.endOfSoftwareMaintenanceInRange = _data["endOfSoftwareMaintenanceInRange"];
            this.lastDateOfSupport = _data["lastDateOfSupport"] ? new Date(_data["lastDateOfSupport"].toString()) : <any>undefined;
            this.lastDateOfSupportYear = _data["lastDateOfSupportYear"];
            this.lastDateOfSupportQuarter = _data["lastDateOfSupportQuarter"];
            this.lastDateOfSupportInRange = _data["lastDateOfSupportInRange"];
            this.endOfVulnerabilityDate = _data["endOfVulnerabilityDate"] ? new Date(_data["endOfVulnerabilityDate"].toString()) : <any>undefined;
            this.endOfSupport = _data["endOfSupport"] ? new Date(_data["endOfSupport"].toString()) : <any>undefined;
            this.warrantyEndDate = _data["warrantyEndDate"] ? new Date(_data["warrantyEndDate"].toString()) : <any>undefined;
            this.warrantyType = _data["warrantyType"];
            this.userLocationName = _data["userLocationName"];
            (<any>this).displayLocationName = _data["displayLocationName"];
            this.locationName = _data["locationName"];
            this.locationAddress = _data["locationAddress"];
            this.locationCity = _data["locationCity"];
            this.locationState = _data["locationState"];
            this.locationCountry = _data["locationCountry"];
            this.locationId = _data["locationId"];
            (<any>this).siteLocation = _data["siteLocation"];
            this.shipDate = _data["shipDate"] ? new Date(_data["shipDate"].toString()) : <any>undefined;
            this.licensesUsed = _data["licensesUsed"];
            this.licensesPurchased = _data["licensesPurchased"];
            this.licensesAvailable = _data["licensesAvailable"];
            this.growthAllowance = _data["growthAllowance"];
            this.renewalDate = _data["renewalDate"] ? new Date(_data["renewalDate"].toString()) : <any>undefined;
            this.antivirusStatus = _data["antivirusStatus"];
            this.assignedOn = _data["assignedOn"] ? new Date(_data["assignedOn"].toString()) : <any>undefined;
            this.installDate = _data["installDate"] ? new Date(_data["installDate"].toString()) : <any>undefined;
            this.lastSeenOn = _data["lastSeenOn"] ? new Date(_data["lastSeenOn"].toString()) : <any>undefined;
            this.discoveredOnNet = _data["discoveredOnNet"];
            this.networkId = _data["networkId"];
            this.networkAddress = _data["networkAddress"];
            this.assignedTo = _data["assignedTo"];
            this.companyName = _data["companyName"];
            this.contactOwner = _data["contactOwner"];
            this.datasource = _data["datasource"];
            this.department = _data["department"];
            this.firmware = _data["firmware"];
            this.lastUser = _data["lastUser"];
            this.operatingSystem = _data["operatingSystem"];
            this.patchStatus = _data["patchStatus"];
            this.rebootStatus = _data["rebootStatus"];
            this.cloudPlatform = _data["cloudPlatform"];
            this.region = _data["region"];
            this.cloudAccount = _data["cloudAccount"];
            this.cloudAccountId = _data["cloudAccountId"];
            this.parentAccountId = _data["parentAccountId"];
            this.resourceGroup = _data["resourceGroup"];
            (<any>this).tagsString = _data["tagsString"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.notes = _data["notes"];
            this.ingestedOn = _data["ingestedOn"] ? new Date(_data["ingestedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Asset {
        data = typeof data === 'object' ? data : {};
        let result = new Asset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueIdentifier"] = this.uniqueIdentifier;
        data["accountIdentifier"] = this.accountIdentifier;
        data["assetId"] = this.assetId;
        data["parentId"] = this.parentId;
        data["displayName"] = this.displayName;
        data["productDescription"] = this.productDescription;
        data["manufacturer"] = this.manufacturer;
        data["manufacturerGlobalCustomerName"] = this.manufacturerGlobalCustomerName;
        data["manufacturerGlobalCustomerId"] = this.manufacturerGlobalCustomerId;
        data["manufacturerCustomerName"] = this.manufacturerCustomerName;
        data["serialNumber"] = this.serialNumber;
        data["managingPartner"] = this.managingPartner;
        data["itemQuantity"] = this.itemQuantity;
        data["assetType"] = this.assetType;
        data["product"] = this.product;
        data["productFamily"] = this.productFamily;
        data["shiCategory"] = this.shiCategory;
        data["subCategory"] = this.subCategory;
        data["microCategory"] = this.microCategory;
        data["listPrice"] = this.listPrice;
        data["contractId"] = this.contractId;
        data["contractType"] = this.contractType;
        data["shiContractType"] = this.shiContractType;
        data["coveredStatus"] = this.coveredStatus;
        data["coveredEndDate"] = this.coveredEndDate ? this.coveredEndDate.toISOString() : <any>undefined;
        data["coveredStartDate"] = this.coveredStartDate ? this.coveredStartDate.toISOString() : <any>undefined;
        data["contractVendor"] = this.contractVendor;
        data["serviceLevelAgreement"] = this.serviceLevelAgreement;
        data["serviceLevelDescription"] = this.serviceLevelDescription;
        data["shiUseState"] = this.shiUseState;
        data["shiLifecycleState"] = this.shiLifecycleState;
        data["nextLifecycleState"] = this.nextLifecycleState;
        data["closeToNextState"] = this.closeToNextState;
        data["endOfLife"] = this.endOfLife ? this.endOfLife.toISOString() : <any>undefined;
        data["endOfSaleDate"] = this.endOfSaleDate ? this.endOfSaleDate.toISOString() : <any>undefined;
        data["endOfSaleYear"] = this.endOfSaleYear;
        data["endOfSaleQuarter"] = this.endOfSaleQuarter;
        data["endOfSaleInRange"] = this.endOfSaleInRange;
        data["endOfSoftwareMaintenanceDate"] = this.endOfSoftwareMaintenanceDate ? this.endOfSoftwareMaintenanceDate.toISOString() : <any>undefined;
        data["endOfSoftwareMaintenanceYear"] = this.endOfSoftwareMaintenanceYear;
        data["endOfSoftwareMaintenanceQuarter"] = this.endOfSoftwareMaintenanceQuarter;
        data["endOfSoftwareMaintenanceInRange"] = this.endOfSoftwareMaintenanceInRange;
        data["lastDateOfSupport"] = this.lastDateOfSupport ? this.lastDateOfSupport.toISOString() : <any>undefined;
        data["lastDateOfSupportYear"] = this.lastDateOfSupportYear;
        data["lastDateOfSupportQuarter"] = this.lastDateOfSupportQuarter;
        data["lastDateOfSupportInRange"] = this.lastDateOfSupportInRange;
        data["endOfVulnerabilityDate"] = this.endOfVulnerabilityDate ? this.endOfVulnerabilityDate.toISOString() : <any>undefined;
        data["endOfSupport"] = this.endOfSupport ? this.endOfSupport.toISOString() : <any>undefined;
        data["warrantyEndDate"] = this.warrantyEndDate ? this.warrantyEndDate.toISOString() : <any>undefined;
        data["warrantyType"] = this.warrantyType;
        data["userLocationName"] = this.userLocationName;
        data["displayLocationName"] = this.displayLocationName;
        data["locationName"] = this.locationName;
        data["locationAddress"] = this.locationAddress;
        data["locationCity"] = this.locationCity;
        data["locationState"] = this.locationState;
        data["locationCountry"] = this.locationCountry;
        data["locationId"] = this.locationId;
        data["siteLocation"] = this.siteLocation;
        data["shipDate"] = this.shipDate ? this.shipDate.toISOString() : <any>undefined;
        data["licensesUsed"] = this.licensesUsed;
        data["licensesPurchased"] = this.licensesPurchased;
        data["licensesAvailable"] = this.licensesAvailable;
        data["growthAllowance"] = this.growthAllowance;
        data["renewalDate"] = this.renewalDate ? this.renewalDate.toISOString() : <any>undefined;
        data["antivirusStatus"] = this.antivirusStatus;
        data["assignedOn"] = this.assignedOn ? this.assignedOn.toISOString() : <any>undefined;
        data["installDate"] = this.installDate ? this.installDate.toISOString() : <any>undefined;
        data["lastSeenOn"] = this.lastSeenOn ? this.lastSeenOn.toISOString() : <any>undefined;
        data["discoveredOnNet"] = this.discoveredOnNet;
        data["networkId"] = this.networkId;
        data["networkAddress"] = this.networkAddress;
        data["assignedTo"] = this.assignedTo;
        data["companyName"] = this.companyName;
        data["contactOwner"] = this.contactOwner;
        data["datasource"] = this.datasource;
        data["department"] = this.department;
        data["firmware"] = this.firmware;
        data["lastUser"] = this.lastUser;
        data["operatingSystem"] = this.operatingSystem;
        data["patchStatus"] = this.patchStatus;
        data["rebootStatus"] = this.rebootStatus;
        data["cloudPlatform"] = this.cloudPlatform;
        data["region"] = this.region;
        data["cloudAccount"] = this.cloudAccount;
        data["cloudAccountId"] = this.cloudAccountId;
        data["parentAccountId"] = this.parentAccountId;
        data["resourceGroup"] = this.resourceGroup;
        data["tagsString"] = this.tagsString;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["notes"] = this.notes;
        data["ingestedOn"] = this.ingestedOn ? this.ingestedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAsset {
    uniqueIdentifier?: string | undefined;
    accountIdentifier?: string | undefined;
    assetId?: string | undefined;
    parentId?: string | undefined;
    displayName?: string | undefined;
    productDescription?: string | undefined;
    manufacturer?: string | undefined;
    manufacturerGlobalCustomerName?: string | undefined;
    manufacturerGlobalCustomerId?: string | undefined;
    manufacturerCustomerName?: string | undefined;
    serialNumber?: string | undefined;
    managingPartner?: string | undefined;
    itemQuantity?: number;
    assetType?: string | undefined;
    product?: string | undefined;
    productFamily?: string | undefined;
    shiCategory?: string | undefined;
    subCategory?: string | undefined;
    microCategory?: string | undefined;
    listPrice?: number | undefined;
    contractId?: string | undefined;
    contractType?: string | undefined;
    shiContractType?: string | undefined;
    coveredStatus?: string | undefined;
    coveredEndDate?: Date | undefined;
    coveredStartDate?: Date | undefined;
    contractVendor?: string | undefined;
    serviceLevelAgreement?: string | undefined;
    serviceLevelDescription?: string | undefined;
    shiUseState?: string | undefined;
    shiLifecycleState?: string | undefined;
    nextLifecycleState?: string | undefined;
    closeToNextState?: string | undefined;
    endOfLife?: Date | undefined;
    endOfSaleDate?: Date | undefined;
    endOfSaleYear?: number | undefined;
    endOfSaleQuarter?: number | undefined;
    endOfSaleInRange?: string | undefined;
    endOfSoftwareMaintenanceDate?: Date | undefined;
    endOfSoftwareMaintenanceYear?: number | undefined;
    endOfSoftwareMaintenanceQuarter?: number | undefined;
    endOfSoftwareMaintenanceInRange?: string | undefined;
    lastDateOfSupport?: Date | undefined;
    lastDateOfSupportYear?: number | undefined;
    lastDateOfSupportQuarter?: number | undefined;
    lastDateOfSupportInRange?: string | undefined;
    endOfVulnerabilityDate?: Date | undefined;
    endOfSupport?: Date | undefined;
    warrantyEndDate?: Date | undefined;
    warrantyType?: string | undefined;
    userLocationName?: string | undefined;
    displayLocationName?: string | undefined;
    locationName?: string | undefined;
    locationAddress?: string | undefined;
    locationCity?: string | undefined;
    locationState?: string | undefined;
    locationCountry?: string | undefined;
    locationId?: string | undefined;
    siteLocation?: string | undefined;
    shipDate?: Date | undefined;
    licensesUsed?: number | undefined;
    licensesPurchased?: number | undefined;
    licensesAvailable?: number | undefined;
    growthAllowance?: number | undefined;
    renewalDate?: Date | undefined;
    antivirusStatus?: string | undefined;
    assignedOn?: Date | undefined;
    installDate?: Date | undefined;
    lastSeenOn?: Date | undefined;
    discoveredOnNet?: string | undefined;
    networkId?: string | undefined;
    networkAddress?: string | undefined;
    assignedTo?: string | undefined;
    companyName?: string | undefined;
    contactOwner?: string | undefined;
    datasource?: string | undefined;
    department?: string | undefined;
    firmware?: string | undefined;
    lastUser?: string | undefined;
    operatingSystem?: string | undefined;
    patchStatus?: string | undefined;
    rebootStatus?: string | undefined;
    cloudPlatform?: string | undefined;
    region?: string | undefined;
    cloudAccount?: string | undefined;
    cloudAccountId?: string | undefined;
    parentAccountId?: string | undefined;
    resourceGroup?: string | undefined;
    tagsString?: string | undefined;
    tags?: string[] | undefined;
    notes?: string | undefined;
    ingestedOn?: Date;
}

export class AssetContract implements IAssetContract {
    shiOneAssetType?: ShiOneAssetType;
    contractId?: string | undefined;
    contractVendor?: string | undefined;
    shiContractType?: string[] | undefined;
    slaItems?: AssetSlaItem[] | undefined;
    totalAssets?: number;
    earliestCoveredEndDate?: string | undefined;
    coveredStartDate?: string | undefined;
    coveredEndDate?: string | undefined;
    coveredStatus?: string | undefined;
    managedBy?: string | undefined;
    subType?: string | undefined;
    readonly shiContractTypeString?: string | undefined;
    readonly slaItemsString?: string | undefined;

    constructor(data?: IAssetContract) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shiOneAssetType = _data["shiOneAssetType"];
            this.contractId = _data["contractId"];
            this.contractVendor = _data["contractVendor"];
            if (Array.isArray(_data["shiContractType"])) {
                this.shiContractType = [] as any;
                for (let item of _data["shiContractType"])
                    this.shiContractType!.push(item);
            }
            if (Array.isArray(_data["slaItems"])) {
                this.slaItems = [] as any;
                for (let item of _data["slaItems"])
                    this.slaItems!.push(AssetSlaItem.fromJS(item));
            }
            this.totalAssets = _data["totalAssets"];
            this.earliestCoveredEndDate = _data["earliestCoveredEndDate"];
            this.coveredStartDate = _data["coveredStartDate"];
            this.coveredEndDate = _data["coveredEndDate"];
            this.coveredStatus = _data["coveredStatus"];
            this.managedBy = _data["managedBy"];
            this.subType = _data["subType"];
            (<any>this).shiContractTypeString = _data["shiContractTypeString"];
            (<any>this).slaItemsString = _data["slaItemsString"];
        }
    }

    static fromJS(data: any): AssetContract {
        data = typeof data === 'object' ? data : {};
        let result = new AssetContract();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiOneAssetType"] = this.shiOneAssetType;
        data["contractId"] = this.contractId;
        data["contractVendor"] = this.contractVendor;
        if (Array.isArray(this.shiContractType)) {
            data["shiContractType"] = [];
            for (let item of this.shiContractType)
                data["shiContractType"].push(item);
        }
        if (Array.isArray(this.slaItems)) {
            data["slaItems"] = [];
            for (let item of this.slaItems)
                data["slaItems"].push(item.toJSON());
        }
        data["totalAssets"] = this.totalAssets;
        data["earliestCoveredEndDate"] = this.earliestCoveredEndDate;
        data["coveredStartDate"] = this.coveredStartDate;
        data["coveredEndDate"] = this.coveredEndDate;
        data["coveredStatus"] = this.coveredStatus;
        data["managedBy"] = this.managedBy;
        data["subType"] = this.subType;
        data["shiContractTypeString"] = this.shiContractTypeString;
        data["slaItemsString"] = this.slaItemsString;
        return data;
    }
}

export interface IAssetContract {
    shiOneAssetType?: ShiOneAssetType;
    contractId?: string | undefined;
    contractVendor?: string | undefined;
    shiContractType?: string[] | undefined;
    slaItems?: AssetSlaItem[] | undefined;
    totalAssets?: number;
    earliestCoveredEndDate?: string | undefined;
    coveredStartDate?: string | undefined;
    coveredEndDate?: string | undefined;
    coveredStatus?: string | undefined;
    managedBy?: string | undefined;
    subType?: string | undefined;
    shiContractTypeString?: string | undefined;
    slaItemsString?: string | undefined;
}

export class AssetSlaItem implements IAssetSlaItem {
    contractType?: string | undefined;
    serviceLevelAgreement?: string | undefined;

    constructor(data?: IAssetSlaItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractType = _data["contractType"];
            this.serviceLevelAgreement = _data["serviceLevelAgreement"];
        }
    }

    static fromJS(data: any): AssetSlaItem {
        data = typeof data === 'object' ? data : {};
        let result = new AssetSlaItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractType"] = this.contractType;
        data["serviceLevelAgreement"] = this.serviceLevelAgreement;
        return data;
    }
}

export interface IAssetSlaItem {
    contractType?: string | undefined;
    serviceLevelAgreement?: string | undefined;
}

export class AssetWidgetBaseRecord implements IAssetWidgetBaseRecord {
    category?: string | undefined;
    assetsCount?: number;

    constructor(data?: IAssetWidgetBaseRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.assetsCount = _data["assetsCount"];
        }
    }

    static fromJS(data: any): AssetWidgetBaseRecord {
        data = typeof data === 'object' ? data : {};
        let result = new AssetWidgetBaseRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["assetsCount"] = this.assetsCount;
        return data;
    }
}

export interface IAssetWidgetBaseRecord {
    category?: string | undefined;
    assetsCount?: number;
}

export class AssetContractSearchQueryDto implements IAssetContractSearchQueryDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    showParentsOnly?: boolean | undefined;
    excludeSearchFilter?: boolean;
    searchFilter?: AssetContractsSearchFilterDto;
    limit?: number;
    scrollSearch?: boolean;

    constructor(data?: IAssetContractSearchQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountIdentifier = _data["accountIdentifier"];
            if (Array.isArray(_data["accountReferences"])) {
                this.accountReferences = [] as any;
                for (let item of _data["accountReferences"])
                    this.accountReferences!.push(item);
            }
            this.showParentsOnly = _data["showParentsOnly"];
            this.excludeSearchFilter = _data["excludeSearchFilter"];
            this.searchFilter = _data["searchFilter"] ? AssetContractsSearchFilterDto.fromJS(_data["searchFilter"]) : <any>undefined;
            this.limit = _data["limit"];
            this.scrollSearch = _data["scrollSearch"];
        }
    }

    static fromJS(data: any): AssetContractSearchQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetContractSearchQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountIdentifier"] = this.accountIdentifier;
        if (Array.isArray(this.accountReferences)) {
            data["accountReferences"] = [];
            for (let item of this.accountReferences)
                data["accountReferences"].push(item);
        }
        data["showParentsOnly"] = this.showParentsOnly;
        data["excludeSearchFilter"] = this.excludeSearchFilter;
        data["searchFilter"] = this.searchFilter ? this.searchFilter.toJSON() : <any>undefined;
        data["limit"] = this.limit;
        data["scrollSearch"] = this.scrollSearch;
        return data;
    }
}

export interface IAssetContractSearchQueryDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    showParentsOnly?: boolean | undefined;
    excludeSearchFilter?: boolean;
    searchFilter?: AssetContractsSearchFilterDto;
    limit?: number;
    scrollSearch?: boolean;
}

export class AssetEndUserDevicesResponse implements IAssetEndUserDevicesResponse {
    devices?: Asset[] | undefined;
    summaryData?: AssetEndUserDevicesSummary;

    constructor(data?: IAssetEndUserDevicesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["devices"])) {
                this.devices = [] as any;
                for (let item of _data["devices"])
                    this.devices!.push(Asset.fromJS(item));
            }
            this.summaryData = _data["summaryData"] ? AssetEndUserDevicesSummary.fromJS(_data["summaryData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AssetEndUserDevicesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AssetEndUserDevicesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.devices)) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item.toJSON());
        }
        data["summaryData"] = this.summaryData ? this.summaryData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAssetEndUserDevicesResponse {
    devices?: Asset[] | undefined;
    summaryData?: AssetEndUserDevicesSummary;
}

export class AssetLifecycleSummaryDto implements IAssetLifecycleSummaryDto {
    quarterlyExpiration?: AssetQuarterlyExpirationFilterDto[] | undefined;
    totalParentRows?: number;

    constructor(data?: IAssetLifecycleSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["quarterlyExpiration"])) {
                this.quarterlyExpiration = [] as any;
                for (let item of _data["quarterlyExpiration"])
                    this.quarterlyExpiration!.push(AssetQuarterlyExpirationFilterDto.fromJS(item));
            }
            this.totalParentRows = _data["totalParentRows"];
        }
    }

    static fromJS(data: any): AssetLifecycleSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetLifecycleSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.quarterlyExpiration)) {
            data["quarterlyExpiration"] = [];
            for (let item of this.quarterlyExpiration)
                data["quarterlyExpiration"].push(item.toJSON());
        }
        data["totalParentRows"] = this.totalParentRows;
        return data;
    }
}

export interface IAssetLifecycleSummaryDto {
    quarterlyExpiration?: AssetQuarterlyExpirationFilterDto[] | undefined;
    totalParentRows?: number;
}

export class AssetLocationDto implements IAssetLocationDto {
    locationId?: string | undefined;
    locationName?: string | undefined;
    userLocationName?: string | undefined;
    readonly displayLocationName?: string | undefined;
    locationAddress?: string | undefined;
    locationCity?: string | undefined;
    locationState?: string | undefined;
    locationCountry?: string | undefined;
    manufacturer?: string | undefined;
    assetsCount?: number;
    isStockroom?: boolean;

    constructor(data?: IAssetLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.locationName = _data["locationName"];
            this.userLocationName = _data["userLocationName"];
            (<any>this).displayLocationName = _data["displayLocationName"];
            this.locationAddress = _data["locationAddress"];
            this.locationCity = _data["locationCity"];
            this.locationState = _data["locationState"];
            this.locationCountry = _data["locationCountry"];
            this.manufacturer = _data["manufacturer"];
            this.assetsCount = _data["assetsCount"];
            this.isStockroom = _data["isStockroom"];
        }
    }

    static fromJS(data: any): AssetLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["locationName"] = this.locationName;
        data["userLocationName"] = this.userLocationName;
        data["displayLocationName"] = this.displayLocationName;
        data["locationAddress"] = this.locationAddress;
        data["locationCity"] = this.locationCity;
        data["locationState"] = this.locationState;
        data["locationCountry"] = this.locationCountry;
        data["manufacturer"] = this.manufacturer;
        data["assetsCount"] = this.assetsCount;
        data["isStockroom"] = this.isStockroom;
        return data;
    }
}

export interface IAssetLocationDto {
    locationId?: string | undefined;
    locationName?: string | undefined;
    userLocationName?: string | undefined;
    displayLocationName?: string | undefined;
    locationAddress?: string | undefined;
    locationCity?: string | undefined;
    locationState?: string | undefined;
    locationCountry?: string | undefined;
    manufacturer?: string | undefined;
    assetsCount?: number;
    isStockroom?: boolean;
}

export class AssetManagementSearchQueryDto implements IAssetManagementSearchQueryDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    limit?: number | undefined;
    offset?: number | undefined;
    showParentsOnly?: boolean | undefined;
    excludeSearchFilter?: boolean;
    assetType?: ShiOneAssetType;
    sortCriteria?: ElasticSortCriteria;
    searchFilter?: AssetInventorySearchFilterDto | undefined;
    scrollSearch?: boolean;

    constructor(data?: IAssetManagementSearchQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountIdentifier = _data["accountIdentifier"];
            if (Array.isArray(_data["accountReferences"])) {
                this.accountReferences = [] as any;
                for (let item of _data["accountReferences"])
                    this.accountReferences!.push(item);
            }
            this.limit = _data["limit"];
            this.offset = _data["offset"];
            this.showParentsOnly = _data["showParentsOnly"];
            this.excludeSearchFilter = _data["excludeSearchFilter"];
            this.assetType = _data["assetType"];
            this.sortCriteria = _data["sortCriteria"] ? ElasticSortCriteria.fromJS(_data["sortCriteria"]) : <any>undefined;
            this.searchFilter = _data["searchFilter"] ? AssetInventorySearchFilterDto.fromJS(_data["searchFilter"]) : <any>undefined;
            this.scrollSearch = _data["scrollSearch"];
        }
    }

    static fromJS(data: any): AssetManagementSearchQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetManagementSearchQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountIdentifier"] = this.accountIdentifier;
        if (Array.isArray(this.accountReferences)) {
            data["accountReferences"] = [];
            for (let item of this.accountReferences)
                data["accountReferences"].push(item);
        }
        data["limit"] = this.limit;
        data["offset"] = this.offset;
        data["showParentsOnly"] = this.showParentsOnly;
        data["excludeSearchFilter"] = this.excludeSearchFilter;
        data["assetType"] = this.assetType;
        data["sortCriteria"] = this.sortCriteria ? this.sortCriteria.toJSON() : <any>undefined;
        data["searchFilter"] = this.searchFilter ? this.searchFilter.toJSON() : <any>undefined;
        data["scrollSearch"] = this.scrollSearch;
        return data;
    }
}

export interface IAssetManagementSearchQueryDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    limit?: number | undefined;
    offset?: number | undefined;
    showParentsOnly?: boolean | undefined;
    excludeSearchFilter?: boolean;
    assetType?: ShiOneAssetType;
    sortCriteria?: ElasticSortCriteria;
    searchFilter?: AssetInventorySearchFilterDto | undefined;
    scrollSearch?: boolean;
}

export class AssetProductCatalogDto implements IAssetProductCatalogDto {
    product?: string | undefined;
    id?: string | undefined;
    productDescription?: string | undefined;
    manufacturer?: string | undefined;
    assetType?: string | undefined;
    shiCategory?: string | undefined;
    subCategory?: string | undefined;
    assetsCount?: number;
    locationsCount?: number | undefined;
    contractsCount?: number | undefined;
    listPrice?: number | undefined;
    minCoveredEndDate?: string | undefined;
    shiLifecycleState?: string | undefined;
    endOfLife?: string | undefined;
    endOfSaleDate?: string | undefined;
    endOfSoftwareMaintenanceDate?: string | undefined;
    lastDateOfSupport?: string | undefined;
    endOfSupport?: string | undefined;
    readonly descriptionString?: string | undefined;
    readonly manufacturerString?: string | undefined;
    readonly assetTypeString?: string | undefined;
    readonly categoryString?: string | undefined;

    constructor(data?: IAssetProductCatalogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product = _data["product"];
            this.id = _data["id"];
            this.productDescription = _data["productDescription"];
            this.manufacturer = _data["manufacturer"];
            this.assetType = _data["assetType"];
            this.shiCategory = _data["shiCategory"];
            this.subCategory = _data["subCategory"];
            this.assetsCount = _data["assetsCount"];
            this.locationsCount = _data["locationsCount"];
            this.contractsCount = _data["contractsCount"];
            this.listPrice = _data["listPrice"];
            this.minCoveredEndDate = _data["minCoveredEndDate"];
            this.shiLifecycleState = _data["shiLifecycleState"];
            this.endOfLife = _data["endOfLife"];
            this.endOfSaleDate = _data["endOfSaleDate"];
            this.endOfSoftwareMaintenanceDate = _data["endOfSoftwareMaintenanceDate"];
            this.lastDateOfSupport = _data["lastDateOfSupport"];
            this.endOfSupport = _data["endOfSupport"];
            (<any>this).descriptionString = _data["descriptionString"];
            (<any>this).manufacturerString = _data["manufacturerString"];
            (<any>this).assetTypeString = _data["assetTypeString"];
            (<any>this).categoryString = _data["categoryString"];
        }
    }

    static fromJS(data: any): AssetProductCatalogDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetProductCatalogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product;
        data["id"] = this.id;
        data["productDescription"] = this.productDescription;
        data["manufacturer"] = this.manufacturer;
        data["assetType"] = this.assetType;
        data["shiCategory"] = this.shiCategory;
        data["subCategory"] = this.subCategory;
        data["assetsCount"] = this.assetsCount;
        data["locationsCount"] = this.locationsCount;
        data["contractsCount"] = this.contractsCount;
        data["listPrice"] = this.listPrice;
        data["minCoveredEndDate"] = this.minCoveredEndDate;
        data["shiLifecycleState"] = this.shiLifecycleState;
        data["endOfLife"] = this.endOfLife;
        data["endOfSaleDate"] = this.endOfSaleDate;
        data["endOfSoftwareMaintenanceDate"] = this.endOfSoftwareMaintenanceDate;
        data["lastDateOfSupport"] = this.lastDateOfSupport;
        data["endOfSupport"] = this.endOfSupport;
        data["descriptionString"] = this.descriptionString;
        data["manufacturerString"] = this.manufacturerString;
        data["assetTypeString"] = this.assetTypeString;
        data["categoryString"] = this.categoryString;
        return data;
    }
}

export interface IAssetProductCatalogDto {
    product?: string | undefined;
    id?: string | undefined;
    productDescription?: string | undefined;
    manufacturer?: string | undefined;
    assetType?: string | undefined;
    shiCategory?: string | undefined;
    subCategory?: string | undefined;
    assetsCount?: number;
    locationsCount?: number | undefined;
    contractsCount?: number | undefined;
    listPrice?: number | undefined;
    minCoveredEndDate?: string | undefined;
    shiLifecycleState?: string | undefined;
    endOfLife?: string | undefined;
    endOfSaleDate?: string | undefined;
    endOfSoftwareMaintenanceDate?: string | undefined;
    lastDateOfSupport?: string | undefined;
    endOfSupport?: string | undefined;
    descriptionString?: string | undefined;
    manufacturerString?: string | undefined;
    assetTypeString?: string | undefined;
    categoryString?: string | undefined;
}

export class AssetContractsSearchFilterDto implements IAssetContractsSearchFilterDto {
    searchFor?: string | undefined;
    contractVendor?: string[] | undefined;
    contractId?: string[] | undefined;
    serviceLevelAgreement?: string[] | undefined;
    serviceLevelDescription?: string[] | undefined;
    coveredStatus?: string[] | undefined;
    managingPartner?: string[] | undefined;
    coveredStartDateStart?: Date | undefined;
    coveredStartDateEnd?: Date | undefined;
    coveredEndDateStart?: Date | undefined;
    coveredEndDateEnd?: Date | undefined;
    product?: string[] | undefined;

    constructor(data?: IAssetContractsSearchFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchFor = _data["searchFor"];
            if (Array.isArray(_data["contractVendor"])) {
                this.contractVendor = [] as any;
                for (let item of _data["contractVendor"])
                    this.contractVendor!.push(item);
            }
            if (Array.isArray(_data["contractId"])) {
                this.contractId = [] as any;
                for (let item of _data["contractId"])
                    this.contractId!.push(item);
            }
            if (Array.isArray(_data["serviceLevelAgreement"])) {
                this.serviceLevelAgreement = [] as any;
                for (let item of _data["serviceLevelAgreement"])
                    this.serviceLevelAgreement!.push(item);
            }
            if (Array.isArray(_data["serviceLevelDescription"])) {
                this.serviceLevelDescription = [] as any;
                for (let item of _data["serviceLevelDescription"])
                    this.serviceLevelDescription!.push(item);
            }
            if (Array.isArray(_data["coveredStatus"])) {
                this.coveredStatus = [] as any;
                for (let item of _data["coveredStatus"])
                    this.coveredStatus!.push(item);
            }
            if (Array.isArray(_data["managingPartner"])) {
                this.managingPartner = [] as any;
                for (let item of _data["managingPartner"])
                    this.managingPartner!.push(item);
            }
            this.coveredStartDateStart = _data["coveredStartDateStart"] ? new Date(_data["coveredStartDateStart"].toString()) : <any>undefined;
            this.coveredStartDateEnd = _data["coveredStartDateEnd"] ? new Date(_data["coveredStartDateEnd"].toString()) : <any>undefined;
            this.coveredEndDateStart = _data["coveredEndDateStart"] ? new Date(_data["coveredEndDateStart"].toString()) : <any>undefined;
            this.coveredEndDateEnd = _data["coveredEndDateEnd"] ? new Date(_data["coveredEndDateEnd"].toString()) : <any>undefined;
            if (Array.isArray(_data["product"])) {
                this.product = [] as any;
                for (let item of _data["product"])
                    this.product!.push(item);
            }
        }
    }

    static fromJS(data: any): AssetContractsSearchFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetContractsSearchFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchFor"] = this.searchFor;
        if (Array.isArray(this.contractVendor)) {
            data["contractVendor"] = [];
            for (let item of this.contractVendor)
                data["contractVendor"].push(item);
        }
        if (Array.isArray(this.contractId)) {
            data["contractId"] = [];
            for (let item of this.contractId)
                data["contractId"].push(item);
        }
        if (Array.isArray(this.serviceLevelAgreement)) {
            data["serviceLevelAgreement"] = [];
            for (let item of this.serviceLevelAgreement)
                data["serviceLevelAgreement"].push(item);
        }
        if (Array.isArray(this.serviceLevelDescription)) {
            data["serviceLevelDescription"] = [];
            for (let item of this.serviceLevelDescription)
                data["serviceLevelDescription"].push(item);
        }
        if (Array.isArray(this.coveredStatus)) {
            data["coveredStatus"] = [];
            for (let item of this.coveredStatus)
                data["coveredStatus"].push(item);
        }
        if (Array.isArray(this.managingPartner)) {
            data["managingPartner"] = [];
            for (let item of this.managingPartner)
                data["managingPartner"].push(item);
        }
        data["coveredStartDateStart"] = this.coveredStartDateStart ? this.coveredStartDateStart.toISOString() : <any>undefined;
        data["coveredStartDateEnd"] = this.coveredStartDateEnd ? this.coveredStartDateEnd.toISOString() : <any>undefined;
        data["coveredEndDateStart"] = this.coveredEndDateStart ? this.coveredEndDateStart.toISOString() : <any>undefined;
        data["coveredEndDateEnd"] = this.coveredEndDateEnd ? this.coveredEndDateEnd.toISOString() : <any>undefined;
        if (Array.isArray(this.product)) {
            data["product"] = [];
            for (let item of this.product)
                data["product"].push(item);
        }
        return data;
    }
}

export interface IAssetContractsSearchFilterDto {
    searchFor?: string | undefined;
    contractVendor?: string[] | undefined;
    contractId?: string[] | undefined;
    serviceLevelAgreement?: string[] | undefined;
    serviceLevelDescription?: string[] | undefined;
    coveredStatus?: string[] | undefined;
    managingPartner?: string[] | undefined;
    coveredStartDateStart?: Date | undefined;
    coveredStartDateEnd?: Date | undefined;
    coveredEndDateStart?: Date | undefined;
    coveredEndDateEnd?: Date | undefined;
    product?: string[] | undefined;
}

export class AssetLifecycleSearchFilterDto implements IAssetLifecycleSearchFilterDto {
    searchFor?: string | undefined;
    assetType?: string[] | undefined;
    displayName?: string[] | undefined;
    manufacturer?: string[] | undefined;
    managingPartner?: string[] | undefined;
    product?: string[] | undefined;
    shiCategory?: string[] | undefined;
    subCategory?: string[] | undefined;
    microCategory?: string[] | undefined;
    shiUseState?: string[] | undefined;
    shiLifecycleState?: string[] | undefined;
    contractId?: string[] | undefined;
    shiContractType?: string[] | undefined;
    coveredStatus?: string[] | undefined;
    contractVendor?: string[] | undefined;
    displayLocationName?: string[] | undefined;
    locationCity?: string[] | undefined;
    locationState?: string[] | undefined;
    locationCountry?: string[] | undefined;
    discoveredOnNet?: string[] | undefined;
    tags?: string[] | undefined;
    coveredStartDateStart?: Date | undefined;
    coveredStartDateEnd?: Date | undefined;
    coveredEndDateStart?: Date | undefined;
    coveredEndDateEnd?: Date | undefined;
    endOfSaleDateStart?: Date | undefined;
    endOfSaleDateEnd?: Date | undefined;
    endOfSoftwareMaintenanceDateStart?: Date | undefined;
    endOfSoftwareMaintenanceDateEnd?: Date | undefined;
    lastDateOfSupportStart?: Date | undefined;
    lastDateOfSupportEnd?: Date | undefined;
    shipDateStart?: Date | undefined;
    shipDateEnd?: Date | undefined;
    quarter?: number | undefined;
    year?: number | undefined;

    constructor(data?: IAssetLifecycleSearchFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchFor = _data["searchFor"];
            if (Array.isArray(_data["assetType"])) {
                this.assetType = [] as any;
                for (let item of _data["assetType"])
                    this.assetType!.push(item);
            }
            if (Array.isArray(_data["displayName"])) {
                this.displayName = [] as any;
                for (let item of _data["displayName"])
                    this.displayName!.push(item);
            }
            if (Array.isArray(_data["manufacturer"])) {
                this.manufacturer = [] as any;
                for (let item of _data["manufacturer"])
                    this.manufacturer!.push(item);
            }
            if (Array.isArray(_data["managingPartner"])) {
                this.managingPartner = [] as any;
                for (let item of _data["managingPartner"])
                    this.managingPartner!.push(item);
            }
            if (Array.isArray(_data["product"])) {
                this.product = [] as any;
                for (let item of _data["product"])
                    this.product!.push(item);
            }
            if (Array.isArray(_data["shiCategory"])) {
                this.shiCategory = [] as any;
                for (let item of _data["shiCategory"])
                    this.shiCategory!.push(item);
            }
            if (Array.isArray(_data["subCategory"])) {
                this.subCategory = [] as any;
                for (let item of _data["subCategory"])
                    this.subCategory!.push(item);
            }
            if (Array.isArray(_data["microCategory"])) {
                this.microCategory = [] as any;
                for (let item of _data["microCategory"])
                    this.microCategory!.push(item);
            }
            if (Array.isArray(_data["shiUseState"])) {
                this.shiUseState = [] as any;
                for (let item of _data["shiUseState"])
                    this.shiUseState!.push(item);
            }
            if (Array.isArray(_data["shiLifecycleState"])) {
                this.shiLifecycleState = [] as any;
                for (let item of _data["shiLifecycleState"])
                    this.shiLifecycleState!.push(item);
            }
            if (Array.isArray(_data["contractId"])) {
                this.contractId = [] as any;
                for (let item of _data["contractId"])
                    this.contractId!.push(item);
            }
            if (Array.isArray(_data["shiContractType"])) {
                this.shiContractType = [] as any;
                for (let item of _data["shiContractType"])
                    this.shiContractType!.push(item);
            }
            if (Array.isArray(_data["coveredStatus"])) {
                this.coveredStatus = [] as any;
                for (let item of _data["coveredStatus"])
                    this.coveredStatus!.push(item);
            }
            if (Array.isArray(_data["contractVendor"])) {
                this.contractVendor = [] as any;
                for (let item of _data["contractVendor"])
                    this.contractVendor!.push(item);
            }
            if (Array.isArray(_data["displayLocationName"])) {
                this.displayLocationName = [] as any;
                for (let item of _data["displayLocationName"])
                    this.displayLocationName!.push(item);
            }
            if (Array.isArray(_data["locationCity"])) {
                this.locationCity = [] as any;
                for (let item of _data["locationCity"])
                    this.locationCity!.push(item);
            }
            if (Array.isArray(_data["locationState"])) {
                this.locationState = [] as any;
                for (let item of _data["locationState"])
                    this.locationState!.push(item);
            }
            if (Array.isArray(_data["locationCountry"])) {
                this.locationCountry = [] as any;
                for (let item of _data["locationCountry"])
                    this.locationCountry!.push(item);
            }
            if (Array.isArray(_data["discoveredOnNet"])) {
                this.discoveredOnNet = [] as any;
                for (let item of _data["discoveredOnNet"])
                    this.discoveredOnNet!.push(item);
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.coveredStartDateStart = _data["coveredStartDateStart"] ? new Date(_data["coveredStartDateStart"].toString()) : <any>undefined;
            this.coveredStartDateEnd = _data["coveredStartDateEnd"] ? new Date(_data["coveredStartDateEnd"].toString()) : <any>undefined;
            this.coveredEndDateStart = _data["coveredEndDateStart"] ? new Date(_data["coveredEndDateStart"].toString()) : <any>undefined;
            this.coveredEndDateEnd = _data["coveredEndDateEnd"] ? new Date(_data["coveredEndDateEnd"].toString()) : <any>undefined;
            this.endOfSaleDateStart = _data["endOfSaleDateStart"] ? new Date(_data["endOfSaleDateStart"].toString()) : <any>undefined;
            this.endOfSaleDateEnd = _data["endOfSaleDateEnd"] ? new Date(_data["endOfSaleDateEnd"].toString()) : <any>undefined;
            this.endOfSoftwareMaintenanceDateStart = _data["endOfSoftwareMaintenanceDateStart"] ? new Date(_data["endOfSoftwareMaintenanceDateStart"].toString()) : <any>undefined;
            this.endOfSoftwareMaintenanceDateEnd = _data["endOfSoftwareMaintenanceDateEnd"] ? new Date(_data["endOfSoftwareMaintenanceDateEnd"].toString()) : <any>undefined;
            this.lastDateOfSupportStart = _data["lastDateOfSupportStart"] ? new Date(_data["lastDateOfSupportStart"].toString()) : <any>undefined;
            this.lastDateOfSupportEnd = _data["lastDateOfSupportEnd"] ? new Date(_data["lastDateOfSupportEnd"].toString()) : <any>undefined;
            this.shipDateStart = _data["shipDateStart"] ? new Date(_data["shipDateStart"].toString()) : <any>undefined;
            this.shipDateEnd = _data["shipDateEnd"] ? new Date(_data["shipDateEnd"].toString()) : <any>undefined;
            this.quarter = _data["quarter"];
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): AssetLifecycleSearchFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetLifecycleSearchFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchFor"] = this.searchFor;
        if (Array.isArray(this.assetType)) {
            data["assetType"] = [];
            for (let item of this.assetType)
                data["assetType"].push(item);
        }
        if (Array.isArray(this.displayName)) {
            data["displayName"] = [];
            for (let item of this.displayName)
                data["displayName"].push(item);
        }
        if (Array.isArray(this.manufacturer)) {
            data["manufacturer"] = [];
            for (let item of this.manufacturer)
                data["manufacturer"].push(item);
        }
        if (Array.isArray(this.managingPartner)) {
            data["managingPartner"] = [];
            for (let item of this.managingPartner)
                data["managingPartner"].push(item);
        }
        if (Array.isArray(this.product)) {
            data["product"] = [];
            for (let item of this.product)
                data["product"].push(item);
        }
        if (Array.isArray(this.shiCategory)) {
            data["shiCategory"] = [];
            for (let item of this.shiCategory)
                data["shiCategory"].push(item);
        }
        if (Array.isArray(this.subCategory)) {
            data["subCategory"] = [];
            for (let item of this.subCategory)
                data["subCategory"].push(item);
        }
        if (Array.isArray(this.microCategory)) {
            data["microCategory"] = [];
            for (let item of this.microCategory)
                data["microCategory"].push(item);
        }
        if (Array.isArray(this.shiUseState)) {
            data["shiUseState"] = [];
            for (let item of this.shiUseState)
                data["shiUseState"].push(item);
        }
        if (Array.isArray(this.shiLifecycleState)) {
            data["shiLifecycleState"] = [];
            for (let item of this.shiLifecycleState)
                data["shiLifecycleState"].push(item);
        }
        if (Array.isArray(this.contractId)) {
            data["contractId"] = [];
            for (let item of this.contractId)
                data["contractId"].push(item);
        }
        if (Array.isArray(this.shiContractType)) {
            data["shiContractType"] = [];
            for (let item of this.shiContractType)
                data["shiContractType"].push(item);
        }
        if (Array.isArray(this.coveredStatus)) {
            data["coveredStatus"] = [];
            for (let item of this.coveredStatus)
                data["coveredStatus"].push(item);
        }
        if (Array.isArray(this.contractVendor)) {
            data["contractVendor"] = [];
            for (let item of this.contractVendor)
                data["contractVendor"].push(item);
        }
        if (Array.isArray(this.displayLocationName)) {
            data["displayLocationName"] = [];
            for (let item of this.displayLocationName)
                data["displayLocationName"].push(item);
        }
        if (Array.isArray(this.locationCity)) {
            data["locationCity"] = [];
            for (let item of this.locationCity)
                data["locationCity"].push(item);
        }
        if (Array.isArray(this.locationState)) {
            data["locationState"] = [];
            for (let item of this.locationState)
                data["locationState"].push(item);
        }
        if (Array.isArray(this.locationCountry)) {
            data["locationCountry"] = [];
            for (let item of this.locationCountry)
                data["locationCountry"].push(item);
        }
        if (Array.isArray(this.discoveredOnNet)) {
            data["discoveredOnNet"] = [];
            for (let item of this.discoveredOnNet)
                data["discoveredOnNet"].push(item);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["coveredStartDateStart"] = this.coveredStartDateStart ? this.coveredStartDateStart.toISOString() : <any>undefined;
        data["coveredStartDateEnd"] = this.coveredStartDateEnd ? this.coveredStartDateEnd.toISOString() : <any>undefined;
        data["coveredEndDateStart"] = this.coveredEndDateStart ? this.coveredEndDateStart.toISOString() : <any>undefined;
        data["coveredEndDateEnd"] = this.coveredEndDateEnd ? this.coveredEndDateEnd.toISOString() : <any>undefined;
        data["endOfSaleDateStart"] = this.endOfSaleDateStart ? this.endOfSaleDateStart.toISOString() : <any>undefined;
        data["endOfSaleDateEnd"] = this.endOfSaleDateEnd ? this.endOfSaleDateEnd.toISOString() : <any>undefined;
        data["endOfSoftwareMaintenanceDateStart"] = this.endOfSoftwareMaintenanceDateStart ? this.endOfSoftwareMaintenanceDateStart.toISOString() : <any>undefined;
        data["endOfSoftwareMaintenanceDateEnd"] = this.endOfSoftwareMaintenanceDateEnd ? this.endOfSoftwareMaintenanceDateEnd.toISOString() : <any>undefined;
        data["lastDateOfSupportStart"] = this.lastDateOfSupportStart ? this.lastDateOfSupportStart.toISOString() : <any>undefined;
        data["lastDateOfSupportEnd"] = this.lastDateOfSupportEnd ? this.lastDateOfSupportEnd.toISOString() : <any>undefined;
        data["shipDateStart"] = this.shipDateStart ? this.shipDateStart.toISOString() : <any>undefined;
        data["shipDateEnd"] = this.shipDateEnd ? this.shipDateEnd.toISOString() : <any>undefined;
        data["quarter"] = this.quarter;
        data["year"] = this.year;
        return data;
    }
}

export interface IAssetLifecycleSearchFilterDto {
    searchFor?: string | undefined;
    assetType?: string[] | undefined;
    displayName?: string[] | undefined;
    manufacturer?: string[] | undefined;
    managingPartner?: string[] | undefined;
    product?: string[] | undefined;
    shiCategory?: string[] | undefined;
    subCategory?: string[] | undefined;
    microCategory?: string[] | undefined;
    shiUseState?: string[] | undefined;
    shiLifecycleState?: string[] | undefined;
    contractId?: string[] | undefined;
    shiContractType?: string[] | undefined;
    coveredStatus?: string[] | undefined;
    contractVendor?: string[] | undefined;
    displayLocationName?: string[] | undefined;
    locationCity?: string[] | undefined;
    locationState?: string[] | undefined;
    locationCountry?: string[] | undefined;
    discoveredOnNet?: string[] | undefined;
    tags?: string[] | undefined;
    coveredStartDateStart?: Date | undefined;
    coveredStartDateEnd?: Date | undefined;
    coveredEndDateStart?: Date | undefined;
    coveredEndDateEnd?: Date | undefined;
    endOfSaleDateStart?: Date | undefined;
    endOfSaleDateEnd?: Date | undefined;
    endOfSoftwareMaintenanceDateStart?: Date | undefined;
    endOfSoftwareMaintenanceDateEnd?: Date | undefined;
    lastDateOfSupportStart?: Date | undefined;
    lastDateOfSupportEnd?: Date | undefined;
    shipDateStart?: Date | undefined;
    shipDateEnd?: Date | undefined;
    quarter?: number | undefined;
    year?: number | undefined;
}

export class AssetLocationsSearchFilterDto implements IAssetLocationsSearchFilterDto {
    searchFor?: string | undefined;
    displayLocationName?: string[] | undefined;
    locationAddress?: string[] | undefined;
    locationCity?: string[] | undefined;
    locationState?: string[] | undefined;
    locationCountry?: string[] | undefined;
    product?: string[] | undefined;
    manufacturer?: string[] | undefined;

    constructor(data?: IAssetLocationsSearchFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchFor = _data["searchFor"];
            if (Array.isArray(_data["displayLocationName"])) {
                this.displayLocationName = [] as any;
                for (let item of _data["displayLocationName"])
                    this.displayLocationName!.push(item);
            }
            if (Array.isArray(_data["locationAddress"])) {
                this.locationAddress = [] as any;
                for (let item of _data["locationAddress"])
                    this.locationAddress!.push(item);
            }
            if (Array.isArray(_data["locationCity"])) {
                this.locationCity = [] as any;
                for (let item of _data["locationCity"])
                    this.locationCity!.push(item);
            }
            if (Array.isArray(_data["locationState"])) {
                this.locationState = [] as any;
                for (let item of _data["locationState"])
                    this.locationState!.push(item);
            }
            if (Array.isArray(_data["locationCountry"])) {
                this.locationCountry = [] as any;
                for (let item of _data["locationCountry"])
                    this.locationCountry!.push(item);
            }
            if (Array.isArray(_data["product"])) {
                this.product = [] as any;
                for (let item of _data["product"])
                    this.product!.push(item);
            }
            if (Array.isArray(_data["manufacturer"])) {
                this.manufacturer = [] as any;
                for (let item of _data["manufacturer"])
                    this.manufacturer!.push(item);
            }
        }
    }

    static fromJS(data: any): AssetLocationsSearchFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetLocationsSearchFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchFor"] = this.searchFor;
        if (Array.isArray(this.displayLocationName)) {
            data["displayLocationName"] = [];
            for (let item of this.displayLocationName)
                data["displayLocationName"].push(item);
        }
        if (Array.isArray(this.locationAddress)) {
            data["locationAddress"] = [];
            for (let item of this.locationAddress)
                data["locationAddress"].push(item);
        }
        if (Array.isArray(this.locationCity)) {
            data["locationCity"] = [];
            for (let item of this.locationCity)
                data["locationCity"].push(item);
        }
        if (Array.isArray(this.locationState)) {
            data["locationState"] = [];
            for (let item of this.locationState)
                data["locationState"].push(item);
        }
        if (Array.isArray(this.locationCountry)) {
            data["locationCountry"] = [];
            for (let item of this.locationCountry)
                data["locationCountry"].push(item);
        }
        if (Array.isArray(this.product)) {
            data["product"] = [];
            for (let item of this.product)
                data["product"].push(item);
        }
        if (Array.isArray(this.manufacturer)) {
            data["manufacturer"] = [];
            for (let item of this.manufacturer)
                data["manufacturer"].push(item);
        }
        return data;
    }
}

export interface IAssetLocationsSearchFilterDto {
    searchFor?: string | undefined;
    displayLocationName?: string[] | undefined;
    locationAddress?: string[] | undefined;
    locationCity?: string[] | undefined;
    locationState?: string[] | undefined;
    locationCountry?: string[] | undefined;
    product?: string[] | undefined;
    manufacturer?: string[] | undefined;
}

export class AssetProductSearchFilterDto implements IAssetProductSearchFilterDto {
    searchFor?: string | undefined;
    assetType?: string[] | undefined;
    manufacturer?: string[] | undefined;
    shiCategory?: string[] | undefined;
    shiLifecycleState?: string[] | undefined;
    endOfSoftwareMaintenanceDateStart?: Date | undefined;
    endOfSoftwareMaintenanceDateEnd?: Date | undefined;
    lastDateOfSupportStart?: Date | undefined;
    lastDateOfSupportEnd?: Date | undefined;

    constructor(data?: IAssetProductSearchFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchFor = _data["searchFor"];
            if (Array.isArray(_data["assetType"])) {
                this.assetType = [] as any;
                for (let item of _data["assetType"])
                    this.assetType!.push(item);
            }
            if (Array.isArray(_data["manufacturer"])) {
                this.manufacturer = [] as any;
                for (let item of _data["manufacturer"])
                    this.manufacturer!.push(item);
            }
            if (Array.isArray(_data["shiCategory"])) {
                this.shiCategory = [] as any;
                for (let item of _data["shiCategory"])
                    this.shiCategory!.push(item);
            }
            if (Array.isArray(_data["shiLifecycleState"])) {
                this.shiLifecycleState = [] as any;
                for (let item of _data["shiLifecycleState"])
                    this.shiLifecycleState!.push(item);
            }
            this.endOfSoftwareMaintenanceDateStart = _data["endOfSoftwareMaintenanceDateStart"] ? new Date(_data["endOfSoftwareMaintenanceDateStart"].toString()) : <any>undefined;
            this.endOfSoftwareMaintenanceDateEnd = _data["endOfSoftwareMaintenanceDateEnd"] ? new Date(_data["endOfSoftwareMaintenanceDateEnd"].toString()) : <any>undefined;
            this.lastDateOfSupportStart = _data["lastDateOfSupportStart"] ? new Date(_data["lastDateOfSupportStart"].toString()) : <any>undefined;
            this.lastDateOfSupportEnd = _data["lastDateOfSupportEnd"] ? new Date(_data["lastDateOfSupportEnd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AssetProductSearchFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetProductSearchFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchFor"] = this.searchFor;
        if (Array.isArray(this.assetType)) {
            data["assetType"] = [];
            for (let item of this.assetType)
                data["assetType"].push(item);
        }
        if (Array.isArray(this.manufacturer)) {
            data["manufacturer"] = [];
            for (let item of this.manufacturer)
                data["manufacturer"].push(item);
        }
        if (Array.isArray(this.shiCategory)) {
            data["shiCategory"] = [];
            for (let item of this.shiCategory)
                data["shiCategory"].push(item);
        }
        if (Array.isArray(this.shiLifecycleState)) {
            data["shiLifecycleState"] = [];
            for (let item of this.shiLifecycleState)
                data["shiLifecycleState"].push(item);
        }
        data["endOfSoftwareMaintenanceDateStart"] = this.endOfSoftwareMaintenanceDateStart ? this.endOfSoftwareMaintenanceDateStart.toISOString() : <any>undefined;
        data["endOfSoftwareMaintenanceDateEnd"] = this.endOfSoftwareMaintenanceDateEnd ? this.endOfSoftwareMaintenanceDateEnd.toISOString() : <any>undefined;
        data["lastDateOfSupportStart"] = this.lastDateOfSupportStart ? this.lastDateOfSupportStart.toISOString() : <any>undefined;
        data["lastDateOfSupportEnd"] = this.lastDateOfSupportEnd ? this.lastDateOfSupportEnd.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAssetProductSearchFilterDto {
    searchFor?: string | undefined;
    assetType?: string[] | undefined;
    manufacturer?: string[] | undefined;
    shiCategory?: string[] | undefined;
    shiLifecycleState?: string[] | undefined;
    endOfSoftwareMaintenanceDateStart?: Date | undefined;
    endOfSoftwareMaintenanceDateEnd?: Date | undefined;
    lastDateOfSupportStart?: Date | undefined;
    lastDateOfSupportEnd?: Date | undefined;
}

export class AssetQuarterlyExpirationFilterDto implements IAssetQuarterlyExpirationFilterDto {
    endOfSale?: number;
    endOfSoftwareMaintenanceDate?: number;
    lastDateOfSupport?: number;
    total?: number;
    year?: number;
    quarter?: number;

    constructor(data?: IAssetQuarterlyExpirationFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.endOfSale = _data["endOfSale"];
            this.endOfSoftwareMaintenanceDate = _data["endOfSoftwareMaintenanceDate"];
            this.lastDateOfSupport = _data["lastDateOfSupport"];
            this.total = _data["total"];
            this.year = _data["year"];
            this.quarter = _data["quarter"];
        }
    }

    static fromJS(data: any): AssetQuarterlyExpirationFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetQuarterlyExpirationFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endOfSale"] = this.endOfSale;
        data["endOfSoftwareMaintenanceDate"] = this.endOfSoftwareMaintenanceDate;
        data["lastDateOfSupport"] = this.lastDateOfSupport;
        data["total"] = this.total;
        data["year"] = this.year;
        data["quarter"] = this.quarter;
        return data;
    }
}

export interface IAssetQuarterlyExpirationFilterDto {
    endOfSale?: number;
    endOfSoftwareMaintenanceDate?: number;
    lastDateOfSupport?: number;
    total?: number;
    year?: number;
    quarter?: number;
}

export enum ShiOneAssetType {
    All = "All",
    Meraki = "Meraki",
    Cisco = "Cisco",
    ManuallyManaged = "ManuallyManaged",
    CiscoEnterprise = "CiscoEnterprise",
    CiscoSubscription = "CiscoSubscription",
    DattoRmm = "DattoRmm",
    Iba = "Iba",
    Unknown = "Unknown",
}

export class AssetExpiringContractQuery implements IAssetExpiringContractQuery {
    accountIdentifier?: string | undefined;
    contractEndDate?: Date;

    constructor(data?: IAssetExpiringContractQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountIdentifier = _data["accountIdentifier"];
            this.contractEndDate = _data["contractEndDate"] ? new Date(_data["contractEndDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AssetExpiringContractQuery {
        data = typeof data === 'object' ? data : {};
        let result = new AssetExpiringContractQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountIdentifier"] = this.accountIdentifier;
        data["contractEndDate"] = this.contractEndDate ? this.contractEndDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAssetExpiringContractQuery {
    accountIdentifier?: string | undefined;
    contractEndDate?: Date;
}

export enum AssetWidgetType {
    Asset = "Asset",
    Product = "Product",
}

export enum FilterByCategory {
    ByType = "ByType",
    ByCategory = "ByCategory",
    ByLifecycleState = "ByLifecycleState",
    ByContractCoverage = "ByContractCoverage",
}

export class GetWarehouseAggregatedOrdersResponse implements IGetWarehouseAggregatedOrdersResponse {
    openTransfersOrders?: number;
    openIntegrationOrders?: number;
    openRackAndStackOrders?: number;
    rmaOrders?: number;

    constructor(data?: IGetWarehouseAggregatedOrdersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.openTransfersOrders = _data["openTransfersOrders"];
            this.openIntegrationOrders = _data["openIntegrationOrders"];
            this.openRackAndStackOrders = _data["openRackAndStackOrders"];
            this.rmaOrders = _data["rmaOrders"];
        }
    }

    static fromJS(data: any): GetWarehouseAggregatedOrdersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWarehouseAggregatedOrdersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["openTransfersOrders"] = this.openTransfersOrders;
        data["openIntegrationOrders"] = this.openIntegrationOrders;
        data["openRackAndStackOrders"] = this.openRackAndStackOrders;
        data["rmaOrders"] = this.rmaOrders;
        return data;
    }
}

export interface IGetWarehouseAggregatedOrdersResponse {
    openTransfersOrders?: number;
    openIntegrationOrders?: number;
    openRackAndStackOrders?: number;
    rmaOrders?: number;
}

export class GetWarehouseAggregatedStockResponse implements IGetWarehouseAggregatedStockResponse {
    incomingAssets?: number;
    transferringAssets?: number;
    assetsAvailableToTransfer?: number;
    productsAtLevelRisk?: number;
    projectOptions?: string[] | undefined;

    constructor(data?: IGetWarehouseAggregatedStockResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.incomingAssets = _data["incomingAssets"];
            this.transferringAssets = _data["transferringAssets"];
            this.assetsAvailableToTransfer = _data["assetsAvailableToTransfer"];
            this.productsAtLevelRisk = _data["productsAtLevelRisk"];
            if (Array.isArray(_data["projectOptions"])) {
                this.projectOptions = [] as any;
                for (let item of _data["projectOptions"])
                    this.projectOptions!.push(item);
            }
        }
    }

    static fromJS(data: any): GetWarehouseAggregatedStockResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWarehouseAggregatedStockResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incomingAssets"] = this.incomingAssets;
        data["transferringAssets"] = this.transferringAssets;
        data["assetsAvailableToTransfer"] = this.assetsAvailableToTransfer;
        data["productsAtLevelRisk"] = this.productsAtLevelRisk;
        if (Array.isArray(this.projectOptions)) {
            data["projectOptions"] = [];
            for (let item of this.projectOptions)
                data["projectOptions"].push(item);
        }
        return data;
    }
}

export interface IGetWarehouseAggregatedStockResponse {
    incomingAssets?: number;
    transferringAssets?: number;
    assetsAvailableToTransfer?: number;
    productsAtLevelRisk?: number;
    projectOptions?: string[] | undefined;
}

export class GetWarehouseOrdersResponse implements IGetWarehouseOrdersResponse {
    warehouseOrders?: CombinedWarehouseOrderItemDto[] | undefined;

    constructor(data?: IGetWarehouseOrdersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["warehouseOrders"])) {
                this.warehouseOrders = [] as any;
                for (let item of _data["warehouseOrders"])
                    this.warehouseOrders!.push(CombinedWarehouseOrderItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetWarehouseOrdersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWarehouseOrdersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.warehouseOrders)) {
            data["warehouseOrders"] = [];
            for (let item of this.warehouseOrders)
                data["warehouseOrders"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetWarehouseOrdersResponse {
    warehouseOrders?: CombinedWarehouseOrderItemDto[] | undefined;
}

export class GetWarehouseStockResponse implements IGetWarehouseStockResponse {
    warehouseStock?: WarehouseStockItemDto[] | undefined;

    constructor(data?: IGetWarehouseStockResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["warehouseStock"])) {
                this.warehouseStock = [] as any;
                for (let item of _data["warehouseStock"])
                    this.warehouseStock!.push(WarehouseStockItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetWarehouseStockResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWarehouseStockResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.warehouseStock)) {
            data["warehouseStock"] = [];
            for (let item of this.warehouseStock)
                data["warehouseStock"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetWarehouseStockResponse {
    warehouseStock?: WarehouseStockItemDto[] | undefined;
}

export class AxCustomerHlmOrderDto implements IAxCustomerHlmOrderDto {
    axCustAccount?: string | undefined;
    axCompany?: string | undefined;
    itemNumber?: string | undefined;
    serialNumber?: string | undefined;
    rmaNumber?: string | undefined;
    custRef?: string | undefined;
    hlmStatus?: string | undefined;
    readonly nextOrderStatus?: string | undefined;

    constructor(data?: IAxCustomerHlmOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.axCustAccount = _data["axCustAccount"];
            this.axCompany = _data["axCompany"];
            this.itemNumber = _data["itemNumber"];
            this.serialNumber = _data["serialNumber"];
            this.rmaNumber = _data["rmaNumber"];
            this.custRef = _data["custRef"];
            this.hlmStatus = _data["hlmStatus"];
            (<any>this).nextOrderStatus = _data["nextOrderStatus"];
        }
    }

    static fromJS(data: any): AxCustomerHlmOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new AxCustomerHlmOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axCustAccount"] = this.axCustAccount;
        data["axCompany"] = this.axCompany;
        data["itemNumber"] = this.itemNumber;
        data["serialNumber"] = this.serialNumber;
        data["rmaNumber"] = this.rmaNumber;
        data["custRef"] = this.custRef;
        data["hlmStatus"] = this.hlmStatus;
        data["nextOrderStatus"] = this.nextOrderStatus;
        return data;
    }
}

export interface IAxCustomerHlmOrderDto {
    axCustAccount?: string | undefined;
    axCompany?: string | undefined;
    itemNumber?: string | undefined;
    serialNumber?: string | undefined;
    rmaNumber?: string | undefined;
    custRef?: string | undefined;
    hlmStatus?: string | undefined;
    nextOrderStatus?: string | undefined;
}

export class CombinedWarehouseOrderItemDto implements ICombinedWarehouseOrderItemDto {
    id?: string | undefined;
    axNumber?: string | undefined;
    axTitle?: string | undefined;
    customerRef?: string | undefined;
    uniqueIdentifier?: string | undefined;
    salesId?: string | undefined;
    purchOrder?: string | undefined;
    invoiceId?: string | undefined;
    orderStatus?: string | undefined;
    expensePurpose?: string | undefined;
    readonly orderType?: string | undefined;
    assetTag?: string | undefined;
    serialNum?: string | undefined;
    lineNum?: number;
    itemId?: string | undefined;
    itemName?: string | undefined;
    mfgName?: string | undefined;
    mfgPart?: string | undefined;
    quantity?: number;
    orderItemQty?: number;
    qty?: number | undefined;
    qtyOrdered?: number | undefined;
    qtyOnOrderItem?: number | undefined;
    deliveryInfo?: Delivery[] | undefined;
    carrierName?: string | undefined;
    deliveryName?: string | undefined;
    deliveryContact?: string | undefined;
    deliveryMethod?: string | undefined;
    destination?: string | undefined;
    trackNum?: string | undefined;
    items?: WarehouseOrderItemGroupingDto[] | undefined;
    projectName?: string | undefined;
    solution?: string | undefined;
    projectDefinedField?: string | undefined;
    buildTeamIssues?: string | undefined;
    buildTeamNotes?: string | undefined;
    serverOEM?: string | undefined;
    engineeringNotes?: string | undefined;
    qcNotes?: string | undefined;
    projectCoordinator?: string | undefined;
    confirmedDate?: Date | undefined;
    shipDate?: Date | undefined;
    invoiceDate?: Date | undefined;
    nowFormula?: Date | undefined;
    opActual?: Date | undefined;
    scheduledDeliveryDate?: Date | undefined;
    targetDeliveryDate?: Date | undefined;
    lastModified?: Date;
    stagingStatus?: RackAndStackStatus;
    rackAndStackStatus?: RackAndStackStatus;
    powerCablingLabelingStatus?: RackAndStackStatus;
    networkCablingLabelingStatus?: RackAndStackStatus;
    assetTaggingStatus?: RackAndStackStatus;
    pTouchStatus?: RackAndStackStatus;
    qcHandoffStatus?: RackAndStackStatus;
    firstQcStatus?: RackAndStackStatus;
    onPowerStatus?: RackAndStackStatus;
    racksDefinedStatus?: RackAndStackStatus;
    serversDiscoveredStatus?: RackAndStackStatus;
    secondQcStatus?: RackAndStackStatus;
    summaryFilePostedStatus?: RackAndStackStatus;
    summaryFileCheckedStatus?: RackAndStackStatus;
    serverLogsClearedStatus?: RackAndStackStatus;
    switchLogsPostedStatus?: RackAndStackStatus;
    switchLogsCheckedStatus?: RackAndStackStatus;
    switchesFinalizedStatus?: RackAndStackStatus;
    photosTakenPostedStatus?: RackAndStackStatus;
    photosReviewedSentStatus?: RackAndStackStatus;
    customerApprovedStatus?: RackAndStackStatus;
    finalQcStatus?: RackAndStackStatus;
    cratingStatus?: RackAndStackStatus;
    nextOrderStatus?: string | undefined;

    constructor(data?: ICombinedWarehouseOrderItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.axNumber = _data["axNumber"];
            this.axTitle = _data["axTitle"];
            this.customerRef = _data["customerRef"];
            this.uniqueIdentifier = _data["uniqueIdentifier"];
            this.salesId = _data["salesId"];
            this.purchOrder = _data["purchOrder"];
            this.invoiceId = _data["invoiceId"];
            this.orderStatus = _data["orderStatus"];
            this.expensePurpose = _data["expensePurpose"];
            (<any>this).orderType = _data["orderType"];
            this.assetTag = _data["assetTag"];
            this.serialNum = _data["serialNum"];
            this.lineNum = _data["lineNum"];
            this.itemId = _data["itemId"];
            this.itemName = _data["itemName"];
            this.mfgName = _data["mfgName"];
            this.mfgPart = _data["mfgPart"];
            this.quantity = _data["quantity"];
            this.orderItemQty = _data["orderItemQty"];
            this.qty = _data["qty"];
            this.qtyOrdered = _data["qtyOrdered"];
            this.qtyOnOrderItem = _data["qtyOnOrderItem"];
            if (Array.isArray(_data["deliveryInfo"])) {
                this.deliveryInfo = [] as any;
                for (let item of _data["deliveryInfo"])
                    this.deliveryInfo!.push(Delivery.fromJS(item));
            }
            this.carrierName = _data["carrierName"];
            this.deliveryName = _data["deliveryName"];
            this.deliveryContact = _data["deliveryContact"];
            this.deliveryMethod = _data["deliveryMethod"];
            this.destination = _data["destination"];
            this.trackNum = _data["trackNum"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(WarehouseOrderItemGroupingDto.fromJS(item));
            }
            this.projectName = _data["projectName"];
            this.solution = _data["solution"];
            this.projectDefinedField = _data["projectDefinedField"];
            this.buildTeamIssues = _data["buildTeamIssues"];
            this.buildTeamNotes = _data["buildTeamNotes"];
            this.serverOEM = _data["serverOEM"];
            this.engineeringNotes = _data["engineeringNotes"];
            this.qcNotes = _data["qcNotes"];
            this.projectCoordinator = _data["projectCoordinator"];
            this.confirmedDate = _data["confirmedDate"] ? new Date(_data["confirmedDate"].toString()) : <any>undefined;
            this.shipDate = _data["shipDate"] ? new Date(_data["shipDate"].toString()) : <any>undefined;
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : <any>undefined;
            this.nowFormula = _data["nowFormula"] ? new Date(_data["nowFormula"].toString()) : <any>undefined;
            this.opActual = _data["opActual"] ? new Date(_data["opActual"].toString()) : <any>undefined;
            this.scheduledDeliveryDate = _data["scheduledDeliveryDate"] ? new Date(_data["scheduledDeliveryDate"].toString()) : <any>undefined;
            this.targetDeliveryDate = _data["targetDeliveryDate"] ? new Date(_data["targetDeliveryDate"].toString()) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.stagingStatus = _data["stagingStatus"];
            this.rackAndStackStatus = _data["rackAndStackStatus"];
            this.powerCablingLabelingStatus = _data["powerCablingLabelingStatus"];
            this.networkCablingLabelingStatus = _data["networkCablingLabelingStatus"];
            this.assetTaggingStatus = _data["assetTaggingStatus"];
            this.pTouchStatus = _data["pTouchStatus"];
            this.qcHandoffStatus = _data["qcHandoffStatus"];
            this.firstQcStatus = _data["firstQcStatus"];
            this.onPowerStatus = _data["onPowerStatus"];
            this.racksDefinedStatus = _data["racksDefinedStatus"];
            this.serversDiscoveredStatus = _data["serversDiscoveredStatus"];
            this.secondQcStatus = _data["secondQcStatus"];
            this.summaryFilePostedStatus = _data["summaryFilePostedStatus"];
            this.summaryFileCheckedStatus = _data["summaryFileCheckedStatus"];
            this.serverLogsClearedStatus = _data["serverLogsClearedStatus"];
            this.switchLogsPostedStatus = _data["switchLogsPostedStatus"];
            this.switchLogsCheckedStatus = _data["switchLogsCheckedStatus"];
            this.switchesFinalizedStatus = _data["switchesFinalizedStatus"];
            this.photosTakenPostedStatus = _data["photosTakenPostedStatus"];
            this.photosReviewedSentStatus = _data["photosReviewedSentStatus"];
            this.customerApprovedStatus = _data["customerApprovedStatus"];
            this.finalQcStatus = _data["finalQcStatus"];
            this.cratingStatus = _data["cratingStatus"];
            this.nextOrderStatus = _data["nextOrderStatus"];
        }
    }

    static fromJS(data: any): CombinedWarehouseOrderItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CombinedWarehouseOrderItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["axNumber"] = this.axNumber;
        data["axTitle"] = this.axTitle;
        data["customerRef"] = this.customerRef;
        data["uniqueIdentifier"] = this.uniqueIdentifier;
        data["salesId"] = this.salesId;
        data["purchOrder"] = this.purchOrder;
        data["invoiceId"] = this.invoiceId;
        data["orderStatus"] = this.orderStatus;
        data["expensePurpose"] = this.expensePurpose;
        data["orderType"] = this.orderType;
        data["assetTag"] = this.assetTag;
        data["serialNum"] = this.serialNum;
        data["lineNum"] = this.lineNum;
        data["itemId"] = this.itemId;
        data["itemName"] = this.itemName;
        data["mfgName"] = this.mfgName;
        data["mfgPart"] = this.mfgPart;
        data["quantity"] = this.quantity;
        data["orderItemQty"] = this.orderItemQty;
        data["qty"] = this.qty;
        data["qtyOrdered"] = this.qtyOrdered;
        data["qtyOnOrderItem"] = this.qtyOnOrderItem;
        if (Array.isArray(this.deliveryInfo)) {
            data["deliveryInfo"] = [];
            for (let item of this.deliveryInfo)
                data["deliveryInfo"].push(item.toJSON());
        }
        data["carrierName"] = this.carrierName;
        data["deliveryName"] = this.deliveryName;
        data["deliveryContact"] = this.deliveryContact;
        data["deliveryMethod"] = this.deliveryMethod;
        data["destination"] = this.destination;
        data["trackNum"] = this.trackNum;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["projectName"] = this.projectName;
        data["solution"] = this.solution;
        data["projectDefinedField"] = this.projectDefinedField;
        data["buildTeamIssues"] = this.buildTeamIssues;
        data["buildTeamNotes"] = this.buildTeamNotes;
        data["serverOEM"] = this.serverOEM;
        data["engineeringNotes"] = this.engineeringNotes;
        data["qcNotes"] = this.qcNotes;
        data["projectCoordinator"] = this.projectCoordinator;
        data["confirmedDate"] = this.confirmedDate ? this.confirmedDate.toISOString() : <any>undefined;
        data["shipDate"] = this.shipDate ? this.shipDate.toISOString() : <any>undefined;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : <any>undefined;
        data["nowFormula"] = this.nowFormula ? this.nowFormula.toISOString() : <any>undefined;
        data["opActual"] = this.opActual ? this.opActual.toISOString() : <any>undefined;
        data["scheduledDeliveryDate"] = this.scheduledDeliveryDate ? this.scheduledDeliveryDate.toISOString() : <any>undefined;
        data["targetDeliveryDate"] = this.targetDeliveryDate ? this.targetDeliveryDate.toISOString() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["stagingStatus"] = this.stagingStatus;
        data["rackAndStackStatus"] = this.rackAndStackStatus;
        data["powerCablingLabelingStatus"] = this.powerCablingLabelingStatus;
        data["networkCablingLabelingStatus"] = this.networkCablingLabelingStatus;
        data["assetTaggingStatus"] = this.assetTaggingStatus;
        data["pTouchStatus"] = this.pTouchStatus;
        data["qcHandoffStatus"] = this.qcHandoffStatus;
        data["firstQcStatus"] = this.firstQcStatus;
        data["onPowerStatus"] = this.onPowerStatus;
        data["racksDefinedStatus"] = this.racksDefinedStatus;
        data["serversDiscoveredStatus"] = this.serversDiscoveredStatus;
        data["secondQcStatus"] = this.secondQcStatus;
        data["summaryFilePostedStatus"] = this.summaryFilePostedStatus;
        data["summaryFileCheckedStatus"] = this.summaryFileCheckedStatus;
        data["serverLogsClearedStatus"] = this.serverLogsClearedStatus;
        data["switchLogsPostedStatus"] = this.switchLogsPostedStatus;
        data["switchLogsCheckedStatus"] = this.switchLogsCheckedStatus;
        data["switchesFinalizedStatus"] = this.switchesFinalizedStatus;
        data["photosTakenPostedStatus"] = this.photosTakenPostedStatus;
        data["photosReviewedSentStatus"] = this.photosReviewedSentStatus;
        data["customerApprovedStatus"] = this.customerApprovedStatus;
        data["finalQcStatus"] = this.finalQcStatus;
        data["cratingStatus"] = this.cratingStatus;
        data["nextOrderStatus"] = this.nextOrderStatus;
        return data;
    }
}

export interface ICombinedWarehouseOrderItemDto {
    id?: string | undefined;
    axNumber?: string | undefined;
    axTitle?: string | undefined;
    customerRef?: string | undefined;
    uniqueIdentifier?: string | undefined;
    salesId?: string | undefined;
    purchOrder?: string | undefined;
    invoiceId?: string | undefined;
    orderStatus?: string | undefined;
    expensePurpose?: string | undefined;
    orderType?: string | undefined;
    assetTag?: string | undefined;
    serialNum?: string | undefined;
    lineNum?: number;
    itemId?: string | undefined;
    itemName?: string | undefined;
    mfgName?: string | undefined;
    mfgPart?: string | undefined;
    quantity?: number;
    orderItemQty?: number;
    qty?: number | undefined;
    qtyOrdered?: number | undefined;
    qtyOnOrderItem?: number | undefined;
    deliveryInfo?: Delivery[] | undefined;
    carrierName?: string | undefined;
    deliveryName?: string | undefined;
    deliveryContact?: string | undefined;
    deliveryMethod?: string | undefined;
    destination?: string | undefined;
    trackNum?: string | undefined;
    items?: WarehouseOrderItemGroupingDto[] | undefined;
    projectName?: string | undefined;
    solution?: string | undefined;
    projectDefinedField?: string | undefined;
    buildTeamIssues?: string | undefined;
    buildTeamNotes?: string | undefined;
    serverOEM?: string | undefined;
    engineeringNotes?: string | undefined;
    qcNotes?: string | undefined;
    projectCoordinator?: string | undefined;
    confirmedDate?: Date | undefined;
    shipDate?: Date | undefined;
    invoiceDate?: Date | undefined;
    nowFormula?: Date | undefined;
    opActual?: Date | undefined;
    scheduledDeliveryDate?: Date | undefined;
    targetDeliveryDate?: Date | undefined;
    lastModified?: Date;
    stagingStatus?: RackAndStackStatus;
    rackAndStackStatus?: RackAndStackStatus;
    powerCablingLabelingStatus?: RackAndStackStatus;
    networkCablingLabelingStatus?: RackAndStackStatus;
    assetTaggingStatus?: RackAndStackStatus;
    pTouchStatus?: RackAndStackStatus;
    qcHandoffStatus?: RackAndStackStatus;
    firstQcStatus?: RackAndStackStatus;
    onPowerStatus?: RackAndStackStatus;
    racksDefinedStatus?: RackAndStackStatus;
    serversDiscoveredStatus?: RackAndStackStatus;
    secondQcStatus?: RackAndStackStatus;
    summaryFilePostedStatus?: RackAndStackStatus;
    summaryFileCheckedStatus?: RackAndStackStatus;
    serverLogsClearedStatus?: RackAndStackStatus;
    switchLogsPostedStatus?: RackAndStackStatus;
    switchLogsCheckedStatus?: RackAndStackStatus;
    switchesFinalizedStatus?: RackAndStackStatus;
    photosTakenPostedStatus?: RackAndStackStatus;
    photosReviewedSentStatus?: RackAndStackStatus;
    customerApprovedStatus?: RackAndStackStatus;
    finalQcStatus?: RackAndStackStatus;
    cratingStatus?: RackAndStackStatus;
    nextOrderStatus?: string | undefined;
}

export class CreateIdcsChangeRequestDto implements ICreateIdcsChangeRequestDto {
    requestorName?: string | undefined;
    requestorEmail?: string | undefined;
    projectName?: string | undefined;
    projectIdentifier?: string | undefined;
    changeType?: string | undefined;
    changeDescription?: string | undefined;
    attachments?: AirtableFileObject[] | undefined;

    constructor(data?: ICreateIdcsChangeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestorName = _data["requestorName"];
            this.requestorEmail = _data["requestorEmail"];
            this.projectName = _data["projectName"];
            this.projectIdentifier = _data["projectIdentifier"];
            this.changeType = _data["changeType"];
            this.changeDescription = _data["changeDescription"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AirtableFileObject.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateIdcsChangeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateIdcsChangeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestorName"] = this.requestorName;
        data["requestorEmail"] = this.requestorEmail;
        data["projectName"] = this.projectName;
        data["projectIdentifier"] = this.projectIdentifier;
        data["changeType"] = this.changeType;
        data["changeDescription"] = this.changeDescription;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateIdcsChangeRequestDto {
    requestorName?: string | undefined;
    requestorEmail?: string | undefined;
    projectName?: string | undefined;
    projectIdentifier?: string | undefined;
    changeType?: string | undefined;
    changeDescription?: string | undefined;
    attachments?: AirtableFileObject[] | undefined;
}

export class Delivery implements IDelivery {
    deliveryMethod?: string | undefined;
    trackNum?: string | undefined;
    trackUrl?: string | undefined;
    shipDate?: Date | undefined;

    constructor(data?: IDelivery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deliveryMethod = _data["deliveryMethod"];
            this.trackNum = _data["trackNum"];
            this.trackUrl = _data["trackUrl"];
            this.shipDate = _data["shipDate"] ? new Date(_data["shipDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Delivery {
        data = typeof data === 'object' ? data : {};
        let result = new Delivery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deliveryMethod"] = this.deliveryMethod;
        data["trackNum"] = this.trackNum;
        data["trackUrl"] = this.trackUrl;
        data["shipDate"] = this.shipDate ? this.shipDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDelivery {
    deliveryMethod?: string | undefined;
    trackNum?: string | undefined;
    trackUrl?: string | undefined;
    shipDate?: Date | undefined;
}

export enum RackAndStackStatus {
    NotStarted = "NotStarted",
    Assigned = "Assigned",
    Warning = "Warning",
    Success = "Success",
    Hidden = "Hidden",
}

export class WarehouseOrderItemDto implements IWarehouseOrderItemDto {
    uniquePrePickId?: string | undefined;
    salesId?: string | undefined;
    assetTag?: string | undefined;
    serialNum?: string | undefined;
    lineNum?: number;
    confirmedDate?: Date | undefined;
    itemId?: string | undefined;
    mfgPart?: string | undefined;
    variant?: string | undefined;
    itemName?: string | undefined;
    mfgName?: string | undefined;
    shipDate?: Date | undefined;
    invoiceId?: string | undefined;
    invoiceDate?: Date | undefined;
    deliveryInfo?: Delivery[] | undefined;
    deliveryName?: string | undefined;
    deliveryContact?: string | undefined;
    deliveryMethod?: string | undefined;
    deliveryAddress?: string | undefined;
    trackNum?: string | undefined;
    orderStatus?: string | undefined;
    orderItemIdentifier?: string | undefined;
    purchOrder?: string | undefined;
    expensePurpose?: string | undefined;
    quantity?: number;
    orderItemQty?: number;
    qty?: number | undefined;
    qtyOrdered?: number | undefined;
    qtyOnOrderItem?: number | undefined;
    carrierName?: string | undefined;
    axNumber?: string | undefined;
    axTitle?: string | undefined;
    customerRef?: string | undefined;
    items?: WarehouseOrderItemGroupingDto[] | undefined;

    constructor(data?: IWarehouseOrderItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniquePrePickId = _data["uniquePrePickId"];
            this.salesId = _data["salesId"];
            this.assetTag = _data["assetTag"];
            this.serialNum = _data["serialNum"];
            this.lineNum = _data["lineNum"];
            this.confirmedDate = _data["confirmedDate"] ? new Date(_data["confirmedDate"].toString()) : <any>undefined;
            this.itemId = _data["itemId"];
            this.mfgPart = _data["mfgPart"];
            this.variant = _data["variant"];
            this.itemName = _data["itemName"];
            this.mfgName = _data["mfgName"];
            this.shipDate = _data["shipDate"] ? new Date(_data["shipDate"].toString()) : <any>undefined;
            this.invoiceId = _data["invoiceId"];
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["deliveryInfo"])) {
                this.deliveryInfo = [] as any;
                for (let item of _data["deliveryInfo"])
                    this.deliveryInfo!.push(Delivery.fromJS(item));
            }
            this.deliveryName = _data["deliveryName"];
            this.deliveryContact = _data["deliveryContact"];
            this.deliveryMethod = _data["deliveryMethod"];
            this.deliveryAddress = _data["deliveryAddress"];
            this.trackNum = _data["trackNum"];
            this.orderStatus = _data["orderStatus"];
            this.orderItemIdentifier = _data["orderItemIdentifier"];
            this.purchOrder = _data["purchOrder"];
            this.expensePurpose = _data["expensePurpose"];
            this.quantity = _data["quantity"];
            this.orderItemQty = _data["orderItemQty"];
            this.qty = _data["qty"];
            this.qtyOrdered = _data["qtyOrdered"];
            this.qtyOnOrderItem = _data["qtyOnOrderItem"];
            this.carrierName = _data["carrierName"];
            this.axNumber = _data["axNumber"];
            this.axTitle = _data["axTitle"];
            this.customerRef = _data["customerRef"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(WarehouseOrderItemGroupingDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WarehouseOrderItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseOrderItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniquePrePickId"] = this.uniquePrePickId;
        data["salesId"] = this.salesId;
        data["assetTag"] = this.assetTag;
        data["serialNum"] = this.serialNum;
        data["lineNum"] = this.lineNum;
        data["confirmedDate"] = this.confirmedDate ? this.confirmedDate.toISOString() : <any>undefined;
        data["itemId"] = this.itemId;
        data["mfgPart"] = this.mfgPart;
        data["variant"] = this.variant;
        data["itemName"] = this.itemName;
        data["mfgName"] = this.mfgName;
        data["shipDate"] = this.shipDate ? this.shipDate.toISOString() : <any>undefined;
        data["invoiceId"] = this.invoiceId;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : <any>undefined;
        if (Array.isArray(this.deliveryInfo)) {
            data["deliveryInfo"] = [];
            for (let item of this.deliveryInfo)
                data["deliveryInfo"].push(item.toJSON());
        }
        data["deliveryName"] = this.deliveryName;
        data["deliveryContact"] = this.deliveryContact;
        data["deliveryMethod"] = this.deliveryMethod;
        data["deliveryAddress"] = this.deliveryAddress;
        data["trackNum"] = this.trackNum;
        data["orderStatus"] = this.orderStatus;
        data["orderItemIdentifier"] = this.orderItemIdentifier;
        data["purchOrder"] = this.purchOrder;
        data["expensePurpose"] = this.expensePurpose;
        data["quantity"] = this.quantity;
        data["orderItemQty"] = this.orderItemQty;
        data["qty"] = this.qty;
        data["qtyOrdered"] = this.qtyOrdered;
        data["qtyOnOrderItem"] = this.qtyOnOrderItem;
        data["carrierName"] = this.carrierName;
        data["axNumber"] = this.axNumber;
        data["axTitle"] = this.axTitle;
        data["customerRef"] = this.customerRef;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWarehouseOrderItemDto {
    uniquePrePickId?: string | undefined;
    salesId?: string | undefined;
    assetTag?: string | undefined;
    serialNum?: string | undefined;
    lineNum?: number;
    confirmedDate?: Date | undefined;
    itemId?: string | undefined;
    mfgPart?: string | undefined;
    variant?: string | undefined;
    itemName?: string | undefined;
    mfgName?: string | undefined;
    shipDate?: Date | undefined;
    invoiceId?: string | undefined;
    invoiceDate?: Date | undefined;
    deliveryInfo?: Delivery[] | undefined;
    deliveryName?: string | undefined;
    deliveryContact?: string | undefined;
    deliveryMethod?: string | undefined;
    deliveryAddress?: string | undefined;
    trackNum?: string | undefined;
    orderStatus?: string | undefined;
    orderItemIdentifier?: string | undefined;
    purchOrder?: string | undefined;
    expensePurpose?: string | undefined;
    quantity?: number;
    orderItemQty?: number;
    qty?: number | undefined;
    qtyOrdered?: number | undefined;
    qtyOnOrderItem?: number | undefined;
    carrierName?: string | undefined;
    axNumber?: string | undefined;
    axTitle?: string | undefined;
    customerRef?: string | undefined;
    items?: WarehouseOrderItemGroupingDto[] | undefined;
}

export class WarehouseOrderItemGroupingDto implements IWarehouseOrderItemGroupingDto {
    salesId?: string | undefined;
    confirmedDate?: Date | undefined;
    itemId?: string | undefined;
    itemName?: string | undefined;
    shipDate?: Date | undefined;
    deliveryName?: string | undefined;
    deliveryContact?: string | undefined;
    deliveryMethod?: string | undefined;
    deliveryAddress?: string | undefined;
    carrierName?: string | undefined;
    trackNum?: string | undefined;
    orderStatus?: string | undefined;
    orderItemIdentifier?: string | undefined;
    purchOrder?: string | undefined;
    expensePurpose?: string | undefined;
    qty?: number;
    qtyOrdered?: number | undefined;
    variant?: string | undefined;
    axNumber?: string | undefined;
    axTitle?: string | undefined;
    customerRef?: string | undefined;
    readonly items?: WarehouseOrderItemDto[] | undefined;

    constructor(data?: IWarehouseOrderItemGroupingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.salesId = _data["salesId"];
            this.confirmedDate = _data["confirmedDate"] ? new Date(_data["confirmedDate"].toString()) : <any>undefined;
            this.itemId = _data["itemId"];
            this.itemName = _data["itemName"];
            this.shipDate = _data["shipDate"] ? new Date(_data["shipDate"].toString()) : <any>undefined;
            this.deliveryName = _data["deliveryName"];
            this.deliveryContact = _data["deliveryContact"];
            this.deliveryMethod = _data["deliveryMethod"];
            this.deliveryAddress = _data["deliveryAddress"];
            this.carrierName = _data["carrierName"];
            this.trackNum = _data["trackNum"];
            this.orderStatus = _data["orderStatus"];
            this.orderItemIdentifier = _data["orderItemIdentifier"];
            this.purchOrder = _data["purchOrder"];
            this.expensePurpose = _data["expensePurpose"];
            this.qty = _data["qty"];
            this.qtyOrdered = _data["qtyOrdered"];
            this.variant = _data["variant"];
            this.axNumber = _data["axNumber"];
            this.axTitle = _data["axTitle"];
            this.customerRef = _data["customerRef"];
            if (Array.isArray(_data["items"])) {
                (<any>this).items = [] as any;
                for (let item of _data["items"])
                    (<any>this).items!.push(WarehouseOrderItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WarehouseOrderItemGroupingDto {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseOrderItemGroupingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesId"] = this.salesId;
        data["confirmedDate"] = this.confirmedDate ? this.confirmedDate.toISOString() : <any>undefined;
        data["itemId"] = this.itemId;
        data["itemName"] = this.itemName;
        data["shipDate"] = this.shipDate ? this.shipDate.toISOString() : <any>undefined;
        data["deliveryName"] = this.deliveryName;
        data["deliveryContact"] = this.deliveryContact;
        data["deliveryMethod"] = this.deliveryMethod;
        data["deliveryAddress"] = this.deliveryAddress;
        data["carrierName"] = this.carrierName;
        data["trackNum"] = this.trackNum;
        data["orderStatus"] = this.orderStatus;
        data["orderItemIdentifier"] = this.orderItemIdentifier;
        data["purchOrder"] = this.purchOrder;
        data["expensePurpose"] = this.expensePurpose;
        data["qty"] = this.qty;
        data["qtyOrdered"] = this.qtyOrdered;
        data["variant"] = this.variant;
        data["axNumber"] = this.axNumber;
        data["axTitle"] = this.axTitle;
        data["customerRef"] = this.customerRef;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWarehouseOrderItemGroupingDto {
    salesId?: string | undefined;
    confirmedDate?: Date | undefined;
    itemId?: string | undefined;
    itemName?: string | undefined;
    shipDate?: Date | undefined;
    deliveryName?: string | undefined;
    deliveryContact?: string | undefined;
    deliveryMethod?: string | undefined;
    deliveryAddress?: string | undefined;
    carrierName?: string | undefined;
    trackNum?: string | undefined;
    orderStatus?: string | undefined;
    orderItemIdentifier?: string | undefined;
    purchOrder?: string | undefined;
    expensePurpose?: string | undefined;
    qty?: number;
    qtyOrdered?: number | undefined;
    variant?: string | undefined;
    axNumber?: string | undefined;
    axTitle?: string | undefined;
    customerRef?: string | undefined;
    items?: WarehouseOrderItemDto[] | undefined;
}

export class WarehouseStockItemDto implements IWarehouseStockItemDto {
    productName?: string | undefined;
    itemNumber?: string | undefined;
    variant?: string | undefined;
    productLine?: string | undefined;
    mfgPartNum?: string | undefined;
    warehouse?: string | undefined;
    warehouseDisplayName?: string | undefined;
    location?: string | undefined;
    batchNumber?: string | undefined;
    salesKey?: string | undefined;
    salesKeyOwner?: string | undefined;
    productCategory?: string | undefined;
    productCategoryDisplayName?: string | undefined;
    physInv?: number;
    pickedInv?: number;
    totalShi?: number;
    physRes?: number;
    ordered?: number;
    onOrder?: number;
    orderRes?: number;
    totalAvail?: number;
    total?: number;
    lastPOReceiptDate?: Date | undefined;
    invoiced30Days?: number;
    invoiced90Days?: number;
    invoiced180Days?: number;
    axNumber?: string | undefined;
    axTitle?: string | undefined;
    projectID?: string | undefined;
    isProject?: boolean;
    uniqueId?: string;

    constructor(data?: IWarehouseStockItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productName = _data["productName"];
            this.itemNumber = _data["itemNumber"];
            this.variant = _data["variant"];
            this.productLine = _data["productLine"];
            this.mfgPartNum = _data["mfgPartNum"];
            this.warehouse = _data["warehouse"];
            this.warehouseDisplayName = _data["warehouseDisplayName"];
            this.location = _data["location"];
            this.batchNumber = _data["batchNumber"];
            this.salesKey = _data["salesKey"];
            this.salesKeyOwner = _data["salesKeyOwner"];
            this.productCategory = _data["productCategory"];
            this.productCategoryDisplayName = _data["productCategoryDisplayName"];
            this.physInv = _data["physInv"];
            this.pickedInv = _data["pickedInv"];
            this.totalShi = _data["totalShi"];
            this.physRes = _data["physRes"];
            this.ordered = _data["ordered"];
            this.onOrder = _data["onOrder"];
            this.orderRes = _data["orderRes"];
            this.totalAvail = _data["totalAvail"];
            this.total = _data["total"];
            this.lastPOReceiptDate = _data["lastPOReceiptDate"] ? new Date(_data["lastPOReceiptDate"].toString()) : <any>undefined;
            this.invoiced30Days = _data["invoiced30Days"];
            this.invoiced90Days = _data["invoiced90Days"];
            this.invoiced180Days = _data["invoiced180Days"];
            this.axNumber = _data["axNumber"];
            this.axTitle = _data["axTitle"];
            this.projectID = _data["projectID"];
            this.isProject = _data["isProject"];
            this.uniqueId = _data["uniqueId"];
        }
    }

    static fromJS(data: any): WarehouseStockItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseStockItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productName"] = this.productName;
        data["itemNumber"] = this.itemNumber;
        data["variant"] = this.variant;
        data["productLine"] = this.productLine;
        data["mfgPartNum"] = this.mfgPartNum;
        data["warehouse"] = this.warehouse;
        data["warehouseDisplayName"] = this.warehouseDisplayName;
        data["location"] = this.location;
        data["batchNumber"] = this.batchNumber;
        data["salesKey"] = this.salesKey;
        data["salesKeyOwner"] = this.salesKeyOwner;
        data["productCategory"] = this.productCategory;
        data["productCategoryDisplayName"] = this.productCategoryDisplayName;
        data["physInv"] = this.physInv;
        data["pickedInv"] = this.pickedInv;
        data["totalShi"] = this.totalShi;
        data["physRes"] = this.physRes;
        data["ordered"] = this.ordered;
        data["onOrder"] = this.onOrder;
        data["orderRes"] = this.orderRes;
        data["totalAvail"] = this.totalAvail;
        data["total"] = this.total;
        data["lastPOReceiptDate"] = this.lastPOReceiptDate ? this.lastPOReceiptDate.toISOString() : <any>undefined;
        data["invoiced30Days"] = this.invoiced30Days;
        data["invoiced90Days"] = this.invoiced90Days;
        data["invoiced180Days"] = this.invoiced180Days;
        data["axNumber"] = this.axNumber;
        data["axTitle"] = this.axTitle;
        data["projectID"] = this.projectID;
        data["isProject"] = this.isProject;
        data["uniqueId"] = this.uniqueId;
        return data;
    }
}

export interface IWarehouseStockItemDto {
    productName?: string | undefined;
    itemNumber?: string | undefined;
    variant?: string | undefined;
    productLine?: string | undefined;
    mfgPartNum?: string | undefined;
    warehouse?: string | undefined;
    warehouseDisplayName?: string | undefined;
    location?: string | undefined;
    batchNumber?: string | undefined;
    salesKey?: string | undefined;
    salesKeyOwner?: string | undefined;
    productCategory?: string | undefined;
    productCategoryDisplayName?: string | undefined;
    physInv?: number;
    pickedInv?: number;
    totalShi?: number;
    physRes?: number;
    ordered?: number;
    onOrder?: number;
    orderRes?: number;
    totalAvail?: number;
    total?: number;
    lastPOReceiptDate?: Date | undefined;
    invoiced30Days?: number;
    invoiced90Days?: number;
    invoiced180Days?: number;
    axNumber?: string | undefined;
    axTitle?: string | undefined;
    projectID?: string | undefined;
    isProject?: boolean;
    uniqueId?: string;
}

export class ClaimDto implements IClaimDto {
    claimType?: string | undefined;
    claimValue?: string | undefined;

    constructor(data?: IClaimDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.claimType = _data["claimType"];
            this.claimValue = _data["claimValue"];
        }
    }

    static fromJS(data: any): ClaimDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        return data;
    }
}

export interface IClaimDto {
    claimType?: string | undefined;
    claimValue?: string | undefined;
}

export enum ActionTypes {
    Create = "Create",
    Update = "Update",
    Delete = "Delete",
    Deactivated = "Deactivated",
    Error = "Error",
}

export enum EntityTypes {
    TicketNotes = "TicketNotes",
    Tickets = "Tickets",
    Contact = "Contact",
    ConfigurationItems = "ConfigurationItems",
    Assets = "Assets",
    Companies = "Companies",
    Error = "Error",
    ServiceLevelAgreementResults = "ServiceLevelAgreementResults",
    SurveyResults = "SurveyResults",
    BillingItem = "BillingItem",
    TicketAttachments = "TicketAttachments",
    TicketNoteAttachments = "TicketNoteAttachments",
    TimeEntryAttachments = "TimeEntryAttachments",
}

export class AutoTaskWebhookDTO implements IAutoTaskWebhookDTO {
    action?: ActionTypes;
    guid?: string;
    entityType?: EntityTypes;
    id?: number;
    fields?: { [key: string]: string; } | undefined;
    eventTime?: Date;
    sequenceNumber?: number;
    personId?: number;
    eventSource?: string | undefined;

    constructor(data?: IAutoTaskWebhookDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"];
            this.guid = _data["guid"];
            this.entityType = _data["entityType"];
            this.id = _data["id"];
            if (_data["fields"]) {
                this.fields = {} as any;
                for (let key in _data["fields"]) {
                    if (_data["fields"].hasOwnProperty(key))
                        (<any>this.fields)![key] = _data["fields"][key];
                }
            }
            this.eventTime = _data["eventTime"] ? new Date(_data["eventTime"].toString()) : <any>undefined;
            this.sequenceNumber = _data["sequenceNumber"];
            this.personId = _data["personId"];
            this.eventSource = _data["eventSource"];
        }
    }

    static fromJS(data: any): AutoTaskWebhookDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AutoTaskWebhookDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action;
        data["guid"] = this.guid;
        data["entityType"] = this.entityType;
        data["id"] = this.id;
        if (this.fields) {
            data["fields"] = {};
            for (let key in this.fields) {
                if (this.fields.hasOwnProperty(key))
                    (<any>data["fields"])[key] = (<any>this.fields)[key];
            }
        }
        data["eventTime"] = this.eventTime ? this.eventTime.toISOString() : <any>undefined;
        data["sequenceNumber"] = this.sequenceNumber;
        data["personId"] = this.personId;
        data["eventSource"] = this.eventSource;
        return data;
    }
}

export interface IAutoTaskWebhookDTO {
    action?: ActionTypes;
    guid?: string;
    entityType?: EntityTypes;
    id?: number;
    fields?: { [key: string]: string; } | undefined;
    eventTime?: Date;
    sequenceNumber?: number;
    personId?: number;
    eventSource?: string | undefined;
}

export enum AutotaskEntityType {
    Account = "Account",
    AttachmentInfo = "AttachmentInfo",
    Contact = "Contact",
    Ticket = "Ticket",
    TicketNote = "TicketNote",
    Resource = "Resource",
    Contract = "Contract",
    Project = "Project",
    Product = "Product",
    ContractRetainer = "ContractRetainer",
    ContractService = "ContractService",
}

export class AutotaskPicklistEntity implements IAutotaskPicklistEntity {
    entityType?: AutotaskEntityType;
    fields?: AutotaskPicklistField[] | undefined;

    constructor(data?: IAutotaskPicklistEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityType = _data["entityType"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(AutotaskPicklistField.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AutotaskPicklistEntity {
        data = typeof data === 'object' ? data : {};
        let result = new AutotaskPicklistEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityType"] = this.entityType;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAutotaskPicklistEntity {
    entityType?: AutotaskEntityType;
    fields?: AutotaskPicklistField[] | undefined;
}

export class AutotaskPicklistField implements IAutotaskPicklistField {
    name?: string | undefined;
    label?: string | undefined;
    type?: string | undefined;
    length?: number;
    description?: string | undefined;
    isRequired?: boolean;
    isReadOnly?: boolean;
    isQueryable?: boolean;
    isReference?: boolean;
    isPickList?: boolean;
    pickListValues?: AutotaskPicklistValue[] | undefined;
    picklistParentValueField?: string | undefined;
    defaultValue?: string | undefined;
    isSupportedWebhookField?: boolean;

    constructor(data?: IAutotaskPicklistField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.label = _data["label"];
            this.type = _data["type"];
            this.length = _data["length"];
            this.description = _data["description"];
            this.isRequired = _data["isRequired"];
            this.isReadOnly = _data["isReadOnly"];
            this.isQueryable = _data["isQueryable"];
            this.isReference = _data["isReference"];
            this.isPickList = _data["isPickList"];
            if (Array.isArray(_data["pickListValues"])) {
                this.pickListValues = [] as any;
                for (let item of _data["pickListValues"])
                    this.pickListValues!.push(AutotaskPicklistValue.fromJS(item));
            }
            this.picklistParentValueField = _data["picklistParentValueField"];
            this.defaultValue = _data["defaultValue"];
            this.isSupportedWebhookField = _data["isSupportedWebhookField"];
        }
    }

    static fromJS(data: any): AutotaskPicklistField {
        data = typeof data === 'object' ? data : {};
        let result = new AutotaskPicklistField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["label"] = this.label;
        data["type"] = this.type;
        data["length"] = this.length;
        data["description"] = this.description;
        data["isRequired"] = this.isRequired;
        data["isReadOnly"] = this.isReadOnly;
        data["isQueryable"] = this.isQueryable;
        data["isReference"] = this.isReference;
        data["isPickList"] = this.isPickList;
        if (Array.isArray(this.pickListValues)) {
            data["pickListValues"] = [];
            for (let item of this.pickListValues)
                data["pickListValues"].push(item.toJSON());
        }
        data["picklistParentValueField"] = this.picklistParentValueField;
        data["defaultValue"] = this.defaultValue;
        data["isSupportedWebhookField"] = this.isSupportedWebhookField;
        return data;
    }
}

export interface IAutotaskPicklistField {
    name?: string | undefined;
    label?: string | undefined;
    type?: string | undefined;
    length?: number;
    description?: string | undefined;
    isRequired?: boolean;
    isReadOnly?: boolean;
    isQueryable?: boolean;
    isReference?: boolean;
    isPickList?: boolean;
    pickListValues?: AutotaskPicklistValue[] | undefined;
    picklistParentValueField?: string | undefined;
    defaultValue?: string | undefined;
    isSupportedWebhookField?: boolean;
}

export class AutotaskPicklistValue implements IAutotaskPicklistValue {
    value?: string | undefined;
    label?: string | undefined;
    isDefaultValue?: boolean;
    sortOrder?: number;
    parentValue?: string | undefined;
    isActive?: boolean;
    isActiveSpecified?: boolean;
    isSystem?: boolean;
    isSystemSpecified?: boolean;

    constructor(data?: IAutotaskPicklistValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.label = _data["label"];
            this.isDefaultValue = _data["isDefaultValue"];
            this.sortOrder = _data["sortOrder"];
            this.parentValue = _data["parentValue"];
            this.isActive = _data["isActive"];
            this.isActiveSpecified = _data["isActiveSpecified"];
            this.isSystem = _data["isSystem"];
            this.isSystemSpecified = _data["isSystemSpecified"];
        }
    }

    static fromJS(data: any): AutotaskPicklistValue {
        data = typeof data === 'object' ? data : {};
        let result = new AutotaskPicklistValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["label"] = this.label;
        data["isDefaultValue"] = this.isDefaultValue;
        data["sortOrder"] = this.sortOrder;
        data["parentValue"] = this.parentValue;
        data["isActive"] = this.isActive;
        data["isActiveSpecified"] = this.isActiveSpecified;
        data["isSystem"] = this.isSystem;
        data["isSystemSpecified"] = this.isSystemSpecified;
        return data;
    }
}

export interface IAutotaskPicklistValue {
    value?: string | undefined;
    label?: string | undefined;
    isDefaultValue?: boolean;
    sortOrder?: number;
    parentValue?: string | undefined;
    isActive?: boolean;
    isActiveSpecified?: boolean;
    isSystem?: boolean;
    isSystemSpecified?: boolean;
}

export class GetCurrentMonthCloudConsumptionResponse implements IGetCurrentMonthCloudConsumptionResponse {
    currentCost?: number | undefined;
    averageDailyCost?: number | undefined;
    projectedCost?: number | undefined;

    constructor(data?: IGetCurrentMonthCloudConsumptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentCost = _data["currentCost"];
            this.averageDailyCost = _data["averageDailyCost"];
            this.projectedCost = _data["projectedCost"];
        }
    }

    static fromJS(data: any): GetCurrentMonthCloudConsumptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentMonthCloudConsumptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentCost"] = this.currentCost;
        data["averageDailyCost"] = this.averageDailyCost;
        data["projectedCost"] = this.projectedCost;
        return data;
    }
}

export interface IGetCurrentMonthCloudConsumptionResponse {
    currentCost?: number | undefined;
    averageDailyCost?: number | undefined;
    projectedCost?: number | undefined;
}

export class CloudTagGroupCostSearchFilter implements ICloudTagGroupCostSearchFilter {
    cloudPlatform?: string[] | undefined;
    cloudAccountName?: string[] | undefined;
    region?: string[] | undefined;
    resourceType?: string[] | undefined;
    cloudResourceTags?: string[] | undefined;

    constructor(data?: ICloudTagGroupCostSearchFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cloudPlatform"])) {
                this.cloudPlatform = [] as any;
                for (let item of _data["cloudPlatform"])
                    this.cloudPlatform!.push(item);
            }
            if (Array.isArray(_data["cloudAccountName"])) {
                this.cloudAccountName = [] as any;
                for (let item of _data["cloudAccountName"])
                    this.cloudAccountName!.push(item);
            }
            if (Array.isArray(_data["region"])) {
                this.region = [] as any;
                for (let item of _data["region"])
                    this.region!.push(item);
            }
            if (Array.isArray(_data["resourceType"])) {
                this.resourceType = [] as any;
                for (let item of _data["resourceType"])
                    this.resourceType!.push(item);
            }
            if (Array.isArray(_data["cloudResourceTags"])) {
                this.cloudResourceTags = [] as any;
                for (let item of _data["cloudResourceTags"])
                    this.cloudResourceTags!.push(item);
            }
        }
    }

    static fromJS(data: any): CloudTagGroupCostSearchFilter {
        data = typeof data === 'object' ? data : {};
        let result = new CloudTagGroupCostSearchFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cloudPlatform)) {
            data["cloudPlatform"] = [];
            for (let item of this.cloudPlatform)
                data["cloudPlatform"].push(item);
        }
        if (Array.isArray(this.cloudAccountName)) {
            data["cloudAccountName"] = [];
            for (let item of this.cloudAccountName)
                data["cloudAccountName"].push(item);
        }
        if (Array.isArray(this.region)) {
            data["region"] = [];
            for (let item of this.region)
                data["region"].push(item);
        }
        if (Array.isArray(this.resourceType)) {
            data["resourceType"] = [];
            for (let item of this.resourceType)
                data["resourceType"].push(item);
        }
        if (Array.isArray(this.cloudResourceTags)) {
            data["cloudResourceTags"] = [];
            for (let item of this.cloudResourceTags)
                data["cloudResourceTags"].push(item);
        }
        return data;
    }
}

export interface ICloudTagGroupCostSearchFilter {
    cloudPlatform?: string[] | undefined;
    cloudAccountName?: string[] | undefined;
    region?: string[] | undefined;
    resourceType?: string[] | undefined;
    cloudResourceTags?: string[] | undefined;
}

export class CloudTagGroupResourcesSearchFilter implements ICloudTagGroupResourcesSearchFilter {
    searchFor?: string | undefined;
    cloudPlatform?: string[] | undefined;
    cloudAccountName?: string[] | undefined;
    region?: string[] | undefined;
    resourceType?: string[] | undefined;
    cloudResourceTags?: string[] | undefined;

    constructor(data?: ICloudTagGroupResourcesSearchFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchFor = _data["searchFor"];
            if (Array.isArray(_data["cloudPlatform"])) {
                this.cloudPlatform = [] as any;
                for (let item of _data["cloudPlatform"])
                    this.cloudPlatform!.push(item);
            }
            if (Array.isArray(_data["cloudAccountName"])) {
                this.cloudAccountName = [] as any;
                for (let item of _data["cloudAccountName"])
                    this.cloudAccountName!.push(item);
            }
            if (Array.isArray(_data["region"])) {
                this.region = [] as any;
                for (let item of _data["region"])
                    this.region!.push(item);
            }
            if (Array.isArray(_data["resourceType"])) {
                this.resourceType = [] as any;
                for (let item of _data["resourceType"])
                    this.resourceType!.push(item);
            }
            if (Array.isArray(_data["cloudResourceTags"])) {
                this.cloudResourceTags = [] as any;
                for (let item of _data["cloudResourceTags"])
                    this.cloudResourceTags!.push(item);
            }
        }
    }

    static fromJS(data: any): CloudTagGroupResourcesSearchFilter {
        data = typeof data === 'object' ? data : {};
        let result = new CloudTagGroupResourcesSearchFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchFor"] = this.searchFor;
        if (Array.isArray(this.cloudPlatform)) {
            data["cloudPlatform"] = [];
            for (let item of this.cloudPlatform)
                data["cloudPlatform"].push(item);
        }
        if (Array.isArray(this.cloudAccountName)) {
            data["cloudAccountName"] = [];
            for (let item of this.cloudAccountName)
                data["cloudAccountName"].push(item);
        }
        if (Array.isArray(this.region)) {
            data["region"] = [];
            for (let item of this.region)
                data["region"].push(item);
        }
        if (Array.isArray(this.resourceType)) {
            data["resourceType"] = [];
            for (let item of this.resourceType)
                data["resourceType"].push(item);
        }
        if (Array.isArray(this.cloudResourceTags)) {
            data["cloudResourceTags"] = [];
            for (let item of this.cloudResourceTags)
                data["cloudResourceTags"].push(item);
        }
        return data;
    }
}

export interface ICloudTagGroupResourcesSearchFilter {
    searchFor?: string | undefined;
    cloudPlatform?: string[] | undefined;
    cloudAccountName?: string[] | undefined;
    region?: string[] | undefined;
    resourceType?: string[] | undefined;
    cloudResourceTags?: string[] | undefined;
}

export class CreateUpdateCloudTagGroupRequest implements ICreateUpdateCloudTagGroupRequest {
    tagGroupId?: number | undefined;
    axAccountId?: number;
    tagGroupName?: string | undefined;
    tagGroupKey?: string | undefined;
    tagGroupTags?: TagGroupTagDto[] | undefined;

    constructor(data?: ICreateUpdateCloudTagGroupRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagGroupId = _data["tagGroupId"];
            this.axAccountId = _data["axAccountId"];
            this.tagGroupName = _data["tagGroupName"];
            this.tagGroupKey = _data["tagGroupKey"];
            if (Array.isArray(_data["tagGroupTags"])) {
                this.tagGroupTags = [] as any;
                for (let item of _data["tagGroupTags"])
                    this.tagGroupTags!.push(TagGroupTagDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateUpdateCloudTagGroupRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateCloudTagGroupRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagGroupId"] = this.tagGroupId;
        data["axAccountId"] = this.axAccountId;
        data["tagGroupName"] = this.tagGroupName;
        data["tagGroupKey"] = this.tagGroupKey;
        if (Array.isArray(this.tagGroupTags)) {
            data["tagGroupTags"] = [];
            for (let item of this.tagGroupTags)
                data["tagGroupTags"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateUpdateCloudTagGroupRequest {
    tagGroupId?: number | undefined;
    axAccountId?: number;
    tagGroupName?: string | undefined;
    tagGroupKey?: string | undefined;
    tagGroupTags?: TagGroupTagDto[] | undefined;
}

export class DeleteCloudTagGroupRequest implements IDeleteCloudTagGroupRequest {
    axAccountId?: number;
    tagGroupId?: number;

    constructor(data?: IDeleteCloudTagGroupRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.axAccountId = _data["axAccountId"];
            this.tagGroupId = _data["tagGroupId"];
        }
    }

    static fromJS(data: any): DeleteCloudTagGroupRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteCloudTagGroupRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccountId"] = this.axAccountId;
        data["tagGroupId"] = this.tagGroupId;
        return data;
    }
}

export interface IDeleteCloudTagGroupRequest {
    axAccountId?: number;
    tagGroupId?: number;
}

export class GetCloudTagGroupCostsRequest implements IGetCloudTagGroupCostsRequest {
    axAccountNumber?: string | undefined;
    tagGroupId?: number;
    tagGroupKey?: string | undefined;
    dateFilter?: TagGroupDateFilter;
    timeInterval?: TagGroupCostTimeInterval;
    searchFilter?: CloudTagGroupCostSearchFilter;
    showUnassigned?: boolean;

    constructor(data?: IGetCloudTagGroupCostsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.axAccountNumber = _data["axAccountNumber"];
            this.tagGroupId = _data["tagGroupId"];
            this.tagGroupKey = _data["tagGroupKey"];
            this.dateFilter = _data["dateFilter"] ? TagGroupDateFilter.fromJS(_data["dateFilter"]) : <any>undefined;
            this.timeInterval = _data["timeInterval"];
            this.searchFilter = _data["searchFilter"] ? CloudTagGroupCostSearchFilter.fromJS(_data["searchFilter"]) : <any>undefined;
            this.showUnassigned = _data["showUnassigned"];
        }
    }

    static fromJS(data: any): GetCloudTagGroupCostsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetCloudTagGroupCostsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccountNumber"] = this.axAccountNumber;
        data["tagGroupId"] = this.tagGroupId;
        data["tagGroupKey"] = this.tagGroupKey;
        data["dateFilter"] = this.dateFilter ? this.dateFilter.toJSON() : <any>undefined;
        data["timeInterval"] = this.timeInterval;
        data["searchFilter"] = this.searchFilter ? this.searchFilter.toJSON() : <any>undefined;
        data["showUnassigned"] = this.showUnassigned;
        return data;
    }
}

export interface IGetCloudTagGroupCostsRequest {
    axAccountNumber?: string | undefined;
    tagGroupId?: number;
    tagGroupKey?: string | undefined;
    dateFilter?: TagGroupDateFilter;
    timeInterval?: TagGroupCostTimeInterval;
    searchFilter?: CloudTagGroupCostSearchFilter;
    showUnassigned?: boolean;
}

export class GetCloudTagGroupResourcesRequest implements IGetCloudTagGroupResourcesRequest {
    axAccountNumber?: string | undefined;
    tagGroupId?: number;
    tagGroupKey?: string | undefined;
    limit?: number | undefined;
    offset?: number | undefined;
    excludeSearchFilter?: boolean;
    searchFilter?: CloudTagGroupResourcesSearchFilter;
    sortCriteria?: ElasticSortCriteria;
    dateFilter?: TagGroupDateFilter;

    constructor(data?: IGetCloudTagGroupResourcesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.axAccountNumber = _data["axAccountNumber"];
            this.tagGroupId = _data["tagGroupId"];
            this.tagGroupKey = _data["tagGroupKey"];
            this.limit = _data["limit"];
            this.offset = _data["offset"];
            this.excludeSearchFilter = _data["excludeSearchFilter"];
            this.searchFilter = _data["searchFilter"] ? CloudTagGroupResourcesSearchFilter.fromJS(_data["searchFilter"]) : <any>undefined;
            this.sortCriteria = _data["sortCriteria"] ? ElasticSortCriteria.fromJS(_data["sortCriteria"]) : <any>undefined;
            this.dateFilter = _data["dateFilter"] ? TagGroupDateFilter.fromJS(_data["dateFilter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCloudTagGroupResourcesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetCloudTagGroupResourcesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccountNumber"] = this.axAccountNumber;
        data["tagGroupId"] = this.tagGroupId;
        data["tagGroupKey"] = this.tagGroupKey;
        data["limit"] = this.limit;
        data["offset"] = this.offset;
        data["excludeSearchFilter"] = this.excludeSearchFilter;
        data["searchFilter"] = this.searchFilter ? this.searchFilter.toJSON() : <any>undefined;
        data["sortCriteria"] = this.sortCriteria ? this.sortCriteria.toJSON() : <any>undefined;
        data["dateFilter"] = this.dateFilter ? this.dateFilter.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCloudTagGroupResourcesRequest {
    axAccountNumber?: string | undefined;
    tagGroupId?: number;
    tagGroupKey?: string | undefined;
    limit?: number | undefined;
    offset?: number | undefined;
    excludeSearchFilter?: boolean;
    searchFilter?: CloudTagGroupResourcesSearchFilter;
    sortCriteria?: ElasticSortCriteria;
    dateFilter?: TagGroupDateFilter;
}

export class GetCloudTagGroupResourcesResponse implements IGetCloudTagGroupResourcesResponse {
    tagGroupId?: number | undefined;
    tagGroupDetails?: TagGroupDetails;
    tagGroupResources?: TagGroupResourceDto[] | undefined;
    resourcesRowCount?: number | undefined;

    constructor(data?: IGetCloudTagGroupResourcesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagGroupId = _data["tagGroupId"];
            this.tagGroupDetails = _data["tagGroupDetails"] ? TagGroupDetails.fromJS(_data["tagGroupDetails"]) : <any>undefined;
            if (Array.isArray(_data["tagGroupResources"])) {
                this.tagGroupResources = [] as any;
                for (let item of _data["tagGroupResources"])
                    this.tagGroupResources!.push(TagGroupResourceDto.fromJS(item));
            }
            this.resourcesRowCount = _data["resourcesRowCount"];
        }
    }

    static fromJS(data: any): GetCloudTagGroupResourcesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCloudTagGroupResourcesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagGroupId"] = this.tagGroupId;
        data["tagGroupDetails"] = this.tagGroupDetails ? this.tagGroupDetails.toJSON() : <any>undefined;
        if (Array.isArray(this.tagGroupResources)) {
            data["tagGroupResources"] = [];
            for (let item of this.tagGroupResources)
                data["tagGroupResources"].push(item.toJSON());
        }
        data["resourcesRowCount"] = this.resourcesRowCount;
        return data;
    }
}

export interface IGetCloudTagGroupResourcesResponse {
    tagGroupId?: number | undefined;
    tagGroupDetails?: TagGroupDetails;
    tagGroupResources?: TagGroupResourceDto[] | undefined;
    resourcesRowCount?: number | undefined;
}

export class GetCloudTagGroupsResponse implements IGetCloudTagGroupsResponse {
    axAccountId?: number;
    tagGroups?: TagGroupDto[] | undefined;

    constructor(data?: IGetCloudTagGroupsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.axAccountId = _data["axAccountId"];
            if (Array.isArray(_data["tagGroups"])) {
                this.tagGroups = [] as any;
                for (let item of _data["tagGroups"])
                    this.tagGroups!.push(TagGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCloudTagGroupsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCloudTagGroupsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccountId"] = this.axAccountId;
        if (Array.isArray(this.tagGroups)) {
            data["tagGroups"] = [];
            for (let item of this.tagGroups)
                data["tagGroups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCloudTagGroupsResponse {
    axAccountId?: number;
    tagGroups?: TagGroupDto[] | undefined;
}

export class GetCloudTagKeyValuesRequest implements IGetCloudTagKeyValuesRequest {
    axAccountNumber?: string | undefined;
    keyName?: string | undefined;

    constructor(data?: IGetCloudTagKeyValuesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.axAccountNumber = _data["axAccountNumber"];
            this.keyName = _data["keyName"];
        }
    }

    static fromJS(data: any): GetCloudTagKeyValuesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetCloudTagKeyValuesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccountNumber"] = this.axAccountNumber;
        data["keyName"] = this.keyName;
        return data;
    }
}

export interface IGetCloudTagKeyValuesRequest {
    axAccountNumber?: string | undefined;
    keyName?: string | undefined;
}

export class GetCloudTagKeyValuesResponse implements IGetCloudTagKeyValuesResponse {
    valueNames?: string[] | undefined;

    constructor(data?: IGetCloudTagKeyValuesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["valueNames"])) {
                this.valueNames = [] as any;
                for (let item of _data["valueNames"])
                    this.valueNames!.push(item);
            }
        }
    }

    static fromJS(data: any): GetCloudTagKeyValuesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCloudTagKeyValuesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.valueNames)) {
            data["valueNames"] = [];
            for (let item of this.valueNames)
                data["valueNames"].push(item);
        }
        return data;
    }
}

export interface IGetCloudTagKeyValuesResponse {
    valueNames?: string[] | undefined;
}

export class GetCloudTagKeysResponse implements IGetCloudTagKeysResponse {
    keyNames?: string[] | undefined;

    constructor(data?: IGetCloudTagKeysResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["keyNames"])) {
                this.keyNames = [] as any;
                for (let item of _data["keyNames"])
                    this.keyNames!.push(item);
            }
        }
    }

    static fromJS(data: any): GetCloudTagKeysResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCloudTagKeysResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.keyNames)) {
            data["keyNames"] = [];
            for (let item of this.keyNames)
                data["keyNames"].push(item);
        }
        return data;
    }
}

export interface IGetCloudTagKeysResponse {
    keyNames?: string[] | undefined;
}

export class TagGroupResourcePicklistQuery implements ITagGroupResourcePicklistQuery {
    axAccountNumber?: string | undefined;
    tagGroupId?: number;
    dateFilter?: TagGroupDateFilter;

    constructor(data?: ITagGroupResourcePicklistQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.axAccountNumber = _data["axAccountNumber"];
            this.tagGroupId = _data["tagGroupId"];
            this.dateFilter = _data["dateFilter"] ? TagGroupDateFilter.fromJS(_data["dateFilter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TagGroupResourcePicklistQuery {
        data = typeof data === 'object' ? data : {};
        let result = new TagGroupResourcePicklistQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccountNumber"] = this.axAccountNumber;
        data["tagGroupId"] = this.tagGroupId;
        data["dateFilter"] = this.dateFilter ? this.dateFilter.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITagGroupResourcePicklistQuery {
    axAccountNumber?: string | undefined;
    tagGroupId?: number;
    dateFilter?: TagGroupDateFilter;
}

export class CloudResourceCount implements ICloudResourceCount {
    taggedResourceCount?: number | undefined;
    totalResourceCount?: number | undefined;

    constructor(data?: ICloudResourceCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taggedResourceCount = _data["taggedResourceCount"];
            this.totalResourceCount = _data["totalResourceCount"];
        }
    }

    static fromJS(data: any): CloudResourceCount {
        data = typeof data === 'object' ? data : {};
        let result = new CloudResourceCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taggedResourceCount"] = this.taggedResourceCount;
        data["totalResourceCount"] = this.totalResourceCount;
        return data;
    }
}

export interface ICloudResourceCount {
    taggedResourceCount?: number | undefined;
    totalResourceCount?: number | undefined;
}

export class TagGroupCostReportDto implements ITagGroupCostReportDto {
    tagGroupId?: number | undefined;
    tagGroupDetails?: TagGroupDetails;
    tagValueTotalCosts?: TagValueCostOverTime[] | undefined;
    tagValueCosts?: TagValueCosts[] | undefined;

    constructor(data?: ITagGroupCostReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagGroupId = _data["tagGroupId"];
            this.tagGroupDetails = _data["tagGroupDetails"] ? TagGroupDetails.fromJS(_data["tagGroupDetails"]) : <any>undefined;
            if (Array.isArray(_data["tagValueTotalCosts"])) {
                this.tagValueTotalCosts = [] as any;
                for (let item of _data["tagValueTotalCosts"])
                    this.tagValueTotalCosts!.push(TagValueCostOverTime.fromJS(item));
            }
            if (Array.isArray(_data["tagValueCosts"])) {
                this.tagValueCosts = [] as any;
                for (let item of _data["tagValueCosts"])
                    this.tagValueCosts!.push(TagValueCosts.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TagGroupCostReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagGroupCostReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagGroupId"] = this.tagGroupId;
        data["tagGroupDetails"] = this.tagGroupDetails ? this.tagGroupDetails.toJSON() : <any>undefined;
        if (Array.isArray(this.tagValueTotalCosts)) {
            data["tagValueTotalCosts"] = [];
            for (let item of this.tagValueTotalCosts)
                data["tagValueTotalCosts"].push(item.toJSON());
        }
        if (Array.isArray(this.tagValueCosts)) {
            data["tagValueCosts"] = [];
            for (let item of this.tagValueCosts)
                data["tagValueCosts"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITagGroupCostReportDto {
    tagGroupId?: number | undefined;
    tagGroupDetails?: TagGroupDetails;
    tagValueTotalCosts?: TagValueCostOverTime[] | undefined;
    tagValueCosts?: TagValueCosts[] | undefined;
}

export class TagGroupDto implements ITagGroupDto {
    id?: number | undefined;
    tagGroupDetails?: TagGroupDetails;
    tagValueCount?: number;
    cloudResourceCount?: CloudResourceCount;
    lastMonthsCost?: LastMonthsCost;
    lastUpdated?: string | undefined;
    tagGroupValues?: TagGroupValues;

    constructor(data?: ITagGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tagGroupDetails = _data["tagGroupDetails"] ? TagGroupDetails.fromJS(_data["tagGroupDetails"]) : <any>undefined;
            this.tagValueCount = _data["tagValueCount"];
            this.cloudResourceCount = _data["cloudResourceCount"] ? CloudResourceCount.fromJS(_data["cloudResourceCount"]) : <any>undefined;
            this.lastMonthsCost = _data["lastMonthsCost"] ? LastMonthsCost.fromJS(_data["lastMonthsCost"]) : <any>undefined;
            this.lastUpdated = _data["lastUpdated"];
            this.tagGroupValues = _data["tagGroupValues"] ? TagGroupValues.fromJS(_data["tagGroupValues"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TagGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tagGroupDetails"] = this.tagGroupDetails ? this.tagGroupDetails.toJSON() : <any>undefined;
        data["tagValueCount"] = this.tagValueCount;
        data["cloudResourceCount"] = this.cloudResourceCount ? this.cloudResourceCount.toJSON() : <any>undefined;
        data["lastMonthsCost"] = this.lastMonthsCost ? this.lastMonthsCost.toJSON() : <any>undefined;
        data["lastUpdated"] = this.lastUpdated;
        data["tagGroupValues"] = this.tagGroupValues ? this.tagGroupValues.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITagGroupDto {
    id?: number | undefined;
    tagGroupDetails?: TagGroupDetails;
    tagValueCount?: number;
    cloudResourceCount?: CloudResourceCount;
    lastMonthsCost?: LastMonthsCost;
    lastUpdated?: string | undefined;
    tagGroupValues?: TagGroupValues;
}

export class TagGroupResourceDto implements ITagGroupResourceDto {
    id?: number;
    cloudResourceName?: string | undefined;
    cloudResourceId?: string | undefined;
    tagValue?: string[] | undefined;
    cloudServiceProvider?: string | undefined;
    cloudResourceType?: string | undefined;
    cloudAccountName?: string | undefined;
    cloudAccountId?: string | undefined;
    region?: string | undefined;
    tags?: string[] | undefined;

    constructor(data?: ITagGroupResourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cloudResourceName = _data["cloudResourceName"];
            this.cloudResourceId = _data["cloudResourceId"];
            if (Array.isArray(_data["tagValue"])) {
                this.tagValue = [] as any;
                for (let item of _data["tagValue"])
                    this.tagValue!.push(item);
            }
            this.cloudServiceProvider = _data["cloudServiceProvider"];
            this.cloudResourceType = _data["cloudResourceType"];
            this.cloudAccountName = _data["cloudAccountName"];
            this.cloudAccountId = _data["cloudAccountId"];
            this.region = _data["region"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
        }
    }

    static fromJS(data: any): TagGroupResourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagGroupResourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cloudResourceName"] = this.cloudResourceName;
        data["cloudResourceId"] = this.cloudResourceId;
        if (Array.isArray(this.tagValue)) {
            data["tagValue"] = [];
            for (let item of this.tagValue)
                data["tagValue"].push(item);
        }
        data["cloudServiceProvider"] = this.cloudServiceProvider;
        data["cloudResourceType"] = this.cloudResourceType;
        data["cloudAccountName"] = this.cloudAccountName;
        data["cloudAccountId"] = this.cloudAccountId;
        data["region"] = this.region;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data;
    }
}

export interface ITagGroupResourceDto {
    id?: number;
    cloudResourceName?: string | undefined;
    cloudResourceId?: string | undefined;
    tagValue?: string[] | undefined;
    cloudServiceProvider?: string | undefined;
    cloudResourceType?: string | undefined;
    cloudAccountName?: string | undefined;
    cloudAccountId?: string | undefined;
    region?: string | undefined;
    tags?: string[] | undefined;
}

export class TagGroupResourcePicklistDto implements ITagGroupResourcePicklistDto {
    cloudPlatform?: string[] | undefined;
    cloudAccountName?: string[] | undefined;
    region?: string[] | undefined;
    cloudResourceType?: string[] | undefined;
    cloudResourceTags?: string[] | undefined;

    constructor(data?: ITagGroupResourcePicklistDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cloudPlatform"])) {
                this.cloudPlatform = [] as any;
                for (let item of _data["cloudPlatform"])
                    this.cloudPlatform!.push(item);
            }
            if (Array.isArray(_data["cloudAccountName"])) {
                this.cloudAccountName = [] as any;
                for (let item of _data["cloudAccountName"])
                    this.cloudAccountName!.push(item);
            }
            if (Array.isArray(_data["region"])) {
                this.region = [] as any;
                for (let item of _data["region"])
                    this.region!.push(item);
            }
            if (Array.isArray(_data["cloudResourceType"])) {
                this.cloudResourceType = [] as any;
                for (let item of _data["cloudResourceType"])
                    this.cloudResourceType!.push(item);
            }
            if (Array.isArray(_data["cloudResourceTags"])) {
                this.cloudResourceTags = [] as any;
                for (let item of _data["cloudResourceTags"])
                    this.cloudResourceTags!.push(item);
            }
        }
    }

    static fromJS(data: any): TagGroupResourcePicklistDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagGroupResourcePicklistDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cloudPlatform)) {
            data["cloudPlatform"] = [];
            for (let item of this.cloudPlatform)
                data["cloudPlatform"].push(item);
        }
        if (Array.isArray(this.cloudAccountName)) {
            data["cloudAccountName"] = [];
            for (let item of this.cloudAccountName)
                data["cloudAccountName"].push(item);
        }
        if (Array.isArray(this.region)) {
            data["region"] = [];
            for (let item of this.region)
                data["region"].push(item);
        }
        if (Array.isArray(this.cloudResourceType)) {
            data["cloudResourceType"] = [];
            for (let item of this.cloudResourceType)
                data["cloudResourceType"].push(item);
        }
        if (Array.isArray(this.cloudResourceTags)) {
            data["cloudResourceTags"] = [];
            for (let item of this.cloudResourceTags)
                data["cloudResourceTags"].push(item);
        }
        return data;
    }
}

export interface ITagGroupResourcePicklistDto {
    cloudPlatform?: string[] | undefined;
    cloudAccountName?: string[] | undefined;
    region?: string[] | undefined;
    cloudResourceType?: string[] | undefined;
    cloudResourceTags?: string[] | undefined;
}

export class TagGroupTagDto implements ITagGroupTagDto {
    id?: number | undefined;
    keyName?: string | undefined;
    combinedKeyName?: string | undefined;
    valueName?: string | undefined;
    combinedValueName?: string | undefined;
    ordinal?: number;
    budget?: number;

    constructor(data?: ITagGroupTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.keyName = _data["keyName"];
            this.combinedKeyName = _data["combinedKeyName"];
            this.valueName = _data["valueName"];
            this.combinedValueName = _data["combinedValueName"];
            this.ordinal = _data["ordinal"];
            this.budget = _data["budget"];
        }
    }

    static fromJS(data: any): TagGroupTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagGroupTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["keyName"] = this.keyName;
        data["combinedKeyName"] = this.combinedKeyName;
        data["valueName"] = this.valueName;
        data["combinedValueName"] = this.combinedValueName;
        data["ordinal"] = this.ordinal;
        data["budget"] = this.budget;
        return data;
    }
}

export interface ITagGroupTagDto {
    id?: number | undefined;
    keyName?: string | undefined;
    combinedKeyName?: string | undefined;
    valueName?: string | undefined;
    combinedValueName?: string | undefined;
    ordinal?: number;
    budget?: number;
}

export class LastMonthsCost implements ILastMonthsCost {
    taggedLastMonthsCost?: number | undefined;
    totalLastMonthsCost?: number | undefined;

    constructor(data?: ILastMonthsCost) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taggedLastMonthsCost = _data["taggedLastMonthsCost"];
            this.totalLastMonthsCost = _data["totalLastMonthsCost"];
        }
    }

    static fromJS(data: any): LastMonthsCost {
        data = typeof data === 'object' ? data : {};
        let result = new LastMonthsCost();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taggedLastMonthsCost"] = this.taggedLastMonthsCost;
        data["totalLastMonthsCost"] = this.totalLastMonthsCost;
        return data;
    }
}

export interface ILastMonthsCost {
    taggedLastMonthsCost?: number | undefined;
    totalLastMonthsCost?: number | undefined;
}

export enum TagGroupCostTimeInterval {
    Month = "month",
    Quarter = "quarter",
    Year = "year",
}

export class TagGroupDateFilter implements ITagGroupDateFilter {
    startDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: ITagGroupDateFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TagGroupDateFilter {
        data = typeof data === 'object' ? data : {};
        let result = new TagGroupDateFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITagGroupDateFilter {
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export class TagGroupDetails implements ITagGroupDetails {
    tagGroupName?: string | undefined;
    tagGroupKey?: string | undefined;

    constructor(data?: ITagGroupDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagGroupName = _data["tagGroupName"];
            this.tagGroupKey = _data["tagGroupKey"];
        }
    }

    static fromJS(data: any): TagGroupDetails {
        data = typeof data === 'object' ? data : {};
        let result = new TagGroupDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagGroupName"] = this.tagGroupName;
        data["tagGroupKey"] = this.tagGroupKey;
        return data;
    }
}

export interface ITagGroupDetails {
    tagGroupName?: string | undefined;
    tagGroupKey?: string | undefined;
}

export class TagGroupValue implements ITagGroupValue {
    valueName?: string | undefined;
    monthlyBudget?: number | undefined;
    combinedName?: string | undefined;

    constructor(data?: ITagGroupValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valueName = _data["valueName"];
            this.monthlyBudget = _data["monthlyBudget"];
            this.combinedName = _data["combinedName"];
        }
    }

    static fromJS(data: any): TagGroupValue {
        data = typeof data === 'object' ? data : {};
        let result = new TagGroupValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valueName"] = this.valueName;
        data["monthlyBudget"] = this.monthlyBudget;
        data["combinedName"] = this.combinedName;
        return data;
    }
}

export interface ITagGroupValue {
    valueName?: string | undefined;
    monthlyBudget?: number | undefined;
    combinedName?: string | undefined;
}

export class TagGroupValues implements ITagGroupValues {
    tagGroupId?: number | undefined;
    tagValues?: TagGroupValue[] | undefined;

    constructor(data?: ITagGroupValues) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagGroupId = _data["tagGroupId"];
            if (Array.isArray(_data["tagValues"])) {
                this.tagValues = [] as any;
                for (let item of _data["tagValues"])
                    this.tagValues!.push(TagGroupValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TagGroupValues {
        data = typeof data === 'object' ? data : {};
        let result = new TagGroupValues();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagGroupId"] = this.tagGroupId;
        if (Array.isArray(this.tagValues)) {
            data["tagValues"] = [];
            for (let item of this.tagValues)
                data["tagValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITagGroupValues {
    tagGroupId?: number | undefined;
    tagValues?: TagGroupValue[] | undefined;
}

export class TagValueCostOverTime implements ITagValueCostOverTime {
    timePeriod?: string | undefined;
    cost?: number | undefined;
    totalBudget?: number | undefined;

    constructor(data?: ITagValueCostOverTime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timePeriod = _data["timePeriod"];
            this.cost = _data["cost"];
            this.totalBudget = _data["totalBudget"];
        }
    }

    static fromJS(data: any): TagValueCostOverTime {
        data = typeof data === 'object' ? data : {};
        let result = new TagValueCostOverTime();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timePeriod"] = this.timePeriod;
        data["cost"] = this.cost;
        data["totalBudget"] = this.totalBudget;
        return data;
    }
}

export interface ITagValueCostOverTime {
    timePeriod?: string | undefined;
    cost?: number | undefined;
    totalBudget?: number | undefined;
}

export class TagValueCosts implements ITagValueCosts {
    combinedValueName?: string | undefined;
    totalCost?: number | undefined;
    costs?: TagValueCostOverTime[] | undefined;

    constructor(data?: ITagValueCosts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.combinedValueName = _data["combinedValueName"];
            this.totalCost = _data["totalCost"];
            if (Array.isArray(_data["costs"])) {
                this.costs = [] as any;
                for (let item of _data["costs"])
                    this.costs!.push(TagValueCostOverTime.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TagValueCosts {
        data = typeof data === 'object' ? data : {};
        let result = new TagValueCosts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["combinedValueName"] = this.combinedValueName;
        data["totalCost"] = this.totalCost;
        if (Array.isArray(this.costs)) {
            data["costs"] = [];
            for (let item of this.costs)
                data["costs"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITagValueCosts {
    combinedValueName?: string | undefined;
    totalCost?: number | undefined;
    costs?: TagValueCostOverTime[] | undefined;
}

export class FilterOption implements IFilterOption {
    accessor?: string | undefined;
    value?: string | undefined;

    constructor(data?: IFilterOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessor = _data["accessor"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): FilterOption {
        data = typeof data === 'object' ? data : {};
        let result = new FilterOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessor"] = this.accessor;
        data["value"] = this.value;
        return data;
    }
}

export interface IFilterOption {
    accessor?: string | undefined;
    value?: string | undefined;
}

export class SearchFilter implements ISearchFilter {
    searchTerm?: string | undefined;
    filters?: FilterOption[] | undefined;

    protected _discriminator: string;

    constructor(data?: ISearchFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "SearchFilter";
    }

    init(_data?: any) {
        if (_data) {
            this.searchTerm = _data["searchTerm"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(FilterOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchFilter {
        data = typeof data === 'object' ? data : {};
        if (data["typeName"] === "PaginatedQuery") {
            let result = new PaginatedQuery();
            result.init(data);
            return result;
        }
        let result = new SearchFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeName"] = this._discriminator;
        data["searchTerm"] = this.searchTerm;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchFilter {
    searchTerm?: string | undefined;
    filters?: FilterOption[] | undefined;
}

export class PaginatedQuery extends SearchFilter implements IPaginatedQuery {
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IPaginatedQuery) {
        super(data);
        this._discriminator = "PaginatedQuery";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static override fromJS(data: any): PaginatedQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedQuery extends ISearchFilter {
    pageNumber?: number;
    pageSize?: number;
}

export class PaginatedResultDto_1OfArticleDto implements IPaginatedResultDto_1OfArticleDto {
    items?: ArticleDto[] | undefined;
    readonly totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    readonly totalPages?: number;

    constructor(data?: IPaginatedResultDto_1OfArticleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ArticleDto.fromJS(item));
            }
            (<any>this).totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            (<any>this).totalPages = _data["totalPages"];
        }
    }

    static fromJS(data: any): PaginatedResultDto_1OfArticleDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultDto_1OfArticleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        return data;
    }
}

export interface IPaginatedResultDto_1OfArticleDto {
    items?: ArticleDto[] | undefined;
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
}

export class PaginatedResultDto_1OfLabDto implements IPaginatedResultDto_1OfLabDto {
    items?: LabDto[] | undefined;
    readonly totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    readonly totalPages?: number;

    constructor(data?: IPaginatedResultDto_1OfLabDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LabDto.fromJS(item));
            }
            (<any>this).totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            (<any>this).totalPages = _data["totalPages"];
        }
    }

    static fromJS(data: any): PaginatedResultDto_1OfLabDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultDto_1OfLabDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        return data;
    }
}

export interface IPaginatedResultDto_1OfLabDto {
    items?: LabDto[] | undefined;
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
}

export class PaginatedResultDto_1OfServiceCatalogDto implements IPaginatedResultDto_1OfServiceCatalogDto {
    items?: ServiceCatalogDto[] | undefined;
    readonly totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    readonly totalPages?: number;

    constructor(data?: IPaginatedResultDto_1OfServiceCatalogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceCatalogDto.fromJS(item));
            }
            (<any>this).totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            (<any>this).totalPages = _data["totalPages"];
        }
    }

    static fromJS(data: any): PaginatedResultDto_1OfServiceCatalogDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultDto_1OfServiceCatalogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        return data;
    }
}

export interface IPaginatedResultDto_1OfServiceCatalogDto {
    items?: ServiceCatalogDto[] | undefined;
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
}

export class ContractReport implements IContractReport {
    accountId?: number;
    expireIn30?: number;
    expireIn60?: number;
    expireIn90?: number;
    expireOver90?: number;
    contractTypeStats?: ContractTypeStats[] | undefined;

    constructor(data?: IContractReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.expireIn30 = _data["expireIn30"];
            this.expireIn60 = _data["expireIn60"];
            this.expireIn90 = _data["expireIn90"];
            this.expireOver90 = _data["expireOver90"];
            if (Array.isArray(_data["contractTypeStats"])) {
                this.contractTypeStats = [] as any;
                for (let item of _data["contractTypeStats"])
                    this.contractTypeStats!.push(ContractTypeStats.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContractReport {
        data = typeof data === 'object' ? data : {};
        let result = new ContractReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["expireIn30"] = this.expireIn30;
        data["expireIn60"] = this.expireIn60;
        data["expireIn90"] = this.expireIn90;
        data["expireOver90"] = this.expireOver90;
        if (Array.isArray(this.contractTypeStats)) {
            data["contractTypeStats"] = [];
            for (let item of this.contractTypeStats)
                data["contractTypeStats"].push(item.toJSON());
        }
        return data;
    }
}

export interface IContractReport {
    accountId?: number;
    expireIn30?: number;
    expireIn60?: number;
    expireIn90?: number;
    expireOver90?: number;
    contractTypeStats?: ContractTypeStats[] | undefined;
}

export class ContractTypeStats implements IContractTypeStats {
    counted?: number;
    contractCategory?: number;
    contractType?: number;

    constructor(data?: IContractTypeStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.counted = _data["counted"];
            this.contractCategory = _data["contractCategory"];
            this.contractType = _data["contractType"];
        }
    }

    static fromJS(data: any): ContractTypeStats {
        data = typeof data === 'object' ? data : {};
        let result = new ContractTypeStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["counted"] = this.counted;
        data["contractCategory"] = this.contractCategory;
        data["contractType"] = this.contractType;
        return data;
    }
}

export interface IContractTypeStats {
    counted?: number;
    contractCategory?: number;
    contractType?: number;
}

export enum DynamicTagActions {
    AddTags = "AddTags",
    RemoveTags = "RemoveTags",
    Notes = "Notes",
}

export enum DynamicTagSource {
    AssetInventory = "AssetInventory",
    AssetLifecycle = "AssetLifecycle",
    AssetLocations = "AssetLocations",
}

export class DynamicTagsGetRequest implements IDynamicTagsGetRequest {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    tagType?: string | undefined;
    tagSource?: DynamicTagSource;
    tagKeys?: string[] | undefined;
    tagValues?: string[] | undefined;
    showParentsOnly?: boolean | undefined;
    allCheckboxSelected?: boolean | undefined;
    excludeSearchFilter?: boolean | undefined;
    searchFilter?: DynamicTagsSearchFilter;

    constructor(data?: IDynamicTagsGetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountIdentifier = _data["accountIdentifier"];
            if (Array.isArray(_data["accountReferences"])) {
                this.accountReferences = [] as any;
                for (let item of _data["accountReferences"])
                    this.accountReferences!.push(item);
            }
            this.tagType = _data["tagType"];
            this.tagSource = _data["tagSource"];
            if (Array.isArray(_data["tagKeys"])) {
                this.tagKeys = [] as any;
                for (let item of _data["tagKeys"])
                    this.tagKeys!.push(item);
            }
            if (Array.isArray(_data["tagValues"])) {
                this.tagValues = [] as any;
                for (let item of _data["tagValues"])
                    this.tagValues!.push(item);
            }
            this.showParentsOnly = _data["showParentsOnly"];
            this.allCheckboxSelected = _data["allCheckboxSelected"];
            this.excludeSearchFilter = _data["excludeSearchFilter"];
            this.searchFilter = _data["searchFilter"] ? DynamicTagsSearchFilter.fromJS(_data["searchFilter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DynamicTagsGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicTagsGetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountIdentifier"] = this.accountIdentifier;
        if (Array.isArray(this.accountReferences)) {
            data["accountReferences"] = [];
            for (let item of this.accountReferences)
                data["accountReferences"].push(item);
        }
        data["tagType"] = this.tagType;
        data["tagSource"] = this.tagSource;
        if (Array.isArray(this.tagKeys)) {
            data["tagKeys"] = [];
            for (let item of this.tagKeys)
                data["tagKeys"].push(item);
        }
        if (Array.isArray(this.tagValues)) {
            data["tagValues"] = [];
            for (let item of this.tagValues)
                data["tagValues"].push(item);
        }
        data["showParentsOnly"] = this.showParentsOnly;
        data["allCheckboxSelected"] = this.allCheckboxSelected;
        data["excludeSearchFilter"] = this.excludeSearchFilter;
        data["searchFilter"] = this.searchFilter ? this.searchFilter.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDynamicTagsGetRequest {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    tagType?: string | undefined;
    tagSource?: DynamicTagSource;
    tagKeys?: string[] | undefined;
    tagValues?: string[] | undefined;
    showParentsOnly?: boolean | undefined;
    allCheckboxSelected?: boolean | undefined;
    excludeSearchFilter?: boolean | undefined;
    searchFilter?: DynamicTagsSearchFilter;
}

export class DynamicTagsGetResponse implements IDynamicTagsGetResponse {
    dynamicTags?: string[] | undefined;

    constructor(data?: IDynamicTagsGetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dynamicTags"])) {
                this.dynamicTags = [] as any;
                for (let item of _data["dynamicTags"])
                    this.dynamicTags!.push(item);
            }
        }
    }

    static fromJS(data: any): DynamicTagsGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicTagsGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dynamicTags)) {
            data["dynamicTags"] = [];
            for (let item of this.dynamicTags)
                data["dynamicTags"].push(item);
        }
        return data;
    }
}

export interface IDynamicTagsGetResponse {
    dynamicTags?: string[] | undefined;
}

export class DynamicTagsRequest implements IDynamicTagsRequest {
    action?: DynamicTagActions;
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    accountId?: number;
    contactId?: number;
    sourceIdentifier?: string | undefined;
    tagType?: string | undefined;
    tagKeys?: string[] | undefined;
    tagValues?: string[] | undefined;
    tagSource?: DynamicTagSource;
    allCheckboxSelected?: boolean | undefined;
    showParentsOnly?: boolean | undefined;
    excludeSearchFilter?: boolean | undefined;
    searchFilter?: DynamicTagsSearchFilter;

    constructor(data?: IDynamicTagsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"];
            this.accountIdentifier = _data["accountIdentifier"];
            if (Array.isArray(_data["accountReferences"])) {
                this.accountReferences = [] as any;
                for (let item of _data["accountReferences"])
                    this.accountReferences!.push(item);
            }
            this.accountId = _data["accountId"];
            this.contactId = _data["contactId"];
            this.sourceIdentifier = _data["sourceIdentifier"];
            this.tagType = _data["tagType"];
            if (Array.isArray(_data["tagKeys"])) {
                this.tagKeys = [] as any;
                for (let item of _data["tagKeys"])
                    this.tagKeys!.push(item);
            }
            if (Array.isArray(_data["tagValues"])) {
                this.tagValues = [] as any;
                for (let item of _data["tagValues"])
                    this.tagValues!.push(item);
            }
            this.tagSource = _data["tagSource"];
            this.allCheckboxSelected = _data["allCheckboxSelected"];
            this.showParentsOnly = _data["showParentsOnly"];
            this.excludeSearchFilter = _data["excludeSearchFilter"];
            this.searchFilter = _data["searchFilter"] ? DynamicTagsSearchFilter.fromJS(_data["searchFilter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DynamicTagsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicTagsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action;
        data["accountIdentifier"] = this.accountIdentifier;
        if (Array.isArray(this.accountReferences)) {
            data["accountReferences"] = [];
            for (let item of this.accountReferences)
                data["accountReferences"].push(item);
        }
        data["accountId"] = this.accountId;
        data["contactId"] = this.contactId;
        data["sourceIdentifier"] = this.sourceIdentifier;
        data["tagType"] = this.tagType;
        if (Array.isArray(this.tagKeys)) {
            data["tagKeys"] = [];
            for (let item of this.tagKeys)
                data["tagKeys"].push(item);
        }
        if (Array.isArray(this.tagValues)) {
            data["tagValues"] = [];
            for (let item of this.tagValues)
                data["tagValues"].push(item);
        }
        data["tagSource"] = this.tagSource;
        data["allCheckboxSelected"] = this.allCheckboxSelected;
        data["showParentsOnly"] = this.showParentsOnly;
        data["excludeSearchFilter"] = this.excludeSearchFilter;
        data["searchFilter"] = this.searchFilter ? this.searchFilter.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDynamicTagsRequest {
    action?: DynamicTagActions;
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    accountId?: number;
    contactId?: number;
    sourceIdentifier?: string | undefined;
    tagType?: string | undefined;
    tagKeys?: string[] | undefined;
    tagValues?: string[] | undefined;
    tagSource?: DynamicTagSource;
    allCheckboxSelected?: boolean | undefined;
    showParentsOnly?: boolean | undefined;
    excludeSearchFilter?: boolean | undefined;
    searchFilter?: DynamicTagsSearchFilter;
}

export class DynamicTagsSearchFilter implements IDynamicTagsSearchFilter {
    searchFor?: string | undefined;
    assetType?: string[] | undefined;
    name?: string[] | undefined;
    manufacturer?: string[] | undefined;
    managingPartner?: string[] | undefined;
    product?: string[] | undefined;
    category?: string[] | undefined;
    subCategory?: string[] | undefined;
    useState?: string[] | undefined;
    lifecycleState?: string[] | undefined;
    contractId?: string[] | undefined;
    contractType?: string[] | undefined;
    contractStatus?: string[] | undefined;
    contractVendor?: string[] | undefined;
    displayLocationName?: string[] | undefined;
    locationAddress?: string[] | undefined;
    locationCity?: string[] | undefined;
    locationState?: string[] | undefined;
    locationCountry?: string[] | undefined;
    discoveredOnNet?: string[] | undefined;
    tags?: string[] | undefined;
    contractStartDate?: ElasticDateRangeQueryFilter;
    contractEndDate?: ElasticDateRangeQueryFilter;
    endOfSaleDate?: ElasticDateRangeQueryFilter;
    endOfSoftwareMaintenanceDate?: ElasticDateRangeQueryFilter;
    lastDateOfSupport?: ElasticDateRangeQueryFilter;
    shipDate?: ElasticDateRangeQueryFilter;
    quarter?: number | undefined;
    year?: number | undefined;

    constructor(data?: IDynamicTagsSearchFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchFor = _data["searchFor"];
            if (Array.isArray(_data["assetType"])) {
                this.assetType = [] as any;
                for (let item of _data["assetType"])
                    this.assetType!.push(item);
            }
            if (Array.isArray(_data["name"])) {
                this.name = [] as any;
                for (let item of _data["name"])
                    this.name!.push(item);
            }
            if (Array.isArray(_data["manufacturer"])) {
                this.manufacturer = [] as any;
                for (let item of _data["manufacturer"])
                    this.manufacturer!.push(item);
            }
            if (Array.isArray(_data["managingPartner"])) {
                this.managingPartner = [] as any;
                for (let item of _data["managingPartner"])
                    this.managingPartner!.push(item);
            }
            if (Array.isArray(_data["product"])) {
                this.product = [] as any;
                for (let item of _data["product"])
                    this.product!.push(item);
            }
            if (Array.isArray(_data["category"])) {
                this.category = [] as any;
                for (let item of _data["category"])
                    this.category!.push(item);
            }
            if (Array.isArray(_data["subCategory"])) {
                this.subCategory = [] as any;
                for (let item of _data["subCategory"])
                    this.subCategory!.push(item);
            }
            if (Array.isArray(_data["useState"])) {
                this.useState = [] as any;
                for (let item of _data["useState"])
                    this.useState!.push(item);
            }
            if (Array.isArray(_data["lifecycleState"])) {
                this.lifecycleState = [] as any;
                for (let item of _data["lifecycleState"])
                    this.lifecycleState!.push(item);
            }
            if (Array.isArray(_data["contractId"])) {
                this.contractId = [] as any;
                for (let item of _data["contractId"])
                    this.contractId!.push(item);
            }
            if (Array.isArray(_data["contractType"])) {
                this.contractType = [] as any;
                for (let item of _data["contractType"])
                    this.contractType!.push(item);
            }
            if (Array.isArray(_data["contractStatus"])) {
                this.contractStatus = [] as any;
                for (let item of _data["contractStatus"])
                    this.contractStatus!.push(item);
            }
            if (Array.isArray(_data["contractVendor"])) {
                this.contractVendor = [] as any;
                for (let item of _data["contractVendor"])
                    this.contractVendor!.push(item);
            }
            if (Array.isArray(_data["displayLocationName"])) {
                this.displayLocationName = [] as any;
                for (let item of _data["displayLocationName"])
                    this.displayLocationName!.push(item);
            }
            if (Array.isArray(_data["locationAddress"])) {
                this.locationAddress = [] as any;
                for (let item of _data["locationAddress"])
                    this.locationAddress!.push(item);
            }
            if (Array.isArray(_data["locationCity"])) {
                this.locationCity = [] as any;
                for (let item of _data["locationCity"])
                    this.locationCity!.push(item);
            }
            if (Array.isArray(_data["locationState"])) {
                this.locationState = [] as any;
                for (let item of _data["locationState"])
                    this.locationState!.push(item);
            }
            if (Array.isArray(_data["locationCountry"])) {
                this.locationCountry = [] as any;
                for (let item of _data["locationCountry"])
                    this.locationCountry!.push(item);
            }
            if (Array.isArray(_data["discoveredOnNet"])) {
                this.discoveredOnNet = [] as any;
                for (let item of _data["discoveredOnNet"])
                    this.discoveredOnNet!.push(item);
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.contractStartDate = _data["contractStartDate"] ? ElasticDateRangeQueryFilter.fromJS(_data["contractStartDate"]) : <any>undefined;
            this.contractEndDate = _data["contractEndDate"] ? ElasticDateRangeQueryFilter.fromJS(_data["contractEndDate"]) : <any>undefined;
            this.endOfSaleDate = _data["endOfSaleDate"] ? ElasticDateRangeQueryFilter.fromJS(_data["endOfSaleDate"]) : <any>undefined;
            this.endOfSoftwareMaintenanceDate = _data["endOfSoftwareMaintenanceDate"] ? ElasticDateRangeQueryFilter.fromJS(_data["endOfSoftwareMaintenanceDate"]) : <any>undefined;
            this.lastDateOfSupport = _data["lastDateOfSupport"] ? ElasticDateRangeQueryFilter.fromJS(_data["lastDateOfSupport"]) : <any>undefined;
            this.shipDate = _data["shipDate"] ? ElasticDateRangeQueryFilter.fromJS(_data["shipDate"]) : <any>undefined;
            this.quarter = _data["quarter"];
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): DynamicTagsSearchFilter {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicTagsSearchFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchFor"] = this.searchFor;
        if (Array.isArray(this.assetType)) {
            data["assetType"] = [];
            for (let item of this.assetType)
                data["assetType"].push(item);
        }
        if (Array.isArray(this.name)) {
            data["name"] = [];
            for (let item of this.name)
                data["name"].push(item);
        }
        if (Array.isArray(this.manufacturer)) {
            data["manufacturer"] = [];
            for (let item of this.manufacturer)
                data["manufacturer"].push(item);
        }
        if (Array.isArray(this.managingPartner)) {
            data["managingPartner"] = [];
            for (let item of this.managingPartner)
                data["managingPartner"].push(item);
        }
        if (Array.isArray(this.product)) {
            data["product"] = [];
            for (let item of this.product)
                data["product"].push(item);
        }
        if (Array.isArray(this.category)) {
            data["category"] = [];
            for (let item of this.category)
                data["category"].push(item);
        }
        if (Array.isArray(this.subCategory)) {
            data["subCategory"] = [];
            for (let item of this.subCategory)
                data["subCategory"].push(item);
        }
        if (Array.isArray(this.useState)) {
            data["useState"] = [];
            for (let item of this.useState)
                data["useState"].push(item);
        }
        if (Array.isArray(this.lifecycleState)) {
            data["lifecycleState"] = [];
            for (let item of this.lifecycleState)
                data["lifecycleState"].push(item);
        }
        if (Array.isArray(this.contractId)) {
            data["contractId"] = [];
            for (let item of this.contractId)
                data["contractId"].push(item);
        }
        if (Array.isArray(this.contractType)) {
            data["contractType"] = [];
            for (let item of this.contractType)
                data["contractType"].push(item);
        }
        if (Array.isArray(this.contractStatus)) {
            data["contractStatus"] = [];
            for (let item of this.contractStatus)
                data["contractStatus"].push(item);
        }
        if (Array.isArray(this.contractVendor)) {
            data["contractVendor"] = [];
            for (let item of this.contractVendor)
                data["contractVendor"].push(item);
        }
        if (Array.isArray(this.displayLocationName)) {
            data["displayLocationName"] = [];
            for (let item of this.displayLocationName)
                data["displayLocationName"].push(item);
        }
        if (Array.isArray(this.locationAddress)) {
            data["locationAddress"] = [];
            for (let item of this.locationAddress)
                data["locationAddress"].push(item);
        }
        if (Array.isArray(this.locationCity)) {
            data["locationCity"] = [];
            for (let item of this.locationCity)
                data["locationCity"].push(item);
        }
        if (Array.isArray(this.locationState)) {
            data["locationState"] = [];
            for (let item of this.locationState)
                data["locationState"].push(item);
        }
        if (Array.isArray(this.locationCountry)) {
            data["locationCountry"] = [];
            for (let item of this.locationCountry)
                data["locationCountry"].push(item);
        }
        if (Array.isArray(this.discoveredOnNet)) {
            data["discoveredOnNet"] = [];
            for (let item of this.discoveredOnNet)
                data["discoveredOnNet"].push(item);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["contractStartDate"] = this.contractStartDate ? this.contractStartDate.toJSON() : <any>undefined;
        data["contractEndDate"] = this.contractEndDate ? this.contractEndDate.toJSON() : <any>undefined;
        data["endOfSaleDate"] = this.endOfSaleDate ? this.endOfSaleDate.toJSON() : <any>undefined;
        data["endOfSoftwareMaintenanceDate"] = this.endOfSoftwareMaintenanceDate ? this.endOfSoftwareMaintenanceDate.toJSON() : <any>undefined;
        data["lastDateOfSupport"] = this.lastDateOfSupport ? this.lastDateOfSupport.toJSON() : <any>undefined;
        data["shipDate"] = this.shipDate ? this.shipDate.toJSON() : <any>undefined;
        data["quarter"] = this.quarter;
        data["year"] = this.year;
        return data;
    }
}

export interface IDynamicTagsSearchFilter {
    searchFor?: string | undefined;
    assetType?: string[] | undefined;
    name?: string[] | undefined;
    manufacturer?: string[] | undefined;
    managingPartner?: string[] | undefined;
    product?: string[] | undefined;
    category?: string[] | undefined;
    subCategory?: string[] | undefined;
    useState?: string[] | undefined;
    lifecycleState?: string[] | undefined;
    contractId?: string[] | undefined;
    contractType?: string[] | undefined;
    contractStatus?: string[] | undefined;
    contractVendor?: string[] | undefined;
    displayLocationName?: string[] | undefined;
    locationAddress?: string[] | undefined;
    locationCity?: string[] | undefined;
    locationState?: string[] | undefined;
    locationCountry?: string[] | undefined;
    discoveredOnNet?: string[] | undefined;
    tags?: string[] | undefined;
    contractStartDate?: ElasticDateRangeQueryFilter;
    contractEndDate?: ElasticDateRangeQueryFilter;
    endOfSaleDate?: ElasticDateRangeQueryFilter;
    endOfSoftwareMaintenanceDate?: ElasticDateRangeQueryFilter;
    lastDateOfSupport?: ElasticDateRangeQueryFilter;
    shipDate?: ElasticDateRangeQueryFilter;
    quarter?: number | undefined;
    year?: number | undefined;
}

export enum DateFilterOption {
    CurrentMonth = "CurrentMonth",
    LastMonth = "LastMonth",
    CurrentQuarter = "CurrentQuarter",
    LastQuarter = "LastQuarter",
    YearToDate = "YearToDate",
    LastYear = "LastYear",
    None = "None",
}

export enum CiscoIbaFilterDates {
    Next12Months = "Next12Months",
    Next3Years = "Next3Years",
    Last12Months = "Last12Months",
}

export enum ServiceRequestQueryType {
    AllRequests = "AllRequests",
    PrimaryContactRequests = "PrimaryContactRequests",
    SecondaryContactRequests = "SecondaryContactRequests",
    BillableRequests = "BillableRequests",
}

export enum ServiceRequestVisualsTypes {
    ServiceRequestType = "ServiceRequestType",
    Priority = "Priority",
    ServiceRequestCategory = "ServiceRequestCategory",
    RequestHistory = "RequestHistory",
}

export class AssetEndUserDevicesRequestDto implements IAssetEndUserDevicesRequestDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;

    constructor(data?: IAssetEndUserDevicesRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountIdentifier = _data["accountIdentifier"];
            if (Array.isArray(_data["accountReferences"])) {
                this.accountReferences = [] as any;
                for (let item of _data["accountReferences"])
                    this.accountReferences!.push(item);
            }
        }
    }

    static fromJS(data: any): AssetEndUserDevicesRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetEndUserDevicesRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountIdentifier"] = this.accountIdentifier;
        if (Array.isArray(this.accountReferences)) {
            data["accountReferences"] = [];
            for (let item of this.accountReferences)
                data["accountReferences"].push(item);
        }
        return data;
    }
}

export interface IAssetEndUserDevicesRequestDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
}

export class AssetLifecycleSearchRequestDto implements IAssetLifecycleSearchRequestDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    limit?: number | undefined;
    offset?: number | undefined;
    showParentsOnly?: boolean | undefined;
    excludeSearchFilter?: boolean;
    sortCriteria?: ElasticSortCriteria;
    searchFilter?: AssetLifecycleSearchFilterDto;
    scrollSearch?: boolean;

    constructor(data?: IAssetLifecycleSearchRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountIdentifier = _data["accountIdentifier"];
            if (Array.isArray(_data["accountReferences"])) {
                this.accountReferences = [] as any;
                for (let item of _data["accountReferences"])
                    this.accountReferences!.push(item);
            }
            this.limit = _data["limit"];
            this.offset = _data["offset"];
            this.showParentsOnly = _data["showParentsOnly"];
            this.excludeSearchFilter = _data["excludeSearchFilter"];
            this.sortCriteria = _data["sortCriteria"] ? ElasticSortCriteria.fromJS(_data["sortCriteria"]) : <any>undefined;
            this.searchFilter = _data["searchFilter"] ? AssetLifecycleSearchFilterDto.fromJS(_data["searchFilter"]) : <any>undefined;
            this.scrollSearch = _data["scrollSearch"];
        }
    }

    static fromJS(data: any): AssetLifecycleSearchRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetLifecycleSearchRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountIdentifier"] = this.accountIdentifier;
        if (Array.isArray(this.accountReferences)) {
            data["accountReferences"] = [];
            for (let item of this.accountReferences)
                data["accountReferences"].push(item);
        }
        data["limit"] = this.limit;
        data["offset"] = this.offset;
        data["showParentsOnly"] = this.showParentsOnly;
        data["excludeSearchFilter"] = this.excludeSearchFilter;
        data["sortCriteria"] = this.sortCriteria ? this.sortCriteria.toJSON() : <any>undefined;
        data["searchFilter"] = this.searchFilter ? this.searchFilter.toJSON() : <any>undefined;
        data["scrollSearch"] = this.scrollSearch;
        return data;
    }
}

export interface IAssetLifecycleSearchRequestDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    limit?: number | undefined;
    offset?: number | undefined;
    showParentsOnly?: boolean | undefined;
    excludeSearchFilter?: boolean;
    sortCriteria?: ElasticSortCriteria;
    searchFilter?: AssetLifecycleSearchFilterDto;
    scrollSearch?: boolean;
}

export class AssetProductCatalogSearchRequestDto implements IAssetProductCatalogSearchRequestDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    excludeSearchFilter?: boolean;
    searchFilter?: AssetProductSearchFilterDto;

    constructor(data?: IAssetProductCatalogSearchRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountIdentifier = _data["accountIdentifier"];
            if (Array.isArray(_data["accountReferences"])) {
                this.accountReferences = [] as any;
                for (let item of _data["accountReferences"])
                    this.accountReferences!.push(item);
            }
            this.excludeSearchFilter = _data["excludeSearchFilter"];
            this.searchFilter = _data["searchFilter"] ? AssetProductSearchFilterDto.fromJS(_data["searchFilter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AssetProductCatalogSearchRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetProductCatalogSearchRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountIdentifier"] = this.accountIdentifier;
        if (Array.isArray(this.accountReferences)) {
            data["accountReferences"] = [];
            for (let item of this.accountReferences)
                data["accountReferences"].push(item);
        }
        data["excludeSearchFilter"] = this.excludeSearchFilter;
        data["searchFilter"] = this.searchFilter ? this.searchFilter.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAssetProductCatalogSearchRequestDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    excludeSearchFilter?: boolean;
    searchFilter?: AssetProductSearchFilterDto;
}

export class CiscoIbaAssetsArchitectureLdosRequestDto implements ICiscoIbaAssetsArchitectureLdosRequestDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    searchFilterInclude?: CiscoIbaSearchFilterDto | undefined;
    searchFilterExclude?: CiscoIbaSearchFilterDto | undefined;
    includeUncovered?: boolean;

    constructor(data?: ICiscoIbaAssetsArchitectureLdosRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountIdentifier = _data["accountIdentifier"];
            if (Array.isArray(_data["accountReferences"])) {
                this.accountReferences = [] as any;
                for (let item of _data["accountReferences"])
                    this.accountReferences!.push(item);
            }
            this.searchFilterInclude = _data["searchFilterInclude"] ? CiscoIbaSearchFilterDto.fromJS(_data["searchFilterInclude"]) : <any>undefined;
            this.searchFilterExclude = _data["searchFilterExclude"] ? CiscoIbaSearchFilterDto.fromJS(_data["searchFilterExclude"]) : <any>undefined;
            this.includeUncovered = _data["includeUncovered"];
        }
    }

    static fromJS(data: any): CiscoIbaAssetsArchitectureLdosRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaAssetsArchitectureLdosRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountIdentifier"] = this.accountIdentifier;
        if (Array.isArray(this.accountReferences)) {
            data["accountReferences"] = [];
            for (let item of this.accountReferences)
                data["accountReferences"].push(item);
        }
        data["searchFilterInclude"] = this.searchFilterInclude ? this.searchFilterInclude.toJSON() : <any>undefined;
        data["searchFilterExclude"] = this.searchFilterExclude ? this.searchFilterExclude.toJSON() : <any>undefined;
        data["includeUncovered"] = this.includeUncovered;
        return data;
    }
}

export interface ICiscoIbaAssetsArchitectureLdosRequestDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    searchFilterInclude?: CiscoIbaSearchFilterDto | undefined;
    searchFilterExclude?: CiscoIbaSearchFilterDto | undefined;
    includeUncovered?: boolean;
}

export class CiscoIbaAssetsSearchRequestDto implements ICiscoIbaAssetsSearchRequestDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    searchFor?: string | undefined;
    excludeSearchFor?: boolean | undefined;
    searchFilterInclude?: CiscoIbaAssetsSearchFilterDto;
    searchFilterExclude?: CiscoIbaAssetsSearchFilterDto;
    limit?: number | undefined;
    offset?: number | undefined;
    sortCriteria?: ElasticSortCriteria;

    constructor(data?: ICiscoIbaAssetsSearchRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountIdentifier = _data["accountIdentifier"];
            if (Array.isArray(_data["accountReferences"])) {
                this.accountReferences = [] as any;
                for (let item of _data["accountReferences"])
                    this.accountReferences!.push(item);
            }
            this.searchFor = _data["searchFor"];
            this.excludeSearchFor = _data["excludeSearchFor"];
            this.searchFilterInclude = _data["searchFilterInclude"] ? CiscoIbaAssetsSearchFilterDto.fromJS(_data["searchFilterInclude"]) : <any>undefined;
            this.searchFilterExclude = _data["searchFilterExclude"] ? CiscoIbaAssetsSearchFilterDto.fromJS(_data["searchFilterExclude"]) : <any>undefined;
            this.limit = _data["limit"];
            this.offset = _data["offset"];
            this.sortCriteria = _data["sortCriteria"] ? ElasticSortCriteria.fromJS(_data["sortCriteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CiscoIbaAssetsSearchRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaAssetsSearchRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountIdentifier"] = this.accountIdentifier;
        if (Array.isArray(this.accountReferences)) {
            data["accountReferences"] = [];
            for (let item of this.accountReferences)
                data["accountReferences"].push(item);
        }
        data["searchFor"] = this.searchFor;
        data["excludeSearchFor"] = this.excludeSearchFor;
        data["searchFilterInclude"] = this.searchFilterInclude ? this.searchFilterInclude.toJSON() : <any>undefined;
        data["searchFilterExclude"] = this.searchFilterExclude ? this.searchFilterExclude.toJSON() : <any>undefined;
        data["limit"] = this.limit;
        data["offset"] = this.offset;
        data["sortCriteria"] = this.sortCriteria ? this.sortCriteria.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICiscoIbaAssetsSearchRequestDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    searchFor?: string | undefined;
    excludeSearchFor?: boolean | undefined;
    searchFilterInclude?: CiscoIbaAssetsSearchFilterDto;
    searchFilterExclude?: CiscoIbaAssetsSearchFilterDto;
    limit?: number | undefined;
    offset?: number | undefined;
    sortCriteria?: ElasticSortCriteria;
}

export class CiscoIbaLdosRequestDto implements ICiscoIbaLdosRequestDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    searchFilterInclude?: CiscoIbaSearchFilterDto | undefined;
    searchFilterExclude?: CiscoIbaSearchFilterDto | undefined;
    selectedDateRange?: CiscoIbaFilterDates;

    constructor(data?: ICiscoIbaLdosRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountIdentifier = _data["accountIdentifier"];
            if (Array.isArray(_data["accountReferences"])) {
                this.accountReferences = [] as any;
                for (let item of _data["accountReferences"])
                    this.accountReferences!.push(item);
            }
            this.searchFilterInclude = _data["searchFilterInclude"] ? CiscoIbaSearchFilterDto.fromJS(_data["searchFilterInclude"]) : <any>undefined;
            this.searchFilterExclude = _data["searchFilterExclude"] ? CiscoIbaSearchFilterDto.fromJS(_data["searchFilterExclude"]) : <any>undefined;
            this.selectedDateRange = _data["selectedDateRange"];
        }
    }

    static fromJS(data: any): CiscoIbaLdosRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaLdosRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountIdentifier"] = this.accountIdentifier;
        if (Array.isArray(this.accountReferences)) {
            data["accountReferences"] = [];
            for (let item of this.accountReferences)
                data["accountReferences"].push(item);
        }
        data["searchFilterInclude"] = this.searchFilterInclude ? this.searchFilterInclude.toJSON() : <any>undefined;
        data["searchFilterExclude"] = this.searchFilterExclude ? this.searchFilterExclude.toJSON() : <any>undefined;
        data["selectedDateRange"] = this.selectedDateRange;
        return data;
    }
}

export interface ICiscoIbaLdosRequestDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    searchFilterInclude?: CiscoIbaSearchFilterDto | undefined;
    searchFilterExclude?: CiscoIbaSearchFilterDto | undefined;
    selectedDateRange?: CiscoIbaFilterDates;
}

export class CiscoIbaShippedHardwareRequestDto implements ICiscoIbaShippedHardwareRequestDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    searchFilterInclude?: CiscoIbaSearchFilterDto | undefined;
    searchFilterExclude?: CiscoIbaSearchFilterDto | undefined;

    constructor(data?: ICiscoIbaShippedHardwareRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountIdentifier = _data["accountIdentifier"];
            if (Array.isArray(_data["accountReferences"])) {
                this.accountReferences = [] as any;
                for (let item of _data["accountReferences"])
                    this.accountReferences!.push(item);
            }
            this.searchFilterInclude = _data["searchFilterInclude"] ? CiscoIbaSearchFilterDto.fromJS(_data["searchFilterInclude"]) : <any>undefined;
            this.searchFilterExclude = _data["searchFilterExclude"] ? CiscoIbaSearchFilterDto.fromJS(_data["searchFilterExclude"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CiscoIbaShippedHardwareRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaShippedHardwareRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountIdentifier"] = this.accountIdentifier;
        if (Array.isArray(this.accountReferences)) {
            data["accountReferences"] = [];
            for (let item of this.accountReferences)
                data["accountReferences"].push(item);
        }
        data["searchFilterInclude"] = this.searchFilterInclude ? this.searchFilterInclude.toJSON() : <any>undefined;
        data["searchFilterExclude"] = this.searchFilterExclude ? this.searchFilterExclude.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICiscoIbaShippedHardwareRequestDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    searchFilterInclude?: CiscoIbaSearchFilterDto | undefined;
    searchFilterExclude?: CiscoIbaSearchFilterDto | undefined;
}

export class GuidsWidgetRequestDto implements IGuidsWidgetRequestDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    searchFilterInclude?: CiscoIbaSearchFilterDto | undefined;
    searchFilterExclude?: CiscoIbaSearchFilterDto | undefined;

    constructor(data?: IGuidsWidgetRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountIdentifier = _data["accountIdentifier"];
            if (Array.isArray(_data["accountReferences"])) {
                this.accountReferences = [] as any;
                for (let item of _data["accountReferences"])
                    this.accountReferences!.push(item);
            }
            this.searchFilterInclude = _data["searchFilterInclude"] ? CiscoIbaSearchFilterDto.fromJS(_data["searchFilterInclude"]) : <any>undefined;
            this.searchFilterExclude = _data["searchFilterExclude"] ? CiscoIbaSearchFilterDto.fromJS(_data["searchFilterExclude"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GuidsWidgetRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GuidsWidgetRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountIdentifier"] = this.accountIdentifier;
        if (Array.isArray(this.accountReferences)) {
            data["accountReferences"] = [];
            for (let item of this.accountReferences)
                data["accountReferences"].push(item);
        }
        data["searchFilterInclude"] = this.searchFilterInclude ? this.searchFilterInclude.toJSON() : <any>undefined;
        data["searchFilterExclude"] = this.searchFilterExclude ? this.searchFilterExclude.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGuidsWidgetRequestDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    searchFilterInclude?: CiscoIbaSearchFilterDto | undefined;
    searchFilterExclude?: CiscoIbaSearchFilterDto | undefined;
}

export class SmartNetSlasWidgetRequestDto implements ISmartNetSlasWidgetRequestDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    searchFilterInclude?: CiscoIbaSearchFilterDto | undefined;
    searchFilterExclude?: CiscoIbaSearchFilterDto | undefined;

    constructor(data?: ISmartNetSlasWidgetRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountIdentifier = _data["accountIdentifier"];
            if (Array.isArray(_data["accountReferences"])) {
                this.accountReferences = [] as any;
                for (let item of _data["accountReferences"])
                    this.accountReferences!.push(item);
            }
            this.searchFilterInclude = _data["searchFilterInclude"] ? CiscoIbaSearchFilterDto.fromJS(_data["searchFilterInclude"]) : <any>undefined;
            this.searchFilterExclude = _data["searchFilterExclude"] ? CiscoIbaSearchFilterDto.fromJS(_data["searchFilterExclude"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SmartNetSlasWidgetRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SmartNetSlasWidgetRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountIdentifier"] = this.accountIdentifier;
        if (Array.isArray(this.accountReferences)) {
            data["accountReferences"] = [];
            for (let item of this.accountReferences)
                data["accountReferences"].push(item);
        }
        data["searchFilterInclude"] = this.searchFilterInclude ? this.searchFilterInclude.toJSON() : <any>undefined;
        data["searchFilterExclude"] = this.searchFilterExclude ? this.searchFilterExclude.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISmartNetSlasWidgetRequestDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    searchFilterInclude?: CiscoIbaSearchFilterDto | undefined;
    searchFilterExclude?: CiscoIbaSearchFilterDto | undefined;
}

export class GetServiceRequestVisuals implements IGetServiceRequestVisuals {
    visuals?: { [key: string]: ServiceRequestBaseElasticQueryRequest; } | undefined;

    constructor(data?: IGetServiceRequestVisuals) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["visuals"]) {
                this.visuals = {} as any;
                for (let key in _data["visuals"]) {
                    if (_data["visuals"].hasOwnProperty(key))
                        (<any>this.visuals)![key] = _data["visuals"][key] ? ServiceRequestBaseElasticQueryRequest.fromJS(_data["visuals"][key]) : new ServiceRequestBaseElasticQueryRequest();
                }
            }
        }
    }

    static fromJS(data: any): GetServiceRequestVisuals {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceRequestVisuals();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.visuals) {
            data["visuals"] = {};
            for (let key in this.visuals) {
                if (this.visuals.hasOwnProperty(key))
                    (<any>data["visuals"])[key] = this.visuals[key] ? this.visuals[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IGetServiceRequestVisuals {
    visuals?: { [key: string]: ServiceRequestBaseElasticQueryRequest; } | undefined;
}

export class ServiceRequestBaseQueryRequest implements IServiceRequestBaseQueryRequest {
    query?: ServiceRequestSearchQuery;

    protected _discriminator: string;

    constructor(data?: IServiceRequestBaseQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "ServiceRequestBaseQueryRequest";
    }

    init(_data?: any) {
        if (_data) {
            this.query = _data["query"] ? ServiceRequestSearchQuery.fromJS(_data["query"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceRequestBaseQueryRequest {
        data = typeof data === 'object' ? data : {};
        if (data["typeName"] === "GetUniqueFilterValuesRequestBase") {
            let result = new GetUniqueFilterValuesRequestBase();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "ServiceRequestBaseElasticQueryRequest") {
            let result = new ServiceRequestBaseElasticQueryRequest();
            result.init(data);
            return result;
        }
        let result = new ServiceRequestBaseQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeName"] = this._discriminator;
        data["query"] = this.query ? this.query.toJSON() : <any>undefined;
        return data;
    }
}

export interface IServiceRequestBaseQueryRequest {
    query?: ServiceRequestSearchQuery;
}

export class GetUniqueFilterValuesRequestBase extends ServiceRequestBaseQueryRequest implements IGetUniqueFilterValuesRequestBase {
    contactId?: number;
    serviceRequestQueryType?: ServiceRequestQueryType;
    isAdmin?: boolean;

    constructor(data?: IGetUniqueFilterValuesRequestBase) {
        super(data);
        this._discriminator = "GetUniqueFilterValuesRequestBase";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contactId = _data["contactId"];
            this.serviceRequestQueryType = _data["serviceRequestQueryType"];
            this.isAdmin = _data["isAdmin"];
        }
    }

    static override fromJS(data: any): GetUniqueFilterValuesRequestBase {
        data = typeof data === 'object' ? data : {};
        let result = new GetUniqueFilterValuesRequestBase();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["serviceRequestQueryType"] = this.serviceRequestQueryType;
        data["isAdmin"] = this.isAdmin;
        super.toJSON(data);
        return data;
    }
}

export interface IGetUniqueFilterValuesRequestBase extends IServiceRequestBaseQueryRequest {
    contactId?: number;
    serviceRequestQueryType?: ServiceRequestQueryType;
    isAdmin?: boolean;
}

export class ServiceRequestBaseElasticQueryRequest extends ServiceRequestBaseQueryRequest implements IServiceRequestBaseElasticQueryRequest {
    contactId?: number;
    serviceRequestQueryType?: ServiceRequestQueryType;
    isAdmin?: boolean;

    constructor(data?: IServiceRequestBaseElasticQueryRequest) {
        super(data);
        this._discriminator = "ServiceRequestBaseElasticQueryRequest";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contactId = _data["contactId"];
            this.serviceRequestQueryType = _data["serviceRequestQueryType"];
            this.isAdmin = _data["isAdmin"];
        }
    }

    static override fromJS(data: any): ServiceRequestBaseElasticQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestBaseElasticQueryRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["serviceRequestQueryType"] = this.serviceRequestQueryType;
        data["isAdmin"] = this.isAdmin;
        super.toJSON(data);
        return data;
    }
}

export interface IServiceRequestBaseElasticQueryRequest extends IServiceRequestBaseQueryRequest {
    contactId?: number;
    serviceRequestQueryType?: ServiceRequestQueryType;
    isAdmin?: boolean;
}

export class CiscoIbaSearchRequestDto implements ICiscoIbaSearchRequestDto {
    searchFor?: string | undefined;
    excludeSearchFor?: boolean | undefined;
    searchFilterInclude?: CiscoIbaSearchFilterDto | undefined;
    searchFilterExclude?: CiscoIbaSearchFilterDto | undefined;

    constructor(data?: ICiscoIbaSearchRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchFor = _data["searchFor"];
            this.excludeSearchFor = _data["excludeSearchFor"];
            this.searchFilterInclude = _data["searchFilterInclude"] ? CiscoIbaSearchFilterDto.fromJS(_data["searchFilterInclude"]) : <any>undefined;
            this.searchFilterExclude = _data["searchFilterExclude"] ? CiscoIbaSearchFilterDto.fromJS(_data["searchFilterExclude"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CiscoIbaSearchRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaSearchRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchFor"] = this.searchFor;
        data["excludeSearchFor"] = this.excludeSearchFor;
        data["searchFilterInclude"] = this.searchFilterInclude ? this.searchFilterInclude.toJSON() : <any>undefined;
        data["searchFilterExclude"] = this.searchFilterExclude ? this.searchFilterExclude.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICiscoIbaSearchRequestDto {
    searchFor?: string | undefined;
    excludeSearchFor?: boolean | undefined;
    searchFilterInclude?: CiscoIbaSearchFilterDto | undefined;
    searchFilterExclude?: CiscoIbaSearchFilterDto | undefined;
}

export class CiscoIbaTableDownloadRequestDto implements ICiscoIbaTableDownloadRequestDto {
    query?: CiscoIbaSearchRequestDto;
    gridDefinitions?: ExcelDownloadDefinition[] | undefined;

    constructor(data?: ICiscoIbaTableDownloadRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.query = _data["query"] ? CiscoIbaSearchRequestDto.fromJS(_data["query"]) : <any>undefined;
            if (Array.isArray(_data["gridDefinitions"])) {
                this.gridDefinitions = [] as any;
                for (let item of _data["gridDefinitions"])
                    this.gridDefinitions!.push(ExcelDownloadDefinition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CiscoIbaTableDownloadRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaTableDownloadRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query ? this.query.toJSON() : <any>undefined;
        if (Array.isArray(this.gridDefinitions)) {
            data["gridDefinitions"] = [];
            for (let item of this.gridDefinitions)
                data["gridDefinitions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICiscoIbaTableDownloadRequestDto {
    query?: CiscoIbaSearchRequestDto;
    gridDefinitions?: ExcelDownloadDefinition[] | undefined;
}

export class ElasticDateRangeFilter implements IElasticDateRangeFilter {
    startDate?: DateMath;
    endDate?: DateMath;

    constructor(data?: IElasticDateRangeFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? DateMath.fromJS(_data["startDate"]) : <any>undefined;
            this.endDate = _data["endDate"] ? DateMath.fromJS(_data["endDate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ElasticDateRangeFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ElasticDateRangeFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toJSON() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toJSON() : <any>undefined;
        return data;
    }
}

export interface IElasticDateRangeFilter {
    startDate?: DateMath;
    endDate?: DateMath;
}

export class ElasticSortCriteria implements IElasticSortCriteria {
    descending?: boolean;
    sortField?: string | undefined;

    constructor(data?: IElasticSortCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.descending = _data["descending"];
            this.sortField = _data["sortField"];
        }
    }

    static fromJS(data: any): ElasticSortCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new ElasticSortCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["descending"] = this.descending;
        data["sortField"] = this.sortField;
        return data;
    }
}

export interface IElasticSortCriteria {
    descending?: boolean;
    sortField?: string | undefined;
}

export class ContractRequestRankingDto implements IContractRequestRankingDto {
    contractId?: number;
    contractName?: string | undefined;
    requestsCount?: number;
    requestsPercentage?: number;

    constructor(data?: IContractRequestRankingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractId = _data["contractId"];
            this.contractName = _data["contractName"];
            this.requestsCount = _data["requestsCount"];
            this.requestsPercentage = _data["requestsPercentage"];
        }
    }

    static fromJS(data: any): ContractRequestRankingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractRequestRankingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractId"] = this.contractId;
        data["contractName"] = this.contractName;
        data["requestsCount"] = this.requestsCount;
        data["requestsPercentage"] = this.requestsPercentage;
        return data;
    }
}

export interface IContractRequestRankingDto {
    contractId?: number;
    contractName?: string | undefined;
    requestsCount?: number;
    requestsPercentage?: number;
}

export class ContractRequestRankingsVisualsDto implements IContractRequestRankingsVisualsDto {
    contractRequestRankings?: ContractRequestRankingDto[] | undefined;

    constructor(data?: IContractRequestRankingsVisualsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["contractRequestRankings"])) {
                this.contractRequestRankings = [] as any;
                for (let item of _data["contractRequestRankings"])
                    this.contractRequestRankings!.push(ContractRequestRankingDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContractRequestRankingsVisualsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractRequestRankingsVisualsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contractRequestRankings)) {
            data["contractRequestRankings"] = [];
            for (let item of this.contractRequestRankings)
                data["contractRequestRankings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IContractRequestRankingsVisualsDto {
    contractRequestRankings?: ContractRequestRankingDto[] | undefined;
}

export class ElasticDateRangeQueryFilter implements IElasticDateRangeQueryFilter {
    startDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: IElasticDateRangeQueryFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ElasticDateRangeQueryFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ElasticDateRangeQueryFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IElasticDateRangeQueryFilter {
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export class MonthlyReportDto implements IMonthlyReportDto {
    month?: number;
    createdTickets?: number;
    completedTickets?: number;
    monthDate?: Date;
    monthName?: string | undefined;
    monthNameShort?: string | undefined;

    constructor(data?: IMonthlyReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data["month"];
            this.createdTickets = _data["createdTickets"];
            this.completedTickets = _data["completedTickets"];
            this.monthDate = _data["monthDate"] ? new Date(_data["monthDate"].toString()) : <any>undefined;
            this.monthName = _data["monthName"];
            this.monthNameShort = _data["monthNameShort"];
        }
    }

    static fromJS(data: any): MonthlyReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        data["createdTickets"] = this.createdTickets;
        data["completedTickets"] = this.completedTickets;
        data["monthDate"] = this.monthDate ? this.monthDate.toISOString() : <any>undefined;
        data["monthName"] = this.monthName;
        data["monthNameShort"] = this.monthNameShort;
        return data;
    }
}

export interface IMonthlyReportDto {
    month?: number;
    createdTickets?: number;
    completedTickets?: number;
    monthDate?: Date;
    monthName?: string | undefined;
    monthNameShort?: string | undefined;
}

export class MonthlyReportsDto implements IMonthlyReportsDto {
    reports?: MonthlyReportDto[] | undefined;

    constructor(data?: IMonthlyReportsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["reports"])) {
                this.reports = [] as any;
                for (let item of _data["reports"])
                    this.reports!.push(MonthlyReportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MonthlyReportsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyReportsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.reports)) {
            data["reports"] = [];
            for (let item of this.reports)
                data["reports"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMonthlyReportsDto {
    reports?: MonthlyReportDto[] | undefined;
}

export class RequestMetricsVisualsDto implements IRequestMetricsVisualsDto {
    averageRating?: number | undefined;
    firstResponseMetPercentage?: number | undefined;
    firstResponseNotMetCount?: number | undefined;
    firstResponseNotMetWarning?: boolean | undefined;

    constructor(data?: IRequestMetricsVisualsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.averageRating = _data["averageRating"];
            this.firstResponseMetPercentage = _data["firstResponseMetPercentage"];
            this.firstResponseNotMetCount = _data["firstResponseNotMetCount"];
            this.firstResponseNotMetWarning = _data["firstResponseNotMetWarning"];
        }
    }

    static fromJS(data: any): RequestMetricsVisualsDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestMetricsVisualsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["averageRating"] = this.averageRating;
        data["firstResponseMetPercentage"] = this.firstResponseMetPercentage;
        data["firstResponseNotMetCount"] = this.firstResponseNotMetCount;
        data["firstResponseNotMetWarning"] = this.firstResponseNotMetWarning;
        return data;
    }
}

export interface IRequestMetricsVisualsDto {
    averageRating?: number | undefined;
    firstResponseMetPercentage?: number | undefined;
    firstResponseNotMetCount?: number | undefined;
    firstResponseNotMetWarning?: boolean | undefined;
}

export class RequesterRankingDto implements IRequesterRankingDto {
    requester?: string | undefined;
    requestCount?: number;
    requestPercentage?: number;

    constructor(data?: IRequesterRankingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requester = _data["requester"];
            this.requestCount = _data["requestCount"];
            this.requestPercentage = _data["requestPercentage"];
        }
    }

    static fromJS(data: any): RequesterRankingDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequesterRankingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requester"] = this.requester;
        data["requestCount"] = this.requestCount;
        data["requestPercentage"] = this.requestPercentage;
        return data;
    }
}

export interface IRequesterRankingDto {
    requester?: string | undefined;
    requestCount?: number;
    requestPercentage?: number;
}

export class RequesterRankingsVisualsDto implements IRequesterRankingsVisualsDto {
    requesterRankings?: RequesterRankingDto[] | undefined;

    constructor(data?: IRequesterRankingsVisualsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["requesterRankings"])) {
                this.requesterRankings = [] as any;
                for (let item of _data["requesterRankings"])
                    this.requesterRankings!.push(RequesterRankingDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RequesterRankingsVisualsDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequesterRankingsVisualsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.requesterRankings)) {
            data["requesterRankings"] = [];
            for (let item of this.requesterRankings)
                data["requesterRankings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRequesterRankingsVisualsDto {
    requesterRankings?: RequesterRankingDto[] | undefined;
}

export class ServiceRequestDto implements IServiceRequestDto {
    id?: number;
    requestIdentifier?: string | undefined;
    description?: string | undefined;
    createdById?: number | undefined;
    createdBy?: string | undefined;
    secondaryContacts?: number[] | undefined;
    assignedToId?: number | undefined;
    assignedTo?: string | undefined;
    accountId?: number;
    serviceRequestType?: string | undefined;
    status?: string | undefined;
    activeOrComplete?: string | undefined;
    priority?: string | undefined;
    serviceRequestCategory?: string | undefined;
    issueType?: string | undefined;
    subIssueType?: string | undefined;
    title?: string | undefined;
    createdDate?: Date;
    lastModifiedDate?: Date;
    completedDate?: Date;
    firstResponseMet?: boolean | undefined;
    surveyRating?: number | undefined;
    createdByEmail?: string | undefined;
    isAllowedForSla?: boolean;
    isWaitingForResponse?: boolean;
    billingItemIds?: number[] | undefined;
    totalBillingHours?: number | undefined;
    totalBillingAmount?: number | undefined;
    contractId?: number | undefined;
    contractName?: string | undefined;
    purchaseOrderNumber?: string | undefined;

    constructor(data?: IServiceRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.requestIdentifier = _data["requestIdentifier"];
            this.description = _data["description"];
            this.createdById = _data["createdById"];
            this.createdBy = _data["createdBy"];
            if (Array.isArray(_data["secondaryContacts"])) {
                this.secondaryContacts = [] as any;
                for (let item of _data["secondaryContacts"])
                    this.secondaryContacts!.push(item);
            }
            this.assignedToId = _data["assignedToId"];
            this.assignedTo = _data["assignedTo"];
            this.accountId = _data["accountId"];
            this.serviceRequestType = _data["serviceRequestType"];
            this.status = _data["status"];
            this.activeOrComplete = _data["activeOrComplete"];
            this.priority = _data["priority"];
            this.serviceRequestCategory = _data["serviceRequestCategory"];
            this.issueType = _data["issueType"];
            this.subIssueType = _data["subIssueType"];
            this.title = _data["title"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            this.completedDate = _data["completedDate"] ? new Date(_data["completedDate"].toString()) : <any>undefined;
            this.firstResponseMet = _data["firstResponseMet"];
            this.surveyRating = _data["surveyRating"];
            this.createdByEmail = _data["createdByEmail"];
            this.isAllowedForSla = _data["isAllowedForSla"];
            this.isWaitingForResponse = _data["isWaitingForResponse"];
            if (Array.isArray(_data["billingItemIds"])) {
                this.billingItemIds = [] as any;
                for (let item of _data["billingItemIds"])
                    this.billingItemIds!.push(item);
            }
            this.totalBillingHours = _data["totalBillingHours"];
            this.totalBillingAmount = _data["totalBillingAmount"];
            this.contractId = _data["contractId"];
            this.contractName = _data["contractName"];
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
        }
    }

    static fromJS(data: any): ServiceRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["requestIdentifier"] = this.requestIdentifier;
        data["description"] = this.description;
        data["createdById"] = this.createdById;
        data["createdBy"] = this.createdBy;
        if (Array.isArray(this.secondaryContacts)) {
            data["secondaryContacts"] = [];
            for (let item of this.secondaryContacts)
                data["secondaryContacts"].push(item);
        }
        data["assignedToId"] = this.assignedToId;
        data["assignedTo"] = this.assignedTo;
        data["accountId"] = this.accountId;
        data["serviceRequestType"] = this.serviceRequestType;
        data["status"] = this.status;
        data["activeOrComplete"] = this.activeOrComplete;
        data["priority"] = this.priority;
        data["serviceRequestCategory"] = this.serviceRequestCategory;
        data["issueType"] = this.issueType;
        data["subIssueType"] = this.subIssueType;
        data["title"] = this.title;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["completedDate"] = this.completedDate ? this.completedDate.toISOString() : <any>undefined;
        data["firstResponseMet"] = this.firstResponseMet;
        data["surveyRating"] = this.surveyRating;
        data["createdByEmail"] = this.createdByEmail;
        data["isAllowedForSla"] = this.isAllowedForSla;
        data["isWaitingForResponse"] = this.isWaitingForResponse;
        if (Array.isArray(this.billingItemIds)) {
            data["billingItemIds"] = [];
            for (let item of this.billingItemIds)
                data["billingItemIds"].push(item);
        }
        data["totalBillingHours"] = this.totalBillingHours;
        data["totalBillingAmount"] = this.totalBillingAmount;
        data["contractId"] = this.contractId;
        data["contractName"] = this.contractName;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        return data;
    }
}

export interface IServiceRequestDto {
    id?: number;
    requestIdentifier?: string | undefined;
    description?: string | undefined;
    createdById?: number | undefined;
    createdBy?: string | undefined;
    secondaryContacts?: number[] | undefined;
    assignedToId?: number | undefined;
    assignedTo?: string | undefined;
    accountId?: number;
    serviceRequestType?: string | undefined;
    status?: string | undefined;
    activeOrComplete?: string | undefined;
    priority?: string | undefined;
    serviceRequestCategory?: string | undefined;
    issueType?: string | undefined;
    subIssueType?: string | undefined;
    title?: string | undefined;
    createdDate?: Date;
    lastModifiedDate?: Date;
    completedDate?: Date;
    firstResponseMet?: boolean | undefined;
    surveyRating?: number | undefined;
    createdByEmail?: string | undefined;
    isAllowedForSla?: boolean;
    isWaitingForResponse?: boolean;
    billingItemIds?: number[] | undefined;
    totalBillingHours?: number | undefined;
    totalBillingAmount?: number | undefined;
    contractId?: number | undefined;
    contractName?: string | undefined;
    purchaseOrderNumber?: string | undefined;
}

export class ServiceRequestIssueRankingsWidgetDto implements IServiceRequestIssueRankingsWidgetDto {
    issueRankings?: { [key: string]: ServiceRequestSubIssueRankingDto; } | undefined;
    totalRecordsCount?: number;

    constructor(data?: IServiceRequestIssueRankingsWidgetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["issueRankings"]) {
                this.issueRankings = {} as any;
                for (let key in _data["issueRankings"]) {
                    if (_data["issueRankings"].hasOwnProperty(key))
                        (<any>this.issueRankings)![key] = _data["issueRankings"][key] ? ServiceRequestSubIssueRankingDto.fromJS(_data["issueRankings"][key]) : new ServiceRequestSubIssueRankingDto();
                }
            }
            this.totalRecordsCount = _data["totalRecordsCount"];
        }
    }

    static fromJS(data: any): ServiceRequestIssueRankingsWidgetDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestIssueRankingsWidgetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.issueRankings) {
            data["issueRankings"] = {};
            for (let key in this.issueRankings) {
                if (this.issueRankings.hasOwnProperty(key))
                    (<any>data["issueRankings"])[key] = this.issueRankings[key] ? this.issueRankings[key].toJSON() : <any>undefined;
            }
        }
        data["totalRecordsCount"] = this.totalRecordsCount;
        return data;
    }
}

export interface IServiceRequestIssueRankingsWidgetDto {
    issueRankings?: { [key: string]: ServiceRequestSubIssueRankingDto; } | undefined;
    totalRecordsCount?: number;
}

export class ServiceRequestListDocumentDto implements IServiceRequestListDocumentDto {
    serviceRequestDtos?: ServiceRequestDto[] | undefined;
    totalCount?: number;

    constructor(data?: IServiceRequestListDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["serviceRequestDtos"])) {
                this.serviceRequestDtos = [] as any;
                for (let item of _data["serviceRequestDtos"])
                    this.serviceRequestDtos!.push(ServiceRequestDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ServiceRequestListDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestListDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.serviceRequestDtos)) {
            data["serviceRequestDtos"] = [];
            for (let item of this.serviceRequestDtos)
                data["serviceRequestDtos"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IServiceRequestListDocumentDto {
    serviceRequestDtos?: ServiceRequestDto[] | undefined;
    totalCount?: number;
}

export class ServiceRequestSearchQuery implements IServiceRequestSearchQuery {
    accountIds?: number[] | undefined;
    searchTerm?: string | undefined;
    termFilters?: { [key: string]: string[]; } | undefined;
    dateFilters?: { [key: string]: ElasticDateRangeFilter; } | undefined;
    sortBy?: string | undefined;
    sortOrder?: SortOrder;
    resultsFrom?: number;
    pageSize?: number;

    constructor(data?: IServiceRequestSearchQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accountIds"])) {
                this.accountIds = [] as any;
                for (let item of _data["accountIds"])
                    this.accountIds!.push(item);
            }
            this.searchTerm = _data["searchTerm"];
            if (_data["termFilters"]) {
                this.termFilters = {} as any;
                for (let key in _data["termFilters"]) {
                    if (_data["termFilters"].hasOwnProperty(key))
                        (<any>this.termFilters)![key] = _data["termFilters"][key] !== undefined ? _data["termFilters"][key] : [];
                }
            }
            if (_data["dateFilters"]) {
                this.dateFilters = {} as any;
                for (let key in _data["dateFilters"]) {
                    if (_data["dateFilters"].hasOwnProperty(key))
                        (<any>this.dateFilters)![key] = _data["dateFilters"][key] ? ElasticDateRangeFilter.fromJS(_data["dateFilters"][key]) : new ElasticDateRangeFilter();
                }
            }
            this.sortBy = _data["sortBy"];
            this.sortOrder = _data["sortOrder"];
            this.resultsFrom = _data["resultsFrom"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): ServiceRequestSearchQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestSearchQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accountIds)) {
            data["accountIds"] = [];
            for (let item of this.accountIds)
                data["accountIds"].push(item);
        }
        data["searchTerm"] = this.searchTerm;
        if (this.termFilters) {
            data["termFilters"] = {};
            for (let key in this.termFilters) {
                if (this.termFilters.hasOwnProperty(key))
                    (<any>data["termFilters"])[key] = (<any>this.termFilters)[key];
            }
        }
        if (this.dateFilters) {
            data["dateFilters"] = {};
            for (let key in this.dateFilters) {
                if (this.dateFilters.hasOwnProperty(key))
                    (<any>data["dateFilters"])[key] = this.dateFilters[key] ? this.dateFilters[key].toJSON() : <any>undefined;
            }
        }
        data["sortBy"] = this.sortBy;
        data["sortOrder"] = this.sortOrder;
        data["resultsFrom"] = this.resultsFrom;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IServiceRequestSearchQuery {
    accountIds?: number[] | undefined;
    searchTerm?: string | undefined;
    termFilters?: { [key: string]: string[]; } | undefined;
    dateFilters?: { [key: string]: ElasticDateRangeFilter; } | undefined;
    sortBy?: string | undefined;
    sortOrder?: SortOrder;
    resultsFrom?: number;
    pageSize?: number;
}

export class ServiceRequestSubIssueRankingDto implements IServiceRequestSubIssueRankingDto {
    subIssueRankings?: { [key: string]: number; } | undefined;
    totalRecords?: number;

    constructor(data?: IServiceRequestSubIssueRankingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["subIssueRankings"]) {
                this.subIssueRankings = {} as any;
                for (let key in _data["subIssueRankings"]) {
                    if (_data["subIssueRankings"].hasOwnProperty(key))
                        (<any>this.subIssueRankings)![key] = _data["subIssueRankings"][key];
                }
            }
            this.totalRecords = _data["totalRecords"];
        }
    }

    static fromJS(data: any): ServiceRequestSubIssueRankingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestSubIssueRankingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.subIssueRankings) {
            data["subIssueRankings"] = {};
            for (let key in this.subIssueRankings) {
                if (this.subIssueRankings.hasOwnProperty(key))
                    (<any>data["subIssueRankings"])[key] = (<any>this.subIssueRankings)[key];
            }
        }
        data["totalRecords"] = this.totalRecords;
        return data;
    }
}

export interface IServiceRequestSubIssueRankingDto {
    subIssueRankings?: { [key: string]: number; } | undefined;
    totalRecords?: number;
}

export class ServiceRequestTabCountsDto implements IServiceRequestTabCountsDto {
    counts?: { [key: string]: number; } | undefined;

    constructor(data?: IServiceRequestTabCountsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["counts"]) {
                this.counts = {} as any;
                for (let key in _data["counts"]) {
                    if (_data["counts"].hasOwnProperty(key))
                        (<any>this.counts)![key] = _data["counts"][key];
                }
            }
        }
    }

    static fromJS(data: any): ServiceRequestTabCountsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestTabCountsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.counts) {
            data["counts"] = {};
            for (let key in this.counts) {
                if (this.counts.hasOwnProperty(key))
                    (<any>data["counts"])[key] = (<any>this.counts)[key];
            }
        }
        return data;
    }
}

export interface IServiceRequestTabCountsDto {
    counts?: { [key: string]: number; } | undefined;
}

export class ServiceRequestVisualsDto implements IServiceRequestVisualsDto {
    visuals?: { [key: string]: { [key: string]: number; }; } | undefined;

    constructor(data?: IServiceRequestVisualsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["visuals"]) {
                this.visuals = {} as any;
                for (let key in _data["visuals"]) {
                    if (_data["visuals"].hasOwnProperty(key))
                        (<any>this.visuals)![key] = _data["visuals"][key] !== undefined ? _data["visuals"][key] : {};
                }
            }
        }
    }

    static fromJS(data: any): ServiceRequestVisualsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestVisualsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.visuals) {
            data["visuals"] = {};
            for (let key in this.visuals) {
                if (this.visuals.hasOwnProperty(key))
                    (<any>data["visuals"])[key] = (<any>this.visuals)[key];
            }
        }
        return data;
    }
}

export interface IServiceRequestVisualsDto {
    visuals?: { [key: string]: { [key: string]: number; }; } | undefined;
}

export class SupportOverviewDto implements ISupportOverviewDto {
    totalRequests?: number | undefined;
    totalOpenRequests?: number;
    totalBillingHours?: number | undefined;
    totalBillingAmount?: number | undefined;

    constructor(data?: ISupportOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRequests = _data["totalRequests"];
            this.totalOpenRequests = _data["totalOpenRequests"];
            this.totalBillingHours = _data["totalBillingHours"];
            this.totalBillingAmount = _data["totalBillingAmount"];
        }
    }

    static fromJS(data: any): SupportOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupportOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRequests"] = this.totalRequests;
        data["totalOpenRequests"] = this.totalOpenRequests;
        data["totalBillingHours"] = this.totalBillingHours;
        data["totalBillingAmount"] = this.totalBillingAmount;
        return data;
    }
}

export interface ISupportOverviewDto {
    totalRequests?: number | undefined;
    totalOpenRequests?: number;
    totalBillingHours?: number | undefined;
    totalBillingAmount?: number | undefined;
}

export class UniqueFilterValuesDto implements IUniqueFilterValuesDto {
    uniqueCreatedByValues?: string[] | undefined;
    uniqueAssignedToValues?: string[] | undefined;
    uniquePriorityValues?: string[] | undefined;
    uniqueCategoryValues?: string[] | undefined;
    uniqueRequestTypeValues?: string[] | undefined;
    uniqueIssueTypeValues?: string[] | undefined;
    uniqueStatusValues?: string[] | undefined;
    uniqueContractValues?: string[] | undefined;
    uniqueTicketNumberValues?: string[] | undefined;

    constructor(data?: IUniqueFilterValuesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["uniqueCreatedByValues"])) {
                this.uniqueCreatedByValues = [] as any;
                for (let item of _data["uniqueCreatedByValues"])
                    this.uniqueCreatedByValues!.push(item);
            }
            if (Array.isArray(_data["uniqueAssignedToValues"])) {
                this.uniqueAssignedToValues = [] as any;
                for (let item of _data["uniqueAssignedToValues"])
                    this.uniqueAssignedToValues!.push(item);
            }
            if (Array.isArray(_data["uniquePriorityValues"])) {
                this.uniquePriorityValues = [] as any;
                for (let item of _data["uniquePriorityValues"])
                    this.uniquePriorityValues!.push(item);
            }
            if (Array.isArray(_data["uniqueCategoryValues"])) {
                this.uniqueCategoryValues = [] as any;
                for (let item of _data["uniqueCategoryValues"])
                    this.uniqueCategoryValues!.push(item);
            }
            if (Array.isArray(_data["uniqueRequestTypeValues"])) {
                this.uniqueRequestTypeValues = [] as any;
                for (let item of _data["uniqueRequestTypeValues"])
                    this.uniqueRequestTypeValues!.push(item);
            }
            if (Array.isArray(_data["uniqueIssueTypeValues"])) {
                this.uniqueIssueTypeValues = [] as any;
                for (let item of _data["uniqueIssueTypeValues"])
                    this.uniqueIssueTypeValues!.push(item);
            }
            if (Array.isArray(_data["uniqueStatusValues"])) {
                this.uniqueStatusValues = [] as any;
                for (let item of _data["uniqueStatusValues"])
                    this.uniqueStatusValues!.push(item);
            }
            if (Array.isArray(_data["uniqueContractValues"])) {
                this.uniqueContractValues = [] as any;
                for (let item of _data["uniqueContractValues"])
                    this.uniqueContractValues!.push(item);
            }
            if (Array.isArray(_data["uniqueTicketNumberValues"])) {
                this.uniqueTicketNumberValues = [] as any;
                for (let item of _data["uniqueTicketNumberValues"])
                    this.uniqueTicketNumberValues!.push(item);
            }
        }
    }

    static fromJS(data: any): UniqueFilterValuesDto {
        data = typeof data === 'object' ? data : {};
        let result = new UniqueFilterValuesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.uniqueCreatedByValues)) {
            data["uniqueCreatedByValues"] = [];
            for (let item of this.uniqueCreatedByValues)
                data["uniqueCreatedByValues"].push(item);
        }
        if (Array.isArray(this.uniqueAssignedToValues)) {
            data["uniqueAssignedToValues"] = [];
            for (let item of this.uniqueAssignedToValues)
                data["uniqueAssignedToValues"].push(item);
        }
        if (Array.isArray(this.uniquePriorityValues)) {
            data["uniquePriorityValues"] = [];
            for (let item of this.uniquePriorityValues)
                data["uniquePriorityValues"].push(item);
        }
        if (Array.isArray(this.uniqueCategoryValues)) {
            data["uniqueCategoryValues"] = [];
            for (let item of this.uniqueCategoryValues)
                data["uniqueCategoryValues"].push(item);
        }
        if (Array.isArray(this.uniqueRequestTypeValues)) {
            data["uniqueRequestTypeValues"] = [];
            for (let item of this.uniqueRequestTypeValues)
                data["uniqueRequestTypeValues"].push(item);
        }
        if (Array.isArray(this.uniqueIssueTypeValues)) {
            data["uniqueIssueTypeValues"] = [];
            for (let item of this.uniqueIssueTypeValues)
                data["uniqueIssueTypeValues"].push(item);
        }
        if (Array.isArray(this.uniqueStatusValues)) {
            data["uniqueStatusValues"] = [];
            for (let item of this.uniqueStatusValues)
                data["uniqueStatusValues"].push(item);
        }
        if (Array.isArray(this.uniqueContractValues)) {
            data["uniqueContractValues"] = [];
            for (let item of this.uniqueContractValues)
                data["uniqueContractValues"].push(item);
        }
        if (Array.isArray(this.uniqueTicketNumberValues)) {
            data["uniqueTicketNumberValues"] = [];
            for (let item of this.uniqueTicketNumberValues)
                data["uniqueTicketNumberValues"].push(item);
        }
        return data;
    }
}

export interface IUniqueFilterValuesDto {
    uniqueCreatedByValues?: string[] | undefined;
    uniqueAssignedToValues?: string[] | undefined;
    uniquePriorityValues?: string[] | undefined;
    uniqueCategoryValues?: string[] | undefined;
    uniqueRequestTypeValues?: string[] | undefined;
    uniqueIssueTypeValues?: string[] | undefined;
    uniqueStatusValues?: string[] | undefined;
    uniqueContractValues?: string[] | undefined;
    uniqueTicketNumberValues?: string[] | undefined;
}

export class CreateEnv0EnvironmentRequest implements ICreateEnv0EnvironmentRequest {
    name?: string | undefined;
    projectId?: string | undefined;
    ttl?: TimeToLive;
    deployRequest?: DeployRequest;
    workspaceName?: string | undefined;
    requiresApproval?: boolean;
    configurationChanges?: ConfigurationPropertyChange[] | undefined;
    vcsCommandsAlias?: string | undefined;
    continuousDeployment?: boolean;
    pullRequestPlanDeployments?: boolean;
    driftDetectionRequest?: any | undefined;
    autoDeployOnPathChangesOnly?: boolean;
    autoDeployByCustomGlob?: string | undefined;
    terragruntWorkingDirectory?: string | undefined;
    isRemoteBackend?: boolean;
    k8sNamespace?: string | undefined;

    constructor(data?: ICreateEnv0EnvironmentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.ttl = _data["ttl"] ? TimeToLive.fromJS(_data["ttl"]) : <any>undefined;
            this.deployRequest = _data["deployRequest"] ? DeployRequest.fromJS(_data["deployRequest"]) : <any>undefined;
            this.workspaceName = _data["workspaceName"];
            this.requiresApproval = _data["requiresApproval"];
            if (Array.isArray(_data["configurationChanges"])) {
                this.configurationChanges = [] as any;
                for (let item of _data["configurationChanges"])
                    this.configurationChanges!.push(ConfigurationPropertyChange.fromJS(item));
            }
            this.vcsCommandsAlias = _data["vcsCommandsAlias"];
            this.continuousDeployment = _data["continuousDeployment"];
            this.pullRequestPlanDeployments = _data["pullRequestPlanDeployments"];
            this.driftDetectionRequest = _data["driftDetectionRequest"];
            this.autoDeployOnPathChangesOnly = _data["autoDeployOnPathChangesOnly"];
            this.autoDeployByCustomGlob = _data["autoDeployByCustomGlob"];
            this.terragruntWorkingDirectory = _data["terragruntWorkingDirectory"];
            this.isRemoteBackend = _data["isRemoteBackend"];
            this.k8sNamespace = _data["k8sNamespace"];
        }
    }

    static fromJS(data: any): CreateEnv0EnvironmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEnv0EnvironmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["ttl"] = this.ttl ? this.ttl.toJSON() : <any>undefined;
        data["deployRequest"] = this.deployRequest ? this.deployRequest.toJSON() : <any>undefined;
        data["workspaceName"] = this.workspaceName;
        data["requiresApproval"] = this.requiresApproval;
        if (Array.isArray(this.configurationChanges)) {
            data["configurationChanges"] = [];
            for (let item of this.configurationChanges)
                data["configurationChanges"].push(item.toJSON());
        }
        data["vcsCommandsAlias"] = this.vcsCommandsAlias;
        data["continuousDeployment"] = this.continuousDeployment;
        data["pullRequestPlanDeployments"] = this.pullRequestPlanDeployments;
        data["driftDetectionRequest"] = this.driftDetectionRequest;
        data["autoDeployOnPathChangesOnly"] = this.autoDeployOnPathChangesOnly;
        data["autoDeployByCustomGlob"] = this.autoDeployByCustomGlob;
        data["terragruntWorkingDirectory"] = this.terragruntWorkingDirectory;
        data["isRemoteBackend"] = this.isRemoteBackend;
        data["k8sNamespace"] = this.k8sNamespace;
        return data;
    }
}

export interface ICreateEnv0EnvironmentRequest {
    name?: string | undefined;
    projectId?: string | undefined;
    ttl?: TimeToLive;
    deployRequest?: DeployRequest;
    workspaceName?: string | undefined;
    requiresApproval?: boolean;
    configurationChanges?: ConfigurationPropertyChange[] | undefined;
    vcsCommandsAlias?: string | undefined;
    continuousDeployment?: boolean;
    pullRequestPlanDeployments?: boolean;
    driftDetectionRequest?: any | undefined;
    autoDeployOnPathChangesOnly?: boolean;
    autoDeployByCustomGlob?: string | undefined;
    terragruntWorkingDirectory?: string | undefined;
    isRemoteBackend?: boolean;
    k8sNamespace?: string | undefined;
}

export class DestroyEnv0EnvironmentRequest implements IDestroyEnv0EnvironmentRequest {
    queryParams?: DestroyEnv0EnvironmentQueryParams;
    requestBody?: DestroyEnv0EnvironmentRequestBody;

    constructor(data?: IDestroyEnv0EnvironmentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.queryParams = _data["queryParams"] ? DestroyEnv0EnvironmentQueryParams.fromJS(_data["queryParams"]) : <any>undefined;
            this.requestBody = _data["requestBody"] ? DestroyEnv0EnvironmentRequestBody.fromJS(_data["requestBody"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DestroyEnv0EnvironmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DestroyEnv0EnvironmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["queryParams"] = this.queryParams ? this.queryParams.toJSON() : <any>undefined;
        data["requestBody"] = this.requestBody ? this.requestBody.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDestroyEnv0EnvironmentRequest {
    queryParams?: DestroyEnv0EnvironmentQueryParams;
    requestBody?: DestroyEnv0EnvironmentRequestBody;
}

export class Env0EnvironmentDto implements IEnv0EnvironmentDto {
    id?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;
    name?: string | undefined;
    organizationId?: string | undefined;
    projectId?: string | undefined;
    userId?: string | undefined;
    user?: Env0UserDto;
    requiresApproval?: boolean;
    status?: string | undefined;
    latestDeploymentLogId?: string | undefined;
    latestDeploymentLog?: DeploymentLog;
    lifespanEndAt?: Date;
    markedForAutoDestroy?: number;
    isArchived?: boolean;
    nextScheduleDates?: NextScheduleDates;
    continuousDeployment?: boolean;
    pullRequestPlanDevelopment?: boolean;
    autoDeployOnPathChangesOnly?: boolean;
    isRemoteBackend?: boolean;
    isLocked?: boolean;

    constructor(data?: IEnv0EnvironmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.organizationId = _data["organizationId"];
            this.projectId = _data["projectId"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? Env0UserDto.fromJS(_data["user"]) : <any>undefined;
            this.requiresApproval = _data["requiresApproval"];
            this.status = _data["status"];
            this.latestDeploymentLogId = _data["latestDeploymentLogId"];
            this.latestDeploymentLog = _data["latestDeploymentLog"] ? DeploymentLog.fromJS(_data["latestDeploymentLog"]) : <any>undefined;
            this.lifespanEndAt = _data["lifespanEndAt"] ? new Date(_data["lifespanEndAt"].toString()) : <any>undefined;
            this.markedForAutoDestroy = _data["markedForAutoDestroy"];
            this.isArchived = _data["isArchived"];
            this.nextScheduleDates = _data["nextScheduleDates"] ? NextScheduleDates.fromJS(_data["nextScheduleDates"]) : <any>undefined;
            this.continuousDeployment = _data["continuousDeployment"];
            this.pullRequestPlanDevelopment = _data["pullRequestPlanDevelopment"];
            this.autoDeployOnPathChangesOnly = _data["autoDeployOnPathChangesOnly"];
            this.isRemoteBackend = _data["isRemoteBackend"];
            this.isLocked = _data["isLocked"];
        }
    }

    static fromJS(data: any): Env0EnvironmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new Env0EnvironmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["organizationId"] = this.organizationId;
        data["projectId"] = this.projectId;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["requiresApproval"] = this.requiresApproval;
        data["status"] = this.status;
        data["latestDeploymentLogId"] = this.latestDeploymentLogId;
        data["latestDeploymentLog"] = this.latestDeploymentLog ? this.latestDeploymentLog.toJSON() : <any>undefined;
        data["lifespanEndAt"] = this.lifespanEndAt ? this.lifespanEndAt.toISOString() : <any>undefined;
        data["markedForAutoDestroy"] = this.markedForAutoDestroy;
        data["isArchived"] = this.isArchived;
        data["nextScheduleDates"] = this.nextScheduleDates ? this.nextScheduleDates.toJSON() : <any>undefined;
        data["continuousDeployment"] = this.continuousDeployment;
        data["pullRequestPlanDevelopment"] = this.pullRequestPlanDevelopment;
        data["autoDeployOnPathChangesOnly"] = this.autoDeployOnPathChangesOnly;
        data["isRemoteBackend"] = this.isRemoteBackend;
        data["isLocked"] = this.isLocked;
        return data;
    }
}

export interface IEnv0EnvironmentDto {
    id?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;
    name?: string | undefined;
    organizationId?: string | undefined;
    projectId?: string | undefined;
    userId?: string | undefined;
    user?: Env0UserDto;
    requiresApproval?: boolean;
    status?: string | undefined;
    latestDeploymentLogId?: string | undefined;
    latestDeploymentLog?: DeploymentLog;
    lifespanEndAt?: Date;
    markedForAutoDestroy?: number;
    isArchived?: boolean;
    nextScheduleDates?: NextScheduleDates;
    continuousDeployment?: boolean;
    pullRequestPlanDevelopment?: boolean;
    autoDeployOnPathChangesOnly?: boolean;
    isRemoteBackend?: boolean;
    isLocked?: boolean;
}

export class UpdateEnv0EnvironmentRequest implements IUpdateEnv0EnvironmentRequest {
    name?: string | undefined;
    requiresApproval?: boolean;
    isArchived?: boolean;
    continuousDeployment?: boolean;
    vcsCommandsAlias?: string | undefined;
    pullRequestPlanDeployments?: boolean;
    autoDeployOnPathChangesOnly?: boolean;
    autoDeployByCustomGlob?: string | undefined;
    isRemoteBackend?: boolean;

    constructor(data?: IUpdateEnv0EnvironmentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.requiresApproval = _data["requiresApproval"];
            this.isArchived = _data["isArchived"];
            this.continuousDeployment = _data["continuousDeployment"];
            this.vcsCommandsAlias = _data["vcsCommandsAlias"];
            this.pullRequestPlanDeployments = _data["pullRequestPlanDeployments"];
            this.autoDeployOnPathChangesOnly = _data["autoDeployOnPathChangesOnly"];
            this.autoDeployByCustomGlob = _data["autoDeployByCustomGlob"];
            this.isRemoteBackend = _data["isRemoteBackend"];
        }
    }

    static fromJS(data: any): UpdateEnv0EnvironmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEnv0EnvironmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["requiresApproval"] = this.requiresApproval;
        data["isArchived"] = this.isArchived;
        data["continuousDeployment"] = this.continuousDeployment;
        data["vcsCommandsAlias"] = this.vcsCommandsAlias;
        data["pullRequestPlanDeployments"] = this.pullRequestPlanDeployments;
        data["autoDeployOnPathChangesOnly"] = this.autoDeployOnPathChangesOnly;
        data["autoDeployByCustomGlob"] = this.autoDeployByCustomGlob;
        data["isRemoteBackend"] = this.isRemoteBackend;
        return data;
    }
}

export interface IUpdateEnv0EnvironmentRequest {
    name?: string | undefined;
    requiresApproval?: boolean;
    isArchived?: boolean;
    continuousDeployment?: boolean;
    vcsCommandsAlias?: string | undefined;
    pullRequestPlanDeployments?: boolean;
    autoDeployOnPathChangesOnly?: boolean;
    autoDeployByCustomGlob?: string | undefined;
    isRemoteBackend?: boolean;
}

export class Blueprint implements IBlueprint {
    blueprintId?: string | undefined;
    blueprintName?: string | undefined;
    blueprintRepository?: string | undefined;
    blueprintRevision?: string | undefined;
    blueprintPath?: string | undefined;
    blueprintType?: any | undefined;

    protected _discriminator: string;

    constructor(data?: IBlueprint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "Blueprint";
    }

    init(_data?: any) {
        if (_data) {
            this.blueprintId = _data["blueprintId"];
            this.blueprintName = _data["blueprintName"];
            this.blueprintRepository = _data["blueprintRepository"];
            this.blueprintRevision = _data["blueprintRevision"];
            this.blueprintPath = _data["blueprintPath"];
            this.blueprintType = _data["blueprintType"];
        }
    }

    static fromJS(data: any): Blueprint {
        data = typeof data === 'object' ? data : {};
        if (data["typeName"] === "DeployRequest") {
            let result = new DeployRequest();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "DeploymentLog") {
            let result = new DeploymentLog();
            result.init(data);
            return result;
        }
        let result = new Blueprint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeName"] = this._discriminator;
        data["blueprintId"] = this.blueprintId;
        data["blueprintName"] = this.blueprintName;
        data["blueprintRepository"] = this.blueprintRepository;
        data["blueprintRevision"] = this.blueprintRevision;
        data["blueprintPath"] = this.blueprintPath;
        data["blueprintType"] = this.blueprintType;
        return data;
    }
}

export interface IBlueprint {
    blueprintId?: string | undefined;
    blueprintName?: string | undefined;
    blueprintRepository?: string | undefined;
    blueprintRevision?: string | undefined;
    blueprintPath?: string | undefined;
    blueprintType?: any | undefined;
}

export class ConfigurationPropertyChange implements IConfigurationPropertyChange {
    name?: string | undefined;
    type?: ConfigurationPropertyChangeType;
    value?: string | undefined;
    isSensitive?: boolean;

    constructor(data?: IConfigurationPropertyChange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
            this.value = _data["value"];
            this.isSensitive = _data["isSensitive"];
        }
    }

    static fromJS(data: any): ConfigurationPropertyChange {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationPropertyChange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        data["value"] = this.value;
        data["isSensitive"] = this.isSensitive;
        return data;
    }
}

export interface IConfigurationPropertyChange {
    name?: string | undefined;
    type?: ConfigurationPropertyChangeType;
    value?: string | undefined;
    isSensitive?: boolean;
}

export class CostEstimation implements ICostEstimation {
    version?: string | undefined;
    projects?: Project[] | undefined;
    timeGenerated?: string | undefined;
    summary?: ProjectSummary;
    resources?: any[] | undefined;
    totalHourlyCost?: string | undefined;
    totalMonthlyCost?: string | undefined;

    constructor(data?: ICostEstimation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(Project.fromJS(item));
            }
            this.timeGenerated = _data["timeGenerated"];
            this.summary = _data["summary"] ? ProjectSummary.fromJS(_data["summary"]) : <any>undefined;
            if (Array.isArray(_data["resources"])) {
                this.resources = [] as any;
                for (let item of _data["resources"])
                    this.resources!.push(item);
            }
            this.totalHourlyCost = _data["totalHourlyCost"];
            this.totalMonthlyCost = _data["totalMonthlyCost"];
        }
    }

    static fromJS(data: any): CostEstimation {
        data = typeof data === 'object' ? data : {};
        let result = new CostEstimation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        data["timeGenerated"] = this.timeGenerated;
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        if (Array.isArray(this.resources)) {
            data["resources"] = [];
            for (let item of this.resources)
                data["resources"].push(item);
        }
        data["totalHourlyCost"] = this.totalHourlyCost;
        data["totalMonthlyCost"] = this.totalMonthlyCost;
        return data;
    }
}

export interface ICostEstimation {
    version?: string | undefined;
    projects?: Project[] | undefined;
    timeGenerated?: string | undefined;
    summary?: ProjectSummary;
    resources?: any[] | undefined;
    totalHourlyCost?: string | undefined;
    totalMonthlyCost?: string | undefined;
}

export class DeployRequest extends Blueprint implements IDeployRequest {
    workflowDeploymentId?: string | undefined;
    deploymentType?: string | undefined;
    configurationChanges?: ConfigurationPropertyChange[] | undefined;
    ttl?: TimeToLive;
    envName?: string | undefined;
    userRequiresApproval?: boolean;
    targets?: string | undefined;
    customEnv0EnvironmentVariables?: any | undefined;
    gitUserData?: any | undefined;
    comment?: string | undefined;
    triggerName?: string | undefined;
    upstreamEnvironmentId?: string | undefined;
    taskPayload?: string | undefined;
    subEnvironments?: any | undefined;

    constructor(data?: IDeployRequest) {
        super(data);
        this._discriminator = "DeployRequest";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.workflowDeploymentId = _data["workflowDeploymentId"];
            this.deploymentType = _data["deploymentType"];
            if (Array.isArray(_data["configurationChanges"])) {
                this.configurationChanges = [] as any;
                for (let item of _data["configurationChanges"])
                    this.configurationChanges!.push(ConfigurationPropertyChange.fromJS(item));
            }
            this.ttl = _data["ttl"] ? TimeToLive.fromJS(_data["ttl"]) : <any>undefined;
            this.envName = _data["envName"];
            this.userRequiresApproval = _data["userRequiresApproval"];
            this.targets = _data["targets"];
            this.customEnv0EnvironmentVariables = _data["customEnv0EnvironmentVariables"];
            this.gitUserData = _data["gitUserData"];
            this.comment = _data["comment"];
            this.triggerName = _data["triggerName"];
            this.upstreamEnvironmentId = _data["upstreamEnvironmentId"];
            this.taskPayload = _data["taskPayload"];
            this.subEnvironments = _data["subEnvironments"];
        }
    }

    static override fromJS(data: any): DeployRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeployRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workflowDeploymentId"] = this.workflowDeploymentId;
        data["deploymentType"] = this.deploymentType;
        if (Array.isArray(this.configurationChanges)) {
            data["configurationChanges"] = [];
            for (let item of this.configurationChanges)
                data["configurationChanges"].push(item.toJSON());
        }
        data["ttl"] = this.ttl ? this.ttl.toJSON() : <any>undefined;
        data["envName"] = this.envName;
        data["userRequiresApproval"] = this.userRequiresApproval;
        data["targets"] = this.targets;
        data["customEnv0EnvironmentVariables"] = this.customEnv0EnvironmentVariables;
        data["gitUserData"] = this.gitUserData;
        data["comment"] = this.comment;
        data["triggerName"] = this.triggerName;
        data["upstreamEnvironmentId"] = this.upstreamEnvironmentId;
        data["taskPayload"] = this.taskPayload;
        data["subEnvironments"] = this.subEnvironments;
        super.toJSON(data);
        return data;
    }
}

export interface IDeployRequest extends IBlueprint {
    workflowDeploymentId?: string | undefined;
    deploymentType?: string | undefined;
    configurationChanges?: ConfigurationPropertyChange[] | undefined;
    ttl?: TimeToLive;
    envName?: string | undefined;
    userRequiresApproval?: boolean;
    targets?: string | undefined;
    customEnv0EnvironmentVariables?: any | undefined;
    gitUserData?: any | undefined;
    comment?: string | undefined;
    triggerName?: string | undefined;
    upstreamEnvironmentId?: string | undefined;
    taskPayload?: string | undefined;
    subEnvironments?: any | undefined;
}

export class DeploymentLog extends Blueprint implements IDeploymentLog {
    id?: string | undefined;
    type?: string | undefined;
    startedBy?: string | undefined;
    queuedAt?: Date | undefined;
    startedAt?: Date | undefined;
    finishedAt?: Date | undefined;
    output?: any | undefined;
    error?: any | undefined;
    costEstimation?: CostEstimation;
    status?: string | undefined;
    environmentId?: string | undefined;
    resourceCount?: number | undefined;
    startedByUser?: Env0UserDto;
    isScheduledRun?: boolean;
    abortedBy?: string | undefined;
    abortedByUser?: Env0UserDto;
    reviewersUsers?: Reviewer[] | undefined;
    reviewers?: Reviewer[] | undefined;

    constructor(data?: IDeploymentLog) {
        super(data);
        this._discriminator = "DeploymentLog";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.startedBy = _data["startedBy"];
            this.queuedAt = _data["queuedAt"] ? new Date(_data["queuedAt"].toString()) : <any>undefined;
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : <any>undefined;
            this.finishedAt = _data["finishedAt"] ? new Date(_data["finishedAt"].toString()) : <any>undefined;
            this.output = _data["output"];
            this.error = _data["error"];
            this.costEstimation = _data["costEstimation"] ? CostEstimation.fromJS(_data["costEstimation"]) : <any>undefined;
            this.status = _data["status"];
            this.environmentId = _data["environmentId"];
            this.resourceCount = _data["resourceCount"];
            this.startedByUser = _data["startedByUser"] ? Env0UserDto.fromJS(_data["startedByUser"]) : <any>undefined;
            this.isScheduledRun = _data["isScheduledRun"];
            this.abortedBy = _data["abortedBy"];
            this.abortedByUser = _data["abortedByUser"] ? Env0UserDto.fromJS(_data["abortedByUser"]) : <any>undefined;
            if (Array.isArray(_data["reviewersUsers"])) {
                this.reviewersUsers = [] as any;
                for (let item of _data["reviewersUsers"])
                    this.reviewersUsers!.push(Reviewer.fromJS(item));
            }
            if (Array.isArray(_data["reviewers"])) {
                this.reviewers = [] as any;
                for (let item of _data["reviewers"])
                    this.reviewers!.push(Reviewer.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): DeploymentLog {
        data = typeof data === 'object' ? data : {};
        let result = new DeploymentLog();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["startedBy"] = this.startedBy;
        data["queuedAt"] = this.queuedAt ? this.queuedAt.toISOString() : <any>undefined;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : <any>undefined;
        data["finishedAt"] = this.finishedAt ? this.finishedAt.toISOString() : <any>undefined;
        data["output"] = this.output;
        data["error"] = this.error;
        data["costEstimation"] = this.costEstimation ? this.costEstimation.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["environmentId"] = this.environmentId;
        data["resourceCount"] = this.resourceCount;
        data["startedByUser"] = this.startedByUser ? this.startedByUser.toJSON() : <any>undefined;
        data["isScheduledRun"] = this.isScheduledRun;
        data["abortedBy"] = this.abortedBy;
        data["abortedByUser"] = this.abortedByUser ? this.abortedByUser.toJSON() : <any>undefined;
        if (Array.isArray(this.reviewersUsers)) {
            data["reviewersUsers"] = [];
            for (let item of this.reviewersUsers)
                data["reviewersUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.reviewers)) {
            data["reviewers"] = [];
            for (let item of this.reviewers)
                data["reviewers"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDeploymentLog extends IBlueprint {
    id?: string | undefined;
    type?: string | undefined;
    startedBy?: string | undefined;
    queuedAt?: Date | undefined;
    startedAt?: Date | undefined;
    finishedAt?: Date | undefined;
    output?: any | undefined;
    error?: any | undefined;
    costEstimation?: CostEstimation;
    status?: string | undefined;
    environmentId?: string | undefined;
    resourceCount?: number | undefined;
    startedByUser?: Env0UserDto;
    isScheduledRun?: boolean;
    abortedBy?: string | undefined;
    abortedByUser?: Env0UserDto;
    reviewersUsers?: Reviewer[] | undefined;
    reviewers?: Reviewer[] | undefined;
}

export class NextScheduleDates implements INextScheduleDates {
    deploy?: Date;
    destroy?: Date;

    constructor(data?: INextScheduleDates) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deploy = _data["deploy"] ? new Date(_data["deploy"].toString()) : <any>undefined;
            this.destroy = _data["destroy"] ? new Date(_data["destroy"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NextScheduleDates {
        data = typeof data === 'object' ? data : {};
        let result = new NextScheduleDates();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deploy"] = this.deploy ? this.deploy.toISOString() : <any>undefined;
        data["destroy"] = this.destroy ? this.destroy.toISOString() : <any>undefined;
        return data;
    }
}

export interface INextScheduleDates {
    deploy?: Date;
    destroy?: Date;
}

export class Project implements IProject {
    path?: string | undefined;
    metadata?: string | undefined;
    pastProjectBreakdown?: ProjectBreakdown;
    projectBreakdown?: ProjectBreakdown;
    diff?: ProjectBreakdown;

    constructor(data?: IProject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.path = _data["path"];
            this.metadata = _data["metadata"];
            this.pastProjectBreakdown = _data["pastProjectBreakdown"] ? ProjectBreakdown.fromJS(_data["pastProjectBreakdown"]) : <any>undefined;
            this.projectBreakdown = _data["projectBreakdown"] ? ProjectBreakdown.fromJS(_data["projectBreakdown"]) : <any>undefined;
            this.diff = _data["diff"] ? ProjectBreakdown.fromJS(_data["diff"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Project {
        data = typeof data === 'object' ? data : {};
        let result = new Project();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["path"] = this.path;
        data["metadata"] = this.metadata;
        data["pastProjectBreakdown"] = this.pastProjectBreakdown ? this.pastProjectBreakdown.toJSON() : <any>undefined;
        data["projectBreakdown"] = this.projectBreakdown ? this.projectBreakdown.toJSON() : <any>undefined;
        data["diff"] = this.diff ? this.diff.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProject {
    path?: string | undefined;
    metadata?: string | undefined;
    pastProjectBreakdown?: ProjectBreakdown;
    projectBreakdown?: ProjectBreakdown;
    diff?: ProjectBreakdown;
}

export class ProjectBreakdown implements IProjectBreakdown {
    resources?: any[] | undefined;
    totalHourlyCost?: string | undefined;
    totalMonthlyCost?: string | undefined;

    constructor(data?: IProjectBreakdown) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["resources"])) {
                this.resources = [] as any;
                for (let item of _data["resources"])
                    this.resources!.push(item);
            }
            this.totalHourlyCost = _data["totalHourlyCost"];
            this.totalMonthlyCost = _data["totalMonthlyCost"];
        }
    }

    static fromJS(data: any): ProjectBreakdown {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectBreakdown();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.resources)) {
            data["resources"] = [];
            for (let item of this.resources)
                data["resources"].push(item);
        }
        data["totalHourlyCost"] = this.totalHourlyCost;
        data["totalMonthlyCost"] = this.totalMonthlyCost;
        return data;
    }
}

export interface IProjectBreakdown {
    resources?: any[] | undefined;
    totalHourlyCost?: string | undefined;
    totalMonthlyCost?: string | undefined;
}

export class ProjectSummary implements IProjectSummary {
    unsupportedResourcesCount?: string | undefined;

    constructor(data?: IProjectSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unsupportedResourcesCount = _data["unsupportedResourcesCount"];
        }
    }

    static fromJS(data: any): ProjectSummary {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unsupportedResourcesCount"] = this.unsupportedResourcesCount;
        return data;
    }
}

export interface IProjectSummary {
    unsupportedResourcesCount?: string | undefined;
}

export class Reviewer implements IReviewer {
    action?: string | undefined;
    userId?: string | undefined;
    user?: Env0UserDto;

    constructor(data?: IReviewer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? Env0UserDto.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Reviewer {
        data = typeof data === 'object' ? data : {};
        let result = new Reviewer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface IReviewer {
    action?: string | undefined;
    userId?: string | undefined;
    user?: Env0UserDto;
}

export class TimeToLive implements ITimeToLive {
    type?: string | undefined;
    value?: string | undefined;

    constructor(data?: ITimeToLive) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): TimeToLive {
        data = typeof data === 'object' ? data : {};
        let result = new TimeToLive();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["value"] = this.value;
        return data;
    }
}

export interface ITimeToLive {
    type?: string | undefined;
    value?: string | undefined;
}

export class DestroyEnv0EnvironmentQueryParams implements IDestroyEnv0EnvironmentQueryParams {
    checkoutUpdatedCode?: string | undefined;
    isScheduledRun?: string | undefined;
    skipStateRefresh?: string | undefined;
    revision?: string | undefined;

    constructor(data?: IDestroyEnv0EnvironmentQueryParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checkoutUpdatedCode = _data["checkoutUpdatedCode"];
            this.isScheduledRun = _data["isScheduledRun"];
            this.skipStateRefresh = _data["skipStateRefresh"];
            this.revision = _data["revision"];
        }
    }

    static fromJS(data: any): DestroyEnv0EnvironmentQueryParams {
        data = typeof data === 'object' ? data : {};
        let result = new DestroyEnv0EnvironmentQueryParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checkoutUpdatedCode"] = this.checkoutUpdatedCode;
        data["isScheduledRun"] = this.isScheduledRun;
        data["skipStateRefresh"] = this.skipStateRefresh;
        data["revision"] = this.revision;
        return data;
    }
}

export interface IDestroyEnv0EnvironmentQueryParams {
    checkoutUpdatedCode?: string | undefined;
    isScheduledRun?: string | undefined;
    skipStateRefresh?: string | undefined;
    revision?: string | undefined;
}

export class DestroyEnv0EnvironmentRequestBody implements IDestroyEnv0EnvironmentRequestBody {
    triggerName?: string | undefined;
    workflowDeploymentId?: string | undefined;
    comment?: string | undefined;

    constructor(data?: IDestroyEnv0EnvironmentRequestBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.triggerName = _data["triggerName"];
            this.workflowDeploymentId = _data["workflowDeploymentId"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): DestroyEnv0EnvironmentRequestBody {
        data = typeof data === 'object' ? data : {};
        let result = new DestroyEnv0EnvironmentRequestBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["triggerName"] = this.triggerName;
        data["workflowDeploymentId"] = this.workflowDeploymentId;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IDestroyEnv0EnvironmentRequestBody {
    triggerName?: string | undefined;
    workflowDeploymentId?: string | undefined;
    comment?: string | undefined;
}

export class DestroyEnv0EnvironmentResponseDto implements IDestroyEnv0EnvironmentResponseDto {
    id?: string | undefined;

    constructor(data?: IDestroyEnv0EnvironmentResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DestroyEnv0EnvironmentResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new DestroyEnv0EnvironmentResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDestroyEnv0EnvironmentResponseDto {
    id?: string | undefined;
}

export enum ConfigurationPropertyChangeType {
    Environment = "Environment",
    Terraform = "Terraform",
}

export class Env0UserDto implements IEnv0UserDto {
    user_Id?: string | undefined;
    email?: string | undefined;
    created_At?: string | undefined;
    picture?: string | undefined;
    name?: string | undefined;
    last_Login?: string | undefined;
    given_Name?: string | undefined;
    family_Name?: string | undefined;

    constructor(data?: IEnv0UserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user_Id = _data["user_Id"];
            this.email = _data["email"];
            this.created_At = _data["created_At"];
            this.picture = _data["picture"];
            this.name = _data["name"];
            this.last_Login = _data["last_Login"];
            this.given_Name = _data["given_Name"];
            this.family_Name = _data["family_Name"];
        }
    }

    static fromJS(data: any): Env0UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new Env0UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user_Id"] = this.user_Id;
        data["email"] = this.email;
        data["created_At"] = this.created_At;
        data["picture"] = this.picture;
        data["name"] = this.name;
        data["last_Login"] = this.last_Login;
        data["given_Name"] = this.given_Name;
        data["family_Name"] = this.family_Name;
        return data;
    }
}

export interface IEnv0UserDto {
    user_Id?: string | undefined;
    email?: string | undefined;
    created_At?: string | undefined;
    picture?: string | undefined;
    name?: string | undefined;
    last_Login?: string | undefined;
    given_Name?: string | undefined;
    family_Name?: string | undefined;
}

export class ListEnv0EnvironmentQueryParams implements IListEnv0EnvironmentQueryParams {
    limit?: string | undefined;
    offset?: string | undefined;
    organizationId?: string | undefined;
    projectId?: string | undefined;
    onlyMy?: string | undefined;
    isActive?: string | undefined;
    name?: string | undefined;
    isBackendRemote?: string | undefined;
    workspaceName?: string | undefined;
    workspaceNamePrefix?: string | undefined;
    includeSubEnvironments?: string | undefined;

    constructor(data?: IListEnv0EnvironmentQueryParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.limit = _data["limit"];
            this.offset = _data["offset"];
            this.organizationId = _data["organizationId"];
            this.projectId = _data["projectId"];
            this.onlyMy = _data["onlyMy"];
            this.isActive = _data["isActive"];
            this.name = _data["name"];
            this.isBackendRemote = _data["isBackendRemote"];
            this.workspaceName = _data["workspaceName"];
            this.workspaceNamePrefix = _data["workspaceNamePrefix"];
            this.includeSubEnvironments = _data["includeSubEnvironments"];
        }
    }

    static fromJS(data: any): ListEnv0EnvironmentQueryParams {
        data = typeof data === 'object' ? data : {};
        let result = new ListEnv0EnvironmentQueryParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["limit"] = this.limit;
        data["offset"] = this.offset;
        data["organizationId"] = this.organizationId;
        data["projectId"] = this.projectId;
        data["onlyMy"] = this.onlyMy;
        data["isActive"] = this.isActive;
        data["name"] = this.name;
        data["isBackendRemote"] = this.isBackendRemote;
        data["workspaceName"] = this.workspaceName;
        data["workspaceNamePrefix"] = this.workspaceNamePrefix;
        data["includeSubEnvironments"] = this.includeSubEnvironments;
        return data;
    }
}

export interface IListEnv0EnvironmentQueryParams {
    limit?: string | undefined;
    offset?: string | undefined;
    organizationId?: string | undefined;
    projectId?: string | undefined;
    onlyMy?: string | undefined;
    isActive?: string | undefined;
    name?: string | undefined;
    isBackendRemote?: string | undefined;
    workspaceName?: string | undefined;
    workspaceNamePrefix?: string | undefined;
    includeSubEnvironments?: string | undefined;
}

export class ListEnv0EnvironmentsDto implements IListEnv0EnvironmentsDto {
    environments?: Env0EnvironmentDto[] | undefined;

    constructor(data?: IListEnv0EnvironmentsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["environments"])) {
                this.environments = [] as any;
                for (let item of _data["environments"])
                    this.environments!.push(Env0EnvironmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListEnv0EnvironmentsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListEnv0EnvironmentsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.environments)) {
            data["environments"] = [];
            for (let item of this.environments)
                data["environments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListEnv0EnvironmentsDto {
    environments?: Env0EnvironmentDto[] | undefined;
}

export class ExcelDownloadDefinition implements IExcelDownloadDefinition {
    header?: string | undefined;
    dataField?: string | undefined;

    constructor(data?: IExcelDownloadDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.header = _data["header"];
            this.dataField = _data["dataField"];
        }
    }

    static fromJS(data: any): ExcelDownloadDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new ExcelDownloadDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["header"] = this.header;
        data["dataField"] = this.dataField;
        return data;
    }
}

export interface IExcelDownloadDefinition {
    header?: string | undefined;
    dataField?: string | undefined;
}

export class CiscoSupplementalDataDto implements ICiscoSupplementalDataDto {
    instanceId?: string | undefined;
    ipAddress?: string | undefined;
    hostName?: string | undefined;
    tags?: string | undefined;
    notes?: string | undefined;

    constructor(data?: ICiscoSupplementalDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.instanceId = _data["instanceId"];
            this.ipAddress = _data["ipAddress"];
            this.hostName = _data["hostName"];
            this.tags = _data["tags"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): CiscoSupplementalDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoSupplementalDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["instanceId"] = this.instanceId;
        data["ipAddress"] = this.ipAddress;
        data["hostName"] = this.hostName;
        data["tags"] = this.tags;
        data["notes"] = this.notes;
        return data;
    }
}

export interface ICiscoSupplementalDataDto {
    instanceId?: string | undefined;
    ipAddress?: string | undefined;
    hostName?: string | undefined;
    tags?: string | undefined;
    notes?: string | undefined;
}

export class CiscoThirdPartyContractDataDto implements ICiscoThirdPartyContractDataDto {
    instanceId?: string | undefined;
    serialNumber?: string | undefined;
    vendor?: string | undefined;
    contractNumber?: string | undefined;
    serviceLevel?: string | undefined;
    coverageStartDate?: string | undefined;
    coverageEndDate?: string | undefined;
    description?: string | undefined;
    customerName?: string | undefined;
    oem?: string | undefined;
    partNumber?: string | undefined;
    remoteMonitoring?: string | undefined;
    status?: string | undefined;
    hostName?: string | undefined;
    ipAddress?: string | undefined;
    assetTags?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    postalCode?: string | undefined;

    constructor(data?: ICiscoThirdPartyContractDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.instanceId = _data["instanceId"];
            this.serialNumber = _data["serialNumber"];
            this.vendor = _data["vendor"];
            this.contractNumber = _data["contractNumber"];
            this.serviceLevel = _data["serviceLevel"];
            this.coverageStartDate = _data["coverageStartDate"];
            this.coverageEndDate = _data["coverageEndDate"];
            this.description = _data["description"];
            this.customerName = _data["customerName"];
            this.oem = _data["oem"];
            this.partNumber = _data["partNumber"];
            this.remoteMonitoring = _data["remoteMonitoring"];
            this.status = _data["status"];
            this.hostName = _data["hostName"];
            this.ipAddress = _data["ipAddress"];
            this.assetTags = _data["assetTags"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.postalCode = _data["postalCode"];
        }
    }

    static fromJS(data: any): CiscoThirdPartyContractDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoThirdPartyContractDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["instanceId"] = this.instanceId;
        data["serialNumber"] = this.serialNumber;
        data["vendor"] = this.vendor;
        data["contractNumber"] = this.contractNumber;
        data["serviceLevel"] = this.serviceLevel;
        data["coverageStartDate"] = this.coverageStartDate;
        data["coverageEndDate"] = this.coverageEndDate;
        data["description"] = this.description;
        data["customerName"] = this.customerName;
        data["oem"] = this.oem;
        data["partNumber"] = this.partNumber;
        data["remoteMonitoring"] = this.remoteMonitoring;
        data["status"] = this.status;
        data["hostName"] = this.hostName;
        data["ipAddress"] = this.ipAddress;
        data["assetTags"] = this.assetTags;
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["postalCode"] = this.postalCode;
        return data;
    }
}

export interface ICiscoThirdPartyContractDataDto {
    instanceId?: string | undefined;
    serialNumber?: string | undefined;
    vendor?: string | undefined;
    contractNumber?: string | undefined;
    serviceLevel?: string | undefined;
    coverageStartDate?: string | undefined;
    coverageEndDate?: string | undefined;
    description?: string | undefined;
    customerName?: string | undefined;
    oem?: string | undefined;
    partNumber?: string | undefined;
    remoteMonitoring?: string | undefined;
    status?: string | undefined;
    hostName?: string | undefined;
    ipAddress?: string | undefined;
    assetTags?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    postalCode?: string | undefined;
}

export class FileValidationDto implements IFileValidationDto {
    title?: string | undefined;
    errorMessage?: string | undefined;
    errorResults?: FileValidationErrors[] | undefined;

    constructor(data?: IFileValidationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.errorMessage = _data["errorMessage"];
            if (Array.isArray(_data["errorResults"])) {
                this.errorResults = [] as any;
                for (let item of _data["errorResults"])
                    this.errorResults!.push(FileValidationErrors.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FileValidationDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileValidationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["errorMessage"] = this.errorMessage;
        if (Array.isArray(this.errorResults)) {
            data["errorResults"] = [];
            for (let item of this.errorResults)
                data["errorResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFileValidationDto {
    title?: string | undefined;
    errorMessage?: string | undefined;
    errorResults?: FileValidationErrors[] | undefined;
}

export class ManualManagedAssetDataRecordDto implements IManualManagedAssetDataRecordDto {
    assetId?: string | undefined;
    parentId?: string | undefined;
    name?: string | undefined;
    product?: string | undefined;
    description?: string | undefined;
    productFamily?: string | undefined;
    serialNumber?: string | undefined;
    manufacturer?: string | undefined;
    assetType?: string | undefined;
    useState?: string | undefined;
    operatingSystem?: string | undefined;
    firmware?: string | undefined;
    shipDate?: string | undefined;
    installDate?: string | undefined;
    assignedTo?: string | undefined;
    assignedOn?: string | undefined;
    contactOwner?: string | undefined;
    itemQuantity?: string | undefined;
    category?: string | undefined;
    subCategory?: string | undefined;
    microCategory?: string | undefined;
    ipAddress?: string | undefined;
    hostname?: string | undefined;
    locationName?: string | undefined;
    locationAddress?: string | undefined;
    locationCity?: string | undefined;
    locationState?: string | undefined;
    locationCountry?: string | undefined;
    listPrice?: string | undefined;
    warrantyType?: string | undefined;
    warrantyEndDate?: string | undefined;
    lifecycleState?: string | undefined;
    endOfSaleDate?: string | undefined;
    lastDateOfSupport?: string | undefined;
    endOfLife?: string | undefined;
    endOfSoftwareMaintenanceDate?: string | undefined;
    licensesPurchased?: string | undefined;
    licensesUsed?: string | undefined;
    growthAllowance?: string | undefined;
    licensesAvailable?: string | undefined;
    tags?: string | undefined;
    notes?: string | undefined;
    contractId?: string | undefined;
    contractVendor?: string | undefined;
    contractType?: string | undefined;
    contractStatus?: string | undefined;
    contractStartDate?: string | undefined;
    contractEndDate?: string | undefined;

    constructor(data?: IManualManagedAssetDataRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetId = _data["assetId"];
            this.parentId = _data["parentId"];
            this.name = _data["name"];
            this.product = _data["product"];
            this.description = _data["description"];
            this.productFamily = _data["productFamily"];
            this.serialNumber = _data["serialNumber"];
            this.manufacturer = _data["manufacturer"];
            this.assetType = _data["assetType"];
            this.useState = _data["useState"];
            this.operatingSystem = _data["operatingSystem"];
            this.firmware = _data["firmware"];
            this.shipDate = _data["shipDate"];
            this.installDate = _data["installDate"];
            this.assignedTo = _data["assignedTo"];
            this.assignedOn = _data["assignedOn"];
            this.contactOwner = _data["contactOwner"];
            this.itemQuantity = _data["itemQuantity"];
            this.category = _data["category"];
            this.subCategory = _data["subCategory"];
            this.microCategory = _data["microCategory"];
            this.ipAddress = _data["ipAddress"];
            this.hostname = _data["hostname"];
            this.locationName = _data["locationName"];
            this.locationAddress = _data["locationAddress"];
            this.locationCity = _data["locationCity"];
            this.locationState = _data["locationState"];
            this.locationCountry = _data["locationCountry"];
            this.listPrice = _data["listPrice"];
            this.warrantyType = _data["warrantyType"];
            this.warrantyEndDate = _data["warrantyEndDate"];
            this.lifecycleState = _data["lifecycleState"];
            this.endOfSaleDate = _data["endOfSaleDate"];
            this.lastDateOfSupport = _data["lastDateOfSupport"];
            this.endOfLife = _data["endOfLife"];
            this.endOfSoftwareMaintenanceDate = _data["endOfSoftwareMaintenanceDate"];
            this.licensesPurchased = _data["licensesPurchased"];
            this.licensesUsed = _data["licensesUsed"];
            this.growthAllowance = _data["growthAllowance"];
            this.licensesAvailable = _data["licensesAvailable"];
            this.tags = _data["tags"];
            this.notes = _data["notes"];
            this.contractId = _data["contractId"];
            this.contractVendor = _data["contractVendor"];
            this.contractType = _data["contractType"];
            this.contractStatus = _data["contractStatus"];
            this.contractStartDate = _data["contractStartDate"];
            this.contractEndDate = _data["contractEndDate"];
        }
    }

    static fromJS(data: any): ManualManagedAssetDataRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManualManagedAssetDataRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetId"] = this.assetId;
        data["parentId"] = this.parentId;
        data["name"] = this.name;
        data["product"] = this.product;
        data["description"] = this.description;
        data["productFamily"] = this.productFamily;
        data["serialNumber"] = this.serialNumber;
        data["manufacturer"] = this.manufacturer;
        data["assetType"] = this.assetType;
        data["useState"] = this.useState;
        data["operatingSystem"] = this.operatingSystem;
        data["firmware"] = this.firmware;
        data["shipDate"] = this.shipDate;
        data["installDate"] = this.installDate;
        data["assignedTo"] = this.assignedTo;
        data["assignedOn"] = this.assignedOn;
        data["contactOwner"] = this.contactOwner;
        data["itemQuantity"] = this.itemQuantity;
        data["category"] = this.category;
        data["subCategory"] = this.subCategory;
        data["microCategory"] = this.microCategory;
        data["ipAddress"] = this.ipAddress;
        data["hostname"] = this.hostname;
        data["locationName"] = this.locationName;
        data["locationAddress"] = this.locationAddress;
        data["locationCity"] = this.locationCity;
        data["locationState"] = this.locationState;
        data["locationCountry"] = this.locationCountry;
        data["listPrice"] = this.listPrice;
        data["warrantyType"] = this.warrantyType;
        data["warrantyEndDate"] = this.warrantyEndDate;
        data["lifecycleState"] = this.lifecycleState;
        data["endOfSaleDate"] = this.endOfSaleDate;
        data["lastDateOfSupport"] = this.lastDateOfSupport;
        data["endOfLife"] = this.endOfLife;
        data["endOfSoftwareMaintenanceDate"] = this.endOfSoftwareMaintenanceDate;
        data["licensesPurchased"] = this.licensesPurchased;
        data["licensesUsed"] = this.licensesUsed;
        data["growthAllowance"] = this.growthAllowance;
        data["licensesAvailable"] = this.licensesAvailable;
        data["tags"] = this.tags;
        data["notes"] = this.notes;
        data["contractId"] = this.contractId;
        data["contractVendor"] = this.contractVendor;
        data["contractType"] = this.contractType;
        data["contractStatus"] = this.contractStatus;
        data["contractStartDate"] = this.contractStartDate;
        data["contractEndDate"] = this.contractEndDate;
        return data;
    }
}

export interface IManualManagedAssetDataRecordDto {
    assetId?: string | undefined;
    parentId?: string | undefined;
    name?: string | undefined;
    product?: string | undefined;
    description?: string | undefined;
    productFamily?: string | undefined;
    serialNumber?: string | undefined;
    manufacturer?: string | undefined;
    assetType?: string | undefined;
    useState?: string | undefined;
    operatingSystem?: string | undefined;
    firmware?: string | undefined;
    shipDate?: string | undefined;
    installDate?: string | undefined;
    assignedTo?: string | undefined;
    assignedOn?: string | undefined;
    contactOwner?: string | undefined;
    itemQuantity?: string | undefined;
    category?: string | undefined;
    subCategory?: string | undefined;
    microCategory?: string | undefined;
    ipAddress?: string | undefined;
    hostname?: string | undefined;
    locationName?: string | undefined;
    locationAddress?: string | undefined;
    locationCity?: string | undefined;
    locationState?: string | undefined;
    locationCountry?: string | undefined;
    listPrice?: string | undefined;
    warrantyType?: string | undefined;
    warrantyEndDate?: string | undefined;
    lifecycleState?: string | undefined;
    endOfSaleDate?: string | undefined;
    lastDateOfSupport?: string | undefined;
    endOfLife?: string | undefined;
    endOfSoftwareMaintenanceDate?: string | undefined;
    licensesPurchased?: string | undefined;
    licensesUsed?: string | undefined;
    growthAllowance?: string | undefined;
    licensesAvailable?: string | undefined;
    tags?: string | undefined;
    notes?: string | undefined;
    contractId?: string | undefined;
    contractVendor?: string | undefined;
    contractType?: string | undefined;
    contractStatus?: string | undefined;
    contractStartDate?: string | undefined;
    contractEndDate?: string | undefined;
}

export class FileHandlerUploadRecord_1OfCiscoSupplementalDataDto implements IFileHandlerUploadRecord_1OfCiscoSupplementalDataDto {
    record?: CiscoSupplementalDataDto;
    errorMessages?: string[] | undefined;
    row?: number;

    constructor(data?: IFileHandlerUploadRecord_1OfCiscoSupplementalDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.record = _data["record"] ? CiscoSupplementalDataDto.fromJS(_data["record"]) : <any>undefined;
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.row = _data["row"];
        }
    }

    static fromJS(data: any): FileHandlerUploadRecord_1OfCiscoSupplementalDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileHandlerUploadRecord_1OfCiscoSupplementalDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["record"] = this.record ? this.record.toJSON() : <any>undefined;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["row"] = this.row;
        return data;
    }
}

export interface IFileHandlerUploadRecord_1OfCiscoSupplementalDataDto {
    record?: CiscoSupplementalDataDto;
    errorMessages?: string[] | undefined;
    row?: number;
}

export class FileHandlerUploadRecord_1OfCiscoThirdPartyContractDataDto implements IFileHandlerUploadRecord_1OfCiscoThirdPartyContractDataDto {
    record?: CiscoThirdPartyContractDataDto;
    errorMessages?: string[] | undefined;
    row?: number;

    constructor(data?: IFileHandlerUploadRecord_1OfCiscoThirdPartyContractDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.record = _data["record"] ? CiscoThirdPartyContractDataDto.fromJS(_data["record"]) : <any>undefined;
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.row = _data["row"];
        }
    }

    static fromJS(data: any): FileHandlerUploadRecord_1OfCiscoThirdPartyContractDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileHandlerUploadRecord_1OfCiscoThirdPartyContractDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["record"] = this.record ? this.record.toJSON() : <any>undefined;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["row"] = this.row;
        return data;
    }
}

export interface IFileHandlerUploadRecord_1OfCiscoThirdPartyContractDataDto {
    record?: CiscoThirdPartyContractDataDto;
    errorMessages?: string[] | undefined;
    row?: number;
}

export class FileHandlerUploadRecord_1OfManualManagedAssetDataRecordDto implements IFileHandlerUploadRecord_1OfManualManagedAssetDataRecordDto {
    record?: ManualManagedAssetDataRecordDto;
    errorMessages?: string[] | undefined;
    row?: number;

    constructor(data?: IFileHandlerUploadRecord_1OfManualManagedAssetDataRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.record = _data["record"] ? ManualManagedAssetDataRecordDto.fromJS(_data["record"]) : <any>undefined;
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.row = _data["row"];
        }
    }

    static fromJS(data: any): FileHandlerUploadRecord_1OfManualManagedAssetDataRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileHandlerUploadRecord_1OfManualManagedAssetDataRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["record"] = this.record ? this.record.toJSON() : <any>undefined;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["row"] = this.row;
        return data;
    }
}

export interface IFileHandlerUploadRecord_1OfManualManagedAssetDataRecordDto {
    record?: ManualManagedAssetDataRecordDto;
    errorMessages?: string[] | undefined;
    row?: number;
}

export enum FileTypes {
    RawRenewalReport = "RawRenewalReport",
    UpdateCiscoMappings = "UpdateCiscoMappings",
    TechdataResults = "TechdataResults",
    SubscriptionMapping = "SubscriptionMapping",
    AssessmentGeneratedTemplate = "AssessmentGeneratedTemplate",
    Other = "Other",
}

export class FileValidationErrors implements IFileValidationErrors {
    errorMessages?: string[] | undefined;
    row?: number;

    constructor(data?: IFileValidationErrors) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.row = _data["row"];
        }
    }

    static fromJS(data: any): FileValidationErrors {
        data = typeof data === 'object' ? data : {};
        let result = new FileValidationErrors();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["row"] = this.row;
        return data;
    }
}

export interface IFileValidationErrors {
    errorMessages?: string[] | undefined;
    row?: number;
}

export enum IntegrationStatus {
    Error = "Error",
    Disabled = "Disabled",
    Pending = "Pending",
    New = "New",
    Success = "Success",
}

export class ContentUnitDto implements IContentUnitDto {
    identifier?: string | undefined;
    title?: string | undefined;
    url?: string | undefined;
    isPublic?: boolean;
    icon?: string | undefined;
    contractCategoryIds?: number[] | undefined;

    constructor(data?: IContentUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
            this.title = _data["title"];
            this.url = _data["url"];
            this.isPublic = _data["isPublic"];
            this.icon = _data["icon"];
            if (Array.isArray(_data["contractCategoryIds"])) {
                this.contractCategoryIds = [] as any;
                for (let item of _data["contractCategoryIds"])
                    this.contractCategoryIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ContentUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContentUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["title"] = this.title;
        data["url"] = this.url;
        data["isPublic"] = this.isPublic;
        data["icon"] = this.icon;
        if (Array.isArray(this.contractCategoryIds)) {
            data["contractCategoryIds"] = [];
            for (let item of this.contractCategoryIds)
                data["contractCategoryIds"].push(item);
        }
        return data;
    }
}

export interface IContentUnitDto {
    identifier?: string | undefined;
    title?: string | undefined;
    url?: string | undefined;
    isPublic?: boolean;
    icon?: string | undefined;
    contractCategoryIds?: number[] | undefined;
}

export class CsvRows implements ICsvRows {
    columnName?: string | undefined;
    exampleData?: string[] | undefined;

    constructor(data?: ICsvRows) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.columnName = _data["columnName"];
            if (Array.isArray(_data["exampleData"])) {
                this.exampleData = [] as any;
                for (let item of _data["exampleData"])
                    this.exampleData!.push(item);
            }
        }
    }

    static fromJS(data: any): CsvRows {
        data = typeof data === 'object' ? data : {};
        let result = new CsvRows();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["columnName"] = this.columnName;
        if (Array.isArray(this.exampleData)) {
            data["exampleData"] = [];
            for (let item of this.exampleData)
                data["exampleData"].push(item);
        }
        return data;
    }
}

export interface ICsvRows {
    columnName?: string | undefined;
    exampleData?: string[] | undefined;
}

export class ExcelRows implements IExcelRows {
    columnName?: string | undefined;
    sheetName?: string | undefined;
    exampleData?: string[] | undefined;
    headerRow?: number | undefined;

    constructor(data?: IExcelRows) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.columnName = _data["columnName"];
            this.sheetName = _data["sheetName"];
            if (Array.isArray(_data["exampleData"])) {
                this.exampleData = [] as any;
                for (let item of _data["exampleData"])
                    this.exampleData!.push(item);
            }
            this.headerRow = _data["headerRow"];
        }
    }

    static fromJS(data: any): ExcelRows {
        data = typeof data === 'object' ? data : {};
        let result = new ExcelRows();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["columnName"] = this.columnName;
        data["sheetName"] = this.sheetName;
        if (Array.isArray(this.exampleData)) {
            data["exampleData"] = [];
            for (let item of this.exampleData)
                data["exampleData"].push(item);
        }
        data["headerRow"] = this.headerRow;
        return data;
    }
}

export interface IExcelRows {
    columnName?: string | undefined;
    sheetName?: string | undefined;
    exampleData?: string[] | undefined;
    headerRow?: number | undefined;
}

export class MappingDto implements IMappingDto {
    id?: number;
    schemaId?: number;
    version?: number;
    description?: string | undefined;
    mapping?: string | undefined;
    published?: boolean;
    uploadResponse?: MappingRowsResultDto;

    constructor(data?: IMappingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.schemaId = _data["schemaId"];
            this.version = _data["version"];
            this.description = _data["description"];
            this.mapping = _data["mapping"];
            this.published = _data["published"];
            this.uploadResponse = _data["uploadResponse"] ? MappingRowsResultDto.fromJS(_data["uploadResponse"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MappingDto {
        data = typeof data === 'object' ? data : {};
        let result = new MappingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["schemaId"] = this.schemaId;
        data["version"] = this.version;
        data["description"] = this.description;
        data["mapping"] = this.mapping;
        data["published"] = this.published;
        data["uploadResponse"] = this.uploadResponse ? this.uploadResponse.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMappingDto {
    id?: number;
    schemaId?: number;
    version?: number;
    description?: string | undefined;
    mapping?: string | undefined;
    published?: boolean;
    uploadResponse?: MappingRowsResultDto;
}

export class MappingEngineMetadata implements IMappingEngineMetadata {
    name?: string | undefined;
    schemaId?: number;
    status?: string | undefined;
    additionalInformation?: string | undefined;
    fileName?: string | undefined;

    constructor(data?: IMappingEngineMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.schemaId = _data["schemaId"];
            this.status = _data["status"];
            this.additionalInformation = _data["additionalInformation"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): MappingEngineMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new MappingEngineMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["schemaId"] = this.schemaId;
        data["status"] = this.status;
        data["additionalInformation"] = this.additionalInformation;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface IMappingEngineMetadata {
    name?: string | undefined;
    schemaId?: number;
    status?: string | undefined;
    additionalInformation?: string | undefined;
    fileName?: string | undefined;
}

export class MappingEngineMetadataDto implements IMappingEngineMetadataDto {
    integrationType?: IntegrationType;
    metadata?: MappingEngineMetadata[] | undefined;
    integrationId?: number;

    constructor(data?: IMappingEngineMetadataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.integrationType = _data["integrationType"];
            if (Array.isArray(_data["metadata"])) {
                this.metadata = [] as any;
                for (let item of _data["metadata"])
                    this.metadata!.push(MappingEngineMetadata.fromJS(item));
            }
            this.integrationId = _data["integrationId"];
        }
    }

    static fromJS(data: any): MappingEngineMetadataDto {
        data = typeof data === 'object' ? data : {};
        let result = new MappingEngineMetadataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        if (Array.isArray(this.metadata)) {
            data["metadata"] = [];
            for (let item of this.metadata)
                data["metadata"].push(item.toJSON());
        }
        data["integrationId"] = this.integrationId;
        return data;
    }
}

export interface IMappingEngineMetadataDto {
    integrationType?: IntegrationType;
    metadata?: MappingEngineMetadata[] | undefined;
    integrationId?: number;
}

export enum MappingFileType {
    Csv = "Csv",
    Excel = "Excel",
}

export class MappingRowsResultDto implements IMappingRowsResultDto {
    guid?: string;
    fileType?: MappingFileType;
    excelRowsList?: ExcelRows[] | undefined;
    csvRowsList?: CsvRows[] | undefined;

    constructor(data?: IMappingRowsResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.fileType = _data["fileType"];
            if (Array.isArray(_data["excelRowsList"])) {
                this.excelRowsList = [] as any;
                for (let item of _data["excelRowsList"])
                    this.excelRowsList!.push(ExcelRows.fromJS(item));
            }
            if (Array.isArray(_data["csvRowsList"])) {
                this.csvRowsList = [] as any;
                for (let item of _data["csvRowsList"])
                    this.csvRowsList!.push(CsvRows.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MappingRowsResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MappingRowsResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["fileType"] = this.fileType;
        if (Array.isArray(this.excelRowsList)) {
            data["excelRowsList"] = [];
            for (let item of this.excelRowsList)
                data["excelRowsList"].push(item.toJSON());
        }
        if (Array.isArray(this.csvRowsList)) {
            data["csvRowsList"] = [];
            for (let item of this.csvRowsList)
                data["csvRowsList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMappingRowsResultDto {
    guid?: string;
    fileType?: MappingFileType;
    excelRowsList?: ExcelRows[] | undefined;
    csvRowsList?: CsvRows[] | undefined;
}

export class SchemaDto implements ISchemaDto {
    id?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    schemaType?: string | undefined;
    targetSchemaUrl?: string | undefined;

    constructor(data?: ISchemaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.schemaType = _data["schemaType"];
            this.targetSchemaUrl = _data["targetSchemaUrl"];
        }
    }

    static fromJS(data: any): SchemaDto {
        data = typeof data === 'object' ? data : {};
        let result = new SchemaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["schemaType"] = this.schemaType;
        data["targetSchemaUrl"] = this.targetSchemaUrl;
        return data;
    }
}

export interface ISchemaDto {
    id?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    schemaType?: string | undefined;
    targetSchemaUrl?: string | undefined;
}

export class ActiveUserTrendsServiceItem implements IActiveUserTrendsServiceItem {
    displayName?: string | undefined;
    activeUsersCounts?: number[] | undefined;

    constructor(data?: IActiveUserTrendsServiceItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            if (Array.isArray(_data["activeUsersCounts"])) {
                this.activeUsersCounts = [] as any;
                for (let item of _data["activeUsersCounts"])
                    this.activeUsersCounts!.push(item);
            }
        }
    }

    static fromJS(data: any): ActiveUserTrendsServiceItem {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveUserTrendsServiceItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        if (Array.isArray(this.activeUsersCounts)) {
            data["activeUsersCounts"] = [];
            for (let item of this.activeUsersCounts)
                data["activeUsersCounts"].push(item);
        }
        return data;
    }
}

export interface IActiveUserTrendsServiceItem {
    displayName?: string | undefined;
    activeUsersCounts?: number[] | undefined;
}

export class ActiveUserTrendsWidgetResponse implements IActiveUserTrendsWidgetResponse {
    services?: ActiveUserTrendsServiceItem[] | undefined;
    activeUsersTimeframeLabels?: string[] | undefined;

    constructor(data?: IActiveUserTrendsWidgetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(ActiveUserTrendsServiceItem.fromJS(item));
            }
            if (Array.isArray(_data["activeUsersTimeframeLabels"])) {
                this.activeUsersTimeframeLabels = [] as any;
                for (let item of _data["activeUsersTimeframeLabels"])
                    this.activeUsersTimeframeLabels!.push(item);
            }
        }
    }

    static fromJS(data: any): ActiveUserTrendsWidgetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveUserTrendsWidgetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item.toJSON());
        }
        if (Array.isArray(this.activeUsersTimeframeLabels)) {
            data["activeUsersTimeframeLabels"] = [];
            for (let item of this.activeUsersTimeframeLabels)
                data["activeUsersTimeframeLabels"].push(item);
        }
        return data;
    }
}

export interface IActiveUserTrendsWidgetResponse {
    services?: ActiveUserTrendsServiceItem[] | undefined;
    activeUsersTimeframeLabels?: string[] | undefined;
}

export class ActiveUsersByServiceWidgetResponse implements IActiveUsersByServiceWidgetResponse {
    services?: ServiceItem[] | undefined;

    constructor(data?: IActiveUsersByServiceWidgetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(ServiceItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActiveUsersByServiceWidgetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveUsersByServiceWidgetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item.toJSON());
        }
        return data;
    }
}

export interface IActiveUsersByServiceWidgetResponse {
    services?: ServiceItem[] | undefined;
}

export class FeatureAdoptionWidgetResponse implements IFeatureAdoptionWidgetResponse {
    services?: ServiceItem[] | undefined;

    constructor(data?: IFeatureAdoptionWidgetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(ServiceItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FeatureAdoptionWidgetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureAdoptionWidgetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFeatureAdoptionWidgetResponse {
    services?: ServiceItem[] | undefined;
}

export class License implements ILicense {
    licenseName?: string | undefined;
    active?: number;
    inactive?: number;
    onboarding?: number;
    notUsed?: number;
    total?: number;

    constructor(data?: ILicense) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenseName = _data["licenseName"];
            this.active = _data["active"];
            this.inactive = _data["inactive"];
            this.onboarding = _data["onboarding"];
            this.notUsed = _data["notUsed"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): License {
        data = typeof data === 'object' ? data : {};
        let result = new License();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenseName"] = this.licenseName;
        data["active"] = this.active;
        data["inactive"] = this.inactive;
        data["onboarding"] = this.onboarding;
        data["notUsed"] = this.notUsed;
        data["total"] = this.total;
        return data;
    }
}

export interface ILicense {
    licenseName?: string | undefined;
    active?: number;
    inactive?: number;
    onboarding?: number;
    notUsed?: number;
    total?: number;
}

export class LicenseUtilizationWidgetResponse implements ILicenseUtilizationWidgetResponse {
    licenses?: License[] | undefined;

    constructor(data?: ILicenseUtilizationWidgetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["licenses"])) {
                this.licenses = [] as any;
                for (let item of _data["licenses"])
                    this.licenses!.push(License.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LicenseUtilizationWidgetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseUtilizationWidgetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.licenses)) {
            data["licenses"] = [];
            for (let item of this.licenses)
                data["licenses"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILicenseUtilizationWidgetResponse {
    licenses?: License[] | undefined;
}

export class ProductivityItem implements IProductivityItem {
    id?: number;
    service?: string | undefined;
    amount?: number;
    unit?: string | undefined;

    constructor(data?: IProductivityItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.service = _data["service"];
            this.amount = _data["amount"];
            this.unit = _data["unit"];
        }
    }

    static fromJS(data: any): ProductivityItem {
        data = typeof data === 'object' ? data : {};
        let result = new ProductivityItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["service"] = this.service;
        data["amount"] = this.amount;
        data["unit"] = this.unit;
        return data;
    }
}

export interface IProductivityItem {
    id?: number;
    service?: string | undefined;
    amount?: number;
    unit?: string | undefined;
}

export class ProductivityWidgetResponse implements IProductivityWidgetResponse {
    services?: ProductivityItem[] | undefined;

    constructor(data?: IProductivityWidgetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(ProductivityItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductivityWidgetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProductivityWidgetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProductivityWidgetResponse {
    services?: ProductivityItem[] | undefined;
}

export class ServiceItem implements IServiceItem {
    id?: number;
    service?: string | undefined;
    activeUsers?: number;
    totalUsers?: number;

    constructor(data?: IServiceItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.service = _data["service"];
            this.activeUsers = _data["activeUsers"];
            this.totalUsers = _data["totalUsers"];
        }
    }

    static fromJS(data: any): ServiceItem {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["service"] = this.service;
        data["activeUsers"] = this.activeUsers;
        data["totalUsers"] = this.totalUsers;
        return data;
    }
}

export interface IServiceItem {
    id?: number;
    service?: string | undefined;
    activeUsers?: number;
    totalUsers?: number;
}

export class MyExternalUserNotificationSettingsResponse implements IMyExternalUserNotificationSettingsResponse {
    featureRule?: RuleDto;

    constructor(data?: IMyExternalUserNotificationSettingsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.featureRule = _data["featureRule"] ? RuleDto.fromJS(_data["featureRule"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MyExternalUserNotificationSettingsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MyExternalUserNotificationSettingsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["featureRule"] = this.featureRule ? this.featureRule.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMyExternalUserNotificationSettingsResponse {
    featureRule?: RuleDto;
}

export class FeatureRulesDto implements IFeatureRulesDto {
    featureName?: string | undefined;
    workflows?: WorkflowDto[] | undefined;

    constructor(data?: IFeatureRulesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.featureName = _data["featureName"];
            if (Array.isArray(_data["workflows"])) {
                this.workflows = [] as any;
                for (let item of _data["workflows"])
                    this.workflows!.push(WorkflowDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FeatureRulesDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureRulesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["featureName"] = this.featureName;
        if (Array.isArray(this.workflows)) {
            data["workflows"] = [];
            for (let item of this.workflows)
                data["workflows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFeatureRulesDto {
    featureName?: string | undefined;
    workflows?: WorkflowDto[] | undefined;
}

export class RuleDto implements IRuleDto {
    enabled?: boolean;
    ruleName?: string | undefined;
    fullRuleName?: string | undefined;
    axNumbers?: string[] | undefined;
    filters?: string | undefined;

    constructor(data?: IRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.ruleName = _data["ruleName"];
            this.fullRuleName = _data["fullRuleName"];
            if (Array.isArray(_data["axNumbers"])) {
                this.axNumbers = [] as any;
                for (let item of _data["axNumbers"])
                    this.axNumbers!.push(item);
            }
            this.filters = _data["filters"];
        }
    }

    static fromJS(data: any): RuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["ruleName"] = this.ruleName;
        data["fullRuleName"] = this.fullRuleName;
        if (Array.isArray(this.axNumbers)) {
            data["axNumbers"] = [];
            for (let item of this.axNumbers)
                data["axNumbers"].push(item);
        }
        data["filters"] = this.filters;
        return data;
    }
}

export interface IRuleDto {
    enabled?: boolean;
    ruleName?: string | undefined;
    fullRuleName?: string | undefined;
    axNumbers?: string[] | undefined;
    filters?: string | undefined;
}

export class WorkflowDto implements IWorkflowDto {
    workflowName?: string | undefined;
    rules?: RuleDto[] | undefined;

    constructor(data?: IWorkflowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workflowName = _data["workflowName"];
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(RuleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkflowDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workflowName"] = this.workflowName;
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWorkflowDto {
    workflowName?: string | undefined;
    rules?: RuleDto[] | undefined;
}

export class NewsCenterArticlesResponse implements INewsCenterArticlesResponse {
    articles?: PaginatedResultDto_1OfArticleDto;
    filterOptions?: NewsCenterFilterOptionDto[] | undefined;

    constructor(data?: INewsCenterArticlesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articles = _data["articles"] ? PaginatedResultDto_1OfArticleDto.fromJS(_data["articles"]) : <any>undefined;
            if (Array.isArray(_data["filterOptions"])) {
                this.filterOptions = [] as any;
                for (let item of _data["filterOptions"])
                    this.filterOptions!.push(NewsCenterFilterOptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NewsCenterArticlesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NewsCenterArticlesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articles"] = this.articles ? this.articles.toJSON() : <any>undefined;
        if (Array.isArray(this.filterOptions)) {
            data["filterOptions"] = [];
            for (let item of this.filterOptions)
                data["filterOptions"].push(item.toJSON());
        }
        return data;
    }
}

export interface INewsCenterArticlesResponse {
    articles?: PaginatedResultDto_1OfArticleDto;
    filterOptions?: NewsCenterFilterOptionDto[] | undefined;
}

export enum SeverityLevel {
    Low = "Low",
    Medium = "Medium",
    High = "High",
}

export class ArticleDetailDto implements IArticleDetailDto {
    id?: number;
    title?: string | undefined;
    content?: string | undefined;
    category?: string | undefined;
    partner?: string | undefined;
    severityLevel?: SeverityLevel;
    modified?: Date;
    tags?: string[] | undefined;

    constructor(data?: IArticleDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.content = _data["content"];
            this.category = _data["category"];
            this.partner = _data["partner"];
            this.severityLevel = _data["severityLevel"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
        }
    }

    static fromJS(data: any): ArticleDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["content"] = this.content;
        data["category"] = this.category;
        data["partner"] = this.partner;
        data["severityLevel"] = this.severityLevel;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data;
    }
}

export interface IArticleDetailDto {
    id?: number;
    title?: string | undefined;
    content?: string | undefined;
    category?: string | undefined;
    partner?: string | undefined;
    severityLevel?: SeverityLevel;
    modified?: Date;
    tags?: string[] | undefined;
}

export class ArticleDto implements IArticleDto {
    id?: number;
    title?: string | undefined;
    category?: string | undefined;
    partner?: string | undefined;
    severityLevel?: SeverityLevel;
    modified?: Date;
    tags?: string[] | undefined;

    constructor(data?: IArticleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.category = _data["category"];
            this.partner = _data["partner"];
            this.severityLevel = _data["severityLevel"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
        }
    }

    static fromJS(data: any): ArticleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["category"] = this.category;
        data["partner"] = this.partner;
        data["severityLevel"] = this.severityLevel;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data;
    }
}

export interface IArticleDto {
    id?: number;
    title?: string | undefined;
    category?: string | undefined;
    partner?: string | undefined;
    severityLevel?: SeverityLevel;
    modified?: Date;
    tags?: string[] | undefined;
}

export class NewsCenterFilterOptionDto implements INewsCenterFilterOptionDto {
    accessor?: string | undefined;
    options?: string[] | undefined;

    constructor(data?: INewsCenterFilterOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessor = _data["accessor"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(item);
            }
        }
    }

    static fromJS(data: any): NewsCenterFilterOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewsCenterFilterOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessor"] = this.accessor;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item);
        }
        return data;
    }
}

export interface INewsCenterFilterOptionDto {
    accessor?: string | undefined;
    options?: string[] | undefined;
}

export class NewsCenterQuery implements INewsCenterQuery {
    page?: number;
    pageSize?: number;
    searchString?: string | undefined;
    sortOption?: NewsCenterQuerySortOption;
    filters?: NewsCenterQueryFilter[] | undefined;

    constructor(data?: INewsCenterQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.searchString = _data["searchString"];
            this.sortOption = _data["sortOption"] ? NewsCenterQuerySortOption.fromJS(_data["sortOption"]) : <any>undefined;
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(NewsCenterQueryFilter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NewsCenterQuery {
        data = typeof data === 'object' ? data : {};
        let result = new NewsCenterQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["searchString"] = this.searchString;
        data["sortOption"] = this.sortOption ? this.sortOption.toJSON() : <any>undefined;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        return data;
    }
}

export interface INewsCenterQuery {
    page?: number;
    pageSize?: number;
    searchString?: string | undefined;
    sortOption?: NewsCenterQuerySortOption;
    filters?: NewsCenterQueryFilter[] | undefined;
}

export class NewsCenterQueryFilter implements INewsCenterQueryFilter {
    column?: string | undefined;
    values?: string[] | undefined;

    constructor(data?: INewsCenterQueryFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.column = _data["column"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
        }
    }

    static fromJS(data: any): NewsCenterQueryFilter {
        data = typeof data === 'object' ? data : {};
        let result = new NewsCenterQueryFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["column"] = this.column;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        return data;
    }
}

export interface INewsCenterQueryFilter {
    column?: string | undefined;
    values?: string[] | undefined;
}

export class NewsCenterQuerySortOption implements INewsCenterQuerySortOption {
    column?: string | undefined;
    descending?: boolean;

    constructor(data?: INewsCenterQuerySortOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.column = _data["column"];
            this.descending = _data["descending"];
        }
    }

    static fromJS(data: any): NewsCenterQuerySortOption {
        data = typeof data === 'object' ? data : {};
        let result = new NewsCenterQuerySortOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["column"] = this.column;
        data["descending"] = this.descending;
        return data;
    }
}

export interface INewsCenterQuerySortOption {
    column?: string | undefined;
    descending?: boolean;
}

export class EventDataDto implements IEventDataDto {

    protected _discriminator: string;

    constructor(data?: IEventDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "EventDataDto";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): EventDataDto {
        data = typeof data === 'object' ? data : {};
        if (data["typeName"] === "ServiceRequestCreatedDto") {
            let result = new ServiceRequestCreatedDto();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "ProjectedSpendDto") {
            let result = new ProjectedSpendDto();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "SpendingThresholdDto") {
            let result = new SpendingThresholdDto();
            result.init(data);
            return result;
        }
        let result = new EventDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeName"] = this._discriminator;
        return data;
    }
}

export interface IEventDataDto {
}

export class ProjectedSpendDto extends EventDataDto implements IProjectedSpendDto {
    commitment?: number;
    projectedSpend?: number;
    projectedSpendPercentage?: number;

    constructor(data?: IProjectedSpendDto) {
        super(data);
        this._discriminator = "ProjectedSpendDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.commitment = _data["commitment"];
            this.projectedSpend = _data["projectedSpend"];
            this.projectedSpendPercentage = _data["projectedSpendPercentage"];
        }
    }

    static override fromJS(data: any): ProjectedSpendDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectedSpendDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commitment"] = this.commitment;
        data["projectedSpend"] = this.projectedSpend;
        data["projectedSpendPercentage"] = this.projectedSpendPercentage;
        super.toJSON(data);
        return data;
    }
}

export interface IProjectedSpendDto extends IEventDataDto {
    commitment?: number;
    projectedSpend?: number;
    projectedSpendPercentage?: number;
}

export class SpendingThresholdDto extends EventDataDto implements ISpendingThresholdDto {
    estimatedSpend?: number;
    highThresholdSpendPercentage?: number;
    lowThresholdSpendPercentage?: number;
    spendLimit?: number;

    constructor(data?: ISpendingThresholdDto) {
        super(data);
        this._discriminator = "SpendingThresholdDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.estimatedSpend = _data["estimatedSpend"];
            this.highThresholdSpendPercentage = _data["highThresholdSpendPercentage"];
            this.lowThresholdSpendPercentage = _data["lowThresholdSpendPercentage"];
            this.spendLimit = _data["spendLimit"];
        }
    }

    static override fromJS(data: any): SpendingThresholdDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpendingThresholdDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["estimatedSpend"] = this.estimatedSpend;
        data["highThresholdSpendPercentage"] = this.highThresholdSpendPercentage;
        data["lowThresholdSpendPercentage"] = this.lowThresholdSpendPercentage;
        data["spendLimit"] = this.spendLimit;
        super.toJSON(data);
        return data;
    }
}

export interface ISpendingThresholdDto extends IEventDataDto {
    estimatedSpend?: number;
    highThresholdSpendPercentage?: number;
    lowThresholdSpendPercentage?: number;
    spendLimit?: number;
}

export class RuleEventDto implements IRuleEventDto {
    accountName?: string | undefined;
    axAccountNumber?: string | undefined;
    workflowName?: string | undefined;
    eventData?: EventDataDto | undefined;

    constructor(data?: IRuleEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountName = _data["accountName"];
            this.axAccountNumber = _data["axAccountNumber"];
            this.workflowName = _data["workflowName"];
            this.eventData = _data["eventData"] ? EventDataDto.fromJS(_data["eventData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RuleEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new RuleEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName;
        data["axAccountNumber"] = this.axAccountNumber;
        data["workflowName"] = this.workflowName;
        data["eventData"] = this.eventData ? this.eventData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRuleEventDto {
    accountName?: string | undefined;
    axAccountNumber?: string | undefined;
    workflowName?: string | undefined;
    eventData?: EventDataDto | undefined;
}

export class ServiceRequestCreatedDto extends EventDataDto implements IServiceRequestCreatedDto {
    ticketNumber?: string | undefined;
    ticketTitle?: string | undefined;
    ticketSeverity?: string | undefined;
    requestType?: string | undefined;

    constructor(data?: IServiceRequestCreatedDto) {
        super(data);
        this._discriminator = "ServiceRequestCreatedDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ticketNumber = _data["ticketNumber"];
            this.ticketTitle = _data["ticketTitle"];
            this.ticketSeverity = _data["ticketSeverity"];
            this.requestType = _data["requestType"];
        }
    }

    static override fromJS(data: any): ServiceRequestCreatedDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestCreatedDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketNumber"] = this.ticketNumber;
        data["ticketTitle"] = this.ticketTitle;
        data["ticketSeverity"] = this.ticketSeverity;
        data["requestType"] = this.requestType;
        super.toJSON(data);
        return data;
    }
}

export interface IServiceRequestCreatedDto extends IEventDataDto {
    ticketNumber?: string | undefined;
    ticketTitle?: string | undefined;
    ticketSeverity?: string | undefined;
    requestType?: string | undefined;
}

export class AwsPotentialSavingsWidgetDto implements IAwsPotentialSavingsWidgetDto {
    optimizationSavingsAmount?: number | undefined;
    optimizationSavingsSeverityColor?: SeverityColor;
    rightsizingSavingsAmount?: number;
    rightsizingSavingsSeverityColor?: SeverityColor;
    withSavingsPlansAmount?: number;
    withSavingsPlansSeverityColor?: SeverityColor;
    reservationsSavingsAmount?: number;
    reservationsSavingsSeverityColor?: SeverityColor;

    constructor(data?: IAwsPotentialSavingsWidgetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.optimizationSavingsAmount = _data["optimizationSavingsAmount"];
            this.optimizationSavingsSeverityColor = _data["optimizationSavingsSeverityColor"];
            this.rightsizingSavingsAmount = _data["rightsizingSavingsAmount"];
            this.rightsizingSavingsSeverityColor = _data["rightsizingSavingsSeverityColor"];
            this.withSavingsPlansAmount = _data["withSavingsPlansAmount"];
            this.withSavingsPlansSeverityColor = _data["withSavingsPlansSeverityColor"];
            this.reservationsSavingsAmount = _data["reservationsSavingsAmount"];
            this.reservationsSavingsSeverityColor = _data["reservationsSavingsSeverityColor"];
        }
    }

    static fromJS(data: any): AwsPotentialSavingsWidgetDto {
        data = typeof data === 'object' ? data : {};
        let result = new AwsPotentialSavingsWidgetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["optimizationSavingsAmount"] = this.optimizationSavingsAmount;
        data["optimizationSavingsSeverityColor"] = this.optimizationSavingsSeverityColor;
        data["rightsizingSavingsAmount"] = this.rightsizingSavingsAmount;
        data["rightsizingSavingsSeverityColor"] = this.rightsizingSavingsSeverityColor;
        data["withSavingsPlansAmount"] = this.withSavingsPlansAmount;
        data["withSavingsPlansSeverityColor"] = this.withSavingsPlansSeverityColor;
        data["reservationsSavingsAmount"] = this.reservationsSavingsAmount;
        data["reservationsSavingsSeverityColor"] = this.reservationsSavingsSeverityColor;
        return data;
    }
}

export interface IAwsPotentialSavingsWidgetDto {
    optimizationSavingsAmount?: number | undefined;
    optimizationSavingsSeverityColor?: SeverityColor;
    rightsizingSavingsAmount?: number;
    rightsizingSavingsSeverityColor?: SeverityColor;
    withSavingsPlansAmount?: number;
    withSavingsPlansSeverityColor?: SeverityColor;
    reservationsSavingsAmount?: number;
    reservationsSavingsSeverityColor?: SeverityColor;
}

export class BarChartDatasetDto implements IBarChartDatasetDto {
    label?: string | undefined;
    stackId?: string | undefined;
    data?: number[] | undefined;

    constructor(data?: IBarChartDatasetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.stackId = _data["stackId"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(item);
            }
        }
    }

    static fromJS(data: any): BarChartDatasetDto {
        data = typeof data === 'object' ? data : {};
        let result = new BarChartDatasetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["stackId"] = this.stackId;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        return data;
    }
}

export interface IBarChartDatasetDto {
    label?: string | undefined;
    stackId?: string | undefined;
    data?: number[] | undefined;
}

export class BarChartDto implements IBarChartDto {
    datasets?: BarChartDatasetDto[] | undefined;
    labels?: string[] | undefined;

    constructor(data?: IBarChartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["datasets"])) {
                this.datasets = [] as any;
                for (let item of _data["datasets"])
                    this.datasets!.push(BarChartDatasetDto.fromJS(item));
            }
            if (Array.isArray(_data["labels"])) {
                this.labels = [] as any;
                for (let item of _data["labels"])
                    this.labels!.push(item);
            }
        }
    }

    static fromJS(data: any): BarChartDto {
        data = typeof data === 'object' ? data : {};
        let result = new BarChartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datasets)) {
            data["datasets"] = [];
            for (let item of this.datasets)
                data["datasets"].push(item.toJSON());
        }
        if (Array.isArray(this.labels)) {
            data["labels"] = [];
            for (let item of this.labels)
                data["labels"].push(item);
        }
        return data;
    }
}

export interface IBarChartDto {
    datasets?: BarChartDatasetDto[] | undefined;
    labels?: string[] | undefined;
}

export class CloudPotentialSavingsWidgetDto implements ICloudPotentialSavingsWidgetDto {
    optimizationSavingsAmount?: number | undefined;
    optimizationSavingsSeverityColor?: SeverityColor;
    rightsizingSavingsAmount?: number;
    rightsizingSavingsSeverityColor?: SeverityColor;
    withSavingsPlansAmount?: number;
    withSavingsPlansSeverityColor?: SeverityColor;
    reservationsSavingsAmount?: number;
    reservationsSavingsSeverityColor?: SeverityColor;

    constructor(data?: ICloudPotentialSavingsWidgetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.optimizationSavingsAmount = _data["optimizationSavingsAmount"];
            this.optimizationSavingsSeverityColor = _data["optimizationSavingsSeverityColor"];
            this.rightsizingSavingsAmount = _data["rightsizingSavingsAmount"];
            this.rightsizingSavingsSeverityColor = _data["rightsizingSavingsSeverityColor"];
            this.withSavingsPlansAmount = _data["withSavingsPlansAmount"];
            this.withSavingsPlansSeverityColor = _data["withSavingsPlansSeverityColor"];
            this.reservationsSavingsAmount = _data["reservationsSavingsAmount"];
            this.reservationsSavingsSeverityColor = _data["reservationsSavingsSeverityColor"];
        }
    }

    static fromJS(data: any): CloudPotentialSavingsWidgetDto {
        data = typeof data === 'object' ? data : {};
        let result = new CloudPotentialSavingsWidgetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["optimizationSavingsAmount"] = this.optimizationSavingsAmount;
        data["optimizationSavingsSeverityColor"] = this.optimizationSavingsSeverityColor;
        data["rightsizingSavingsAmount"] = this.rightsizingSavingsAmount;
        data["rightsizingSavingsSeverityColor"] = this.rightsizingSavingsSeverityColor;
        data["withSavingsPlansAmount"] = this.withSavingsPlansAmount;
        data["withSavingsPlansSeverityColor"] = this.withSavingsPlansSeverityColor;
        data["reservationsSavingsAmount"] = this.reservationsSavingsAmount;
        data["reservationsSavingsSeverityColor"] = this.reservationsSavingsSeverityColor;
        return data;
    }
}

export interface ICloudPotentialSavingsWidgetDto {
    optimizationSavingsAmount?: number | undefined;
    optimizationSavingsSeverityColor?: SeverityColor;
    rightsizingSavingsAmount?: number;
    rightsizingSavingsSeverityColor?: SeverityColor;
    withSavingsPlansAmount?: number;
    withSavingsPlansSeverityColor?: SeverityColor;
    reservationsSavingsAmount?: number;
    reservationsSavingsSeverityColor?: SeverityColor;
}

export class PageLayoutColumnDto implements IPageLayoutColumnDto {
    widgets?: PageLayoutWidgetDto[] | undefined;

    constructor(data?: IPageLayoutColumnDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["widgets"])) {
                this.widgets = [] as any;
                for (let item of _data["widgets"])
                    this.widgets!.push(PageLayoutWidgetDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PageLayoutColumnDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageLayoutColumnDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.widgets)) {
            data["widgets"] = [];
            for (let item of this.widgets)
                data["widgets"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPageLayoutColumnDto {
    widgets?: PageLayoutWidgetDto[] | undefined;
}

export class PageLayoutDto implements IPageLayoutDto {
    pageLayoutId?: string | undefined;
    columns?: PageLayoutColumnDto[] | undefined;
    widgetGroups?: string[] | undefined;

    constructor(data?: IPageLayoutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageLayoutId = _data["pageLayoutId"];
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(PageLayoutColumnDto.fromJS(item));
            }
            if (Array.isArray(_data["widgetGroups"])) {
                this.widgetGroups = [] as any;
                for (let item of _data["widgetGroups"])
                    this.widgetGroups!.push(item);
            }
        }
    }

    static fromJS(data: any): PageLayoutDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageLayoutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageLayoutId"] = this.pageLayoutId;
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        if (Array.isArray(this.widgetGroups)) {
            data["widgetGroups"] = [];
            for (let item of this.widgetGroups)
                data["widgetGroups"].push(item);
        }
        return data;
    }
}

export interface IPageLayoutDto {
    pageLayoutId?: string | undefined;
    columns?: PageLayoutColumnDto[] | undefined;
    widgetGroups?: string[] | undefined;
}

export class PageLayoutWidgetDto implements IPageLayoutWidgetDto {
    widgetId?: string | undefined;
    title?: string | undefined;
    widgetGroup?: string | undefined;
    enabled?: boolean;

    constructor(data?: IPageLayoutWidgetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.widgetId = _data["widgetId"];
            this.title = _data["title"];
            this.widgetGroup = _data["widgetGroup"];
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): PageLayoutWidgetDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageLayoutWidgetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["widgetId"] = this.widgetId;
        data["title"] = this.title;
        data["widgetGroup"] = this.widgetGroup;
        data["enabled"] = this.enabled;
        return data;
    }
}

export interface IPageLayoutWidgetDto {
    widgetId?: string | undefined;
    title?: string | undefined;
    widgetGroup?: string | undefined;
    enabled?: boolean;
}

export class PieChartDto implements IPieChartDto {
    totalLabel?: string | undefined;
    totalCount?: number;
    slices?: PieChartSliceDto[] | undefined;

    constructor(data?: IPieChartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalLabel = _data["totalLabel"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["slices"])) {
                this.slices = [] as any;
                for (let item of _data["slices"])
                    this.slices!.push(PieChartSliceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PieChartDto {
        data = typeof data === 'object' ? data : {};
        let result = new PieChartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalLabel"] = this.totalLabel;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.slices)) {
            data["slices"] = [];
            for (let item of this.slices)
                data["slices"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPieChartDto {
    totalLabel?: string | undefined;
    totalCount?: number;
    slices?: PieChartSliceDto[] | undefined;
}

export class PieChartSliceDto implements IPieChartSliceDto {
    label?: string | undefined;
    quantity?: number;
    percentage?: number | undefined;

    constructor(data?: IPieChartSliceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.quantity = _data["quantity"];
            this.percentage = _data["percentage"];
        }
    }

    static fromJS(data: any): PieChartSliceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PieChartSliceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["quantity"] = this.quantity;
        data["percentage"] = this.percentage;
        return data;
    }
}

export interface IPieChartSliceDto {
    label?: string | undefined;
    quantity?: number;
    percentage?: number | undefined;
}

export class SampleWidgetBResponseDto implements ISampleWidgetBResponseDto {
    incomingAssets?: number;
    transferringAssets?: number;
    assetsAvailableToTransfer?: number;
    productsAtLevelRisk?: number;

    constructor(data?: ISampleWidgetBResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.incomingAssets = _data["incomingAssets"];
            this.transferringAssets = _data["transferringAssets"];
            this.assetsAvailableToTransfer = _data["assetsAvailableToTransfer"];
            this.productsAtLevelRisk = _data["productsAtLevelRisk"];
        }
    }

    static fromJS(data: any): SampleWidgetBResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SampleWidgetBResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incomingAssets"] = this.incomingAssets;
        data["transferringAssets"] = this.transferringAssets;
        data["assetsAvailableToTransfer"] = this.assetsAvailableToTransfer;
        data["productsAtLevelRisk"] = this.productsAtLevelRisk;
        return data;
    }
}

export interface ISampleWidgetBResponseDto {
    incomingAssets?: number;
    transferringAssets?: number;
    assetsAvailableToTransfer?: number;
    productsAtLevelRisk?: number;
}

export enum SeverityColor {
    BadCritical = "BadCritical",
    WarningHigh = "WarningHigh",
    Medium = "Medium",
    GoodLow = "GoodLow",
}

export class WidgetContentResponseDto_1OfAssetLifecycleManagementWidgetResponseDto implements IWidgetContentResponseDto_1OfAssetLifecycleManagementWidgetResponseDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: AssetLifecycleManagementWidgetResponseDto;

    constructor(data?: IWidgetContentResponseDto_1OfAssetLifecycleManagementWidgetResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"] ? AssetLifecycleManagementWidgetResponseDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfAssetLifecycleManagementWidgetResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfAssetLifecycleManagementWidgetResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfAssetLifecycleManagementWidgetResponseDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: AssetLifecycleManagementWidgetResponseDto;
}

export class WidgetContentResponseDto_1OfAssetWidgetFilterByCategoryResponse implements IWidgetContentResponseDto_1OfAssetWidgetFilterByCategoryResponse {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: AssetWidgetFilterByCategoryResponse;

    constructor(data?: IWidgetContentResponseDto_1OfAssetWidgetFilterByCategoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"] ? AssetWidgetFilterByCategoryResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfAssetWidgetFilterByCategoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfAssetWidgetFilterByCategoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfAssetWidgetFilterByCategoryResponse {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: AssetWidgetFilterByCategoryResponse;
}

export class WidgetContentResponseDto_1OfCoveredAssetsByProductWidgetResponse implements IWidgetContentResponseDto_1OfCoveredAssetsByProductWidgetResponse {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: CoveredAssetsByProductWidgetResponse;

    constructor(data?: IWidgetContentResponseDto_1OfCoveredAssetsByProductWidgetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"] ? CoveredAssetsByProductWidgetResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfCoveredAssetsByProductWidgetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfCoveredAssetsByProductWidgetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfCoveredAssetsByProductWidgetResponse {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: CoveredAssetsByProductWidgetResponse;
}

export class WidgetContentResponseDto_1OfGetWarehouseAggregatedOrdersResponse implements IWidgetContentResponseDto_1OfGetWarehouseAggregatedOrdersResponse {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: GetWarehouseAggregatedOrdersResponse;

    constructor(data?: IWidgetContentResponseDto_1OfGetWarehouseAggregatedOrdersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"] ? GetWarehouseAggregatedOrdersResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfGetWarehouseAggregatedOrdersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfGetWarehouseAggregatedOrdersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfGetWarehouseAggregatedOrdersResponse {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: GetWarehouseAggregatedOrdersResponse;
}

export class WidgetContentResponseDto_1OfGetWarehouseAggregatedStockResponse implements IWidgetContentResponseDto_1OfGetWarehouseAggregatedStockResponse {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: GetWarehouseAggregatedStockResponse;

    constructor(data?: IWidgetContentResponseDto_1OfGetWarehouseAggregatedStockResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"] ? GetWarehouseAggregatedStockResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfGetWarehouseAggregatedStockResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfGetWarehouseAggregatedStockResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfGetWarehouseAggregatedStockResponse {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: GetWarehouseAggregatedStockResponse;
}

export class WidgetContentResponseDto_1OfGetCurrentMonthCloudConsumptionResponse implements IWidgetContentResponseDto_1OfGetCurrentMonthCloudConsumptionResponse {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: GetCurrentMonthCloudConsumptionResponse;

    constructor(data?: IWidgetContentResponseDto_1OfGetCurrentMonthCloudConsumptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"] ? GetCurrentMonthCloudConsumptionResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfGetCurrentMonthCloudConsumptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfGetCurrentMonthCloudConsumptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfGetCurrentMonthCloudConsumptionResponse {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: GetCurrentMonthCloudConsumptionResponse;
}

export class WidgetContentResponseDto_1OfContractRequestRankingsVisualsDto implements IWidgetContentResponseDto_1OfContractRequestRankingsVisualsDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: ContractRequestRankingsVisualsDto;

    constructor(data?: IWidgetContentResponseDto_1OfContractRequestRankingsVisualsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"] ? ContractRequestRankingsVisualsDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfContractRequestRankingsVisualsDto {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfContractRequestRankingsVisualsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfContractRequestRankingsVisualsDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: ContractRequestRankingsVisualsDto;
}

export class WidgetContentResponseDto_1OfRequestMetricsVisualsDto implements IWidgetContentResponseDto_1OfRequestMetricsVisualsDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: RequestMetricsVisualsDto;

    constructor(data?: IWidgetContentResponseDto_1OfRequestMetricsVisualsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"] ? RequestMetricsVisualsDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfRequestMetricsVisualsDto {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfRequestMetricsVisualsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfRequestMetricsVisualsDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: RequestMetricsVisualsDto;
}

export class WidgetContentResponseDto_1OfRequesterRankingsVisualsDto implements IWidgetContentResponseDto_1OfRequesterRankingsVisualsDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: RequesterRankingsVisualsDto;

    constructor(data?: IWidgetContentResponseDto_1OfRequesterRankingsVisualsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"] ? RequesterRankingsVisualsDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfRequesterRankingsVisualsDto {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfRequesterRankingsVisualsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfRequesterRankingsVisualsDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: RequesterRankingsVisualsDto;
}

export class WidgetContentResponseDto_1OfSupportOverviewDto implements IWidgetContentResponseDto_1OfSupportOverviewDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: SupportOverviewDto;

    constructor(data?: IWidgetContentResponseDto_1OfSupportOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"] ? SupportOverviewDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfSupportOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfSupportOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfSupportOverviewDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: SupportOverviewDto;
}

export class WidgetContentResponseDto_1OfAwsPotentialSavingsWidgetDto implements IWidgetContentResponseDto_1OfAwsPotentialSavingsWidgetDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: AwsPotentialSavingsWidgetDto;

    constructor(data?: IWidgetContentResponseDto_1OfAwsPotentialSavingsWidgetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"] ? AwsPotentialSavingsWidgetDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfAwsPotentialSavingsWidgetDto {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfAwsPotentialSavingsWidgetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfAwsPotentialSavingsWidgetDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: AwsPotentialSavingsWidgetDto;
}

export class WidgetContentResponseDto_1OfBarChartDto implements IWidgetContentResponseDto_1OfBarChartDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: BarChartDto;

    constructor(data?: IWidgetContentResponseDto_1OfBarChartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"] ? BarChartDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfBarChartDto {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfBarChartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfBarChartDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: BarChartDto;
}

export class WidgetContentResponseDto_1OfCloudPotentialSavingsWidgetDto implements IWidgetContentResponseDto_1OfCloudPotentialSavingsWidgetDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: CloudPotentialSavingsWidgetDto;

    constructor(data?: IWidgetContentResponseDto_1OfCloudPotentialSavingsWidgetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"] ? CloudPotentialSavingsWidgetDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfCloudPotentialSavingsWidgetDto {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfCloudPotentialSavingsWidgetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfCloudPotentialSavingsWidgetDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: CloudPotentialSavingsWidgetDto;
}

export class WidgetContentResponseDto_1OfPieChartDto implements IWidgetContentResponseDto_1OfPieChartDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: PieChartDto;

    constructor(data?: IWidgetContentResponseDto_1OfPieChartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"] ? PieChartDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfPieChartDto {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfPieChartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfPieChartDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: PieChartDto;
}

export class WidgetContentResponseDto_1OfSampleWidgetBResponseDto implements IWidgetContentResponseDto_1OfSampleWidgetBResponseDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: SampleWidgetBResponseDto;

    constructor(data?: IWidgetContentResponseDto_1OfSampleWidgetBResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"] ? SampleWidgetBResponseDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfSampleWidgetBResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfSampleWidgetBResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfSampleWidgetBResponseDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: SampleWidgetBResponseDto;
}

export class WidgetContentResponseDto_1OfLastMonthsCostDto implements IWidgetContentResponseDto_1OfLastMonthsCostDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: LastMonthsCostDto;

    constructor(data?: IWidgetContentResponseDto_1OfLastMonthsCostDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"] ? LastMonthsCostDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfLastMonthsCostDto {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfLastMonthsCostDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfLastMonthsCostDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: LastMonthsCostDto;
}

export class WidgetContentResponseDto_1OfCloudAssetsWidgetDtoOf implements IWidgetContentResponseDto_1OfCloudAssetsWidgetDtoOf {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: CloudAssetsWidgetDto[] | undefined;

    constructor(data?: IWidgetContentResponseDto_1OfCloudAssetsWidgetDtoOf) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CloudAssetsWidgetDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfCloudAssetsWidgetDtoOf {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfCloudAssetsWidgetDtoOf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfCloudAssetsWidgetDtoOf {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: CloudAssetsWidgetDto[] | undefined;
}

export class WidgetContentResponseDto_1OfGetCloudConsumptionHistoryResponse implements IWidgetContentResponseDto_1OfGetCloudConsumptionHistoryResponse {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: GetCloudConsumptionHistoryResponse;

    constructor(data?: IWidgetContentResponseDto_1OfGetCloudConsumptionHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"] ? GetCloudConsumptionHistoryResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfGetCloudConsumptionHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfGetCloudConsumptionHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfGetCloudConsumptionHistoryResponse {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: GetCloudConsumptionHistoryResponse;
}

export class WidgetContentResponseDto_1OfServiceContractsWidgetDto implements IWidgetContentResponseDto_1OfServiceContractsWidgetDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: ServiceContractsWidgetDto;

    constructor(data?: IWidgetContentResponseDto_1OfServiceContractsWidgetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"] ? ServiceContractsWidgetDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfServiceContractsWidgetDto {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfServiceContractsWidgetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfServiceContractsWidgetDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: ServiceContractsWidgetDto;
}

export class WidgetContentResponseDto_1OfServiceRequestCompletedMeetingSlaWidgetDto implements IWidgetContentResponseDto_1OfServiceRequestCompletedMeetingSlaWidgetDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: ServiceRequestCompletedMeetingSlaWidgetDto;

    constructor(data?: IWidgetContentResponseDto_1OfServiceRequestCompletedMeetingSlaWidgetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"] ? ServiceRequestCompletedMeetingSlaWidgetDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfServiceRequestCompletedMeetingSlaWidgetDto {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfServiceRequestCompletedMeetingSlaWidgetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfServiceRequestCompletedMeetingSlaWidgetDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: ServiceRequestCompletedMeetingSlaWidgetDto;
}

export class WidgetContentResponseDto_1OfServicesExpiringContractsWidgetDto implements IWidgetContentResponseDto_1OfServicesExpiringContractsWidgetDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: ServicesExpiringContractsWidgetDto;

    constructor(data?: IWidgetContentResponseDto_1OfServicesExpiringContractsWidgetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"] ? ServicesExpiringContractsWidgetDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfServicesExpiringContractsWidgetDto {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfServicesExpiringContractsWidgetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfServicesExpiringContractsWidgetDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: ServicesExpiringContractsWidgetDto;
}

export class WidgetContentResponseDto_1OfString implements IWidgetContentResponseDto_1OfString {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: string | undefined;

    constructor(data?: IWidgetContentResponseDto_1OfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfString {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfString {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: string | undefined;
}

export enum PermissionConfigurationType {
    Manual = "Manual",
    InferredAtRuntimeForAdmins = "InferredAtRuntimeForAdmins",
    InferredAtRuntimeForEveryone = "InferredAtRuntimeForEveryone",
}

export class ActionDto implements IActionDto {
    displayName?: string | undefined;
    actionName?: string | undefined;

    constructor(data?: IActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.actionName = _data["actionName"];
        }
    }

    static fromJS(data: any): ActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["actionName"] = this.actionName;
        return data;
    }
}

export interface IActionDto {
    displayName?: string | undefined;
    actionName?: string | undefined;
}

export class DuplicateReportRequest implements IDuplicateReportRequest {
    reportName?: string | undefined;
    reportDescription?: string | undefined;
    powerBiReportId?: string;
    authorizationSettings?: SelfServiceAuthorizationSettings;

    constructor(data?: IDuplicateReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportName = _data["reportName"];
            this.reportDescription = _data["reportDescription"];
            this.powerBiReportId = _data["powerBiReportId"];
            this.authorizationSettings = _data["authorizationSettings"] ? SelfServiceAuthorizationSettings.fromJS(_data["authorizationSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DuplicateReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DuplicateReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportName"] = this.reportName;
        data["reportDescription"] = this.reportDescription;
        data["powerBiReportId"] = this.powerBiReportId;
        data["authorizationSettings"] = this.authorizationSettings ? this.authorizationSettings.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDuplicateReportRequest {
    reportName?: string | undefined;
    reportDescription?: string | undefined;
    powerBiReportId?: string;
    authorizationSettings?: SelfServiceAuthorizationSettings;
}

export class EmbedParams implements IEmbedParams {
    type?: string | undefined;
    embedReport?: EmbedReport;
    embedToken?: EmbedToken;

    constructor(data?: IEmbedParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.embedReport = _data["embedReport"] ? EmbedReport.fromJS(_data["embedReport"]) : <any>undefined;
            this.embedToken = _data["embedToken"] ? EmbedToken.fromJS(_data["embedToken"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmbedParams {
        data = typeof data === 'object' ? data : {};
        let result = new EmbedParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["embedReport"] = this.embedReport ? this.embedReport.toJSON() : <any>undefined;
        data["embedToken"] = this.embedToken ? this.embedToken.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEmbedParams {
    type?: string | undefined;
    embedReport?: EmbedReport;
    embedToken?: EmbedToken;
}

export class BookmarkDto implements IBookmarkDto {
    readonly bookmarkId?: string | undefined;
    bookmarkType?: BookmarkTypes;
    entityId?: string | undefined;
    settingsKey?: string | undefined;
    name?: string | undefined;
    value?: string | undefined;
    reportId?: string | undefined;

    constructor(data?: IBookmarkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).bookmarkId = _data["bookmarkId"];
            this.bookmarkType = _data["bookmarkType"];
            this.entityId = _data["entityId"];
            this.settingsKey = _data["settingsKey"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.reportId = _data["reportId"];
        }
    }

    static fromJS(data: any): BookmarkDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookmarkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookmarkId"] = this.bookmarkId;
        data["bookmarkType"] = this.bookmarkType;
        data["entityId"] = this.entityId;
        data["settingsKey"] = this.settingsKey;
        data["name"] = this.name;
        data["value"] = this.value;
        data["reportId"] = this.reportId;
        return data;
    }
}

export interface IBookmarkDto {
    bookmarkId?: string | undefined;
    bookmarkType?: BookmarkTypes;
    entityId?: string | undefined;
    settingsKey?: string | undefined;
    name?: string | undefined;
    value?: string | undefined;
    reportId?: string | undefined;
}

export enum BookmarkTypes {
    Group = "Group",
    User = "User",
}

export class BookmarksDto implements IBookmarksDto {
    userBookmarks?: BookmarkDto[] | undefined;
    groupBookmarks?: BookmarkDto[] | undefined;

    constructor(data?: IBookmarksDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userBookmarks"])) {
                this.userBookmarks = [] as any;
                for (let item of _data["userBookmarks"])
                    this.userBookmarks!.push(BookmarkDto.fromJS(item));
            }
            if (Array.isArray(_data["groupBookmarks"])) {
                this.groupBookmarks = [] as any;
                for (let item of _data["groupBookmarks"])
                    this.groupBookmarks!.push(BookmarkDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BookmarksDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookmarksDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userBookmarks)) {
            data["userBookmarks"] = [];
            for (let item of this.userBookmarks)
                data["userBookmarks"].push(item.toJSON());
        }
        if (Array.isArray(this.groupBookmarks)) {
            data["groupBookmarks"] = [];
            for (let item of this.groupBookmarks)
                data["groupBookmarks"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBookmarksDto {
    userBookmarks?: BookmarkDto[] | undefined;
    groupBookmarks?: BookmarkDto[] | undefined;
}

export enum DatasetCategories {
    AWSConsumption = "AWSConsumption",
    AzureDirectConsumption = "AzureDirectConsumption",
    AzurePlanConsumption = "AzurePlanConsumption",
    ServiceRequests = "ServiceRequests",
    MicrosoftConsolidatedAssets = "MicrosoftConsolidatedAssets",
    CustomerAssets = "CustomerAssets",
}

export class EmbedReport implements IEmbedReport {
    reportId?: string | undefined;
    reportName?: string | undefined;
    embedUrl?: string | undefined;

    constructor(data?: IEmbedReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.reportName = _data["reportName"];
            this.embedUrl = _data["embedUrl"];
        }
    }

    static fromJS(data: any): EmbedReport {
        data = typeof data === 'object' ? data : {};
        let result = new EmbedReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["reportName"] = this.reportName;
        data["embedUrl"] = this.embedUrl;
        return data;
    }
}

export interface IEmbedReport {
    reportId?: string | undefined;
    reportName?: string | undefined;
    embedUrl?: string | undefined;
}

export class GetReportHistory implements IGetReportHistory {
    versions?: SelfServiceReportVersionDto[][] | undefined;

    constructor(data?: IGetReportHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["versions"])) {
                this.versions = [] as any;
                for (let item of _data["versions"])
                    this.versions!.push(item);
            }
        }
    }

    static fromJS(data: any): GetReportHistory {
        data = typeof data === 'object' ? data : {};
        let result = new GetReportHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.versions)) {
            data["versions"] = [];
            for (let item of this.versions)
                data["versions"].push(item);
        }
        return data;
    }
}

export interface IGetReportHistory {
    versions?: SelfServiceReportVersionDto[][] | undefined;
}

export class ReportDto implements IReportDto {
    id?: number;
    pbiReportId?: string;
    name?: string | undefined;
    description?: string | undefined;
    draftVersionId?: number | undefined;
    activeVersionId?: number | undefined;
    draftVersion?: ReportVersionDto;
    activeVersion?: ReportVersionDto;
    versionId?: number;
    datasetCategory?: DatasetCategories;
    pbiDatasetId?: string;
    status?: ReportStatus;
    canEdit?: boolean;
    canDuplicate?: boolean;
    canDelete?: boolean;
    canDiscardChanges?: boolean;
    canDiscardChangesAndTakeOwnership?: boolean;
    canPublish?: boolean;
    canUnpublish?: boolean;

    constructor(data?: IReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pbiReportId = _data["pbiReportId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.draftVersionId = _data["draftVersionId"];
            this.activeVersionId = _data["activeVersionId"];
            this.draftVersion = _data["draftVersion"] ? ReportVersionDto.fromJS(_data["draftVersion"]) : <any>undefined;
            this.activeVersion = _data["activeVersion"] ? ReportVersionDto.fromJS(_data["activeVersion"]) : <any>undefined;
            this.versionId = _data["versionId"];
            this.datasetCategory = _data["datasetCategory"];
            this.pbiDatasetId = _data["pbiDatasetId"];
            this.status = _data["status"];
            this.canEdit = _data["canEdit"];
            this.canDuplicate = _data["canDuplicate"];
            this.canDelete = _data["canDelete"];
            this.canDiscardChanges = _data["canDiscardChanges"];
            this.canDiscardChangesAndTakeOwnership = _data["canDiscardChangesAndTakeOwnership"];
            this.canPublish = _data["canPublish"];
            this.canUnpublish = _data["canUnpublish"];
        }
    }

    static fromJS(data: any): ReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pbiReportId"] = this.pbiReportId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["draftVersionId"] = this.draftVersionId;
        data["activeVersionId"] = this.activeVersionId;
        data["draftVersion"] = this.draftVersion ? this.draftVersion.toJSON() : <any>undefined;
        data["activeVersion"] = this.activeVersion ? this.activeVersion.toJSON() : <any>undefined;
        data["versionId"] = this.versionId;
        data["datasetCategory"] = this.datasetCategory;
        data["pbiDatasetId"] = this.pbiDatasetId;
        data["status"] = this.status;
        data["canEdit"] = this.canEdit;
        data["canDuplicate"] = this.canDuplicate;
        data["canDelete"] = this.canDelete;
        data["canDiscardChanges"] = this.canDiscardChanges;
        data["canDiscardChangesAndTakeOwnership"] = this.canDiscardChangesAndTakeOwnership;
        data["canPublish"] = this.canPublish;
        data["canUnpublish"] = this.canUnpublish;
        return data;
    }
}

export interface IReportDto {
    id?: number;
    pbiReportId?: string;
    name?: string | undefined;
    description?: string | undefined;
    draftVersionId?: number | undefined;
    activeVersionId?: number | undefined;
    draftVersion?: ReportVersionDto;
    activeVersion?: ReportVersionDto;
    versionId?: number;
    datasetCategory?: DatasetCategories;
    pbiDatasetId?: string;
    status?: ReportStatus;
    canEdit?: boolean;
    canDuplicate?: boolean;
    canDelete?: boolean;
    canDiscardChanges?: boolean;
    canDiscardChangesAndTakeOwnership?: boolean;
    canPublish?: boolean;
    canUnpublish?: boolean;
}

export enum ReportStatus {
    Published = "Published",
    PendingChanges = "PendingChanges",
    LockedForEditing = "LockedForEditing",
}

export class ReportVersionDto implements IReportVersionDto {
    id?: number;
    pbiReportId?: string;
    createdDateTimeUtc?: Date;
    createdBy?: string | undefined;

    constructor(data?: IReportVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pbiReportId = _data["pbiReportId"];
            this.createdDateTimeUtc = _data["createdDateTimeUtc"] ? new Date(_data["createdDateTimeUtc"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
        }
    }

    static fromJS(data: any): ReportVersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportVersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pbiReportId"] = this.pbiReportId;
        data["createdDateTimeUtc"] = this.createdDateTimeUtc ? this.createdDateTimeUtc.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        return data;
    }
}

export interface IReportVersionDto {
    id?: number;
    pbiReportId?: string;
    createdDateTimeUtc?: Date;
    createdBy?: string | undefined;
}

export class ReportsDto implements IReportsDto {
    reports?: ReportDto[] | undefined;

    constructor(data?: IReportsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["reports"])) {
                this.reports = [] as any;
                for (let item of _data["reports"])
                    this.reports!.push(ReportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReportsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.reports)) {
            data["reports"] = [];
            for (let item of this.reports)
                data["reports"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReportsDto {
    reports?: ReportDto[] | undefined;
}

export class SelfServiceAuthorizationSettings implements ISelfServiceAuthorizationSettings {
    accountId?: number;
    userEntityId?: string | undefined;
    hasReportEditPermission?: boolean;
    allowedDatasetCategories?: DatasetCategories[] | undefined;

    constructor(data?: ISelfServiceAuthorizationSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.userEntityId = _data["userEntityId"];
            this.hasReportEditPermission = _data["hasReportEditPermission"];
            if (Array.isArray(_data["allowedDatasetCategories"])) {
                this.allowedDatasetCategories = [] as any;
                for (let item of _data["allowedDatasetCategories"])
                    this.allowedDatasetCategories!.push(item);
            }
        }
    }

    static fromJS(data: any): SelfServiceAuthorizationSettings {
        data = typeof data === 'object' ? data : {};
        let result = new SelfServiceAuthorizationSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["userEntityId"] = this.userEntityId;
        data["hasReportEditPermission"] = this.hasReportEditPermission;
        if (Array.isArray(this.allowedDatasetCategories)) {
            data["allowedDatasetCategories"] = [];
            for (let item of this.allowedDatasetCategories)
                data["allowedDatasetCategories"].push(item);
        }
        return data;
    }
}

export interface ISelfServiceAuthorizationSettings {
    accountId?: number;
    userEntityId?: string | undefined;
    hasReportEditPermission?: boolean;
    allowedDatasetCategories?: DatasetCategories[] | undefined;
}

export class SelfServiceReportVersionDto implements ISelfServiceReportVersionDto {
    versionId?: number;
    createTime?: Date;
    status?: string | undefined;
    createdBy?: string | undefined;
    version?: number;
    reportId?: number;

    constructor(data?: ISelfServiceReportVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.versionId = _data["versionId"];
            this.createTime = _data["createTime"] ? new Date(_data["createTime"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.createdBy = _data["createdBy"];
            this.version = _data["version"];
            this.reportId = _data["reportId"];
        }
    }

    static fromJS(data: any): SelfServiceReportVersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelfServiceReportVersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["versionId"] = this.versionId;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["createdBy"] = this.createdBy;
        data["version"] = this.version;
        data["reportId"] = this.reportId;
        return data;
    }
}

export interface ISelfServiceReportVersionDto {
    versionId?: number;
    createTime?: Date;
    status?: string | undefined;
    createdBy?: string | undefined;
    version?: number;
    reportId?: number;
}

export class ContractBlockDto implements IContractBlockDto {
    id?: number;
    contractID?: number | undefined;
    datePurchased?: Date;
    startDate?: Date;
    endDate?: Date;
    hours?: number;
    hoursApproved?: number;
    status?: number;

    constructor(data?: IContractBlockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contractID = _data["contractID"];
            this.datePurchased = _data["datePurchased"] ? new Date(_data["datePurchased"].toString()) : <any>undefined;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.hours = _data["hours"];
            this.hoursApproved = _data["hoursApproved"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ContractBlockDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractBlockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contractID"] = this.contractID;
        data["datePurchased"] = this.datePurchased ? this.datePurchased.toISOString() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["hours"] = this.hours;
        data["hoursApproved"] = this.hoursApproved;
        data["status"] = this.status;
        return data;
    }
}

export interface IContractBlockDto {
    id?: number;
    contractID?: number | undefined;
    datePurchased?: Date;
    startDate?: Date;
    endDate?: Date;
    hours?: number;
    hoursApproved?: number;
    status?: number;
}

export class ContractDto implements IContractDto {
    id?: number;
    userDefinedFieldsJson?: string | undefined;
    accountID?: number | undefined;
    businessDivisionSubdivisionID?: number;
    compliance?: boolean;
    contactID?: number | undefined;
    contactName?: string | undefined;
    contractCategory?: number | undefined;
    contractName?: string | undefined;
    contractNumber?: string | undefined;
    contractPeriodType?: string | undefined;
    contractType?: number;
    contractServiceType?: string | undefined;
    contractVendor?: string | undefined;
    contractSubType?: string | undefined;
    description?: string | undefined;
    endDate?: Date;
    purchaseOrderNumber?: string | undefined;
    renewedContractID?: number | undefined;
    serviceLevelAgreementID?: number | undefined;
    startDate?: Date;
    status?: number;
    timeReportingRequiresStartAndStopTimes?: number;
    contractBlock?: ContractBlockDto;
    contractTicketPurchase?: ContractTicketPurchaseDto;

    constructor(data?: IContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userDefinedFieldsJson = _data["userDefinedFieldsJson"];
            this.accountID = _data["accountID"];
            this.businessDivisionSubdivisionID = _data["businessDivisionSubdivisionID"];
            this.compliance = _data["compliance"];
            this.contactID = _data["contactID"];
            this.contactName = _data["contactName"];
            this.contractCategory = _data["contractCategory"];
            this.contractName = _data["contractName"];
            this.contractNumber = _data["contractNumber"];
            this.contractPeriodType = _data["contractPeriodType"];
            this.contractType = _data["contractType"];
            this.contractServiceType = _data["contractServiceType"];
            this.contractVendor = _data["contractVendor"];
            this.contractSubType = _data["contractSubType"];
            this.description = _data["description"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
            this.renewedContractID = _data["renewedContractID"];
            this.serviceLevelAgreementID = _data["serviceLevelAgreementID"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.timeReportingRequiresStartAndStopTimes = _data["timeReportingRequiresStartAndStopTimes"];
            this.contractBlock = _data["contractBlock"] ? ContractBlockDto.fromJS(_data["contractBlock"]) : <any>undefined;
            this.contractTicketPurchase = _data["contractTicketPurchase"] ? ContractTicketPurchaseDto.fromJS(_data["contractTicketPurchase"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userDefinedFieldsJson"] = this.userDefinedFieldsJson;
        data["accountID"] = this.accountID;
        data["businessDivisionSubdivisionID"] = this.businessDivisionSubdivisionID;
        data["compliance"] = this.compliance;
        data["contactID"] = this.contactID;
        data["contactName"] = this.contactName;
        data["contractCategory"] = this.contractCategory;
        data["contractName"] = this.contractName;
        data["contractNumber"] = this.contractNumber;
        data["contractPeriodType"] = this.contractPeriodType;
        data["contractType"] = this.contractType;
        data["contractServiceType"] = this.contractServiceType;
        data["contractVendor"] = this.contractVendor;
        data["contractSubType"] = this.contractSubType;
        data["description"] = this.description;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        data["renewedContractID"] = this.renewedContractID;
        data["serviceLevelAgreementID"] = this.serviceLevelAgreementID;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["timeReportingRequiresStartAndStopTimes"] = this.timeReportingRequiresStartAndStopTimes;
        data["contractBlock"] = this.contractBlock ? this.contractBlock.toJSON() : <any>undefined;
        data["contractTicketPurchase"] = this.contractTicketPurchase ? this.contractTicketPurchase.toJSON() : <any>undefined;
        return data;
    }
}

export interface IContractDto {
    id?: number;
    userDefinedFieldsJson?: string | undefined;
    accountID?: number | undefined;
    businessDivisionSubdivisionID?: number;
    compliance?: boolean;
    contactID?: number | undefined;
    contactName?: string | undefined;
    contractCategory?: number | undefined;
    contractName?: string | undefined;
    contractNumber?: string | undefined;
    contractPeriodType?: string | undefined;
    contractType?: number;
    contractServiceType?: string | undefined;
    contractVendor?: string | undefined;
    contractSubType?: string | undefined;
    description?: string | undefined;
    endDate?: Date;
    purchaseOrderNumber?: string | undefined;
    renewedContractID?: number | undefined;
    serviceLevelAgreementID?: number | undefined;
    startDate?: Date;
    status?: number;
    timeReportingRequiresStartAndStopTimes?: number;
    contractBlock?: ContractBlockDto;
    contractTicketPurchase?: ContractTicketPurchaseDto;
}

export class ContractTicketPurchaseDto implements IContractTicketPurchaseDto {
    id?: number;
    contractID?: number | undefined;
    datePurchased?: Date;
    startDate?: Date;
    endDate?: Date;
    ticketsPurchased?: number;
    ticketsUsed?: number;
    status?: number;

    constructor(data?: IContractTicketPurchaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contractID = _data["contractID"];
            this.datePurchased = _data["datePurchased"] ? new Date(_data["datePurchased"].toString()) : <any>undefined;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.ticketsPurchased = _data["ticketsPurchased"];
            this.ticketsUsed = _data["ticketsUsed"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ContractTicketPurchaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractTicketPurchaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contractID"] = this.contractID;
        data["datePurchased"] = this.datePurchased ? this.datePurchased.toISOString() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["ticketsPurchased"] = this.ticketsPurchased;
        data["ticketsUsed"] = this.ticketsUsed;
        data["status"] = this.status;
        return data;
    }
}

export interface IContractTicketPurchaseDto {
    id?: number;
    contractID?: number | undefined;
    datePurchased?: Date;
    startDate?: Date;
    endDate?: Date;
    ticketsPurchased?: number;
    ticketsUsed?: number;
    status?: number;
}

export class PhaseDto implements IPhaseDto {
    id?: number;
    createDate?: Date | undefined;
    creatorResourceID?: number;
    description?: string | undefined;
    dueDate?: Date | undefined;
    estimatedHours?: number | undefined;
    externalID?: string | undefined;
    parentPhaseID?: number;
    phaseNumber?: string | undefined;
    projectID?: number;
    scheduled?: boolean;
    startDate?: Date | undefined;
    title?: string | undefined;
    lastActivityDateTime?: Date;

    constructor(data?: IPhaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.creatorResourceID = _data["creatorResourceID"];
            this.description = _data["description"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.estimatedHours = _data["estimatedHours"];
            this.externalID = _data["externalID"];
            this.parentPhaseID = _data["parentPhaseID"];
            this.phaseNumber = _data["phaseNumber"];
            this.projectID = _data["projectID"];
            this.scheduled = _data["scheduled"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.lastActivityDateTime = _data["lastActivityDateTime"] ? new Date(_data["lastActivityDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PhaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PhaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["creatorResourceID"] = this.creatorResourceID;
        data["description"] = this.description;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["estimatedHours"] = this.estimatedHours;
        data["externalID"] = this.externalID;
        data["parentPhaseID"] = this.parentPhaseID;
        data["phaseNumber"] = this.phaseNumber;
        data["projectID"] = this.projectID;
        data["scheduled"] = this.scheduled;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["title"] = this.title;
        data["lastActivityDateTime"] = this.lastActivityDateTime ? this.lastActivityDateTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPhaseDto {
    id?: number;
    createDate?: Date | undefined;
    creatorResourceID?: number;
    description?: string | undefined;
    dueDate?: Date | undefined;
    estimatedHours?: number | undefined;
    externalID?: string | undefined;
    parentPhaseID?: number;
    phaseNumber?: string | undefined;
    projectID?: number;
    scheduled?: boolean;
    startDate?: Date | undefined;
    title?: string | undefined;
    lastActivityDateTime?: Date;
}

export class PhasesWithTasks implements IPhasesWithTasks {
    phase?: PhaseDto;
    tasks?: ProjectTaskDto[] | undefined;
    childPhases?: PhasesWithTasks[] | undefined;

    constructor(data?: IPhasesWithTasks) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phase = _data["phase"] ? PhaseDto.fromJS(_data["phase"]) : <any>undefined;
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(ProjectTaskDto.fromJS(item));
            }
            if (Array.isArray(_data["childPhases"])) {
                this.childPhases = [] as any;
                for (let item of _data["childPhases"])
                    this.childPhases!.push(PhasesWithTasks.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PhasesWithTasks {
        data = typeof data === 'object' ? data : {};
        let result = new PhasesWithTasks();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phase"] = this.phase ? this.phase.toJSON() : <any>undefined;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item.toJSON());
        }
        if (Array.isArray(this.childPhases)) {
            data["childPhases"] = [];
            for (let item of this.childPhases)
                data["childPhases"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPhasesWithTasks {
    phase?: PhaseDto;
    tasks?: ProjectTaskDto[] | undefined;
    childPhases?: PhasesWithTasks[] | undefined;
}

export class ProjectCacheResponse implements IProjectCacheResponse {
    expiry?: number | undefined;
    responseStatus?: number;
    errorMessage?: string | undefined;
    projects?: ProjectDto[] | undefined;

    constructor(data?: IProjectCacheResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expiry = _data["expiry"];
            this.responseStatus = _data["responseStatus"];
            this.errorMessage = _data["errorMessage"];
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(ProjectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectCacheResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectCacheResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expiry"] = this.expiry;
        data["responseStatus"] = this.responseStatus;
        data["errorMessage"] = this.errorMessage;
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProjectCacheResponse {
    expiry?: number | undefined;
    responseStatus?: number;
    errorMessage?: string | undefined;
    projects?: ProjectDto[] | undefined;
}

export class ProjectDto implements IProjectDto {
    id?: number;
    projectName?: string | undefined;
    accountID?: number;
    type?: number;
    extProjectType?: number | undefined;
    extPNumber?: string | undefined;
    projectNumber?: string | undefined;
    description?: string | undefined;
    createDateTime?: Date | undefined;
    creatorResourceId?: number | undefined;
    startDateTime?: Date | undefined;
    endDateTime?: Date | undefined;
    duration?: number | undefined;
    actualHours?: number | undefined;
    actualBilledHours?: number | undefined;
    estimatedTime?: number | undefined;
    laborEstimatedRevenue?: number | undefined;
    laborEstimatedCosts?: number | undefined;
    laborEstimatedMarginPercentage?: number | undefined;
    projectCostsRevenue?: number | undefined;
    projectCostsBudget?: number | undefined;
    projectCostEstimatedMarginPercentage?: number | undefined;
    changeOrdersRevenue?: number | undefined;
    sgda?: number | undefined;
    originalEstimatedRevenue?: number | undefined;
    estimatedSalesCost?: number | undefined;
    status?: number;
    contractID?: number | undefined;
    projectLeadResourceID?: number;
    companyOwnerResourceID?: number;
    completedPercentage?: number;
    completedDateTime?: Date | undefined;
    statusDetail?: string | undefined;
    statusDateTime?: Date | undefined;
    department?: number;
    lineOfBusiness?: number;
    purchaseOrderNumber?: string | undefined;
    businessDivisionSubdivisionID?: number;
    lastActivityDateTime?: Date;
    userDefinedFieldsJson?: string | undefined;
    projectLead?: ResourceDto;
    contract?: ContractDto;
    phases?: PhaseDto[] | undefined;
    projectTasks?: ProjectTaskDto[] | undefined;
    projectTaskPredecessors?: ProjectTaskPredecessorDto[] | undefined;
    allowedResources?: ResourceDto[] | undefined;

    constructor(data?: IProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectName = _data["projectName"];
            this.accountID = _data["accountID"];
            this.type = _data["type"];
            this.extProjectType = _data["extProjectType"];
            this.extPNumber = _data["extPNumber"];
            this.projectNumber = _data["projectNumber"];
            this.description = _data["description"];
            this.createDateTime = _data["createDateTime"] ? new Date(_data["createDateTime"].toString()) : <any>undefined;
            this.creatorResourceId = _data["creatorResourceId"];
            this.startDateTime = _data["startDateTime"] ? new Date(_data["startDateTime"].toString()) : <any>undefined;
            this.endDateTime = _data["endDateTime"] ? new Date(_data["endDateTime"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.actualHours = _data["actualHours"];
            this.actualBilledHours = _data["actualBilledHours"];
            this.estimatedTime = _data["estimatedTime"];
            this.laborEstimatedRevenue = _data["laborEstimatedRevenue"];
            this.laborEstimatedCosts = _data["laborEstimatedCosts"];
            this.laborEstimatedMarginPercentage = _data["laborEstimatedMarginPercentage"];
            this.projectCostsRevenue = _data["projectCostsRevenue"];
            this.projectCostsBudget = _data["projectCostsBudget"];
            this.projectCostEstimatedMarginPercentage = _data["projectCostEstimatedMarginPercentage"];
            this.changeOrdersRevenue = _data["changeOrdersRevenue"];
            this.sgda = _data["sgda"];
            this.originalEstimatedRevenue = _data["originalEstimatedRevenue"];
            this.estimatedSalesCost = _data["estimatedSalesCost"];
            this.status = _data["status"];
            this.contractID = _data["contractID"];
            this.projectLeadResourceID = _data["projectLeadResourceID"];
            this.companyOwnerResourceID = _data["companyOwnerResourceID"];
            this.completedPercentage = _data["completedPercentage"];
            this.completedDateTime = _data["completedDateTime"] ? new Date(_data["completedDateTime"].toString()) : <any>undefined;
            this.statusDetail = _data["statusDetail"];
            this.statusDateTime = _data["statusDateTime"] ? new Date(_data["statusDateTime"].toString()) : <any>undefined;
            this.department = _data["department"];
            this.lineOfBusiness = _data["lineOfBusiness"];
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
            this.businessDivisionSubdivisionID = _data["businessDivisionSubdivisionID"];
            this.lastActivityDateTime = _data["lastActivityDateTime"] ? new Date(_data["lastActivityDateTime"].toString()) : <any>undefined;
            this.userDefinedFieldsJson = _data["userDefinedFieldsJson"];
            this.projectLead = _data["projectLead"] ? ResourceDto.fromJS(_data["projectLead"]) : <any>undefined;
            this.contract = _data["contract"] ? ContractDto.fromJS(_data["contract"]) : <any>undefined;
            if (Array.isArray(_data["phases"])) {
                this.phases = [] as any;
                for (let item of _data["phases"])
                    this.phases!.push(PhaseDto.fromJS(item));
            }
            if (Array.isArray(_data["projectTasks"])) {
                this.projectTasks = [] as any;
                for (let item of _data["projectTasks"])
                    this.projectTasks!.push(ProjectTaskDto.fromJS(item));
            }
            if (Array.isArray(_data["projectTaskPredecessors"])) {
                this.projectTaskPredecessors = [] as any;
                for (let item of _data["projectTaskPredecessors"])
                    this.projectTaskPredecessors!.push(ProjectTaskPredecessorDto.fromJS(item));
            }
            if (Array.isArray(_data["allowedResources"])) {
                this.allowedResources = [] as any;
                for (let item of _data["allowedResources"])
                    this.allowedResources!.push(ResourceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectName"] = this.projectName;
        data["accountID"] = this.accountID;
        data["type"] = this.type;
        data["extProjectType"] = this.extProjectType;
        data["extPNumber"] = this.extPNumber;
        data["projectNumber"] = this.projectNumber;
        data["description"] = this.description;
        data["createDateTime"] = this.createDateTime ? this.createDateTime.toISOString() : <any>undefined;
        data["creatorResourceId"] = this.creatorResourceId;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["actualHours"] = this.actualHours;
        data["actualBilledHours"] = this.actualBilledHours;
        data["estimatedTime"] = this.estimatedTime;
        data["laborEstimatedRevenue"] = this.laborEstimatedRevenue;
        data["laborEstimatedCosts"] = this.laborEstimatedCosts;
        data["laborEstimatedMarginPercentage"] = this.laborEstimatedMarginPercentage;
        data["projectCostsRevenue"] = this.projectCostsRevenue;
        data["projectCostsBudget"] = this.projectCostsBudget;
        data["projectCostEstimatedMarginPercentage"] = this.projectCostEstimatedMarginPercentage;
        data["changeOrdersRevenue"] = this.changeOrdersRevenue;
        data["sgda"] = this.sgda;
        data["originalEstimatedRevenue"] = this.originalEstimatedRevenue;
        data["estimatedSalesCost"] = this.estimatedSalesCost;
        data["status"] = this.status;
        data["contractID"] = this.contractID;
        data["projectLeadResourceID"] = this.projectLeadResourceID;
        data["companyOwnerResourceID"] = this.companyOwnerResourceID;
        data["completedPercentage"] = this.completedPercentage;
        data["completedDateTime"] = this.completedDateTime ? this.completedDateTime.toISOString() : <any>undefined;
        data["statusDetail"] = this.statusDetail;
        data["statusDateTime"] = this.statusDateTime ? this.statusDateTime.toISOString() : <any>undefined;
        data["department"] = this.department;
        data["lineOfBusiness"] = this.lineOfBusiness;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        data["businessDivisionSubdivisionID"] = this.businessDivisionSubdivisionID;
        data["lastActivityDateTime"] = this.lastActivityDateTime ? this.lastActivityDateTime.toISOString() : <any>undefined;
        data["userDefinedFieldsJson"] = this.userDefinedFieldsJson;
        data["projectLead"] = this.projectLead ? this.projectLead.toJSON() : <any>undefined;
        data["contract"] = this.contract ? this.contract.toJSON() : <any>undefined;
        if (Array.isArray(this.phases)) {
            data["phases"] = [];
            for (let item of this.phases)
                data["phases"].push(item.toJSON());
        }
        if (Array.isArray(this.projectTasks)) {
            data["projectTasks"] = [];
            for (let item of this.projectTasks)
                data["projectTasks"].push(item.toJSON());
        }
        if (Array.isArray(this.projectTaskPredecessors)) {
            data["projectTaskPredecessors"] = [];
            for (let item of this.projectTaskPredecessors)
                data["projectTaskPredecessors"].push(item.toJSON());
        }
        if (Array.isArray(this.allowedResources)) {
            data["allowedResources"] = [];
            for (let item of this.allowedResources)
                data["allowedResources"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProjectDto {
    id?: number;
    projectName?: string | undefined;
    accountID?: number;
    type?: number;
    extProjectType?: number | undefined;
    extPNumber?: string | undefined;
    projectNumber?: string | undefined;
    description?: string | undefined;
    createDateTime?: Date | undefined;
    creatorResourceId?: number | undefined;
    startDateTime?: Date | undefined;
    endDateTime?: Date | undefined;
    duration?: number | undefined;
    actualHours?: number | undefined;
    actualBilledHours?: number | undefined;
    estimatedTime?: number | undefined;
    laborEstimatedRevenue?: number | undefined;
    laborEstimatedCosts?: number | undefined;
    laborEstimatedMarginPercentage?: number | undefined;
    projectCostsRevenue?: number | undefined;
    projectCostsBudget?: number | undefined;
    projectCostEstimatedMarginPercentage?: number | undefined;
    changeOrdersRevenue?: number | undefined;
    sgda?: number | undefined;
    originalEstimatedRevenue?: number | undefined;
    estimatedSalesCost?: number | undefined;
    status?: number;
    contractID?: number | undefined;
    projectLeadResourceID?: number;
    companyOwnerResourceID?: number;
    completedPercentage?: number;
    completedDateTime?: Date | undefined;
    statusDetail?: string | undefined;
    statusDateTime?: Date | undefined;
    department?: number;
    lineOfBusiness?: number;
    purchaseOrderNumber?: string | undefined;
    businessDivisionSubdivisionID?: number;
    lastActivityDateTime?: Date;
    userDefinedFieldsJson?: string | undefined;
    projectLead?: ResourceDto;
    contract?: ContractDto;
    phases?: PhaseDto[] | undefined;
    projectTasks?: ProjectTaskDto[] | undefined;
    projectTaskPredecessors?: ProjectTaskPredecessorDto[] | undefined;
    allowedResources?: ResourceDto[] | undefined;
}

export class ProjectIndividualResponse implements IProjectIndividualResponse {
    responseStatus?: number;
    errorMessage?: string | undefined;
    projectId?: number;
    project?: ProjectListItem;
    activePhase?: number | undefined;
    phasesWithTasksList?: PhasesWithTasks[] | undefined;
    orphanTasks?: ProjectTaskDto[] | undefined;
    attachedResources?: ResourceDto[] | undefined;

    constructor(data?: IProjectIndividualResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseStatus = _data["responseStatus"];
            this.errorMessage = _data["errorMessage"];
            this.projectId = _data["projectId"];
            this.project = _data["project"] ? ProjectListItem.fromJS(_data["project"]) : <any>undefined;
            this.activePhase = _data["activePhase"];
            if (Array.isArray(_data["phasesWithTasksList"])) {
                this.phasesWithTasksList = [] as any;
                for (let item of _data["phasesWithTasksList"])
                    this.phasesWithTasksList!.push(PhasesWithTasks.fromJS(item));
            }
            if (Array.isArray(_data["orphanTasks"])) {
                this.orphanTasks = [] as any;
                for (let item of _data["orphanTasks"])
                    this.orphanTasks!.push(ProjectTaskDto.fromJS(item));
            }
            if (Array.isArray(_data["attachedResources"])) {
                this.attachedResources = [] as any;
                for (let item of _data["attachedResources"])
                    this.attachedResources!.push(ResourceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectIndividualResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectIndividualResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseStatus"] = this.responseStatus;
        data["errorMessage"] = this.errorMessage;
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["activePhase"] = this.activePhase;
        if (Array.isArray(this.phasesWithTasksList)) {
            data["phasesWithTasksList"] = [];
            for (let item of this.phasesWithTasksList)
                data["phasesWithTasksList"].push(item.toJSON());
        }
        if (Array.isArray(this.orphanTasks)) {
            data["orphanTasks"] = [];
            for (let item of this.orphanTasks)
                data["orphanTasks"].push(item.toJSON());
        }
        if (Array.isArray(this.attachedResources)) {
            data["attachedResources"] = [];
            for (let item of this.attachedResources)
                data["attachedResources"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProjectIndividualResponse {
    responseStatus?: number;
    errorMessage?: string | undefined;
    projectId?: number;
    project?: ProjectListItem;
    activePhase?: number | undefined;
    phasesWithTasksList?: PhasesWithTasks[] | undefined;
    orphanTasks?: ProjectTaskDto[] | undefined;
    attachedResources?: ResourceDto[] | undefined;
}

export class ProjectListItem implements IProjectListItem {
    id?: number;
    projectName?: string | undefined;
    accountID?: number;
    accountName?: string | undefined;
    accountExecutive?: string | undefined;
    type?: number;
    createDateTime?: Date | undefined;
    startDateTime?: Date | undefined;
    endDateTime?: Date | undefined;
    duration?: number | undefined;
    status?: number;
    contractType?: number;
    projectLeadFirstName?: string | undefined;
    projectLeadLastName?: string | undefined;
    projectLeadEmail?: string | undefined;
    purchaseOrderNumber?: string | undefined;
    contractID?: number | undefined;

    constructor(data?: IProjectListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectName = _data["projectName"];
            this.accountID = _data["accountID"];
            this.accountName = _data["accountName"];
            this.accountExecutive = _data["accountExecutive"];
            this.type = _data["type"];
            this.createDateTime = _data["createDateTime"] ? new Date(_data["createDateTime"].toString()) : <any>undefined;
            this.startDateTime = _data["startDateTime"] ? new Date(_data["startDateTime"].toString()) : <any>undefined;
            this.endDateTime = _data["endDateTime"] ? new Date(_data["endDateTime"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.status = _data["status"];
            this.contractType = _data["contractType"];
            this.projectLeadFirstName = _data["projectLeadFirstName"];
            this.projectLeadLastName = _data["projectLeadLastName"];
            this.projectLeadEmail = _data["projectLeadEmail"];
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
            this.contractID = _data["contractID"];
        }
    }

    static fromJS(data: any): ProjectListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectName"] = this.projectName;
        data["accountID"] = this.accountID;
        data["accountName"] = this.accountName;
        data["accountExecutive"] = this.accountExecutive;
        data["type"] = this.type;
        data["createDateTime"] = this.createDateTime ? this.createDateTime.toISOString() : <any>undefined;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["status"] = this.status;
        data["contractType"] = this.contractType;
        data["projectLeadFirstName"] = this.projectLeadFirstName;
        data["projectLeadLastName"] = this.projectLeadLastName;
        data["projectLeadEmail"] = this.projectLeadEmail;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        data["contractID"] = this.contractID;
        return data;
    }
}

export interface IProjectListItem {
    id?: number;
    projectName?: string | undefined;
    accountID?: number;
    accountName?: string | undefined;
    accountExecutive?: string | undefined;
    type?: number;
    createDateTime?: Date | undefined;
    startDateTime?: Date | undefined;
    endDateTime?: Date | undefined;
    duration?: number | undefined;
    status?: number;
    contractType?: number;
    projectLeadFirstName?: string | undefined;
    projectLeadLastName?: string | undefined;
    projectLeadEmail?: string | undefined;
    purchaseOrderNumber?: string | undefined;
    contractID?: number | undefined;
}

export class ProjectListResponse implements IProjectListResponse {
    responseStatus?: number;
    errorMessage?: string | undefined;
    projects?: ProjectListItem[] | undefined;
    associatedContracts?: ContractDto[] | undefined;

    constructor(data?: IProjectListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseStatus = _data["responseStatus"];
            this.errorMessage = _data["errorMessage"];
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(ProjectListItem.fromJS(item));
            }
            if (Array.isArray(_data["associatedContracts"])) {
                this.associatedContracts = [] as any;
                for (let item of _data["associatedContracts"])
                    this.associatedContracts!.push(ContractDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseStatus"] = this.responseStatus;
        data["errorMessage"] = this.errorMessage;
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        if (Array.isArray(this.associatedContracts)) {
            data["associatedContracts"] = [];
            for (let item of this.associatedContracts)
                data["associatedContracts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProjectListResponse {
    responseStatus?: number;
    errorMessage?: string | undefined;
    projects?: ProjectListItem[] | undefined;
    associatedContracts?: ContractDto[] | undefined;
}

export enum ProjectStatus {
    Inactive = "Inactive",
    New = "New",
    InProgress = "InProgress",
    OnHold = "OnHold",
    ChangeOrder = "ChangeOrder",
    Complete = "Complete",
    WaitingParts = "WaitingParts",
    WaitingCustomer = "WaitingCustomer",
    AtRisk = "AtRisk",
    Backlog = "Backlog",
}

export class ProjectTaskDto implements IProjectTaskDto {
    id?: number;
    allocationCodeID?: number;
    assignedResourceID?: number;
    assignedResourceRoleID?: number;
    createDateTime?: Date | undefined;
    completedDateTime?: Date | undefined;
    creatorResourceID?: number;
    departmentID?: number;
    description?: string | undefined;
    endDateTime?: Date | undefined;
    estimatedHours?: number | undefined;
    externalID?: string | undefined;
    hoursToBeScheduled?: number | undefined;
    isVisibleInClientPortal?: boolean;
    phaseID?: number;
    priority?: number;
    projectID?: number;
    purchaseOrderNumber?: string | undefined;
    remainingHours?: number;
    startDateTime?: Date | undefined;
    status?: number;
    taskIsBillable?: boolean;
    taskNumber?: string | undefined;
    taskType?: number;
    title?: string | undefined;
    priorityLabel?: number;
    creatorType?: number;
    completedByResourceID?: number;
    completedByType?: number;
    lastActivityResourceID?: number;
    lastActivityPersonType?: number;
    lastActivityDateTime?: Date;
    userDefinedFieldsJson?: string | undefined;

    constructor(data?: IProjectTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.allocationCodeID = _data["allocationCodeID"];
            this.assignedResourceID = _data["assignedResourceID"];
            this.assignedResourceRoleID = _data["assignedResourceRoleID"];
            this.createDateTime = _data["createDateTime"] ? new Date(_data["createDateTime"].toString()) : <any>undefined;
            this.completedDateTime = _data["completedDateTime"] ? new Date(_data["completedDateTime"].toString()) : <any>undefined;
            this.creatorResourceID = _data["creatorResourceID"];
            this.departmentID = _data["departmentID"];
            this.description = _data["description"];
            this.endDateTime = _data["endDateTime"] ? new Date(_data["endDateTime"].toString()) : <any>undefined;
            this.estimatedHours = _data["estimatedHours"];
            this.externalID = _data["externalID"];
            this.hoursToBeScheduled = _data["hoursToBeScheduled"];
            this.isVisibleInClientPortal = _data["isVisibleInClientPortal"];
            this.phaseID = _data["phaseID"];
            this.priority = _data["priority"];
            this.projectID = _data["projectID"];
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
            this.remainingHours = _data["remainingHours"];
            this.startDateTime = _data["startDateTime"] ? new Date(_data["startDateTime"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.taskIsBillable = _data["taskIsBillable"];
            this.taskNumber = _data["taskNumber"];
            this.taskType = _data["taskType"];
            this.title = _data["title"];
            this.priorityLabel = _data["priorityLabel"];
            this.creatorType = _data["creatorType"];
            this.completedByResourceID = _data["completedByResourceID"];
            this.completedByType = _data["completedByType"];
            this.lastActivityResourceID = _data["lastActivityResourceID"];
            this.lastActivityPersonType = _data["lastActivityPersonType"];
            this.lastActivityDateTime = _data["lastActivityDateTime"] ? new Date(_data["lastActivityDateTime"].toString()) : <any>undefined;
            this.userDefinedFieldsJson = _data["userDefinedFieldsJson"];
        }
    }

    static fromJS(data: any): ProjectTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["allocationCodeID"] = this.allocationCodeID;
        data["assignedResourceID"] = this.assignedResourceID;
        data["assignedResourceRoleID"] = this.assignedResourceRoleID;
        data["createDateTime"] = this.createDateTime ? this.createDateTime.toISOString() : <any>undefined;
        data["completedDateTime"] = this.completedDateTime ? this.completedDateTime.toISOString() : <any>undefined;
        data["creatorResourceID"] = this.creatorResourceID;
        data["departmentID"] = this.departmentID;
        data["description"] = this.description;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : <any>undefined;
        data["estimatedHours"] = this.estimatedHours;
        data["externalID"] = this.externalID;
        data["hoursToBeScheduled"] = this.hoursToBeScheduled;
        data["isVisibleInClientPortal"] = this.isVisibleInClientPortal;
        data["phaseID"] = this.phaseID;
        data["priority"] = this.priority;
        data["projectID"] = this.projectID;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        data["remainingHours"] = this.remainingHours;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["taskIsBillable"] = this.taskIsBillable;
        data["taskNumber"] = this.taskNumber;
        data["taskType"] = this.taskType;
        data["title"] = this.title;
        data["priorityLabel"] = this.priorityLabel;
        data["creatorType"] = this.creatorType;
        data["completedByResourceID"] = this.completedByResourceID;
        data["completedByType"] = this.completedByType;
        data["lastActivityResourceID"] = this.lastActivityResourceID;
        data["lastActivityPersonType"] = this.lastActivityPersonType;
        data["lastActivityDateTime"] = this.lastActivityDateTime ? this.lastActivityDateTime.toISOString() : <any>undefined;
        data["userDefinedFieldsJson"] = this.userDefinedFieldsJson;
        return data;
    }
}

export interface IProjectTaskDto {
    id?: number;
    allocationCodeID?: number;
    assignedResourceID?: number;
    assignedResourceRoleID?: number;
    createDateTime?: Date | undefined;
    completedDateTime?: Date | undefined;
    creatorResourceID?: number;
    departmentID?: number;
    description?: string | undefined;
    endDateTime?: Date | undefined;
    estimatedHours?: number | undefined;
    externalID?: string | undefined;
    hoursToBeScheduled?: number | undefined;
    isVisibleInClientPortal?: boolean;
    phaseID?: number;
    priority?: number;
    projectID?: number;
    purchaseOrderNumber?: string | undefined;
    remainingHours?: number;
    startDateTime?: Date | undefined;
    status?: number;
    taskIsBillable?: boolean;
    taskNumber?: string | undefined;
    taskType?: number;
    title?: string | undefined;
    priorityLabel?: number;
    creatorType?: number;
    completedByResourceID?: number;
    completedByType?: number;
    lastActivityResourceID?: number;
    lastActivityPersonType?: number;
    lastActivityDateTime?: Date;
    userDefinedFieldsJson?: string | undefined;
}

export class ProjectTaskPredecessorDto implements IProjectTaskPredecessorDto {
    id?: number;
    lagDays?: number;
    predecessorTaskID?: number;
    successorTaskID?: number;

    constructor(data?: IProjectTaskPredecessorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lagDays = _data["lagDays"];
            this.predecessorTaskID = _data["predecessorTaskID"];
            this.successorTaskID = _data["successorTaskID"];
        }
    }

    static fromJS(data: any): ProjectTaskPredecessorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTaskPredecessorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lagDays"] = this.lagDays;
        data["predecessorTaskID"] = this.predecessorTaskID;
        data["successorTaskID"] = this.successorTaskID;
        return data;
    }
}

export interface IProjectTaskPredecessorDto {
    id?: number;
    lagDays?: number;
    predecessorTaskID?: number;
    successorTaskID?: number;
}

export class ProjectWidgetItemDto implements IProjectWidgetItemDto {
    status?: ProjectStatus;
    count?: number;

    constructor(data?: IProjectWidgetItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): ProjectWidgetItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectWidgetItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["count"] = this.count;
        return data;
    }
}

export interface IProjectWidgetItemDto {
    status?: ProjectStatus;
    count?: number;
}

export class ResourceDto implements IResourceDto {
    id?: number;
    accountingReferenceID?: string | undefined;
    active?: boolean;
    dateFormat?: string | undefined;
    defaultServiceDeskRoleID?: number;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    initials?: string | undefined;
    title?: string | undefined;
    email?: string | undefined;
    email2?: string | undefined;
    email3?: string | undefined;
    emailTypeCode?: string | undefined;
    emailTypeCode2?: string | undefined;
    emailTypeCode3?: string | undefined;
    gender?: string | undefined;
    greeting?: number;
    hiredate?: Date;
    homePhone?: string | undefined;
    internalCost?: number;
    locationID?: number;
    mobilePhone?: string | undefined;
    numberFormat?: string | undefined;
    officeExtension?: string | undefined;
    officePhone?: string | undefined;
    payrollType?: number;
    resourceType?: string | undefined;
    timeFormat?: string | undefined;
    travelAvailabilityPct?: string | undefined;
    userName?: string | undefined;
    userType?: number;
    userDefinedFieldsJson?: string | undefined;

    constructor(data?: IResourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountingReferenceID = _data["accountingReferenceID"];
            this.active = _data["active"];
            this.dateFormat = _data["dateFormat"];
            this.defaultServiceDeskRoleID = _data["defaultServiceDeskRoleID"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.suffix = _data["suffix"];
            this.initials = _data["initials"];
            this.title = _data["title"];
            this.email = _data["email"];
            this.email2 = _data["email2"];
            this.email3 = _data["email3"];
            this.emailTypeCode = _data["emailTypeCode"];
            this.emailTypeCode2 = _data["emailTypeCode2"];
            this.emailTypeCode3 = _data["emailTypeCode3"];
            this.gender = _data["gender"];
            this.greeting = _data["greeting"];
            this.hiredate = _data["hiredate"] ? new Date(_data["hiredate"].toString()) : <any>undefined;
            this.homePhone = _data["homePhone"];
            this.internalCost = _data["internalCost"];
            this.locationID = _data["locationID"];
            this.mobilePhone = _data["mobilePhone"];
            this.numberFormat = _data["numberFormat"];
            this.officeExtension = _data["officeExtension"];
            this.officePhone = _data["officePhone"];
            this.payrollType = _data["payrollType"];
            this.resourceType = _data["resourceType"];
            this.timeFormat = _data["timeFormat"];
            this.travelAvailabilityPct = _data["travelAvailabilityPct"];
            this.userName = _data["userName"];
            this.userType = _data["userType"];
            this.userDefinedFieldsJson = _data["userDefinedFieldsJson"];
        }
    }

    static fromJS(data: any): ResourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountingReferenceID"] = this.accountingReferenceID;
        data["active"] = this.active;
        data["dateFormat"] = this.dateFormat;
        data["defaultServiceDeskRoleID"] = this.defaultServiceDeskRoleID;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["suffix"] = this.suffix;
        data["initials"] = this.initials;
        data["title"] = this.title;
        data["email"] = this.email;
        data["email2"] = this.email2;
        data["email3"] = this.email3;
        data["emailTypeCode"] = this.emailTypeCode;
        data["emailTypeCode2"] = this.emailTypeCode2;
        data["emailTypeCode3"] = this.emailTypeCode3;
        data["gender"] = this.gender;
        data["greeting"] = this.greeting;
        data["hiredate"] = this.hiredate ? this.hiredate.toISOString() : <any>undefined;
        data["homePhone"] = this.homePhone;
        data["internalCost"] = this.internalCost;
        data["locationID"] = this.locationID;
        data["mobilePhone"] = this.mobilePhone;
        data["numberFormat"] = this.numberFormat;
        data["officeExtension"] = this.officeExtension;
        data["officePhone"] = this.officePhone;
        data["payrollType"] = this.payrollType;
        data["resourceType"] = this.resourceType;
        data["timeFormat"] = this.timeFormat;
        data["travelAvailabilityPct"] = this.travelAvailabilityPct;
        data["userName"] = this.userName;
        data["userType"] = this.userType;
        data["userDefinedFieldsJson"] = this.userDefinedFieldsJson;
        return data;
    }
}

export interface IResourceDto {
    id?: number;
    accountingReferenceID?: string | undefined;
    active?: boolean;
    dateFormat?: string | undefined;
    defaultServiceDeskRoleID?: number;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    initials?: string | undefined;
    title?: string | undefined;
    email?: string | undefined;
    email2?: string | undefined;
    email3?: string | undefined;
    emailTypeCode?: string | undefined;
    emailTypeCode2?: string | undefined;
    emailTypeCode3?: string | undefined;
    gender?: string | undefined;
    greeting?: number;
    hiredate?: Date;
    homePhone?: string | undefined;
    internalCost?: number;
    locationID?: number;
    mobilePhone?: string | undefined;
    numberFormat?: string | undefined;
    officeExtension?: string | undefined;
    officePhone?: string | undefined;
    payrollType?: number;
    resourceType?: string | undefined;
    timeFormat?: string | undefined;
    travelAvailabilityPct?: string | undefined;
    userName?: string | undefined;
    userType?: number;
    userDefinedFieldsJson?: string | undefined;
}

export class CiscoIbaAssetsArchitectureLdosResponse implements ICiscoIbaAssetsArchitectureLdosResponse {
    assets?: CiscoIbaAssetsArchitectureLdosDto[] | undefined;
    allArchitectures?: string[] | undefined;

    constructor(data?: ICiscoIbaAssetsArchitectureLdosResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["assets"])) {
                this.assets = [] as any;
                for (let item of _data["assets"])
                    this.assets!.push(CiscoIbaAssetsArchitectureLdosDto.fromJS(item));
            }
            if (Array.isArray(_data["allArchitectures"])) {
                this.allArchitectures = [] as any;
                for (let item of _data["allArchitectures"])
                    this.allArchitectures!.push(item);
            }
        }
    }

    static fromJS(data: any): CiscoIbaAssetsArchitectureLdosResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaAssetsArchitectureLdosResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assets)) {
            data["assets"] = [];
            for (let item of this.assets)
                data["assets"].push(item.toJSON());
        }
        if (Array.isArray(this.allArchitectures)) {
            data["allArchitectures"] = [];
            for (let item of this.allArchitectures)
                data["allArchitectures"].push(item);
        }
        return data;
    }
}

export interface ICiscoIbaAssetsArchitectureLdosResponse {
    assets?: CiscoIbaAssetsArchitectureLdosDto[] | undefined;
    allArchitectures?: string[] | undefined;
}

export class CiscoIbaAssetsSearchResponse implements ICiscoIbaAssetsSearchResponse {
    assets?: Asset[] | undefined;
    totalAssetsCount?: number;

    constructor(data?: ICiscoIbaAssetsSearchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["assets"])) {
                this.assets = [] as any;
                for (let item of _data["assets"])
                    this.assets!.push(Asset.fromJS(item));
            }
            this.totalAssetsCount = _data["totalAssetsCount"];
        }
    }

    static fromJS(data: any): CiscoIbaAssetsSearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaAssetsSearchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assets)) {
            data["assets"] = [];
            for (let item of this.assets)
                data["assets"].push(item.toJSON());
        }
        data["totalAssetsCount"] = this.totalAssetsCount;
        return data;
    }
}

export interface ICiscoIbaAssetsSearchResponse {
    assets?: Asset[] | undefined;
    totalAssetsCount?: number;
}

export class CiscoIbaBaseInsightsResponse implements ICiscoIbaBaseInsightsResponse {
    subscriptionCount?: number;
    smartNetSlaCount?: number;
    coveredAssetCount?: number;
    ciscoGuidCount?: number;
    ciscoPartyCount?: number;
    locationCount?: number;

    constructor(data?: ICiscoIbaBaseInsightsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionCount = _data["subscriptionCount"];
            this.smartNetSlaCount = _data["smartNetSlaCount"];
            this.coveredAssetCount = _data["coveredAssetCount"];
            this.ciscoGuidCount = _data["ciscoGuidCount"];
            this.ciscoPartyCount = _data["ciscoPartyCount"];
            this.locationCount = _data["locationCount"];
        }
    }

    static fromJS(data: any): CiscoIbaBaseInsightsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaBaseInsightsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionCount"] = this.subscriptionCount;
        data["smartNetSlaCount"] = this.smartNetSlaCount;
        data["coveredAssetCount"] = this.coveredAssetCount;
        data["ciscoGuidCount"] = this.ciscoGuidCount;
        data["ciscoPartyCount"] = this.ciscoPartyCount;
        data["locationCount"] = this.locationCount;
        return data;
    }
}

export interface ICiscoIbaBaseInsightsResponse {
    subscriptionCount?: number;
    smartNetSlaCount?: number;
    coveredAssetCount?: number;
    ciscoGuidCount?: number;
    ciscoPartyCount?: number;
    locationCount?: number;
}

export class CiscoIbaExpiringAssetsResponse implements ICiscoIbaExpiringAssetsResponse {
    next6Months?: ExpiringAssetCounts;
    next12Months?: ExpiringAssetCounts;
    next3Years?: ExpiringAssetCounts;

    constructor(data?: ICiscoIbaExpiringAssetsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.next6Months = _data["next6Months"] ? ExpiringAssetCounts.fromJS(_data["next6Months"]) : <any>undefined;
            this.next12Months = _data["next12Months"] ? ExpiringAssetCounts.fromJS(_data["next12Months"]) : <any>undefined;
            this.next3Years = _data["next3Years"] ? ExpiringAssetCounts.fromJS(_data["next3Years"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CiscoIbaExpiringAssetsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaExpiringAssetsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["next6Months"] = this.next6Months ? this.next6Months.toJSON() : <any>undefined;
        data["next12Months"] = this.next12Months ? this.next12Months.toJSON() : <any>undefined;
        data["next3Years"] = this.next3Years ? this.next3Years.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICiscoIbaExpiringAssetsResponse {
    next6Months?: ExpiringAssetCounts;
    next12Months?: ExpiringAssetCounts;
    next3Years?: ExpiringAssetCounts;
}

export class CiscoIbaLdosResponse implements ICiscoIbaLdosResponse {
    products?: CiscoIbaLdosDto[] | undefined;
    coveredCount?: number | undefined;
    totalCount?: number | undefined;

    constructor(data?: ICiscoIbaLdosResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(CiscoIbaLdosDto.fromJS(item));
            }
            this.coveredCount = _data["coveredCount"];
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CiscoIbaLdosResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaLdosResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        data["coveredCount"] = this.coveredCount;
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICiscoIbaLdosResponse {
    products?: CiscoIbaLdosDto[] | undefined;
    coveredCount?: number | undefined;
    totalCount?: number | undefined;
}

export class CiscoIbaLocationDto implements ICiscoIbaLocationDto {
    manufacturerGlobalCustomerId?: string | undefined;
    manufacturerGlobalCustomerName?: string | undefined;
    manufacturerCustomerName?: string | undefined;
    locationName?: string | undefined;
    locationAddress?: string | undefined;
    locationCity?: string | undefined;
    locationState?: string | undefined;
    locationCountry?: string | undefined;
    assetCount?: number;

    constructor(data?: ICiscoIbaLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.manufacturerGlobalCustomerId = _data["manufacturerGlobalCustomerId"];
            this.manufacturerGlobalCustomerName = _data["manufacturerGlobalCustomerName"];
            this.manufacturerCustomerName = _data["manufacturerCustomerName"];
            this.locationName = _data["locationName"];
            this.locationAddress = _data["locationAddress"];
            this.locationCity = _data["locationCity"];
            this.locationState = _data["locationState"];
            this.locationCountry = _data["locationCountry"];
            this.assetCount = _data["assetCount"];
        }
    }

    static fromJS(data: any): CiscoIbaLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["manufacturerGlobalCustomerId"] = this.manufacturerGlobalCustomerId;
        data["manufacturerGlobalCustomerName"] = this.manufacturerGlobalCustomerName;
        data["manufacturerCustomerName"] = this.manufacturerCustomerName;
        data["locationName"] = this.locationName;
        data["locationAddress"] = this.locationAddress;
        data["locationCity"] = this.locationCity;
        data["locationState"] = this.locationState;
        data["locationCountry"] = this.locationCountry;
        data["assetCount"] = this.assetCount;
        return data;
    }
}

export interface ICiscoIbaLocationDto {
    manufacturerGlobalCustomerId?: string | undefined;
    manufacturerGlobalCustomerName?: string | undefined;
    manufacturerCustomerName?: string | undefined;
    locationName?: string | undefined;
    locationAddress?: string | undefined;
    locationCity?: string | undefined;
    locationState?: string | undefined;
    locationCountry?: string | undefined;
    assetCount?: number;
}

export class CiscoIbaLocationResponse implements ICiscoIbaLocationResponse {
    locationData?: CiscoIbaLocationDto[] | undefined;
    globalLocationData?: GlobalLocationData[] | undefined;
    customerNameLocationData?: CustomerNameLocationData[] | undefined;

    constructor(data?: ICiscoIbaLocationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["locationData"])) {
                this.locationData = [] as any;
                for (let item of _data["locationData"])
                    this.locationData!.push(CiscoIbaLocationDto.fromJS(item));
            }
            if (Array.isArray(_data["globalLocationData"])) {
                this.globalLocationData = [] as any;
                for (let item of _data["globalLocationData"])
                    this.globalLocationData!.push(GlobalLocationData.fromJS(item));
            }
            if (Array.isArray(_data["customerNameLocationData"])) {
                this.customerNameLocationData = [] as any;
                for (let item of _data["customerNameLocationData"])
                    this.customerNameLocationData!.push(CustomerNameLocationData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CiscoIbaLocationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaLocationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.locationData)) {
            data["locationData"] = [];
            for (let item of this.locationData)
                data["locationData"].push(item.toJSON());
        }
        if (Array.isArray(this.globalLocationData)) {
            data["globalLocationData"] = [];
            for (let item of this.globalLocationData)
                data["globalLocationData"].push(item.toJSON());
        }
        if (Array.isArray(this.customerNameLocationData)) {
            data["customerNameLocationData"] = [];
            for (let item of this.customerNameLocationData)
                data["customerNameLocationData"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICiscoIbaLocationResponse {
    locationData?: CiscoIbaLocationDto[] | undefined;
    globalLocationData?: GlobalLocationData[] | undefined;
    customerNameLocationData?: CustomerNameLocationData[] | undefined;
}

export class CiscoIbaPicklistResponse implements ICiscoIbaPicklistResponse {
    productFamily?: string[] | undefined;
    coveredStatus?: string[] | undefined;
    manufacturerGlobalCustomerName?: string[] | undefined;
    manufacturerCustomerName?: string[] | undefined;
    siteLocation?: SiteLocationGroup[] | undefined;
    assetType?: string[] | undefined;
    tags?: string[] | undefined;
    shiCategory?: ShiCategoryGroup[] | undefined;
    importantDates?: string[] | undefined;

    constructor(data?: ICiscoIbaPicklistResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["productFamily"])) {
                this.productFamily = [] as any;
                for (let item of _data["productFamily"])
                    this.productFamily!.push(item);
            }
            if (Array.isArray(_data["coveredStatus"])) {
                this.coveredStatus = [] as any;
                for (let item of _data["coveredStatus"])
                    this.coveredStatus!.push(item);
            }
            if (Array.isArray(_data["manufacturerGlobalCustomerName"])) {
                this.manufacturerGlobalCustomerName = [] as any;
                for (let item of _data["manufacturerGlobalCustomerName"])
                    this.manufacturerGlobalCustomerName!.push(item);
            }
            if (Array.isArray(_data["manufacturerCustomerName"])) {
                this.manufacturerCustomerName = [] as any;
                for (let item of _data["manufacturerCustomerName"])
                    this.manufacturerCustomerName!.push(item);
            }
            if (Array.isArray(_data["siteLocation"])) {
                this.siteLocation = [] as any;
                for (let item of _data["siteLocation"])
                    this.siteLocation!.push(SiteLocationGroup.fromJS(item));
            }
            if (Array.isArray(_data["assetType"])) {
                this.assetType = [] as any;
                for (let item of _data["assetType"])
                    this.assetType!.push(item);
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            if (Array.isArray(_data["shiCategory"])) {
                this.shiCategory = [] as any;
                for (let item of _data["shiCategory"])
                    this.shiCategory!.push(ShiCategoryGroup.fromJS(item));
            }
            if (Array.isArray(_data["importantDates"])) {
                this.importantDates = [] as any;
                for (let item of _data["importantDates"])
                    this.importantDates!.push(item);
            }
        }
    }

    static fromJS(data: any): CiscoIbaPicklistResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaPicklistResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productFamily)) {
            data["productFamily"] = [];
            for (let item of this.productFamily)
                data["productFamily"].push(item);
        }
        if (Array.isArray(this.coveredStatus)) {
            data["coveredStatus"] = [];
            for (let item of this.coveredStatus)
                data["coveredStatus"].push(item);
        }
        if (Array.isArray(this.manufacturerGlobalCustomerName)) {
            data["manufacturerGlobalCustomerName"] = [];
            for (let item of this.manufacturerGlobalCustomerName)
                data["manufacturerGlobalCustomerName"].push(item);
        }
        if (Array.isArray(this.manufacturerCustomerName)) {
            data["manufacturerCustomerName"] = [];
            for (let item of this.manufacturerCustomerName)
                data["manufacturerCustomerName"].push(item);
        }
        if (Array.isArray(this.siteLocation)) {
            data["siteLocation"] = [];
            for (let item of this.siteLocation)
                data["siteLocation"].push(item.toJSON());
        }
        if (Array.isArray(this.assetType)) {
            data["assetType"] = [];
            for (let item of this.assetType)
                data["assetType"].push(item);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        if (Array.isArray(this.shiCategory)) {
            data["shiCategory"] = [];
            for (let item of this.shiCategory)
                data["shiCategory"].push(item.toJSON());
        }
        if (Array.isArray(this.importantDates)) {
            data["importantDates"] = [];
            for (let item of this.importantDates)
                data["importantDates"].push(item);
        }
        return data;
    }
}

export interface ICiscoIbaPicklistResponse {
    productFamily?: string[] | undefined;
    coveredStatus?: string[] | undefined;
    manufacturerGlobalCustomerName?: string[] | undefined;
    manufacturerCustomerName?: string[] | undefined;
    siteLocation?: SiteLocationGroup[] | undefined;
    assetType?: string[] | undefined;
    tags?: string[] | undefined;
    shiCategory?: ShiCategoryGroup[] | undefined;
    importantDates?: string[] | undefined;
}

export class CiscoIbaProductResponse implements ICiscoIbaProductResponse {
    products?: CiscoIbaProductDto[] | undefined;
    summary?: CiscoIbaProductSummaryDto;

    constructor(data?: ICiscoIbaProductResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(CiscoIbaProductDto.fromJS(item));
            }
            this.summary = _data["summary"] ? CiscoIbaProductSummaryDto.fromJS(_data["summary"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CiscoIbaProductResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaProductResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICiscoIbaProductResponse {
    products?: CiscoIbaProductDto[] | undefined;
    summary?: CiscoIbaProductSummaryDto;
}

export class CiscoIbaShippedHardwareResponse implements ICiscoIbaShippedHardwareResponse {
    cisco?: { [key: string]: CiscoIbaShippedHardwareCiscoDto[]; } | undefined;
    meraki?: { [key: string]: CiscoIbaShippedHardwareMerakiDto[]; } | undefined;

    constructor(data?: ICiscoIbaShippedHardwareResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["cisco"]) {
                this.cisco = {} as any;
                for (let key in _data["cisco"]) {
                    if (_data["cisco"].hasOwnProperty(key))
                        (<any>this.cisco)![key] = _data["cisco"][key] ? _data["cisco"][key].map((i: any) => CiscoIbaShippedHardwareCiscoDto.fromJS(i)) : <any>undefined;
                }
            }
            if (_data["meraki"]) {
                this.meraki = {} as any;
                for (let key in _data["meraki"]) {
                    if (_data["meraki"].hasOwnProperty(key))
                        (<any>this.meraki)![key] = _data["meraki"][key] ? _data["meraki"][key].map((i: any) => CiscoIbaShippedHardwareMerakiDto.fromJS(i)) : <any>undefined;
                }
            }
        }
    }

    static fromJS(data: any): CiscoIbaShippedHardwareResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaShippedHardwareResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.cisco) {
            data["cisco"] = {};
            for (let key in this.cisco) {
                if (this.cisco.hasOwnProperty(key))
                    (<any>data["cisco"])[key] = (<any>this.cisco)[key];
            }
        }
        if (this.meraki) {
            data["meraki"] = {};
            for (let key in this.meraki) {
                if (this.meraki.hasOwnProperty(key))
                    (<any>data["meraki"])[key] = (<any>this.meraki)[key];
            }
        }
        return data;
    }
}

export interface ICiscoIbaShippedHardwareResponse {
    cisco?: { [key: string]: CiscoIbaShippedHardwareCiscoDto[]; } | undefined;
    meraki?: { [key: string]: CiscoIbaShippedHardwareMerakiDto[]; } | undefined;
}

export class CustomerNameLocationData implements ICustomerNameLocationData {
    manufacturerCustomerName?: string | undefined;
    manufacturerGlobalCustomerId?: string | undefined;
    manufacturerGlobalCustomerName?: string | undefined;
    assetCountByManufacturerCustomerName?: number;

    constructor(data?: ICustomerNameLocationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.manufacturerCustomerName = _data["manufacturerCustomerName"];
            this.manufacturerGlobalCustomerId = _data["manufacturerGlobalCustomerId"];
            this.manufacturerGlobalCustomerName = _data["manufacturerGlobalCustomerName"];
            this.assetCountByManufacturerCustomerName = _data["assetCountByManufacturerCustomerName"];
        }
    }

    static fromJS(data: any): CustomerNameLocationData {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerNameLocationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["manufacturerCustomerName"] = this.manufacturerCustomerName;
        data["manufacturerGlobalCustomerId"] = this.manufacturerGlobalCustomerId;
        data["manufacturerGlobalCustomerName"] = this.manufacturerGlobalCustomerName;
        data["assetCountByManufacturerCustomerName"] = this.assetCountByManufacturerCustomerName;
        return data;
    }
}

export interface ICustomerNameLocationData {
    manufacturerCustomerName?: string | undefined;
    manufacturerGlobalCustomerId?: string | undefined;
    manufacturerGlobalCustomerName?: string | undefined;
    assetCountByManufacturerCustomerName?: number;
}

export class ExpiringAssetCounts implements IExpiringAssetCounts {
    subscriptionCount?: number;
    smartnetCount?: number;
    ciscoHardwareCount?: number;
    merakiHardwareCount?: number;

    constructor(data?: IExpiringAssetCounts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionCount = _data["subscriptionCount"];
            this.smartnetCount = _data["smartnetCount"];
            this.ciscoHardwareCount = _data["ciscoHardwareCount"];
            this.merakiHardwareCount = _data["merakiHardwareCount"];
        }
    }

    static fromJS(data: any): ExpiringAssetCounts {
        data = typeof data === 'object' ? data : {};
        let result = new ExpiringAssetCounts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionCount"] = this.subscriptionCount;
        data["smartnetCount"] = this.smartnetCount;
        data["ciscoHardwareCount"] = this.ciscoHardwareCount;
        data["merakiHardwareCount"] = this.merakiHardwareCount;
        return data;
    }
}

export interface IExpiringAssetCounts {
    subscriptionCount?: number;
    smartnetCount?: number;
    ciscoHardwareCount?: number;
    merakiHardwareCount?: number;
}

export class GlobalLocationData implements IGlobalLocationData {
    manufacturerGlobalCustomerId?: string | undefined;
    manufacturerGlobalCustomerName?: string | undefined;
    assetCountByManufacturerGlobal?: number;

    constructor(data?: IGlobalLocationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.manufacturerGlobalCustomerId = _data["manufacturerGlobalCustomerId"];
            this.manufacturerGlobalCustomerName = _data["manufacturerGlobalCustomerName"];
            this.assetCountByManufacturerGlobal = _data["assetCountByManufacturerGlobal"];
        }
    }

    static fromJS(data: any): GlobalLocationData {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalLocationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["manufacturerGlobalCustomerId"] = this.manufacturerGlobalCustomerId;
        data["manufacturerGlobalCustomerName"] = this.manufacturerGlobalCustomerName;
        data["assetCountByManufacturerGlobal"] = this.assetCountByManufacturerGlobal;
        return data;
    }
}

export interface IGlobalLocationData {
    manufacturerGlobalCustomerId?: string | undefined;
    manufacturerGlobalCustomerName?: string | undefined;
    assetCountByManufacturerGlobal?: number;
}

export class GuidsWidgetResponse implements IGuidsWidgetResponse {
    guids?: CiscoIbaGuidsDto[] | undefined;

    constructor(data?: IGuidsWidgetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["guids"])) {
                this.guids = [] as any;
                for (let item of _data["guids"])
                    this.guids!.push(CiscoIbaGuidsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GuidsWidgetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GuidsWidgetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.guids)) {
            data["guids"] = [];
            for (let item of this.guids)
                data["guids"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGuidsWidgetResponse {
    guids?: CiscoIbaGuidsDto[] | undefined;
}

export class ShiCategoryGroup implements IShiCategoryGroup {
    shiCategory?: string | undefined;
    subCategory?: SubCategoryGroup[] | undefined;

    constructor(data?: IShiCategoryGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shiCategory = _data["shiCategory"];
            if (Array.isArray(_data["subCategory"])) {
                this.subCategory = [] as any;
                for (let item of _data["subCategory"])
                    this.subCategory!.push(SubCategoryGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShiCategoryGroup {
        data = typeof data === 'object' ? data : {};
        let result = new ShiCategoryGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiCategory"] = this.shiCategory;
        if (Array.isArray(this.subCategory)) {
            data["subCategory"] = [];
            for (let item of this.subCategory)
                data["subCategory"].push(item.toJSON());
        }
        return data;
    }
}

export interface IShiCategoryGroup {
    shiCategory?: string | undefined;
    subCategory?: SubCategoryGroup[] | undefined;
}

export class SiteLocationGroup implements ISiteLocationGroup {
    siteLocation?: string | undefined;
    locationAddress?: string[] | undefined;

    constructor(data?: ISiteLocationGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.siteLocation = _data["siteLocation"];
            if (Array.isArray(_data["locationAddress"])) {
                this.locationAddress = [] as any;
                for (let item of _data["locationAddress"])
                    this.locationAddress!.push(item);
            }
        }
    }

    static fromJS(data: any): SiteLocationGroup {
        data = typeof data === 'object' ? data : {};
        let result = new SiteLocationGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteLocation"] = this.siteLocation;
        if (Array.isArray(this.locationAddress)) {
            data["locationAddress"] = [];
            for (let item of this.locationAddress)
                data["locationAddress"].push(item);
        }
        return data;
    }
}

export interface ISiteLocationGroup {
    siteLocation?: string | undefined;
    locationAddress?: string[] | undefined;
}

export class SmartNetSlasWidgetResponse implements ISmartNetSlasWidgetResponse {
    smartNetSlas?: CiscoIbaSmartNetSlaDto[] | undefined;

    constructor(data?: ISmartNetSlasWidgetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["smartNetSlas"])) {
                this.smartNetSlas = [] as any;
                for (let item of _data["smartNetSlas"])
                    this.smartNetSlas!.push(CiscoIbaSmartNetSlaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SmartNetSlasWidgetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SmartNetSlasWidgetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.smartNetSlas)) {
            data["smartNetSlas"] = [];
            for (let item of this.smartNetSlas)
                data["smartNetSlas"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISmartNetSlasWidgetResponse {
    smartNetSlas?: CiscoIbaSmartNetSlaDto[] | undefined;
}

export class SubCategoryGroup implements ISubCategoryGroup {
    subCategory?: string | undefined;
    microCategory?: string[] | undefined;

    constructor(data?: ISubCategoryGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subCategory = _data["subCategory"];
            if (Array.isArray(_data["microCategory"])) {
                this.microCategory = [] as any;
                for (let item of _data["microCategory"])
                    this.microCategory!.push(item);
            }
        }
    }

    static fromJS(data: any): SubCategoryGroup {
        data = typeof data === 'object' ? data : {};
        let result = new SubCategoryGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subCategory"] = this.subCategory;
        if (Array.isArray(this.microCategory)) {
            data["microCategory"] = [];
            for (let item of this.microCategory)
                data["microCategory"].push(item);
        }
        return data;
    }
}

export interface ISubCategoryGroup {
    subCategory?: string | undefined;
    microCategory?: string[] | undefined;
}

export class CiscoIbaAssetsArchitectureLdosAssetDetailsDto implements ICiscoIbaAssetsArchitectureLdosAssetDetailsDto {
    architecture?: string | undefined;
    totalAssetCount?: number;

    constructor(data?: ICiscoIbaAssetsArchitectureLdosAssetDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.architecture = _data["architecture"];
            this.totalAssetCount = _data["totalAssetCount"];
        }
    }

    static fromJS(data: any): CiscoIbaAssetsArchitectureLdosAssetDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaAssetsArchitectureLdosAssetDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["architecture"] = this.architecture;
        data["totalAssetCount"] = this.totalAssetCount;
        return data;
    }
}

export interface ICiscoIbaAssetsArchitectureLdosAssetDetailsDto {
    architecture?: string | undefined;
    totalAssetCount?: number;
}

export class CiscoIbaAssetsArchitectureLdosDto implements ICiscoIbaAssetsArchitectureLdosDto {
    year?: number;
    assetDetails?: CiscoIbaAssetsArchitectureLdosAssetDetailsDto[] | undefined;

    constructor(data?: ICiscoIbaAssetsArchitectureLdosDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            if (Array.isArray(_data["assetDetails"])) {
                this.assetDetails = [] as any;
                for (let item of _data["assetDetails"])
                    this.assetDetails!.push(CiscoIbaAssetsArchitectureLdosAssetDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CiscoIbaAssetsArchitectureLdosDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaAssetsArchitectureLdosDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        if (Array.isArray(this.assetDetails)) {
            data["assetDetails"] = [];
            for (let item of this.assetDetails)
                data["assetDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICiscoIbaAssetsArchitectureLdosDto {
    year?: number;
    assetDetails?: CiscoIbaAssetsArchitectureLdosAssetDetailsDto[] | undefined;
}

export class CiscoIbaSearchFilterDto implements ICiscoIbaSearchFilterDto {
    assetType?: string[] | undefined;
    category?: string[] | undefined;
    coveredStatus?: string[] | undefined;
    shiCategory?: string[] | undefined;
    subCategory?: string[] | undefined;
    microCategory?: string[] | undefined;
    productFamily?: string[] | undefined;
    tags?: string[] | undefined;
    manufacturerGlobalCustomerName?: string[] | undefined;
    manufacturerCustomerName?: string[] | undefined;
    siteLocation?: string[] | undefined;
    locationName?: string[] | undefined;
    locationAddress?: string[] | undefined;
    coveredEndDate?: string[] | undefined;
    endOfLife?: string[] | undefined;
    endOfSaleDate?: string[] | undefined;
    endOfSoftwareMaintenanceDate?: string[] | undefined;
    lastDateOfSupport?: string[] | undefined;

    protected _discriminator: string;

    constructor(data?: ICiscoIbaSearchFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "CiscoIbaSearchFilterDto";
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["assetType"])) {
                this.assetType = [] as any;
                for (let item of _data["assetType"])
                    this.assetType!.push(item);
            }
            if (Array.isArray(_data["category"])) {
                this.category = [] as any;
                for (let item of _data["category"])
                    this.category!.push(item);
            }
            if (Array.isArray(_data["coveredStatus"])) {
                this.coveredStatus = [] as any;
                for (let item of _data["coveredStatus"])
                    this.coveredStatus!.push(item);
            }
            if (Array.isArray(_data["shiCategory"])) {
                this.shiCategory = [] as any;
                for (let item of _data["shiCategory"])
                    this.shiCategory!.push(item);
            }
            if (Array.isArray(_data["subCategory"])) {
                this.subCategory = [] as any;
                for (let item of _data["subCategory"])
                    this.subCategory!.push(item);
            }
            if (Array.isArray(_data["microCategory"])) {
                this.microCategory = [] as any;
                for (let item of _data["microCategory"])
                    this.microCategory!.push(item);
            }
            if (Array.isArray(_data["productFamily"])) {
                this.productFamily = [] as any;
                for (let item of _data["productFamily"])
                    this.productFamily!.push(item);
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            if (Array.isArray(_data["manufacturerGlobalCustomerName"])) {
                this.manufacturerGlobalCustomerName = [] as any;
                for (let item of _data["manufacturerGlobalCustomerName"])
                    this.manufacturerGlobalCustomerName!.push(item);
            }
            if (Array.isArray(_data["manufacturerCustomerName"])) {
                this.manufacturerCustomerName = [] as any;
                for (let item of _data["manufacturerCustomerName"])
                    this.manufacturerCustomerName!.push(item);
            }
            if (Array.isArray(_data["siteLocation"])) {
                this.siteLocation = [] as any;
                for (let item of _data["siteLocation"])
                    this.siteLocation!.push(item);
            }
            if (Array.isArray(_data["locationName"])) {
                this.locationName = [] as any;
                for (let item of _data["locationName"])
                    this.locationName!.push(item);
            }
            if (Array.isArray(_data["locationAddress"])) {
                this.locationAddress = [] as any;
                for (let item of _data["locationAddress"])
                    this.locationAddress!.push(item);
            }
            if (Array.isArray(_data["coveredEndDate"])) {
                this.coveredEndDate = [] as any;
                for (let item of _data["coveredEndDate"])
                    this.coveredEndDate!.push(item);
            }
            if (Array.isArray(_data["endOfLife"])) {
                this.endOfLife = [] as any;
                for (let item of _data["endOfLife"])
                    this.endOfLife!.push(item);
            }
            if (Array.isArray(_data["endOfSaleDate"])) {
                this.endOfSaleDate = [] as any;
                for (let item of _data["endOfSaleDate"])
                    this.endOfSaleDate!.push(item);
            }
            if (Array.isArray(_data["endOfSoftwareMaintenanceDate"])) {
                this.endOfSoftwareMaintenanceDate = [] as any;
                for (let item of _data["endOfSoftwareMaintenanceDate"])
                    this.endOfSoftwareMaintenanceDate!.push(item);
            }
            if (Array.isArray(_data["lastDateOfSupport"])) {
                this.lastDateOfSupport = [] as any;
                for (let item of _data["lastDateOfSupport"])
                    this.lastDateOfSupport!.push(item);
            }
        }
    }

    static fromJS(data: any): CiscoIbaSearchFilterDto {
        data = typeof data === 'object' ? data : {};
        if (data["typeName"] === "CiscoIbaAssetsSearchFilterDto") {
            let result = new CiscoIbaAssetsSearchFilterDto();
            result.init(data);
            return result;
        }
        let result = new CiscoIbaSearchFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeName"] = this._discriminator;
        if (Array.isArray(this.assetType)) {
            data["assetType"] = [];
            for (let item of this.assetType)
                data["assetType"].push(item);
        }
        if (Array.isArray(this.category)) {
            data["category"] = [];
            for (let item of this.category)
                data["category"].push(item);
        }
        if (Array.isArray(this.coveredStatus)) {
            data["coveredStatus"] = [];
            for (let item of this.coveredStatus)
                data["coveredStatus"].push(item);
        }
        if (Array.isArray(this.shiCategory)) {
            data["shiCategory"] = [];
            for (let item of this.shiCategory)
                data["shiCategory"].push(item);
        }
        if (Array.isArray(this.subCategory)) {
            data["subCategory"] = [];
            for (let item of this.subCategory)
                data["subCategory"].push(item);
        }
        if (Array.isArray(this.microCategory)) {
            data["microCategory"] = [];
            for (let item of this.microCategory)
                data["microCategory"].push(item);
        }
        if (Array.isArray(this.productFamily)) {
            data["productFamily"] = [];
            for (let item of this.productFamily)
                data["productFamily"].push(item);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        if (Array.isArray(this.manufacturerGlobalCustomerName)) {
            data["manufacturerGlobalCustomerName"] = [];
            for (let item of this.manufacturerGlobalCustomerName)
                data["manufacturerGlobalCustomerName"].push(item);
        }
        if (Array.isArray(this.manufacturerCustomerName)) {
            data["manufacturerCustomerName"] = [];
            for (let item of this.manufacturerCustomerName)
                data["manufacturerCustomerName"].push(item);
        }
        if (Array.isArray(this.siteLocation)) {
            data["siteLocation"] = [];
            for (let item of this.siteLocation)
                data["siteLocation"].push(item);
        }
        if (Array.isArray(this.locationName)) {
            data["locationName"] = [];
            for (let item of this.locationName)
                data["locationName"].push(item);
        }
        if (Array.isArray(this.locationAddress)) {
            data["locationAddress"] = [];
            for (let item of this.locationAddress)
                data["locationAddress"].push(item);
        }
        if (Array.isArray(this.coveredEndDate)) {
            data["coveredEndDate"] = [];
            for (let item of this.coveredEndDate)
                data["coveredEndDate"].push(item);
        }
        if (Array.isArray(this.endOfLife)) {
            data["endOfLife"] = [];
            for (let item of this.endOfLife)
                data["endOfLife"].push(item);
        }
        if (Array.isArray(this.endOfSaleDate)) {
            data["endOfSaleDate"] = [];
            for (let item of this.endOfSaleDate)
                data["endOfSaleDate"].push(item);
        }
        if (Array.isArray(this.endOfSoftwareMaintenanceDate)) {
            data["endOfSoftwareMaintenanceDate"] = [];
            for (let item of this.endOfSoftwareMaintenanceDate)
                data["endOfSoftwareMaintenanceDate"].push(item);
        }
        if (Array.isArray(this.lastDateOfSupport)) {
            data["lastDateOfSupport"] = [];
            for (let item of this.lastDateOfSupport)
                data["lastDateOfSupport"].push(item);
        }
        return data;
    }
}

export interface ICiscoIbaSearchFilterDto {
    assetType?: string[] | undefined;
    category?: string[] | undefined;
    coveredStatus?: string[] | undefined;
    shiCategory?: string[] | undefined;
    subCategory?: string[] | undefined;
    microCategory?: string[] | undefined;
    productFamily?: string[] | undefined;
    tags?: string[] | undefined;
    manufacturerGlobalCustomerName?: string[] | undefined;
    manufacturerCustomerName?: string[] | undefined;
    siteLocation?: string[] | undefined;
    locationName?: string[] | undefined;
    locationAddress?: string[] | undefined;
    coveredEndDate?: string[] | undefined;
    endOfLife?: string[] | undefined;
    endOfSaleDate?: string[] | undefined;
    endOfSoftwareMaintenanceDate?: string[] | undefined;
    lastDateOfSupport?: string[] | undefined;
}

export class CiscoIbaAssetsSearchFilterDto extends CiscoIbaSearchFilterDto implements ICiscoIbaAssetsSearchFilterDto {
    product?: string[] | undefined;
    manufacturerGlobalCustomerId?: string[] | undefined;
    locationAddress?: string[] | undefined;
    locationCity?: string[] | undefined;
    locationCountry?: string[] | undefined;
    locationState?: string[] | undefined;

    constructor(data?: ICiscoIbaAssetsSearchFilterDto) {
        super(data);
        this._discriminator = "CiscoIbaAssetsSearchFilterDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["product"])) {
                this.product = [] as any;
                for (let item of _data["product"])
                    this.product!.push(item);
            }
            if (Array.isArray(_data["manufacturerGlobalCustomerId"])) {
                this.manufacturerGlobalCustomerId = [] as any;
                for (let item of _data["manufacturerGlobalCustomerId"])
                    this.manufacturerGlobalCustomerId!.push(item);
            }
            if (Array.isArray(_data["locationAddress"])) {
                this.locationAddress = [] as any;
                for (let item of _data["locationAddress"])
                    this.locationAddress!.push(item);
            }
            if (Array.isArray(_data["locationCity"])) {
                this.locationCity = [] as any;
                for (let item of _data["locationCity"])
                    this.locationCity!.push(item);
            }
            if (Array.isArray(_data["locationCountry"])) {
                this.locationCountry = [] as any;
                for (let item of _data["locationCountry"])
                    this.locationCountry!.push(item);
            }
            if (Array.isArray(_data["locationState"])) {
                this.locationState = [] as any;
                for (let item of _data["locationState"])
                    this.locationState!.push(item);
            }
        }
    }

    static override fromJS(data: any): CiscoIbaAssetsSearchFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaAssetsSearchFilterDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.product)) {
            data["product"] = [];
            for (let item of this.product)
                data["product"].push(item);
        }
        if (Array.isArray(this.manufacturerGlobalCustomerId)) {
            data["manufacturerGlobalCustomerId"] = [];
            for (let item of this.manufacturerGlobalCustomerId)
                data["manufacturerGlobalCustomerId"].push(item);
        }
        if (Array.isArray(this.locationAddress)) {
            data["locationAddress"] = [];
            for (let item of this.locationAddress)
                data["locationAddress"].push(item);
        }
        if (Array.isArray(this.locationCity)) {
            data["locationCity"] = [];
            for (let item of this.locationCity)
                data["locationCity"].push(item);
        }
        if (Array.isArray(this.locationCountry)) {
            data["locationCountry"] = [];
            for (let item of this.locationCountry)
                data["locationCountry"].push(item);
        }
        if (Array.isArray(this.locationState)) {
            data["locationState"] = [];
            for (let item of this.locationState)
                data["locationState"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICiscoIbaAssetsSearchFilterDto extends ICiscoIbaSearchFilterDto {
    product?: string[] | undefined;
    manufacturerGlobalCustomerId?: string[] | undefined;
    locationAddress?: string[] | undefined;
    locationCity?: string[] | undefined;
    locationCountry?: string[] | undefined;
    locationState?: string[] | undefined;
}

export class CiscoIbaGuidsDto implements ICiscoIbaGuidsDto {
    manufacturerGlobalCustomerName?: string | undefined;
    manufacturerGlobalCustomerId?: string | undefined;
    partiesCount?: number;
    assetsCount?: number;

    constructor(data?: ICiscoIbaGuidsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.manufacturerGlobalCustomerName = _data["manufacturerGlobalCustomerName"];
            this.manufacturerGlobalCustomerId = _data["manufacturerGlobalCustomerId"];
            this.partiesCount = _data["partiesCount"];
            this.assetsCount = _data["assetsCount"];
        }
    }

    static fromJS(data: any): CiscoIbaGuidsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaGuidsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["manufacturerGlobalCustomerName"] = this.manufacturerGlobalCustomerName;
        data["manufacturerGlobalCustomerId"] = this.manufacturerGlobalCustomerId;
        data["partiesCount"] = this.partiesCount;
        data["assetsCount"] = this.assetsCount;
        return data;
    }
}

export interface ICiscoIbaGuidsDto {
    manufacturerGlobalCustomerName?: string | undefined;
    manufacturerGlobalCustomerId?: string | undefined;
    partiesCount?: number;
    assetsCount?: number;
}

export class CiscoIbaLdosDto implements ICiscoIbaLdosDto {
    product?: string | undefined;
    documentCount?: number | undefined;
    coverageDetails?: CiscoIbaLdosDtoCoverageDetailsDto[] | undefined;
    ldos?: string | undefined;

    constructor(data?: ICiscoIbaLdosDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product = _data["product"];
            this.documentCount = _data["documentCount"];
            if (Array.isArray(_data["coverageDetails"])) {
                this.coverageDetails = [] as any;
                for (let item of _data["coverageDetails"])
                    this.coverageDetails!.push(CiscoIbaLdosDtoCoverageDetailsDto.fromJS(item));
            }
            this.ldos = _data["ldos"];
        }
    }

    static fromJS(data: any): CiscoIbaLdosDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaLdosDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product;
        data["documentCount"] = this.documentCount;
        if (Array.isArray(this.coverageDetails)) {
            data["coverageDetails"] = [];
            for (let item of this.coverageDetails)
                data["coverageDetails"].push(item.toJSON());
        }
        data["ldos"] = this.ldos;
        return data;
    }
}

export interface ICiscoIbaLdosDto {
    product?: string | undefined;
    documentCount?: number | undefined;
    coverageDetails?: CiscoIbaLdosDtoCoverageDetailsDto[] | undefined;
    ldos?: string | undefined;
}

export class CiscoIbaLdosDtoCoverageDetailsDto implements ICiscoIbaLdosDtoCoverageDetailsDto {
    coveredStatus?: string | undefined;
    count?: number | undefined;

    constructor(data?: ICiscoIbaLdosDtoCoverageDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.coveredStatus = _data["coveredStatus"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): CiscoIbaLdosDtoCoverageDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaLdosDtoCoverageDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coveredStatus"] = this.coveredStatus;
        data["count"] = this.count;
        return data;
    }
}

export interface ICiscoIbaLdosDtoCoverageDetailsDto {
    coveredStatus?: string | undefined;
    count?: number | undefined;
}

export class CiscoIbaProductDto implements ICiscoIbaProductDto {
    product?: string | undefined;
    assetType?: string | undefined;
    assetsCount?: number;
    endOfSoftwareMaintenanceDate?: string | undefined;
    lastDateOfSupport?: string | undefined;
    coveredLineStatus?: string | undefined;
    minCoveredEndDate?: string | undefined;

    constructor(data?: ICiscoIbaProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product = _data["product"];
            this.assetType = _data["assetType"];
            this.assetsCount = _data["assetsCount"];
            this.endOfSoftwareMaintenanceDate = _data["endOfSoftwareMaintenanceDate"];
            this.lastDateOfSupport = _data["lastDateOfSupport"];
            this.coveredLineStatus = _data["coveredLineStatus"];
            this.minCoveredEndDate = _data["minCoveredEndDate"];
        }
    }

    static fromJS(data: any): CiscoIbaProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product;
        data["assetType"] = this.assetType;
        data["assetsCount"] = this.assetsCount;
        data["endOfSoftwareMaintenanceDate"] = this.endOfSoftwareMaintenanceDate;
        data["lastDateOfSupport"] = this.lastDateOfSupport;
        data["coveredLineStatus"] = this.coveredLineStatus;
        data["minCoveredEndDate"] = this.minCoveredEndDate;
        return data;
    }
}

export interface ICiscoIbaProductDto {
    product?: string | undefined;
    assetType?: string | undefined;
    assetsCount?: number;
    endOfSoftwareMaintenanceDate?: string | undefined;
    lastDateOfSupport?: string | undefined;
    coveredLineStatus?: string | undefined;
    minCoveredEndDate?: string | undefined;
}

export class CiscoIbaProductSummaryDto implements ICiscoIbaProductSummaryDto {
    productsCount?: number;
    totalAssetsCounts?: number;

    constructor(data?: ICiscoIbaProductSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productsCount = _data["productsCount"];
            this.totalAssetsCounts = _data["totalAssetsCounts"];
        }
    }

    static fromJS(data: any): CiscoIbaProductSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaProductSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productsCount"] = this.productsCount;
        data["totalAssetsCounts"] = this.totalAssetsCounts;
        return data;
    }
}

export interface ICiscoIbaProductSummaryDto {
    productsCount?: number;
    totalAssetsCounts?: number;
}

export class CiscoIbaShippedHardwareCiscoDto implements ICiscoIbaShippedHardwareCiscoDto {
    coveredStatus?: string | undefined;
    itemQuantity?: number;

    constructor(data?: ICiscoIbaShippedHardwareCiscoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.coveredStatus = _data["coveredStatus"];
            this.itemQuantity = _data["itemQuantity"];
        }
    }

    static fromJS(data: any): CiscoIbaShippedHardwareCiscoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaShippedHardwareCiscoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coveredStatus"] = this.coveredStatus;
        data["itemQuantity"] = this.itemQuantity;
        return data;
    }
}

export interface ICiscoIbaShippedHardwareCiscoDto {
    coveredStatus?: string | undefined;
    itemQuantity?: number;
}

export class CiscoIbaShippedHardwareMerakiDto implements ICiscoIbaShippedHardwareMerakiDto {
    microCategory?: string | undefined;
    itemQuantity?: number;

    constructor(data?: ICiscoIbaShippedHardwareMerakiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.microCategory = _data["microCategory"];
            this.itemQuantity = _data["itemQuantity"];
        }
    }

    static fromJS(data: any): CiscoIbaShippedHardwareMerakiDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaShippedHardwareMerakiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["microCategory"] = this.microCategory;
        data["itemQuantity"] = this.itemQuantity;
        return data;
    }
}

export interface ICiscoIbaShippedHardwareMerakiDto {
    microCategory?: string | undefined;
    itemQuantity?: number;
}

export class CiscoIbaSmartNetSlaDto implements ICiscoIbaSmartNetSlaDto {
    serviceLevelAgreement?: string | undefined;
    serviceLevelDescription?: string | undefined;
    assetsCount?: number;

    constructor(data?: ICiscoIbaSmartNetSlaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceLevelAgreement = _data["serviceLevelAgreement"];
            this.serviceLevelDescription = _data["serviceLevelDescription"];
            this.assetsCount = _data["assetsCount"];
        }
    }

    static fromJS(data: any): CiscoIbaSmartNetSlaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaSmartNetSlaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceLevelAgreement"] = this.serviceLevelAgreement;
        data["serviceLevelDescription"] = this.serviceLevelDescription;
        data["assetsCount"] = this.assetsCount;
        return data;
    }
}

export interface ICiscoIbaSmartNetSlaDto {
    serviceLevelAgreement?: string | undefined;
    serviceLevelDescription?: string | undefined;
    assetsCount?: number;
}

export class CheckSourceIdsRoadmapLinkResponse implements ICheckSourceIdsRoadmapLinkResponse {
    success?: boolean;
    sourceIdLinks?: SourceIdLinkInfo[] | undefined;
    errorMessage?: string | undefined;

    constructor(data?: ICheckSourceIdsRoadmapLinkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["sourceIdLinks"])) {
                this.sourceIdLinks = [] as any;
                for (let item of _data["sourceIdLinks"])
                    this.sourceIdLinks!.push(SourceIdLinkInfo.fromJS(item));
            }
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): CheckSourceIdsRoadmapLinkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CheckSourceIdsRoadmapLinkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.sourceIdLinks)) {
            data["sourceIdLinks"] = [];
            for (let item of this.sourceIdLinks)
                data["sourceIdLinks"].push(item.toJSON());
        }
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface ICheckSourceIdsRoadmapLinkResponse {
    success?: boolean;
    sourceIdLinks?: SourceIdLinkInfo[] | undefined;
    errorMessage?: string | undefined;
}

export class SourceIdLinkInfo implements ISourceIdLinkInfo {
    sourceId?: string | undefined;
    alreadyAttached?: boolean;
    sourceType?: RoadmapItemSourceType;
    roadmapItemId?: string | undefined;
    roadmapId?: string | undefined;
    roadmapName?: string | undefined;

    constructor(data?: ISourceIdLinkInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.alreadyAttached = _data["alreadyAttached"];
            this.sourceType = _data["sourceType"];
            this.roadmapItemId = _data["roadmapItemId"];
            this.roadmapId = _data["roadmapId"];
            this.roadmapName = _data["roadmapName"];
        }
    }

    static fromJS(data: any): SourceIdLinkInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SourceIdLinkInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["alreadyAttached"] = this.alreadyAttached;
        data["sourceType"] = this.sourceType;
        data["roadmapItemId"] = this.roadmapItemId;
        data["roadmapId"] = this.roadmapId;
        data["roadmapName"] = this.roadmapName;
        return data;
    }
}

export interface ISourceIdLinkInfo {
    sourceId?: string | undefined;
    alreadyAttached?: boolean;
    sourceType?: RoadmapItemSourceType;
    roadmapItemId?: string | undefined;
    roadmapId?: string | undefined;
    roadmapName?: string | undefined;
}

export class CreateRoadmapItemResponse implements ICreateRoadmapItemResponse {
    isSuccessful?: boolean;
    roadmapItem?: RoadmapItemDto;
    responseMessage?: string | undefined;

    constructor(data?: ICreateRoadmapItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.roadmapItem = _data["roadmapItem"] ? RoadmapItemDto.fromJS(_data["roadmapItem"]) : <any>undefined;
            this.responseMessage = _data["responseMessage"];
        }
    }

    static fromJS(data: any): CreateRoadmapItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoadmapItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["roadmapItem"] = this.roadmapItem ? this.roadmapItem.toJSON() : <any>undefined;
        data["responseMessage"] = this.responseMessage;
        return data;
    }
}

export interface ICreateRoadmapItemResponse {
    isSuccessful?: boolean;
    roadmapItem?: RoadmapItemDto;
    responseMessage?: string | undefined;
}

export class DeleteRoadmapItemResponse implements IDeleteRoadmapItemResponse {
    isSuccessful?: boolean;
    responseMessage?: string | undefined;

    constructor(data?: IDeleteRoadmapItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.responseMessage = _data["responseMessage"];
        }
    }

    static fromJS(data: any): DeleteRoadmapItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteRoadmapItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["responseMessage"] = this.responseMessage;
        return data;
    }
}

export interface IDeleteRoadmapItemResponse {
    isSuccessful?: boolean;
    responseMessage?: string | undefined;
}

export class UpdateRoadmapItemResponse implements IUpdateRoadmapItemResponse {
    isSuccessful?: boolean;
    roadmapItem?: RoadmapItemDto;
    responseMessage?: string | undefined;

    constructor(data?: IUpdateRoadmapItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.roadmapItem = _data["roadmapItem"] ? RoadmapItemDto.fromJS(_data["roadmapItem"]) : <any>undefined;
            this.responseMessage = _data["responseMessage"];
        }
    }

    static fromJS(data: any): UpdateRoadmapItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRoadmapItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["roadmapItem"] = this.roadmapItem ? this.roadmapItem.toJSON() : <any>undefined;
        data["responseMessage"] = this.responseMessage;
        return data;
    }
}

export interface IUpdateRoadmapItemResponse {
    isSuccessful?: boolean;
    roadmapItem?: RoadmapItemDto;
    responseMessage?: string | undefined;
}

export class CreateRoadmapResponse implements ICreateRoadmapResponse {
    isSuccessful?: boolean;
    roadmap?: RoadmapDto;
    responseMessage?: string | undefined;

    constructor(data?: ICreateRoadmapResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.roadmap = _data["roadmap"] ? RoadmapDto.fromJS(_data["roadmap"]) : <any>undefined;
            this.responseMessage = _data["responseMessage"];
        }
    }

    static fromJS(data: any): CreateRoadmapResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoadmapResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["roadmap"] = this.roadmap ? this.roadmap.toJSON() : <any>undefined;
        data["responseMessage"] = this.responseMessage;
        return data;
    }
}

export interface ICreateRoadmapResponse {
    isSuccessful?: boolean;
    roadmap?: RoadmapDto;
    responseMessage?: string | undefined;
}

export class DeleteRoadmapResponse implements IDeleteRoadmapResponse {
    isSuccessful?: boolean;
    responseMessage?: string | undefined;

    constructor(data?: IDeleteRoadmapResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.responseMessage = _data["responseMessage"];
        }
    }

    static fromJS(data: any): DeleteRoadmapResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteRoadmapResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["responseMessage"] = this.responseMessage;
        return data;
    }
}

export interface IDeleteRoadmapResponse {
    isSuccessful?: boolean;
    responseMessage?: string | undefined;
}

export class GetRoadmapByIdResponse implements IGetRoadmapByIdResponse {
    isSuccessful?: boolean;
    roadmap?: RoadmapDto;
    responseMessage?: string | undefined;

    constructor(data?: IGetRoadmapByIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.roadmap = _data["roadmap"] ? RoadmapDto.fromJS(_data["roadmap"]) : <any>undefined;
            this.responseMessage = _data["responseMessage"];
        }
    }

    static fromJS(data: any): GetRoadmapByIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoadmapByIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["roadmap"] = this.roadmap ? this.roadmap.toJSON() : <any>undefined;
        data["responseMessage"] = this.responseMessage;
        return data;
    }
}

export interface IGetRoadmapByIdResponse {
    isSuccessful?: boolean;
    roadmap?: RoadmapDto;
    responseMessage?: string | undefined;
}

export class GetRoadmapsByCustomerResponse implements IGetRoadmapsByCustomerResponse {
    isSuccessful?: boolean;
    roadmapList?: RoadmapDto[] | undefined;
    responseMessage?: string | undefined;

    constructor(data?: IGetRoadmapsByCustomerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            if (Array.isArray(_data["roadmapList"])) {
                this.roadmapList = [] as any;
                for (let item of _data["roadmapList"])
                    this.roadmapList!.push(RoadmapDto.fromJS(item));
            }
            this.responseMessage = _data["responseMessage"];
        }
    }

    static fromJS(data: any): GetRoadmapsByCustomerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoadmapsByCustomerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        if (Array.isArray(this.roadmapList)) {
            data["roadmapList"] = [];
            for (let item of this.roadmapList)
                data["roadmapList"].push(item.toJSON());
        }
        data["responseMessage"] = this.responseMessage;
        return data;
    }
}

export interface IGetRoadmapsByCustomerResponse {
    isSuccessful?: boolean;
    roadmapList?: RoadmapDto[] | undefined;
    responseMessage?: string | undefined;
}

export class UpdateRoadmapResponse implements IUpdateRoadmapResponse {
    isSuccessful?: boolean;
    roadmap?: RoadmapDto;
    responseMessage?: string | undefined;

    constructor(data?: IUpdateRoadmapResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.roadmap = _data["roadmap"] ? RoadmapDto.fromJS(_data["roadmap"]) : <any>undefined;
            this.responseMessage = _data["responseMessage"];
        }
    }

    static fromJS(data: any): UpdateRoadmapResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRoadmapResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["roadmap"] = this.roadmap ? this.roadmap.toJSON() : <any>undefined;
        data["responseMessage"] = this.responseMessage;
        return data;
    }
}

export interface IUpdateRoadmapResponse {
    isSuccessful?: boolean;
    roadmap?: RoadmapDto;
    responseMessage?: string | undefined;
}

export enum RoadmapItemCostFrequency {
    OneTime = "OneTime",
    Monthly = "Monthly",
    Quarterly = "Quarterly",
    Annual = "Annual",
}

export enum RoadmapItemSourceType {
    Undefined = "Undefined",
    AssessmentRecommendation = "AssessmentRecommendation",
    Project = "Project",
    Custom = "Custom",
}

export class RoadmapCostItemDto implements IRoadmapCostItemDto {
    costItemId?: string;
    roadmapItemId?: string;
    category?: string | undefined;
    subcategory?: string | undefined;
    amount?: number;
    frequency?: RoadmapItemCostFrequency;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    roadmapItem?: RoadmapItemDto;

    constructor(data?: IRoadmapCostItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.costItemId = _data["costItemId"];
            this.roadmapItemId = _data["roadmapItemId"];
            this.category = _data["category"];
            this.subcategory = _data["subcategory"];
            this.amount = _data["amount"];
            this.frequency = _data["frequency"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.roadmapItem = _data["roadmapItem"] ? RoadmapItemDto.fromJS(_data["roadmapItem"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RoadmapCostItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoadmapCostItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["costItemId"] = this.costItemId;
        data["roadmapItemId"] = this.roadmapItemId;
        data["category"] = this.category;
        data["subcategory"] = this.subcategory;
        data["amount"] = this.amount;
        data["frequency"] = this.frequency;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["roadmapItem"] = this.roadmapItem ? this.roadmapItem.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRoadmapCostItemDto {
    costItemId?: string;
    roadmapItemId?: string;
    category?: string | undefined;
    subcategory?: string | undefined;
    amount?: number;
    frequency?: RoadmapItemCostFrequency;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    roadmapItem?: RoadmapItemDto;
}

export class RoadmapDto implements IRoadmapDto {
    id?: string;
    accountId?: number;
    name?: string | undefined;
    description?: string | undefined;
    createdDate?: Date;
    lastModifiedDate?: Date;
    roadmapItems?: RoadmapItemDto[] | undefined;
    isDeleted?: boolean;

    constructor(data?: IRoadmapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["roadmapItems"])) {
                this.roadmapItems = [] as any;
                for (let item of _data["roadmapItems"])
                    this.roadmapItems!.push(RoadmapItemDto.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): RoadmapDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoadmapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        if (Array.isArray(this.roadmapItems)) {
            data["roadmapItems"] = [];
            for (let item of this.roadmapItems)
                data["roadmapItems"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IRoadmapDto {
    id?: string;
    accountId?: number;
    name?: string | undefined;
    description?: string | undefined;
    createdDate?: Date;
    lastModifiedDate?: Date;
    roadmapItems?: RoadmapItemDto[] | undefined;
    isDeleted?: boolean;
}

export class RoadmapItemDto implements IRoadmapItemDto {
    roadmapItemId?: string;
    roadmapId?: string;
    parentRoadmapItemId?: string | undefined;
    roadmapItemOrdinal?: number;
    isMilestone?: boolean;
    isShiHelping?: boolean;
    owner?: string | undefined;
    status?: string | undefined;
    sourceType?: RoadmapItemSourceType;
    sourceMetadata?: { [key: string]: string; } | undefined;
    sourceId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    startDate?: Date | undefined;
    targetDate?: Date;
    roadmap?: RoadmapDto;
    costItems?: RoadmapCostItemDto[] | undefined;
    createdDate?: Date;
    lastModifiedDate?: Date;
    parentRoadmapItem?: RoadmapItemDto;
    subRoadmapItems?: RoadmapItemDto[] | undefined;
    isDeleted?: boolean;

    constructor(data?: IRoadmapItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roadmapItemId = _data["roadmapItemId"];
            this.roadmapId = _data["roadmapId"];
            this.parentRoadmapItemId = _data["parentRoadmapItemId"];
            this.roadmapItemOrdinal = _data["roadmapItemOrdinal"];
            this.isMilestone = _data["isMilestone"];
            this.isShiHelping = _data["isShiHelping"];
            this.owner = _data["owner"];
            this.status = _data["status"];
            this.sourceType = _data["sourceType"];
            if (_data["sourceMetadata"]) {
                this.sourceMetadata = {} as any;
                for (let key in _data["sourceMetadata"]) {
                    if (_data["sourceMetadata"].hasOwnProperty(key))
                        (<any>this.sourceMetadata)![key] = _data["sourceMetadata"][key];
                }
            }
            this.sourceId = _data["sourceId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.targetDate = _data["targetDate"] ? new Date(_data["targetDate"].toString()) : <any>undefined;
            this.roadmap = _data["roadmap"] ? RoadmapDto.fromJS(_data["roadmap"]) : <any>undefined;
            if (Array.isArray(_data["costItems"])) {
                this.costItems = [] as any;
                for (let item of _data["costItems"])
                    this.costItems!.push(RoadmapCostItemDto.fromJS(item));
            }
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            this.parentRoadmapItem = _data["parentRoadmapItem"] ? RoadmapItemDto.fromJS(_data["parentRoadmapItem"]) : <any>undefined;
            if (Array.isArray(_data["subRoadmapItems"])) {
                this.subRoadmapItems = [] as any;
                for (let item of _data["subRoadmapItems"])
                    this.subRoadmapItems!.push(RoadmapItemDto.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): RoadmapItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoadmapItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roadmapItemId"] = this.roadmapItemId;
        data["roadmapId"] = this.roadmapId;
        data["parentRoadmapItemId"] = this.parentRoadmapItemId;
        data["roadmapItemOrdinal"] = this.roadmapItemOrdinal;
        data["isMilestone"] = this.isMilestone;
        data["isShiHelping"] = this.isShiHelping;
        data["owner"] = this.owner;
        data["status"] = this.status;
        data["sourceType"] = this.sourceType;
        if (this.sourceMetadata) {
            data["sourceMetadata"] = {};
            for (let key in this.sourceMetadata) {
                if (this.sourceMetadata.hasOwnProperty(key))
                    (<any>data["sourceMetadata"])[key] = (<any>this.sourceMetadata)[key];
            }
        }
        data["sourceId"] = this.sourceId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["targetDate"] = this.targetDate ? this.targetDate.toISOString() : <any>undefined;
        data["roadmap"] = this.roadmap ? this.roadmap.toJSON() : <any>undefined;
        if (Array.isArray(this.costItems)) {
            data["costItems"] = [];
            for (let item of this.costItems)
                data["costItems"].push(item.toJSON());
        }
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["parentRoadmapItem"] = this.parentRoadmapItem ? this.parentRoadmapItem.toJSON() : <any>undefined;
        if (Array.isArray(this.subRoadmapItems)) {
            data["subRoadmapItems"] = [];
            for (let item of this.subRoadmapItems)
                data["subRoadmapItems"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IRoadmapItemDto {
    roadmapItemId?: string;
    roadmapId?: string;
    parentRoadmapItemId?: string | undefined;
    roadmapItemOrdinal?: number;
    isMilestone?: boolean;
    isShiHelping?: boolean;
    owner?: string | undefined;
    status?: string | undefined;
    sourceType?: RoadmapItemSourceType;
    sourceMetadata?: { [key: string]: string; } | undefined;
    sourceId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    startDate?: Date | undefined;
    targetDate?: Date;
    roadmap?: RoadmapDto;
    costItems?: RoadmapCostItemDto[] | undefined;
    createdDate?: Date;
    lastModifiedDate?: Date;
    parentRoadmapItem?: RoadmapItemDto;
    subRoadmapItems?: RoadmapItemDto[] | undefined;
    isDeleted?: boolean;
}

export class CreateUpdateSecretDto implements ICreateUpdateSecretDto {
    integrationType?: IntegrationType;
    friendlyKeyName?: string | undefined;
    axNumber?: string | undefined;
    keyValue?: string | undefined;

    constructor(data?: ICreateUpdateSecretDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.integrationType = _data["integrationType"];
            this.friendlyKeyName = _data["friendlyKeyName"];
            this.axNumber = _data["axNumber"];
            this.keyValue = _data["keyValue"];
        }
    }

    static fromJS(data: any): CreateUpdateSecretDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateSecretDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["friendlyKeyName"] = this.friendlyKeyName;
        data["axNumber"] = this.axNumber;
        data["keyValue"] = this.keyValue;
        return data;
    }
}

export interface ICreateUpdateSecretDto {
    integrationType?: IntegrationType;
    friendlyKeyName?: string | undefined;
    axNumber?: string | undefined;
    keyValue?: string | undefined;
}

export class DeleteSecretDto implements IDeleteSecretDto {
    keyName?: string | undefined;
    axNumber?: string | undefined;

    constructor(data?: IDeleteSecretDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keyName = _data["keyName"];
            this.axNumber = _data["axNumber"];
        }
    }

    static fromJS(data: any): DeleteSecretDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteSecretDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyName"] = this.keyName;
        data["axNumber"] = this.axNumber;
        return data;
    }
}

export interface IDeleteSecretDto {
    keyName?: string | undefined;
    axNumber?: string | undefined;
}

export class GetSecretDto implements IGetSecretDto {
    keyName?: string | undefined;
    axNumber?: string | undefined;

    constructor(data?: IGetSecretDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keyName = _data["keyName"];
            this.axNumber = _data["axNumber"];
        }
    }

    static fromJS(data: any): GetSecretDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSecretDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyName"] = this.keyName;
        data["axNumber"] = this.axNumber;
        return data;
    }
}

export interface IGetSecretDto {
    keyName?: string | undefined;
    axNumber?: string | undefined;
}

export class AccountsPendingSelfServiceEnvironmentCreationDto implements IAccountsPendingSelfServiceEnvironmentCreationDto {
    accounts?: EnvironmentCreationAccountDetailsDto[] | undefined;

    constructor(data?: IAccountsPendingSelfServiceEnvironmentCreationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accounts"])) {
                this.accounts = [] as any;
                for (let item of _data["accounts"])
                    this.accounts!.push(EnvironmentCreationAccountDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccountsPendingSelfServiceEnvironmentCreationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountsPendingSelfServiceEnvironmentCreationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accounts)) {
            data["accounts"] = [];
            for (let item of this.accounts)
                data["accounts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAccountsPendingSelfServiceEnvironmentCreationDto {
    accounts?: EnvironmentCreationAccountDetailsDto[] | undefined;
}

export class ActiveSelfServiceIntegrationDto implements IActiveSelfServiceIntegrationDto {
    primaryAxNumber?: string | undefined;
    secondaryAxNumbers?: string[] | undefined;
    accountId?: number;
    workspaceId?: string;
    selfServiceEnvironmentId?: number;
    datasetCategories?: DatasetCategories[] | undefined;
    datasets?: SelfServiceDatasetDto[] | undefined;

    constructor(data?: IActiveSelfServiceIntegrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.primaryAxNumber = _data["primaryAxNumber"];
            if (Array.isArray(_data["secondaryAxNumbers"])) {
                this.secondaryAxNumbers = [] as any;
                for (let item of _data["secondaryAxNumbers"])
                    this.secondaryAxNumbers!.push(item);
            }
            this.accountId = _data["accountId"];
            this.workspaceId = _data["workspaceId"];
            this.selfServiceEnvironmentId = _data["selfServiceEnvironmentId"];
            if (Array.isArray(_data["datasetCategories"])) {
                this.datasetCategories = [] as any;
                for (let item of _data["datasetCategories"])
                    this.datasetCategories!.push(item);
            }
            if (Array.isArray(_data["datasets"])) {
                this.datasets = [] as any;
                for (let item of _data["datasets"])
                    this.datasets!.push(SelfServiceDatasetDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActiveSelfServiceIntegrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveSelfServiceIntegrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["primaryAxNumber"] = this.primaryAxNumber;
        if (Array.isArray(this.secondaryAxNumbers)) {
            data["secondaryAxNumbers"] = [];
            for (let item of this.secondaryAxNumbers)
                data["secondaryAxNumbers"].push(item);
        }
        data["accountId"] = this.accountId;
        data["workspaceId"] = this.workspaceId;
        data["selfServiceEnvironmentId"] = this.selfServiceEnvironmentId;
        if (Array.isArray(this.datasetCategories)) {
            data["datasetCategories"] = [];
            for (let item of this.datasetCategories)
                data["datasetCategories"].push(item);
        }
        if (Array.isArray(this.datasets)) {
            data["datasets"] = [];
            for (let item of this.datasets)
                data["datasets"].push(item.toJSON());
        }
        return data;
    }
}

export interface IActiveSelfServiceIntegrationDto {
    primaryAxNumber?: string | undefined;
    secondaryAxNumbers?: string[] | undefined;
    accountId?: number;
    workspaceId?: string;
    selfServiceEnvironmentId?: number;
    datasetCategories?: DatasetCategories[] | undefined;
    datasets?: SelfServiceDatasetDto[] | undefined;
}

export class EnvironmentCreationAccountDetailsDto implements IEnvironmentCreationAccountDetailsDto {
    accountId?: number;
    axAccount?: string | undefined;
    accountName?: string | undefined;

    constructor(data?: IEnvironmentCreationAccountDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.axAccount = _data["axAccount"];
            this.accountName = _data["accountName"];
        }
    }

    static fromJS(data: any): EnvironmentCreationAccountDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnvironmentCreationAccountDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["axAccount"] = this.axAccount;
        data["accountName"] = this.accountName;
        return data;
    }
}

export interface IEnvironmentCreationAccountDetailsDto {
    accountId?: number;
    axAccount?: string | undefined;
    accountName?: string | undefined;
}

export class SelfServiceDatasetDto implements ISelfServiceDatasetDto {
    selfServiceDatasetId?: number;
    selfServiceEnvironmentId?: number;
    datasetCategory?: DatasetCategories;
    datasetName?: string | undefined;
    pbiDatasetId?: string | undefined;

    constructor(data?: ISelfServiceDatasetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selfServiceDatasetId = _data["selfServiceDatasetId"];
            this.selfServiceEnvironmentId = _data["selfServiceEnvironmentId"];
            this.datasetCategory = _data["datasetCategory"];
            this.datasetName = _data["datasetName"];
            this.pbiDatasetId = _data["pbiDatasetId"];
        }
    }

    static fromJS(data: any): SelfServiceDatasetDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelfServiceDatasetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selfServiceDatasetId"] = this.selfServiceDatasetId;
        data["selfServiceEnvironmentId"] = this.selfServiceEnvironmentId;
        data["datasetCategory"] = this.datasetCategory;
        data["datasetName"] = this.datasetName;
        data["pbiDatasetId"] = this.pbiDatasetId;
        return data;
    }
}

export interface ISelfServiceDatasetDto {
    selfServiceDatasetId?: number;
    selfServiceEnvironmentId?: number;
    datasetCategory?: DatasetCategories;
    datasetName?: string | undefined;
    pbiDatasetId?: string | undefined;
}

export class SelfServiceDatasetRequest implements ISelfServiceDatasetRequest {
    accountId?: number;
    datasetCategory?: DatasetCategories;
    datasetId?: string;
    datasetName?: string | undefined;

    constructor(data?: ISelfServiceDatasetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.datasetCategory = _data["datasetCategory"];
            this.datasetId = _data["datasetId"];
            this.datasetName = _data["datasetName"];
        }
    }

    static fromJS(data: any): SelfServiceDatasetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SelfServiceDatasetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["datasetCategory"] = this.datasetCategory;
        data["datasetId"] = this.datasetId;
        data["datasetName"] = this.datasetName;
        return data;
    }
}

export interface ISelfServiceDatasetRequest {
    accountId?: number;
    datasetCategory?: DatasetCategories;
    datasetId?: string;
    datasetName?: string | undefined;
}

export class SelfServiceDatasetsDto implements ISelfServiceDatasetsDto {
    datasets?: SelfServiceDatasetDto[] | undefined;

    constructor(data?: ISelfServiceDatasetsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["datasets"])) {
                this.datasets = [] as any;
                for (let item of _data["datasets"])
                    this.datasets!.push(SelfServiceDatasetDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SelfServiceDatasetsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelfServiceDatasetsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datasets)) {
            data["datasets"] = [];
            for (let item of this.datasets)
                data["datasets"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISelfServiceDatasetsDto {
    datasets?: SelfServiceDatasetDto[] | undefined;
}

export class SelfServiceEnvironmentDto implements ISelfServiceEnvironmentDto {
    selfServiceEnvironmentId?: number;
    accountId?: number;
    workspaceId?: string;

    constructor(data?: ISelfServiceEnvironmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selfServiceEnvironmentId = _data["selfServiceEnvironmentId"];
            this.accountId = _data["accountId"];
            this.workspaceId = _data["workspaceId"];
        }
    }

    static fromJS(data: any): SelfServiceEnvironmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelfServiceEnvironmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selfServiceEnvironmentId"] = this.selfServiceEnvironmentId;
        data["accountId"] = this.accountId;
        data["workspaceId"] = this.workspaceId;
        return data;
    }
}

export interface ISelfServiceEnvironmentDto {
    selfServiceEnvironmentId?: number;
    accountId?: number;
    workspaceId?: string;
}

export class SelfServiceEnvironmentRequest implements ISelfServiceEnvironmentRequest {
    accountId?: number;
    workspaceId?: string;

    constructor(data?: ISelfServiceEnvironmentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.workspaceId = _data["workspaceId"];
        }
    }

    static fromJS(data: any): SelfServiceEnvironmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SelfServiceEnvironmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["workspaceId"] = this.workspaceId;
        return data;
    }
}

export interface ISelfServiceEnvironmentRequest {
    accountId?: number;
    workspaceId?: string;
}

export enum OnDemandLabDeploymentStatus {
    Deploying = "Deploying",
    Queued = "Queued",
    Active = "Active",
    Failed = "Failed",
    Destroyed = "Destroyed",
    Unknown = "Unknown",
}

export enum UserOnDemandLabRequestStatus {
    Pending = "Pending",
    Approved = "Approved",
    Denied = "Denied",
}

export class DownloadLabDocumentationByFileReference implements IDownloadLabDocumentationByFileReference {
    fileRef?: string | undefined;

    constructor(data?: IDownloadLabDocumentationByFileReference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileRef = _data["fileRef"];
        }
    }

    static fromJS(data: any): DownloadLabDocumentationByFileReference {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadLabDocumentationByFileReference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileRef"] = this.fileRef;
        return data;
    }
}

export interface IDownloadLabDocumentationByFileReference {
    fileRef?: string | undefined;
}

export class ServiceCatalogAccessResponse implements IServiceCatalogAccessResponse {
    success?: boolean;

    constructor(data?: IServiceCatalogAccessResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): ServiceCatalogAccessResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCatalogAccessResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface IServiceCatalogAccessResponse {
    success?: boolean;
}

export class BannerImageDto implements IBannerImageDto {
    labTitle?: string | undefined;
    imageSource?: string | undefined;

    constructor(data?: IBannerImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.labTitle = _data["labTitle"];
            this.imageSource = _data["imageSource"];
        }
    }

    static fromJS(data: any): BannerImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new BannerImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["labTitle"] = this.labTitle;
        data["imageSource"] = this.imageSource;
        return data;
    }
}

export interface IBannerImageDto {
    labTitle?: string | undefined;
    imageSource?: string | undefined;
}

export class DownloadLabDocumentationDto implements IDownloadLabDocumentationDto {
    file?: string | undefined;
    mimeType?: string | undefined;
    fileName?: string | undefined;

    constructor(data?: IDownloadLabDocumentationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.file = _data["file"];
            this.mimeType = _data["mimeType"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): DownloadLabDocumentationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadLabDocumentationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["file"] = this.file;
        data["mimeType"] = this.mimeType;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface IDownloadLabDocumentationDto {
    file?: string | undefined;
    mimeType?: string | undefined;
    fileName?: string | undefined;
}

export enum ELinkType {
    Article = "Article",
    Image = "Image",
    Video = "Video",
}

export class LabAccessRequestResponse implements ILabAccessRequestResponse {
    success?: boolean;

    constructor(data?: ILabAccessRequestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): LabAccessRequestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LabAccessRequestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface ILabAccessRequestResponse {
    success?: boolean;
}

export class LabDocumentationDto implements ILabDocumentationDto {
    labTitle?: string | undefined;
    documentationFileRef?: string | undefined;

    constructor(data?: ILabDocumentationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.labTitle = _data["labTitle"];
            this.documentationFileRef = _data["documentationFileRef"];
        }
    }

    static fromJS(data: any): LabDocumentationDto {
        data = typeof data === 'object' ? data : {};
        let result = new LabDocumentationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["labTitle"] = this.labTitle;
        data["documentationFileRef"] = this.documentationFileRef;
        return data;
    }
}

export interface ILabDocumentationDto {
    labTitle?: string | undefined;
    documentationFileRef?: string | undefined;
}

export class LabDto implements ILabDto {
    id?: number;
    productName?: string | undefined;
    uniqueId?: string | undefined;
    isOnDemandLab?: boolean;
    practice?: string[] | undefined;
    platform?: string[] | undefined;
    overview?: string | undefined;
    deliverables?: string | undefined;
    technology?: string | undefined;
    duration?: string | undefined;
    labLinks?: LabLinkDto[] | undefined;
    partners?: PartnerLogoDto[] | undefined;
    bannerImages?: BannerImageDto[] | undefined;
    documentation?: LabDocumentationDto[] | undefined;

    constructor(data?: ILabDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productName = _data["productName"];
            this.uniqueId = _data["uniqueId"];
            this.isOnDemandLab = _data["isOnDemandLab"];
            if (Array.isArray(_data["practice"])) {
                this.practice = [] as any;
                for (let item of _data["practice"])
                    this.practice!.push(item);
            }
            if (Array.isArray(_data["platform"])) {
                this.platform = [] as any;
                for (let item of _data["platform"])
                    this.platform!.push(item);
            }
            this.overview = _data["overview"];
            this.deliverables = _data["deliverables"];
            this.technology = _data["technology"];
            this.duration = _data["duration"];
            if (Array.isArray(_data["labLinks"])) {
                this.labLinks = [] as any;
                for (let item of _data["labLinks"])
                    this.labLinks!.push(LabLinkDto.fromJS(item));
            }
            if (Array.isArray(_data["partners"])) {
                this.partners = [] as any;
                for (let item of _data["partners"])
                    this.partners!.push(PartnerLogoDto.fromJS(item));
            }
            if (Array.isArray(_data["bannerImages"])) {
                this.bannerImages = [] as any;
                for (let item of _data["bannerImages"])
                    this.bannerImages!.push(BannerImageDto.fromJS(item));
            }
            if (Array.isArray(_data["documentation"])) {
                this.documentation = [] as any;
                for (let item of _data["documentation"])
                    this.documentation!.push(LabDocumentationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LabDto {
        data = typeof data === 'object' ? data : {};
        let result = new LabDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productName"] = this.productName;
        data["uniqueId"] = this.uniqueId;
        data["isOnDemandLab"] = this.isOnDemandLab;
        if (Array.isArray(this.practice)) {
            data["practice"] = [];
            for (let item of this.practice)
                data["practice"].push(item);
        }
        if (Array.isArray(this.platform)) {
            data["platform"] = [];
            for (let item of this.platform)
                data["platform"].push(item);
        }
        data["overview"] = this.overview;
        data["deliverables"] = this.deliverables;
        data["technology"] = this.technology;
        data["duration"] = this.duration;
        if (Array.isArray(this.labLinks)) {
            data["labLinks"] = [];
            for (let item of this.labLinks)
                data["labLinks"].push(item.toJSON());
        }
        if (Array.isArray(this.partners)) {
            data["partners"] = [];
            for (let item of this.partners)
                data["partners"].push(item.toJSON());
        }
        if (Array.isArray(this.bannerImages)) {
            data["bannerImages"] = [];
            for (let item of this.bannerImages)
                data["bannerImages"].push(item.toJSON());
        }
        if (Array.isArray(this.documentation)) {
            data["documentation"] = [];
            for (let item of this.documentation)
                data["documentation"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILabDto {
    id?: number;
    productName?: string | undefined;
    uniqueId?: string | undefined;
    isOnDemandLab?: boolean;
    practice?: string[] | undefined;
    platform?: string[] | undefined;
    overview?: string | undefined;
    deliverables?: string | undefined;
    technology?: string | undefined;
    duration?: string | undefined;
    labLinks?: LabLinkDto[] | undefined;
    partners?: PartnerLogoDto[] | undefined;
    bannerImages?: BannerImageDto[] | undefined;
    documentation?: LabDocumentationDto[] | undefined;
}

export class LabLinkDto implements ILabLinkDto {
    id?: number;
    linkCaption?: string | undefined;
    description?: string | undefined;
    link?: string | undefined;
    linkType?: ELinkType;

    constructor(data?: ILabLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.linkCaption = _data["linkCaption"];
            this.description = _data["description"];
            this.link = _data["link"];
            this.linkType = _data["linkType"];
        }
    }

    static fromJS(data: any): LabLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new LabLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["linkCaption"] = this.linkCaption;
        data["description"] = this.description;
        data["link"] = this.link;
        data["linkType"] = this.linkType;
        return data;
    }
}

export interface ILabLinkDto {
    id?: number;
    linkCaption?: string | undefined;
    description?: string | undefined;
    link?: string | undefined;
    linkType?: ELinkType;
}

export class LabLogoDto implements ILabLogoDto {
    image?: string | undefined;
    mimeType?: string | undefined;

    constructor(data?: ILabLogoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.image = _data["image"];
            this.mimeType = _data["mimeType"];
        }
    }

    static fromJS(data: any): LabLogoDto {
        data = typeof data === 'object' ? data : {};
        let result = new LabLogoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["image"] = this.image;
        data["mimeType"] = this.mimeType;
        return data;
    }
}

export interface ILabLogoDto {
    image?: string | undefined;
    mimeType?: string | undefined;
}

export class LabsOnDemandUserDto implements ILabsOnDemandUserDto {
    id?: string | undefined;
    username?: string | undefined;
    email?: string | undefined;
    env0Id?: string | undefined;

    protected _discriminator: string;

    constructor(data?: ILabsOnDemandUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "LabsOnDemandUserDto";
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.username = _data["username"];
            this.email = _data["email"];
            this.env0Id = _data["env0Id"];
        }
    }

    static fromJS(data: any): LabsOnDemandUserDto {
        data = typeof data === 'object' ? data : {};
        if (data["typeName"] === "UserLabsDto") {
            let result = new UserLabsDto();
            result.init(data);
            return result;
        }
        let result = new LabsOnDemandUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeName"] = this._discriminator;
        data["id"] = this.id;
        data["username"] = this.username;
        data["email"] = this.email;
        data["env0Id"] = this.env0Id;
        return data;
    }
}

export interface ILabsOnDemandUserDto {
    id?: string | undefined;
    username?: string | undefined;
    email?: string | undefined;
    env0Id?: string | undefined;
}

export class OnDemandLabDto implements IOnDemandLabDto {
    labId?: string | undefined;
    userId?: string | undefined;
    status?: string | undefined;
    createdUtc?: Date | undefined;
    envId?: string | undefined;
    siteId?: string | undefined;
    expirationUtc?: Date | undefined;

    constructor(data?: IOnDemandLabDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.labId = _data["labId"];
            this.userId = _data["userId"];
            this.status = _data["status"];
            this.createdUtc = _data["createdUtc"] ? new Date(_data["createdUtc"].toString()) : <any>undefined;
            this.envId = _data["envId"];
            this.siteId = _data["siteId"];
            this.expirationUtc = _data["expirationUtc"] ? new Date(_data["expirationUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OnDemandLabDto {
        data = typeof data === 'object' ? data : {};
        let result = new OnDemandLabDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["labId"] = this.labId;
        data["userId"] = this.userId;
        data["status"] = this.status;
        data["createdUtc"] = this.createdUtc ? this.createdUtc.toISOString() : <any>undefined;
        data["envId"] = this.envId;
        data["siteId"] = this.siteId;
        data["expirationUtc"] = this.expirationUtc ? this.expirationUtc.toISOString() : <any>undefined;
        return data;
    }
}

export interface IOnDemandLabDto {
    labId?: string | undefined;
    userId?: string | undefined;
    status?: string | undefined;
    createdUtc?: Date | undefined;
    envId?: string | undefined;
    siteId?: string | undefined;
    expirationUtc?: Date | undefined;
}

export class PartnerLogoDto implements IPartnerLogoDto {
    partner?: string | undefined;
    logo?: string | undefined;

    constructor(data?: IPartnerLogoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partner = _data["partner"];
            this.logo = _data["logo"];
        }
    }

    static fromJS(data: any): PartnerLogoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerLogoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partner"] = this.partner;
        data["logo"] = this.logo;
        return data;
    }
}

export interface IPartnerLogoDto {
    partner?: string | undefined;
    logo?: string | undefined;
}

export class ServiceCatalogDto implements IServiceCatalogDto {
    id?: number;
    productName?: string | undefined;
    uniqueId?: string | undefined;
    practice?: string[] | undefined;
    platform?: string[] | undefined;
    manufacturer?: string | undefined;
    category?: string | undefined;
    deliveryTeam?: string | undefined;
    projectType?: string | undefined;
    overview?: string | undefined;
    deliverables?: string | undefined;
    technology?: string | undefined;
    duration?: string | undefined;
    partners?: PartnerLogoDto[] | undefined;

    constructor(data?: IServiceCatalogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productName = _data["productName"];
            this.uniqueId = _data["uniqueId"];
            if (Array.isArray(_data["practice"])) {
                this.practice = [] as any;
                for (let item of _data["practice"])
                    this.practice!.push(item);
            }
            if (Array.isArray(_data["platform"])) {
                this.platform = [] as any;
                for (let item of _data["platform"])
                    this.platform!.push(item);
            }
            this.manufacturer = _data["manufacturer"];
            this.category = _data["category"];
            this.deliveryTeam = _data["deliveryTeam"];
            this.projectType = _data["projectType"];
            this.overview = _data["overview"];
            this.deliverables = _data["deliverables"];
            this.technology = _data["technology"];
            this.duration = _data["duration"];
            if (Array.isArray(_data["partners"])) {
                this.partners = [] as any;
                for (let item of _data["partners"])
                    this.partners!.push(PartnerLogoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ServiceCatalogDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCatalogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productName"] = this.productName;
        data["uniqueId"] = this.uniqueId;
        if (Array.isArray(this.practice)) {
            data["practice"] = [];
            for (let item of this.practice)
                data["practice"].push(item);
        }
        if (Array.isArray(this.platform)) {
            data["platform"] = [];
            for (let item of this.platform)
                data["platform"].push(item);
        }
        data["manufacturer"] = this.manufacturer;
        data["category"] = this.category;
        data["deliveryTeam"] = this.deliveryTeam;
        data["projectType"] = this.projectType;
        data["overview"] = this.overview;
        data["deliverables"] = this.deliverables;
        data["technology"] = this.technology;
        data["duration"] = this.duration;
        if (Array.isArray(this.partners)) {
            data["partners"] = [];
            for (let item of this.partners)
                data["partners"].push(item.toJSON());
        }
        return data;
    }
}

export interface IServiceCatalogDto {
    id?: number;
    productName?: string | undefined;
    uniqueId?: string | undefined;
    practice?: string[] | undefined;
    platform?: string[] | undefined;
    manufacturer?: string | undefined;
    category?: string | undefined;
    deliveryTeam?: string | undefined;
    projectType?: string | undefined;
    overview?: string | undefined;
    deliverables?: string | undefined;
    technology?: string | undefined;
    duration?: string | undefined;
    partners?: PartnerLogoDto[] | undefined;
}

export class UserLabsDto extends LabsOnDemandUserDto implements IUserLabsDto {
    labs?: OnDemandLabDto[] | undefined;

    constructor(data?: IUserLabsDto) {
        super(data);
        this._discriminator = "UserLabsDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["labs"])) {
                this.labs = [] as any;
                for (let item of _data["labs"])
                    this.labs!.push(OnDemandLabDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): UserLabsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLabsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.labs)) {
            data["labs"] = [];
            for (let item of this.labs)
                data["labs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUserLabsDto extends ILabsOnDemandUserDto {
    labs?: OnDemandLabDto[] | undefined;
}

export class UserOnDemandLabRequestDto implements IUserOnDemandLabRequestDto {
    accountName?: string | undefined;
    accountId?: number;
    userEmail?: string | undefined;
    requesterUsername?: string | undefined;
    labId?: number;
    labTitle?: string | undefined;
    labDeploymentStatus?: OnDemandLabDeploymentStatus;
    accountExecutive?: string | undefined;
    requesterUserId?: string | undefined;
    uniqueLabIdentifier?: string | undefined;
    requestDateUtc?: Date | undefined;
    status?: UserOnDemandLabRequestStatus;
    reviewedBy?: string | undefined;
    reviewDateUtc?: Date | undefined;

    constructor(data?: IUserOnDemandLabRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountName = _data["accountName"];
            this.accountId = _data["accountId"];
            this.userEmail = _data["userEmail"];
            this.requesterUsername = _data["requesterUsername"];
            this.labId = _data["labId"];
            this.labTitle = _data["labTitle"];
            this.labDeploymentStatus = _data["labDeploymentStatus"];
            this.accountExecutive = _data["accountExecutive"];
            this.requesterUserId = _data["requesterUserId"];
            this.uniqueLabIdentifier = _data["uniqueLabIdentifier"];
            this.requestDateUtc = _data["requestDateUtc"] ? new Date(_data["requestDateUtc"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.reviewedBy = _data["reviewedBy"];
            this.reviewDateUtc = _data["reviewDateUtc"] ? new Date(_data["reviewDateUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserOnDemandLabRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserOnDemandLabRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName;
        data["accountId"] = this.accountId;
        data["userEmail"] = this.userEmail;
        data["requesterUsername"] = this.requesterUsername;
        data["labId"] = this.labId;
        data["labTitle"] = this.labTitle;
        data["labDeploymentStatus"] = this.labDeploymentStatus;
        data["accountExecutive"] = this.accountExecutive;
        data["requesterUserId"] = this.requesterUserId;
        data["uniqueLabIdentifier"] = this.uniqueLabIdentifier;
        data["requestDateUtc"] = this.requestDateUtc ? this.requestDateUtc.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["reviewedBy"] = this.reviewedBy;
        data["reviewDateUtc"] = this.reviewDateUtc ? this.reviewDateUtc.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUserOnDemandLabRequestDto {
    accountName?: string | undefined;
    accountId?: number;
    userEmail?: string | undefined;
    requesterUsername?: string | undefined;
    labId?: number;
    labTitle?: string | undefined;
    labDeploymentStatus?: OnDemandLabDeploymentStatus;
    accountExecutive?: string | undefined;
    requesterUserId?: string | undefined;
    uniqueLabIdentifier?: string | undefined;
    requestDateUtc?: Date | undefined;
    status?: UserOnDemandLabRequestStatus;
    reviewedBy?: string | undefined;
    reviewDateUtc?: Date | undefined;
}

export class AirtableFileObject implements IAirtableFileObject {
    fileName?: string | undefined;
    contentType?: string | undefined;
    base64FileStream?: string | undefined;

    constructor(data?: IAirtableFileObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
            this.base64FileStream = _data["base64FileStream"];
        }
    }

    static fromJS(data: any): AirtableFileObject {
        data = typeof data === 'object' ? data : {};
        let result = new AirtableFileObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["base64FileStream"] = this.base64FileStream;
        return data;
    }
}

export interface IAirtableFileObject {
    fileName?: string | undefined;
    contentType?: string | undefined;
    base64FileStream?: string | undefined;
}

export class AttachmentDto implements IAttachmentDto {
    id?: number;
    dateUploaded?: Date;
    fileName?: string | undefined;
    fileSize?: number;
    fileType?: string | undefined;
    guid?: string | undefined;
    ticketId?: number | undefined;
    ticketNoteId?: number | undefined;
    url?: string | undefined;

    constructor(data?: IAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateUploaded = _data["dateUploaded"] ? new Date(_data["dateUploaded"].toString()) : <any>undefined;
            this.fileName = _data["fileName"];
            this.fileSize = _data["fileSize"];
            this.fileType = _data["fileType"];
            this.guid = _data["guid"];
            this.ticketId = _data["ticketId"];
            this.ticketNoteId = _data["ticketNoteId"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): AttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateUploaded"] = this.dateUploaded ? this.dateUploaded.toISOString() : <any>undefined;
        data["fileName"] = this.fileName;
        data["fileSize"] = this.fileSize;
        data["fileType"] = this.fileType;
        data["guid"] = this.guid;
        data["ticketId"] = this.ticketId;
        data["ticketNoteId"] = this.ticketNoteId;
        data["url"] = this.url;
        return data;
    }
}

export interface IAttachmentDto {
    id?: number;
    dateUploaded?: Date;
    fileName?: string | undefined;
    fileSize?: number;
    fileType?: string | undefined;
    guid?: string | undefined;
    ticketId?: number | undefined;
    ticketNoteId?: number | undefined;
    url?: string | undefined;
}

export class ContactDto implements IContactDto {
    id?: number;
    name?: string | undefined;
    email?: string | undefined;

    protected _discriminator: string;

    constructor(data?: IContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "ContactDto";
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ContactDto {
        data = typeof data === 'object' ? data : {};
        if (data["typeName"] === "ContactDtoWithServiceRequestIdAndAxNumber") {
            let result = new ContactDtoWithServiceRequestIdAndAxNumber();
            result.init(data);
            return result;
        }
        let result = new ContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeName"] = this._discriminator;
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        return data;
    }
}

export interface IContactDto {
    id?: number;
    name?: string | undefined;
    email?: string | undefined;
}

export class ContactDtoWithServiceRequestIdAndAxNumber extends ContactDto implements IContactDtoWithServiceRequestIdAndAxNumber {
    serviceRequestId?: number;
    axAccountNumber?: string | undefined;
    accountId?: number;

    constructor(data?: IContactDtoWithServiceRequestIdAndAxNumber) {
        super(data);
        this._discriminator = "ContactDtoWithServiceRequestIdAndAxNumber";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.serviceRequestId = _data["serviceRequestId"];
            this.axAccountNumber = _data["axAccountNumber"];
            this.accountId = _data["accountId"];
        }
    }

    static override fromJS(data: any): ContactDtoWithServiceRequestIdAndAxNumber {
        data = typeof data === 'object' ? data : {};
        let result = new ContactDtoWithServiceRequestIdAndAxNumber();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceRequestId"] = this.serviceRequestId;
        data["axAccountNumber"] = this.axAccountNumber;
        data["accountId"] = this.accountId;
        super.toJSON(data);
        return data;
    }
}

export interface IContactDtoWithServiceRequestIdAndAxNumber extends IContactDto {
    serviceRequestId?: number;
    axAccountNumber?: string | undefined;
    accountId?: number;
}

export enum ServiceRequestActionType {
    Save = "Save",
    Close = "Close",
    PlaceOnHold = "PlaceOnHold",
    RemoveHold = "RemoveHold",
    Reject = "Reject",
}

export class ServiceRequestDetailsDto implements IServiceRequestDetailsDto {
    id?: number;
    requestIdentifier?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    secondaryContacts?: ContactDto[] | undefined;
    surveyRating?: number | undefined;
    preferredContactMethod?: string | undefined;
    status?: string | undefined;
    severity?: string | undefined;
    category?: string | undefined;
    issue?: string | undefined;
    cloudAccount?: string | undefined;
    accountId?: number;
    createdBy?: string | undefined;
    createdByContactId?: number | undefined;
    assignedTo?: string | undefined;
    createdDate?: Date;
    lastModifiedDate?: Date;
    completedDate?: Date;
    messages?: ServiceRequestMessageDto[] | undefined;
    attachments?: AttachmentDto[] | undefined;
    serviceRequestMapping?: ServiceRequestMappingDto;
    availableActions?: ServiceRequestActionType[] | undefined;
    showFormWhenViewing?: boolean;
    onboardingState?: ServiceRequestState;
    ticketId?: number;

    constructor(data?: IServiceRequestDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.requestIdentifier = _data["requestIdentifier"];
            this.title = _data["title"];
            this.description = _data["description"];
            if (Array.isArray(_data["secondaryContacts"])) {
                this.secondaryContacts = [] as any;
                for (let item of _data["secondaryContacts"])
                    this.secondaryContacts!.push(ContactDto.fromJS(item));
            }
            this.surveyRating = _data["surveyRating"];
            this.preferredContactMethod = _data["preferredContactMethod"];
            this.status = _data["status"];
            this.severity = _data["severity"];
            this.category = _data["category"];
            this.issue = _data["issue"];
            this.cloudAccount = _data["cloudAccount"];
            this.accountId = _data["accountId"];
            this.createdBy = _data["createdBy"];
            this.createdByContactId = _data["createdByContactId"];
            this.assignedTo = _data["assignedTo"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            this.completedDate = _data["completedDate"] ? new Date(_data["completedDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(ServiceRequestMessageDto.fromJS(item));
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
            this.serviceRequestMapping = _data["serviceRequestMapping"] ? ServiceRequestMappingDto.fromJS(_data["serviceRequestMapping"]) : <any>undefined;
            if (Array.isArray(_data["availableActions"])) {
                this.availableActions = [] as any;
                for (let item of _data["availableActions"])
                    this.availableActions!.push(item);
            }
            this.showFormWhenViewing = _data["showFormWhenViewing"];
            this.onboardingState = _data["onboardingState"];
            this.ticketId = _data["ticketId"];
        }
    }

    static fromJS(data: any): ServiceRequestDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["requestIdentifier"] = this.requestIdentifier;
        data["title"] = this.title;
        data["description"] = this.description;
        if (Array.isArray(this.secondaryContacts)) {
            data["secondaryContacts"] = [];
            for (let item of this.secondaryContacts)
                data["secondaryContacts"].push(item.toJSON());
        }
        data["surveyRating"] = this.surveyRating;
        data["preferredContactMethod"] = this.preferredContactMethod;
        data["status"] = this.status;
        data["severity"] = this.severity;
        data["category"] = this.category;
        data["issue"] = this.issue;
        data["cloudAccount"] = this.cloudAccount;
        data["accountId"] = this.accountId;
        data["createdBy"] = this.createdBy;
        data["createdByContactId"] = this.createdByContactId;
        data["assignedTo"] = this.assignedTo;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["completedDate"] = this.completedDate ? this.completedDate.toISOString() : <any>undefined;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["serviceRequestMapping"] = this.serviceRequestMapping ? this.serviceRequestMapping.toJSON() : <any>undefined;
        if (Array.isArray(this.availableActions)) {
            data["availableActions"] = [];
            for (let item of this.availableActions)
                data["availableActions"].push(item);
        }
        data["showFormWhenViewing"] = this.showFormWhenViewing;
        data["onboardingState"] = this.onboardingState;
        data["ticketId"] = this.ticketId;
        return data;
    }
}

export interface IServiceRequestDetailsDto {
    id?: number;
    requestIdentifier?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    secondaryContacts?: ContactDto[] | undefined;
    surveyRating?: number | undefined;
    preferredContactMethod?: string | undefined;
    status?: string | undefined;
    severity?: string | undefined;
    category?: string | undefined;
    issue?: string | undefined;
    cloudAccount?: string | undefined;
    accountId?: number;
    createdBy?: string | undefined;
    createdByContactId?: number | undefined;
    assignedTo?: string | undefined;
    createdDate?: Date;
    lastModifiedDate?: Date;
    completedDate?: Date;
    messages?: ServiceRequestMessageDto[] | undefined;
    attachments?: AttachmentDto[] | undefined;
    serviceRequestMapping?: ServiceRequestMappingDto;
    availableActions?: ServiceRequestActionType[] | undefined;
    showFormWhenViewing?: boolean;
    onboardingState?: ServiceRequestState;
    ticketId?: number;
}

export class ServiceRequestMappingDto implements IServiceRequestMappingDto {
    formSchema?: string | undefined;
    formUiSchema?: string | undefined;
    rules?: string | undefined;

    constructor(data?: IServiceRequestMappingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formSchema = _data["formSchema"];
            this.formUiSchema = _data["formUiSchema"];
            this.rules = _data["rules"];
        }
    }

    static fromJS(data: any): ServiceRequestMappingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestMappingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formSchema"] = this.formSchema;
        data["formUiSchema"] = this.formUiSchema;
        data["rules"] = this.rules;
        return data;
    }
}

export interface IServiceRequestMappingDto {
    formSchema?: string | undefined;
    formUiSchema?: string | undefined;
    rules?: string | undefined;
}

export class ServiceRequestMessageDto implements IServiceRequestMessageDto {
    id?: number;
    serviceRequestId?: number;
    author?: string | undefined;
    message?: string | undefined;
    lastActivityDate?: Date;
    attachments?: AttachmentDto[] | undefined;

    constructor(data?: IServiceRequestMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceRequestId = _data["serviceRequestId"];
            this.author = _data["author"];
            this.message = _data["message"];
            this.lastActivityDate = _data["lastActivityDate"] ? new Date(_data["lastActivityDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ServiceRequestMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceRequestId"] = this.serviceRequestId;
        data["author"] = this.author;
        data["message"] = this.message;
        data["lastActivityDate"] = this.lastActivityDate ? this.lastActivityDate.toISOString() : <any>undefined;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IServiceRequestMessageDto {
    id?: number;
    serviceRequestId?: number;
    author?: string | undefined;
    message?: string | undefined;
    lastActivityDate?: Date;
    attachments?: AttachmentDto[] | undefined;
}

export enum ServiceRequestState {
    New = "New",
    Open = "Open",
    Closed = "Closed",
    Rejected = "Rejected",
}

export class ReservationPurchaseResult implements IReservationPurchaseResult {
    payerAccountId?: string | undefined;
    reservationPurchaseRecommendation?: ReservationPurchaseRecommendation[] | undefined;

    constructor(data?: IReservationPurchaseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payerAccountId = _data["payerAccountId"];
            if (Array.isArray(_data["reservationPurchaseRecommendation"])) {
                this.reservationPurchaseRecommendation = [] as any;
                for (let item of _data["reservationPurchaseRecommendation"])
                    this.reservationPurchaseRecommendation!.push(ReservationPurchaseRecommendation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReservationPurchaseResult {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationPurchaseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payerAccountId"] = this.payerAccountId;
        if (Array.isArray(this.reservationPurchaseRecommendation)) {
            data["reservationPurchaseRecommendation"] = [];
            for (let item of this.reservationPurchaseRecommendation)
                data["reservationPurchaseRecommendation"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReservationPurchaseResult {
    payerAccountId?: string | undefined;
    reservationPurchaseRecommendation?: ReservationPurchaseRecommendation[] | undefined;
}

export class RightSizingResult implements IRightSizingResult {
    payerAccountId?: string | undefined;
    rightSizingRecommendations?: RightsizingRecommendation[] | undefined;

    constructor(data?: IRightSizingResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payerAccountId = _data["payerAccountId"];
            if (Array.isArray(_data["rightSizingRecommendations"])) {
                this.rightSizingRecommendations = [] as any;
                for (let item of _data["rightSizingRecommendations"])
                    this.rightSizingRecommendations!.push(RightsizingRecommendation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RightSizingResult {
        data = typeof data === 'object' ? data : {};
        let result = new RightSizingResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payerAccountId"] = this.payerAccountId;
        if (Array.isArray(this.rightSizingRecommendations)) {
            data["rightSizingRecommendations"] = [];
            for (let item of this.rightSizingRecommendations)
                data["rightSizingRecommendations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRightSizingResult {
    payerAccountId?: string | undefined;
    rightSizingRecommendations?: RightsizingRecommendation[] | undefined;
}

export class SavingsPlansPurchaseResult implements ISavingsPlansPurchaseResult {
    payerAccountId?: string | undefined;
    savingsPlansPurchaseRecommendations?: SavingsPlansPurchaseRecommendation[] | undefined;

    constructor(data?: ISavingsPlansPurchaseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payerAccountId = _data["payerAccountId"];
            if (Array.isArray(_data["savingsPlansPurchaseRecommendations"])) {
                this.savingsPlansPurchaseRecommendations = [] as any;
                for (let item of _data["savingsPlansPurchaseRecommendations"])
                    this.savingsPlansPurchaseRecommendations!.push(SavingsPlansPurchaseRecommendation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SavingsPlansPurchaseResult {
        data = typeof data === 'object' ? data : {};
        let result = new SavingsPlansPurchaseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payerAccountId"] = this.payerAccountId;
        if (Array.isArray(this.savingsPlansPurchaseRecommendations)) {
            data["savingsPlansPurchaseRecommendations"] = [];
            for (let item of this.savingsPlansPurchaseRecommendations)
                data["savingsPlansPurchaseRecommendations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISavingsPlansPurchaseResult {
    payerAccountId?: string | undefined;
    savingsPlansPurchaseRecommendations?: SavingsPlansPurchaseRecommendation[] | undefined;
}

export class TestConsumerResult implements ITestConsumerResult {
    id?: number;
    description?: string | undefined;

    constructor(data?: ITestConsumerResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): TestConsumerResult {
        data = typeof data === 'object' ? data : {};
        let result = new TestConsumerResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }
}

export interface ITestConsumerResult {
    id?: number;
    description?: string | undefined;
}

export class TrustedAdvisorResult implements ITrustedAdvisorResult {
    payerAccountId?: string | undefined;
    linkedAccountId?: string | undefined;
    trustedAdvisorRecommendations?: TrustedAdvisorComposite[] | undefined;

    constructor(data?: ITrustedAdvisorResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payerAccountId = _data["payerAccountId"];
            this.linkedAccountId = _data["linkedAccountId"];
            if (Array.isArray(_data["trustedAdvisorRecommendations"])) {
                this.trustedAdvisorRecommendations = [] as any;
                for (let item of _data["trustedAdvisorRecommendations"])
                    this.trustedAdvisorRecommendations!.push(TrustedAdvisorComposite.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TrustedAdvisorResult {
        data = typeof data === 'object' ? data : {};
        let result = new TrustedAdvisorResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payerAccountId"] = this.payerAccountId;
        data["linkedAccountId"] = this.linkedAccountId;
        if (Array.isArray(this.trustedAdvisorRecommendations)) {
            data["trustedAdvisorRecommendations"] = [];
            for (let item of this.trustedAdvisorRecommendations)
                data["trustedAdvisorRecommendations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITrustedAdvisorResult {
    payerAccountId?: string | undefined;
    linkedAccountId?: string | undefined;
    trustedAdvisorRecommendations?: TrustedAdvisorComposite[] | undefined;
}

export class AccountSearchQuery implements IAccountSearchQuery {
    searchString?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    orderBy?: string | undefined;
    descending?: boolean;
    impersonateOnly?: boolean;
    includeAccountExec?: boolean;
    successPlanId?: number;
    shiOneStatus?: AccountStatus;

    constructor(data?: IAccountSearchQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchString = _data["searchString"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.orderBy = _data["orderBy"];
            this.descending = _data["descending"];
            this.impersonateOnly = _data["impersonateOnly"];
            this.includeAccountExec = _data["includeAccountExec"];
            this.successPlanId = _data["successPlanId"];
            this.shiOneStatus = _data["shiOneStatus"];
        }
    }

    static fromJS(data: any): AccountSearchQuery {
        data = typeof data === 'object' ? data : {};
        let result = new AccountSearchQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchString"] = this.searchString;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["orderBy"] = this.orderBy;
        data["descending"] = this.descending;
        data["impersonateOnly"] = this.impersonateOnly;
        data["includeAccountExec"] = this.includeAccountExec;
        data["successPlanId"] = this.successPlanId;
        data["shiOneStatus"] = this.shiOneStatus;
        return data;
    }
}

export interface IAccountSearchQuery {
    searchString?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    orderBy?: string | undefined;
    descending?: boolean;
    impersonateOnly?: boolean;
    includeAccountExec?: boolean;
    successPlanId?: number;
    shiOneStatus?: AccountStatus;
}

export enum AccountStatus {
    None = "None",
    NotConfigured = "NotConfigured",
    Pending = "Pending",
    Unhealthy = "Unhealthy",
    Healthy = "Healthy",
}

export enum IntegrationGroup {
    Other = "Other",
    Assets = "Assets",
    Cloud = "Cloud",
    Assessments = "Assessments",
}

export enum IntegrationType {
    Unknown = "Unknown",
    AwsCompliance = "AwsCompliance",
    AzureCompliance = "AzureCompliance",
    Unknown2 = "Unknown2",
    AzurePlanReport = "AzurePlanReport",
    AwsSimpleRecommendations = "AwsSimpleRecommendations",
    AwsBillingReport = "AwsBillingReport",
    AzureSimpleRecommendations = "AzureSimpleRecommendations",
    AzureBackups = "AzureBackups",
    RackAndStack = "RackAndStack",
    CiscoSNTC = "CiscoSNTC",
    GcpUsageReport = "GcpUsageReport",
    CiscoReadyReport = "CiscoReadyReport",
    AzureDirectConsumption = "AzureDirectConsumption",
    DatadogUsageReport = "DatadogUsageReport",
    DattoRMM = "DattoRMM",
    AzureDevOpsReport = "AzureDevOpsReport",
    CiscoContractCoverage = "CiscoContractCoverage",
    IdcsReport = "IdcsReport",
    HardwareLifecycleManagement = "HardwareLifecycleManagement",
    AwsGovernanceReports = "AwsGovernanceReports",
    CiscoMeraki = "CiscoMeraki",
    AssetManagement = "AssetManagement",
    CiscoSubscriptionManagement = "CiscoSubscriptionManagement",
    CiscoEnterpriseAgreement = "CiscoEnterpriseAgreement",
    AzureGovernanceReports = "AzureGovernanceReports",
    SelfServiceReporting = "SelfServiceReporting",
    AzureResourceGraph = "AzureResourceGraph",
    AwsResourceExplorer = "AwsResourceExplorer",
    GcpCloudAssetInventory = "GcpCloudAssetInventory",
    Catalyst = "Catalyst",
    SecurityPostureReview = "SecurityPostureReview",
    AIReadiness = "AIReadiness",
    InstallBaseAnalysis = "InstallBaseAnalysis",
    LiveOptics = "LiveOptics",
    MicrosoftAdoptionAssessment = "MicrosoftAdoptionAssessment",
    Microsoft365Reports = "Microsoft365Reports",
    DevOpsPostureReview = "DevOpsPostureReview",
    AzureAssetConnection = "AzureAssetConnection",
    AzureCostAndUsageConnection = "AzureCostAndUsageConnection",
    CiscoMerakiCustomer = "CiscoMerakiCustomer",
    AwsMaturity = "AwsMaturity",
}

export class TrustedAdvisorComposite implements ITrustedAdvisorComposite {
    description?: TrustedAdvisorCheckDescription;
    summary?: TrustedAdvisorCheckSummary;
    result?: TrustedAdvisorCheckResult;

    constructor(data?: ITrustedAdvisorComposite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"] ? TrustedAdvisorCheckDescription.fromJS(_data["description"]) : <any>undefined;
            this.summary = _data["summary"] ? TrustedAdvisorCheckSummary.fromJS(_data["summary"]) : <any>undefined;
            this.result = _data["result"] ? TrustedAdvisorCheckResult.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TrustedAdvisorComposite {
        data = typeof data === 'object' ? data : {};
        let result = new TrustedAdvisorComposite();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description ? this.description.toJSON() : <any>undefined;
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITrustedAdvisorComposite {
    description?: TrustedAdvisorCheckDescription;
    summary?: TrustedAdvisorCheckSummary;
    result?: TrustedAdvisorCheckResult;
}

export class UserConfigDto implements IUserConfigDto {
    entityId?: string | undefined;
    settingsKey?: string | undefined;
    settingsValue?: string | undefined;
    lastUpdatedUtc?: Date;

    constructor(data?: IUserConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            this.settingsKey = _data["settingsKey"];
            this.settingsValue = _data["settingsValue"];
            this.lastUpdatedUtc = _data["lastUpdatedUtc"] ? new Date(_data["lastUpdatedUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        data["settingsKey"] = this.settingsKey;
        data["settingsValue"] = this.settingsValue;
        data["lastUpdatedUtc"] = this.lastUpdatedUtc ? this.lastUpdatedUtc.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUserConfigDto {
    entityId?: string | undefined;
    settingsKey?: string | undefined;
    settingsValue?: string | undefined;
    lastUpdatedUtc?: Date;
}

export class DeleteGuestUserRequest implements IDeleteGuestUserRequest {
    accountId?: number;
    id?: number;

    constructor(data?: IDeleteGuestUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteGuestUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteGuestUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteGuestUserRequest {
    accountId?: number;
    id?: number;
}

export class UpdateGuestUsersRequest implements IUpdateGuestUsersRequest {
    accountId?: number;
    emailAddresses?: string[] | undefined;
    permissions?: GuestPermissionStatementDto[] | undefined;

    constructor(data?: IUpdateGuestUsersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            if (Array.isArray(_data["emailAddresses"])) {
                this.emailAddresses = [] as any;
                for (let item of _data["emailAddresses"])
                    this.emailAddresses!.push(item);
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(GuestPermissionStatementDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateGuestUsersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGuestUsersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        if (Array.isArray(this.emailAddresses)) {
            data["emailAddresses"] = [];
            for (let item of this.emailAddresses)
                data["emailAddresses"].push(item);
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateGuestUsersRequest {
    accountId?: number;
    emailAddresses?: string[] | undefined;
    permissions?: GuestPermissionStatementDto[] | undefined;
}

export class GuestPermissionStatementDto implements IGuestPermissionStatementDto {
    action?: string[] | undefined;
    resource?: string | undefined;

    constructor(data?: IGuestPermissionStatementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["action"])) {
                this.action = [] as any;
                for (let item of _data["action"])
                    this.action!.push(item);
            }
            this.resource = _data["resource"];
        }
    }

    static fromJS(data: any): GuestPermissionStatementDto {
        data = typeof data === 'object' ? data : {};
        let result = new GuestPermissionStatementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.action)) {
            data["action"] = [];
            for (let item of this.action)
                data["action"].push(item);
        }
        data["resource"] = this.resource;
        return data;
    }
}

export interface IGuestPermissionStatementDto {
    action?: string[] | undefined;
    resource?: string | undefined;
}

export class GuestPermissionsDisplayDto implements IGuestPermissionsDisplayDto {
    action?: ActionDto[] | undefined;
    resourceDisplayName?: string | undefined;
    resource?: string | undefined;

    constructor(data?: IGuestPermissionsDisplayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["action"])) {
                this.action = [] as any;
                for (let item of _data["action"])
                    this.action!.push(ActionDto.fromJS(item));
            }
            this.resourceDisplayName = _data["resourceDisplayName"];
            this.resource = _data["resource"];
        }
    }

    static fromJS(data: any): GuestPermissionsDisplayDto {
        data = typeof data === 'object' ? data : {};
        let result = new GuestPermissionsDisplayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.action)) {
            data["action"] = [];
            for (let item of this.action)
                data["action"].push(item.toJSON());
        }
        data["resourceDisplayName"] = this.resourceDisplayName;
        data["resource"] = this.resource;
        return data;
    }
}

export interface IGuestPermissionsDisplayDto {
    action?: ActionDto[] | undefined;
    resourceDisplayName?: string | undefined;
    resource?: string | undefined;
}

export class GuestUserWithPermissions implements IGuestUserWithPermissions {
    userProfileId?: number;
    accountId?: number | undefined;
    emailAddress?: string | undefined;
    permissions?: GuestPermissionsDisplayDto[] | undefined;

    constructor(data?: IGuestUserWithPermissions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userProfileId = _data["userProfileId"];
            this.accountId = _data["accountId"];
            this.emailAddress = _data["emailAddress"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(GuestPermissionsDisplayDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GuestUserWithPermissions {
        data = typeof data === 'object' ? data : {};
        let result = new GuestUserWithPermissions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userProfileId"] = this.userProfileId;
        data["accountId"] = this.accountId;
        data["emailAddress"] = this.emailAddress;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGuestUserWithPermissions {
    userProfileId?: number;
    accountId?: number | undefined;
    emailAddress?: string | undefined;
    permissions?: GuestPermissionsDisplayDto[] | undefined;
}

export class AccountTeamReponse implements IAccountTeamReponse {
    teamsEnabled?: boolean;
    isGlobalAdmin?: boolean;
    teams?: Team[] | undefined;
    ticketCategoryMappings?: TicketCategoryMapping[] | undefined;
    contractSLAs?: ContractSLA[] | undefined;

    constructor(data?: IAccountTeamReponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamsEnabled = _data["teamsEnabled"];
            this.isGlobalAdmin = _data["isGlobalAdmin"];
            if (Array.isArray(_data["teams"])) {
                this.teams = [] as any;
                for (let item of _data["teams"])
                    this.teams!.push(Team.fromJS(item));
            }
            if (Array.isArray(_data["ticketCategoryMappings"])) {
                this.ticketCategoryMappings = [] as any;
                for (let item of _data["ticketCategoryMappings"])
                    this.ticketCategoryMappings!.push(TicketCategoryMapping.fromJS(item));
            }
            if (Array.isArray(_data["contractSLAs"])) {
                this.contractSLAs = [] as any;
                for (let item of _data["contractSLAs"])
                    this.contractSLAs!.push(ContractSLA.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccountTeamReponse {
        data = typeof data === 'object' ? data : {};
        let result = new AccountTeamReponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamsEnabled"] = this.teamsEnabled;
        data["isGlobalAdmin"] = this.isGlobalAdmin;
        if (Array.isArray(this.teams)) {
            data["teams"] = [];
            for (let item of this.teams)
                data["teams"].push(item.toJSON());
        }
        if (Array.isArray(this.ticketCategoryMappings)) {
            data["ticketCategoryMappings"] = [];
            for (let item of this.ticketCategoryMappings)
                data["ticketCategoryMappings"].push(item.toJSON());
        }
        if (Array.isArray(this.contractSLAs)) {
            data["contractSLAs"] = [];
            for (let item of this.contractSLAs)
                data["contractSLAs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAccountTeamReponse {
    teamsEnabled?: boolean;
    isGlobalAdmin?: boolean;
    teams?: Team[] | undefined;
    ticketCategoryMappings?: TicketCategoryMapping[] | undefined;
    contractSLAs?: ContractSLA[] | undefined;
}

export class AddConfigItems implements IAddConfigItems {
    teamId?: number;
    configItemIds?: number[] | undefined;

    constructor(data?: IAddConfigItems) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamId = _data["teamId"];
            if (Array.isArray(_data["configItemIds"])) {
                this.configItemIds = [] as any;
                for (let item of _data["configItemIds"])
                    this.configItemIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AddConfigItems {
        data = typeof data === 'object' ? data : {};
        let result = new AddConfigItems();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamId"] = this.teamId;
        if (Array.isArray(this.configItemIds)) {
            data["configItemIds"] = [];
            for (let item of this.configItemIds)
                data["configItemIds"].push(item);
        }
        return data;
    }
}

export interface IAddConfigItems {
    teamId?: number;
    configItemIds?: number[] | undefined;
}

export class AddContacts implements IAddContacts {
    teamId?: number;
    contacts?: number[] | undefined;

    constructor(data?: IAddContacts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamId = _data["teamId"];
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(item);
            }
        }
    }

    static fromJS(data: any): AddContacts {
        data = typeof data === 'object' ? data : {};
        let result = new AddContacts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamId"] = this.teamId;
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item);
        }
        return data;
    }
}

export interface IAddContacts {
    teamId?: number;
    contacts?: number[] | undefined;
}

export class AddContracts implements IAddContracts {
    teamId?: number;
    contracts?: number[] | undefined;

    constructor(data?: IAddContracts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamId = _data["teamId"];
            if (Array.isArray(_data["contracts"])) {
                this.contracts = [] as any;
                for (let item of _data["contracts"])
                    this.contracts!.push(item);
            }
        }
    }

    static fromJS(data: any): AddContracts {
        data = typeof data === 'object' ? data : {};
        let result = new AddContracts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamId"] = this.teamId;
        if (Array.isArray(this.contracts)) {
            data["contracts"] = [];
            for (let item of this.contracts)
                data["contracts"].push(item);
        }
        return data;
    }
}

export interface IAddContracts {
    teamId?: number;
    contracts?: number[] | undefined;
}

export class AddTicketCategoryMappings implements IAddTicketCategoryMappings {
    teamId?: number;
    contractMapping?: TeamTicketCategoryMappingTemp[] | undefined;

    constructor(data?: IAddTicketCategoryMappings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamId = _data["teamId"];
            if (Array.isArray(_data["contractMapping"])) {
                this.contractMapping = [] as any;
                for (let item of _data["contractMapping"])
                    this.contractMapping!.push(TeamTicketCategoryMappingTemp.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddTicketCategoryMappings {
        data = typeof data === 'object' ? data : {};
        let result = new AddTicketCategoryMappings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamId"] = this.teamId;
        if (Array.isArray(this.contractMapping)) {
            data["contractMapping"] = [];
            for (let item of this.contractMapping)
                data["contractMapping"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAddTicketCategoryMappings {
    teamId?: number;
    contractMapping?: TeamTicketCategoryMappingTemp[] | undefined;
}

export class CurrentPrefix implements ICurrentPrefix {
    prefix?: string | undefined;

    constructor(data?: ICurrentPrefix) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prefix = _data["prefix"];
        }
    }

    static fromJS(data: any): CurrentPrefix {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentPrefix();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prefix"] = this.prefix;
        return data;
    }
}

export interface ICurrentPrefix {
    prefix?: string | undefined;
}

export class FileUploadResponse implements IFileUploadResponse {
    url?: string | undefined;
    errorMessage?: string | undefined;

    constructor(data?: IFileUploadResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): FileUploadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IFileUploadResponse {
    url?: string | undefined;
    errorMessage?: string | undefined;
}

export class EventsController_BroadcastModel implements IEventsController_BroadcastModel {
    workflow?: string | undefined;
    eventData?: any | undefined;

    constructor(data?: IEventsController_BroadcastModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workflow = _data["workflow"];
            this.eventData = _data["eventData"];
        }
    }

    static fromJS(data: any): EventsController_BroadcastModel {
        data = typeof data === 'object' ? data : {};
        let result = new EventsController_BroadcastModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workflow"] = this.workflow;
        data["eventData"] = this.eventData;
        return data;
    }
}

export interface IEventsController_BroadcastModel {
    workflow?: string | undefined;
    eventData?: any | undefined;
}

export class RenameTeamObject implements IRenameTeamObject {
    teamId?: number;
    name?: string | undefined;

    constructor(data?: IRenameTeamObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamId = _data["teamId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RenameTeamObject {
        data = typeof data === 'object' ? data : {};
        let result = new RenameTeamObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamId"] = this.teamId;
        data["name"] = this.name;
        return data;
    }
}

export interface IRenameTeamObject {
    teamId?: number;
    name?: string | undefined;
}

export class SetUserRole implements ISetUserRole {
    teamId?: number;
    contactId?: number;
    roleId?: number;

    constructor(data?: ISetUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamId = _data["teamId"];
            this.contactId = _data["contactId"];
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): SetUserRole {
        data = typeof data === 'object' ? data : {};
        let result = new SetUserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamId"] = this.teamId;
        data["contactId"] = this.contactId;
        data["roleId"] = this.roleId;
        return data;
    }
}

export interface ISetUserRole {
    teamId?: number;
    contactId?: number;
    roleId?: number;
}

export class TeamTicketCategoryMappingTemp implements ITeamTicketCategoryMappingTemp {
    teamId?: number;
    ticketCategoryMappingId?: number;
    contractId?: number;
    enabledIssueType?: string | undefined;

    constructor(data?: ITeamTicketCategoryMappingTemp) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamId = _data["teamId"];
            this.ticketCategoryMappingId = _data["ticketCategoryMappingId"];
            this.contractId = _data["contractId"];
            this.enabledIssueType = _data["enabledIssueType"];
        }
    }

    static fromJS(data: any): TeamTicketCategoryMappingTemp {
        data = typeof data === 'object' ? data : {};
        let result = new TeamTicketCategoryMappingTemp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamId"] = this.teamId;
        data["ticketCategoryMappingId"] = this.ticketCategoryMappingId;
        data["contractId"] = this.contractId;
        data["enabledIssueType"] = this.enabledIssueType;
        return data;
    }
}

export interface ITeamTicketCategoryMappingTemp {
    teamId?: number;
    ticketCategoryMappingId?: number;
    contractId?: number;
    enabledIssueType?: string | undefined;
}

export class WhiteLabelResult implements IWhiteLabelResult {
    defaultSet?: boolean;
    subDomain?: string | undefined;
    logoUrl?: string | undefined;
    landingTitle?: string | undefined;
    topLeftTitle?: string | undefined;
    welcomeMessage?: string | undefined;
    hasError?: boolean;
    errorMessage?: string | undefined;
    accountName?: string | undefined;

    constructor(data?: IWhiteLabelResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultSet = _data["defaultSet"];
            this.subDomain = _data["subDomain"];
            this.logoUrl = _data["logoUrl"];
            this.landingTitle = _data["landingTitle"];
            this.topLeftTitle = _data["topLeftTitle"];
            this.welcomeMessage = _data["welcomeMessage"];
            this.hasError = _data["hasError"];
            this.errorMessage = _data["errorMessage"];
            this.accountName = _data["accountName"];
        }
    }

    static fromJS(data: any): WhiteLabelResult {
        data = typeof data === 'object' ? data : {};
        let result = new WhiteLabelResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultSet"] = this.defaultSet;
        data["subDomain"] = this.subDomain;
        data["logoUrl"] = this.logoUrl;
        data["landingTitle"] = this.landingTitle;
        data["topLeftTitle"] = this.topLeftTitle;
        data["welcomeMessage"] = this.welcomeMessage;
        data["hasError"] = this.hasError;
        data["errorMessage"] = this.errorMessage;
        data["accountName"] = this.accountName;
        return data;
    }
}

export interface IWhiteLabelResult {
    defaultSet?: boolean;
    subDomain?: string | undefined;
    logoUrl?: string | undefined;
    landingTitle?: string | undefined;
    topLeftTitle?: string | undefined;
    welcomeMessage?: string | undefined;
    hasError?: boolean;
    errorMessage?: string | undefined;
    accountName?: string | undefined;
}

export enum CloudAssetWidgetRequestType {
    Cloud = "Cloud",
    CostCenter = "CostCenter",
}

export class AXReference implements IAXReference {
    id?: number;
    axNumber?: string | undefined;
    axTitle?: string | undefined;
    account?: Account;
    dateCreated?: Date;
    createdByEntraId?: string | undefined;
    dateModified?: Date | undefined;
    modifiedByEntraId?: string | undefined;

    constructor(data?: IAXReference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.axNumber = _data["axNumber"];
            this.axTitle = _data["axTitle"];
            this.account = _data["account"] ? Account.fromJS(_data["account"]) : <any>undefined;
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>undefined;
            this.createdByEntraId = _data["createdByEntraId"];
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
            this.modifiedByEntraId = _data["modifiedByEntraId"];
        }
    }

    static fromJS(data: any): AXReference {
        data = typeof data === 'object' ? data : {};
        let result = new AXReference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["axNumber"] = this.axNumber;
        data["axTitle"] = this.axTitle;
        data["account"] = this.account ? this.account.toJSON() : <any>undefined;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["createdByEntraId"] = this.createdByEntraId;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        data["modifiedByEntraId"] = this.modifiedByEntraId;
        return data;
    }
}

export interface IAXReference {
    id?: number;
    axNumber?: string | undefined;
    axTitle?: string | undefined;
    account?: Account;
    dateCreated?: Date;
    createdByEntraId?: string | undefined;
    dateModified?: Date | undefined;
    modifiedByEntraId?: string | undefined;
}

export class AccountConfiguredStatus implements IAccountConfiguredStatus {
    accountId?: number;
    accountAxNumber?: string | undefined;
    welcomeLinkGenerated?: boolean;
    hasUser?: boolean;
    hasAdminUser?: boolean;
    onboardingConfigurationComplete?: boolean;
    hasCreatedTeam?: boolean;

    constructor(data?: IAccountConfiguredStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.accountAxNumber = _data["accountAxNumber"];
            this.welcomeLinkGenerated = _data["welcomeLinkGenerated"];
            this.hasUser = _data["hasUser"];
            this.hasAdminUser = _data["hasAdminUser"];
            this.onboardingConfigurationComplete = _data["onboardingConfigurationComplete"];
            this.hasCreatedTeam = _data["hasCreatedTeam"];
        }
    }

    static fromJS(data: any): AccountConfiguredStatus {
        data = typeof data === 'object' ? data : {};
        let result = new AccountConfiguredStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["accountAxNumber"] = this.accountAxNumber;
        data["welcomeLinkGenerated"] = this.welcomeLinkGenerated;
        data["hasUser"] = this.hasUser;
        data["hasAdminUser"] = this.hasAdminUser;
        data["onboardingConfigurationComplete"] = this.onboardingConfigurationComplete;
        data["hasCreatedTeam"] = this.hasCreatedTeam;
        return data;
    }
}

export interface IAccountConfiguredStatus {
    accountId?: number;
    accountAxNumber?: string | undefined;
    welcomeLinkGenerated?: boolean;
    hasUser?: boolean;
    hasAdminUser?: boolean;
    onboardingConfigurationComplete?: boolean;
    hasCreatedTeam?: boolean;
}

export class Account implements IAccount {
    id?: number;
    accountName?: string | undefined;
    accountNumber?: string | undefined;
    accountType?: number;
    active?: boolean;
    additionalAddressInformation?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    alternatePhone1?: string | undefined;
    alternatePhone2?: string | undefined;
    assetValue?: number;
    billToAccountPhysicalLocationID?: number;
    billToAdditionalAddressInformation?: string | undefined;
    billToAddress1?: string | undefined;
    billToAddress2?: string | undefined;
    billToAddressToUse?: number;
    billToAttention?: string | undefined;
    billToCity?: string | undefined;
    billToCountryID?: number;
    billToState?: string | undefined;
    billToZipCode?: string | undefined;
    city?: string | undefined;
    clientPortalActive?: boolean;
    competitorID?: number;
    country?: string | undefined;
    countryID?: number;
    createDate?: Date;
    currencyID?: number;
    invoiceEmailMessageID?: number;
    invoiceMethod?: number;
    invoiceNonContractItemsToParentAccount?: boolean;
    invoiceTemplateID?: number;
    keyAccountIcon?: number;
    marketSegmentID?: number;
    phone?: string | undefined;
    postalCode?: string | undefined;
    quoteEmailMessageID?: number;
    quoteTemplateID?: number;
    sicCode?: string | undefined;
    state?: string | undefined;
    stockMarket?: string | undefined;
    stockSymbol?: string | undefined;
    taskFireActive?: boolean;
    taxExempt?: boolean;
    taxID?: string | undefined;
    taxRegionID?: number;
    territoryID?: number;
    webAddress?: string | undefined;
    readonly userDefinedFieldsObject?: string | undefined;
    axNumber?: string | undefined;
    accountExecutiveEmail?: string | undefined;
    lastActivityDate?: Date;
    parentAccountID?: number | undefined;
    userDefinedFieldsJson?: string | undefined;
    subdomainPrefix?: string | undefined;
    subdomainSettingsJson?: string | undefined;
    axReferences?: AXReference[] | undefined;
    teams?: Team[] | undefined;
    teamsEnabled?: boolean;
    noManualAuthRequired?: boolean;
    onboardingConfigurationComplete?: boolean;
    costCenters?: CostCenter[] | undefined;

    constructor(data?: IAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountName = _data["accountName"];
            this.accountNumber = _data["accountNumber"];
            this.accountType = _data["accountType"];
            this.active = _data["active"];
            this.additionalAddressInformation = _data["additionalAddressInformation"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.alternatePhone1 = _data["alternatePhone1"];
            this.alternatePhone2 = _data["alternatePhone2"];
            this.assetValue = _data["assetValue"];
            this.billToAccountPhysicalLocationID = _data["billToAccountPhysicalLocationID"];
            this.billToAdditionalAddressInformation = _data["billToAdditionalAddressInformation"];
            this.billToAddress1 = _data["billToAddress1"];
            this.billToAddress2 = _data["billToAddress2"];
            this.billToAddressToUse = _data["billToAddressToUse"];
            this.billToAttention = _data["billToAttention"];
            this.billToCity = _data["billToCity"];
            this.billToCountryID = _data["billToCountryID"];
            this.billToState = _data["billToState"];
            this.billToZipCode = _data["billToZipCode"];
            this.city = _data["city"];
            this.clientPortalActive = _data["clientPortalActive"];
            this.competitorID = _data["competitorID"];
            this.country = _data["country"];
            this.countryID = _data["countryID"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.currencyID = _data["currencyID"];
            this.invoiceEmailMessageID = _data["invoiceEmailMessageID"];
            this.invoiceMethod = _data["invoiceMethod"];
            this.invoiceNonContractItemsToParentAccount = _data["invoiceNonContractItemsToParentAccount"];
            this.invoiceTemplateID = _data["invoiceTemplateID"];
            this.keyAccountIcon = _data["keyAccountIcon"];
            this.marketSegmentID = _data["marketSegmentID"];
            this.phone = _data["phone"];
            this.postalCode = _data["postalCode"];
            this.quoteEmailMessageID = _data["quoteEmailMessageID"];
            this.quoteTemplateID = _data["quoteTemplateID"];
            this.sicCode = _data["sicCode"];
            this.state = _data["state"];
            this.stockMarket = _data["stockMarket"];
            this.stockSymbol = _data["stockSymbol"];
            this.taskFireActive = _data["taskFireActive"];
            this.taxExempt = _data["taxExempt"];
            this.taxID = _data["taxID"];
            this.taxRegionID = _data["taxRegionID"];
            this.territoryID = _data["territoryID"];
            this.webAddress = _data["webAddress"];
            (<any>this).userDefinedFieldsObject = _data["userDefinedFieldsObject"];
            this.axNumber = _data["axNumber"];
            this.accountExecutiveEmail = _data["accountExecutiveEmail"];
            this.lastActivityDate = _data["lastActivityDate"] ? new Date(_data["lastActivityDate"].toString()) : <any>undefined;
            this.parentAccountID = _data["parentAccountID"];
            this.userDefinedFieldsJson = _data["userDefinedFieldsJson"];
            this.subdomainPrefix = _data["subdomainPrefix"];
            this.subdomainSettingsJson = _data["subdomainSettingsJson"];
            if (Array.isArray(_data["axReferences"])) {
                this.axReferences = [] as any;
                for (let item of _data["axReferences"])
                    this.axReferences!.push(AXReference.fromJS(item));
            }
            if (Array.isArray(_data["teams"])) {
                this.teams = [] as any;
                for (let item of _data["teams"])
                    this.teams!.push(Team.fromJS(item));
            }
            this.teamsEnabled = _data["teamsEnabled"];
            this.noManualAuthRequired = _data["noManualAuthRequired"];
            this.onboardingConfigurationComplete = _data["onboardingConfigurationComplete"];
            if (Array.isArray(_data["costCenters"])) {
                this.costCenters = [] as any;
                for (let item of _data["costCenters"])
                    this.costCenters!.push(CostCenter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Account {
        data = typeof data === 'object' ? data : {};
        let result = new Account();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountName"] = this.accountName;
        data["accountNumber"] = this.accountNumber;
        data["accountType"] = this.accountType;
        data["active"] = this.active;
        data["additionalAddressInformation"] = this.additionalAddressInformation;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["alternatePhone1"] = this.alternatePhone1;
        data["alternatePhone2"] = this.alternatePhone2;
        data["assetValue"] = this.assetValue;
        data["billToAccountPhysicalLocationID"] = this.billToAccountPhysicalLocationID;
        data["billToAdditionalAddressInformation"] = this.billToAdditionalAddressInformation;
        data["billToAddress1"] = this.billToAddress1;
        data["billToAddress2"] = this.billToAddress2;
        data["billToAddressToUse"] = this.billToAddressToUse;
        data["billToAttention"] = this.billToAttention;
        data["billToCity"] = this.billToCity;
        data["billToCountryID"] = this.billToCountryID;
        data["billToState"] = this.billToState;
        data["billToZipCode"] = this.billToZipCode;
        data["city"] = this.city;
        data["clientPortalActive"] = this.clientPortalActive;
        data["competitorID"] = this.competitorID;
        data["country"] = this.country;
        data["countryID"] = this.countryID;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["currencyID"] = this.currencyID;
        data["invoiceEmailMessageID"] = this.invoiceEmailMessageID;
        data["invoiceMethod"] = this.invoiceMethod;
        data["invoiceNonContractItemsToParentAccount"] = this.invoiceNonContractItemsToParentAccount;
        data["invoiceTemplateID"] = this.invoiceTemplateID;
        data["keyAccountIcon"] = this.keyAccountIcon;
        data["marketSegmentID"] = this.marketSegmentID;
        data["phone"] = this.phone;
        data["postalCode"] = this.postalCode;
        data["quoteEmailMessageID"] = this.quoteEmailMessageID;
        data["quoteTemplateID"] = this.quoteTemplateID;
        data["sicCode"] = this.sicCode;
        data["state"] = this.state;
        data["stockMarket"] = this.stockMarket;
        data["stockSymbol"] = this.stockSymbol;
        data["taskFireActive"] = this.taskFireActive;
        data["taxExempt"] = this.taxExempt;
        data["taxID"] = this.taxID;
        data["taxRegionID"] = this.taxRegionID;
        data["territoryID"] = this.territoryID;
        data["webAddress"] = this.webAddress;
        data["userDefinedFieldsObject"] = this.userDefinedFieldsObject;
        data["axNumber"] = this.axNumber;
        data["accountExecutiveEmail"] = this.accountExecutiveEmail;
        data["lastActivityDate"] = this.lastActivityDate ? this.lastActivityDate.toISOString() : <any>undefined;
        data["parentAccountID"] = this.parentAccountID;
        data["userDefinedFieldsJson"] = this.userDefinedFieldsJson;
        data["subdomainPrefix"] = this.subdomainPrefix;
        data["subdomainSettingsJson"] = this.subdomainSettingsJson;
        if (Array.isArray(this.axReferences)) {
            data["axReferences"] = [];
            for (let item of this.axReferences)
                data["axReferences"].push(item.toJSON());
        }
        if (Array.isArray(this.teams)) {
            data["teams"] = [];
            for (let item of this.teams)
                data["teams"].push(item.toJSON());
        }
        data["teamsEnabled"] = this.teamsEnabled;
        data["noManualAuthRequired"] = this.noManualAuthRequired;
        data["onboardingConfigurationComplete"] = this.onboardingConfigurationComplete;
        if (Array.isArray(this.costCenters)) {
            data["costCenters"] = [];
            for (let item of this.costCenters)
                data["costCenters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAccount {
    id?: number;
    accountName?: string | undefined;
    accountNumber?: string | undefined;
    accountType?: number;
    active?: boolean;
    additionalAddressInformation?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    alternatePhone1?: string | undefined;
    alternatePhone2?: string | undefined;
    assetValue?: number;
    billToAccountPhysicalLocationID?: number;
    billToAdditionalAddressInformation?: string | undefined;
    billToAddress1?: string | undefined;
    billToAddress2?: string | undefined;
    billToAddressToUse?: number;
    billToAttention?: string | undefined;
    billToCity?: string | undefined;
    billToCountryID?: number;
    billToState?: string | undefined;
    billToZipCode?: string | undefined;
    city?: string | undefined;
    clientPortalActive?: boolean;
    competitorID?: number;
    country?: string | undefined;
    countryID?: number;
    createDate?: Date;
    currencyID?: number;
    invoiceEmailMessageID?: number;
    invoiceMethod?: number;
    invoiceNonContractItemsToParentAccount?: boolean;
    invoiceTemplateID?: number;
    keyAccountIcon?: number;
    marketSegmentID?: number;
    phone?: string | undefined;
    postalCode?: string | undefined;
    quoteEmailMessageID?: number;
    quoteTemplateID?: number;
    sicCode?: string | undefined;
    state?: string | undefined;
    stockMarket?: string | undefined;
    stockSymbol?: string | undefined;
    taskFireActive?: boolean;
    taxExempt?: boolean;
    taxID?: string | undefined;
    taxRegionID?: number;
    territoryID?: number;
    webAddress?: string | undefined;
    userDefinedFieldsObject?: string | undefined;
    axNumber?: string | undefined;
    accountExecutiveEmail?: string | undefined;
    lastActivityDate?: Date;
    parentAccountID?: number | undefined;
    userDefinedFieldsJson?: string | undefined;
    subdomainPrefix?: string | undefined;
    subdomainSettingsJson?: string | undefined;
    axReferences?: AXReference[] | undefined;
    teams?: Team[] | undefined;
    teamsEnabled?: boolean;
    noManualAuthRequired?: boolean;
    onboardingConfigurationComplete?: boolean;
    costCenters?: CostCenter[] | undefined;
}

export class AggregatedContractsResponse implements IAggregatedContractsResponse {
    contractRetainers?: ContractRetainerSpend[] | undefined;

    constructor(data?: IAggregatedContractsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["contractRetainers"])) {
                this.contractRetainers = [] as any;
                for (let item of _data["contractRetainers"])
                    this.contractRetainers!.push(ContractRetainerSpend.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AggregatedContractsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AggregatedContractsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contractRetainers)) {
            data["contractRetainers"] = [];
            for (let item of this.contractRetainers)
                data["contractRetainers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAggregatedContractsResponse {
    contractRetainers?: ContractRetainerSpend[] | undefined;
}

export class ConfigurationItem implements IConfigurationItem {
    id?: number;
    accountID?: number | undefined;
    accountPhysicalLocationID?: number | undefined;
    productID?: number | undefined;
    contractID?: number | undefined;
    serviceID?: number | undefined;
    serviceBundleID?: number | undefined;
    contactID?: number | undefined;
    vendorID?: number | undefined;
    installedByID?: number | undefined;
    installedByContactID?: number | undefined;
    parentInstalledProductID?: number | undefined;
    contractServiceID?: number | undefined;
    contractServiceBundleID?: number | undefined;
    serviceLevelAgreementID?: number | undefined;
    active?: boolean;
    createDate?: Date;
    installDate?: Date;
    notes?: string | undefined;
    referenceNumber?: string | undefined;
    referenceTitle?: string | undefined;
    serialNumber?: string | undefined;
    warrantyExpirationDate?: Date;
    type?: number;
    location?: string | undefined;
    lastModifiedTime?: Date;
    rmmDeviceID?: number | undefined;
    rmmDeviceUID?: string | undefined;
    rmmDeviceAuditArchitectureID?: number | undefined;
    rmmDeviceAuditDescription?: string | undefined;
    rmmDeviceAuditDisplayAdaptorID?: number | undefined;
    rmmDeviceAuditDomainID?: number | undefined;
    rmmDeviceAuditExternalIPAddress?: string | undefined;
    rmmDeviceAuditHostname?: string | undefined;
    rmmDeviceAuditIPAddress?: string | undefined;
    rmmDeviceAuditMacAddress?: string | undefined;
    rmmDeviceAuditManufacturerID?: number | undefined;
    rmmDeviceAuditMemoryBytes?: number | undefined;
    rmmDeviceAuditModelID?: number | undefined;
    rmmDeviceAuditMotherboardID?: number | undefined;
    rmmDeviceAuditOperatingSystem?: string | undefined;
    rmmDeviceAuditProcessorID?: number | undefined;
    rmmDeviceAuditServicePackID?: number | undefined;
    rmmDeviceAuditStorageBytes?: number | undefined;
    rmmDeviceAuditDeviceTypeID?: number | undefined;
    rmmDeviceAuditSNMPLocation?: string | undefined;
    rmmDeviceAuditSNMPName?: string | undefined;
    rmmDeviceAuditSNMPContact?: string | undefined;
    rmmDeviceAuditMobileNetworkOperatorID?: number | undefined;
    rmmDeviceAuditMobileNumber?: string | undefined;
    rmmDeviceAuditMissingPatchCount?: number | undefined;
    rmmOpenAlertCount?: number | undefined;
    rmmDeviceAuditLastUser?: string | undefined;
    dattoSerialNumber?: string | undefined;
    dattoInternalIP?: string | undefined;
    dattoRemoteIP?: string | undefined;
    dattoHostname?: string | undefined;
    dattoProtectedKilobytes?: number | undefined;
    dattoUsedKilobytes?: number | undefined;
    dattoAvailableKilobytes?: number | undefined;
    dattoPercentageUsed?: number | undefined;
    dattoOffsiteUsedBytes?: number | undefined;
    dattoOSVersionID?: number | undefined;
    dattoZFSVersionID?: number | undefined;
    dattoKernelVersionID?: number | undefined;
    dattoNICSpeedKilobitsPerSecond?: number | undefined;
    dattoDeviceMemoryMegabytes?: number | undefined;
    dattoUptimeSeconds?: number | undefined;
    dattoNumberOfAgents?: number | undefined;
    dattoNumberOfDrives?: number | undefined;
    dattoDrivesErrors?: boolean;
    dattoNumberOfVolumes?: number | undefined;
    numberOfUsers?: number;
    dattoLastCheckInDateTime?: Date | undefined;
    userDefinedFieldsJson?: string | undefined;
    installedProductCategoryID?: number | undefined;
    teamConfigItems?: TeamConfigItem[] | undefined;
    costCenter?: CostCenterConfigItem;

    constructor(data?: IConfigurationItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountID = _data["accountID"];
            this.accountPhysicalLocationID = _data["accountPhysicalLocationID"];
            this.productID = _data["productID"];
            this.contractID = _data["contractID"];
            this.serviceID = _data["serviceID"];
            this.serviceBundleID = _data["serviceBundleID"];
            this.contactID = _data["contactID"];
            this.vendorID = _data["vendorID"];
            this.installedByID = _data["installedByID"];
            this.installedByContactID = _data["installedByContactID"];
            this.parentInstalledProductID = _data["parentInstalledProductID"];
            this.contractServiceID = _data["contractServiceID"];
            this.contractServiceBundleID = _data["contractServiceBundleID"];
            this.serviceLevelAgreementID = _data["serviceLevelAgreementID"];
            this.active = _data["active"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.installDate = _data["installDate"] ? new Date(_data["installDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.referenceNumber = _data["referenceNumber"];
            this.referenceTitle = _data["referenceTitle"];
            this.serialNumber = _data["serialNumber"];
            this.warrantyExpirationDate = _data["warrantyExpirationDate"] ? new Date(_data["warrantyExpirationDate"].toString()) : <any>undefined;
            this.type = _data["type"];
            this.location = _data["location"];
            this.lastModifiedTime = _data["lastModifiedTime"] ? new Date(_data["lastModifiedTime"].toString()) : <any>undefined;
            this.rmmDeviceID = _data["rmmDeviceID"];
            this.rmmDeviceUID = _data["rmmDeviceUID"];
            this.rmmDeviceAuditArchitectureID = _data["rmmDeviceAuditArchitectureID"];
            this.rmmDeviceAuditDescription = _data["rmmDeviceAuditDescription"];
            this.rmmDeviceAuditDisplayAdaptorID = _data["rmmDeviceAuditDisplayAdaptorID"];
            this.rmmDeviceAuditDomainID = _data["rmmDeviceAuditDomainID"];
            this.rmmDeviceAuditExternalIPAddress = _data["rmmDeviceAuditExternalIPAddress"];
            this.rmmDeviceAuditHostname = _data["rmmDeviceAuditHostname"];
            this.rmmDeviceAuditIPAddress = _data["rmmDeviceAuditIPAddress"];
            this.rmmDeviceAuditMacAddress = _data["rmmDeviceAuditMacAddress"];
            this.rmmDeviceAuditManufacturerID = _data["rmmDeviceAuditManufacturerID"];
            this.rmmDeviceAuditMemoryBytes = _data["rmmDeviceAuditMemoryBytes"];
            this.rmmDeviceAuditModelID = _data["rmmDeviceAuditModelID"];
            this.rmmDeviceAuditMotherboardID = _data["rmmDeviceAuditMotherboardID"];
            this.rmmDeviceAuditOperatingSystem = _data["rmmDeviceAuditOperatingSystem"];
            this.rmmDeviceAuditProcessorID = _data["rmmDeviceAuditProcessorID"];
            this.rmmDeviceAuditServicePackID = _data["rmmDeviceAuditServicePackID"];
            this.rmmDeviceAuditStorageBytes = _data["rmmDeviceAuditStorageBytes"];
            this.rmmDeviceAuditDeviceTypeID = _data["rmmDeviceAuditDeviceTypeID"];
            this.rmmDeviceAuditSNMPLocation = _data["rmmDeviceAuditSNMPLocation"];
            this.rmmDeviceAuditSNMPName = _data["rmmDeviceAuditSNMPName"];
            this.rmmDeviceAuditSNMPContact = _data["rmmDeviceAuditSNMPContact"];
            this.rmmDeviceAuditMobileNetworkOperatorID = _data["rmmDeviceAuditMobileNetworkOperatorID"];
            this.rmmDeviceAuditMobileNumber = _data["rmmDeviceAuditMobileNumber"];
            this.rmmDeviceAuditMissingPatchCount = _data["rmmDeviceAuditMissingPatchCount"];
            this.rmmOpenAlertCount = _data["rmmOpenAlertCount"];
            this.rmmDeviceAuditLastUser = _data["rmmDeviceAuditLastUser"];
            this.dattoSerialNumber = _data["dattoSerialNumber"];
            this.dattoInternalIP = _data["dattoInternalIP"];
            this.dattoRemoteIP = _data["dattoRemoteIP"];
            this.dattoHostname = _data["dattoHostname"];
            this.dattoProtectedKilobytes = _data["dattoProtectedKilobytes"];
            this.dattoUsedKilobytes = _data["dattoUsedKilobytes"];
            this.dattoAvailableKilobytes = _data["dattoAvailableKilobytes"];
            this.dattoPercentageUsed = _data["dattoPercentageUsed"];
            this.dattoOffsiteUsedBytes = _data["dattoOffsiteUsedBytes"];
            this.dattoOSVersionID = _data["dattoOSVersionID"];
            this.dattoZFSVersionID = _data["dattoZFSVersionID"];
            this.dattoKernelVersionID = _data["dattoKernelVersionID"];
            this.dattoNICSpeedKilobitsPerSecond = _data["dattoNICSpeedKilobitsPerSecond"];
            this.dattoDeviceMemoryMegabytes = _data["dattoDeviceMemoryMegabytes"];
            this.dattoUptimeSeconds = _data["dattoUptimeSeconds"];
            this.dattoNumberOfAgents = _data["dattoNumberOfAgents"];
            this.dattoNumberOfDrives = _data["dattoNumberOfDrives"];
            this.dattoDrivesErrors = _data["dattoDrivesErrors"];
            this.dattoNumberOfVolumes = _data["dattoNumberOfVolumes"];
            this.numberOfUsers = _data["numberOfUsers"];
            this.dattoLastCheckInDateTime = _data["dattoLastCheckInDateTime"] ? new Date(_data["dattoLastCheckInDateTime"].toString()) : <any>undefined;
            this.userDefinedFieldsJson = _data["userDefinedFieldsJson"];
            this.installedProductCategoryID = _data["installedProductCategoryID"];
            if (Array.isArray(_data["teamConfigItems"])) {
                this.teamConfigItems = [] as any;
                for (let item of _data["teamConfigItems"])
                    this.teamConfigItems!.push(TeamConfigItem.fromJS(item));
            }
            this.costCenter = _data["costCenter"] ? CostCenterConfigItem.fromJS(_data["costCenter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ConfigurationItem {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountID"] = this.accountID;
        data["accountPhysicalLocationID"] = this.accountPhysicalLocationID;
        data["productID"] = this.productID;
        data["contractID"] = this.contractID;
        data["serviceID"] = this.serviceID;
        data["serviceBundleID"] = this.serviceBundleID;
        data["contactID"] = this.contactID;
        data["vendorID"] = this.vendorID;
        data["installedByID"] = this.installedByID;
        data["installedByContactID"] = this.installedByContactID;
        data["parentInstalledProductID"] = this.parentInstalledProductID;
        data["contractServiceID"] = this.contractServiceID;
        data["contractServiceBundleID"] = this.contractServiceBundleID;
        data["serviceLevelAgreementID"] = this.serviceLevelAgreementID;
        data["active"] = this.active;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["installDate"] = this.installDate ? this.installDate.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["referenceNumber"] = this.referenceNumber;
        data["referenceTitle"] = this.referenceTitle;
        data["serialNumber"] = this.serialNumber;
        data["warrantyExpirationDate"] = this.warrantyExpirationDate ? this.warrantyExpirationDate.toISOString() : <any>undefined;
        data["type"] = this.type;
        data["location"] = this.location;
        data["lastModifiedTime"] = this.lastModifiedTime ? this.lastModifiedTime.toISOString() : <any>undefined;
        data["rmmDeviceID"] = this.rmmDeviceID;
        data["rmmDeviceUID"] = this.rmmDeviceUID;
        data["rmmDeviceAuditArchitectureID"] = this.rmmDeviceAuditArchitectureID;
        data["rmmDeviceAuditDescription"] = this.rmmDeviceAuditDescription;
        data["rmmDeviceAuditDisplayAdaptorID"] = this.rmmDeviceAuditDisplayAdaptorID;
        data["rmmDeviceAuditDomainID"] = this.rmmDeviceAuditDomainID;
        data["rmmDeviceAuditExternalIPAddress"] = this.rmmDeviceAuditExternalIPAddress;
        data["rmmDeviceAuditHostname"] = this.rmmDeviceAuditHostname;
        data["rmmDeviceAuditIPAddress"] = this.rmmDeviceAuditIPAddress;
        data["rmmDeviceAuditMacAddress"] = this.rmmDeviceAuditMacAddress;
        data["rmmDeviceAuditManufacturerID"] = this.rmmDeviceAuditManufacturerID;
        data["rmmDeviceAuditMemoryBytes"] = this.rmmDeviceAuditMemoryBytes;
        data["rmmDeviceAuditModelID"] = this.rmmDeviceAuditModelID;
        data["rmmDeviceAuditMotherboardID"] = this.rmmDeviceAuditMotherboardID;
        data["rmmDeviceAuditOperatingSystem"] = this.rmmDeviceAuditOperatingSystem;
        data["rmmDeviceAuditProcessorID"] = this.rmmDeviceAuditProcessorID;
        data["rmmDeviceAuditServicePackID"] = this.rmmDeviceAuditServicePackID;
        data["rmmDeviceAuditStorageBytes"] = this.rmmDeviceAuditStorageBytes;
        data["rmmDeviceAuditDeviceTypeID"] = this.rmmDeviceAuditDeviceTypeID;
        data["rmmDeviceAuditSNMPLocation"] = this.rmmDeviceAuditSNMPLocation;
        data["rmmDeviceAuditSNMPName"] = this.rmmDeviceAuditSNMPName;
        data["rmmDeviceAuditSNMPContact"] = this.rmmDeviceAuditSNMPContact;
        data["rmmDeviceAuditMobileNetworkOperatorID"] = this.rmmDeviceAuditMobileNetworkOperatorID;
        data["rmmDeviceAuditMobileNumber"] = this.rmmDeviceAuditMobileNumber;
        data["rmmDeviceAuditMissingPatchCount"] = this.rmmDeviceAuditMissingPatchCount;
        data["rmmOpenAlertCount"] = this.rmmOpenAlertCount;
        data["rmmDeviceAuditLastUser"] = this.rmmDeviceAuditLastUser;
        data["dattoSerialNumber"] = this.dattoSerialNumber;
        data["dattoInternalIP"] = this.dattoInternalIP;
        data["dattoRemoteIP"] = this.dattoRemoteIP;
        data["dattoHostname"] = this.dattoHostname;
        data["dattoProtectedKilobytes"] = this.dattoProtectedKilobytes;
        data["dattoUsedKilobytes"] = this.dattoUsedKilobytes;
        data["dattoAvailableKilobytes"] = this.dattoAvailableKilobytes;
        data["dattoPercentageUsed"] = this.dattoPercentageUsed;
        data["dattoOffsiteUsedBytes"] = this.dattoOffsiteUsedBytes;
        data["dattoOSVersionID"] = this.dattoOSVersionID;
        data["dattoZFSVersionID"] = this.dattoZFSVersionID;
        data["dattoKernelVersionID"] = this.dattoKernelVersionID;
        data["dattoNICSpeedKilobitsPerSecond"] = this.dattoNICSpeedKilobitsPerSecond;
        data["dattoDeviceMemoryMegabytes"] = this.dattoDeviceMemoryMegabytes;
        data["dattoUptimeSeconds"] = this.dattoUptimeSeconds;
        data["dattoNumberOfAgents"] = this.dattoNumberOfAgents;
        data["dattoNumberOfDrives"] = this.dattoNumberOfDrives;
        data["dattoDrivesErrors"] = this.dattoDrivesErrors;
        data["dattoNumberOfVolumes"] = this.dattoNumberOfVolumes;
        data["numberOfUsers"] = this.numberOfUsers;
        data["dattoLastCheckInDateTime"] = this.dattoLastCheckInDateTime ? this.dattoLastCheckInDateTime.toISOString() : <any>undefined;
        data["userDefinedFieldsJson"] = this.userDefinedFieldsJson;
        data["installedProductCategoryID"] = this.installedProductCategoryID;
        if (Array.isArray(this.teamConfigItems)) {
            data["teamConfigItems"] = [];
            for (let item of this.teamConfigItems)
                data["teamConfigItems"].push(item.toJSON());
        }
        data["costCenter"] = this.costCenter ? this.costCenter.toJSON() : <any>undefined;
        return data;
    }
}

export interface IConfigurationItem {
    id?: number;
    accountID?: number | undefined;
    accountPhysicalLocationID?: number | undefined;
    productID?: number | undefined;
    contractID?: number | undefined;
    serviceID?: number | undefined;
    serviceBundleID?: number | undefined;
    contactID?: number | undefined;
    vendorID?: number | undefined;
    installedByID?: number | undefined;
    installedByContactID?: number | undefined;
    parentInstalledProductID?: number | undefined;
    contractServiceID?: number | undefined;
    contractServiceBundleID?: number | undefined;
    serviceLevelAgreementID?: number | undefined;
    active?: boolean;
    createDate?: Date;
    installDate?: Date;
    notes?: string | undefined;
    referenceNumber?: string | undefined;
    referenceTitle?: string | undefined;
    serialNumber?: string | undefined;
    warrantyExpirationDate?: Date;
    type?: number;
    location?: string | undefined;
    lastModifiedTime?: Date;
    rmmDeviceID?: number | undefined;
    rmmDeviceUID?: string | undefined;
    rmmDeviceAuditArchitectureID?: number | undefined;
    rmmDeviceAuditDescription?: string | undefined;
    rmmDeviceAuditDisplayAdaptorID?: number | undefined;
    rmmDeviceAuditDomainID?: number | undefined;
    rmmDeviceAuditExternalIPAddress?: string | undefined;
    rmmDeviceAuditHostname?: string | undefined;
    rmmDeviceAuditIPAddress?: string | undefined;
    rmmDeviceAuditMacAddress?: string | undefined;
    rmmDeviceAuditManufacturerID?: number | undefined;
    rmmDeviceAuditMemoryBytes?: number | undefined;
    rmmDeviceAuditModelID?: number | undefined;
    rmmDeviceAuditMotherboardID?: number | undefined;
    rmmDeviceAuditOperatingSystem?: string | undefined;
    rmmDeviceAuditProcessorID?: number | undefined;
    rmmDeviceAuditServicePackID?: number | undefined;
    rmmDeviceAuditStorageBytes?: number | undefined;
    rmmDeviceAuditDeviceTypeID?: number | undefined;
    rmmDeviceAuditSNMPLocation?: string | undefined;
    rmmDeviceAuditSNMPName?: string | undefined;
    rmmDeviceAuditSNMPContact?: string | undefined;
    rmmDeviceAuditMobileNetworkOperatorID?: number | undefined;
    rmmDeviceAuditMobileNumber?: string | undefined;
    rmmDeviceAuditMissingPatchCount?: number | undefined;
    rmmOpenAlertCount?: number | undefined;
    rmmDeviceAuditLastUser?: string | undefined;
    dattoSerialNumber?: string | undefined;
    dattoInternalIP?: string | undefined;
    dattoRemoteIP?: string | undefined;
    dattoHostname?: string | undefined;
    dattoProtectedKilobytes?: number | undefined;
    dattoUsedKilobytes?: number | undefined;
    dattoAvailableKilobytes?: number | undefined;
    dattoPercentageUsed?: number | undefined;
    dattoOffsiteUsedBytes?: number | undefined;
    dattoOSVersionID?: number | undefined;
    dattoZFSVersionID?: number | undefined;
    dattoKernelVersionID?: number | undefined;
    dattoNICSpeedKilobitsPerSecond?: number | undefined;
    dattoDeviceMemoryMegabytes?: number | undefined;
    dattoUptimeSeconds?: number | undefined;
    dattoNumberOfAgents?: number | undefined;
    dattoNumberOfDrives?: number | undefined;
    dattoDrivesErrors?: boolean;
    dattoNumberOfVolumes?: number | undefined;
    numberOfUsers?: number;
    dattoLastCheckInDateTime?: Date | undefined;
    userDefinedFieldsJson?: string | undefined;
    installedProductCategoryID?: number | undefined;
    teamConfigItems?: TeamConfigItem[] | undefined;
    costCenter?: CostCenterConfigItem;
}

export class ConfigurationItem_CreateUpdate implements IConfigurationItem_CreateUpdate {
    axNumber?: string | undefined;
    referenceName?: string | undefined;
    referenceNumber?: string | undefined;
    product?: string | undefined;
    installDate?: Date | undefined;
    active?: boolean;
    numberOfUsers?: number | undefined;
    contractID?: number | undefined;
    msCustomerID?: string | undefined;
    msProgram?: string | undefined;
    msParentSubscriptionId?: string | undefined;
    msDomain?: string | undefined;
    msCompanyName?: string | undefined;
    awsAccountEmail?: string | undefined;
    awsAccountName?: string | undefined;
    awsSupportLevel?: string | undefined;
    awsAccountType?: string | undefined;
    awsPayerId?: string | undefined;
    awsPayerAccountName?: string | undefined;
    awsPayerAccountEmail?: string | undefined;
    gcpBillingAccountId?: string | undefined;

    constructor(data?: IConfigurationItem_CreateUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.axNumber = _data["axNumber"];
            this.referenceName = _data["referenceName"];
            this.referenceNumber = _data["referenceNumber"];
            this.product = _data["product"];
            this.installDate = _data["installDate"] ? new Date(_data["installDate"].toString()) : <any>undefined;
            this.active = _data["active"];
            this.numberOfUsers = _data["numberOfUsers"];
            this.contractID = _data["contractID"];
            this.msCustomerID = _data["msCustomerID"];
            this.msProgram = _data["msProgram"];
            this.msParentSubscriptionId = _data["msParentSubscriptionId"];
            this.msDomain = _data["msDomain"];
            this.msCompanyName = _data["msCompanyName"];
            this.awsAccountEmail = _data["awsAccountEmail"];
            this.awsAccountName = _data["awsAccountName"];
            this.awsSupportLevel = _data["awsSupportLevel"];
            this.awsAccountType = _data["awsAccountType"];
            this.awsPayerId = _data["awsPayerId"];
            this.awsPayerAccountName = _data["awsPayerAccountName"];
            this.awsPayerAccountEmail = _data["awsPayerAccountEmail"];
            this.gcpBillingAccountId = _data["gcpBillingAccountId"];
        }
    }

    static fromJS(data: any): ConfigurationItem_CreateUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationItem_CreateUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axNumber"] = this.axNumber;
        data["referenceName"] = this.referenceName;
        data["referenceNumber"] = this.referenceNumber;
        data["product"] = this.product;
        data["installDate"] = this.installDate ? this.installDate.toISOString() : <any>undefined;
        data["active"] = this.active;
        data["numberOfUsers"] = this.numberOfUsers;
        data["contractID"] = this.contractID;
        data["msCustomerID"] = this.msCustomerID;
        data["msProgram"] = this.msProgram;
        data["msParentSubscriptionId"] = this.msParentSubscriptionId;
        data["msDomain"] = this.msDomain;
        data["msCompanyName"] = this.msCompanyName;
        data["awsAccountEmail"] = this.awsAccountEmail;
        data["awsAccountName"] = this.awsAccountName;
        data["awsSupportLevel"] = this.awsSupportLevel;
        data["awsAccountType"] = this.awsAccountType;
        data["awsPayerId"] = this.awsPayerId;
        data["awsPayerAccountName"] = this.awsPayerAccountName;
        data["awsPayerAccountEmail"] = this.awsPayerAccountEmail;
        data["gcpBillingAccountId"] = this.gcpBillingAccountId;
        return data;
    }
}

export interface IConfigurationItem_CreateUpdate {
    axNumber?: string | undefined;
    referenceName?: string | undefined;
    referenceNumber?: string | undefined;
    product?: string | undefined;
    installDate?: Date | undefined;
    active?: boolean;
    numberOfUsers?: number | undefined;
    contractID?: number | undefined;
    msCustomerID?: string | undefined;
    msProgram?: string | undefined;
    msParentSubscriptionId?: string | undefined;
    msDomain?: string | undefined;
    msCompanyName?: string | undefined;
    awsAccountEmail?: string | undefined;
    awsAccountName?: string | undefined;
    awsSupportLevel?: string | undefined;
    awsAccountType?: string | undefined;
    awsPayerId?: string | undefined;
    awsPayerAccountName?: string | undefined;
    awsPayerAccountEmail?: string | undefined;
    gcpBillingAccountId?: string | undefined;
}

export class Contact implements IContact {
    id?: number;
    active?: number;
    alternatePhone?: string | undefined;
    bulkEmailOptOut?: boolean;
    bulkEmailOptOutTime?: Date;
    accountPhysicalLocationId?: number;
    addressLine?: string | undefined;
    addressLine1?: string | undefined;
    additionalAddressInformation?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    zipCode?: string | undefined;
    roomNumber?: string | undefined;
    countryId?: number;
    createDate?: Date;
    eMailAddress?: string | undefined;
    eMailAddress2?: string | undefined;
    eMailAddress3?: string | undefined;
    externalId?: string | undefined;
    faxNumber?: string | undefined;
    mobilePhone?: string | undefined;
    phone?: string | undefined;
    extension?: string | undefined;
    title?: string | undefined;
    firstName?: string | undefined;
    middleInitial?: string | undefined;
    lastName?: string | undefined;
    namePrefix?: number;
    nameSuffix?: number;
    note?: string | undefined;
    notification?: boolean;
    primaryContact?: boolean;
    solicitationOptOut?: boolean;
    solicitationOptOutTime?: Date;
    surveyOptOut?: boolean;
    facebookUrl?: string | undefined;
    twitterUrl?: string | undefined;
    linkedInUrl?: string | undefined;
    accountID?: number | undefined;
    contactTeamRoles?: ContactTeamRole[] | undefined;
    ticketAdditionalContacts?: TicketAdditionalContact[] | undefined;
    fullProjectAccess?: boolean;
    lastActivityDate?: Date;
    lastModifiedDate?: Date;
    userDefinedFieldsJson?: string | undefined;

    constructor(data?: IContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.alternatePhone = _data["alternatePhone"];
            this.bulkEmailOptOut = _data["bulkEmailOptOut"];
            this.bulkEmailOptOutTime = _data["bulkEmailOptOutTime"] ? new Date(_data["bulkEmailOptOutTime"].toString()) : <any>undefined;
            this.accountPhysicalLocationId = _data["accountPhysicalLocationId"];
            this.addressLine = _data["addressLine"];
            this.addressLine1 = _data["addressLine1"];
            this.additionalAddressInformation = _data["additionalAddressInformation"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.zipCode = _data["zipCode"];
            this.roomNumber = _data["roomNumber"];
            this.countryId = _data["countryId"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.eMailAddress = _data["eMailAddress"];
            this.eMailAddress2 = _data["eMailAddress2"];
            this.eMailAddress3 = _data["eMailAddress3"];
            this.externalId = _data["externalId"];
            this.faxNumber = _data["faxNumber"];
            this.mobilePhone = _data["mobilePhone"];
            this.phone = _data["phone"];
            this.extension = _data["extension"];
            this.title = _data["title"];
            this.firstName = _data["firstName"];
            this.middleInitial = _data["middleInitial"];
            this.lastName = _data["lastName"];
            this.namePrefix = _data["namePrefix"];
            this.nameSuffix = _data["nameSuffix"];
            this.note = _data["note"];
            this.notification = _data["notification"];
            this.primaryContact = _data["primaryContact"];
            this.solicitationOptOut = _data["solicitationOptOut"];
            this.solicitationOptOutTime = _data["solicitationOptOutTime"] ? new Date(_data["solicitationOptOutTime"].toString()) : <any>undefined;
            this.surveyOptOut = _data["surveyOptOut"];
            this.facebookUrl = _data["facebookUrl"];
            this.twitterUrl = _data["twitterUrl"];
            this.linkedInUrl = _data["linkedInUrl"];
            this.accountID = _data["accountID"];
            if (Array.isArray(_data["contactTeamRoles"])) {
                this.contactTeamRoles = [] as any;
                for (let item of _data["contactTeamRoles"])
                    this.contactTeamRoles!.push(ContactTeamRole.fromJS(item));
            }
            if (Array.isArray(_data["ticketAdditionalContacts"])) {
                this.ticketAdditionalContacts = [] as any;
                for (let item of _data["ticketAdditionalContacts"])
                    this.ticketAdditionalContacts!.push(TicketAdditionalContact.fromJS(item));
            }
            this.fullProjectAccess = _data["fullProjectAccess"];
            this.lastActivityDate = _data["lastActivityDate"] ? new Date(_data["lastActivityDate"].toString()) : <any>undefined;
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            this.userDefinedFieldsJson = _data["userDefinedFieldsJson"];
        }
    }

    static fromJS(data: any): Contact {
        data = typeof data === 'object' ? data : {};
        let result = new Contact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["alternatePhone"] = this.alternatePhone;
        data["bulkEmailOptOut"] = this.bulkEmailOptOut;
        data["bulkEmailOptOutTime"] = this.bulkEmailOptOutTime ? this.bulkEmailOptOutTime.toISOString() : <any>undefined;
        data["accountPhysicalLocationId"] = this.accountPhysicalLocationId;
        data["addressLine"] = this.addressLine;
        data["addressLine1"] = this.addressLine1;
        data["additionalAddressInformation"] = this.additionalAddressInformation;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["zipCode"] = this.zipCode;
        data["roomNumber"] = this.roomNumber;
        data["countryId"] = this.countryId;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["eMailAddress"] = this.eMailAddress;
        data["eMailAddress2"] = this.eMailAddress2;
        data["eMailAddress3"] = this.eMailAddress3;
        data["externalId"] = this.externalId;
        data["faxNumber"] = this.faxNumber;
        data["mobilePhone"] = this.mobilePhone;
        data["phone"] = this.phone;
        data["extension"] = this.extension;
        data["title"] = this.title;
        data["firstName"] = this.firstName;
        data["middleInitial"] = this.middleInitial;
        data["lastName"] = this.lastName;
        data["namePrefix"] = this.namePrefix;
        data["nameSuffix"] = this.nameSuffix;
        data["note"] = this.note;
        data["notification"] = this.notification;
        data["primaryContact"] = this.primaryContact;
        data["solicitationOptOut"] = this.solicitationOptOut;
        data["solicitationOptOutTime"] = this.solicitationOptOutTime ? this.solicitationOptOutTime.toISOString() : <any>undefined;
        data["surveyOptOut"] = this.surveyOptOut;
        data["facebookUrl"] = this.facebookUrl;
        data["twitterUrl"] = this.twitterUrl;
        data["linkedInUrl"] = this.linkedInUrl;
        data["accountID"] = this.accountID;
        if (Array.isArray(this.contactTeamRoles)) {
            data["contactTeamRoles"] = [];
            for (let item of this.contactTeamRoles)
                data["contactTeamRoles"].push(item.toJSON());
        }
        if (Array.isArray(this.ticketAdditionalContacts)) {
            data["ticketAdditionalContacts"] = [];
            for (let item of this.ticketAdditionalContacts)
                data["ticketAdditionalContacts"].push(item.toJSON());
        }
        data["fullProjectAccess"] = this.fullProjectAccess;
        data["lastActivityDate"] = this.lastActivityDate ? this.lastActivityDate.toISOString() : <any>undefined;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["userDefinedFieldsJson"] = this.userDefinedFieldsJson;
        return data;
    }
}

export interface IContact {
    id?: number;
    active?: number;
    alternatePhone?: string | undefined;
    bulkEmailOptOut?: boolean;
    bulkEmailOptOutTime?: Date;
    accountPhysicalLocationId?: number;
    addressLine?: string | undefined;
    addressLine1?: string | undefined;
    additionalAddressInformation?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    zipCode?: string | undefined;
    roomNumber?: string | undefined;
    countryId?: number;
    createDate?: Date;
    eMailAddress?: string | undefined;
    eMailAddress2?: string | undefined;
    eMailAddress3?: string | undefined;
    externalId?: string | undefined;
    faxNumber?: string | undefined;
    mobilePhone?: string | undefined;
    phone?: string | undefined;
    extension?: string | undefined;
    title?: string | undefined;
    firstName?: string | undefined;
    middleInitial?: string | undefined;
    lastName?: string | undefined;
    namePrefix?: number;
    nameSuffix?: number;
    note?: string | undefined;
    notification?: boolean;
    primaryContact?: boolean;
    solicitationOptOut?: boolean;
    solicitationOptOutTime?: Date;
    surveyOptOut?: boolean;
    facebookUrl?: string | undefined;
    twitterUrl?: string | undefined;
    linkedInUrl?: string | undefined;
    accountID?: number | undefined;
    contactTeamRoles?: ContactTeamRole[] | undefined;
    ticketAdditionalContacts?: TicketAdditionalContact[] | undefined;
    fullProjectAccess?: boolean;
    lastActivityDate?: Date;
    lastModifiedDate?: Date;
    userDefinedFieldsJson?: string | undefined;
}

export class Contract implements IContract {
    id?: number;
    userDefinedFieldsJson?: string | undefined;
    readonly userDefinedFieldsObject?: string | undefined;
    partnerName?: string | undefined;
    accountID?: number | undefined;
    axNumber?: string | undefined;
    billingPreference?: number;
    businessDivisionSubdivisionID?: number;
    compliance?: boolean;
    contactID?: number | undefined;
    contactName?: string | undefined;
    contractCategory?: number | undefined;
    contractName?: string | undefined;
    contractNumber?: string | undefined;
    contractPeriodType?: string | undefined;
    contractType?: number;
    description?: string | undefined;
    endDate?: Date;
    estimatedCost?: number | undefined;
    estimatedHours?: number | undefined;
    estimatedRevenue?: number | undefined;
    exclusionContractID?: number | undefined;
    internalCurrencyOverageBillingRate?: number | undefined;
    internalCurrencySetupFee?: number | undefined;
    isDefaultContract?: boolean;
    opportunityID?: number | undefined;
    overageBillingRate?: number | undefined;
    purchaseOrderNumber?: string | undefined;
    renewedContractID?: number | undefined;
    serviceLevelAgreementID?: number | undefined;
    setupFee?: number | undefined;
    setupFeeAllocationCodeID?: number | undefined;
    startDate?: Date;
    status?: number;
    timeReportingRequiresStartAndStopTimes?: number;
    deleted?: boolean;
    systemGuid?: string | undefined;
    parentSystemGuid?: string | undefined;
    teamContracts?: TeamContract[] | undefined;

    constructor(data?: IContract) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userDefinedFieldsJson = _data["userDefinedFieldsJson"];
            (<any>this).userDefinedFieldsObject = _data["userDefinedFieldsObject"];
            this.partnerName = _data["partnerName"];
            this.accountID = _data["accountID"];
            this.axNumber = _data["axNumber"];
            this.billingPreference = _data["billingPreference"];
            this.businessDivisionSubdivisionID = _data["businessDivisionSubdivisionID"];
            this.compliance = _data["compliance"];
            this.contactID = _data["contactID"];
            this.contactName = _data["contactName"];
            this.contractCategory = _data["contractCategory"];
            this.contractName = _data["contractName"];
            this.contractNumber = _data["contractNumber"];
            this.contractPeriodType = _data["contractPeriodType"];
            this.contractType = _data["contractType"];
            this.description = _data["description"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.estimatedCost = _data["estimatedCost"];
            this.estimatedHours = _data["estimatedHours"];
            this.estimatedRevenue = _data["estimatedRevenue"];
            this.exclusionContractID = _data["exclusionContractID"];
            this.internalCurrencyOverageBillingRate = _data["internalCurrencyOverageBillingRate"];
            this.internalCurrencySetupFee = _data["internalCurrencySetupFee"];
            this.isDefaultContract = _data["isDefaultContract"];
            this.opportunityID = _data["opportunityID"];
            this.overageBillingRate = _data["overageBillingRate"];
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
            this.renewedContractID = _data["renewedContractID"];
            this.serviceLevelAgreementID = _data["serviceLevelAgreementID"];
            this.setupFee = _data["setupFee"];
            this.setupFeeAllocationCodeID = _data["setupFeeAllocationCodeID"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.timeReportingRequiresStartAndStopTimes = _data["timeReportingRequiresStartAndStopTimes"];
            this.deleted = _data["deleted"];
            this.systemGuid = _data["systemGuid"];
            this.parentSystemGuid = _data["parentSystemGuid"];
            if (Array.isArray(_data["teamContracts"])) {
                this.teamContracts = [] as any;
                for (let item of _data["teamContracts"])
                    this.teamContracts!.push(TeamContract.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Contract {
        data = typeof data === 'object' ? data : {};
        let result = new Contract();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userDefinedFieldsJson"] = this.userDefinedFieldsJson;
        data["userDefinedFieldsObject"] = this.userDefinedFieldsObject;
        data["partnerName"] = this.partnerName;
        data["accountID"] = this.accountID;
        data["axNumber"] = this.axNumber;
        data["billingPreference"] = this.billingPreference;
        data["businessDivisionSubdivisionID"] = this.businessDivisionSubdivisionID;
        data["compliance"] = this.compliance;
        data["contactID"] = this.contactID;
        data["contactName"] = this.contactName;
        data["contractCategory"] = this.contractCategory;
        data["contractName"] = this.contractName;
        data["contractNumber"] = this.contractNumber;
        data["contractPeriodType"] = this.contractPeriodType;
        data["contractType"] = this.contractType;
        data["description"] = this.description;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["estimatedCost"] = this.estimatedCost;
        data["estimatedHours"] = this.estimatedHours;
        data["estimatedRevenue"] = this.estimatedRevenue;
        data["exclusionContractID"] = this.exclusionContractID;
        data["internalCurrencyOverageBillingRate"] = this.internalCurrencyOverageBillingRate;
        data["internalCurrencySetupFee"] = this.internalCurrencySetupFee;
        data["isDefaultContract"] = this.isDefaultContract;
        data["opportunityID"] = this.opportunityID;
        data["overageBillingRate"] = this.overageBillingRate;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        data["renewedContractID"] = this.renewedContractID;
        data["serviceLevelAgreementID"] = this.serviceLevelAgreementID;
        data["setupFee"] = this.setupFee;
        data["setupFeeAllocationCodeID"] = this.setupFeeAllocationCodeID;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["timeReportingRequiresStartAndStopTimes"] = this.timeReportingRequiresStartAndStopTimes;
        data["deleted"] = this.deleted;
        data["systemGuid"] = this.systemGuid;
        data["parentSystemGuid"] = this.parentSystemGuid;
        if (Array.isArray(this.teamContracts)) {
            data["teamContracts"] = [];
            for (let item of this.teamContracts)
                data["teamContracts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IContract {
    id?: number;
    userDefinedFieldsJson?: string | undefined;
    userDefinedFieldsObject?: string | undefined;
    partnerName?: string | undefined;
    accountID?: number | undefined;
    axNumber?: string | undefined;
    billingPreference?: number;
    businessDivisionSubdivisionID?: number;
    compliance?: boolean;
    contactID?: number | undefined;
    contactName?: string | undefined;
    contractCategory?: number | undefined;
    contractName?: string | undefined;
    contractNumber?: string | undefined;
    contractPeriodType?: string | undefined;
    contractType?: number;
    description?: string | undefined;
    endDate?: Date;
    estimatedCost?: number | undefined;
    estimatedHours?: number | undefined;
    estimatedRevenue?: number | undefined;
    exclusionContractID?: number | undefined;
    internalCurrencyOverageBillingRate?: number | undefined;
    internalCurrencySetupFee?: number | undefined;
    isDefaultContract?: boolean;
    opportunityID?: number | undefined;
    overageBillingRate?: number | undefined;
    purchaseOrderNumber?: string | undefined;
    renewedContractID?: number | undefined;
    serviceLevelAgreementID?: number | undefined;
    setupFee?: number | undefined;
    setupFeeAllocationCodeID?: number | undefined;
    startDate?: Date;
    status?: number;
    timeReportingRequiresStartAndStopTimes?: number;
    deleted?: boolean;
    systemGuid?: string | undefined;
    parentSystemGuid?: string | undefined;
    teamContracts?: TeamContract[] | undefined;
}

export class ContractRetainerSpend implements IContractRetainerSpend {
    id?: number;
    accountId?: number;
    contractId?: number;
    contractActive?: boolean;
    hasAnyRetainerActive?: boolean;
    totalActiveRetainerAmount?: number;
    billedSpend?: number;
    pendingSpend?: number;
    billedOverage?: number;
    pendingOverage?: number;
    dataLoadedDateTime?: Date;

    constructor(data?: IContractRetainerSpend) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.contractId = _data["contractId"];
            this.contractActive = _data["contractActive"];
            this.hasAnyRetainerActive = _data["hasAnyRetainerActive"];
            this.totalActiveRetainerAmount = _data["totalActiveRetainerAmount"];
            this.billedSpend = _data["billedSpend"];
            this.pendingSpend = _data["pendingSpend"];
            this.billedOverage = _data["billedOverage"];
            this.pendingOverage = _data["pendingOverage"];
            this.dataLoadedDateTime = _data["dataLoadedDateTime"] ? new Date(_data["dataLoadedDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ContractRetainerSpend {
        data = typeof data === 'object' ? data : {};
        let result = new ContractRetainerSpend();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["contractId"] = this.contractId;
        data["contractActive"] = this.contractActive;
        data["hasAnyRetainerActive"] = this.hasAnyRetainerActive;
        data["totalActiveRetainerAmount"] = this.totalActiveRetainerAmount;
        data["billedSpend"] = this.billedSpend;
        data["pendingSpend"] = this.pendingSpend;
        data["billedOverage"] = this.billedOverage;
        data["pendingOverage"] = this.pendingOverage;
        data["dataLoadedDateTime"] = this.dataLoadedDateTime ? this.dataLoadedDateTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IContractRetainerSpend {
    id?: number;
    accountId?: number;
    contractId?: number;
    contractActive?: boolean;
    hasAnyRetainerActive?: boolean;
    totalActiveRetainerAmount?: number;
    billedSpend?: number;
    pendingSpend?: number;
    billedOverage?: number;
    pendingOverage?: number;
    dataLoadedDateTime?: Date;
}

export class DetailedContractRetainerExpenseDto implements IDetailedContractRetainerExpenseDto {
    retainerContractSpendResults?: RetainerMonthlyExpenseDto[] | undefined;
    retainerMonthlyBreakdown?: RetainerMonthlyBreakdownDto[] | undefined;

    constructor(data?: IDetailedContractRetainerExpenseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["retainerContractSpendResults"])) {
                this.retainerContractSpendResults = [] as any;
                for (let item of _data["retainerContractSpendResults"])
                    this.retainerContractSpendResults!.push(RetainerMonthlyExpenseDto.fromJS(item));
            }
            if (Array.isArray(_data["retainerMonthlyBreakdown"])) {
                this.retainerMonthlyBreakdown = [] as any;
                for (let item of _data["retainerMonthlyBreakdown"])
                    this.retainerMonthlyBreakdown!.push(RetainerMonthlyBreakdownDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DetailedContractRetainerExpenseDto {
        data = typeof data === 'object' ? data : {};
        let result = new DetailedContractRetainerExpenseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.retainerContractSpendResults)) {
            data["retainerContractSpendResults"] = [];
            for (let item of this.retainerContractSpendResults)
                data["retainerContractSpendResults"].push(item.toJSON());
        }
        if (Array.isArray(this.retainerMonthlyBreakdown)) {
            data["retainerMonthlyBreakdown"] = [];
            for (let item of this.retainerMonthlyBreakdown)
                data["retainerMonthlyBreakdown"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDetailedContractRetainerExpenseDto {
    retainerContractSpendResults?: RetainerMonthlyExpenseDto[] | undefined;
    retainerMonthlyBreakdown?: RetainerMonthlyBreakdownDto[] | undefined;
}

export enum RetainerBreakdownStatus {
    Consumed = "Consumed",
    Pending = "Pending",
    Invoiced = "Invoiced",
    Other = "Other",
}

export class RetainerExpenseAmountDto implements IRetainerExpenseAmountDto {
    expenseType?: RetainerExpenseType;
    amount?: number;

    constructor(data?: IRetainerExpenseAmountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expenseType = _data["expenseType"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): RetainerExpenseAmountDto {
        data = typeof data === 'object' ? data : {};
        let result = new RetainerExpenseAmountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expenseType"] = this.expenseType;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IRetainerExpenseAmountDto {
    expenseType?: RetainerExpenseType;
    amount?: number;
}

export enum RetainerExpenseType {
    RetainerSigning = "RetainerSigning",
    TicketExpense = "TicketExpense",
    ProjectTaskExpense = "ProjectTaskExpense",
    ContractExpense = "ContractExpense",
    Other = "Other",
}

export class RetainerMonthlyBreakdownDto implements IRetainerMonthlyBreakdownDto {
    year?: number;
    month?: number;
    classification?: RetainerExpenseType;
    deposits?: number;
    usage?: number;
    status?: RetainerBreakdownStatus;
    accountId?: number;
    contractId?: number;
    invoiceIds?: number[] | undefined;
    ticketNumbers?: string[] | undefined;
    projectIds?: number[] | undefined;

    constructor(data?: IRetainerMonthlyBreakdownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
            this.classification = _data["classification"];
            this.deposits = _data["deposits"];
            this.usage = _data["usage"];
            this.status = _data["status"];
            this.accountId = _data["accountId"];
            this.contractId = _data["contractId"];
            if (Array.isArray(_data["invoiceIds"])) {
                this.invoiceIds = [] as any;
                for (let item of _data["invoiceIds"])
                    this.invoiceIds!.push(item);
            }
            if (Array.isArray(_data["ticketNumbers"])) {
                this.ticketNumbers = [] as any;
                for (let item of _data["ticketNumbers"])
                    this.ticketNumbers!.push(item);
            }
            if (Array.isArray(_data["projectIds"])) {
                this.projectIds = [] as any;
                for (let item of _data["projectIds"])
                    this.projectIds!.push(item);
            }
        }
    }

    static fromJS(data: any): RetainerMonthlyBreakdownDto {
        data = typeof data === 'object' ? data : {};
        let result = new RetainerMonthlyBreakdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        data["classification"] = this.classification;
        data["deposits"] = this.deposits;
        data["usage"] = this.usage;
        data["status"] = this.status;
        data["accountId"] = this.accountId;
        data["contractId"] = this.contractId;
        if (Array.isArray(this.invoiceIds)) {
            data["invoiceIds"] = [];
            for (let item of this.invoiceIds)
                data["invoiceIds"].push(item);
        }
        if (Array.isArray(this.ticketNumbers)) {
            data["ticketNumbers"] = [];
            for (let item of this.ticketNumbers)
                data["ticketNumbers"].push(item);
        }
        if (Array.isArray(this.projectIds)) {
            data["projectIds"] = [];
            for (let item of this.projectIds)
                data["projectIds"].push(item);
        }
        return data;
    }
}

export interface IRetainerMonthlyBreakdownDto {
    year?: number;
    month?: number;
    classification?: RetainerExpenseType;
    deposits?: number;
    usage?: number;
    status?: RetainerBreakdownStatus;
    accountId?: number;
    contractId?: number;
    invoiceIds?: number[] | undefined;
    ticketNumbers?: string[] | undefined;
    projectIds?: number[] | undefined;
}

export class RetainerMonthlyExpenseDto implements IRetainerMonthlyExpenseDto {
    label?: string | undefined;
    amounts?: RetainerExpenseAmountDto[] | undefined;

    constructor(data?: IRetainerMonthlyExpenseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            if (Array.isArray(_data["amounts"])) {
                this.amounts = [] as any;
                for (let item of _data["amounts"])
                    this.amounts!.push(RetainerExpenseAmountDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RetainerMonthlyExpenseDto {
        data = typeof data === 'object' ? data : {};
        let result = new RetainerMonthlyExpenseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        if (Array.isArray(this.amounts)) {
            data["amounts"] = [];
            for (let item of this.amounts)
                data["amounts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRetainerMonthlyExpenseDto {
    label?: string | undefined;
    amounts?: RetainerExpenseAmountDto[] | undefined;
}

export class Resource implements IResource {
    id?: number;
    accountingReferenceID?: string | undefined;
    active?: boolean;
    dateFormat?: string | undefined;
    defaultServiceDeskRoleID?: number;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    initials?: string | undefined;
    title?: string | undefined;
    email?: string | undefined;
    email2?: string | undefined;
    email3?: string | undefined;
    emailTypeCode?: string | undefined;
    emailTypeCode2?: string | undefined;
    emailTypeCode3?: string | undefined;
    gender?: string | undefined;
    greeting?: number;
    hiredate?: Date;
    homePhone?: string | undefined;
    internalCost?: number;
    locationID?: number;
    mobilePhone?: string | undefined;
    numberFormat?: string | undefined;
    officeExtension?: string | undefined;
    officePhone?: string | undefined;
    payrollType?: number;
    resourceType?: string | undefined;
    timeFormat?: string | undefined;
    travelAvailabilityPct?: string | undefined;
    userName?: string | undefined;
    userType?: number;
    userDefinedFieldsJson?: string | undefined;
    manualResource?: boolean;

    constructor(data?: IResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountingReferenceID = _data["accountingReferenceID"];
            this.active = _data["active"];
            this.dateFormat = _data["dateFormat"];
            this.defaultServiceDeskRoleID = _data["defaultServiceDeskRoleID"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.suffix = _data["suffix"];
            this.initials = _data["initials"];
            this.title = _data["title"];
            this.email = _data["email"];
            this.email2 = _data["email2"];
            this.email3 = _data["email3"];
            this.emailTypeCode = _data["emailTypeCode"];
            this.emailTypeCode2 = _data["emailTypeCode2"];
            this.emailTypeCode3 = _data["emailTypeCode3"];
            this.gender = _data["gender"];
            this.greeting = _data["greeting"];
            this.hiredate = _data["hiredate"] ? new Date(_data["hiredate"].toString()) : <any>undefined;
            this.homePhone = _data["homePhone"];
            this.internalCost = _data["internalCost"];
            this.locationID = _data["locationID"];
            this.mobilePhone = _data["mobilePhone"];
            this.numberFormat = _data["numberFormat"];
            this.officeExtension = _data["officeExtension"];
            this.officePhone = _data["officePhone"];
            this.payrollType = _data["payrollType"];
            this.resourceType = _data["resourceType"];
            this.timeFormat = _data["timeFormat"];
            this.travelAvailabilityPct = _data["travelAvailabilityPct"];
            this.userName = _data["userName"];
            this.userType = _data["userType"];
            this.userDefinedFieldsJson = _data["userDefinedFieldsJson"];
            this.manualResource = _data["manualResource"];
        }
    }

    static fromJS(data: any): Resource {
        data = typeof data === 'object' ? data : {};
        let result = new Resource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountingReferenceID"] = this.accountingReferenceID;
        data["active"] = this.active;
        data["dateFormat"] = this.dateFormat;
        data["defaultServiceDeskRoleID"] = this.defaultServiceDeskRoleID;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["suffix"] = this.suffix;
        data["initials"] = this.initials;
        data["title"] = this.title;
        data["email"] = this.email;
        data["email2"] = this.email2;
        data["email3"] = this.email3;
        data["emailTypeCode"] = this.emailTypeCode;
        data["emailTypeCode2"] = this.emailTypeCode2;
        data["emailTypeCode3"] = this.emailTypeCode3;
        data["gender"] = this.gender;
        data["greeting"] = this.greeting;
        data["hiredate"] = this.hiredate ? this.hiredate.toISOString() : <any>undefined;
        data["homePhone"] = this.homePhone;
        data["internalCost"] = this.internalCost;
        data["locationID"] = this.locationID;
        data["mobilePhone"] = this.mobilePhone;
        data["numberFormat"] = this.numberFormat;
        data["officeExtension"] = this.officeExtension;
        data["officePhone"] = this.officePhone;
        data["payrollType"] = this.payrollType;
        data["resourceType"] = this.resourceType;
        data["timeFormat"] = this.timeFormat;
        data["travelAvailabilityPct"] = this.travelAvailabilityPct;
        data["userName"] = this.userName;
        data["userType"] = this.userType;
        data["userDefinedFieldsJson"] = this.userDefinedFieldsJson;
        data["manualResource"] = this.manualResource;
        return data;
    }
}

export interface IResource {
    id?: number;
    accountingReferenceID?: string | undefined;
    active?: boolean;
    dateFormat?: string | undefined;
    defaultServiceDeskRoleID?: number;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    initials?: string | undefined;
    title?: string | undefined;
    email?: string | undefined;
    email2?: string | undefined;
    email3?: string | undefined;
    emailTypeCode?: string | undefined;
    emailTypeCode2?: string | undefined;
    emailTypeCode3?: string | undefined;
    gender?: string | undefined;
    greeting?: number;
    hiredate?: Date;
    homePhone?: string | undefined;
    internalCost?: number;
    locationID?: number;
    mobilePhone?: string | undefined;
    numberFormat?: string | undefined;
    officeExtension?: string | undefined;
    officePhone?: string | undefined;
    payrollType?: number;
    resourceType?: string | undefined;
    timeFormat?: string | undefined;
    travelAvailabilityPct?: string | undefined;
    userName?: string | undefined;
    userType?: number;
    userDefinedFieldsJson?: string | undefined;
    manualResource?: boolean;
}

export class TicketAdditionalContact implements ITicketAdditionalContact {
    id?: number;
    contactId?: number;
    ticketId?: number;

    constructor(data?: ITicketAdditionalContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contactId = _data["contactId"];
            this.ticketId = _data["ticketId"];
        }
    }

    static fromJS(data: any): TicketAdditionalContact {
        data = typeof data === 'object' ? data : {};
        let result = new TicketAdditionalContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contactId"] = this.contactId;
        data["ticketId"] = this.ticketId;
        return data;
    }
}

export interface ITicketAdditionalContact {
    id?: number;
    contactId?: number;
    ticketId?: number;
}

export class ClientAccountDTO implements IClientAccountDTO {
    id?: number;
    name?: string | undefined;
    titleWithAx?: string | undefined;
    axReferences?: AXReference[] | undefined;
    userDefinedFields?: string | undefined;
    ticketCount?: number;
    projectCount?: number;
    contractCount?: number;
    canImpersonate?: boolean;
    primaryAXAccount?: string | undefined;

    constructor(data?: IClientAccountDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.titleWithAx = _data["titleWithAx"];
            if (Array.isArray(_data["axReferences"])) {
                this.axReferences = [] as any;
                for (let item of _data["axReferences"])
                    this.axReferences!.push(AXReference.fromJS(item));
            }
            this.userDefinedFields = _data["userDefinedFields"];
            this.ticketCount = _data["ticketCount"];
            this.projectCount = _data["projectCount"];
            this.contractCount = _data["contractCount"];
            this.canImpersonate = _data["canImpersonate"];
            this.primaryAXAccount = _data["primaryAXAccount"];
        }
    }

    static fromJS(data: any): ClientAccountDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ClientAccountDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["titleWithAx"] = this.titleWithAx;
        if (Array.isArray(this.axReferences)) {
            data["axReferences"] = [];
            for (let item of this.axReferences)
                data["axReferences"].push(item.toJSON());
        }
        data["userDefinedFields"] = this.userDefinedFields;
        data["ticketCount"] = this.ticketCount;
        data["projectCount"] = this.projectCount;
        data["contractCount"] = this.contractCount;
        data["canImpersonate"] = this.canImpersonate;
        data["primaryAXAccount"] = this.primaryAXAccount;
        return data;
    }
}

export interface IClientAccountDTO {
    id?: number;
    name?: string | undefined;
    titleWithAx?: string | undefined;
    axReferences?: AXReference[] | undefined;
    userDefinedFields?: string | undefined;
    ticketCount?: number;
    projectCount?: number;
    contractCount?: number;
    canImpersonate?: boolean;
    primaryAXAccount?: string | undefined;
}

export class ClientAccountsDTO implements IClientAccountsDTO {
    clientAccounts?: ClientAccountDTO[] | undefined;
    responseStatus?: number;
    errorMessage?: string | undefined;
    userType?: string | undefined;
    expires?: number;

    constructor(data?: IClientAccountsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["clientAccounts"])) {
                this.clientAccounts = [] as any;
                for (let item of _data["clientAccounts"])
                    this.clientAccounts!.push(ClientAccountDTO.fromJS(item));
            }
            this.responseStatus = _data["responseStatus"];
            this.errorMessage = _data["errorMessage"];
            this.userType = _data["userType"];
            this.expires = _data["expires"];
        }
    }

    static fromJS(data: any): ClientAccountsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ClientAccountsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.clientAccounts)) {
            data["clientAccounts"] = [];
            for (let item of this.clientAccounts)
                data["clientAccounts"].push(item.toJSON());
        }
        data["responseStatus"] = this.responseStatus;
        data["errorMessage"] = this.errorMessage;
        data["userType"] = this.userType;
        data["expires"] = this.expires;
        return data;
    }
}

export interface IClientAccountsDTO {
    clientAccounts?: ClientAccountDTO[] | undefined;
    responseStatus?: number;
    errorMessage?: string | undefined;
    userType?: string | undefined;
    expires?: number;
}

export class ContactTeamRole implements IContactTeamRole {
    id?: number;
    contactId?: number;
    contact!: Contact;
    teamId?: number;
    team!: Team;
    roleId?: number | undefined;
    role?: Role;

    constructor(data?: IContactTeamRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.contact = new Contact();
            this.team = new Team();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contactId = _data["contactId"];
            this.contact = _data["contact"] ? Contact.fromJS(_data["contact"]) : new Contact();
            this.teamId = _data["teamId"];
            this.team = _data["team"] ? Team.fromJS(_data["team"]) : new Team();
            this.roleId = _data["roleId"];
            this.role = _data["role"] ? Role.fromJS(_data["role"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ContactTeamRole {
        data = typeof data === 'object' ? data : {};
        let result = new ContactTeamRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contactId"] = this.contactId;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["teamId"] = this.teamId;
        data["team"] = this.team ? this.team.toJSON() : <any>undefined;
        data["roleId"] = this.roleId;
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        return data;
    }
}

export interface IContactTeamRole {
    id?: number;
    contactId?: number;
    contact: Contact;
    teamId?: number;
    team: Team;
    roleId?: number | undefined;
    role?: Role;
}

export class ContractSLA implements IContractSLA {
    id?: number;
    contractCategory?: number;
    serviceLevelAgreementID?: number;
    contractType?: string | undefined;
    ticketCategoryMappings?: TicketCategoryMapping[] | undefined;

    constructor(data?: IContractSLA) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contractCategory = _data["contractCategory"];
            this.serviceLevelAgreementID = _data["serviceLevelAgreementID"];
            this.contractType = _data["contractType"];
            if (Array.isArray(_data["ticketCategoryMappings"])) {
                this.ticketCategoryMappings = [] as any;
                for (let item of _data["ticketCategoryMappings"])
                    this.ticketCategoryMappings!.push(TicketCategoryMapping.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContractSLA {
        data = typeof data === 'object' ? data : {};
        let result = new ContractSLA();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contractCategory"] = this.contractCategory;
        data["serviceLevelAgreementID"] = this.serviceLevelAgreementID;
        data["contractType"] = this.contractType;
        if (Array.isArray(this.ticketCategoryMappings)) {
            data["ticketCategoryMappings"] = [];
            for (let item of this.ticketCategoryMappings)
                data["ticketCategoryMappings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IContractSLA {
    id?: number;
    contractCategory?: number;
    serviceLevelAgreementID?: number;
    contractType?: string | undefined;
    ticketCategoryMappings?: TicketCategoryMapping[] | undefined;
}

export enum CostAnalyticProviders {
    Aws = "Aws",
    Azure = "Azure",
    Gcp = "Gcp",
    AzureDirect = "AzureDirect",
}

export class CostCenter implements ICostCenter {
    id?: number;
    costCenterId?: string | undefined;
    accountId?: number | undefined;
    account?: Account;
    name?: string | undefined;
    description?: string | undefined;
    purchaseOrderId?: number | undefined;
    purchaseOrder?: PurchaseOrder;
    createTime?: Date;
    modifyTime?: Date;
    isDefaultCostCenter?: boolean;
    configItems?: CostCenterConfigItem[] | undefined;

    constructor(data?: ICostCenter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.isDefaultCostCenter = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.costCenterId = _data["costCenterId"];
            this.accountId = _data["accountId"];
            this.account = _data["account"] ? Account.fromJS(_data["account"]) : <any>undefined;
            this.name = _data["name"];
            this.description = _data["description"];
            this.purchaseOrderId = _data["purchaseOrderId"];
            this.purchaseOrder = _data["purchaseOrder"] ? PurchaseOrder.fromJS(_data["purchaseOrder"]) : <any>undefined;
            this.createTime = _data["createTime"] ? new Date(_data["createTime"].toString()) : <any>undefined;
            this.modifyTime = _data["modifyTime"] ? new Date(_data["modifyTime"].toString()) : <any>undefined;
            this.isDefaultCostCenter = _data["isDefaultCostCenter"] !== undefined ? _data["isDefaultCostCenter"] : false;
            if (Array.isArray(_data["configItems"])) {
                this.configItems = [] as any;
                for (let item of _data["configItems"])
                    this.configItems!.push(CostCenterConfigItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CostCenter {
        data = typeof data === 'object' ? data : {};
        let result = new CostCenter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["costCenterId"] = this.costCenterId;
        data["accountId"] = this.accountId;
        data["account"] = this.account ? this.account.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["description"] = this.description;
        data["purchaseOrderId"] = this.purchaseOrderId;
        data["purchaseOrder"] = this.purchaseOrder ? this.purchaseOrder.toJSON() : <any>undefined;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["modifyTime"] = this.modifyTime ? this.modifyTime.toISOString() : <any>undefined;
        data["isDefaultCostCenter"] = this.isDefaultCostCenter;
        if (Array.isArray(this.configItems)) {
            data["configItems"] = [];
            for (let item of this.configItems)
                data["configItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICostCenter {
    id?: number;
    costCenterId?: string | undefined;
    accountId?: number | undefined;
    account?: Account;
    name?: string | undefined;
    description?: string | undefined;
    purchaseOrderId?: number | undefined;
    purchaseOrder?: PurchaseOrder;
    createTime?: Date;
    modifyTime?: Date;
    isDefaultCostCenter?: boolean;
    configItems?: CostCenterConfigItem[] | undefined;
}

export class CostCenterConfigItem implements ICostCenterConfigItem {
    configurationItemId?: number;
    configurationItem?: ConfigurationItem;
    costCenterId?: number;
    costCenter?: CostCenter;
    createTime?: Date;
    modifyTime?: Date;

    constructor(data?: ICostCenterConfigItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configurationItemId = _data["configurationItemId"];
            this.configurationItem = _data["configurationItem"] ? ConfigurationItem.fromJS(_data["configurationItem"]) : <any>undefined;
            this.costCenterId = _data["costCenterId"];
            this.costCenter = _data["costCenter"] ? CostCenter.fromJS(_data["costCenter"]) : <any>undefined;
            this.createTime = _data["createTime"] ? new Date(_data["createTime"].toString()) : <any>undefined;
            this.modifyTime = _data["modifyTime"] ? new Date(_data["modifyTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CostCenterConfigItem {
        data = typeof data === 'object' ? data : {};
        let result = new CostCenterConfigItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configurationItemId"] = this.configurationItemId;
        data["configurationItem"] = this.configurationItem ? this.configurationItem.toJSON() : <any>undefined;
        data["costCenterId"] = this.costCenterId;
        data["costCenter"] = this.costCenter ? this.costCenter.toJSON() : <any>undefined;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["modifyTime"] = this.modifyTime ? this.modifyTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICostCenterConfigItem {
    configurationItemId?: number;
    configurationItem?: ConfigurationItem;
    costCenterId?: number;
    costCenter?: CostCenter;
    createTime?: Date;
    modifyTime?: Date;
}

export class DynamicTag implements IDynamicTag {
    id?: number;
    accountId?: number;
    contactId?: number;
    sourceIdentifier?: string | undefined;
    tagKey?: string | undefined;
    tagValue?: string | undefined;
    tagType?: string | undefined;

    constructor(data?: IDynamicTag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.contactId = _data["contactId"];
            this.sourceIdentifier = _data["sourceIdentifier"];
            this.tagKey = _data["tagKey"];
            this.tagValue = _data["tagValue"];
            this.tagType = _data["tagType"];
        }
    }

    static fromJS(data: any): DynamicTag {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["contactId"] = this.contactId;
        data["sourceIdentifier"] = this.sourceIdentifier;
        data["tagKey"] = this.tagKey;
        data["tagValue"] = this.tagValue;
        data["tagType"] = this.tagType;
        return data;
    }
}

export interface IDynamicTag {
    id?: number;
    accountId?: number;
    contactId?: number;
    sourceIdentifier?: string | undefined;
    tagKey?: string | undefined;
    tagValue?: string | undefined;
    tagType?: string | undefined;
}

export class ServiceRequestMappingSubmissionTypes implements IServiceRequestMappingSubmissionTypes {
    id?: number;
    name?: string | undefined;

    constructor(data?: IServiceRequestMappingSubmissionTypes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ServiceRequestMappingSubmissionTypes {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestMappingSubmissionTypes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IServiceRequestMappingSubmissionTypes {
    id?: number;
    name?: string | undefined;
}

export class ServiceRequestSubmissionTypes implements IServiceRequestSubmissionTypes {
    id?: number;
    name?: string | undefined;

    constructor(data?: IServiceRequestSubmissionTypes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ServiceRequestSubmissionTypes {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestSubmissionTypes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IServiceRequestSubmissionTypes {
    id?: number;
    name?: string | undefined;
}

export class ServiceRequestTypes implements IServiceRequestTypes {
    id?: number;
    name?: string | undefined;

    constructor(data?: IServiceRequestTypes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ServiceRequestTypes {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestTypes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IServiceRequestTypes {
    id?: number;
    name?: string | undefined;
}

export class PurchaseOrder implements IPurchaseOrder {
    id?: number;
    poNumber?: string | undefined;
    costCenters?: CostCenter[] | undefined;

    constructor(data?: IPurchaseOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.poNumber = _data["poNumber"];
            if (Array.isArray(_data["costCenters"])) {
                this.costCenters = [] as any;
                for (let item of _data["costCenters"])
                    this.costCenters!.push(CostCenter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PurchaseOrder {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["poNumber"] = this.poNumber;
        if (Array.isArray(this.costCenters)) {
            data["costCenters"] = [];
            for (let item of this.costCenters)
                data["costCenters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPurchaseOrder {
    id?: number;
    poNumber?: string | undefined;
    costCenters?: CostCenter[] | undefined;
}

export class Role implements IRole {
    id?: number;
    roleName?: string | undefined;
    contactTeamRole?: ContactTeamRole[] | undefined;

    constructor(data?: IRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.roleName = _data["roleName"];
            if (Array.isArray(_data["contactTeamRole"])) {
                this.contactTeamRole = [] as any;
                for (let item of _data["contactTeamRole"])
                    this.contactTeamRole!.push(ContactTeamRole.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Role {
        data = typeof data === 'object' ? data : {};
        let result = new Role();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["roleName"] = this.roleName;
        if (Array.isArray(this.contactTeamRole)) {
            data["contactTeamRole"] = [];
            for (let item of this.contactTeamRole)
                data["contactTeamRole"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRole {
    id?: number;
    roleName?: string | undefined;
    contactTeamRole?: ContactTeamRole[] | undefined;
}

export class ServiceRequestMapping implements IServiceRequestMapping {
    id?: number;
    submissionTypeId?: number;
    submissionType?: ServiceRequestMappingSubmissionTypes;
    supportOptionName?: string | undefined;
    accountId?: number;
    ticketCategory?: number | undefined;
    issue?: number;
    enabledSubIssues?: string | undefined;
    userInputFieldsJson?: string | undefined;
    serviceRequestTypeId?: number;
    serviceRequestType?: ServiceRequestTypes;
    formSchema!: string;
    formUiSchema!: string;
    rules!: string;
    submitterContactId?: number;
    approverContactId?: number | undefined;
    mappingIdentifier?: string | undefined;
    revision?: number;
    approved?: boolean;
    serviceRequestSubmissionTypeId?: number;
    serviceRequestSubmissionType?: ServiceRequestSubmissionTypes;
    displayAsTile?: boolean;
    tileIcon?: string | undefined;
    tileTitle?: string | undefined;
    tileDescription?: string | undefined;
    tileRoute?: string | undefined;
    canBeIncident?: boolean;
    canBeServiceRequest?: boolean;
    canBeChangeRequest?: boolean;
    displayOrder?: number;

    constructor(data?: IServiceRequestMapping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.submissionTypeId = _data["submissionTypeId"];
            this.submissionType = _data["submissionType"] ? ServiceRequestMappingSubmissionTypes.fromJS(_data["submissionType"]) : <any>undefined;
            this.supportOptionName = _data["supportOptionName"];
            this.accountId = _data["accountId"];
            this.ticketCategory = _data["ticketCategory"];
            this.issue = _data["issue"];
            this.enabledSubIssues = _data["enabledSubIssues"];
            this.userInputFieldsJson = _data["userInputFieldsJson"];
            this.serviceRequestTypeId = _data["serviceRequestTypeId"];
            this.serviceRequestType = _data["serviceRequestType"] ? ServiceRequestTypes.fromJS(_data["serviceRequestType"]) : <any>undefined;
            this.formSchema = _data["formSchema"];
            this.formUiSchema = _data["formUiSchema"];
            this.rules = _data["rules"];
            this.submitterContactId = _data["submitterContactId"];
            this.approverContactId = _data["approverContactId"];
            this.mappingIdentifier = _data["mappingIdentifier"];
            this.revision = _data["revision"];
            this.approved = _data["approved"];
            this.serviceRequestSubmissionTypeId = _data["serviceRequestSubmissionTypeId"];
            this.serviceRequestSubmissionType = _data["serviceRequestSubmissionType"] ? ServiceRequestSubmissionTypes.fromJS(_data["serviceRequestSubmissionType"]) : <any>undefined;
            this.displayAsTile = _data["displayAsTile"];
            this.tileIcon = _data["tileIcon"];
            this.tileTitle = _data["tileTitle"];
            this.tileDescription = _data["tileDescription"];
            this.tileRoute = _data["tileRoute"];
            this.canBeIncident = _data["canBeIncident"];
            this.canBeServiceRequest = _data["canBeServiceRequest"];
            this.canBeChangeRequest = _data["canBeChangeRequest"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): ServiceRequestMapping {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestMapping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["submissionTypeId"] = this.submissionTypeId;
        data["submissionType"] = this.submissionType ? this.submissionType.toJSON() : <any>undefined;
        data["supportOptionName"] = this.supportOptionName;
        data["accountId"] = this.accountId;
        data["ticketCategory"] = this.ticketCategory;
        data["issue"] = this.issue;
        data["enabledSubIssues"] = this.enabledSubIssues;
        data["userInputFieldsJson"] = this.userInputFieldsJson;
        data["serviceRequestTypeId"] = this.serviceRequestTypeId;
        data["serviceRequestType"] = this.serviceRequestType ? this.serviceRequestType.toJSON() : <any>undefined;
        data["formSchema"] = this.formSchema;
        data["formUiSchema"] = this.formUiSchema;
        data["rules"] = this.rules;
        data["submitterContactId"] = this.submitterContactId;
        data["approverContactId"] = this.approverContactId;
        data["mappingIdentifier"] = this.mappingIdentifier;
        data["revision"] = this.revision;
        data["approved"] = this.approved;
        data["serviceRequestSubmissionTypeId"] = this.serviceRequestSubmissionTypeId;
        data["serviceRequestSubmissionType"] = this.serviceRequestSubmissionType ? this.serviceRequestSubmissionType.toJSON() : <any>undefined;
        data["displayAsTile"] = this.displayAsTile;
        data["tileIcon"] = this.tileIcon;
        data["tileTitle"] = this.tileTitle;
        data["tileDescription"] = this.tileDescription;
        data["tileRoute"] = this.tileRoute;
        data["canBeIncident"] = this.canBeIncident;
        data["canBeServiceRequest"] = this.canBeServiceRequest;
        data["canBeChangeRequest"] = this.canBeChangeRequest;
        data["displayOrder"] = this.displayOrder;
        return data;
    }
}

export interface IServiceRequestMapping {
    id?: number;
    submissionTypeId?: number;
    submissionType?: ServiceRequestMappingSubmissionTypes;
    supportOptionName?: string | undefined;
    accountId?: number;
    ticketCategory?: number | undefined;
    issue?: number;
    enabledSubIssues?: string | undefined;
    userInputFieldsJson?: string | undefined;
    serviceRequestTypeId?: number;
    serviceRequestType?: ServiceRequestTypes;
    formSchema: string;
    formUiSchema: string;
    rules: string;
    submitterContactId?: number;
    approverContactId?: number | undefined;
    mappingIdentifier?: string | undefined;
    revision?: number;
    approved?: boolean;
    serviceRequestSubmissionTypeId?: number;
    serviceRequestSubmissionType?: ServiceRequestSubmissionTypes;
    displayAsTile?: boolean;
    tileIcon?: string | undefined;
    tileTitle?: string | undefined;
    tileDescription?: string | undefined;
    tileRoute?: string | undefined;
    canBeIncident?: boolean;
    canBeServiceRequest?: boolean;
    canBeChangeRequest?: boolean;
    displayOrder?: number;
}

export class Team implements ITeam {
    id?: number;
    teamName?: string | undefined;
    account?: Account;
    teamTicketCategoryMappings?: TeamTicketCategoryMapping[] | undefined;
    contactTeamRole?: ContactTeamRole[] | undefined;
    teamContracts?: TeamContract[] | undefined;
    teamConfigItems?: TeamConfigItem[] | undefined;
    deleted?: boolean;
    isDefaultGroup?: boolean;
    permissionStatements?: string | undefined;

    constructor(data?: ITeam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.teamName = _data["teamName"];
            this.account = _data["account"] ? Account.fromJS(_data["account"]) : <any>undefined;
            if (Array.isArray(_data["teamTicketCategoryMappings"])) {
                this.teamTicketCategoryMappings = [] as any;
                for (let item of _data["teamTicketCategoryMappings"])
                    this.teamTicketCategoryMappings!.push(TeamTicketCategoryMapping.fromJS(item));
            }
            if (Array.isArray(_data["contactTeamRole"])) {
                this.contactTeamRole = [] as any;
                for (let item of _data["contactTeamRole"])
                    this.contactTeamRole!.push(ContactTeamRole.fromJS(item));
            }
            if (Array.isArray(_data["teamContracts"])) {
                this.teamContracts = [] as any;
                for (let item of _data["teamContracts"])
                    this.teamContracts!.push(TeamContract.fromJS(item));
            }
            if (Array.isArray(_data["teamConfigItems"])) {
                this.teamConfigItems = [] as any;
                for (let item of _data["teamConfigItems"])
                    this.teamConfigItems!.push(TeamConfigItem.fromJS(item));
            }
            this.deleted = _data["deleted"];
            this.isDefaultGroup = _data["isDefaultGroup"];
            this.permissionStatements = _data["permissionStatements"];
        }
    }

    static fromJS(data: any): Team {
        data = typeof data === 'object' ? data : {};
        let result = new Team();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["teamName"] = this.teamName;
        data["account"] = this.account ? this.account.toJSON() : <any>undefined;
        if (Array.isArray(this.teamTicketCategoryMappings)) {
            data["teamTicketCategoryMappings"] = [];
            for (let item of this.teamTicketCategoryMappings)
                data["teamTicketCategoryMappings"].push(item.toJSON());
        }
        if (Array.isArray(this.contactTeamRole)) {
            data["contactTeamRole"] = [];
            for (let item of this.contactTeamRole)
                data["contactTeamRole"].push(item.toJSON());
        }
        if (Array.isArray(this.teamContracts)) {
            data["teamContracts"] = [];
            for (let item of this.teamContracts)
                data["teamContracts"].push(item.toJSON());
        }
        if (Array.isArray(this.teamConfigItems)) {
            data["teamConfigItems"] = [];
            for (let item of this.teamConfigItems)
                data["teamConfigItems"].push(item.toJSON());
        }
        data["deleted"] = this.deleted;
        data["isDefaultGroup"] = this.isDefaultGroup;
        data["permissionStatements"] = this.permissionStatements;
        return data;
    }
}

export interface ITeam {
    id?: number;
    teamName?: string | undefined;
    account?: Account;
    teamTicketCategoryMappings?: TeamTicketCategoryMapping[] | undefined;
    contactTeamRole?: ContactTeamRole[] | undefined;
    teamContracts?: TeamContract[] | undefined;
    teamConfigItems?: TeamConfigItem[] | undefined;
    deleted?: boolean;
    isDefaultGroup?: boolean;
    permissionStatements?: string | undefined;
}

export class TeamConfigItem implements ITeamConfigItem {
    configurationItemId?: number;
    configurationItem?: ConfigurationItem;
    teamId?: number;
    team?: Team;

    constructor(data?: ITeamConfigItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configurationItemId = _data["configurationItemId"];
            this.configurationItem = _data["configurationItem"] ? ConfigurationItem.fromJS(_data["configurationItem"]) : <any>undefined;
            this.teamId = _data["teamId"];
            this.team = _data["team"] ? Team.fromJS(_data["team"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TeamConfigItem {
        data = typeof data === 'object' ? data : {};
        let result = new TeamConfigItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configurationItemId"] = this.configurationItemId;
        data["configurationItem"] = this.configurationItem ? this.configurationItem.toJSON() : <any>undefined;
        data["teamId"] = this.teamId;
        data["team"] = this.team ? this.team.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITeamConfigItem {
    configurationItemId?: number;
    configurationItem?: ConfigurationItem;
    teamId?: number;
    team?: Team;
}

export class TeamContract implements ITeamContract {
    contractId?: number;
    contract?: Contract;
    teamId?: number;
    team?: Team;

    constructor(data?: ITeamContract) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractId = _data["contractId"];
            this.contract = _data["contract"] ? Contract.fromJS(_data["contract"]) : <any>undefined;
            this.teamId = _data["teamId"];
            this.team = _data["team"] ? Team.fromJS(_data["team"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TeamContract {
        data = typeof data === 'object' ? data : {};
        let result = new TeamContract();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractId"] = this.contractId;
        data["contract"] = this.contract ? this.contract.toJSON() : <any>undefined;
        data["teamId"] = this.teamId;
        data["team"] = this.team ? this.team.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITeamContract {
    contractId?: number;
    contract?: Contract;
    teamId?: number;
    team?: Team;
}

export class TeamTicketCategoryMapping implements ITeamTicketCategoryMapping {
    teamId?: number;
    team?: Team;
    ticketCategoryMappingId?: number;
    ticketCategoryMapping?: TicketCategoryMapping;
    contractId?: number;
    enabledIssueType?: string | undefined;

    constructor(data?: ITeamTicketCategoryMapping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamId = _data["teamId"];
            this.team = _data["team"] ? Team.fromJS(_data["team"]) : <any>undefined;
            this.ticketCategoryMappingId = _data["ticketCategoryMappingId"];
            this.ticketCategoryMapping = _data["ticketCategoryMapping"] ? TicketCategoryMapping.fromJS(_data["ticketCategoryMapping"]) : <any>undefined;
            this.contractId = _data["contractId"];
            this.enabledIssueType = _data["enabledIssueType"];
        }
    }

    static fromJS(data: any): TeamTicketCategoryMapping {
        data = typeof data === 'object' ? data : {};
        let result = new TeamTicketCategoryMapping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamId"] = this.teamId;
        data["team"] = this.team ? this.team.toJSON() : <any>undefined;
        data["ticketCategoryMappingId"] = this.ticketCategoryMappingId;
        data["ticketCategoryMapping"] = this.ticketCategoryMapping ? this.ticketCategoryMapping.toJSON() : <any>undefined;
        data["contractId"] = this.contractId;
        data["enabledIssueType"] = this.enabledIssueType;
        return data;
    }
}

export interface ITeamTicketCategoryMapping {
    teamId?: number;
    team?: Team;
    ticketCategoryMappingId?: number;
    ticketCategoryMapping?: TicketCategoryMapping;
    contractId?: number;
    enabledIssueType?: string | undefined;
}

export class TicketCategoryMapping implements ITicketCategoryMapping {
    id?: number;
    contractSLA?: ContractSLA;
    contractSLAId?: number;
    ticketCategoryId?: number;
    listOfValidIssueTypes?: string | undefined;
    teamTicketCategoryMappings?: TeamTicketCategoryMapping[] | undefined;

    constructor(data?: ITicketCategoryMapping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contractSLA = _data["contractSLA"] ? ContractSLA.fromJS(_data["contractSLA"]) : <any>undefined;
            this.contractSLAId = _data["contractSLAId"];
            this.ticketCategoryId = _data["ticketCategoryId"];
            this.listOfValidIssueTypes = _data["listOfValidIssueTypes"];
            if (Array.isArray(_data["teamTicketCategoryMappings"])) {
                this.teamTicketCategoryMappings = [] as any;
                for (let item of _data["teamTicketCategoryMappings"])
                    this.teamTicketCategoryMappings!.push(TeamTicketCategoryMapping.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TicketCategoryMapping {
        data = typeof data === 'object' ? data : {};
        let result = new TicketCategoryMapping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contractSLA"] = this.contractSLA ? this.contractSLA.toJSON() : <any>undefined;
        data["contractSLAId"] = this.contractSLAId;
        data["ticketCategoryId"] = this.ticketCategoryId;
        data["listOfValidIssueTypes"] = this.listOfValidIssueTypes;
        if (Array.isArray(this.teamTicketCategoryMappings)) {
            data["teamTicketCategoryMappings"] = [];
            for (let item of this.teamTicketCategoryMappings)
                data["teamTicketCategoryMappings"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITicketCategoryMapping {
    id?: number;
    contractSLA?: ContractSLA;
    contractSLAId?: number;
    ticketCategoryId?: number;
    listOfValidIssueTypes?: string | undefined;
    teamTicketCategoryMappings?: TeamTicketCategoryMapping[] | undefined;
}

export class UserProfile implements IUserProfile {
    id?: number;
    displayName?: string | undefined;
    givenName?: string | undefined;
    surname?: string | undefined;
    phoneNumber?: string | undefined;
    extension?: string | undefined;
    mail?: string | undefined;
    isParentAccountAdmin?: boolean;
    lastRefresh?: Date;
    contact?: Contact;
    contactId?: number | undefined;
    approved?: boolean;
    accountId?: number | undefined;
    autotaskAdmin?: boolean;
    emailRequestSent?: boolean;
    emailRequestSentTime?: Date;
    lastActivity?: Date;
    loginCount?: number;
    isGuestUser?: boolean;

    constructor(data?: IUserProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.givenName = _data["givenName"];
            this.surname = _data["surname"];
            this.phoneNumber = _data["phoneNumber"];
            this.extension = _data["extension"];
            this.mail = _data["mail"];
            this.isParentAccountAdmin = _data["isParentAccountAdmin"];
            this.lastRefresh = _data["lastRefresh"] ? new Date(_data["lastRefresh"].toString()) : <any>undefined;
            this.contact = _data["contact"] ? Contact.fromJS(_data["contact"]) : <any>undefined;
            this.contactId = _data["contactId"];
            this.approved = _data["approved"];
            this.accountId = _data["accountId"];
            this.autotaskAdmin = _data["autotaskAdmin"];
            this.emailRequestSent = _data["emailRequestSent"];
            this.emailRequestSentTime = _data["emailRequestSentTime"] ? new Date(_data["emailRequestSentTime"].toString()) : <any>undefined;
            this.lastActivity = _data["lastActivity"] ? new Date(_data["lastActivity"].toString()) : <any>undefined;
            this.loginCount = _data["loginCount"];
            this.isGuestUser = _data["isGuestUser"];
        }
    }

    static fromJS(data: any): UserProfile {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["givenName"] = this.givenName;
        data["surname"] = this.surname;
        data["phoneNumber"] = this.phoneNumber;
        data["extension"] = this.extension;
        data["mail"] = this.mail;
        data["isParentAccountAdmin"] = this.isParentAccountAdmin;
        data["lastRefresh"] = this.lastRefresh ? this.lastRefresh.toISOString() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["contactId"] = this.contactId;
        data["approved"] = this.approved;
        data["accountId"] = this.accountId;
        data["autotaskAdmin"] = this.autotaskAdmin;
        data["emailRequestSent"] = this.emailRequestSent;
        data["emailRequestSentTime"] = this.emailRequestSentTime ? this.emailRequestSentTime.toISOString() : <any>undefined;
        data["lastActivity"] = this.lastActivity ? this.lastActivity.toISOString() : <any>undefined;
        data["loginCount"] = this.loginCount;
        data["isGuestUser"] = this.isGuestUser;
        return data;
    }
}

export interface IUserProfile {
    id?: number;
    displayName?: string | undefined;
    givenName?: string | undefined;
    surname?: string | undefined;
    phoneNumber?: string | undefined;
    extension?: string | undefined;
    mail?: string | undefined;
    isParentAccountAdmin?: boolean;
    lastRefresh?: Date;
    contact?: Contact;
    contactId?: number | undefined;
    approved?: boolean;
    accountId?: number | undefined;
    autotaskAdmin?: boolean;
    emailRequestSent?: boolean;
    emailRequestSentTime?: Date;
    lastActivity?: Date;
    loginCount?: number;
    isGuestUser?: boolean;
}

export enum BusinessUnitPathType {
    CompanyId = "CompanyId",
    BusinessUnitId = "BusinessUnitId",
    SegmentId = "SegmentId",
    DivisionId = "DivisionId",
    RegionId = "RegionId",
    DistrictId = "DistrictId",
}

export enum UserRole {
    User = "User",
    Admin = "Admin",
}

export enum UserStatus {
    Active = "Active",
    InActive = "InActive",
}

export enum ResponseStatusValues {
    Success = "Success",
    InvalidLogin = "InvalidLogin",
    Error = "Error",
    ProfileNotConfigured = "ProfileNotConfigured",
    AccountPendingApproval = "AccountPendingApproval",
    AccessRequested = "AccessRequested",
    UserNotAssignedToAccount = "UserNotAssignedToAccount",
    ExternalProcessingError = "ExternalProcessingError",
    InternalProcessingError = "InternalProcessingError",
    Unauthorized = "Unauthorized",
    AuthenticationError = "AuthenticationError",
    Failed = "Failed",
}

export enum ServiceRequestCloudTypes {
    AWS = "AWS",
    GCP = "GCP",
}

export class AccountContractResponse implements IAccountContractResponse {
    contractSummary?: ContractReport;
    resultInfo?: PagedResultData;
    resultContracts?: ContractDto[] | undefined;
    resultContacts?: Contact[] | undefined;

    constructor(data?: IAccountContractResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractSummary = _data["contractSummary"] ? ContractReport.fromJS(_data["contractSummary"]) : <any>undefined;
            this.resultInfo = _data["resultInfo"] ? PagedResultData.fromJS(_data["resultInfo"]) : <any>undefined;
            if (Array.isArray(_data["resultContracts"])) {
                this.resultContracts = [] as any;
                for (let item of _data["resultContracts"])
                    this.resultContracts!.push(ContractDto.fromJS(item));
            }
            if (Array.isArray(_data["resultContacts"])) {
                this.resultContacts = [] as any;
                for (let item of _data["resultContacts"])
                    this.resultContacts!.push(Contact.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccountContractResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AccountContractResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractSummary"] = this.contractSummary ? this.contractSummary.toJSON() : <any>undefined;
        data["resultInfo"] = this.resultInfo ? this.resultInfo.toJSON() : <any>undefined;
        if (Array.isArray(this.resultContracts)) {
            data["resultContracts"] = [];
            for (let item of this.resultContracts)
                data["resultContracts"].push(item.toJSON());
        }
        if (Array.isArray(this.resultContacts)) {
            data["resultContacts"] = [];
            for (let item of this.resultContacts)
                data["resultContacts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAccountContractResponse {
    contractSummary?: ContractReport;
    resultInfo?: PagedResultData;
    resultContracts?: ContractDto[] | undefined;
    resultContacts?: Contact[] | undefined;
}

export class AccountNameWithAxNumber implements IAccountNameWithAxNumber {
    accountName?: string | undefined;
    axNumber?: string | undefined;

    constructor(data?: IAccountNameWithAxNumber) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountName = _data["accountName"];
            this.axNumber = _data["axNumber"];
        }
    }

    static fromJS(data: any): AccountNameWithAxNumber {
        data = typeof data === 'object' ? data : {};
        let result = new AccountNameWithAxNumber();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName;
        data["axNumber"] = this.axNumber;
        return data;
    }
}

export interface IAccountNameWithAxNumber {
    accountName?: string | undefined;
    axNumber?: string | undefined;
}

export class AccountTeamLastSyncDateTime implements IAccountTeamLastSyncDateTime {
    id?: number;
    accountId?: number;
    lastSyncDateTime?: Date;

    constructor(data?: IAccountTeamLastSyncDateTime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.lastSyncDateTime = _data["lastSyncDateTime"] ? new Date(_data["lastSyncDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AccountTeamLastSyncDateTime {
        data = typeof data === 'object' ? data : {};
        let result = new AccountTeamLastSyncDateTime();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["lastSyncDateTime"] = this.lastSyncDateTime ? this.lastSyncDateTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAccountTeamLastSyncDateTime {
    id?: number;
    accountId?: number;
    lastSyncDateTime?: Date;
}

export class AccountTeamMember implements IAccountTeamMember {
    id?: number;
    contactId?: number | undefined;
    accountId?: number;
    readAccess?: boolean;
    writeAccess?: boolean;
    manageAccess?: boolean;
    note?: string | undefined;
    source?: string | undefined;
    jobTitle?: string | undefined;
    accountTeamMemberRoleId?: number;
    accountTeamMemberRole?: AccountTeamMemberRole;
    systemUserId?: string | undefined;
    crmUserDetails?: CrmUserDetails;
    createdUtc?: Date;
    createdBy?: number | undefined;
    modifiedUtc?: Date;
    modifiedBy?: number | undefined;
    deleted?: boolean;
    deletedUtc?: Date | undefined;
    deletedBy?: number | undefined;

    constructor(data?: IAccountTeamMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contactId = _data["contactId"];
            this.accountId = _data["accountId"];
            this.readAccess = _data["readAccess"];
            this.writeAccess = _data["writeAccess"];
            this.manageAccess = _data["manageAccess"];
            this.note = _data["note"];
            this.source = _data["source"];
            this.jobTitle = _data["jobTitle"];
            this.accountTeamMemberRoleId = _data["accountTeamMemberRoleId"];
            this.accountTeamMemberRole = _data["accountTeamMemberRole"] ? AccountTeamMemberRole.fromJS(_data["accountTeamMemberRole"]) : <any>undefined;
            this.systemUserId = _data["systemUserId"];
            this.crmUserDetails = _data["crmUserDetails"] ? CrmUserDetails.fromJS(_data["crmUserDetails"]) : <any>undefined;
            this.createdUtc = _data["createdUtc"] ? new Date(_data["createdUtc"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.modifiedUtc = _data["modifiedUtc"] ? new Date(_data["modifiedUtc"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.deleted = _data["deleted"];
            this.deletedUtc = _data["deletedUtc"] ? new Date(_data["deletedUtc"].toString()) : <any>undefined;
            this.deletedBy = _data["deletedBy"];
        }
    }

    static fromJS(data: any): AccountTeamMember {
        data = typeof data === 'object' ? data : {};
        let result = new AccountTeamMember();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contactId"] = this.contactId;
        data["accountId"] = this.accountId;
        data["readAccess"] = this.readAccess;
        data["writeAccess"] = this.writeAccess;
        data["manageAccess"] = this.manageAccess;
        data["note"] = this.note;
        data["source"] = this.source;
        data["jobTitle"] = this.jobTitle;
        data["accountTeamMemberRoleId"] = this.accountTeamMemberRoleId;
        data["accountTeamMemberRole"] = this.accountTeamMemberRole ? this.accountTeamMemberRole.toJSON() : <any>undefined;
        data["systemUserId"] = this.systemUserId;
        data["crmUserDetails"] = this.crmUserDetails ? this.crmUserDetails.toJSON() : <any>undefined;
        data["createdUtc"] = this.createdUtc ? this.createdUtc.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["modifiedUtc"] = this.modifiedUtc ? this.modifiedUtc.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["deleted"] = this.deleted;
        data["deletedUtc"] = this.deletedUtc ? this.deletedUtc.toISOString() : <any>undefined;
        data["deletedBy"] = this.deletedBy;
        return data;
    }
}

export interface IAccountTeamMember {
    id?: number;
    contactId?: number | undefined;
    accountId?: number;
    readAccess?: boolean;
    writeAccess?: boolean;
    manageAccess?: boolean;
    note?: string | undefined;
    source?: string | undefined;
    jobTitle?: string | undefined;
    accountTeamMemberRoleId?: number;
    accountTeamMemberRole?: AccountTeamMemberRole;
    systemUserId?: string | undefined;
    crmUserDetails?: CrmUserDetails;
    createdUtc?: Date;
    createdBy?: number | undefined;
    modifiedUtc?: Date;
    modifiedBy?: number | undefined;
    deleted?: boolean;
    deletedUtc?: Date | undefined;
    deletedBy?: number | undefined;
}

export class AccountTeamMemberRole implements IAccountTeamMemberRole {
    id?: number;
    name?: string | undefined;
    accountTeamMembers?: AccountTeamMember[] | undefined;

    constructor(data?: IAccountTeamMemberRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["accountTeamMembers"])) {
                this.accountTeamMembers = [] as any;
                for (let item of _data["accountTeamMembers"])
                    this.accountTeamMembers!.push(AccountTeamMember.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccountTeamMemberRole {
        data = typeof data === 'object' ? data : {};
        let result = new AccountTeamMemberRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.accountTeamMembers)) {
            data["accountTeamMembers"] = [];
            for (let item of this.accountTeamMembers)
                data["accountTeamMembers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAccountTeamMemberRole {
    id?: number;
    name?: string | undefined;
    accountTeamMembers?: AccountTeamMember[] | undefined;
}

export class AccountTeamMemberSyncDetails implements IAccountTeamMemberSyncDetails {
    teamid?: string | undefined;
    ownerid?: string | undefined;
    teammembership_association?: CrmAccountTeamMember[] | undefined;
    teammembership_associationodataNextLink?: string | undefined;

    constructor(data?: IAccountTeamMemberSyncDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamid = _data["teamid"];
            this.ownerid = _data["ownerid"];
            if (Array.isArray(_data["teammembership_association"])) {
                this.teammembership_association = [] as any;
                for (let item of _data["teammembership_association"])
                    this.teammembership_association!.push(CrmAccountTeamMember.fromJS(item));
            }
            this.teammembership_associationodataNextLink = _data["teammembership_association@odata.nextLink"];
        }
    }

    static fromJS(data: any): AccountTeamMemberSyncDetails {
        data = typeof data === 'object' ? data : {};
        let result = new AccountTeamMemberSyncDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamid"] = this.teamid;
        data["ownerid"] = this.ownerid;
        if (Array.isArray(this.teammembership_association)) {
            data["teammembership_association"] = [];
            for (let item of this.teammembership_association)
                data["teammembership_association"].push(item.toJSON());
        }
        data["teammembership_association@odata.nextLink"] = this.teammembership_associationodataNextLink;
        return data;
    }
}

export interface IAccountTeamMemberSyncDetails {
    teamid?: string | undefined;
    ownerid?: string | undefined;
    teammembership_association?: CrmAccountTeamMember[] | undefined;
    teammembership_associationodataNextLink?: string | undefined;
}

export class AccountWelcomeLink implements IAccountWelcomeLink {
    id?: number;
    linkId?: string;
    expirationDate?: Date;
    email?: string | undefined;
    domain?: string | undefined;
    accountID?: number;
    completed?: boolean;
    microsoftSSOSelected?: boolean;
    microsoftSSOSuccessful?: boolean;
    createdContactId?: number;
    createdContact?: Contact;

    constructor(data?: IAccountWelcomeLink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.linkId = _data["linkId"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            this.email = _data["email"];
            this.domain = _data["domain"];
            this.accountID = _data["accountID"];
            this.completed = _data["completed"];
            this.microsoftSSOSelected = _data["microsoftSSOSelected"];
            this.microsoftSSOSuccessful = _data["microsoftSSOSuccessful"];
            this.createdContactId = _data["createdContactId"];
            this.createdContact = _data["createdContact"] ? Contact.fromJS(_data["createdContact"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AccountWelcomeLink {
        data = typeof data === 'object' ? data : {};
        let result = new AccountWelcomeLink();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["linkId"] = this.linkId;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["email"] = this.email;
        data["domain"] = this.domain;
        data["accountID"] = this.accountID;
        data["completed"] = this.completed;
        data["microsoftSSOSelected"] = this.microsoftSSOSelected;
        data["microsoftSSOSuccessful"] = this.microsoftSSOSuccessful;
        data["createdContactId"] = this.createdContactId;
        data["createdContact"] = this.createdContact ? this.createdContact.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAccountWelcomeLink {
    id?: number;
    linkId?: string;
    expirationDate?: Date;
    email?: string | undefined;
    domain?: string | undefined;
    accountID?: number;
    completed?: boolean;
    microsoftSSOSelected?: boolean;
    microsoftSSOSuccessful?: boolean;
    createdContactId?: number;
    createdContact?: Contact;
}

export class ActiveDirectoryAccountTeamMember implements IActiveDirectoryAccountTeamMember {
    activeDirectoryId?: string | undefined;
    emailAddress?: string | undefined;

    constructor(data?: IActiveDirectoryAccountTeamMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activeDirectoryId = _data["activeDirectoryId"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): ActiveDirectoryAccountTeamMember {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveDirectoryAccountTeamMember();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeDirectoryId"] = this.activeDirectoryId;
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface IActiveDirectoryAccountTeamMember {
    activeDirectoryId?: string | undefined;
    emailAddress?: string | undefined;
}

export class AllServiceRequestsRequest implements IAllServiceRequestsRequest {
    pageNumber?: number;
    pageSize?: number;
    searchString?: string | undefined;
    issueType?: number | undefined;
    status?: number[] | undefined;
    contractIds?: number[] | undefined;
    ticketCategoryIds?: number[] | undefined;
    issueIds?: number[] | undefined;
    priority?: number | undefined;
    ticketType?: number | undefined;
    contractId?: number | undefined;
    accountId?: number | undefined;
    createdBefore?: Date | undefined;
    createdAfter?: Date | undefined;
    completedBefore?: Date | undefined;
    completedAfter?: Date | undefined;
    lastUpdatedBefore?: Date | undefined;
    lastUpdatedAfter?: Date | undefined;
    accounts?: number[] | undefined;
    orderBy?: string | undefined;
    orderDirection?: string | undefined;

    constructor(data?: IAllServiceRequestsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.searchString = _data["searchString"];
            this.issueType = _data["issueType"];
            if (Array.isArray(_data["status"])) {
                this.status = [] as any;
                for (let item of _data["status"])
                    this.status!.push(item);
            }
            if (Array.isArray(_data["contractIds"])) {
                this.contractIds = [] as any;
                for (let item of _data["contractIds"])
                    this.contractIds!.push(item);
            }
            if (Array.isArray(_data["ticketCategoryIds"])) {
                this.ticketCategoryIds = [] as any;
                for (let item of _data["ticketCategoryIds"])
                    this.ticketCategoryIds!.push(item);
            }
            if (Array.isArray(_data["issueIds"])) {
                this.issueIds = [] as any;
                for (let item of _data["issueIds"])
                    this.issueIds!.push(item);
            }
            this.priority = _data["priority"];
            this.ticketType = _data["ticketType"];
            this.contractId = _data["contractId"];
            this.accountId = _data["accountId"];
            this.createdBefore = _data["createdBefore"] ? new Date(_data["createdBefore"].toString()) : <any>undefined;
            this.createdAfter = _data["createdAfter"] ? new Date(_data["createdAfter"].toString()) : <any>undefined;
            this.completedBefore = _data["completedBefore"] ? new Date(_data["completedBefore"].toString()) : <any>undefined;
            this.completedAfter = _data["completedAfter"] ? new Date(_data["completedAfter"].toString()) : <any>undefined;
            this.lastUpdatedBefore = _data["lastUpdatedBefore"] ? new Date(_data["lastUpdatedBefore"].toString()) : <any>undefined;
            this.lastUpdatedAfter = _data["lastUpdatedAfter"] ? new Date(_data["lastUpdatedAfter"].toString()) : <any>undefined;
            if (Array.isArray(_data["accounts"])) {
                this.accounts = [] as any;
                for (let item of _data["accounts"])
                    this.accounts!.push(item);
            }
            this.orderBy = _data["orderBy"];
            this.orderDirection = _data["orderDirection"];
        }
    }

    static fromJS(data: any): AllServiceRequestsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AllServiceRequestsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["searchString"] = this.searchString;
        data["issueType"] = this.issueType;
        if (Array.isArray(this.status)) {
            data["status"] = [];
            for (let item of this.status)
                data["status"].push(item);
        }
        if (Array.isArray(this.contractIds)) {
            data["contractIds"] = [];
            for (let item of this.contractIds)
                data["contractIds"].push(item);
        }
        if (Array.isArray(this.ticketCategoryIds)) {
            data["ticketCategoryIds"] = [];
            for (let item of this.ticketCategoryIds)
                data["ticketCategoryIds"].push(item);
        }
        if (Array.isArray(this.issueIds)) {
            data["issueIds"] = [];
            for (let item of this.issueIds)
                data["issueIds"].push(item);
        }
        data["priority"] = this.priority;
        data["ticketType"] = this.ticketType;
        data["contractId"] = this.contractId;
        data["accountId"] = this.accountId;
        data["createdBefore"] = this.createdBefore ? this.createdBefore.toISOString() : <any>undefined;
        data["createdAfter"] = this.createdAfter ? this.createdAfter.toISOString() : <any>undefined;
        data["completedBefore"] = this.completedBefore ? this.completedBefore.toISOString() : <any>undefined;
        data["completedAfter"] = this.completedAfter ? this.completedAfter.toISOString() : <any>undefined;
        data["lastUpdatedBefore"] = this.lastUpdatedBefore ? this.lastUpdatedBefore.toISOString() : <any>undefined;
        data["lastUpdatedAfter"] = this.lastUpdatedAfter ? this.lastUpdatedAfter.toISOString() : <any>undefined;
        if (Array.isArray(this.accounts)) {
            data["accounts"] = [];
            for (let item of this.accounts)
                data["accounts"].push(item);
        }
        data["orderBy"] = this.orderBy;
        data["orderDirection"] = this.orderDirection;
        return data;
    }
}

export interface IAllServiceRequestsRequest {
    pageNumber?: number;
    pageSize?: number;
    searchString?: string | undefined;
    issueType?: number | undefined;
    status?: number[] | undefined;
    contractIds?: number[] | undefined;
    ticketCategoryIds?: number[] | undefined;
    issueIds?: number[] | undefined;
    priority?: number | undefined;
    ticketType?: number | undefined;
    contractId?: number | undefined;
    accountId?: number | undefined;
    createdBefore?: Date | undefined;
    createdAfter?: Date | undefined;
    completedBefore?: Date | undefined;
    completedAfter?: Date | undefined;
    lastUpdatedBefore?: Date | undefined;
    lastUpdatedAfter?: Date | undefined;
    accounts?: number[] | undefined;
    orderBy?: string | undefined;
    orderDirection?: string | undefined;
}

export class IntegrationMetadata implements IIntegrationMetadata {
    status?: string | undefined;

    protected _discriminator: string;

    constructor(data?: IIntegrationMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "IntegrationMetadata";
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): IntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        if (data["typeName"] === "GcpUsageReportIntegrationMetadata") {
            let result = new GcpUsageReportIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AssessmentIntegrationMetadata") {
            let result = new AssessmentIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AwsBillingReportIntegrationMetadata") {
            let result = new AwsBillingReportIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AwsComplianceIntegrationMetadata") {
            let result = new AwsComplianceIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AwsSimpleRecommendationsIntegrationMetadata") {
            let result = new AwsSimpleRecommendationsIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AzureDevOpsReportIntegrationMetadata") {
            let result = new AzureDevOpsReportIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AzureIntegrationMetadata") {
            let result = new AzureIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AzurePlanReportIntegrationMetadata") {
            let result = new AzurePlanReportIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "CatalystIntegrationMetadata") {
            let result = new CatalystIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "CiscoMerakiCustomerMetadata") {
            let result = new CiscoMerakiCustomerMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AwsResourceExplorerMetadata") {
            let result = new AwsResourceExplorerMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "GcpCloudAssetInventoryMetadata") {
            let result = new GcpCloudAssetInventoryMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "HardwareLifecycleIntegrationMetadata") {
            let result = new HardwareLifecycleIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "IdcsReportIntegrationMetadata") {
            let result = new IdcsReportIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "RackAndStackIntegrationMetadata") {
            let result = new RackAndStackIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "SelfServiceReportingIntegrationMetadata") {
            let result = new SelfServiceReportingIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "LiveOpticsIntegrationMetadata") {
            let result = new LiveOpticsIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AzureAssetIntegrationMetadata") {
            let result = new AzureAssetIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AzureCostAndUsageIntegrationMetadata") {
            let result = new AzureCostAndUsageIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "Microsoft365ReportsIntegrationMetadata") {
            let result = new Microsoft365ReportsIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "IbaIntegrationMetadata") {
            let result = new IbaIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "DattoRMMIntegrationMetadata") {
            let result = new DattoRMMIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "DatadogUsageReportIntegrationMetadata") {
            let result = new DatadogUsageReportIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "CiscoContractCoverageIntegrationMetadata") {
            let result = new CiscoContractCoverageIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "CiscoEnterpriseAgreementMetadata") {
            let result = new CiscoEnterpriseAgreementMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "CiscoMerakiIntegrationMetadata") {
            let result = new CiscoMerakiIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "CiscoReadyReportIntegrationMetadata") {
            let result = new CiscoReadyReportIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "CiscoSNTCIntegrationMetadata") {
            let result = new CiscoSNTCIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "CiscoSubscriptionManagementIntegrationMetadata") {
            let result = new CiscoSubscriptionManagementIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AssetManagementIntegrationMetadata") {
            let result = new AssetManagementIntegrationMetadata();
            result.init(data);
            return result;
        }
        let result = new IntegrationMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeName"] = this._discriminator;
        data["status"] = this.status;
        return data;
    }
}

export interface IIntegrationMetadata {
    status?: string | undefined;
}

export class AssessmentIntegrationMetadata extends IntegrationMetadata implements IAssessmentIntegrationMetadata {
    crmGuid?: string | undefined;
    airtableAssessmentLink?: string | undefined;
    airtableId?: string | undefined;
    assessmentGuid?: string | undefined;

    constructor(data?: IAssessmentIntegrationMetadata) {
        super(data);
        this._discriminator = "AssessmentIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.crmGuid = _data["crmGuid"];
            this.airtableAssessmentLink = _data["airtableAssessmentLink"];
            this.airtableId = _data["airtableId"];
            this.assessmentGuid = _data["assessmentGuid"];
        }
    }

    static override fromJS(data: any): AssessmentIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["crmGuid"] = this.crmGuid;
        data["airtableAssessmentLink"] = this.airtableAssessmentLink;
        data["airtableId"] = this.airtableId;
        data["assessmentGuid"] = this.assessmentGuid;
        super.toJSON(data);
        return data;
    }
}

export interface IAssessmentIntegrationMetadata extends IIntegrationMetadata {
    crmGuid?: string | undefined;
    airtableAssessmentLink?: string | undefined;
    airtableId?: string | undefined;
    assessmentGuid?: string | undefined;
}

export class AssetManagementIntegrationMetadata extends IntegrationMetadata implements IAssetManagementIntegrationMetadata {
    axAccount?: string | undefined;
    filename?: string | undefined;

    constructor(data?: IAssetManagementIntegrationMetadata) {
        super(data);
        this._discriminator = "AssetManagementIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.axAccount = _data["axAccount"];
            this.filename = _data["filename"];
        }
    }

    static override fromJS(data: any): AssetManagementIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new AssetManagementIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccount"] = this.axAccount;
        data["filename"] = this.filename;
        super.toJSON(data);
        return data;
    }
}

export interface IAssetManagementIntegrationMetadata extends IIntegrationMetadata {
    axAccount?: string | undefined;
    filename?: string | undefined;
}

export class AssetDownloadContractsRequest implements IAssetDownloadContractsRequest {
    query?: AssetContractSearchQueryDto;
    gridDefinitions?: ExcelDownloadDefinition[] | undefined;

    constructor(data?: IAssetDownloadContractsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.query = _data["query"] ? AssetContractSearchQueryDto.fromJS(_data["query"]) : <any>undefined;
            if (Array.isArray(_data["gridDefinitions"])) {
                this.gridDefinitions = [] as any;
                for (let item of _data["gridDefinitions"])
                    this.gridDefinitions!.push(ExcelDownloadDefinition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssetDownloadContractsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AssetDownloadContractsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query ? this.query.toJSON() : <any>undefined;
        if (Array.isArray(this.gridDefinitions)) {
            data["gridDefinitions"] = [];
            for (let item of this.gridDefinitions)
                data["gridDefinitions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAssetDownloadContractsRequest {
    query?: AssetContractSearchQueryDto;
    gridDefinitions?: ExcelDownloadDefinition[] | undefined;
}

export class AssetDownloadInventoryRequest implements IAssetDownloadInventoryRequest {
    query?: AssetManagementSearchQueryDto;
    gridDefinitions?: ExcelDownloadDefinition[] | undefined;
    queryString?: string | undefined;

    constructor(data?: IAssetDownloadInventoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.query = _data["query"] ? AssetManagementSearchQueryDto.fromJS(_data["query"]) : <any>undefined;
            if (Array.isArray(_data["gridDefinitions"])) {
                this.gridDefinitions = [] as any;
                for (let item of _data["gridDefinitions"])
                    this.gridDefinitions!.push(ExcelDownloadDefinition.fromJS(item));
            }
            this.queryString = _data["queryString"];
        }
    }

    static fromJS(data: any): AssetDownloadInventoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AssetDownloadInventoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query ? this.query.toJSON() : <any>undefined;
        if (Array.isArray(this.gridDefinitions)) {
            data["gridDefinitions"] = [];
            for (let item of this.gridDefinitions)
                data["gridDefinitions"].push(item.toJSON());
        }
        data["queryString"] = this.queryString;
        return data;
    }
}

export interface IAssetDownloadInventoryRequest {
    query?: AssetManagementSearchQueryDto;
    gridDefinitions?: ExcelDownloadDefinition[] | undefined;
    queryString?: string | undefined;
}

export class AssetDownloadLifecycleRequest implements IAssetDownloadLifecycleRequest {
    query?: AssetLifecycleSearchRequestDto;
    gridDefinitions?: ExcelDownloadDefinition[] | undefined;

    constructor(data?: IAssetDownloadLifecycleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.query = _data["query"] ? AssetLifecycleSearchRequestDto.fromJS(_data["query"]) : <any>undefined;
            if (Array.isArray(_data["gridDefinitions"])) {
                this.gridDefinitions = [] as any;
                for (let item of _data["gridDefinitions"])
                    this.gridDefinitions!.push(ExcelDownloadDefinition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssetDownloadLifecycleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AssetDownloadLifecycleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query ? this.query.toJSON() : <any>undefined;
        if (Array.isArray(this.gridDefinitions)) {
            data["gridDefinitions"] = [];
            for (let item of this.gridDefinitions)
                data["gridDefinitions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAssetDownloadLifecycleRequest {
    query?: AssetLifecycleSearchRequestDto;
    gridDefinitions?: ExcelDownloadDefinition[] | undefined;
}

export class AssetDownloadProductCatalogRequest implements IAssetDownloadProductCatalogRequest {
    query?: AssetProductCatalogSearchRequestDto;
    gridDefinitions?: ExcelDownloadDefinition[] | undefined;

    constructor(data?: IAssetDownloadProductCatalogRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.query = _data["query"] ? AssetProductCatalogSearchRequestDto.fromJS(_data["query"]) : <any>undefined;
            if (Array.isArray(_data["gridDefinitions"])) {
                this.gridDefinitions = [] as any;
                for (let item of _data["gridDefinitions"])
                    this.gridDefinitions!.push(ExcelDownloadDefinition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssetDownloadProductCatalogRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AssetDownloadProductCatalogRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query ? this.query.toJSON() : <any>undefined;
        if (Array.isArray(this.gridDefinitions)) {
            data["gridDefinitions"] = [];
            for (let item of this.gridDefinitions)
                data["gridDefinitions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAssetDownloadProductCatalogRequest {
    query?: AssetProductCatalogSearchRequestDto;
    gridDefinitions?: ExcelDownloadDefinition[] | undefined;
}

export class AwsBillingReportIntegrationMetadata extends IntegrationMetadata implements IAwsBillingReportIntegrationMetadata {
    axAccount?: string | undefined;

    constructor(data?: IAwsBillingReportIntegrationMetadata) {
        super(data);
        this._discriminator = "AwsBillingReportIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.axAccount = _data["axAccount"];
        }
    }

    static override fromJS(data: any): AwsBillingReportIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new AwsBillingReportIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccount"] = this.axAccount;
        super.toJSON(data);
        return data;
    }
}

export interface IAwsBillingReportIntegrationMetadata extends IIntegrationMetadata {
    axAccount?: string | undefined;
}

export class AwsComplianceIntegrationMetadata extends IntegrationMetadata implements IAwsComplianceIntegrationMetadata {
    accountId?: string | undefined;
    roleArn?: string | undefined;
    externalId?: string | undefined;

    constructor(data?: IAwsComplianceIntegrationMetadata) {
        super(data);
        this._discriminator = "AwsComplianceIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accountId = _data["accountId"];
            this.roleArn = _data["roleArn"];
            this.externalId = _data["externalId"];
        }
    }

    static override fromJS(data: any): AwsComplianceIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new AwsComplianceIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["roleArn"] = this.roleArn;
        data["externalId"] = this.externalId;
        super.toJSON(data);
        return data;
    }
}

export interface IAwsComplianceIntegrationMetadata extends IIntegrationMetadata {
    accountId?: string | undefined;
    roleArn?: string | undefined;
    externalId?: string | undefined;
}

export class AwsResourceExplorerMetadata extends IntegrationMetadata implements IAwsResourceExplorerMetadata {
    roleArn?: string | undefined;
    externalId?: string | undefined;

    constructor(data?: IAwsResourceExplorerMetadata) {
        super(data);
        this._discriminator = "AwsResourceExplorerMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.roleArn = _data["roleArn"];
            this.externalId = _data["externalId"];
        }
    }

    static override fromJS(data: any): AwsResourceExplorerMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new AwsResourceExplorerMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleArn"] = this.roleArn;
        data["externalId"] = this.externalId;
        super.toJSON(data);
        return data;
    }
}

export interface IAwsResourceExplorerMetadata extends IIntegrationMetadata {
    roleArn?: string | undefined;
    externalId?: string | undefined;
}

export class AwsSimpleRecommendationsIntegrationMetadata extends IntegrationMetadata implements IAwsSimpleRecommendationsIntegrationMetadata {
    payerAccountId?: string | undefined;
    roleArn?: string | undefined;
    externalId?: string | undefined;

    constructor(data?: IAwsSimpleRecommendationsIntegrationMetadata) {
        super(data);
        this._discriminator = "AwsSimpleRecommendationsIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.payerAccountId = _data["payerAccountId"];
            this.roleArn = _data["roleArn"];
            this.externalId = _data["externalId"];
        }
    }

    static override fromJS(data: any): AwsSimpleRecommendationsIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new AwsSimpleRecommendationsIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payerAccountId"] = this.payerAccountId;
        data["roleArn"] = this.roleArn;
        data["externalId"] = this.externalId;
        super.toJSON(data);
        return data;
    }
}

export interface IAwsSimpleRecommendationsIntegrationMetadata extends IIntegrationMetadata {
    payerAccountId?: string | undefined;
    roleArn?: string | undefined;
    externalId?: string | undefined;
}

export class AzureSubscriptionStatus implements IAzureSubscriptionStatus {
    id?: number;
    accountId?: number;
    createDateTime?: Date;
    displayName?: string | undefined;
    subscriptionId?: string | undefined;
    creationConfirmedDateTime?: Date | undefined;

    constructor(data?: IAzureSubscriptionStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.createDateTime = _data["createDateTime"] ? new Date(_data["createDateTime"].toString()) : <any>undefined;
            this.displayName = _data["displayName"];
            this.subscriptionId = _data["subscriptionId"];
            this.creationConfirmedDateTime = _data["creationConfirmedDateTime"] ? new Date(_data["creationConfirmedDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AzureSubscriptionStatus {
        data = typeof data === 'object' ? data : {};
        let result = new AzureSubscriptionStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["createDateTime"] = this.createDateTime ? this.createDateTime.toISOString() : <any>undefined;
        data["displayName"] = this.displayName;
        data["subscriptionId"] = this.subscriptionId;
        data["creationConfirmedDateTime"] = this.creationConfirmedDateTime ? this.creationConfirmedDateTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAzureSubscriptionStatus {
    id?: number;
    accountId?: number;
    createDateTime?: Date;
    displayName?: string | undefined;
    subscriptionId?: string | undefined;
    creationConfirmedDateTime?: Date | undefined;
}

export class CustomerAccount implements ICustomerAccount {
    customerId?: string | undefined;
    displayName?: string | undefined;
    typeName?: string | undefined;
    active?: boolean;

    constructor(data?: ICustomerAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.displayName = _data["displayName"];
            this.typeName = _data["typeName"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): CustomerAccount {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["displayName"] = this.displayName;
        data["typeName"] = this.typeName;
        data["active"] = this.active;
        return data;
    }
}

export interface ICustomerAccount {
    customerId?: string | undefined;
    displayName?: string | undefined;
    typeName?: string | undefined;
    active?: boolean;
}

export class SubscriptionMapping implements ISubscriptionMapping {
    axNumber?: string | undefined;
    subscriptionIds?: string[] | undefined;

    constructor(data?: ISubscriptionMapping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.axNumber = _data["axNumber"];
            if (Array.isArray(_data["subscriptionIds"])) {
                this.subscriptionIds = [] as any;
                for (let item of _data["subscriptionIds"])
                    this.subscriptionIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SubscriptionMapping {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionMapping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axNumber"] = this.axNumber;
        if (Array.isArray(this.subscriptionIds)) {
            data["subscriptionIds"] = [];
            for (let item of this.subscriptionIds)
                data["subscriptionIds"].push(item);
        }
        return data;
    }
}

export interface ISubscriptionMapping {
    axNumber?: string | undefined;
    subscriptionIds?: string[] | undefined;
}

export class SubscriptionResponseProperties implements ISubscriptionResponseProperties {
    subscriptionId?: string | undefined;
    provisioningState?: string | undefined;

    constructor(data?: ISubscriptionResponseProperties) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionId = _data["subscriptionId"];
            this.provisioningState = _data["provisioningState"];
        }
    }

    static fromJS(data: any): SubscriptionResponseProperties {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionResponseProperties();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionId"] = this.subscriptionId;
        data["provisioningState"] = this.provisioningState;
        return data;
    }
}

export interface ISubscriptionResponseProperties {
    subscriptionId?: string | undefined;
    provisioningState?: string | undefined;
}

export class TenantSubscriptions implements ITenantSubscriptions {
    tenantId?: string | undefined;
    subscriptions?: CustomerAccount[] | undefined;

    constructor(data?: ITenantSubscriptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            if (Array.isArray(_data["subscriptions"])) {
                this.subscriptions = [] as any;
                for (let item of _data["subscriptions"])
                    this.subscriptions!.push(CustomerAccount.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantSubscriptions {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSubscriptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        if (Array.isArray(this.subscriptions)) {
            data["subscriptions"] = [];
            for (let item of this.subscriptions)
                data["subscriptions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITenantSubscriptions {
    tenantId?: string | undefined;
    subscriptions?: CustomerAccount[] | undefined;
}

export class AzureBackupAlert implements IAzureBackupAlert {
    name?: string | undefined;
    resourceLocation?: string | undefined;
    resourceTags?: string | undefined;
    backupLocation?: string | undefined;
    backupPlan?: string | undefined;
    healthStatus?: string | undefined;
    protectionState?: string | undefined;
    workloadType?: string | undefined;
    lastRecoveryPoint?: string | undefined;
    lastBackupStatus?: string | undefined;
    lastBackupTime?: string | undefined;
    subscriptionId?: string | undefined;
    resourceId?: string | undefined;
    resourceGroup?: string | undefined;

    constructor(data?: IAzureBackupAlert) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.resourceLocation = _data["resourceLocation"];
            this.resourceTags = _data["resourceTags"];
            this.backupLocation = _data["backupLocation"];
            this.backupPlan = _data["backupPlan"];
            this.healthStatus = _data["healthStatus"];
            this.protectionState = _data["protectionState"];
            this.workloadType = _data["workloadType"];
            this.lastRecoveryPoint = _data["lastRecoveryPoint"];
            this.lastBackupStatus = _data["lastBackupStatus"];
            this.lastBackupTime = _data["lastBackupTime"];
            this.subscriptionId = _data["subscriptionId"];
            this.resourceId = _data["resourceId"];
            this.resourceGroup = _data["resourceGroup"];
        }
    }

    static fromJS(data: any): AzureBackupAlert {
        data = typeof data === 'object' ? data : {};
        let result = new AzureBackupAlert();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["resourceLocation"] = this.resourceLocation;
        data["resourceTags"] = this.resourceTags;
        data["backupLocation"] = this.backupLocation;
        data["backupPlan"] = this.backupPlan;
        data["healthStatus"] = this.healthStatus;
        data["protectionState"] = this.protectionState;
        data["workloadType"] = this.workloadType;
        data["lastRecoveryPoint"] = this.lastRecoveryPoint;
        data["lastBackupStatus"] = this.lastBackupStatus;
        data["lastBackupTime"] = this.lastBackupTime;
        data["subscriptionId"] = this.subscriptionId;
        data["resourceId"] = this.resourceId;
        data["resourceGroup"] = this.resourceGroup;
        return data;
    }
}

export interface IAzureBackupAlert {
    name?: string | undefined;
    resourceLocation?: string | undefined;
    resourceTags?: string | undefined;
    backupLocation?: string | undefined;
    backupPlan?: string | undefined;
    healthStatus?: string | undefined;
    protectionState?: string | undefined;
    workloadType?: string | undefined;
    lastRecoveryPoint?: string | undefined;
    lastBackupStatus?: string | undefined;
    lastBackupTime?: string | undefined;
    subscriptionId?: string | undefined;
    resourceId?: string | undefined;
    resourceGroup?: string | undefined;
}

export class AzureDevOpsReportIntegrationMetadata extends IntegrationMetadata implements IAzureDevOpsReportIntegrationMetadata {
    axAccount?: string | undefined;

    constructor(data?: IAzureDevOpsReportIntegrationMetadata) {
        super(data);
        this._discriminator = "AzureDevOpsReportIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.axAccount = _data["axAccount"];
        }
    }

    static override fromJS(data: any): AzureDevOpsReportIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new AzureDevOpsReportIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccount"] = this.axAccount;
        super.toJSON(data);
        return data;
    }
}

export interface IAzureDevOpsReportIntegrationMetadata extends IIntegrationMetadata {
    axAccount?: string | undefined;
}

export class AzureIntegrationMetadata extends IntegrationMetadata implements IAzureIntegrationMetadata {
    subscriptionId?: string | undefined;

    constructor(data?: IAzureIntegrationMetadata) {
        super(data);
        this._discriminator = "AzureIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.subscriptionId = _data["subscriptionId"];
        }
    }

    static override fromJS(data: any): AzureIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new AzureIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionId"] = this.subscriptionId;
        super.toJSON(data);
        return data;
    }
}

export interface IAzureIntegrationMetadata extends IIntegrationMetadata {
    subscriptionId?: string | undefined;
}

export class AzurePlanReportIntegrationMetadata extends IntegrationMetadata implements IAzurePlanReportIntegrationMetadata {
    customerTenantId?: string | undefined;
    axAccount?: string | undefined;

    constructor(data?: IAzurePlanReportIntegrationMetadata) {
        super(data);
        this._discriminator = "AzurePlanReportIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.customerTenantId = _data["customerTenantId"];
            this.axAccount = _data["axAccount"];
        }
    }

    static override fromJS(data: any): AzurePlanReportIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new AzurePlanReportIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerTenantId"] = this.customerTenantId;
        data["axAccount"] = this.axAccount;
        super.toJSON(data);
        return data;
    }
}

export interface IAzurePlanReportIntegrationMetadata extends IIntegrationMetadata {
    customerTenantId?: string | undefined;
    axAccount?: string | undefined;
}

export class AzureTenantConnection implements IAzureTenantConnection {
    tenantId?: string | undefined;
    appRegistrationId?: string | undefined;
    purpose?: Purpose[] | undefined;
    currentState?: ConnectionStatus;
    errorMessage?: string | undefined;

    constructor(data?: IAzureTenantConnection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.appRegistrationId = _data["appRegistrationId"];
            if (Array.isArray(_data["purpose"])) {
                this.purpose = [] as any;
                for (let item of _data["purpose"])
                    this.purpose!.push(item);
            }
            this.currentState = _data["currentState"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): AzureTenantConnection {
        data = typeof data === 'object' ? data : {};
        let result = new AzureTenantConnection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["appRegistrationId"] = this.appRegistrationId;
        if (Array.isArray(this.purpose)) {
            data["purpose"] = [];
            for (let item of this.purpose)
                data["purpose"].push(item);
        }
        data["currentState"] = this.currentState;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IAzureTenantConnection {
    tenantId?: string | undefined;
    appRegistrationId?: string | undefined;
    purpose?: Purpose[] | undefined;
    currentState?: ConnectionStatus;
    errorMessage?: string | undefined;
}

export class BillingInvoiceDto implements IBillingInvoiceDto {
    invoiceId?: string | undefined;
    invoiceDate?: Date;
    customerPo?: string | undefined;
    customerRequisition?: string | undefined;
    invoiceAmount?: number;
    tagFilter?: string | undefined;
    tag?: string | undefined;
    tenant?: string | undefined;
    serviceProjectName?: string | undefined;
    serviceType?: string | undefined;
    contractType?: string | undefined;
    companyName?: string | undefined;
    contractName?: string | undefined;

    constructor(data?: IBillingInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["invoiceId"];
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : <any>undefined;
            this.customerPo = _data["customerPo"];
            this.customerRequisition = _data["customerRequisition"];
            this.invoiceAmount = _data["invoiceAmount"];
            this.tagFilter = _data["tagFilter"];
            this.tag = _data["tag"];
            this.tenant = _data["tenant"];
            this.serviceProjectName = _data["serviceProjectName"];
            this.serviceType = _data["serviceType"];
            this.contractType = _data["contractType"];
            this.companyName = _data["companyName"];
            this.contractName = _data["contractName"];
        }
    }

    static fromJS(data: any): BillingInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillingInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceId"] = this.invoiceId;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : <any>undefined;
        data["customerPo"] = this.customerPo;
        data["customerRequisition"] = this.customerRequisition;
        data["invoiceAmount"] = this.invoiceAmount;
        data["tagFilter"] = this.tagFilter;
        data["tag"] = this.tag;
        data["tenant"] = this.tenant;
        data["serviceProjectName"] = this.serviceProjectName;
        data["serviceType"] = this.serviceType;
        data["contractType"] = this.contractType;
        data["companyName"] = this.companyName;
        data["contractName"] = this.contractName;
        return data;
    }
}

export interface IBillingInvoiceDto {
    invoiceId?: string | undefined;
    invoiceDate?: Date;
    customerPo?: string | undefined;
    customerRequisition?: string | undefined;
    invoiceAmount?: number;
    tagFilter?: string | undefined;
    tag?: string | undefined;
    tenant?: string | undefined;
    serviceProjectName?: string | undefined;
    serviceType?: string | undefined;
    contractType?: string | undefined;
    companyName?: string | undefined;
    contractName?: string | undefined;
}

export class EmailInvoicesDto implements IEmailInvoicesDto {
    emailAddress?: string | undefined;
    invoices?: BillingInvoiceDto[] | undefined;

    constructor(data?: IEmailInvoicesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices!.push(BillingInvoiceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmailInvoicesDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailInvoicesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEmailInvoicesDto {
    emailAddress?: string | undefined;
    invoices?: BillingInvoiceDto[] | undefined;
}

export class InvoicesByMonthResponseDto implements IInvoicesByMonthResponseDto {
    monthlyInvoices?: MonthlyInvoiceList[] | undefined;

    constructor(data?: IInvoicesByMonthResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["monthlyInvoices"])) {
                this.monthlyInvoices = [] as any;
                for (let item of _data["monthlyInvoices"])
                    this.monthlyInvoices!.push(MonthlyInvoiceList.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvoicesByMonthResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicesByMonthResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.monthlyInvoices)) {
            data["monthlyInvoices"] = [];
            for (let item of this.monthlyInvoices)
                data["monthlyInvoices"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInvoicesByMonthResponseDto {
    monthlyInvoices?: MonthlyInvoiceList[] | undefined;
}

export class LastMonthsCostDto implements ILastMonthsCostDto {
    lastMonthsCostType?: LastMonthsCostType;
    totalCost?: number;
    lastMonthsCostLineItems?: LastMonthsCostLineItem[] | undefined;

    constructor(data?: ILastMonthsCostDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lastMonthsCostType = _data["lastMonthsCostType"];
            this.totalCost = _data["totalCost"];
            if (Array.isArray(_data["lastMonthsCostLineItems"])) {
                this.lastMonthsCostLineItems = [] as any;
                for (let item of _data["lastMonthsCostLineItems"])
                    this.lastMonthsCostLineItems!.push(LastMonthsCostLineItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LastMonthsCostDto {
        data = typeof data === 'object' ? data : {};
        let result = new LastMonthsCostDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastMonthsCostType"] = this.lastMonthsCostType;
        data["totalCost"] = this.totalCost;
        if (Array.isArray(this.lastMonthsCostLineItems)) {
            data["lastMonthsCostLineItems"] = [];
            for (let item of this.lastMonthsCostLineItems)
                data["lastMonthsCostLineItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILastMonthsCostDto {
    lastMonthsCostType?: LastMonthsCostType;
    totalCost?: number;
    lastMonthsCostLineItems?: LastMonthsCostLineItem[] | undefined;
}

export class LastMonthsCostLineItem implements ILastMonthsCostLineItem {
    name?: string | undefined;
    cost?: number;
    percentage?: number;

    constructor(data?: ILastMonthsCostLineItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.cost = _data["cost"];
            this.percentage = _data["percentage"];
        }
    }

    static fromJS(data: any): LastMonthsCostLineItem {
        data = typeof data === 'object' ? data : {};
        let result = new LastMonthsCostLineItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["cost"] = this.cost;
        data["percentage"] = this.percentage;
        return data;
    }
}

export interface ILastMonthsCostLineItem {
    name?: string | undefined;
    cost?: number;
    percentage?: number;
}

export enum LastMonthsCostType {
    ByContract = "ByContract",
    ByContractType = "ByContractType",
    ByVendor = "ByVendor",
    ByServiceType = "ByServiceType",
}

export class MonthlyInvoiceList implements IMonthlyInvoiceList {
    totalCost?: number;
    differenceFromPreviousMonthPercentage?: number;
    billingPeriod?: Date;
    differenceFromPreviousMonth?: number;
    invoices?: BillingInvoiceDto[] | undefined;

    constructor(data?: IMonthlyInvoiceList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCost = _data["totalCost"];
            this.differenceFromPreviousMonthPercentage = _data["differenceFromPreviousMonthPercentage"];
            this.billingPeriod = _data["billingPeriod"] ? new Date(_data["billingPeriod"].toString()) : <any>undefined;
            this.differenceFromPreviousMonth = _data["differenceFromPreviousMonth"];
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices!.push(BillingInvoiceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MonthlyInvoiceList {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyInvoiceList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCost"] = this.totalCost;
        data["differenceFromPreviousMonthPercentage"] = this.differenceFromPreviousMonthPercentage;
        data["billingPeriod"] = this.billingPeriod ? this.billingPeriod.toISOString() : <any>undefined;
        data["differenceFromPreviousMonth"] = this.differenceFromPreviousMonth;
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMonthlyInvoiceList {
    totalCost?: number;
    differenceFromPreviousMonthPercentage?: number;
    billingPeriod?: Date;
    differenceFromPreviousMonth?: number;
    invoices?: BillingInvoiceDto[] | undefined;
}

export class Bookmark implements IBookmark {
    id?: number;
    name?: string | undefined;
    value?: string | undefined;
    reportId?: string | undefined;

    protected _discriminator: string;

    constructor(data?: IBookmark) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "Bookmark";
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.reportId = _data["reportId"];
        }
    }

    static fromJS(data: any): Bookmark {
        data = typeof data === 'object' ? data : {};
        if (data["typeName"] === "AccountBookmark") {
            let result = new AccountBookmark();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "ContactBookmark") {
            let result = new ContactBookmark();
            result.init(data);
            return result;
        }
        let result = new Bookmark();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeName"] = this._discriminator;
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        data["reportId"] = this.reportId;
        return data;
    }
}

export interface IBookmark {
    id?: number;
    name?: string | undefined;
    value?: string | undefined;
    reportId?: string | undefined;
}

export class AccountBookmark extends Bookmark implements IAccountBookmark {
    accountId?: number;

    constructor(data?: IAccountBookmark) {
        super(data);
        this._discriminator = "AccountBookmark";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accountId = _data["accountId"];
        }
    }

    static override fromJS(data: any): AccountBookmark {
        data = typeof data === 'object' ? data : {};
        let result = new AccountBookmark();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        super.toJSON(data);
        return data;
    }
}

export interface IAccountBookmark extends IBookmark {
    accountId?: number;
}

export class ContactBookmark extends Bookmark implements IContactBookmark {
    contactId?: number;

    constructor(data?: IContactBookmark) {
        super(data);
        this._discriminator = "ContactBookmark";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contactId = _data["contactId"];
        }
    }

    static override fromJS(data: any): ContactBookmark {
        data = typeof data === 'object' ? data : {};
        let result = new ContactBookmark();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        super.toJSON(data);
        return data;
    }
}

export interface IContactBookmark extends IBookmark {
    contactId?: number;
}

export class BusinessPath implements IBusinessPath {
    reportingBuId?: string | undefined;
    name?: string | undefined;
    pathName?: string | undefined;
    parentReportingBuId?: string | undefined;
    businessUnitPathType?: BusinessUnitPathType;
    children?: BusinessPath[] | undefined;

    constructor(data?: IBusinessPath) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportingBuId = _data["reportingBuId"];
            this.name = _data["name"];
            this.pathName = _data["pathName"];
            this.parentReportingBuId = _data["parentReportingBuId"];
            this.businessUnitPathType = _data["businessUnitPathType"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(BusinessPath.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BusinessPath {
        data = typeof data === 'object' ? data : {};
        let result = new BusinessPath();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportingBuId"] = this.reportingBuId;
        data["name"] = this.name;
        data["pathName"] = this.pathName;
        data["parentReportingBuId"] = this.parentReportingBuId;
        data["businessUnitPathType"] = this.businessUnitPathType;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBusinessPath {
    reportingBuId?: string | undefined;
    name?: string | undefined;
    pathName?: string | undefined;
    parentReportingBuId?: string | undefined;
    businessUnitPathType?: BusinessUnitPathType;
    children?: BusinessPath[] | undefined;
}

export class BusinessPathAccount implements IBusinessPathAccount {
    reportingBuPathId?: string | undefined;
    owningTeamId?: string | undefined;
    axAccountNumber?: string | undefined;
    crmAccountGuid?: string | undefined;
    businessPathCompanyGuid?: string | undefined;
    businessPathBusinessUnitGuid?: string | undefined;
    businessPathSegmentGuid?: string | undefined;
    businessPathDivisionGuid?: string | undefined;
    businessPathRegionGuid?: string | undefined;
    businessPathDistrictGuid?: string | undefined;

    constructor(data?: IBusinessPathAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportingBuPathId = _data["reportingBuPathId"];
            this.owningTeamId = _data["owningTeamId"];
            this.axAccountNumber = _data["axAccountNumber"];
            this.crmAccountGuid = _data["crmAccountGuid"];
            this.businessPathCompanyGuid = _data["businessPathCompanyGuid"];
            this.businessPathBusinessUnitGuid = _data["businessPathBusinessUnitGuid"];
            this.businessPathSegmentGuid = _data["businessPathSegmentGuid"];
            this.businessPathDivisionGuid = _data["businessPathDivisionGuid"];
            this.businessPathRegionGuid = _data["businessPathRegionGuid"];
            this.businessPathDistrictGuid = _data["businessPathDistrictGuid"];
        }
    }

    static fromJS(data: any): BusinessPathAccount {
        data = typeof data === 'object' ? data : {};
        let result = new BusinessPathAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportingBuPathId"] = this.reportingBuPathId;
        data["owningTeamId"] = this.owningTeamId;
        data["axAccountNumber"] = this.axAccountNumber;
        data["crmAccountGuid"] = this.crmAccountGuid;
        data["businessPathCompanyGuid"] = this.businessPathCompanyGuid;
        data["businessPathBusinessUnitGuid"] = this.businessPathBusinessUnitGuid;
        data["businessPathSegmentGuid"] = this.businessPathSegmentGuid;
        data["businessPathDivisionGuid"] = this.businessPathDivisionGuid;
        data["businessPathRegionGuid"] = this.businessPathRegionGuid;
        data["businessPathDistrictGuid"] = this.businessPathDistrictGuid;
        return data;
    }
}

export interface IBusinessPathAccount {
    reportingBuPathId?: string | undefined;
    owningTeamId?: string | undefined;
    axAccountNumber?: string | undefined;
    crmAccountGuid?: string | undefined;
    businessPathCompanyGuid?: string | undefined;
    businessPathBusinessUnitGuid?: string | undefined;
    businessPathSegmentGuid?: string | undefined;
    businessPathDivisionGuid?: string | undefined;
    businessPathRegionGuid?: string | undefined;
    businessPathDistrictGuid?: string | undefined;
}

export class CatalystIntegrationMetadata extends IntegrationMetadata implements ICatalystIntegrationMetadata {
    advisoryContractId?: number | undefined;
    manuallyEnabled?: boolean;
    azureTenants?: AzureTenantConnection[] | undefined;
    m365Tenants?: Microsoft365TenantConnection[] | undefined;

    constructor(data?: ICatalystIntegrationMetadata) {
        super(data);
        this._discriminator = "CatalystIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.advisoryContractId = _data["advisoryContractId"];
            this.manuallyEnabled = _data["manuallyEnabled"];
            if (Array.isArray(_data["azureTenants"])) {
                this.azureTenants = [] as any;
                for (let item of _data["azureTenants"])
                    this.azureTenants!.push(AzureTenantConnection.fromJS(item));
            }
            if (Array.isArray(_data["m365Tenants"])) {
                this.m365Tenants = [] as any;
                for (let item of _data["m365Tenants"])
                    this.m365Tenants!.push(Microsoft365TenantConnection.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): CatalystIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new CatalystIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advisoryContractId"] = this.advisoryContractId;
        data["manuallyEnabled"] = this.manuallyEnabled;
        if (Array.isArray(this.azureTenants)) {
            data["azureTenants"] = [];
            for (let item of this.azureTenants)
                data["azureTenants"].push(item.toJSON());
        }
        if (Array.isArray(this.m365Tenants)) {
            data["m365Tenants"] = [];
            for (let item of this.m365Tenants)
                data["m365Tenants"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICatalystIntegrationMetadata extends IIntegrationMetadata {
    advisoryContractId?: number | undefined;
    manuallyEnabled?: boolean;
    azureTenants?: AzureTenantConnection[] | undefined;
    m365Tenants?: Microsoft365TenantConnection[] | undefined;
}

export class CiscoContractCoverageIntegrationMetadata extends IntegrationMetadata implements ICiscoContractCoverageIntegrationMetadata {
    axAccount?: string | undefined;

    constructor(data?: ICiscoContractCoverageIntegrationMetadata) {
        super(data);
        this._discriminator = "CiscoContractCoverageIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.axAccount = _data["axAccount"];
        }
    }

    static override fromJS(data: any): CiscoContractCoverageIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoContractCoverageIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccount"] = this.axAccount;
        super.toJSON(data);
        return data;
    }
}

export interface ICiscoContractCoverageIntegrationMetadata extends IIntegrationMetadata {
    axAccount?: string | undefined;
}

export class CiscoEnterpriseAgreementMetadata extends IntegrationMetadata implements ICiscoEnterpriseAgreementMetadata {
    smartAccountDomain?: string | undefined;
    axAccount?: string | undefined;

    constructor(data?: ICiscoEnterpriseAgreementMetadata) {
        super(data);
        this._discriminator = "CiscoEnterpriseAgreementMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.smartAccountDomain = _data["smartAccountDomain"];
            this.axAccount = _data["axAccount"];
        }
    }

    static override fromJS(data: any): CiscoEnterpriseAgreementMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoEnterpriseAgreementMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["smartAccountDomain"] = this.smartAccountDomain;
        data["axAccount"] = this.axAccount;
        super.toJSON(data);
        return data;
    }
}

export interface ICiscoEnterpriseAgreementMetadata extends IIntegrationMetadata {
    smartAccountDomain?: string | undefined;
    axAccount?: string | undefined;
}

export class CiscoMerakiIntegrationMetadata extends IntegrationMetadata implements ICiscoMerakiIntegrationMetadata {
    axAccount?: string | undefined;

    constructor(data?: ICiscoMerakiIntegrationMetadata) {
        super(data);
        this._discriminator = "CiscoMerakiIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.axAccount = _data["axAccount"];
        }
    }

    static override fromJS(data: any): CiscoMerakiIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoMerakiIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccount"] = this.axAccount;
        super.toJSON(data);
        return data;
    }
}

export interface ICiscoMerakiIntegrationMetadata extends IIntegrationMetadata {
    axAccount?: string | undefined;
}

export class CiscoReadyReportIntegrationMetadata extends IntegrationMetadata implements ICiscoReadyReportIntegrationMetadata {
    axAccount?: string | undefined;
    originalFilename?: string | undefined;
    processedFilename?: string | undefined;
    fileSubmissionUtcDateTime?: Date;

    constructor(data?: ICiscoReadyReportIntegrationMetadata) {
        super(data);
        this._discriminator = "CiscoReadyReportIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.axAccount = _data["axAccount"];
            this.originalFilename = _data["originalFilename"];
            this.processedFilename = _data["processedFilename"];
            this.fileSubmissionUtcDateTime = _data["fileSubmissionUtcDateTime"] ? new Date(_data["fileSubmissionUtcDateTime"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): CiscoReadyReportIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoReadyReportIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccount"] = this.axAccount;
        data["originalFilename"] = this.originalFilename;
        data["processedFilename"] = this.processedFilename;
        data["fileSubmissionUtcDateTime"] = this.fileSubmissionUtcDateTime ? this.fileSubmissionUtcDateTime.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICiscoReadyReportIntegrationMetadata extends IIntegrationMetadata {
    axAccount?: string | undefined;
    originalFilename?: string | undefined;
    processedFilename?: string | undefined;
    fileSubmissionUtcDateTime?: Date;
}

export class CiscoReadyReportUploadResponse implements ICiscoReadyReportUploadResponse {
    warnings?: EvaluatedCiscoReadyReportRecord[] | undefined;
    integrationRecord?: IntegrationDTO | undefined;

    constructor(data?: ICiscoReadyReportUploadResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(EvaluatedCiscoReadyReportRecord.fromJS(item));
            }
            this.integrationRecord = _data["integrationRecord"] ? IntegrationDTO.fromJS(_data["integrationRecord"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CiscoReadyReportUploadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoReadyReportUploadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item.toJSON());
        }
        data["integrationRecord"] = this.integrationRecord ? this.integrationRecord.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICiscoReadyReportUploadResponse {
    warnings?: EvaluatedCiscoReadyReportRecord[] | undefined;
    integrationRecord?: IntegrationDTO | undefined;
}

export class CiscoSNTCIntegrationMetadata extends IntegrationMetadata implements ICiscoSNTCIntegrationMetadata {
    customerId?: string | undefined;
    axAccount?: string | undefined;

    constructor(data?: ICiscoSNTCIntegrationMetadata) {
        super(data);
        this._discriminator = "CiscoSNTCIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.customerId = _data["customerId"];
            this.axAccount = _data["axAccount"];
        }
    }

    static override fromJS(data: any): CiscoSNTCIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoSNTCIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["axAccount"] = this.axAccount;
        super.toJSON(data);
        return data;
    }
}

export interface ICiscoSNTCIntegrationMetadata extends IIntegrationMetadata {
    customerId?: string | undefined;
    axAccount?: string | undefined;
}

export class CiscoSubscriptionManagementIntegrationMetadata extends IntegrationMetadata implements ICiscoSubscriptionManagementIntegrationMetadata {
    axAccount?: string | undefined;

    constructor(data?: ICiscoSubscriptionManagementIntegrationMetadata) {
        super(data);
        this._discriminator = "CiscoSubscriptionManagementIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.axAccount = _data["axAccount"];
        }
    }

    static override fromJS(data: any): CiscoSubscriptionManagementIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoSubscriptionManagementIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccount"] = this.axAccount;
        super.toJSON(data);
        return data;
    }
}

export interface ICiscoSubscriptionManagementIntegrationMetadata extends IIntegrationMetadata {
    axAccount?: string | undefined;
}

export class CiscoMerakiCustomerMetadata extends IntegrationMetadata implements ICiscoMerakiCustomerMetadata {
    customerApiKey?: string | undefined;
    friendlyKeyName?: string | undefined;

    constructor(data?: ICiscoMerakiCustomerMetadata) {
        super(data);
        this._discriminator = "CiscoMerakiCustomerMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.customerApiKey = _data["customerApiKey"];
            this.friendlyKeyName = _data["friendlyKeyName"];
        }
    }

    static override fromJS(data: any): CiscoMerakiCustomerMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoMerakiCustomerMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerApiKey"] = this.customerApiKey;
        data["friendlyKeyName"] = this.friendlyKeyName;
        super.toJSON(data);
        return data;
    }
}

export interface ICiscoMerakiCustomerMetadata extends IIntegrationMetadata {
    customerApiKey?: string | undefined;
    friendlyKeyName?: string | undefined;
}

export class CloudConsumptionDto implements ICloudConsumptionDto {
    customerPrice?: number[] | undefined;
    monthToDateCustomerPrice?: number[] | undefined;
    monthlyTotalCustomerPrice?: number;
    consumptionDates?: Date[] | undefined;
    billingPeriodStartDate?: Date;

    constructor(data?: ICloudConsumptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["customerPrice"])) {
                this.customerPrice = [] as any;
                for (let item of _data["customerPrice"])
                    this.customerPrice!.push(item);
            }
            if (Array.isArray(_data["monthToDateCustomerPrice"])) {
                this.monthToDateCustomerPrice = [] as any;
                for (let item of _data["monthToDateCustomerPrice"])
                    this.monthToDateCustomerPrice!.push(item);
            }
            this.monthlyTotalCustomerPrice = _data["monthlyTotalCustomerPrice"];
            if (Array.isArray(_data["consumptionDates"])) {
                this.consumptionDates = [] as any;
                for (let item of _data["consumptionDates"])
                    this.consumptionDates!.push(new Date(item));
            }
            this.billingPeriodStartDate = _data["billingPeriodStartDate"] ? new Date(_data["billingPeriodStartDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CloudConsumptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CloudConsumptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.customerPrice)) {
            data["customerPrice"] = [];
            for (let item of this.customerPrice)
                data["customerPrice"].push(item);
        }
        if (Array.isArray(this.monthToDateCustomerPrice)) {
            data["monthToDateCustomerPrice"] = [];
            for (let item of this.monthToDateCustomerPrice)
                data["monthToDateCustomerPrice"].push(item);
        }
        data["monthlyTotalCustomerPrice"] = this.monthlyTotalCustomerPrice;
        if (Array.isArray(this.consumptionDates)) {
            data["consumptionDates"] = [];
            for (let item of this.consumptionDates)
                data["consumptionDates"].push(item.toISOString());
        }
        data["billingPeriodStartDate"] = this.billingPeriodStartDate ? this.billingPeriodStartDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICloudConsumptionDto {
    customerPrice?: number[] | undefined;
    monthToDateCustomerPrice?: number[] | undefined;
    monthlyTotalCustomerPrice?: number;
    consumptionDates?: Date[] | undefined;
    billingPeriodStartDate?: Date;
}

export class AccessValidationRequest implements IAccessValidationRequest {
    accountRoleName?: string | undefined;
    uniqueId?: string | undefined;
    integrationType?: IntegrationType;

    constructor(data?: IAccessValidationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountRoleName = _data["accountRoleName"];
            this.uniqueId = _data["uniqueId"];
            this.integrationType = _data["integrationType"];
        }
    }

    static fromJS(data: any): AccessValidationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AccessValidationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountRoleName"] = this.accountRoleName;
        data["uniqueId"] = this.uniqueId;
        data["integrationType"] = this.integrationType;
        return data;
    }
}

export interface IAccessValidationRequest {
    accountRoleName?: string | undefined;
    uniqueId?: string | undefined;
    integrationType?: IntegrationType;
}

export class AccessValidationResponse implements IAccessValidationResponse {
    responseMessage?: string[] | undefined;
    passed?: boolean;
    integrationType?: IntegrationType;

    constructor(data?: IAccessValidationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["responseMessage"])) {
                this.responseMessage = [] as any;
                for (let item of _data["responseMessage"])
                    this.responseMessage!.push(item);
            }
            this.passed = _data["passed"];
            this.integrationType = _data["integrationType"];
        }
    }

    static fromJS(data: any): AccessValidationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AccessValidationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.responseMessage)) {
            data["responseMessage"] = [];
            for (let item of this.responseMessage)
                data["responseMessage"].push(item);
        }
        data["passed"] = this.passed;
        data["integrationType"] = this.integrationType;
        return data;
    }
}

export interface IAccessValidationResponse {
    responseMessage?: string[] | undefined;
    passed?: boolean;
    integrationType?: IntegrationType;
}

export class CloudAccountIdentifier implements ICloudAccountIdentifier {
    cloud?: string | undefined;
    awsPayerID?: string | undefined;
    accountID?: string | undefined;
    microsoftAzureParentID?: string | undefined;
    gcpBillingAccountId?: string | undefined;

    constructor(data?: ICloudAccountIdentifier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cloud = _data["cloud"];
            this.awsPayerID = _data["awsPayerID"];
            this.accountID = _data["accountID"];
            this.microsoftAzureParentID = _data["microsoftAzureParentID"];
            this.gcpBillingAccountId = _data["gcpBillingAccountId"];
        }
    }

    static fromJS(data: any): CloudAccountIdentifier {
        data = typeof data === 'object' ? data : {};
        let result = new CloudAccountIdentifier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cloud"] = this.cloud;
        data["awsPayerID"] = this.awsPayerID;
        data["accountID"] = this.accountID;
        data["microsoftAzureParentID"] = this.microsoftAzureParentID;
        data["gcpBillingAccountId"] = this.gcpBillingAccountId;
        return data;
    }
}

export interface ICloudAccountIdentifier {
    cloud?: string | undefined;
    awsPayerID?: string | undefined;
    accountID?: string | undefined;
    microsoftAzureParentID?: string | undefined;
    gcpBillingAccountId?: string | undefined;
}

export class CustomerSubscription implements ICustomerSubscription {
    subscriptionId?: string | undefined;
    customerName?: string | undefined;
    contractName?: string | undefined;

    constructor(data?: ICustomerSubscription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionId = _data["subscriptionId"];
            this.customerName = _data["customerName"];
            this.contractName = _data["contractName"];
        }
    }

    static fromJS(data: any): CustomerSubscription {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerSubscription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionId"] = this.subscriptionId;
        data["customerName"] = this.customerName;
        data["contractName"] = this.contractName;
        return data;
    }
}

export interface ICustomerSubscription {
    subscriptionId?: string | undefined;
    customerName?: string | undefined;
    contractName?: string | undefined;
}

export class ConfigContractSLA implements IConfigContractSLA {
    id?: number;
    contractCategory?: number;
    serviceLevelAgreementID?: number;
    configTicketCategoryMappings?: ConfigTicketCategoryMapping[] | undefined;

    constructor(data?: IConfigContractSLA) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contractCategory = _data["contractCategory"];
            this.serviceLevelAgreementID = _data["serviceLevelAgreementID"];
            if (Array.isArray(_data["configTicketCategoryMappings"])) {
                this.configTicketCategoryMappings = [] as any;
                for (let item of _data["configTicketCategoryMappings"])
                    this.configTicketCategoryMappings!.push(ConfigTicketCategoryMapping.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConfigContractSLA {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigContractSLA();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contractCategory"] = this.contractCategory;
        data["serviceLevelAgreementID"] = this.serviceLevelAgreementID;
        if (Array.isArray(this.configTicketCategoryMappings)) {
            data["configTicketCategoryMappings"] = [];
            for (let item of this.configTicketCategoryMappings)
                data["configTicketCategoryMappings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IConfigContractSLA {
    id?: number;
    contractCategory?: number;
    serviceLevelAgreementID?: number;
    configTicketCategoryMappings?: ConfigTicketCategoryMapping[] | undefined;
}

export class ConfigTicketCategoryMapping implements IConfigTicketCategoryMapping {
    id?: number;
    contractSLAId?: number;
    ticketCategoryId?: number;
    issueTypes?: number[] | undefined;

    constructor(data?: IConfigTicketCategoryMapping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contractSLAId = _data["contractSLAId"];
            this.ticketCategoryId = _data["ticketCategoryId"];
            if (Array.isArray(_data["issueTypes"])) {
                this.issueTypes = [] as any;
                for (let item of _data["issueTypes"])
                    this.issueTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): ConfigTicketCategoryMapping {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigTicketCategoryMapping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contractSLAId"] = this.contractSLAId;
        data["ticketCategoryId"] = this.ticketCategoryId;
        if (Array.isArray(this.issueTypes)) {
            data["issueTypes"] = [];
            for (let item of this.issueTypes)
                data["issueTypes"].push(item);
        }
        return data;
    }
}

export interface IConfigTicketCategoryMapping {
    id?: number;
    contractSLAId?: number;
    ticketCategoryId?: number;
    issueTypes?: number[] | undefined;
}

export enum ConnectionStatus {
    Success = "Success",
    Partial = "Partial",
    Failure = "Failure",
}

export class CostCenterCloudAccountRequest implements ICostCenterCloudAccountRequest {
    costCenterId?: number;
    configurationItemIds?: number[] | undefined;

    constructor(data?: ICostCenterCloudAccountRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.costCenterId = _data["costCenterId"];
            if (Array.isArray(_data["configurationItemIds"])) {
                this.configurationItemIds = [] as any;
                for (let item of _data["configurationItemIds"])
                    this.configurationItemIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CostCenterCloudAccountRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CostCenterCloudAccountRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["costCenterId"] = this.costCenterId;
        if (Array.isArray(this.configurationItemIds)) {
            data["configurationItemIds"] = [];
            for (let item of this.configurationItemIds)
                data["configurationItemIds"].push(item);
        }
        return data;
    }
}

export interface ICostCenterCloudAccountRequest {
    costCenterId?: number;
    configurationItemIds?: number[] | undefined;
}

export class CrmAccountTeamMember implements ICrmAccountTeamMember {
    contactId?: number | undefined;
    activeDirectoryId?: string | undefined;
    jobTitle?: string | undefined;
    systemUserId?: string | undefined;
    accountId?: number;
    source?: string | undefined;
    crmConnectionRoleId?: string | undefined;
    isAccountTeamLeadership?: boolean;

    constructor(data?: ICrmAccountTeamMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactId = _data["contactId"];
            this.activeDirectoryId = _data["activeDirectoryId"];
            this.jobTitle = _data["jobTitle"];
            this.systemUserId = _data["systemUserId"];
            this.accountId = _data["accountId"];
            this.source = _data["source"];
            this.crmConnectionRoleId = _data["crmConnectionRoleId"];
            this.isAccountTeamLeadership = _data["isAccountTeamLeadership"];
        }
    }

    static fromJS(data: any): CrmAccountTeamMember {
        data = typeof data === 'object' ? data : {};
        let result = new CrmAccountTeamMember();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["activeDirectoryId"] = this.activeDirectoryId;
        data["jobTitle"] = this.jobTitle;
        data["systemUserId"] = this.systemUserId;
        data["accountId"] = this.accountId;
        data["source"] = this.source;
        data["crmConnectionRoleId"] = this.crmConnectionRoleId;
        data["isAccountTeamLeadership"] = this.isAccountTeamLeadership;
        return data;
    }
}

export interface ICrmAccountTeamMember {
    contactId?: number | undefined;
    activeDirectoryId?: string | undefined;
    jobTitle?: string | undefined;
    systemUserId?: string | undefined;
    accountId?: number;
    source?: string | undefined;
    crmConnectionRoleId?: string | undefined;
    isAccountTeamLeadership?: boolean;
}

export class CrmShiConnectionRole implements ICrmShiConnectionRole {
    id?: number;
    crmConnectionRoleId?: string | undefined;
    crmConnectionRoleName?: string | undefined;
    enabled?: boolean;
    interfaceType?: CrmUserTypes;

    constructor(data?: ICrmShiConnectionRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.crmConnectionRoleId = _data["crmConnectionRoleId"];
            this.crmConnectionRoleName = _data["crmConnectionRoleName"];
            this.enabled = _data["enabled"];
            this.interfaceType = _data["interfaceType"];
        }
    }

    static fromJS(data: any): CrmShiConnectionRole {
        data = typeof data === 'object' ? data : {};
        let result = new CrmShiConnectionRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["crmConnectionRoleId"] = this.crmConnectionRoleId;
        data["crmConnectionRoleName"] = this.crmConnectionRoleName;
        data["enabled"] = this.enabled;
        data["interfaceType"] = this.interfaceType;
        return data;
    }
}

export interface ICrmShiConnectionRole {
    id?: number;
    crmConnectionRoleId?: string | undefined;
    crmConnectionRoleName?: string | undefined;
    enabled?: boolean;
    interfaceType?: CrmUserTypes;
}

export class CrmUserDetails implements ICrmUserDetails {
    id?: number;
    systemUserId?: string | undefined;
    shiReportingBuPath?: string | undefined;
    azureActiveDirectoryId?: string | undefined;
    parentSystemUserId?: string | undefined;
    fullName?: string | undefined;
    title?: string | undefined;
    emailAddress?: string | undefined;
    contactId?: number | undefined;
    contact?: Contact;
    crmConnectionRoleId?: string | undefined;
    crmRole?: CrmShiConnectionRole;
    accountTeamMember?: AccountTeamMember[] | undefined;

    constructor(data?: ICrmUserDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.systemUserId = _data["systemUserId"];
            this.shiReportingBuPath = _data["shiReportingBuPath"];
            this.azureActiveDirectoryId = _data["azureActiveDirectoryId"];
            this.parentSystemUserId = _data["parentSystemUserId"];
            this.fullName = _data["fullName"];
            this.title = _data["title"];
            this.emailAddress = _data["emailAddress"];
            this.contactId = _data["contactId"];
            this.contact = _data["contact"] ? Contact.fromJS(_data["contact"]) : <any>undefined;
            this.crmConnectionRoleId = _data["crmConnectionRoleId"];
            this.crmRole = _data["crmRole"] ? CrmShiConnectionRole.fromJS(_data["crmRole"]) : <any>undefined;
            if (Array.isArray(_data["accountTeamMember"])) {
                this.accountTeamMember = [] as any;
                for (let item of _data["accountTeamMember"])
                    this.accountTeamMember!.push(AccountTeamMember.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CrmUserDetails {
        data = typeof data === 'object' ? data : {};
        let result = new CrmUserDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["systemUserId"] = this.systemUserId;
        data["shiReportingBuPath"] = this.shiReportingBuPath;
        data["azureActiveDirectoryId"] = this.azureActiveDirectoryId;
        data["parentSystemUserId"] = this.parentSystemUserId;
        data["fullName"] = this.fullName;
        data["title"] = this.title;
        data["emailAddress"] = this.emailAddress;
        data["contactId"] = this.contactId;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["crmConnectionRoleId"] = this.crmConnectionRoleId;
        data["crmRole"] = this.crmRole ? this.crmRole.toJSON() : <any>undefined;
        if (Array.isArray(this.accountTeamMember)) {
            data["accountTeamMember"] = [];
            for (let item of this.accountTeamMember)
                data["accountTeamMember"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICrmUserDetails {
    id?: number;
    systemUserId?: string | undefined;
    shiReportingBuPath?: string | undefined;
    azureActiveDirectoryId?: string | undefined;
    parentSystemUserId?: string | undefined;
    fullName?: string | undefined;
    title?: string | undefined;
    emailAddress?: string | undefined;
    contactId?: number | undefined;
    contact?: Contact;
    crmConnectionRoleId?: string | undefined;
    crmRole?: CrmShiConnectionRole;
    accountTeamMember?: AccountTeamMember[] | undefined;
}

export enum CrmUserTypes {
    None = "None",
    ISAM = "ISAM",
    ISAMLeadership = "ISAMLeadership",
}

export class AXAccountBillingUsersDTO implements IAXAccountBillingUsersDTO {
    name?: string | undefined;
    readonly emails?: string[] | undefined;
    readonly phoneNumbers?: string[] | undefined;

    constructor(data?: IAXAccountBillingUsersDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["emails"])) {
                (<any>this).emails = [] as any;
                for (let item of _data["emails"])
                    (<any>this).emails!.push(item);
            }
            if (Array.isArray(_data["phoneNumbers"])) {
                (<any>this).phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    (<any>this).phoneNumbers!.push(item);
            }
        }
    }

    static fromJS(data: any): AXAccountBillingUsersDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AXAccountBillingUsersDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item);
        }
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item);
        }
        return data;
    }
}

export interface IAXAccountBillingUsersDTO {
    name?: string | undefined;
    emails?: string[] | undefined;
    phoneNumbers?: string[] | undefined;
}

export class AXAccountDetailsDTO implements IAXAccountDetailsDTO {
    axAccountNumber?: string | undefined;
    companyName?: string | undefined;
    paymentTerms?: string | undefined;

    constructor(data?: IAXAccountDetailsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.axAccountNumber = _data["axAccountNumber"];
            this.companyName = _data["companyName"];
            this.paymentTerms = _data["paymentTerms"];
        }
    }

    static fromJS(data: any): AXAccountDetailsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AXAccountDetailsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccountNumber"] = this.axAccountNumber;
        data["companyName"] = this.companyName;
        data["paymentTerms"] = this.paymentTerms;
        return data;
    }
}

export interface IAXAccountDetailsDTO {
    axAccountNumber?: string | undefined;
    companyName?: string | undefined;
    paymentTerms?: string | undefined;
}

export class AccountCRMAccountTeamSyncDTO implements IAccountCRMAccountTeamSyncDTO {
    id?: number;
    axNumber?: string | undefined;
    owningTeamId?: string | undefined;
    reportingBuId?: string | undefined;

    constructor(data?: IAccountCRMAccountTeamSyncDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.axNumber = _data["axNumber"];
            this.owningTeamId = _data["owningTeamId"];
            this.reportingBuId = _data["reportingBuId"];
        }
    }

    static fromJS(data: any): AccountCRMAccountTeamSyncDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AccountCRMAccountTeamSyncDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["axNumber"] = this.axNumber;
        data["owningTeamId"] = this.owningTeamId;
        data["reportingBuId"] = this.reportingBuId;
        return data;
    }
}

export interface IAccountCRMAccountTeamSyncDTO {
    id?: number;
    axNumber?: string | undefined;
    owningTeamId?: string | undefined;
    reportingBuId?: string | undefined;
}

export class AccountWelcomeLinkDto implements IAccountWelcomeLinkDto {
    linkId?: string;
    email?: string | undefined;
    domain?: string[] | undefined;
    accountID?: number;
    completed?: boolean;
    microsoftSSOSelected?: boolean;
    microsoftSSOSuccessful?: boolean;
    createdContact?: Contact;

    constructor(data?: IAccountWelcomeLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.linkId = _data["linkId"];
            this.email = _data["email"];
            if (Array.isArray(_data["domain"])) {
                this.domain = [] as any;
                for (let item of _data["domain"])
                    this.domain!.push(item);
            }
            this.accountID = _data["accountID"];
            this.completed = _data["completed"];
            this.microsoftSSOSelected = _data["microsoftSSOSelected"];
            this.microsoftSSOSuccessful = _data["microsoftSSOSuccessful"];
            this.createdContact = _data["createdContact"] ? Contact.fromJS(_data["createdContact"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AccountWelcomeLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountWelcomeLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkId"] = this.linkId;
        data["email"] = this.email;
        if (Array.isArray(this.domain)) {
            data["domain"] = [];
            for (let item of this.domain)
                data["domain"].push(item);
        }
        data["accountID"] = this.accountID;
        data["completed"] = this.completed;
        data["microsoftSSOSelected"] = this.microsoftSSOSelected;
        data["microsoftSSOSuccessful"] = this.microsoftSSOSuccessful;
        data["createdContact"] = this.createdContact ? this.createdContact.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAccountWelcomeLinkDto {
    linkId?: string;
    email?: string | undefined;
    domain?: string[] | undefined;
    accountID?: number;
    completed?: boolean;
    microsoftSSOSelected?: boolean;
    microsoftSSOSuccessful?: boolean;
    createdContact?: Contact;
}

export class IntegrationDTO implements IIntegrationDTO {
    id?: number;
    accountId?: number;
    axAccountNumber?: string | undefined;
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    activated?: boolean;
    metadata?: IntegrationMetadata | undefined;
    lastSuccessfulCheckDateTime?: Date | undefined;
    lastFailedCheckDateTime?: Date | undefined;
    lastExceptionMessage?: string | undefined;
    statusMessage?: string | undefined;
    statusMessageDateTime?: Date | undefined;
    status?: IntegrationStatus;

    protected _discriminator: string;

    constructor(data?: IIntegrationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "IntegrationDTO";
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.axAccountNumber = _data["axAccountNumber"];
            this.integrationType = _data["integrationType"];
            (<any>this).identifier = _data["identifier"];
            this.activated = _data["activated"];
            this.metadata = _data["metadata"] ? IntegrationMetadata.fromJS(_data["metadata"]) : <any>undefined;
            this.lastSuccessfulCheckDateTime = _data["lastSuccessfulCheckDateTime"] ? new Date(_data["lastSuccessfulCheckDateTime"].toString()) : <any>undefined;
            this.lastFailedCheckDateTime = _data["lastFailedCheckDateTime"] ? new Date(_data["lastFailedCheckDateTime"].toString()) : <any>undefined;
            this.lastExceptionMessage = _data["lastExceptionMessage"];
            this.statusMessage = _data["statusMessage"];
            this.statusMessageDateTime = _data["statusMessageDateTime"] ? new Date(_data["statusMessageDateTime"].toString()) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): IntegrationDTO {
        data = typeof data === 'object' ? data : {};
        if (data["typeName"] === "GcpUsageReportIntegrationDTO") {
            let result = new GcpUsageReportIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AzureAssetIntegrationDTO") {
            let result = new AzureAssetIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AzureCostAndUsageIntegrationDTO") {
            let result = new AzureCostAndUsageIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "Microsoft365ReportsIntegrationDTO") {
            let result = new Microsoft365ReportsIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AssetManagementDto") {
            let result = new AssetManagementDto();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AwsBillingReportIntegrationDTO") {
            let result = new AwsBillingReportIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AwsComplianceIntegrationDTO") {
            let result = new AwsComplianceIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AwsGovernanceReportsDto") {
            let result = new AwsGovernanceReportsDto();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AwsResourceExplorerIntegrationDTO") {
            let result = new AwsResourceExplorerIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AwsSimpleRecommendationsIntegrationDTO") {
            let result = new AwsSimpleRecommendationsIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AzureBackupsIntegrationDTO") {
            let result = new AzureBackupsIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AzureComplianceIntegrationDTO") {
            let result = new AzureComplianceIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AzureDevOpsReportIntegrationDTO") {
            let result = new AzureDevOpsReportIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AzureDirectConsumptionIntegrationDTO") {
            let result = new AzureDirectConsumptionIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AzureGovernanceReportsDto") {
            let result = new AzureGovernanceReportsDto();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AzurePlanReportIntegrationDTO") {
            let result = new AzurePlanReportIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AzureResourceGraphIntegrationDTO") {
            let result = new AzureResourceGraphIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AzureSimpleRecommendationsIntegrationDTO") {
            let result = new AzureSimpleRecommendationsIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "CiscoContractCoverageIntegrationDTO") {
            let result = new CiscoContractCoverageIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "CiscoEnterpriseAgreementIntegrationDTO") {
            let result = new CiscoEnterpriseAgreementIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "CiscoMerakiCustomerIntegrationDto") {
            let result = new CiscoMerakiCustomerIntegrationDto();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "CiscoMerakiIntegrationDTO") {
            let result = new CiscoMerakiIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "CiscoReadyReportIntegrationDTO") {
            let result = new CiscoReadyReportIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "CiscoSNTCIntegrationDTO") {
            let result = new CiscoSNTCIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "CiscoSubscriptionManagementIntegrationDTO") {
            let result = new CiscoSubscriptionManagementIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "DatadogUsageReportIntegrationDTO") {
            let result = new DatadogUsageReportIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "DattoRMMIntegrationDTO") {
            let result = new DattoRMMIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "GcpCloudAssetInventoryIntegrationDTO") {
            let result = new GcpCloudAssetInventoryIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "HardwareLifecycleManagementIntegrationDTO") {
            let result = new HardwareLifecycleManagementIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "IdcsReportIntegrationDTO") {
            let result = new IdcsReportIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "RackAndStackIntegrationDTO") {
            let result = new RackAndStackIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "SelfServiceReportingIntegrationDto") {
            let result = new SelfServiceReportingIntegrationDto();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AiReadinessIntegrationDto") {
            let result = new AiReadinessIntegrationDto();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AssessmentIntegrationDto") {
            let result = new AssessmentIntegrationDto();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AwsMaturityAssessmentIntegrationDto") {
            let result = new AwsMaturityAssessmentIntegrationDto();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "DevOpsPostureReviewIntegrationDto") {
            let result = new DevOpsPostureReviewIntegrationDto();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "MicrosoftAdoptionIntegrationDto") {
            let result = new MicrosoftAdoptionIntegrationDto();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "SecurityPostureReviewIntegrationDto") {
            let result = new SecurityPostureReviewIntegrationDto();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "CatalystIntegrationDTO") {
            let result = new CatalystIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "InstallBaseAnalysisDto") {
            let result = new InstallBaseAnalysisDto();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "LiveOpticsIntegrationDto") {
            let result = new LiveOpticsIntegrationDto();
            result.init(data);
            return result;
        }
        let result = new IntegrationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeName"] = this._discriminator;
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["axAccountNumber"] = this.axAccountNumber;
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["activated"] = this.activated;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        data["lastSuccessfulCheckDateTime"] = this.lastSuccessfulCheckDateTime ? this.lastSuccessfulCheckDateTime.toISOString() : <any>undefined;
        data["lastFailedCheckDateTime"] = this.lastFailedCheckDateTime ? this.lastFailedCheckDateTime.toISOString() : <any>undefined;
        data["lastExceptionMessage"] = this.lastExceptionMessage;
        data["statusMessage"] = this.statusMessage;
        data["statusMessageDateTime"] = this.statusMessageDateTime ? this.statusMessageDateTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        return data;
    }
}

export interface IIntegrationDTO {
    id?: number;
    accountId?: number;
    axAccountNumber?: string | undefined;
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    activated?: boolean;
    metadata?: IntegrationMetadata | undefined;
    lastSuccessfulCheckDateTime?: Date | undefined;
    lastFailedCheckDateTime?: Date | undefined;
    lastExceptionMessage?: string | undefined;
    statusMessage?: string | undefined;
    statusMessageDateTime?: Date | undefined;
    status?: IntegrationStatus;
}

export class AssetManagementDto extends IntegrationDTO implements IAssetManagementDto {
    integrationType?: IntegrationType;

    constructor(data?: IAssetManagementDto) {
        super(data);
        this._discriminator = "AssetManagementDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
        }
    }

    static override fromJS(data: any): AssetManagementDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetManagementDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        super.toJSON(data);
        return data;
    }
}

export interface IAssetManagementDto extends IIntegrationDTO {
    integrationType?: IntegrationType;
}

export class AwsBillingReportIntegrationDTO extends IntegrationDTO implements IAwsBillingReportIntegrationDTO {
    integrationType?: IntegrationType;
    metadata?: AwsBillingReportIntegrationMetadata;

    constructor(data?: IAwsBillingReportIntegrationDTO) {
        super(data);
        this._discriminator = "AwsBillingReportIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            this.metadata = _data["metadata"] ? AwsBillingReportIntegrationMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): AwsBillingReportIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AwsBillingReportIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAwsBillingReportIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    metadata?: AwsBillingReportIntegrationMetadata;
}

export class AwsComplianceIntegrationDTO extends IntegrationDTO implements IAwsComplianceIntegrationDTO {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: AwsComplianceIntegrationMetadata;

    constructor(data?: IAwsComplianceIntegrationDTO) {
        super(data);
        this._discriminator = "AwsComplianceIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (<any>this).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? AwsComplianceIntegrationMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): AwsComplianceIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AwsComplianceIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAwsComplianceIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: AwsComplianceIntegrationMetadata;
}

export class AwsGovernanceReportsDto extends IntegrationDTO implements IAwsGovernanceReportsDto {
    integrationType?: IntegrationType;

    constructor(data?: IAwsGovernanceReportsDto) {
        super(data);
        this._discriminator = "AwsGovernanceReportsDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
        }
    }

    static override fromJS(data: any): AwsGovernanceReportsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AwsGovernanceReportsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        super.toJSON(data);
        return data;
    }
}

export interface IAwsGovernanceReportsDto extends IIntegrationDTO {
    integrationType?: IntegrationType;
}

export class AwsResourceExplorerIntegrationDTO extends IntegrationDTO implements IAwsResourceExplorerIntegrationDTO {
    integrationType?: IntegrationType;
    metadata?: AwsResourceExplorerMetadata;

    constructor(data?: IAwsResourceExplorerIntegrationDTO) {
        super(data);
        this._discriminator = "AwsResourceExplorerIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            this.metadata = _data["metadata"] ? AwsResourceExplorerMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): AwsResourceExplorerIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AwsResourceExplorerIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAwsResourceExplorerIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    metadata?: AwsResourceExplorerMetadata;
}

export class AwsSimpleRecommendationsIntegrationDTO extends IntegrationDTO implements IAwsSimpleRecommendationsIntegrationDTO {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: AwsSimpleRecommendationsIntegrationMetadata;

    constructor(data?: IAwsSimpleRecommendationsIntegrationDTO) {
        super(data);
        this._discriminator = "AwsSimpleRecommendationsIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (<any>this).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? AwsSimpleRecommendationsIntegrationMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): AwsSimpleRecommendationsIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AwsSimpleRecommendationsIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAwsSimpleRecommendationsIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: AwsSimpleRecommendationsIntegrationMetadata;
}

export class AxInvoiceAggregateDto implements IAxInvoiceAggregateDto {
    invoiceId?: string | undefined;
    invoiceDate?: string | undefined;
    customerPo?: string | undefined;
    customerRequisition?: string | undefined;
    invoiceAmount?: number;
    tagFilter?: string | undefined;
    tag?: string | undefined;
    tenant?: string | undefined;
    serviceProjectName?: string | undefined;
    contractId?: number | undefined;
    projectId?: number | undefined;
    contractName?: string | undefined;
    projectName?: string | undefined;

    constructor(data?: IAxInvoiceAggregateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["invoiceId"];
            this.invoiceDate = _data["invoiceDate"];
            this.customerPo = _data["customerPo"];
            this.customerRequisition = _data["customerRequisition"];
            this.invoiceAmount = _data["invoiceAmount"];
            this.tagFilter = _data["tagFilter"];
            this.tag = _data["tag"];
            this.tenant = _data["tenant"];
            this.serviceProjectName = _data["serviceProjectName"];
            this.contractId = _data["contractId"];
            this.projectId = _data["projectId"];
            this.contractName = _data["contractName"];
            this.projectName = _data["projectName"];
        }
    }

    static fromJS(data: any): AxInvoiceAggregateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AxInvoiceAggregateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceId"] = this.invoiceId;
        data["invoiceDate"] = this.invoiceDate;
        data["customerPo"] = this.customerPo;
        data["customerRequisition"] = this.customerRequisition;
        data["invoiceAmount"] = this.invoiceAmount;
        data["tagFilter"] = this.tagFilter;
        data["tag"] = this.tag;
        data["tenant"] = this.tenant;
        data["serviceProjectName"] = this.serviceProjectName;
        data["contractId"] = this.contractId;
        data["projectId"] = this.projectId;
        data["contractName"] = this.contractName;
        data["projectName"] = this.projectName;
        return data;
    }
}

export interface IAxInvoiceAggregateDto {
    invoiceId?: string | undefined;
    invoiceDate?: string | undefined;
    customerPo?: string | undefined;
    customerRequisition?: string | undefined;
    invoiceAmount?: number;
    tagFilter?: string | undefined;
    tag?: string | undefined;
    tenant?: string | undefined;
    serviceProjectName?: string | undefined;
    contractId?: number | undefined;
    projectId?: number | undefined;
    contractName?: string | undefined;
    projectName?: string | undefined;
}

export class AzureBackupsIntegrationDTO extends IntegrationDTO implements IAzureBackupsIntegrationDTO {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: AzureIntegrationMetadata;

    constructor(data?: IAzureBackupsIntegrationDTO) {
        super(data);
        this._discriminator = "AzureBackupsIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (<any>this).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? AzureIntegrationMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): AzureBackupsIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AzureBackupsIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAzureBackupsIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: AzureIntegrationMetadata;
}

export class AzureComplianceIntegrationDTO extends IntegrationDTO implements IAzureComplianceIntegrationDTO {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: AzureIntegrationMetadata;

    constructor(data?: IAzureComplianceIntegrationDTO) {
        super(data);
        this._discriminator = "AzureComplianceIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (<any>this).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? AzureIntegrationMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): AzureComplianceIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AzureComplianceIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAzureComplianceIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: AzureIntegrationMetadata;
}

export class AzureDevOpsReportIntegrationDTO extends IntegrationDTO implements IAzureDevOpsReportIntegrationDTO {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: AzureDevOpsReportIntegrationMetadata;

    constructor(data?: IAzureDevOpsReportIntegrationDTO) {
        super(data);
        this._discriminator = "AzureDevOpsReportIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (<any>this).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? AzureDevOpsReportIntegrationMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): AzureDevOpsReportIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AzureDevOpsReportIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAzureDevOpsReportIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: AzureDevOpsReportIntegrationMetadata;
}

export class AzureDirectConsumptionIntegrationDTO extends IntegrationDTO implements IAzureDirectConsumptionIntegrationDTO {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: AzureIntegrationMetadata;

    constructor(data?: IAzureDirectConsumptionIntegrationDTO) {
        super(data);
        this._discriminator = "AzureDirectConsumptionIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (<any>this).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? AzureIntegrationMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): AzureDirectConsumptionIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AzureDirectConsumptionIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAzureDirectConsumptionIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: AzureIntegrationMetadata;
}

export class AzureGovernanceReportsDto extends IntegrationDTO implements IAzureGovernanceReportsDto {
    integrationType?: IntegrationType;

    constructor(data?: IAzureGovernanceReportsDto) {
        super(data);
        this._discriminator = "AzureGovernanceReportsDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
        }
    }

    static override fromJS(data: any): AzureGovernanceReportsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AzureGovernanceReportsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        super.toJSON(data);
        return data;
    }
}

export interface IAzureGovernanceReportsDto extends IIntegrationDTO {
    integrationType?: IntegrationType;
}

export class AzurePlanReportIntegrationDTO extends IntegrationDTO implements IAzurePlanReportIntegrationDTO {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: AzurePlanReportIntegrationMetadata;

    constructor(data?: IAzurePlanReportIntegrationDTO) {
        super(data);
        this._discriminator = "AzurePlanReportIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (<any>this).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? AzurePlanReportIntegrationMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): AzurePlanReportIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AzurePlanReportIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAzurePlanReportIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: AzurePlanReportIntegrationMetadata;
}

export class AzureResourceGraphIntegrationDTO extends IntegrationDTO implements IAzureResourceGraphIntegrationDTO {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: AzureIntegrationMetadata;

    constructor(data?: IAzureResourceGraphIntegrationDTO) {
        super(data);
        this._discriminator = "AzureResourceGraphIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (<any>this).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? AzureIntegrationMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): AzureResourceGraphIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AzureResourceGraphIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAzureResourceGraphIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: AzureIntegrationMetadata;
}

export class AzureSimpleRecommendationsIntegrationDTO extends IntegrationDTO implements IAzureSimpleRecommendationsIntegrationDTO {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: AzureIntegrationMetadata;

    constructor(data?: IAzureSimpleRecommendationsIntegrationDTO) {
        super(data);
        this._discriminator = "AzureSimpleRecommendationsIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (<any>this).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? AzureIntegrationMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): AzureSimpleRecommendationsIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AzureSimpleRecommendationsIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAzureSimpleRecommendationsIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: AzureIntegrationMetadata;
}

export class BasicCiscoEAIntegrationDTO implements IBasicCiscoEAIntegrationDTO {
    smartAccountDomain?: string | undefined;
    existingSmartAccountDomain?: string | undefined;

    constructor(data?: IBasicCiscoEAIntegrationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.smartAccountDomain = _data["smartAccountDomain"];
            this.existingSmartAccountDomain = _data["existingSmartAccountDomain"];
        }
    }

    static fromJS(data: any): BasicCiscoEAIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BasicCiscoEAIntegrationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["smartAccountDomain"] = this.smartAccountDomain;
        data["existingSmartAccountDomain"] = this.existingSmartAccountDomain;
        return data;
    }
}

export interface IBasicCiscoEAIntegrationDTO {
    smartAccountDomain?: string | undefined;
    existingSmartAccountDomain?: string | undefined;
}

export class BasicCiscoSNTCIntegrationDTO implements IBasicCiscoSNTCIntegrationDTO {
    customerId?: string | undefined;
    existingId?: string | undefined;

    constructor(data?: IBasicCiscoSNTCIntegrationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.existingId = _data["existingId"];
        }
    }

    static fromJS(data: any): BasicCiscoSNTCIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BasicCiscoSNTCIntegrationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["existingId"] = this.existingId;
        return data;
    }
}

export interface IBasicCiscoSNTCIntegrationDTO {
    customerId?: string | undefined;
    existingId?: string | undefined;
}

export class BillingItemMetadataDto implements IBillingItemMetadataDto {
    id?: number;
    itemDate?: Date;

    constructor(data?: IBillingItemMetadataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.itemDate = _data["itemDate"] ? new Date(_data["itemDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BillingItemMetadataDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillingItemMetadataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["itemDate"] = this.itemDate ? this.itemDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBillingItemMetadataDto {
    id?: number;
    itemDate?: Date;
}

export class BulkPermissionsUpdateDTO implements IBulkPermissionsUpdateDTO {
    updateUserStatus?: UserStatus;
    updateUserRole?: UserRole;
    contactIds!: number[];
    securityGroups?: number[] | undefined;
    readonly any?: boolean;

    constructor(data?: IBulkPermissionsUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.contactIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updateUserStatus = _data["updateUserStatus"];
            this.updateUserRole = _data["updateUserRole"];
            if (Array.isArray(_data["contactIds"])) {
                this.contactIds = [] as any;
                for (let item of _data["contactIds"])
                    this.contactIds!.push(item);
            }
            if (Array.isArray(_data["securityGroups"])) {
                this.securityGroups = [] as any;
                for (let item of _data["securityGroups"])
                    this.securityGroups!.push(item);
            }
            (<any>this).any = _data["any"];
        }
    }

    static fromJS(data: any): BulkPermissionsUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BulkPermissionsUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updateUserStatus"] = this.updateUserStatus;
        data["updateUserRole"] = this.updateUserRole;
        if (Array.isArray(this.contactIds)) {
            data["contactIds"] = [];
            for (let item of this.contactIds)
                data["contactIds"].push(item);
        }
        if (Array.isArray(this.securityGroups)) {
            data["securityGroups"] = [];
            for (let item of this.securityGroups)
                data["securityGroups"].push(item);
        }
        data["any"] = this.any;
        return data;
    }
}

export interface IBulkPermissionsUpdateDTO {
    updateUserStatus?: UserStatus;
    updateUserRole?: UserRole;
    contactIds: number[];
    securityGroups?: number[] | undefined;
    any?: boolean;
}

export class CiscoContractCoverageIntegrationDTO extends IntegrationDTO implements ICiscoContractCoverageIntegrationDTO {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: CiscoContractCoverageIntegrationMetadata;

    constructor(data?: ICiscoContractCoverageIntegrationDTO) {
        super(data);
        this._discriminator = "CiscoContractCoverageIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (<any>this).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? CiscoContractCoverageIntegrationMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): CiscoContractCoverageIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoContractCoverageIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICiscoContractCoverageIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: CiscoContractCoverageIntegrationMetadata;
}

export class CiscoEnterpriseAgreementIntegrationDTO extends IntegrationDTO implements ICiscoEnterpriseAgreementIntegrationDTO {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: CiscoEnterpriseAgreementMetadata;

    constructor(data?: ICiscoEnterpriseAgreementIntegrationDTO) {
        super(data);
        this._discriminator = "CiscoEnterpriseAgreementIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (<any>this).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? CiscoEnterpriseAgreementMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): CiscoEnterpriseAgreementIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoEnterpriseAgreementIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICiscoEnterpriseAgreementIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: CiscoEnterpriseAgreementMetadata;
}

export class CiscoMerakiCustomerIntegrationDto extends IntegrationDTO implements ICiscoMerakiCustomerIntegrationDto {
    integrationType?: IntegrationType;
    metadata?: CiscoMerakiCustomerMetadata;

    constructor(data?: ICiscoMerakiCustomerIntegrationDto) {
        super(data);
        this._discriminator = "CiscoMerakiCustomerIntegrationDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            this.metadata = _data["metadata"] ? CiscoMerakiCustomerMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): CiscoMerakiCustomerIntegrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoMerakiCustomerIntegrationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICiscoMerakiCustomerIntegrationDto extends IIntegrationDTO {
    integrationType?: IntegrationType;
    metadata?: CiscoMerakiCustomerMetadata;
}

export class CiscoMerakiIntegrationDTO extends IntegrationDTO implements ICiscoMerakiIntegrationDTO {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: CiscoMerakiIntegrationMetadata;

    constructor(data?: ICiscoMerakiIntegrationDTO) {
        super(data);
        this._discriminator = "CiscoMerakiIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (<any>this).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? CiscoMerakiIntegrationMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): CiscoMerakiIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoMerakiIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICiscoMerakiIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: CiscoMerakiIntegrationMetadata;
}

export class CiscoReadyReportIntegrationDTO extends IntegrationDTO implements ICiscoReadyReportIntegrationDTO {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: CiscoReadyReportIntegrationMetadata;

    constructor(data?: ICiscoReadyReportIntegrationDTO) {
        super(data);
        this._discriminator = "CiscoReadyReportIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (<any>this).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? CiscoReadyReportIntegrationMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): CiscoReadyReportIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoReadyReportIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICiscoReadyReportIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: CiscoReadyReportIntegrationMetadata;
}

export class CiscoSNTCIntegrationDTO extends IntegrationDTO implements ICiscoSNTCIntegrationDTO {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: CiscoSNTCIntegrationMetadata;

    constructor(data?: ICiscoSNTCIntegrationDTO) {
        super(data);
        this._discriminator = "CiscoSNTCIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (<any>this).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? CiscoSNTCIntegrationMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): CiscoSNTCIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoSNTCIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICiscoSNTCIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: CiscoSNTCIntegrationMetadata;
}

export class CiscoSubscriptionManagementIntegrationDTO extends IntegrationDTO implements ICiscoSubscriptionManagementIntegrationDTO {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: CiscoSubscriptionManagementIntegrationMetadata;

    constructor(data?: ICiscoSubscriptionManagementIntegrationDTO) {
        super(data);
        this._discriminator = "CiscoSubscriptionManagementIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (<any>this).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? CiscoSubscriptionManagementIntegrationMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): CiscoSubscriptionManagementIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoSubscriptionManagementIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICiscoSubscriptionManagementIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: CiscoSubscriptionManagementIntegrationMetadata;
}

export class ClientUserDTO implements IClientUserDTO {
    id?: number;
    name?: string | undefined;
    email?: string | undefined;
    role?: string | undefined;
    active?: number;

    constructor(data?: IClientUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.role = _data["role"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): ClientUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ClientUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["role"] = this.role;
        data["active"] = this.active;
        return data;
    }
}

export interface IClientUserDTO {
    id?: number;
    name?: string | undefined;
    email?: string | undefined;
    role?: string | undefined;
    active?: number;
}

export class ClientUsersDTO implements IClientUsersDTO {
    clientUsers?: ClientUserDTO[] | undefined;
    responseStatus?: number;
    errorMessage?: string | undefined;

    constructor(data?: IClientUsersDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["clientUsers"])) {
                this.clientUsers = [] as any;
                for (let item of _data["clientUsers"])
                    this.clientUsers!.push(ClientUserDTO.fromJS(item));
            }
            this.responseStatus = _data["responseStatus"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): ClientUsersDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ClientUsersDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.clientUsers)) {
            data["clientUsers"] = [];
            for (let item of this.clientUsers)
                data["clientUsers"].push(item.toJSON());
        }
        data["responseStatus"] = this.responseStatus;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IClientUsersDTO {
    clientUsers?: ClientUserDTO[] | undefined;
    responseStatus?: number;
    errorMessage?: string | undefined;
}

export class CloudAccountDTO implements ICloudAccountDTO {
    cloudAccountName?: string | undefined;
    cloud?: string | undefined;
    cloudAccountStatus?: string | undefined;
    cloudAccountCreateDate?: Date;
    cloudAccountId?: string | undefined;
    userDefinedFieldsJson?: string | undefined;
    serviceLevel?: string | undefined;
    licenseCount?: number;
    account?: Account;
    contractId?: number;
    configurationItemId?: number;
    costCenterId?: number | undefined;
    costCenterName?: string | undefined;

    constructor(data?: ICloudAccountDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cloudAccountName = _data["cloudAccountName"];
            this.cloud = _data["cloud"];
            this.cloudAccountStatus = _data["cloudAccountStatus"];
            this.cloudAccountCreateDate = _data["cloudAccountCreateDate"] ? new Date(_data["cloudAccountCreateDate"].toString()) : <any>undefined;
            this.cloudAccountId = _data["cloudAccountId"];
            this.userDefinedFieldsJson = _data["userDefinedFieldsJson"];
            this.serviceLevel = _data["serviceLevel"];
            this.licenseCount = _data["licenseCount"];
            this.account = _data["account"] ? Account.fromJS(_data["account"]) : <any>undefined;
            this.contractId = _data["contractId"];
            this.configurationItemId = _data["configurationItemId"];
            this.costCenterId = _data["costCenterId"];
            this.costCenterName = _data["costCenterName"];
        }
    }

    static fromJS(data: any): CloudAccountDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CloudAccountDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cloudAccountName"] = this.cloudAccountName;
        data["cloud"] = this.cloud;
        data["cloudAccountStatus"] = this.cloudAccountStatus;
        data["cloudAccountCreateDate"] = this.cloudAccountCreateDate ? this.cloudAccountCreateDate.toISOString() : <any>undefined;
        data["cloudAccountId"] = this.cloudAccountId;
        data["userDefinedFieldsJson"] = this.userDefinedFieldsJson;
        data["serviceLevel"] = this.serviceLevel;
        data["licenseCount"] = this.licenseCount;
        data["account"] = this.account ? this.account.toJSON() : <any>undefined;
        data["contractId"] = this.contractId;
        data["configurationItemId"] = this.configurationItemId;
        data["costCenterId"] = this.costCenterId;
        data["costCenterName"] = this.costCenterName;
        return data;
    }
}

export interface ICloudAccountDTO {
    cloudAccountName?: string | undefined;
    cloud?: string | undefined;
    cloudAccountStatus?: string | undefined;
    cloudAccountCreateDate?: Date;
    cloudAccountId?: string | undefined;
    userDefinedFieldsJson?: string | undefined;
    serviceLevel?: string | undefined;
    licenseCount?: number;
    account?: Account;
    contractId?: number;
    configurationItemId?: number;
    costCenterId?: number | undefined;
    costCenterName?: string | undefined;
}

export class CloudAccountV2Dto implements ICloudAccountV2Dto {
    parent?: string | undefined;
    cloudAccountName?: string | undefined;
    cloudPlatform?: string | undefined;
    cloudAccountId?: string | undefined;
    type?: string | undefined;
    shiSupportLevel?: string | undefined;
    vendorSupportLevel?: string | undefined;
    currentConsumption?: CloudConsumptionDto;
    monthlyConsumption?: MonthlyCloudConsumptionDto;
    availableActions?: string[] | undefined;
    ownerId?: string | undefined;
    created?: string | undefined;
    contractId?: number;
    configurationItemId?: number;
    itemQuantity?: number | undefined;
    unitType?: string | undefined;
    licensesUsed?: number | undefined;
    licensesAvailable?: number | undefined;

    constructor(data?: ICloudAccountV2Dto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parent = _data["parent"];
            this.cloudAccountName = _data["cloudAccountName"];
            this.cloudPlatform = _data["cloudPlatform"];
            this.cloudAccountId = _data["cloudAccountId"];
            this.type = _data["type"];
            this.shiSupportLevel = _data["shiSupportLevel"];
            this.vendorSupportLevel = _data["vendorSupportLevel"];
            this.currentConsumption = _data["currentConsumption"] ? CloudConsumptionDto.fromJS(_data["currentConsumption"]) : <any>undefined;
            this.monthlyConsumption = _data["monthlyConsumption"] ? MonthlyCloudConsumptionDto.fromJS(_data["monthlyConsumption"]) : <any>undefined;
            if (Array.isArray(_data["availableActions"])) {
                this.availableActions = [] as any;
                for (let item of _data["availableActions"])
                    this.availableActions!.push(item);
            }
            this.ownerId = _data["ownerId"];
            this.created = _data["created"];
            this.contractId = _data["contractId"];
            this.configurationItemId = _data["configurationItemId"];
            this.itemQuantity = _data["itemQuantity"];
            this.unitType = _data["unitType"];
            this.licensesUsed = _data["licensesUsed"];
            this.licensesAvailable = _data["licensesAvailable"];
        }
    }

    static fromJS(data: any): CloudAccountV2Dto {
        data = typeof data === 'object' ? data : {};
        let result = new CloudAccountV2Dto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parent"] = this.parent;
        data["cloudAccountName"] = this.cloudAccountName;
        data["cloudPlatform"] = this.cloudPlatform;
        data["cloudAccountId"] = this.cloudAccountId;
        data["type"] = this.type;
        data["shiSupportLevel"] = this.shiSupportLevel;
        data["vendorSupportLevel"] = this.vendorSupportLevel;
        data["currentConsumption"] = this.currentConsumption ? this.currentConsumption.toJSON() : <any>undefined;
        data["monthlyConsumption"] = this.monthlyConsumption ? this.monthlyConsumption.toJSON() : <any>undefined;
        if (Array.isArray(this.availableActions)) {
            data["availableActions"] = [];
            for (let item of this.availableActions)
                data["availableActions"].push(item);
        }
        data["ownerId"] = this.ownerId;
        data["created"] = this.created;
        data["contractId"] = this.contractId;
        data["configurationItemId"] = this.configurationItemId;
        data["itemQuantity"] = this.itemQuantity;
        data["unitType"] = this.unitType;
        data["licensesUsed"] = this.licensesUsed;
        data["licensesAvailable"] = this.licensesAvailable;
        return data;
    }
}

export interface ICloudAccountV2Dto {
    parent?: string | undefined;
    cloudAccountName?: string | undefined;
    cloudPlatform?: string | undefined;
    cloudAccountId?: string | undefined;
    type?: string | undefined;
    shiSupportLevel?: string | undefined;
    vendorSupportLevel?: string | undefined;
    currentConsumption?: CloudConsumptionDto;
    monthlyConsumption?: MonthlyCloudConsumptionDto;
    availableActions?: string[] | undefined;
    ownerId?: string | undefined;
    created?: string | undefined;
    contractId?: number;
    configurationItemId?: number;
    itemQuantity?: number | undefined;
    unitType?: string | undefined;
    licensesUsed?: number | undefined;
    licensesAvailable?: number | undefined;
}

export class CloudAssetsWidgetDto implements ICloudAssetsWidgetDto {
    name?: string | undefined;
    count?: number;

    constructor(data?: ICloudAssetsWidgetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): CloudAssetsWidgetDto {
        data = typeof data === 'object' ? data : {};
        let result = new CloudAssetsWidgetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["count"] = this.count;
        return data;
    }
}

export interface ICloudAssetsWidgetDto {
    name?: string | undefined;
    count?: number;
}

export class CloudConsumptionHistoryDto implements ICloudConsumptionHistoryDto {
    monthStart?: Date;
    monthlyProviderAmount?: { [key: string]: number; } | undefined;

    constructor(data?: ICloudConsumptionHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monthStart = _data["monthStart"] ? new Date(_data["monthStart"].toString()) : <any>undefined;
            if (_data["monthlyProviderAmount"]) {
                this.monthlyProviderAmount = {} as any;
                for (let key in _data["monthlyProviderAmount"]) {
                    if (_data["monthlyProviderAmount"].hasOwnProperty(key))
                        (<any>this.monthlyProviderAmount)![key] = _data["monthlyProviderAmount"][key];
                }
            }
        }
    }

    static fromJS(data: any): CloudConsumptionHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CloudConsumptionHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monthStart"] = this.monthStart ? this.monthStart.toISOString() : <any>undefined;
        if (this.monthlyProviderAmount) {
            data["monthlyProviderAmount"] = {};
            for (let key in this.monthlyProviderAmount) {
                if (this.monthlyProviderAmount.hasOwnProperty(key))
                    (<any>data["monthlyProviderAmount"])[key] = (<any>this.monthlyProviderAmount)[key];
            }
        }
        return data;
    }
}

export interface ICloudConsumptionHistoryDto {
    monthStart?: Date;
    monthlyProviderAmount?: { [key: string]: number; } | undefined;
}

export class ConfigurationItemDTO implements IConfigurationItemDTO {
    id?: number;
    accountID?: number;
    productID?: number | undefined;
    productName?: string | undefined;
    contractID?: number | undefined;
    type?: number;
    rmmDeviceAuditModelID?: number | undefined;
    rmmDeviceAuditHostname?: string | undefined;
    installDate?: Date;
    contactID?: number | undefined;
    rmmDeviceAuditLastUser?: string | undefined;
    rmmDeviceAuditMissingPatchCount?: number | undefined;
    rmmDeviceID?: number | undefined;
    imageUrl?: string | undefined;
    serialNumber?: string | undefined;
    rmmDeviceUID?: string | undefined;

    protected _discriminator: string;

    constructor(data?: IConfigurationItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "ConfigurationItemDTO";
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountID = _data["accountID"];
            this.productID = _data["productID"];
            this.productName = _data["productName"];
            this.contractID = _data["contractID"];
            this.type = _data["type"];
            this.rmmDeviceAuditModelID = _data["rmmDeviceAuditModelID"];
            this.rmmDeviceAuditHostname = _data["rmmDeviceAuditHostname"];
            this.installDate = _data["installDate"] ? new Date(_data["installDate"].toString()) : <any>undefined;
            this.contactID = _data["contactID"];
            this.rmmDeviceAuditLastUser = _data["rmmDeviceAuditLastUser"];
            this.rmmDeviceAuditMissingPatchCount = _data["rmmDeviceAuditMissingPatchCount"];
            this.rmmDeviceID = _data["rmmDeviceID"];
            this.imageUrl = _data["imageUrl"];
            this.serialNumber = _data["serialNumber"];
            this.rmmDeviceUID = _data["rmmDeviceUID"];
        }
    }

    static fromJS(data: any): ConfigurationItemDTO {
        data = typeof data === 'object' ? data : {};
        if (data["typeName"] === "DattoRmmConfigurationItemDTO") {
            let result = new DattoRmmConfigurationItemDTO();
            result.init(data);
            return result;
        }
        let result = new ConfigurationItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeName"] = this._discriminator;
        data["id"] = this.id;
        data["accountID"] = this.accountID;
        data["productID"] = this.productID;
        data["productName"] = this.productName;
        data["contractID"] = this.contractID;
        data["type"] = this.type;
        data["rmmDeviceAuditModelID"] = this.rmmDeviceAuditModelID;
        data["rmmDeviceAuditHostname"] = this.rmmDeviceAuditHostname;
        data["installDate"] = this.installDate ? this.installDate.toISOString() : <any>undefined;
        data["contactID"] = this.contactID;
        data["rmmDeviceAuditLastUser"] = this.rmmDeviceAuditLastUser;
        data["rmmDeviceAuditMissingPatchCount"] = this.rmmDeviceAuditMissingPatchCount;
        data["rmmDeviceID"] = this.rmmDeviceID;
        data["imageUrl"] = this.imageUrl;
        data["serialNumber"] = this.serialNumber;
        data["rmmDeviceUID"] = this.rmmDeviceUID;
        return data;
    }
}

export interface IConfigurationItemDTO {
    id?: number;
    accountID?: number;
    productID?: number | undefined;
    productName?: string | undefined;
    contractID?: number | undefined;
    type?: number;
    rmmDeviceAuditModelID?: number | undefined;
    rmmDeviceAuditHostname?: string | undefined;
    installDate?: Date;
    contactID?: number | undefined;
    rmmDeviceAuditLastUser?: string | undefined;
    rmmDeviceAuditMissingPatchCount?: number | undefined;
    rmmDeviceID?: number | undefined;
    imageUrl?: string | undefined;
    serialNumber?: string | undefined;
    rmmDeviceUID?: string | undefined;
}

export class CostCenterDTO implements ICostCenterDTO {
    id?: number;
    accountId?: number;
    costCenterId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    poNumber?: string | undefined;
    isDefaultCostCenter?: boolean;

    constructor(data?: ICostCenterDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.costCenterId = _data["costCenterId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.poNumber = _data["poNumber"];
            this.isDefaultCostCenter = _data["isDefaultCostCenter"];
        }
    }

    static fromJS(data: any): CostCenterDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CostCenterDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["costCenterId"] = this.costCenterId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["poNumber"] = this.poNumber;
        data["isDefaultCostCenter"] = this.isDefaultCostCenter;
        return data;
    }
}

export interface ICostCenterDTO {
    id?: number;
    accountId?: number;
    costCenterId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    poNumber?: string | undefined;
    isDefaultCostCenter?: boolean;
}

export class DatadogUsageReportIntegrationDTO extends IntegrationDTO implements IDatadogUsageReportIntegrationDTO {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: DatadogUsageReportIntegrationMetadata;

    constructor(data?: IDatadogUsageReportIntegrationDTO) {
        super(data);
        this._discriminator = "DatadogUsageReportIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (<any>this).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? DatadogUsageReportIntegrationMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): DatadogUsageReportIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DatadogUsageReportIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IDatadogUsageReportIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: DatadogUsageReportIntegrationMetadata;
}

export class DattoRMMIntegrationDTO extends IntegrationDTO implements IDattoRMMIntegrationDTO {
    integrationType?: IntegrationType;
    metadata?: DattoRMMIntegrationMetadata;

    constructor(data?: IDattoRMMIntegrationDTO) {
        super(data);
        this._discriminator = "DattoRMMIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            this.metadata = _data["metadata"] ? DattoRMMIntegrationMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): DattoRMMIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DattoRMMIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IDattoRMMIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    metadata?: DattoRMMIntegrationMetadata;
}

export class DattoRmmConfigurationItemDTO extends ConfigurationItemDTO implements IDattoRmmConfigurationItemDTO {
    rebootStatus?: string | undefined;
    antiVirusStatus?: string | undefined;
    patchStatus?: string | undefined;
    contactName?: string | undefined;
    lastSeen?: number;

    constructor(data?: IDattoRmmConfigurationItemDTO) {
        super(data);
        this._discriminator = "DattoRmmConfigurationItemDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rebootStatus = _data["rebootStatus"];
            this.antiVirusStatus = _data["antiVirusStatus"];
            this.patchStatus = _data["patchStatus"];
            this.contactName = _data["contactName"];
            this.lastSeen = _data["lastSeen"];
        }
    }

    static override fromJS(data: any): DattoRmmConfigurationItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DattoRmmConfigurationItemDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rebootStatus"] = this.rebootStatus;
        data["antiVirusStatus"] = this.antiVirusStatus;
        data["patchStatus"] = this.patchStatus;
        data["contactName"] = this.contactName;
        data["lastSeen"] = this.lastSeen;
        super.toJSON(data);
        return data;
    }
}

export interface IDattoRmmConfigurationItemDTO extends IConfigurationItemDTO {
    rebootStatus?: string | undefined;
    antiVirusStatus?: string | undefined;
    patchStatus?: string | undefined;
    contactName?: string | undefined;
    lastSeen?: number;
}

export class FlexibleServicesAgreementDTO implements IFlexibleServicesAgreementDTO {
    contractId?: number;
    contractTitle?: string | undefined;
    purchasedBilled?: number;
    purchasedAll?: number;
    consumedBilled?: number;
    hoursSpent?: number;
    retainerPurchases?: RetainerPurchaseDTO[] | undefined;
    endDate?: Date;

    constructor(data?: IFlexibleServicesAgreementDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractId = _data["contractId"];
            this.contractTitle = _data["contractTitle"];
            this.purchasedBilled = _data["purchasedBilled"];
            this.purchasedAll = _data["purchasedAll"];
            this.consumedBilled = _data["consumedBilled"];
            this.hoursSpent = _data["hoursSpent"];
            if (Array.isArray(_data["retainerPurchases"])) {
                this.retainerPurchases = [] as any;
                for (let item of _data["retainerPurchases"])
                    this.retainerPurchases!.push(RetainerPurchaseDTO.fromJS(item));
            }
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FlexibleServicesAgreementDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FlexibleServicesAgreementDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractId"] = this.contractId;
        data["contractTitle"] = this.contractTitle;
        data["purchasedBilled"] = this.purchasedBilled;
        data["purchasedAll"] = this.purchasedAll;
        data["consumedBilled"] = this.consumedBilled;
        data["hoursSpent"] = this.hoursSpent;
        if (Array.isArray(this.retainerPurchases)) {
            data["retainerPurchases"] = [];
            for (let item of this.retainerPurchases)
                data["retainerPurchases"].push(item.toJSON());
        }
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFlexibleServicesAgreementDTO {
    contractId?: number;
    contractTitle?: string | undefined;
    purchasedBilled?: number;
    purchasedAll?: number;
    consumedBilled?: number;
    hoursSpent?: number;
    retainerPurchases?: RetainerPurchaseDTO[] | undefined;
    endDate?: Date;
}

export class GcpCloudAssetInventoryIntegrationDTO extends IntegrationDTO implements IGcpCloudAssetInventoryIntegrationDTO {
    integrationType?: IntegrationType;
    metadata?: GcpCloudAssetInventoryMetadata;

    constructor(data?: IGcpCloudAssetInventoryIntegrationDTO) {
        super(data);
        this._discriminator = "GcpCloudAssetInventoryIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            this.metadata = _data["metadata"] ? GcpCloudAssetInventoryMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): GcpCloudAssetInventoryIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GcpCloudAssetInventoryIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IGcpCloudAssetInventoryIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    metadata?: GcpCloudAssetInventoryMetadata;
}

export class GetCloudConsumptionHistoryResponse implements IGetCloudConsumptionHistoryResponse {
    cloudConsumptionHistory?: CloudConsumptionHistoryDto[] | undefined;

    constructor(data?: IGetCloudConsumptionHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cloudConsumptionHistory"])) {
                this.cloudConsumptionHistory = [] as any;
                for (let item of _data["cloudConsumptionHistory"])
                    this.cloudConsumptionHistory!.push(CloudConsumptionHistoryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCloudConsumptionHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCloudConsumptionHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cloudConsumptionHistory)) {
            data["cloudConsumptionHistory"] = [];
            for (let item of this.cloudConsumptionHistory)
                data["cloudConsumptionHistory"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCloudConsumptionHistoryResponse {
    cloudConsumptionHistory?: CloudConsumptionHistoryDto[] | undefined;
}

export class HardwareLifecycleManagementIntegrationDTO extends IntegrationDTO implements IHardwareLifecycleManagementIntegrationDTO {
    integrationType?: IntegrationType;
    metadata?: HardwareLifecycleIntegrationMetadata;

    constructor(data?: IHardwareLifecycleManagementIntegrationDTO) {
        super(data);
        this._discriminator = "HardwareLifecycleManagementIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            this.metadata = _data["metadata"] ? HardwareLifecycleIntegrationMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): HardwareLifecycleManagementIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HardwareLifecycleManagementIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IHardwareLifecycleManagementIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    metadata?: HardwareLifecycleIntegrationMetadata;
}

export class IdcsReportIntegrationDTO extends IntegrationDTO implements IIdcsReportIntegrationDTO {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: IdcsReportIntegrationMetadata;

    constructor(data?: IIdcsReportIntegrationDTO) {
        super(data);
        this._discriminator = "IdcsReportIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (<any>this).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? IdcsReportIntegrationMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): IdcsReportIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IdcsReportIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IIdcsReportIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: IdcsReportIntegrationMetadata;
}

export class AssessmentIntegrationDto extends IntegrationDTO implements IAssessmentIntegrationDto {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: AssessmentIntegrationMetadata;

    protected _discriminator: string;

    constructor(data?: IAssessmentIntegrationDto) {
        super(data);
        this._discriminator = "AssessmentIntegrationDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (<any>this).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? AssessmentIntegrationMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): AssessmentIntegrationDto {
        data = typeof data === 'object' ? data : {};
        if (data["typeName"] === "AiReadinessIntegrationDto") {
            let result = new AiReadinessIntegrationDto();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AwsMaturityAssessmentIntegrationDto") {
            let result = new AwsMaturityAssessmentIntegrationDto();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "DevOpsPostureReviewIntegrationDto") {
            let result = new DevOpsPostureReviewIntegrationDto();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "MicrosoftAdoptionIntegrationDto") {
            let result = new MicrosoftAdoptionIntegrationDto();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "SecurityPostureReviewIntegrationDto") {
            let result = new SecurityPostureReviewIntegrationDto();
            result.init(data);
            return result;
        }
        let result = new AssessmentIntegrationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeName"] = this._discriminator;
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAssessmentIntegrationDto extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: AssessmentIntegrationMetadata;
}

export class AiReadinessIntegrationDto extends AssessmentIntegrationDto implements IAiReadinessIntegrationDto {
    integrationType?: IntegrationType;

    constructor(data?: IAiReadinessIntegrationDto) {
        super(data);
        this._discriminator = "AiReadinessIntegrationDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
        }
    }

    static override fromJS(data: any): AiReadinessIntegrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AiReadinessIntegrationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        super.toJSON(data);
        return data;
    }
}

export interface IAiReadinessIntegrationDto extends IAssessmentIntegrationDto {
    integrationType?: IntegrationType;
}

export class AwsMaturityAssessmentIntegrationDto extends AssessmentIntegrationDto implements IAwsMaturityAssessmentIntegrationDto {
    integrationType?: IntegrationType;

    constructor(data?: IAwsMaturityAssessmentIntegrationDto) {
        super(data);
        this._discriminator = "AwsMaturityAssessmentIntegrationDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
        }
    }

    static override fromJS(data: any): AwsMaturityAssessmentIntegrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AwsMaturityAssessmentIntegrationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        super.toJSON(data);
        return data;
    }
}

export interface IAwsMaturityAssessmentIntegrationDto extends IAssessmentIntegrationDto {
    integrationType?: IntegrationType;
}

export class CatalystIntegrationDTO extends IntegrationDTO implements ICatalystIntegrationDTO {
    integrationType?: IntegrationType;
    metadata?: CatalystIntegrationMetadata;

    constructor(data?: ICatalystIntegrationDTO) {
        super(data);
        this._discriminator = "CatalystIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            this.metadata = _data["metadata"] ? CatalystIntegrationMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): CatalystIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CatalystIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICatalystIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    metadata?: CatalystIntegrationMetadata;
}

export class DevOpsPostureReviewIntegrationDto extends AssessmentIntegrationDto implements IDevOpsPostureReviewIntegrationDto {
    integrationType?: IntegrationType;

    constructor(data?: IDevOpsPostureReviewIntegrationDto) {
        super(data);
        this._discriminator = "DevOpsPostureReviewIntegrationDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
        }
    }

    static override fromJS(data: any): DevOpsPostureReviewIntegrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DevOpsPostureReviewIntegrationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        super.toJSON(data);
        return data;
    }
}

export interface IDevOpsPostureReviewIntegrationDto extends IAssessmentIntegrationDto {
    integrationType?: IntegrationType;
}

export class InstallBaseAnalysisDto extends IntegrationDTO implements IInstallBaseAnalysisDto {
    integrationType?: IntegrationType;
    metadata?: IbaIntegrationMetadata;

    constructor(data?: IInstallBaseAnalysisDto) {
        super(data);
        this._discriminator = "InstallBaseAnalysisDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            this.metadata = _data["metadata"] ? IbaIntegrationMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): InstallBaseAnalysisDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstallBaseAnalysisDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IInstallBaseAnalysisDto extends IIntegrationDTO {
    integrationType?: IntegrationType;
    metadata?: IbaIntegrationMetadata;
}

export class LiveOpticsIntegrationDto extends IntegrationDTO implements ILiveOpticsIntegrationDto {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: LiveOpticsIntegrationMetadata;

    constructor(data?: ILiveOpticsIntegrationDto) {
        super(data);
        this._discriminator = "LiveOpticsIntegrationDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (<any>this).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? LiveOpticsIntegrationMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): LiveOpticsIntegrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiveOpticsIntegrationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ILiveOpticsIntegrationDto extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: LiveOpticsIntegrationMetadata;
}

export class MicrosoftAdoptionIntegrationDto extends AssessmentIntegrationDto implements IMicrosoftAdoptionIntegrationDto {
    integrationType?: IntegrationType;

    constructor(data?: IMicrosoftAdoptionIntegrationDto) {
        super(data);
        this._discriminator = "MicrosoftAdoptionIntegrationDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
        }
    }

    static override fromJS(data: any): MicrosoftAdoptionIntegrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new MicrosoftAdoptionIntegrationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        super.toJSON(data);
        return data;
    }
}

export interface IMicrosoftAdoptionIntegrationDto extends IAssessmentIntegrationDto {
    integrationType?: IntegrationType;
}

export class SecurityPostureReviewIntegrationDto extends AssessmentIntegrationDto implements ISecurityPostureReviewIntegrationDto {
    integrationType?: IntegrationType;

    constructor(data?: ISecurityPostureReviewIntegrationDto) {
        super(data);
        this._discriminator = "SecurityPostureReviewIntegrationDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
        }
    }

    static override fromJS(data: any): SecurityPostureReviewIntegrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityPostureReviewIntegrationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        super.toJSON(data);
        return data;
    }
}

export interface ISecurityPostureReviewIntegrationDto extends IAssessmentIntegrationDto {
    integrationType?: IntegrationType;
}

export class InvoiceSearchFilterDto implements IInvoiceSearchFilterDto {
    searchTerm?: string | undefined;
    page?: number;
    pageSize?: number;
    sortBy?: string | undefined;
    sortDescending?: boolean;
    invoiceId?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    customerPo?: string | undefined;
    tag?: string | undefined;
    contractId?: number | undefined;
    projectId?: number | undefined;
    minAmount?: number | undefined;
    maxAmount?: number | undefined;

    constructor(data?: IInvoiceSearchFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchTerm = _data["searchTerm"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.sortBy = _data["sortBy"];
            this.sortDescending = _data["sortDescending"];
            this.invoiceId = _data["invoiceId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.customerPo = _data["customerPo"];
            this.tag = _data["tag"];
            this.contractId = _data["contractId"];
            this.projectId = _data["projectId"];
            this.minAmount = _data["minAmount"];
            this.maxAmount = _data["maxAmount"];
        }
    }

    static fromJS(data: any): InvoiceSearchFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceSearchFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchTerm"] = this.searchTerm;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["sortBy"] = this.sortBy;
        data["sortDescending"] = this.sortDescending;
        data["invoiceId"] = this.invoiceId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["customerPo"] = this.customerPo;
        data["tag"] = this.tag;
        data["contractId"] = this.contractId;
        data["projectId"] = this.projectId;
        data["minAmount"] = this.minAmount;
        data["maxAmount"] = this.maxAmount;
        return data;
    }
}

export interface IInvoiceSearchFilterDto {
    searchTerm?: string | undefined;
    page?: number;
    pageSize?: number;
    sortBy?: string | undefined;
    sortDescending?: boolean;
    invoiceId?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    customerPo?: string | undefined;
    tag?: string | undefined;
    contractId?: number | undefined;
    projectId?: number | undefined;
    minAmount?: number | undefined;
    maxAmount?: number | undefined;
}

export class MonthlyCloudConsumptionDto implements IMonthlyCloudConsumptionDto {
    cloudAccountId?: string | undefined;
    monthlySpend?: MonthlySpendDto[] | undefined;

    constructor(data?: IMonthlyCloudConsumptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cloudAccountId = _data["cloudAccountId"];
            if (Array.isArray(_data["monthlySpend"])) {
                this.monthlySpend = [] as any;
                for (let item of _data["monthlySpend"])
                    this.monthlySpend!.push(MonthlySpendDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MonthlyCloudConsumptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyCloudConsumptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cloudAccountId"] = this.cloudAccountId;
        if (Array.isArray(this.monthlySpend)) {
            data["monthlySpend"] = [];
            for (let item of this.monthlySpend)
                data["monthlySpend"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMonthlyCloudConsumptionDto {
    cloudAccountId?: string | undefined;
    monthlySpend?: MonthlySpendDto[] | undefined;
}

export class MonthlySpendDto implements IMonthlySpendDto {
    billingMonth?: Date;
    price?: number;

    constructor(data?: IMonthlySpendDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.billingMonth = _data["billingMonth"] ? new Date(_data["billingMonth"].toString()) : <any>undefined;
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): MonthlySpendDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlySpendDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billingMonth"] = this.billingMonth ? this.billingMonth.toISOString() : <any>undefined;
        data["price"] = this.price;
        return data;
    }
}

export interface IMonthlySpendDto {
    billingMonth?: Date;
    price?: number;
}

export class PagedInvoiceResponseDto implements IPagedInvoiceResponseDto {
    invoices?: AxInvoiceAggregateDto[] | undefined;
    pagination?: PagedResultData;

    constructor(data?: IPagedInvoiceResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices!.push(AxInvoiceAggregateDto.fromJS(item));
            }
            this.pagination = _data["pagination"] ? PagedResultData.fromJS(_data["pagination"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PagedInvoiceResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedInvoiceResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item.toJSON());
        }
        data["pagination"] = this.pagination ? this.pagination.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPagedInvoiceResponseDto {
    invoices?: AxInvoiceAggregateDto[] | undefined;
    pagination?: PagedResultData;
}

export class RackAndStackIntegrationDTO extends IntegrationDTO implements IRackAndStackIntegrationDTO {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: RackAndStackIntegrationMetadata;

    constructor(data?: IRackAndStackIntegrationDTO) {
        super(data);
        this._discriminator = "RackAndStackIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (<any>this).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? RackAndStackIntegrationMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): RackAndStackIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RackAndStackIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IRackAndStackIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: RackAndStackIntegrationMetadata;
}

export class RequestSummary implements IRequestSummary {
    severity?: KeyValuePair_2OfInt32AndInt32[] | undefined;
    type?: KeyValuePair_2OfInt32AndInt32[] | undefined;
    category?: KeyValuePair_2OfInt32AndInt32[] | undefined;
    count?: number;

    constructor(data?: IRequestSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["severity"])) {
                this.severity = [] as any;
                for (let item of _data["severity"])
                    this.severity!.push(KeyValuePair_2OfInt32AndInt32.fromJS(item));
            }
            if (Array.isArray(_data["type"])) {
                this.type = [] as any;
                for (let item of _data["type"])
                    this.type!.push(KeyValuePair_2OfInt32AndInt32.fromJS(item));
            }
            if (Array.isArray(_data["category"])) {
                this.category = [] as any;
                for (let item of _data["category"])
                    this.category!.push(KeyValuePair_2OfInt32AndInt32.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): RequestSummary {
        data = typeof data === 'object' ? data : {};
        let result = new RequestSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.severity)) {
            data["severity"] = [];
            for (let item of this.severity)
                data["severity"].push(item.toJSON());
        }
        if (Array.isArray(this.type)) {
            data["type"] = [];
            for (let item of this.type)
                data["type"].push(item.toJSON());
        }
        if (Array.isArray(this.category)) {
            data["category"] = [];
            for (let item of this.category)
                data["category"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data;
    }
}

export interface IRequestSummary {
    severity?: KeyValuePair_2OfInt32AndInt32[] | undefined;
    type?: KeyValuePair_2OfInt32AndInt32[] | undefined;
    category?: KeyValuePair_2OfInt32AndInt32[] | undefined;
    count?: number;
}

export class ResponsesMeetingSlaDto implements IResponsesMeetingSlaDto {
    responseType?: string | undefined;
    meetingSla?: number;
    notMeetingSla?: number;

    constructor(data?: IResponsesMeetingSlaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseType = _data["responseType"];
            this.meetingSla = _data["meetingSla"];
            this.notMeetingSla = _data["notMeetingSla"];
        }
    }

    static fromJS(data: any): ResponsesMeetingSlaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponsesMeetingSlaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseType"] = this.responseType;
        data["meetingSla"] = this.meetingSla;
        data["notMeetingSla"] = this.notMeetingSla;
        return data;
    }
}

export interface IResponsesMeetingSlaDto {
    responseType?: string | undefined;
    meetingSla?: number;
    notMeetingSla?: number;
}

export class RetainerPurchaseDTO implements IRetainerPurchaseDTO {
    retainerId?: number;
    purchased?: Date;
    startDate?: Date;
    endDate?: Date;
    description?: string | undefined;
    amount?: number;
    active?: boolean;
    billed?: boolean;

    constructor(data?: IRetainerPurchaseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.retainerId = _data["retainerId"];
            this.purchased = _data["purchased"] ? new Date(_data["purchased"].toString()) : <any>undefined;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.amount = _data["amount"];
            this.active = _data["active"];
            this.billed = _data["billed"];
        }
    }

    static fromJS(data: any): RetainerPurchaseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RetainerPurchaseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["retainerId"] = this.retainerId;
        data["purchased"] = this.purchased ? this.purchased.toISOString() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["amount"] = this.amount;
        data["active"] = this.active;
        data["billed"] = this.billed;
        return data;
    }
}

export interface IRetainerPurchaseDTO {
    retainerId?: number;
    purchased?: Date;
    startDate?: Date;
    endDate?: Date;
    description?: string | undefined;
    amount?: number;
    active?: boolean;
    billed?: boolean;
}

export class SelfServiceReportingIntegrationDto extends IntegrationDTO implements ISelfServiceReportingIntegrationDto {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: SelfServiceReportingIntegrationMetadata;

    constructor(data?: ISelfServiceReportingIntegrationDto) {
        super(data);
        this._discriminator = "SelfServiceReportingIntegrationDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (<any>this).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? SelfServiceReportingIntegrationMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): SelfServiceReportingIntegrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelfServiceReportingIntegrationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ISelfServiceReportingIntegrationDto extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: SelfServiceReportingIntegrationMetadata;
}

export class ServiceContractTypeDto implements IServiceContractTypeDto {
    contractType?: string | undefined;
    count?: number;

    constructor(data?: IServiceContractTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractType = _data["contractType"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): ServiceContractTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceContractTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractType"] = this.contractType;
        data["count"] = this.count;
        return data;
    }
}

export interface IServiceContractTypeDto {
    contractType?: string | undefined;
    count?: number;
}

export class ServiceContractsWidgetDto implements IServiceContractsWidgetDto {
    contractTypes?: ServiceContractTypeDto[] | undefined;

    constructor(data?: IServiceContractsWidgetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["contractTypes"])) {
                this.contractTypes = [] as any;
                for (let item of _data["contractTypes"])
                    this.contractTypes!.push(ServiceContractTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ServiceContractsWidgetDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceContractsWidgetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contractTypes)) {
            data["contractTypes"] = [];
            for (let item of this.contractTypes)
                data["contractTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IServiceContractsWidgetDto {
    contractTypes?: ServiceContractTypeDto[] | undefined;
}

export class ServiceLevelAgreementResultMetadataDto implements IServiceLevelAgreementResultMetadataDto {
    id?: number;
    lastModifiedDateTime?: Date;

    constructor(data?: IServiceLevelAgreementResultMetadataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastModifiedDateTime = _data["lastModifiedDateTime"] ? new Date(_data["lastModifiedDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceLevelAgreementResultMetadataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceLevelAgreementResultMetadataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime ? this.lastModifiedDateTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IServiceLevelAgreementResultMetadataDto {
    id?: number;
    lastModifiedDateTime?: Date;
}

export class ServiceRequestAccountLocationDTO implements IServiceRequestAccountLocationDTO {
    id?: number;
    name?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    postalCode?: string | undefined;

    constructor(data?: IServiceRequestAccountLocationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.postalCode = _data["postalCode"];
        }
    }

    static fromJS(data: any): ServiceRequestAccountLocationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestAccountLocationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["city"] = this.city;
        data["state"] = this.state;
        data["postalCode"] = this.postalCode;
        return data;
    }
}

export interface IServiceRequestAccountLocationDTO {
    id?: number;
    name?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    postalCode?: string | undefined;
}

export class ServiceRequestCompletedMeetingSlaWidgetDto implements IServiceRequestCompletedMeetingSlaWidgetDto {
    responseTypes?: ResponsesMeetingSlaDto[] | undefined;
    totalMeetingSla?: number;
    totalNotMeetingSla?: number;

    constructor(data?: IServiceRequestCompletedMeetingSlaWidgetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["responseTypes"])) {
                this.responseTypes = [] as any;
                for (let item of _data["responseTypes"])
                    this.responseTypes!.push(ResponsesMeetingSlaDto.fromJS(item));
            }
            this.totalMeetingSla = _data["totalMeetingSla"];
            this.totalNotMeetingSla = _data["totalNotMeetingSla"];
        }
    }

    static fromJS(data: any): ServiceRequestCompletedMeetingSlaWidgetDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestCompletedMeetingSlaWidgetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.responseTypes)) {
            data["responseTypes"] = [];
            for (let item of this.responseTypes)
                data["responseTypes"].push(item.toJSON());
        }
        data["totalMeetingSla"] = this.totalMeetingSla;
        data["totalNotMeetingSla"] = this.totalNotMeetingSla;
        return data;
    }
}

export interface IServiceRequestCompletedMeetingSlaWidgetDto {
    responseTypes?: ResponsesMeetingSlaDto[] | undefined;
    totalMeetingSla?: number;
    totalNotMeetingSla?: number;
}

export class ServiceRequestContactDTO implements IServiceRequestContactDTO {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;

    constructor(data?: IServiceRequestContactDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): ServiceRequestContactDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestContactDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface IServiceRequestContactDTO {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
}

export class ServiceRequestDTO implements IServiceRequestDTO {
    id?: number;
    serviceRequestData?: string | undefined;
    state?: ServiceRequestState;
    serviceRequestMappingId?: number | undefined;
    autotaskTicketData?: TicketDTO;
    serviceRequestMapping?: ServiceRequestMapping;
    createdBy?: Contact;
    availableActions?: ServiceRequestActionType[] | undefined;
    showFormWhenViewing?: boolean;
    isDemoData?: boolean;

    constructor(data?: IServiceRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceRequestData = _data["serviceRequestData"];
            this.state = _data["state"];
            this.serviceRequestMappingId = _data["serviceRequestMappingId"];
            this.autotaskTicketData = _data["autotaskTicketData"] ? TicketDTO.fromJS(_data["autotaskTicketData"]) : <any>undefined;
            this.serviceRequestMapping = _data["serviceRequestMapping"] ? ServiceRequestMapping.fromJS(_data["serviceRequestMapping"]) : <any>undefined;
            this.createdBy = _data["createdBy"] ? Contact.fromJS(_data["createdBy"]) : <any>undefined;
            if (Array.isArray(_data["availableActions"])) {
                this.availableActions = [] as any;
                for (let item of _data["availableActions"])
                    this.availableActions!.push(item);
            }
            this.showFormWhenViewing = _data["showFormWhenViewing"];
            this.isDemoData = _data["isDemoData"];
        }
    }

    static fromJS(data: any): ServiceRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceRequestData"] = this.serviceRequestData;
        data["state"] = this.state;
        data["serviceRequestMappingId"] = this.serviceRequestMappingId;
        data["autotaskTicketData"] = this.autotaskTicketData ? this.autotaskTicketData.toJSON() : <any>undefined;
        data["serviceRequestMapping"] = this.serviceRequestMapping ? this.serviceRequestMapping.toJSON() : <any>undefined;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        if (Array.isArray(this.availableActions)) {
            data["availableActions"] = [];
            for (let item of this.availableActions)
                data["availableActions"].push(item);
        }
        data["showFormWhenViewing"] = this.showFormWhenViewing;
        data["isDemoData"] = this.isDemoData;
        return data;
    }
}

export interface IServiceRequestDTO {
    id?: number;
    serviceRequestData?: string | undefined;
    state?: ServiceRequestState;
    serviceRequestMappingId?: number | undefined;
    autotaskTicketData?: TicketDTO;
    serviceRequestMapping?: ServiceRequestMapping;
    createdBy?: Contact;
    availableActions?: ServiceRequestActionType[] | undefined;
    showFormWhenViewing?: boolean;
    isDemoData?: boolean;
}

export class ServiceRequestSummaryDTO implements IServiceRequestSummaryDTO {
    allServiceRequestsSummary?: RequestSummary;
    myServiceRequestSummary?: RequestSummary;
    secondaryServiceRequestsSummary?: RequestSummary;

    constructor(data?: IServiceRequestSummaryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allServiceRequestsSummary = _data["allServiceRequestsSummary"] ? RequestSummary.fromJS(_data["allServiceRequestsSummary"]) : <any>undefined;
            this.myServiceRequestSummary = _data["myServiceRequestSummary"] ? RequestSummary.fromJS(_data["myServiceRequestSummary"]) : <any>undefined;
            this.secondaryServiceRequestsSummary = _data["secondaryServiceRequestsSummary"] ? RequestSummary.fromJS(_data["secondaryServiceRequestsSummary"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceRequestSummaryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestSummaryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allServiceRequestsSummary"] = this.allServiceRequestsSummary ? this.allServiceRequestsSummary.toJSON() : <any>undefined;
        data["myServiceRequestSummary"] = this.myServiceRequestSummary ? this.myServiceRequestSummary.toJSON() : <any>undefined;
        data["secondaryServiceRequestsSummary"] = this.secondaryServiceRequestsSummary ? this.secondaryServiceRequestsSummary.toJSON() : <any>undefined;
        return data;
    }
}

export interface IServiceRequestSummaryDTO {
    allServiceRequestsSummary?: RequestSummary;
    myServiceRequestSummary?: RequestSummary;
    secondaryServiceRequestsSummary?: RequestSummary;
}

export class ServiceRequestsResponseDTO implements IServiceRequestsResponseDTO {
    requests?: ServiceRequestDTO[] | undefined;
    count?: number;
    contacts?: Contact[] | undefined;
    resources?: Resource[] | undefined;

    constructor(data?: IServiceRequestsResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["requests"])) {
                this.requests = [] as any;
                for (let item of _data["requests"])
                    this.requests!.push(ServiceRequestDTO.fromJS(item));
            }
            this.count = _data["count"];
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(Contact.fromJS(item));
            }
            if (Array.isArray(_data["resources"])) {
                this.resources = [] as any;
                for (let item of _data["resources"])
                    this.resources!.push(Resource.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ServiceRequestsResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestsResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.requests)) {
            data["requests"] = [];
            for (let item of this.requests)
                data["requests"].push(item.toJSON());
        }
        data["count"] = this.count;
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        if (Array.isArray(this.resources)) {
            data["resources"] = [];
            for (let item of this.resources)
                data["resources"].push(item.toJSON());
        }
        return data;
    }
}

export interface IServiceRequestsResponseDTO {
    requests?: ServiceRequestDTO[] | undefined;
    count?: number;
    contacts?: Contact[] | undefined;
    resources?: Resource[] | undefined;
}

export class ServicesExpiringContractDto implements IServicesExpiringContractDto {
    name?: string | undefined;
    company?: string | undefined;
    contractType?: string | undefined;
    daysUntilExpiration?: number;

    constructor(data?: IServicesExpiringContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.company = _data["company"];
            this.contractType = _data["contractType"];
            this.daysUntilExpiration = _data["daysUntilExpiration"];
        }
    }

    static fromJS(data: any): ServicesExpiringContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServicesExpiringContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["company"] = this.company;
        data["contractType"] = this.contractType;
        data["daysUntilExpiration"] = this.daysUntilExpiration;
        return data;
    }
}

export interface IServicesExpiringContractDto {
    name?: string | undefined;
    company?: string | undefined;
    contractType?: string | undefined;
    daysUntilExpiration?: number;
}

export class ServicesExpiringContractsWidgetDto implements IServicesExpiringContractsWidgetDto {
    expiringContracts?: ServicesExpiringContractDto[] | undefined;

    constructor(data?: IServicesExpiringContractsWidgetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["expiringContracts"])) {
                this.expiringContracts = [] as any;
                for (let item of _data["expiringContracts"])
                    this.expiringContracts!.push(ServicesExpiringContractDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ServicesExpiringContractsWidgetDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServicesExpiringContractsWidgetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.expiringContracts)) {
            data["expiringContracts"] = [];
            for (let item of this.expiringContracts)
                data["expiringContracts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IServicesExpiringContractsWidgetDto {
    expiringContracts?: ServicesExpiringContractDto[] | undefined;
}

export class SurveyResultMetadataDto implements ISurveyResultMetadataDto {
    id?: number;
    completeDate?: Date;

    constructor(data?: ISurveyResultMetadataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.completeDate = _data["completeDate"] ? new Date(_data["completeDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SurveyResultMetadataDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyResultMetadataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["completeDate"] = this.completeDate ? this.completeDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISurveyResultMetadataDto {
    id?: number;
    completeDate?: Date;
}

export class TestNestedChildDataDto implements ITestNestedChildDataDto {
    nestedListOfIntegers?: number[] | undefined;
    nestedListOfStrings?: string[] | undefined;
    nestedListOfDoubles?: number[] | undefined;
    nestedArrayOfIntegers?: number[] | undefined;
    nestedArrayOfStrings?: string[] | undefined;
    nestedArrayOfDoubles?: number[] | undefined;

    constructor(data?: ITestNestedChildDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["nestedListOfIntegers"])) {
                this.nestedListOfIntegers = [] as any;
                for (let item of _data["nestedListOfIntegers"])
                    this.nestedListOfIntegers!.push(item);
            }
            if (Array.isArray(_data["nestedListOfStrings"])) {
                this.nestedListOfStrings = [] as any;
                for (let item of _data["nestedListOfStrings"])
                    this.nestedListOfStrings!.push(item);
            }
            if (Array.isArray(_data["nestedListOfDoubles"])) {
                this.nestedListOfDoubles = [] as any;
                for (let item of _data["nestedListOfDoubles"])
                    this.nestedListOfDoubles!.push(item);
            }
            if (Array.isArray(_data["nestedArrayOfIntegers"])) {
                this.nestedArrayOfIntegers = [] as any;
                for (let item of _data["nestedArrayOfIntegers"])
                    this.nestedArrayOfIntegers!.push(item);
            }
            if (Array.isArray(_data["nestedArrayOfStrings"])) {
                this.nestedArrayOfStrings = [] as any;
                for (let item of _data["nestedArrayOfStrings"])
                    this.nestedArrayOfStrings!.push(item);
            }
            if (Array.isArray(_data["nestedArrayOfDoubles"])) {
                this.nestedArrayOfDoubles = [] as any;
                for (let item of _data["nestedArrayOfDoubles"])
                    this.nestedArrayOfDoubles!.push(item);
            }
        }
    }

    static fromJS(data: any): TestNestedChildDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new TestNestedChildDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.nestedListOfIntegers)) {
            data["nestedListOfIntegers"] = [];
            for (let item of this.nestedListOfIntegers)
                data["nestedListOfIntegers"].push(item);
        }
        if (Array.isArray(this.nestedListOfStrings)) {
            data["nestedListOfStrings"] = [];
            for (let item of this.nestedListOfStrings)
                data["nestedListOfStrings"].push(item);
        }
        if (Array.isArray(this.nestedListOfDoubles)) {
            data["nestedListOfDoubles"] = [];
            for (let item of this.nestedListOfDoubles)
                data["nestedListOfDoubles"].push(item);
        }
        if (Array.isArray(this.nestedArrayOfIntegers)) {
            data["nestedArrayOfIntegers"] = [];
            for (let item of this.nestedArrayOfIntegers)
                data["nestedArrayOfIntegers"].push(item);
        }
        if (Array.isArray(this.nestedArrayOfStrings)) {
            data["nestedArrayOfStrings"] = [];
            for (let item of this.nestedArrayOfStrings)
                data["nestedArrayOfStrings"].push(item);
        }
        if (Array.isArray(this.nestedArrayOfDoubles)) {
            data["nestedArrayOfDoubles"] = [];
            for (let item of this.nestedArrayOfDoubles)
                data["nestedArrayOfDoubles"].push(item);
        }
        return data;
    }
}

export interface ITestNestedChildDataDto {
    nestedListOfIntegers?: number[] | undefined;
    nestedListOfStrings?: string[] | undefined;
    nestedListOfDoubles?: number[] | undefined;
    nestedArrayOfIntegers?: number[] | undefined;
    nestedArrayOfStrings?: string[] | undefined;
    nestedArrayOfDoubles?: number[] | undefined;
}

export class TestNestedDataDto implements ITestNestedDataDto {
    integerValue?: number;
    doubleValue?: number;
    booleanValue?: boolean;
    stringValue?: string | undefined;
    listOfIntegers?: number[] | undefined;
    listOfStrings?: string[] | undefined;
    listOfDoubles?: number[] | undefined;
    arrayOfIntegers?: number[] | undefined;
    arrayOfStrings?: string[] | undefined;
    arrayOfDoubles?: number[] | undefined;
    childData?: TestNestedChildDataDto;

    constructor(data?: ITestNestedDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.integerValue = _data["integerValue"];
            this.doubleValue = _data["doubleValue"];
            this.booleanValue = _data["booleanValue"];
            this.stringValue = _data["stringValue"];
            if (Array.isArray(_data["listOfIntegers"])) {
                this.listOfIntegers = [] as any;
                for (let item of _data["listOfIntegers"])
                    this.listOfIntegers!.push(item);
            }
            if (Array.isArray(_data["listOfStrings"])) {
                this.listOfStrings = [] as any;
                for (let item of _data["listOfStrings"])
                    this.listOfStrings!.push(item);
            }
            if (Array.isArray(_data["listOfDoubles"])) {
                this.listOfDoubles = [] as any;
                for (let item of _data["listOfDoubles"])
                    this.listOfDoubles!.push(item);
            }
            if (Array.isArray(_data["arrayOfIntegers"])) {
                this.arrayOfIntegers = [] as any;
                for (let item of _data["arrayOfIntegers"])
                    this.arrayOfIntegers!.push(item);
            }
            if (Array.isArray(_data["arrayOfStrings"])) {
                this.arrayOfStrings = [] as any;
                for (let item of _data["arrayOfStrings"])
                    this.arrayOfStrings!.push(item);
            }
            if (Array.isArray(_data["arrayOfDoubles"])) {
                this.arrayOfDoubles = [] as any;
                for (let item of _data["arrayOfDoubles"])
                    this.arrayOfDoubles!.push(item);
            }
            this.childData = _data["childData"] ? TestNestedChildDataDto.fromJS(_data["childData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TestNestedDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new TestNestedDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integerValue"] = this.integerValue;
        data["doubleValue"] = this.doubleValue;
        data["booleanValue"] = this.booleanValue;
        data["stringValue"] = this.stringValue;
        if (Array.isArray(this.listOfIntegers)) {
            data["listOfIntegers"] = [];
            for (let item of this.listOfIntegers)
                data["listOfIntegers"].push(item);
        }
        if (Array.isArray(this.listOfStrings)) {
            data["listOfStrings"] = [];
            for (let item of this.listOfStrings)
                data["listOfStrings"].push(item);
        }
        if (Array.isArray(this.listOfDoubles)) {
            data["listOfDoubles"] = [];
            for (let item of this.listOfDoubles)
                data["listOfDoubles"].push(item);
        }
        if (Array.isArray(this.arrayOfIntegers)) {
            data["arrayOfIntegers"] = [];
            for (let item of this.arrayOfIntegers)
                data["arrayOfIntegers"].push(item);
        }
        if (Array.isArray(this.arrayOfStrings)) {
            data["arrayOfStrings"] = [];
            for (let item of this.arrayOfStrings)
                data["arrayOfStrings"].push(item);
        }
        if (Array.isArray(this.arrayOfDoubles)) {
            data["arrayOfDoubles"] = [];
            for (let item of this.arrayOfDoubles)
                data["arrayOfDoubles"].push(item);
        }
        data["childData"] = this.childData ? this.childData.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITestNestedDataDto {
    integerValue?: number;
    doubleValue?: number;
    booleanValue?: boolean;
    stringValue?: string | undefined;
    listOfIntegers?: number[] | undefined;
    listOfStrings?: string[] | undefined;
    listOfDoubles?: number[] | undefined;
    arrayOfIntegers?: number[] | undefined;
    arrayOfStrings?: string[] | undefined;
    arrayOfDoubles?: number[] | undefined;
    childData?: TestNestedChildDataDto;
}

export class TestNestedDataResultDto implements ITestNestedDataResultDto {
    id?: number;
    nestedData?: TestNestedDataDto;

    constructor(data?: ITestNestedDataResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nestedData = _data["nestedData"] ? TestNestedDataDto.fromJS(_data["nestedData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TestNestedDataResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TestNestedDataResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nestedData"] = this.nestedData ? this.nestedData.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITestNestedDataResultDto {
    id?: number;
    nestedData?: TestNestedDataDto;
}

export class TicketAdditionalContactDTO implements ITicketAdditionalContactDTO {
    id?: number;
    contactId?: number;
    ticketId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;

    constructor(data?: ITicketAdditionalContactDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contactId = _data["contactId"];
            this.ticketId = _data["ticketId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): TicketAdditionalContactDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TicketAdditionalContactDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contactId"] = this.contactId;
        data["ticketId"] = this.ticketId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        return data;
    }
}

export interface ITicketAdditionalContactDTO {
    id?: number;
    contactId?: number;
    ticketId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export class TicketAttachmentDTO implements ITicketAttachmentDTO {
    id?: number;
    guid?: string | undefined;
    fileName?: string | undefined;
    fileType?: string | undefined;
    dateUploaded?: Date;
    fileSize?: number;
    ticketId?: number;
    ticketNoteId?: number;

    constructor(data?: ITicketAttachmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.guid = _data["guid"];
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.dateUploaded = _data["dateUploaded"] ? new Date(_data["dateUploaded"].toString()) : <any>undefined;
            this.fileSize = _data["fileSize"];
            this.ticketId = _data["ticketId"];
            this.ticketNoteId = _data["ticketNoteId"];
        }
    }

    static fromJS(data: any): TicketAttachmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TicketAttachmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["guid"] = this.guid;
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["dateUploaded"] = this.dateUploaded ? this.dateUploaded.toISOString() : <any>undefined;
        data["fileSize"] = this.fileSize;
        data["ticketId"] = this.ticketId;
        data["ticketNoteId"] = this.ticketNoteId;
        return data;
    }
}

export interface ITicketAttachmentDTO {
    id?: number;
    guid?: string | undefined;
    fileName?: string | undefined;
    fileType?: string | undefined;
    dateUploaded?: Date;
    fileSize?: number;
    ticketId?: number;
    ticketNoteId?: number;
}

export class TicketDTO implements ITicketDTO {
    id?: number;
    accountPhysicalLocationID?: number;
    rmmAlertID?: string | undefined;
    allocationCodeID?: number;
    assignedResourceRoleID?: number;
    businessDivisionSubdivisionID?: number;
    changeApprovalBoard?: number;
    changeApprovalStatus?: number;
    changeApprovalType?: number;
    changeInfoField1?: string | undefined;
    changeInfoField2?: string | undefined;
    changeInfoField3?: string | undefined;
    changeInfoField4?: string | undefined;
    changeInfoField5?: string | undefined;
    completedDate?: Date;
    contractID?: number;
    contractServiceBundleID?: number;
    contractServiceID?: number;
    createDate?: Date;
    creatorType?: number;
    description?: string | undefined;
    dueDateTime?: Date;
    estimatedHours?: number;
    externalID?: string | undefined;
    firstResponseAssignedResourceID?: number;
    firstResponseDateTime?: Date;
    firstResponseDueDateTime?: Date;
    firstResponseInitiatingResourceID?: number;
    hoursToBeScheduled?: number;
    installedProductID?: number;
    issueType?: number;
    lastActivityDate?: Date;
    lastActivityPersonType?: number;
    lastCustomerNotificationDateTime?: Date;
    lastCustomerVisibleActivityDateTime?: Date;
    monitorID?: number;
    monitorTypeID?: number;
    opportunityID?: number;
    priority?: number;
    problemTicketID?: number;
    projectID?: number;
    purchaseOrderNumber?: string | undefined;
    queueID?: number;
    resolution?: string | undefined;
    resolutionPlanDateTime?: Date;
    resolutionPlanDueDateTime?: Date;
    resolvedDateTime?: Date;
    resolvedDueDateTime?: Date;
    serviceLevelAgreementHasBeenMet?: boolean;
    serviceLevelAgreementID?: number;
    source?: number;
    status?: number;
    subIssueType?: number;
    ticketCategory?: number;
    ticketNumber?: string | undefined;
    ticketType?: number;
    title?: string | undefined;
    accountID?: number | undefined;
    contactID?: number | undefined;
    contactName?: string | undefined;
    lastActivity?: Date;
    ticketNotes?: TicketNoteDTO[] | undefined;
    assignedResourceID?: number | undefined;
    completedByResourceID?: number | undefined;
    creatorResourceID?: number | undefined;
    lastActivityResourceID?: number | undefined;
    deleted?: boolean;
    assignedResourceName?: string | undefined;
    completedByResourceName?: string | undefined;
    creatorResourceName?: string | undefined;
    lastActivityResourceName?: string | undefined;
    userDefinedFieldsJson?: string | undefined;
    ticketAttachmentGuids?: string[] | undefined;
    ticketAttachments?: TicketAttachmentDTO[] | undefined;
    secondaryContactIds?: number[] | undefined;
    configurationPageUrl?: string | undefined;
    totalRows?: number | undefined;

    constructor(data?: ITicketDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountPhysicalLocationID = _data["accountPhysicalLocationID"];
            this.rmmAlertID = _data["rmmAlertID"];
            this.allocationCodeID = _data["allocationCodeID"];
            this.assignedResourceRoleID = _data["assignedResourceRoleID"];
            this.businessDivisionSubdivisionID = _data["businessDivisionSubdivisionID"];
            this.changeApprovalBoard = _data["changeApprovalBoard"];
            this.changeApprovalStatus = _data["changeApprovalStatus"];
            this.changeApprovalType = _data["changeApprovalType"];
            this.changeInfoField1 = _data["changeInfoField1"];
            this.changeInfoField2 = _data["changeInfoField2"];
            this.changeInfoField3 = _data["changeInfoField3"];
            this.changeInfoField4 = _data["changeInfoField4"];
            this.changeInfoField5 = _data["changeInfoField5"];
            this.completedDate = _data["completedDate"] ? new Date(_data["completedDate"].toString()) : <any>undefined;
            this.contractID = _data["contractID"];
            this.contractServiceBundleID = _data["contractServiceBundleID"];
            this.contractServiceID = _data["contractServiceID"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.creatorType = _data["creatorType"];
            this.description = _data["description"];
            this.dueDateTime = _data["dueDateTime"] ? new Date(_data["dueDateTime"].toString()) : <any>undefined;
            this.estimatedHours = _data["estimatedHours"];
            this.externalID = _data["externalID"];
            this.firstResponseAssignedResourceID = _data["firstResponseAssignedResourceID"];
            this.firstResponseDateTime = _data["firstResponseDateTime"] ? new Date(_data["firstResponseDateTime"].toString()) : <any>undefined;
            this.firstResponseDueDateTime = _data["firstResponseDueDateTime"] ? new Date(_data["firstResponseDueDateTime"].toString()) : <any>undefined;
            this.firstResponseInitiatingResourceID = _data["firstResponseInitiatingResourceID"];
            this.hoursToBeScheduled = _data["hoursToBeScheduled"];
            this.installedProductID = _data["installedProductID"];
            this.issueType = _data["issueType"];
            this.lastActivityDate = _data["lastActivityDate"] ? new Date(_data["lastActivityDate"].toString()) : <any>undefined;
            this.lastActivityPersonType = _data["lastActivityPersonType"];
            this.lastCustomerNotificationDateTime = _data["lastCustomerNotificationDateTime"] ? new Date(_data["lastCustomerNotificationDateTime"].toString()) : <any>undefined;
            this.lastCustomerVisibleActivityDateTime = _data["lastCustomerVisibleActivityDateTime"] ? new Date(_data["lastCustomerVisibleActivityDateTime"].toString()) : <any>undefined;
            this.monitorID = _data["monitorID"];
            this.monitorTypeID = _data["monitorTypeID"];
            this.opportunityID = _data["opportunityID"];
            this.priority = _data["priority"];
            this.problemTicketID = _data["problemTicketID"];
            this.projectID = _data["projectID"];
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
            this.queueID = _data["queueID"];
            this.resolution = _data["resolution"];
            this.resolutionPlanDateTime = _data["resolutionPlanDateTime"] ? new Date(_data["resolutionPlanDateTime"].toString()) : <any>undefined;
            this.resolutionPlanDueDateTime = _data["resolutionPlanDueDateTime"] ? new Date(_data["resolutionPlanDueDateTime"].toString()) : <any>undefined;
            this.resolvedDateTime = _data["resolvedDateTime"] ? new Date(_data["resolvedDateTime"].toString()) : <any>undefined;
            this.resolvedDueDateTime = _data["resolvedDueDateTime"] ? new Date(_data["resolvedDueDateTime"].toString()) : <any>undefined;
            this.serviceLevelAgreementHasBeenMet = _data["serviceLevelAgreementHasBeenMet"];
            this.serviceLevelAgreementID = _data["serviceLevelAgreementID"];
            this.source = _data["source"];
            this.status = _data["status"];
            this.subIssueType = _data["subIssueType"];
            this.ticketCategory = _data["ticketCategory"];
            this.ticketNumber = _data["ticketNumber"];
            this.ticketType = _data["ticketType"];
            this.title = _data["title"];
            this.accountID = _data["accountID"];
            this.contactID = _data["contactID"];
            this.contactName = _data["contactName"];
            this.lastActivity = _data["lastActivity"] ? new Date(_data["lastActivity"].toString()) : <any>undefined;
            if (Array.isArray(_data["ticketNotes"])) {
                this.ticketNotes = [] as any;
                for (let item of _data["ticketNotes"])
                    this.ticketNotes!.push(TicketNoteDTO.fromJS(item));
            }
            this.assignedResourceID = _data["assignedResourceID"];
            this.completedByResourceID = _data["completedByResourceID"];
            this.creatorResourceID = _data["creatorResourceID"];
            this.lastActivityResourceID = _data["lastActivityResourceID"];
            this.deleted = _data["deleted"];
            this.assignedResourceName = _data["assignedResourceName"];
            this.completedByResourceName = _data["completedByResourceName"];
            this.creatorResourceName = _data["creatorResourceName"];
            this.lastActivityResourceName = _data["lastActivityResourceName"];
            this.userDefinedFieldsJson = _data["userDefinedFieldsJson"];
            if (Array.isArray(_data["ticketAttachmentGuids"])) {
                this.ticketAttachmentGuids = [] as any;
                for (let item of _data["ticketAttachmentGuids"])
                    this.ticketAttachmentGuids!.push(item);
            }
            if (Array.isArray(_data["ticketAttachments"])) {
                this.ticketAttachments = [] as any;
                for (let item of _data["ticketAttachments"])
                    this.ticketAttachments!.push(TicketAttachmentDTO.fromJS(item));
            }
            if (Array.isArray(_data["secondaryContactIds"])) {
                this.secondaryContactIds = [] as any;
                for (let item of _data["secondaryContactIds"])
                    this.secondaryContactIds!.push(item);
            }
            this.configurationPageUrl = _data["configurationPageUrl"];
            this.totalRows = _data["totalRows"];
        }
    }

    static fromJS(data: any): TicketDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TicketDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountPhysicalLocationID"] = this.accountPhysicalLocationID;
        data["rmmAlertID"] = this.rmmAlertID;
        data["allocationCodeID"] = this.allocationCodeID;
        data["assignedResourceRoleID"] = this.assignedResourceRoleID;
        data["businessDivisionSubdivisionID"] = this.businessDivisionSubdivisionID;
        data["changeApprovalBoard"] = this.changeApprovalBoard;
        data["changeApprovalStatus"] = this.changeApprovalStatus;
        data["changeApprovalType"] = this.changeApprovalType;
        data["changeInfoField1"] = this.changeInfoField1;
        data["changeInfoField2"] = this.changeInfoField2;
        data["changeInfoField3"] = this.changeInfoField3;
        data["changeInfoField4"] = this.changeInfoField4;
        data["changeInfoField5"] = this.changeInfoField5;
        data["completedDate"] = this.completedDate ? this.completedDate.toISOString() : <any>undefined;
        data["contractID"] = this.contractID;
        data["contractServiceBundleID"] = this.contractServiceBundleID;
        data["contractServiceID"] = this.contractServiceID;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["creatorType"] = this.creatorType;
        data["description"] = this.description;
        data["dueDateTime"] = this.dueDateTime ? this.dueDateTime.toISOString() : <any>undefined;
        data["estimatedHours"] = this.estimatedHours;
        data["externalID"] = this.externalID;
        data["firstResponseAssignedResourceID"] = this.firstResponseAssignedResourceID;
        data["firstResponseDateTime"] = this.firstResponseDateTime ? this.firstResponseDateTime.toISOString() : <any>undefined;
        data["firstResponseDueDateTime"] = this.firstResponseDueDateTime ? this.firstResponseDueDateTime.toISOString() : <any>undefined;
        data["firstResponseInitiatingResourceID"] = this.firstResponseInitiatingResourceID;
        data["hoursToBeScheduled"] = this.hoursToBeScheduled;
        data["installedProductID"] = this.installedProductID;
        data["issueType"] = this.issueType;
        data["lastActivityDate"] = this.lastActivityDate ? this.lastActivityDate.toISOString() : <any>undefined;
        data["lastActivityPersonType"] = this.lastActivityPersonType;
        data["lastCustomerNotificationDateTime"] = this.lastCustomerNotificationDateTime ? this.lastCustomerNotificationDateTime.toISOString() : <any>undefined;
        data["lastCustomerVisibleActivityDateTime"] = this.lastCustomerVisibleActivityDateTime ? this.lastCustomerVisibleActivityDateTime.toISOString() : <any>undefined;
        data["monitorID"] = this.monitorID;
        data["monitorTypeID"] = this.monitorTypeID;
        data["opportunityID"] = this.opportunityID;
        data["priority"] = this.priority;
        data["problemTicketID"] = this.problemTicketID;
        data["projectID"] = this.projectID;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        data["queueID"] = this.queueID;
        data["resolution"] = this.resolution;
        data["resolutionPlanDateTime"] = this.resolutionPlanDateTime ? this.resolutionPlanDateTime.toISOString() : <any>undefined;
        data["resolutionPlanDueDateTime"] = this.resolutionPlanDueDateTime ? this.resolutionPlanDueDateTime.toISOString() : <any>undefined;
        data["resolvedDateTime"] = this.resolvedDateTime ? this.resolvedDateTime.toISOString() : <any>undefined;
        data["resolvedDueDateTime"] = this.resolvedDueDateTime ? this.resolvedDueDateTime.toISOString() : <any>undefined;
        data["serviceLevelAgreementHasBeenMet"] = this.serviceLevelAgreementHasBeenMet;
        data["serviceLevelAgreementID"] = this.serviceLevelAgreementID;
        data["source"] = this.source;
        data["status"] = this.status;
        data["subIssueType"] = this.subIssueType;
        data["ticketCategory"] = this.ticketCategory;
        data["ticketNumber"] = this.ticketNumber;
        data["ticketType"] = this.ticketType;
        data["title"] = this.title;
        data["accountID"] = this.accountID;
        data["contactID"] = this.contactID;
        data["contactName"] = this.contactName;
        data["lastActivity"] = this.lastActivity ? this.lastActivity.toISOString() : <any>undefined;
        if (Array.isArray(this.ticketNotes)) {
            data["ticketNotes"] = [];
            for (let item of this.ticketNotes)
                data["ticketNotes"].push(item.toJSON());
        }
        data["assignedResourceID"] = this.assignedResourceID;
        data["completedByResourceID"] = this.completedByResourceID;
        data["creatorResourceID"] = this.creatorResourceID;
        data["lastActivityResourceID"] = this.lastActivityResourceID;
        data["deleted"] = this.deleted;
        data["assignedResourceName"] = this.assignedResourceName;
        data["completedByResourceName"] = this.completedByResourceName;
        data["creatorResourceName"] = this.creatorResourceName;
        data["lastActivityResourceName"] = this.lastActivityResourceName;
        data["userDefinedFieldsJson"] = this.userDefinedFieldsJson;
        if (Array.isArray(this.ticketAttachmentGuids)) {
            data["ticketAttachmentGuids"] = [];
            for (let item of this.ticketAttachmentGuids)
                data["ticketAttachmentGuids"].push(item);
        }
        if (Array.isArray(this.ticketAttachments)) {
            data["ticketAttachments"] = [];
            for (let item of this.ticketAttachments)
                data["ticketAttachments"].push(item.toJSON());
        }
        if (Array.isArray(this.secondaryContactIds)) {
            data["secondaryContactIds"] = [];
            for (let item of this.secondaryContactIds)
                data["secondaryContactIds"].push(item);
        }
        data["configurationPageUrl"] = this.configurationPageUrl;
        data["totalRows"] = this.totalRows;
        return data;
    }
}

export interface ITicketDTO {
    id?: number;
    accountPhysicalLocationID?: number;
    rmmAlertID?: string | undefined;
    allocationCodeID?: number;
    assignedResourceRoleID?: number;
    businessDivisionSubdivisionID?: number;
    changeApprovalBoard?: number;
    changeApprovalStatus?: number;
    changeApprovalType?: number;
    changeInfoField1?: string | undefined;
    changeInfoField2?: string | undefined;
    changeInfoField3?: string | undefined;
    changeInfoField4?: string | undefined;
    changeInfoField5?: string | undefined;
    completedDate?: Date;
    contractID?: number;
    contractServiceBundleID?: number;
    contractServiceID?: number;
    createDate?: Date;
    creatorType?: number;
    description?: string | undefined;
    dueDateTime?: Date;
    estimatedHours?: number;
    externalID?: string | undefined;
    firstResponseAssignedResourceID?: number;
    firstResponseDateTime?: Date;
    firstResponseDueDateTime?: Date;
    firstResponseInitiatingResourceID?: number;
    hoursToBeScheduled?: number;
    installedProductID?: number;
    issueType?: number;
    lastActivityDate?: Date;
    lastActivityPersonType?: number;
    lastCustomerNotificationDateTime?: Date;
    lastCustomerVisibleActivityDateTime?: Date;
    monitorID?: number;
    monitorTypeID?: number;
    opportunityID?: number;
    priority?: number;
    problemTicketID?: number;
    projectID?: number;
    purchaseOrderNumber?: string | undefined;
    queueID?: number;
    resolution?: string | undefined;
    resolutionPlanDateTime?: Date;
    resolutionPlanDueDateTime?: Date;
    resolvedDateTime?: Date;
    resolvedDueDateTime?: Date;
    serviceLevelAgreementHasBeenMet?: boolean;
    serviceLevelAgreementID?: number;
    source?: number;
    status?: number;
    subIssueType?: number;
    ticketCategory?: number;
    ticketNumber?: string | undefined;
    ticketType?: number;
    title?: string | undefined;
    accountID?: number | undefined;
    contactID?: number | undefined;
    contactName?: string | undefined;
    lastActivity?: Date;
    ticketNotes?: TicketNoteDTO[] | undefined;
    assignedResourceID?: number | undefined;
    completedByResourceID?: number | undefined;
    creatorResourceID?: number | undefined;
    lastActivityResourceID?: number | undefined;
    deleted?: boolean;
    assignedResourceName?: string | undefined;
    completedByResourceName?: string | undefined;
    creatorResourceName?: string | undefined;
    lastActivityResourceName?: string | undefined;
    userDefinedFieldsJson?: string | undefined;
    ticketAttachmentGuids?: string[] | undefined;
    ticketAttachments?: TicketAttachmentDTO[] | undefined;
    secondaryContactIds?: number[] | undefined;
    configurationPageUrl?: string | undefined;
    totalRows?: number | undefined;
}

export class TicketMetadataDto implements ITicketMetadataDto {
    id?: number;
    accountId?: number;
    lastActivityDate?: Date;
    deleted?: boolean;

    constructor(data?: ITicketMetadataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.lastActivityDate = _data["lastActivityDate"] ? new Date(_data["lastActivityDate"].toString()) : <any>undefined;
            this.deleted = _data["deleted"];
        }
    }

    static fromJS(data: any): TicketMetadataDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketMetadataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["lastActivityDate"] = this.lastActivityDate ? this.lastActivityDate.toISOString() : <any>undefined;
        data["deleted"] = this.deleted;
        return data;
    }
}

export interface ITicketMetadataDto {
    id?: number;
    accountId?: number;
    lastActivityDate?: Date;
    deleted?: boolean;
}

export class TicketNoteDTO implements ITicketNoteDTO {
    id?: number;
    creatorResourceID?: number;
    resourceName?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    noteType?: number;
    publish?: number;
    lastActivityDate?: Date;
    ticketID?: number | undefined;
    ticketAttachmentGuids?: string[] | undefined;
    ticketAttachments?: TicketAttachmentDTO[] | undefined;

    constructor(data?: ITicketNoteDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorResourceID = _data["creatorResourceID"];
            this.resourceName = _data["resourceName"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.noteType = _data["noteType"];
            this.publish = _data["publish"];
            this.lastActivityDate = _data["lastActivityDate"] ? new Date(_data["lastActivityDate"].toString()) : <any>undefined;
            this.ticketID = _data["ticketID"];
            if (Array.isArray(_data["ticketAttachmentGuids"])) {
                this.ticketAttachmentGuids = [] as any;
                for (let item of _data["ticketAttachmentGuids"])
                    this.ticketAttachmentGuids!.push(item);
            }
            if (Array.isArray(_data["ticketAttachments"])) {
                this.ticketAttachments = [] as any;
                for (let item of _data["ticketAttachments"])
                    this.ticketAttachments!.push(TicketAttachmentDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TicketNoteDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TicketNoteDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorResourceID"] = this.creatorResourceID;
        data["resourceName"] = this.resourceName;
        data["title"] = this.title;
        data["description"] = this.description;
        data["noteType"] = this.noteType;
        data["publish"] = this.publish;
        data["lastActivityDate"] = this.lastActivityDate ? this.lastActivityDate.toISOString() : <any>undefined;
        data["ticketID"] = this.ticketID;
        if (Array.isArray(this.ticketAttachmentGuids)) {
            data["ticketAttachmentGuids"] = [];
            for (let item of this.ticketAttachmentGuids)
                data["ticketAttachmentGuids"].push(item);
        }
        if (Array.isArray(this.ticketAttachments)) {
            data["ticketAttachments"] = [];
            for (let item of this.ticketAttachments)
                data["ticketAttachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITicketNoteDTO {
    id?: number;
    creatorResourceID?: number;
    resourceName?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    noteType?: number;
    publish?: number;
    lastActivityDate?: Date;
    ticketID?: number | undefined;
    ticketAttachmentGuids?: string[] | undefined;
    ticketAttachments?: TicketAttachmentDTO[] | undefined;
}

export class TicketNoteMetadataDto implements ITicketNoteMetadataDto {
    id?: number;
    ticketId?: number;
    lastActivityDate?: Date;

    constructor(data?: ITicketNoteMetadataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketId = _data["ticketId"];
            this.lastActivityDate = _data["lastActivityDate"] ? new Date(_data["lastActivityDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TicketNoteMetadataDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketNoteMetadataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketId"] = this.ticketId;
        data["lastActivityDate"] = this.lastActivityDate ? this.lastActivityDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITicketNoteMetadataDto {
    id?: number;
    ticketId?: number;
    lastActivityDate?: Date;
}

export class TimeEntryMetadataDto implements ITimeEntryMetadataDto {
    id?: number;
    ticketId?: number;
    lastActivityDate?: Date;

    constructor(data?: ITimeEntryMetadataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketId = _data["ticketId"];
            this.lastActivityDate = _data["lastActivityDate"] ? new Date(_data["lastActivityDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TimeEntryMetadataDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimeEntryMetadataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketId"] = this.ticketId;
        data["lastActivityDate"] = this.lastActivityDate ? this.lastActivityDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITimeEntryMetadataDto {
    id?: number;
    ticketId?: number;
    lastActivityDate?: Date;
}

export class UserProfileDTO implements IUserProfileDTO {
    id?: number;
    displayName?: string | undefined;
    givenName?: string | undefined;
    surname?: string | undefined;
    phoneNumber?: string | undefined;
    extension?: string | undefined;
    mail?: string | undefined;
    isParentAccountAdmin?: boolean;
    lastRefresh?: Date;
    contact?: Contact;
    approved?: boolean;
    accountId?: number | undefined;
    autotaskAdmin?: boolean;
    emailRequestSent?: boolean;
    emailRequestSentTime?: Date;
    accountName?: string | undefined;
    isGuestUser?: boolean;

    constructor(data?: IUserProfileDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.givenName = _data["givenName"];
            this.surname = _data["surname"];
            this.phoneNumber = _data["phoneNumber"];
            this.extension = _data["extension"];
            this.mail = _data["mail"];
            this.isParentAccountAdmin = _data["isParentAccountAdmin"];
            this.lastRefresh = _data["lastRefresh"] ? new Date(_data["lastRefresh"].toString()) : <any>undefined;
            this.contact = _data["contact"] ? Contact.fromJS(_data["contact"]) : <any>undefined;
            this.approved = _data["approved"];
            this.accountId = _data["accountId"];
            this.autotaskAdmin = _data["autotaskAdmin"];
            this.emailRequestSent = _data["emailRequestSent"];
            this.emailRequestSentTime = _data["emailRequestSentTime"] ? new Date(_data["emailRequestSentTime"].toString()) : <any>undefined;
            this.accountName = _data["accountName"];
            this.isGuestUser = _data["isGuestUser"];
        }
    }

    static fromJS(data: any): UserProfileDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["givenName"] = this.givenName;
        data["surname"] = this.surname;
        data["phoneNumber"] = this.phoneNumber;
        data["extension"] = this.extension;
        data["mail"] = this.mail;
        data["isParentAccountAdmin"] = this.isParentAccountAdmin;
        data["lastRefresh"] = this.lastRefresh ? this.lastRefresh.toISOString() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["approved"] = this.approved;
        data["accountId"] = this.accountId;
        data["autotaskAdmin"] = this.autotaskAdmin;
        data["emailRequestSent"] = this.emailRequestSent;
        data["emailRequestSentTime"] = this.emailRequestSentTime ? this.emailRequestSentTime.toISOString() : <any>undefined;
        data["accountName"] = this.accountName;
        data["isGuestUser"] = this.isGuestUser;
        return data;
    }
}

export interface IUserProfileDTO {
    id?: number;
    displayName?: string | undefined;
    givenName?: string | undefined;
    surname?: string | undefined;
    phoneNumber?: string | undefined;
    extension?: string | undefined;
    mail?: string | undefined;
    isParentAccountAdmin?: boolean;
    lastRefresh?: Date;
    contact?: Contact;
    approved?: boolean;
    accountId?: number | undefined;
    autotaskAdmin?: boolean;
    emailRequestSent?: boolean;
    emailRequestSentTime?: Date;
    accountName?: string | undefined;
    isGuestUser?: boolean;
}

export class DeviceReport implements IDeviceReport {
    accountId?: number;
    deviceTypeStats?: DeviceTypeStats[] | undefined;

    constructor(data?: IDeviceReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            if (Array.isArray(_data["deviceTypeStats"])) {
                this.deviceTypeStats = [] as any;
                for (let item of _data["deviceTypeStats"])
                    this.deviceTypeStats!.push(DeviceTypeStats.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeviceReport {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        if (Array.isArray(this.deviceTypeStats)) {
            data["deviceTypeStats"] = [];
            for (let item of this.deviceTypeStats)
                data["deviceTypeStats"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDeviceReport {
    accountId?: number;
    deviceTypeStats?: DeviceTypeStats[] | undefined;
}

export class DeviceTypeStats implements IDeviceTypeStats {
    deviceCount?: number;
    deviceMissingPatches?: number;
    name?: string | undefined;

    constructor(data?: IDeviceTypeStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceCount = _data["deviceCount"];
            this.deviceMissingPatches = _data["deviceMissingPatches"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): DeviceTypeStats {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceTypeStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceCount"] = this.deviceCount;
        data["deviceMissingPatches"] = this.deviceMissingPatches;
        data["name"] = this.name;
        return data;
    }
}

export interface IDeviceTypeStats {
    deviceCount?: number;
    deviceMissingPatches?: number;
    name?: string | undefined;
}

export class ProjectReport implements IProjectReport {
    accountId?: number;
    projectTypeStats?: ProjectTypeStats[] | undefined;

    constructor(data?: IProjectReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            if (Array.isArray(_data["projectTypeStats"])) {
                this.projectTypeStats = [] as any;
                for (let item of _data["projectTypeStats"])
                    this.projectTypeStats!.push(ProjectTypeStats.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectReport {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        if (Array.isArray(this.projectTypeStats)) {
            data["projectTypeStats"] = [];
            for (let item of this.projectTypeStats)
                data["projectTypeStats"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProjectReport {
    accountId?: number;
    projectTypeStats?: ProjectTypeStats[] | undefined;
}

export class ProjectTypeStats implements IProjectTypeStats {
    counted?: number;
    status?: number;

    constructor(data?: IProjectTypeStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.counted = _data["counted"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ProjectTypeStats {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTypeStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["counted"] = this.counted;
        data["status"] = this.status;
        return data;
    }
}

export interface IProjectTypeStats {
    counted?: number;
    status?: number;
}

export class SimpleCloudContract implements ISimpleCloudContract {
    id?: number;
    accountId?: number;
    contractCategory?: number;
    contractName?: string | undefined;

    constructor(data?: ISimpleCloudContract) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.contractCategory = _data["contractCategory"];
            this.contractName = _data["contractName"];
        }
    }

    static fromJS(data: any): SimpleCloudContract {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleCloudContract();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["contractCategory"] = this.contractCategory;
        data["contractName"] = this.contractName;
        return data;
    }
}

export interface ISimpleCloudContract {
    id?: number;
    accountId?: number;
    contractCategory?: number;
    contractName?: string | undefined;
}

export class DatadogUsageReportIntegrationMetadata extends IntegrationMetadata implements IDatadogUsageReportIntegrationMetadata {
    axAccount?: string | undefined;

    constructor(data?: IDatadogUsageReportIntegrationMetadata) {
        super(data);
        this._discriminator = "DatadogUsageReportIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.axAccount = _data["axAccount"];
        }
    }

    static override fromJS(data: any): DatadogUsageReportIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new DatadogUsageReportIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccount"] = this.axAccount;
        super.toJSON(data);
        return data;
    }
}

export interface IDatadogUsageReportIntegrationMetadata extends IIntegrationMetadata {
    axAccount?: string | undefined;
}

export class Antivirus implements IAntivirus {
    antivirusProduct?: string | undefined;
    antivirusStatus?: string | undefined;

    constructor(data?: IAntivirus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.antivirusProduct = _data["antivirusProduct"];
            this.antivirusStatus = _data["antivirusStatus"];
        }
    }

    static fromJS(data: any): Antivirus {
        data = typeof data === 'object' ? data : {};
        let result = new Antivirus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["antivirusProduct"] = this.antivirusProduct;
        data["antivirusStatus"] = this.antivirusStatus;
        return data;
    }
}

export interface IAntivirus {
    antivirusProduct?: string | undefined;
    antivirusStatus?: string | undefined;
}

export class DattoRMMIntegrationMetadata extends IntegrationMetadata implements IDattoRMMIntegrationMetadata {
    dattoSite?: DattoSite;

    constructor(data?: IDattoRMMIntegrationMetadata) {
        super(data);
        this._discriminator = "DattoRMMIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dattoSite = _data["dattoSite"] ? DattoSite.fromJS(_data["dattoSite"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): DattoRMMIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new DattoRMMIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dattoSite"] = this.dattoSite ? this.dattoSite.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IDattoRMMIntegrationMetadata extends IIntegrationMetadata {
    dattoSite?: DattoSite;
}

export class DattoRmmDevice implements IDattoRmmDevice {
    id?: number;
    uid?: string | undefined;
    siteId?: number;
    siteUid?: string | undefined;
    siteName?: string | undefined;
    deviceType?: DeviceType;
    hostname?: string | undefined;
    intIpAddress?: string | undefined;
    operatingSystem?: string | undefined;
    lastLoggedInUser?: string | undefined;
    domain?: string | undefined;
    cagVersion?: string | undefined;
    displayVersion?: string | undefined;
    extIpAddress?: string | undefined;
    description?: string | undefined;
    a64Bit?: boolean | undefined;
    rebootRequired?: boolean | undefined;
    online?: boolean | undefined;
    suspended?: boolean | undefined;
    deleted?: boolean | undefined;
    lastSeen?: number | undefined;
    lastReboot?: number | undefined;
    lastAuditDate?: number | undefined;
    creationDate?: number | undefined;
    udf?: Udf;
    snmpEnabled?: boolean | undefined;
    deviceClass?: string | undefined;
    portalUrl?: string | undefined;
    warrantyDate?: any | undefined;
    antivirus?: Antivirus;
    patchManagement?: PatchManagement;
    softwareStatus?: string | undefined;

    constructor(data?: IDattoRmmDevice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.uid = _data["uid"];
            this.siteId = _data["siteId"];
            this.siteUid = _data["siteUid"];
            this.siteName = _data["siteName"];
            this.deviceType = _data["deviceType"] ? DeviceType.fromJS(_data["deviceType"]) : <any>undefined;
            this.hostname = _data["hostname"];
            this.intIpAddress = _data["intIpAddress"];
            this.operatingSystem = _data["operatingSystem"];
            this.lastLoggedInUser = _data["lastLoggedInUser"];
            this.domain = _data["domain"];
            this.cagVersion = _data["cagVersion"];
            this.displayVersion = _data["displayVersion"];
            this.extIpAddress = _data["extIpAddress"];
            this.description = _data["description"];
            this.a64Bit = _data["a64Bit"];
            this.rebootRequired = _data["rebootRequired"];
            this.online = _data["online"];
            this.suspended = _data["suspended"];
            this.deleted = _data["deleted"];
            this.lastSeen = _data["lastSeen"];
            this.lastReboot = _data["lastReboot"];
            this.lastAuditDate = _data["lastAuditDate"];
            this.creationDate = _data["creationDate"];
            this.udf = _data["udf"] ? Udf.fromJS(_data["udf"]) : <any>undefined;
            this.snmpEnabled = _data["snmpEnabled"];
            this.deviceClass = _data["deviceClass"];
            this.portalUrl = _data["portalUrl"];
            this.warrantyDate = _data["warrantyDate"];
            this.antivirus = _data["antivirus"] ? Antivirus.fromJS(_data["antivirus"]) : <any>undefined;
            this.patchManagement = _data["patchManagement"] ? PatchManagement.fromJS(_data["patchManagement"]) : <any>undefined;
            this.softwareStatus = _data["softwareStatus"];
        }
    }

    static fromJS(data: any): DattoRmmDevice {
        data = typeof data === 'object' ? data : {};
        let result = new DattoRmmDevice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["uid"] = this.uid;
        data["siteId"] = this.siteId;
        data["siteUid"] = this.siteUid;
        data["siteName"] = this.siteName;
        data["deviceType"] = this.deviceType ? this.deviceType.toJSON() : <any>undefined;
        data["hostname"] = this.hostname;
        data["intIpAddress"] = this.intIpAddress;
        data["operatingSystem"] = this.operatingSystem;
        data["lastLoggedInUser"] = this.lastLoggedInUser;
        data["domain"] = this.domain;
        data["cagVersion"] = this.cagVersion;
        data["displayVersion"] = this.displayVersion;
        data["extIpAddress"] = this.extIpAddress;
        data["description"] = this.description;
        data["a64Bit"] = this.a64Bit;
        data["rebootRequired"] = this.rebootRequired;
        data["online"] = this.online;
        data["suspended"] = this.suspended;
        data["deleted"] = this.deleted;
        data["lastSeen"] = this.lastSeen;
        data["lastReboot"] = this.lastReboot;
        data["lastAuditDate"] = this.lastAuditDate;
        data["creationDate"] = this.creationDate;
        data["udf"] = this.udf ? this.udf.toJSON() : <any>undefined;
        data["snmpEnabled"] = this.snmpEnabled;
        data["deviceClass"] = this.deviceClass;
        data["portalUrl"] = this.portalUrl;
        data["warrantyDate"] = this.warrantyDate;
        data["antivirus"] = this.antivirus ? this.antivirus.toJSON() : <any>undefined;
        data["patchManagement"] = this.patchManagement ? this.patchManagement.toJSON() : <any>undefined;
        data["softwareStatus"] = this.softwareStatus;
        return data;
    }
}

export interface IDattoRmmDevice {
    id?: number;
    uid?: string | undefined;
    siteId?: number;
    siteUid?: string | undefined;
    siteName?: string | undefined;
    deviceType?: DeviceType;
    hostname?: string | undefined;
    intIpAddress?: string | undefined;
    operatingSystem?: string | undefined;
    lastLoggedInUser?: string | undefined;
    domain?: string | undefined;
    cagVersion?: string | undefined;
    displayVersion?: string | undefined;
    extIpAddress?: string | undefined;
    description?: string | undefined;
    a64Bit?: boolean | undefined;
    rebootRequired?: boolean | undefined;
    online?: boolean | undefined;
    suspended?: boolean | undefined;
    deleted?: boolean | undefined;
    lastSeen?: number | undefined;
    lastReboot?: number | undefined;
    lastAuditDate?: number | undefined;
    creationDate?: number | undefined;
    udf?: Udf;
    snmpEnabled?: boolean | undefined;
    deviceClass?: string | undefined;
    portalUrl?: string | undefined;
    warrantyDate?: any | undefined;
    antivirus?: Antivirus;
    patchManagement?: PatchManagement;
    softwareStatus?: string | undefined;
}

export class DattoRmmDevicesRequest implements IDattoRmmDevicesRequest {
    siteUid?: string | undefined;
    skip?: number;
    take?: number;

    constructor(data?: IDattoRmmDevicesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.siteUid = _data["siteUid"];
            this.skip = _data["skip"];
            this.take = _data["take"];
        }
    }

    static fromJS(data: any): DattoRmmDevicesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DattoRmmDevicesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteUid"] = this.siteUid;
        data["skip"] = this.skip;
        data["take"] = this.take;
        return data;
    }
}

export interface IDattoRmmDevicesRequest {
    siteUid?: string | undefined;
    skip?: number;
    take?: number;
}

export class DeviceType implements IDeviceType {
    category?: string | undefined;
    type?: string | undefined;

    constructor(data?: IDeviceType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): DeviceType {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["type"] = this.type;
        return data;
    }
}

export interface IDeviceType {
    category?: string | undefined;
    type?: string | undefined;
}

export class PatchManagement implements IPatchManagement {
    patchStatus?: string | undefined;
    patchesApprovedPending?: number | undefined;
    patchesNotApproved?: number | undefined;
    patchesInstalled?: number | undefined;

    constructor(data?: IPatchManagement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patchStatus = _data["patchStatus"];
            this.patchesApprovedPending = _data["patchesApprovedPending"];
            this.patchesNotApproved = _data["patchesNotApproved"];
            this.patchesInstalled = _data["patchesInstalled"];
        }
    }

    static fromJS(data: any): PatchManagement {
        data = typeof data === 'object' ? data : {};
        let result = new PatchManagement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patchStatus"] = this.patchStatus;
        data["patchesApprovedPending"] = this.patchesApprovedPending;
        data["patchesNotApproved"] = this.patchesNotApproved;
        data["patchesInstalled"] = this.patchesInstalled;
        return data;
    }
}

export interface IPatchManagement {
    patchStatus?: string | undefined;
    patchesApprovedPending?: number | undefined;
    patchesNotApproved?: number | undefined;
    patchesInstalled?: number | undefined;
}

export class Udf implements IUdf {
    udf1?: any | undefined;
    udf2?: any | undefined;
    udf3?: any | undefined;
    udf4?: any | undefined;
    udf5?: any | undefined;
    udf6?: any | undefined;
    udf7?: any | undefined;
    udf8?: any | undefined;
    udf9?: any | undefined;
    udf10?: string | undefined;
    udf11?: string | undefined;
    udf12?: any | undefined;
    udf13?: any | undefined;
    udf14?: any | undefined;
    udf15?: any | undefined;
    udf16?: any | undefined;
    udf17?: any | undefined;
    udf18?: any | undefined;
    udf19?: any | undefined;
    udf20?: any | undefined;
    udf21?: any | undefined;
    udf22?: string | undefined;
    udf23?: any | undefined;
    udf24?: any | undefined;
    udf25?: any | undefined;
    udf26?: any | undefined;
    udf27?: string | undefined;
    udf28?: string | undefined;
    udf29?: any | undefined;
    udf30?: any | undefined;

    constructor(data?: IUdf) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.udf1 = _data["udf1"];
            this.udf2 = _data["udf2"];
            this.udf3 = _data["udf3"];
            this.udf4 = _data["udf4"];
            this.udf5 = _data["udf5"];
            this.udf6 = _data["udf6"];
            this.udf7 = _data["udf7"];
            this.udf8 = _data["udf8"];
            this.udf9 = _data["udf9"];
            this.udf10 = _data["udf10"];
            this.udf11 = _data["udf11"];
            this.udf12 = _data["udf12"];
            this.udf13 = _data["udf13"];
            this.udf14 = _data["udf14"];
            this.udf15 = _data["udf15"];
            this.udf16 = _data["udf16"];
            this.udf17 = _data["udf17"];
            this.udf18 = _data["udf18"];
            this.udf19 = _data["udf19"];
            this.udf20 = _data["udf20"];
            this.udf21 = _data["udf21"];
            this.udf22 = _data["udf22"];
            this.udf23 = _data["udf23"];
            this.udf24 = _data["udf24"];
            this.udf25 = _data["udf25"];
            this.udf26 = _data["udf26"];
            this.udf27 = _data["udf27"];
            this.udf28 = _data["udf28"];
            this.udf29 = _data["udf29"];
            this.udf30 = _data["udf30"];
        }
    }

    static fromJS(data: any): Udf {
        data = typeof data === 'object' ? data : {};
        let result = new Udf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["udf1"] = this.udf1;
        data["udf2"] = this.udf2;
        data["udf3"] = this.udf3;
        data["udf4"] = this.udf4;
        data["udf5"] = this.udf5;
        data["udf6"] = this.udf6;
        data["udf7"] = this.udf7;
        data["udf8"] = this.udf8;
        data["udf9"] = this.udf9;
        data["udf10"] = this.udf10;
        data["udf11"] = this.udf11;
        data["udf12"] = this.udf12;
        data["udf13"] = this.udf13;
        data["udf14"] = this.udf14;
        data["udf15"] = this.udf15;
        data["udf16"] = this.udf16;
        data["udf17"] = this.udf17;
        data["udf18"] = this.udf18;
        data["udf19"] = this.udf19;
        data["udf20"] = this.udf20;
        data["udf21"] = this.udf21;
        data["udf22"] = this.udf22;
        data["udf23"] = this.udf23;
        data["udf24"] = this.udf24;
        data["udf25"] = this.udf25;
        data["udf26"] = this.udf26;
        data["udf27"] = this.udf27;
        data["udf28"] = this.udf28;
        data["udf29"] = this.udf29;
        data["udf30"] = this.udf30;
        return data;
    }
}

export interface IUdf {
    udf1?: any | undefined;
    udf2?: any | undefined;
    udf3?: any | undefined;
    udf4?: any | undefined;
    udf5?: any | undefined;
    udf6?: any | undefined;
    udf7?: any | undefined;
    udf8?: any | undefined;
    udf9?: any | undefined;
    udf10?: string | undefined;
    udf11?: string | undefined;
    udf12?: any | undefined;
    udf13?: any | undefined;
    udf14?: any | undefined;
    udf15?: any | undefined;
    udf16?: any | undefined;
    udf17?: any | undefined;
    udf18?: any | undefined;
    udf19?: any | undefined;
    udf20?: any | undefined;
    udf21?: any | undefined;
    udf22?: string | undefined;
    udf23?: any | undefined;
    udf24?: any | undefined;
    udf25?: any | undefined;
    udf26?: any | undefined;
    udf27?: string | undefined;
    udf28?: string | undefined;
    udf29?: any | undefined;
    udf30?: any | undefined;
}

export class DynamicTagRequest implements IDynamicTagRequest {
    accountId?: number;
    axReferences?: string[] | undefined;
    contactId?: number;
    sourceIdentifier?: string | undefined;
    tagType?: string | undefined;
    dynamicTags?: DynamicTag[] | undefined;

    constructor(data?: IDynamicTagRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            if (Array.isArray(_data["axReferences"])) {
                this.axReferences = [] as any;
                for (let item of _data["axReferences"])
                    this.axReferences!.push(item);
            }
            this.contactId = _data["contactId"];
            this.sourceIdentifier = _data["sourceIdentifier"];
            this.tagType = _data["tagType"];
            if (Array.isArray(_data["dynamicTags"])) {
                this.dynamicTags = [] as any;
                for (let item of _data["dynamicTags"])
                    this.dynamicTags!.push(DynamicTag.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DynamicTagRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicTagRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        if (Array.isArray(this.axReferences)) {
            data["axReferences"] = [];
            for (let item of this.axReferences)
                data["axReferences"].push(item);
        }
        data["contactId"] = this.contactId;
        data["sourceIdentifier"] = this.sourceIdentifier;
        data["tagType"] = this.tagType;
        if (Array.isArray(this.dynamicTags)) {
            data["dynamicTags"] = [];
            for (let item of this.dynamicTags)
                data["dynamicTags"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDynamicTagRequest {
    accountId?: number;
    axReferences?: string[] | undefined;
    contactId?: number;
    sourceIdentifier?: string | undefined;
    tagType?: string | undefined;
    dynamicTags?: DynamicTag[] | undefined;
}

export class FileDownloadResponse implements IFileDownloadResponse {
    file?: string | undefined;
    errorMessage?: string | undefined;

    constructor(data?: IFileDownloadResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.file = _data["file"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): FileDownloadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FileDownloadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["file"] = this.file;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IFileDownloadResponse {
    file?: string | undefined;
    errorMessage?: string | undefined;
}

export class FileUploadResponse_1OfCiscoSupplementalDataDto implements IFileUploadResponse_1OfCiscoSupplementalDataDto {
    warnings?: FileHandlerUploadRecord_1OfCiscoSupplementalDataDto[] | undefined;
    integrationRecord?: IntegrationDTO | undefined;

    constructor(data?: IFileUploadResponse_1OfCiscoSupplementalDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(FileHandlerUploadRecord_1OfCiscoSupplementalDataDto.fromJS(item));
            }
            this.integrationRecord = _data["integrationRecord"] ? IntegrationDTO.fromJS(_data["integrationRecord"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FileUploadResponse_1OfCiscoSupplementalDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploadResponse_1OfCiscoSupplementalDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item.toJSON());
        }
        data["integrationRecord"] = this.integrationRecord ? this.integrationRecord.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFileUploadResponse_1OfCiscoSupplementalDataDto {
    warnings?: FileHandlerUploadRecord_1OfCiscoSupplementalDataDto[] | undefined;
    integrationRecord?: IntegrationDTO | undefined;
}

export class FileUploadResponse_1OfCiscoThirdPartyContractDataDto implements IFileUploadResponse_1OfCiscoThirdPartyContractDataDto {
    warnings?: FileHandlerUploadRecord_1OfCiscoThirdPartyContractDataDto[] | undefined;
    integrationRecord?: IntegrationDTO | undefined;

    constructor(data?: IFileUploadResponse_1OfCiscoThirdPartyContractDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(FileHandlerUploadRecord_1OfCiscoThirdPartyContractDataDto.fromJS(item));
            }
            this.integrationRecord = _data["integrationRecord"] ? IntegrationDTO.fromJS(_data["integrationRecord"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FileUploadResponse_1OfCiscoThirdPartyContractDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploadResponse_1OfCiscoThirdPartyContractDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item.toJSON());
        }
        data["integrationRecord"] = this.integrationRecord ? this.integrationRecord.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFileUploadResponse_1OfCiscoThirdPartyContractDataDto {
    warnings?: FileHandlerUploadRecord_1OfCiscoThirdPartyContractDataDto[] | undefined;
    integrationRecord?: IntegrationDTO | undefined;
}

export class FileUploadResponse_1OfManualManagedAssetDataRecordDto implements IFileUploadResponse_1OfManualManagedAssetDataRecordDto {
    warnings?: FileHandlerUploadRecord_1OfManualManagedAssetDataRecordDto[] | undefined;
    integrationRecord?: IntegrationDTO | undefined;

    constructor(data?: IFileUploadResponse_1OfManualManagedAssetDataRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(FileHandlerUploadRecord_1OfManualManagedAssetDataRecordDto.fromJS(item));
            }
            this.integrationRecord = _data["integrationRecord"] ? IntegrationDTO.fromJS(_data["integrationRecord"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FileUploadResponse_1OfManualManagedAssetDataRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploadResponse_1OfManualManagedAssetDataRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item.toJSON());
        }
        data["integrationRecord"] = this.integrationRecord ? this.integrationRecord.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFileUploadResponse_1OfManualManagedAssetDataRecordDto {
    warnings?: FileHandlerUploadRecord_1OfManualManagedAssetDataRecordDto[] | undefined;
    integrationRecord?: IntegrationDTO | undefined;
}

export class GcpCloudAssetInventoryMetadata extends IntegrationMetadata implements IGcpCloudAssetInventoryMetadata {
    authorizationScope?: string | undefined;
    serviceAccountKey?: string | undefined;

    constructor(data?: IGcpCloudAssetInventoryMetadata) {
        super(data);
        this._discriminator = "GcpCloudAssetInventoryMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.authorizationScope = _data["authorizationScope"];
            this.serviceAccountKey = _data["serviceAccountKey"];
        }
    }

    static override fromJS(data: any): GcpCloudAssetInventoryMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new GcpCloudAssetInventoryMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authorizationScope"] = this.authorizationScope;
        data["serviceAccountKey"] = this.serviceAccountKey;
        super.toJSON(data);
        return data;
    }
}

export interface IGcpCloudAssetInventoryMetadata extends IIntegrationMetadata {
    authorizationScope?: string | undefined;
    serviceAccountKey?: string | undefined;
}

export class GcpUsageReportIntegrationDTO extends IntegrationDTO implements IGcpUsageReportIntegrationDTO {
    integrationType?: IntegrationType;
    metadata?: GcpUsageReportIntegrationMetadata;

    constructor(data?: IGcpUsageReportIntegrationDTO) {
        super(data);
        this._discriminator = "GcpUsageReportIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            this.metadata = _data["metadata"] ? GcpUsageReportIntegrationMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): GcpUsageReportIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GcpUsageReportIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IGcpUsageReportIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    metadata?: GcpUsageReportIntegrationMetadata;
}

export class GcpUsageReportIntegrationMetadata extends IntegrationMetadata implements IGcpUsageReportIntegrationMetadata {
    axAccount?: string | undefined;

    constructor(data?: IGcpUsageReportIntegrationMetadata) {
        super(data);
        this._discriminator = "GcpUsageReportIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.axAccount = _data["axAccount"];
        }
    }

    static override fromJS(data: any): GcpUsageReportIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new GcpUsageReportIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccount"] = this.axAccount;
        super.toJSON(data);
        return data;
    }
}

export interface IGcpUsageReportIntegrationMetadata extends IIntegrationMetadata {
    axAccount?: string | undefined;
}

export class HardwareLifecycleIntegrationMetadata extends IntegrationMetadata implements IHardwareLifecycleIntegrationMetadata {
    deviceMakeModel?: string | undefined;

    constructor(data?: IHardwareLifecycleIntegrationMetadata) {
        super(data);
        this._discriminator = "HardwareLifecycleIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.deviceMakeModel = _data["deviceMakeModel"];
        }
    }

    static override fromJS(data: any): HardwareLifecycleIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new HardwareLifecycleIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceMakeModel"] = this.deviceMakeModel;
        super.toJSON(data);
        return data;
    }
}

export interface IHardwareLifecycleIntegrationMetadata extends IIntegrationMetadata {
    deviceMakeModel?: string | undefined;
}

export class IbaIntegrationMetadata extends IntegrationMetadata implements IIbaIntegrationMetadata {
    integrations?: MappingEngineMetadata[] | undefined;

    constructor(data?: IIbaIntegrationMetadata) {
        super(data);
        this._discriminator = "IbaIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["integrations"])) {
                this.integrations = [] as any;
                for (let item of _data["integrations"])
                    this.integrations!.push(MappingEngineMetadata.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): IbaIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new IbaIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.integrations)) {
            data["integrations"] = [];
            for (let item of this.integrations)
                data["integrations"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IIbaIntegrationMetadata extends IIntegrationMetadata {
    integrations?: MappingEngineMetadata[] | undefined;
}

export class IdcsReportIntegrationMetadata extends IntegrationMetadata implements IIdcsReportIntegrationMetadata {
    axAccount?: string | undefined;

    constructor(data?: IIdcsReportIntegrationMetadata) {
        super(data);
        this._discriminator = "IdcsReportIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.axAccount = _data["axAccount"];
        }
    }

    static override fromJS(data: any): IdcsReportIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new IdcsReportIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccount"] = this.axAccount;
        super.toJSON(data);
        return data;
    }
}

export interface IIdcsReportIntegrationMetadata extends IIntegrationMetadata {
    axAccount?: string | undefined;
}

export class IntegrationDefinition implements IIntegrationDefinition {
    id?: number;
    integrationTitle?: string | undefined;
    enabled?: boolean;
    selfRegister?: boolean;
    statusVisibleToCustomer?: boolean;
    configurationVisibleToCustomer?: boolean;
    configurationVisibleToShi?: boolean;
    thumbnailImageUrl?: string | undefined;
    contentMarkdownUrl?: string | undefined;
    requiresEulaAgreement?: boolean;
    eulaAgreementUrl?: string | undefined;
    integrationDescriptionMarkdown?: string | undefined;
    activationDescription?: string | undefined;
    multipleIntegrationsAllowed?: boolean;
    integrationType?: IntegrationType;
    integrationGroup?: IntegrationGroup;
    canSelfConnect?: boolean;

    constructor(data?: IIntegrationDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.integrationTitle = _data["integrationTitle"];
            this.enabled = _data["enabled"];
            this.selfRegister = _data["selfRegister"];
            this.statusVisibleToCustomer = _data["statusVisibleToCustomer"];
            this.configurationVisibleToCustomer = _data["configurationVisibleToCustomer"];
            this.configurationVisibleToShi = _data["configurationVisibleToShi"];
            this.thumbnailImageUrl = _data["thumbnailImageUrl"];
            this.contentMarkdownUrl = _data["contentMarkdownUrl"];
            this.requiresEulaAgreement = _data["requiresEulaAgreement"];
            this.eulaAgreementUrl = _data["eulaAgreementUrl"];
            this.integrationDescriptionMarkdown = _data["integrationDescriptionMarkdown"];
            this.activationDescription = _data["activationDescription"];
            this.multipleIntegrationsAllowed = _data["multipleIntegrationsAllowed"];
            this.integrationType = _data["integrationType"];
            this.integrationGroup = _data["integrationGroup"];
            this.canSelfConnect = _data["canSelfConnect"];
        }
    }

    static fromJS(data: any): IntegrationDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["integrationTitle"] = this.integrationTitle;
        data["enabled"] = this.enabled;
        data["selfRegister"] = this.selfRegister;
        data["statusVisibleToCustomer"] = this.statusVisibleToCustomer;
        data["configurationVisibleToCustomer"] = this.configurationVisibleToCustomer;
        data["configurationVisibleToShi"] = this.configurationVisibleToShi;
        data["thumbnailImageUrl"] = this.thumbnailImageUrl;
        data["contentMarkdownUrl"] = this.contentMarkdownUrl;
        data["requiresEulaAgreement"] = this.requiresEulaAgreement;
        data["eulaAgreementUrl"] = this.eulaAgreementUrl;
        data["integrationDescriptionMarkdown"] = this.integrationDescriptionMarkdown;
        data["activationDescription"] = this.activationDescription;
        data["multipleIntegrationsAllowed"] = this.multipleIntegrationsAllowed;
        data["integrationType"] = this.integrationType;
        data["integrationGroup"] = this.integrationGroup;
        data["canSelfConnect"] = this.canSelfConnect;
        return data;
    }
}

export interface IIntegrationDefinition {
    id?: number;
    integrationTitle?: string | undefined;
    enabled?: boolean;
    selfRegister?: boolean;
    statusVisibleToCustomer?: boolean;
    configurationVisibleToCustomer?: boolean;
    configurationVisibleToShi?: boolean;
    thumbnailImageUrl?: string | undefined;
    contentMarkdownUrl?: string | undefined;
    requiresEulaAgreement?: boolean;
    eulaAgreementUrl?: string | undefined;
    integrationDescriptionMarkdown?: string | undefined;
    activationDescription?: string | undefined;
    multipleIntegrationsAllowed?: boolean;
    integrationType?: IntegrationType;
    integrationGroup?: IntegrationGroup;
    canSelfConnect?: boolean;
}

export class AzureAssetIntegrationDTO extends IntegrationDTO implements IAzureAssetIntegrationDTO {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: AzureAssetIntegrationMetadata;

    constructor(data?: IAzureAssetIntegrationDTO) {
        super(data);
        this._discriminator = "AzureAssetIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (<any>this).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? AzureAssetIntegrationMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): AzureAssetIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AzureAssetIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAzureAssetIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: AzureAssetIntegrationMetadata;
}

export class AzureCostAndUsageIntegrationDTO extends IntegrationDTO implements IAzureCostAndUsageIntegrationDTO {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: AzureCostAndUsageIntegrationMetadata;

    constructor(data?: IAzureCostAndUsageIntegrationDTO) {
        super(data);
        this._discriminator = "AzureCostAndUsageIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (<any>this).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? AzureCostAndUsageIntegrationMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): AzureCostAndUsageIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AzureCostAndUsageIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAzureCostAndUsageIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: AzureCostAndUsageIntegrationMetadata;
}

export class Microsoft365ReportsIntegrationDTO extends IntegrationDTO implements IMicrosoft365ReportsIntegrationDTO {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: Microsoft365ReportsIntegrationMetadata;

    constructor(data?: IMicrosoft365ReportsIntegrationDTO) {
        super(data);
        this._discriminator = "Microsoft365ReportsIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (<any>this).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? Microsoft365ReportsIntegrationMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): Microsoft365ReportsIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new Microsoft365ReportsIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IMicrosoft365ReportsIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: Microsoft365ReportsIntegrationMetadata;
}

export class AzureAssetIntegrationMetadata extends IntegrationMetadata implements IAzureAssetIntegrationMetadata {
    shiRegistrationGuid?: string;
    domainName?: string | undefined;
    tenantId?: string | undefined;
    applicationRegistrationId?: string | undefined;
    servicePrincipalRegistrationStatus?: RegistrationStatus;
    registrationLink?: string | undefined;
    linkCreationDate?: Date | undefined;
    linkCreationUser?: string | undefined;
    directoryAccessRegistrationStatus?: RegistrationStatus;
    isCallbackReceived?: boolean | undefined;
    callbackReceivedDate?: Date | undefined;
    callbackPermittedScope?: string | undefined;
    callbackState?: string | undefined;

    constructor(data?: IAzureAssetIntegrationMetadata) {
        super(data);
        this._discriminator = "AzureAssetIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.shiRegistrationGuid = _data["shiRegistrationGuid"];
            this.domainName = _data["domainName"];
            this.tenantId = _data["tenantId"];
            this.applicationRegistrationId = _data["applicationRegistrationId"];
            this.servicePrincipalRegistrationStatus = _data["servicePrincipalRegistrationStatus"];
            this.registrationLink = _data["registrationLink"];
            this.linkCreationDate = _data["linkCreationDate"] ? new Date(_data["linkCreationDate"].toString()) : <any>undefined;
            this.linkCreationUser = _data["linkCreationUser"];
            this.directoryAccessRegistrationStatus = _data["directoryAccessRegistrationStatus"];
            this.isCallbackReceived = _data["isCallbackReceived"];
            this.callbackReceivedDate = _data["callbackReceivedDate"] ? new Date(_data["callbackReceivedDate"].toString()) : <any>undefined;
            this.callbackPermittedScope = _data["callbackPermittedScope"];
            this.callbackState = _data["callbackState"];
        }
    }

    static override fromJS(data: any): AzureAssetIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new AzureAssetIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiRegistrationGuid"] = this.shiRegistrationGuid;
        data["domainName"] = this.domainName;
        data["tenantId"] = this.tenantId;
        data["applicationRegistrationId"] = this.applicationRegistrationId;
        data["servicePrincipalRegistrationStatus"] = this.servicePrincipalRegistrationStatus;
        data["registrationLink"] = this.registrationLink;
        data["linkCreationDate"] = this.linkCreationDate ? this.linkCreationDate.toISOString() : <any>undefined;
        data["linkCreationUser"] = this.linkCreationUser;
        data["directoryAccessRegistrationStatus"] = this.directoryAccessRegistrationStatus;
        data["isCallbackReceived"] = this.isCallbackReceived;
        data["callbackReceivedDate"] = this.callbackReceivedDate ? this.callbackReceivedDate.toISOString() : <any>undefined;
        data["callbackPermittedScope"] = this.callbackPermittedScope;
        data["callbackState"] = this.callbackState;
        super.toJSON(data);
        return data;
    }
}

export interface IAzureAssetIntegrationMetadata extends IIntegrationMetadata {
    shiRegistrationGuid?: string;
    domainName?: string | undefined;
    tenantId?: string | undefined;
    applicationRegistrationId?: string | undefined;
    servicePrincipalRegistrationStatus?: RegistrationStatus;
    registrationLink?: string | undefined;
    linkCreationDate?: Date | undefined;
    linkCreationUser?: string | undefined;
    directoryAccessRegistrationStatus?: RegistrationStatus;
    isCallbackReceived?: boolean | undefined;
    callbackReceivedDate?: Date | undefined;
    callbackPermittedScope?: string | undefined;
    callbackState?: string | undefined;
}

export class AzureCostAndUsageIntegrationMetadata extends IntegrationMetadata implements IAzureCostAndUsageIntegrationMetadata {
    shiRegistrationGuid?: string;
    domainName?: string | undefined;
    tenantId?: string | undefined;
    applicationRegistrationId?: string | undefined;
    storageAccountContributorStatus?: RegistrationStatus;
    azureStorageAccountSubscription?: string | undefined;
    azureResourceGroup?: string | undefined;
    azureStorageAccount?: string | undefined;
    hasAccessToStorageAccount?: boolean;

    constructor(data?: IAzureCostAndUsageIntegrationMetadata) {
        super(data);
        this._discriminator = "AzureCostAndUsageIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.shiRegistrationGuid = _data["shiRegistrationGuid"];
            this.domainName = _data["domainName"];
            this.tenantId = _data["tenantId"];
            this.applicationRegistrationId = _data["applicationRegistrationId"];
            this.storageAccountContributorStatus = _data["storageAccountContributorStatus"];
            this.azureStorageAccountSubscription = _data["azureStorageAccountSubscription"];
            this.azureResourceGroup = _data["azureResourceGroup"];
            this.azureStorageAccount = _data["azureStorageAccount"];
            this.hasAccessToStorageAccount = _data["hasAccessToStorageAccount"];
        }
    }

    static override fromJS(data: any): AzureCostAndUsageIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new AzureCostAndUsageIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiRegistrationGuid"] = this.shiRegistrationGuid;
        data["domainName"] = this.domainName;
        data["tenantId"] = this.tenantId;
        data["applicationRegistrationId"] = this.applicationRegistrationId;
        data["storageAccountContributorStatus"] = this.storageAccountContributorStatus;
        data["azureStorageAccountSubscription"] = this.azureStorageAccountSubscription;
        data["azureResourceGroup"] = this.azureResourceGroup;
        data["azureStorageAccount"] = this.azureStorageAccount;
        data["hasAccessToStorageAccount"] = this.hasAccessToStorageAccount;
        super.toJSON(data);
        return data;
    }
}

export interface IAzureCostAndUsageIntegrationMetadata extends IIntegrationMetadata {
    shiRegistrationGuid?: string;
    domainName?: string | undefined;
    tenantId?: string | undefined;
    applicationRegistrationId?: string | undefined;
    storageAccountContributorStatus?: RegistrationStatus;
    azureStorageAccountSubscription?: string | undefined;
    azureResourceGroup?: string | undefined;
    azureStorageAccount?: string | undefined;
    hasAccessToStorageAccount?: boolean;
}

export enum RegistrationStatus {
    Pending = "Pending",
    Completed = "Completed",
    Failed = "Failed",
}

export class Microsoft365ReportsIntegrationMetadata extends IntegrationMetadata implements IMicrosoft365ReportsIntegrationMetadata {
    shiRegistrationGuid?: string;
    domainName?: string | undefined;
    tenantId?: string | undefined;
    applicationRegistrationId?: string | undefined;
    registrationLink?: string | undefined;
    linkCreationDate?: Date | undefined;
    linkCreationUser?: string | undefined;
    registrationStatus?: RegistrationStatus;
    isCallbackReceived?: boolean | undefined;
    callbackReceivedDate?: Date | undefined;
    callbackPermittedScope?: string | undefined;
    callbackState?: string | undefined;

    constructor(data?: IMicrosoft365ReportsIntegrationMetadata) {
        super(data);
        this._discriminator = "Microsoft365ReportsIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.shiRegistrationGuid = _data["shiRegistrationGuid"];
            this.domainName = _data["domainName"];
            this.tenantId = _data["tenantId"];
            this.applicationRegistrationId = _data["applicationRegistrationId"];
            this.registrationLink = _data["registrationLink"];
            this.linkCreationDate = _data["linkCreationDate"] ? new Date(_data["linkCreationDate"].toString()) : <any>undefined;
            this.linkCreationUser = _data["linkCreationUser"];
            this.registrationStatus = _data["registrationStatus"];
            this.isCallbackReceived = _data["isCallbackReceived"];
            this.callbackReceivedDate = _data["callbackReceivedDate"] ? new Date(_data["callbackReceivedDate"].toString()) : <any>undefined;
            this.callbackPermittedScope = _data["callbackPermittedScope"];
            this.callbackState = _data["callbackState"];
        }
    }

    static override fromJS(data: any): Microsoft365ReportsIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new Microsoft365ReportsIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiRegistrationGuid"] = this.shiRegistrationGuid;
        data["domainName"] = this.domainName;
        data["tenantId"] = this.tenantId;
        data["applicationRegistrationId"] = this.applicationRegistrationId;
        data["registrationLink"] = this.registrationLink;
        data["linkCreationDate"] = this.linkCreationDate ? this.linkCreationDate.toISOString() : <any>undefined;
        data["linkCreationUser"] = this.linkCreationUser;
        data["registrationStatus"] = this.registrationStatus;
        data["isCallbackReceived"] = this.isCallbackReceived;
        data["callbackReceivedDate"] = this.callbackReceivedDate ? this.callbackReceivedDate.toISOString() : <any>undefined;
        data["callbackPermittedScope"] = this.callbackPermittedScope;
        data["callbackState"] = this.callbackState;
        super.toJSON(data);
        return data;
    }
}

export interface IMicrosoft365ReportsIntegrationMetadata extends IIntegrationMetadata {
    shiRegistrationGuid?: string;
    domainName?: string | undefined;
    tenantId?: string | undefined;
    applicationRegistrationId?: string | undefined;
    registrationLink?: string | undefined;
    linkCreationDate?: Date | undefined;
    linkCreationUser?: string | undefined;
    registrationStatus?: RegistrationStatus;
    isCallbackReceived?: boolean | undefined;
    callbackReceivedDate?: Date | undefined;
    callbackPermittedScope?: string | undefined;
    callbackState?: string | undefined;
}

export class Microsoft365CallbackDetails implements IMicrosoft365CallbackDetails {
    code?: string | undefined;
    registrationId?: string | undefined;
    registrationType?: IntegrationType;
    sessionState?: string | undefined;

    constructor(data?: IMicrosoft365CallbackDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.registrationId = _data["registrationId"];
            this.registrationType = _data["registrationType"];
            this.sessionState = _data["sessionState"];
        }
    }

    static fromJS(data: any): Microsoft365CallbackDetails {
        data = typeof data === 'object' ? data : {};
        let result = new Microsoft365CallbackDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["registrationId"] = this.registrationId;
        data["registrationType"] = this.registrationType;
        data["sessionState"] = this.sessionState;
        return data;
    }
}

export interface IMicrosoft365CallbackDetails {
    code?: string | undefined;
    registrationId?: string | undefined;
    registrationType?: IntegrationType;
    sessionState?: string | undefined;
}

export class RegistrationError implements IRegistrationError {
    errorInformation?: string | undefined;

    constructor(data?: IRegistrationError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorInformation = _data["errorInformation"];
        }
    }

    static fromJS(data: any): RegistrationError {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorInformation"] = this.errorInformation;
        return data;
    }
}

export interface IRegistrationError {
    errorInformation?: string | undefined;
}

export class Microsoft365TenantConnection implements IMicrosoft365TenantConnection {
    tenantId?: string | undefined;
    currentState?: ConnectionStatus;
    errorMessage?: string | undefined;

    constructor(data?: IMicrosoft365TenantConnection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.currentState = _data["currentState"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): Microsoft365TenantConnection {
        data = typeof data === 'object' ? data : {};
        let result = new Microsoft365TenantConnection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["currentState"] = this.currentState;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IMicrosoft365TenantConnection {
    tenantId?: string | undefined;
    currentState?: ConnectionStatus;
    errorMessage?: string | undefined;
}

export class LiveOpticsIntegrationMetadata extends IntegrationMetadata implements ILiveOpticsIntegrationMetadata {
    axAccount?: string | undefined;
    originalFilename?: string | undefined;
    processedFilename?: string | undefined;
    fileSubmissionUtcDateTime?: Date;
    liveOpticsProjectId?: string | undefined;

    constructor(data?: ILiveOpticsIntegrationMetadata) {
        super(data);
        this._discriminator = "LiveOpticsIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.axAccount = _data["axAccount"];
            this.originalFilename = _data["originalFilename"];
            this.processedFilename = _data["processedFilename"];
            this.fileSubmissionUtcDateTime = _data["fileSubmissionUtcDateTime"] ? new Date(_data["fileSubmissionUtcDateTime"].toString()) : <any>undefined;
            this.liveOpticsProjectId = _data["liveOpticsProjectId"];
        }
    }

    static override fromJS(data: any): LiveOpticsIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new LiveOpticsIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccount"] = this.axAccount;
        data["originalFilename"] = this.originalFilename;
        data["processedFilename"] = this.processedFilename;
        data["fileSubmissionUtcDateTime"] = this.fileSubmissionUtcDateTime ? this.fileSubmissionUtcDateTime.toISOString() : <any>undefined;
        data["liveOpticsProjectId"] = this.liveOpticsProjectId;
        super.toJSON(data);
        return data;
    }
}

export interface ILiveOpticsIntegrationMetadata extends IIntegrationMetadata {
    axAccount?: string | undefined;
    originalFilename?: string | undefined;
    processedFilename?: string | undefined;
    fileSubmissionUtcDateTime?: Date;
    liveOpticsProjectId?: string | undefined;
}

export class LiveOpticsProjectUploadResponse implements ILiveOpticsProjectUploadResponse {
    integrationRecord?: IntegrationDTO | undefined;

    constructor(data?: ILiveOpticsProjectUploadResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.integrationRecord = _data["integrationRecord"] ? IntegrationDTO.fromJS(_data["integrationRecord"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LiveOpticsProjectUploadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LiveOpticsProjectUploadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationRecord"] = this.integrationRecord ? this.integrationRecord.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILiveOpticsProjectUploadResponse {
    integrationRecord?: IntegrationDTO | undefined;
}

export enum Purpose {
    AzureAssets = "AzureAssets",
    AzureCostAndUsage = "AzureCostAndUsage",
}

export enum OrderBy {
    LastActivityDate = "LastActivityDate",
    Id = "Id",
}

export class RackAndStackIntegrationMetadata extends IntegrationMetadata implements IRackAndStackIntegrationMetadata {
    axNumber?: string | undefined;

    constructor(data?: IRackAndStackIntegrationMetadata) {
        super(data);
        this._discriminator = "RackAndStackIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.axNumber = _data["axNumber"];
        }
    }

    static override fromJS(data: any): RackAndStackIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new RackAndStackIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axNumber"] = this.axNumber;
        super.toJSON(data);
        return data;
    }
}

export interface IRackAndStackIntegrationMetadata extends IIntegrationMetadata {
    axNumber?: string | undefined;
}

export class AzureCreateSubscriptionRequest implements IAzureCreateSubscriptionRequest {
    displayName?: string | undefined;
    customerId?: string | undefined;
    desiredOwnerEmail?: string | undefined;
    azurePlanDomain?: string | undefined;
    azurePlanParentID?: string | undefined;
    contractID?: number;

    constructor(data?: IAzureCreateSubscriptionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.customerId = _data["customerId"];
            this.desiredOwnerEmail = _data["desiredOwnerEmail"];
            this.azurePlanDomain = _data["azurePlanDomain"];
            this.azurePlanParentID = _data["azurePlanParentID"];
            this.contractID = _data["contractID"];
        }
    }

    static fromJS(data: any): AzureCreateSubscriptionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AzureCreateSubscriptionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["customerId"] = this.customerId;
        data["desiredOwnerEmail"] = this.desiredOwnerEmail;
        data["azurePlanDomain"] = this.azurePlanDomain;
        data["azurePlanParentID"] = this.azurePlanParentID;
        data["contractID"] = this.contractID;
        return data;
    }
}

export interface IAzureCreateSubscriptionRequest {
    displayName?: string | undefined;
    customerId?: string | undefined;
    desiredOwnerEmail?: string | undefined;
    azurePlanDomain?: string | undefined;
    azurePlanParentID?: string | undefined;
    contractID?: number;
}

export class CostAnalytics implements ICostAnalytics {
    axAccountNumber?: string | undefined;
    month?: number;
    year?: number;
    monthlyCost?: number;
    dailyAverageCost?: number;
    numberOfAccounts?: number;
    projectedCost?: number;
    lastSuccessfulCheckDateTime?: Date;

    constructor(data?: ICostAnalytics) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.axAccountNumber = _data["axAccountNumber"];
            this.month = _data["month"];
            this.year = _data["year"];
            this.monthlyCost = _data["monthlyCost"];
            this.dailyAverageCost = _data["dailyAverageCost"];
            this.numberOfAccounts = _data["numberOfAccounts"];
            this.projectedCost = _data["projectedCost"];
            this.lastSuccessfulCheckDateTime = _data["lastSuccessfulCheckDateTime"] ? new Date(_data["lastSuccessfulCheckDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CostAnalytics {
        data = typeof data === 'object' ? data : {};
        let result = new CostAnalytics();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccountNumber"] = this.axAccountNumber;
        data["month"] = this.month;
        data["year"] = this.year;
        data["monthlyCost"] = this.monthlyCost;
        data["dailyAverageCost"] = this.dailyAverageCost;
        data["numberOfAccounts"] = this.numberOfAccounts;
        data["projectedCost"] = this.projectedCost;
        data["lastSuccessfulCheckDateTime"] = this.lastSuccessfulCheckDateTime ? this.lastSuccessfulCheckDateTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICostAnalytics {
    axAccountNumber?: string | undefined;
    month?: number;
    year?: number;
    monthlyCost?: number;
    dailyAverageCost?: number;
    numberOfAccounts?: number;
    projectedCost?: number;
    lastSuccessfulCheckDateTime?: Date;
}

export class PostCostAnalyticsRequest implements IPostCostAnalyticsRequest {
    costAnalytics?: CostAnalytics[] | undefined;

    constructor(data?: IPostCostAnalyticsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["costAnalytics"])) {
                this.costAnalytics = [] as any;
                for (let item of _data["costAnalytics"])
                    this.costAnalytics!.push(CostAnalytics.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PostCostAnalyticsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PostCostAnalyticsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.costAnalytics)) {
            data["costAnalytics"] = [];
            for (let item of this.costAnalytics)
                data["costAnalytics"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPostCostAnalyticsRequest {
    costAnalytics?: CostAnalytics[] | undefined;
}

export class AzureSubscriptionErrorResponse implements IAzureSubscriptionErrorResponse {
    error?: SubscriptionError;
    code?: string | undefined;
    message?: string | undefined;

    constructor(data?: IAzureSubscriptionErrorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"] ? SubscriptionError.fromJS(_data["error"]) : <any>undefined;
            this.code = _data["code"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): AzureSubscriptionErrorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AzureSubscriptionErrorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["code"] = this.code;
        data["message"] = this.message;
        return data;
    }
}

export interface IAzureSubscriptionErrorResponse {
    error?: SubscriptionError;
    code?: string | undefined;
    message?: string | undefined;
}

export class AzureSubscriptionResponse implements IAzureSubscriptionResponse {
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    properties?: SubscriptionResponseProperties;
    error?: AzureSubscriptionErrorResponse;

    constructor(data?: IAzureSubscriptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.properties = _data["properties"] ? SubscriptionResponseProperties.fromJS(_data["properties"]) : <any>undefined;
            this.error = _data["error"] ? AzureSubscriptionErrorResponse.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AzureSubscriptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AzureSubscriptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["properties"] = this.properties ? this.properties.toJSON() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAzureSubscriptionResponse {
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    properties?: SubscriptionResponseProperties;
    error?: AzureSubscriptionErrorResponse;
}

export class AzureSubscriptionStatusResponse implements IAzureSubscriptionStatusResponse {
    subscriptionStatuses?: AzureSubscriptionStatus[] | undefined;

    constructor(data?: IAzureSubscriptionStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["subscriptionStatuses"])) {
                this.subscriptionStatuses = [] as any;
                for (let item of _data["subscriptionStatuses"])
                    this.subscriptionStatuses!.push(AzureSubscriptionStatus.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AzureSubscriptionStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AzureSubscriptionStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.subscriptionStatuses)) {
            data["subscriptionStatuses"] = [];
            for (let item of this.subscriptionStatuses)
                data["subscriptionStatuses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAzureSubscriptionStatusResponse {
    subscriptionStatuses?: AzureSubscriptionStatus[] | undefined;
}

export class SubscriptionError implements ISubscriptionError {
    code?: string | undefined;
    message?: string | undefined;

    constructor(data?: ISubscriptionError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SubscriptionError {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        return data;
    }
}

export interface ISubscriptionError {
    code?: string | undefined;
    message?: string | undefined;
}

export class ContractOverview implements IContractOverview {
    contractId?: number;
    totalHoursSpent?: number;
    ticketIdHoursSpent?: HoursSpentByTicket[] | undefined;

    constructor(data?: IContractOverview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractId = _data["contractId"];
            this.totalHoursSpent = _data["totalHoursSpent"];
            if (Array.isArray(_data["ticketIdHoursSpent"])) {
                this.ticketIdHoursSpent = [] as any;
                for (let item of _data["ticketIdHoursSpent"])
                    this.ticketIdHoursSpent!.push(HoursSpentByTicket.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContractOverview {
        data = typeof data === 'object' ? data : {};
        let result = new ContractOverview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractId"] = this.contractId;
        data["totalHoursSpent"] = this.totalHoursSpent;
        if (Array.isArray(this.ticketIdHoursSpent)) {
            data["ticketIdHoursSpent"] = [];
            for (let item of this.ticketIdHoursSpent)
                data["ticketIdHoursSpent"].push(item.toJSON());
        }
        return data;
    }
}

export interface IContractOverview {
    contractId?: number;
    totalHoursSpent?: number;
    ticketIdHoursSpent?: HoursSpentByTicket[] | undefined;
}

export class CostAnalyticsResponse implements ICostAnalyticsResponse {
    accounts?: { [key: string]: CostAnalytics[]; } | undefined;

    constructor(data?: ICostAnalyticsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["accounts"]) {
                this.accounts = {} as any;
                for (let key in _data["accounts"]) {
                    if (_data["accounts"].hasOwnProperty(key))
                        (<any>this.accounts)![key] = _data["accounts"][key] ? _data["accounts"][key].map((i: any) => CostAnalytics.fromJS(i)) : <any>undefined;
                }
            }
        }
    }

    static fromJS(data: any): CostAnalyticsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CostAnalyticsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.accounts) {
            data["accounts"] = {};
            for (let key in this.accounts) {
                if (this.accounts.hasOwnProperty(key))
                    (<any>data["accounts"])[key] = (<any>this.accounts)[key];
            }
        }
        return data;
    }
}

export interface ICostAnalyticsResponse {
    accounts?: { [key: string]: CostAnalytics[]; } | undefined;
}

export class HoursSpentByTicket implements IHoursSpentByTicket {
    ticketId?: number;
    hours?: number;

    constructor(data?: IHoursSpentByTicket) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketId = _data["ticketId"];
            this.hours = _data["hours"];
        }
    }

    static fromJS(data: any): HoursSpentByTicket {
        data = typeof data === 'object' ? data : {};
        let result = new HoursSpentByTicket();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketId"] = this.ticketId;
        data["hours"] = this.hours;
        return data;
    }
}

export interface IHoursSpentByTicket {
    ticketId?: number;
    hours?: number;
}

export class SaveAccountTeamMembersRequest implements ISaveAccountTeamMembersRequest {
    activeDirectoryAccountTeamMembers?: ActiveDirectoryAccountTeamMember[] | undefined;
    crmAccountTeamMembers?: CrmAccountTeamMember[] | undefined;

    constructor(data?: ISaveAccountTeamMembersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["activeDirectoryAccountTeamMembers"])) {
                this.activeDirectoryAccountTeamMembers = [] as any;
                for (let item of _data["activeDirectoryAccountTeamMembers"])
                    this.activeDirectoryAccountTeamMembers!.push(ActiveDirectoryAccountTeamMember.fromJS(item));
            }
            if (Array.isArray(_data["crmAccountTeamMembers"])) {
                this.crmAccountTeamMembers = [] as any;
                for (let item of _data["crmAccountTeamMembers"])
                    this.crmAccountTeamMembers!.push(CrmAccountTeamMember.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveAccountTeamMembersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveAccountTeamMembersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.activeDirectoryAccountTeamMembers)) {
            data["activeDirectoryAccountTeamMembers"] = [];
            for (let item of this.activeDirectoryAccountTeamMembers)
                data["activeDirectoryAccountTeamMembers"].push(item.toJSON());
        }
        if (Array.isArray(this.crmAccountTeamMembers)) {
            data["crmAccountTeamMembers"] = [];
            for (let item of this.crmAccountTeamMembers)
                data["crmAccountTeamMembers"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISaveAccountTeamMembersRequest {
    activeDirectoryAccountTeamMembers?: ActiveDirectoryAccountTeamMember[] | undefined;
    crmAccountTeamMembers?: CrmAccountTeamMember[] | undefined;
}

export class AccountContractRequest implements IAccountContractRequest {
    pageNumber?: number;
    pageSize?: number;
    searchString?: string | undefined;
    accountId?: number | undefined;
    contractTypes?: number[] | undefined;
    accounts?: number[] | undefined;
    status?: number | undefined;
    orderBy?: string | undefined;
    orderDirection?: string | undefined;

    constructor(data?: IAccountContractRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.searchString = _data["searchString"];
            this.accountId = _data["accountId"];
            if (Array.isArray(_data["contractTypes"])) {
                this.contractTypes = [] as any;
                for (let item of _data["contractTypes"])
                    this.contractTypes!.push(item);
            }
            if (Array.isArray(_data["accounts"])) {
                this.accounts = [] as any;
                for (let item of _data["accounts"])
                    this.accounts!.push(item);
            }
            this.status = _data["status"];
            this.orderBy = _data["orderBy"];
            this.orderDirection = _data["orderDirection"];
        }
    }

    static fromJS(data: any): AccountContractRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AccountContractRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["searchString"] = this.searchString;
        data["accountId"] = this.accountId;
        if (Array.isArray(this.contractTypes)) {
            data["contractTypes"] = [];
            for (let item of this.contractTypes)
                data["contractTypes"].push(item);
        }
        if (Array.isArray(this.accounts)) {
            data["accounts"] = [];
            for (let item of this.accounts)
                data["accounts"].push(item);
        }
        data["status"] = this.status;
        data["orderBy"] = this.orderBy;
        data["orderDirection"] = this.orderDirection;
        return data;
    }
}

export interface IAccountContractRequest {
    pageNumber?: number;
    pageSize?: number;
    searchString?: string | undefined;
    accountId?: number | undefined;
    contractTypes?: number[] | undefined;
    accounts?: number[] | undefined;
    status?: number | undefined;
    orderBy?: string | undefined;
    orderDirection?: string | undefined;
}

export class AccountDeviceRequest implements IAccountDeviceRequest {
    pageNumber?: number;
    pageSize?: number;
    searchString?: string | undefined;
    accounts?: number[] | undefined;
    productTypeIds?: number[] | undefined;
    assignedContactIds?: number[] | undefined;
    orderBy?: ConfigItemOrderBy;
    orderDirection?: ConfigItemOrderDirection;

    constructor(data?: IAccountDeviceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.searchString = _data["searchString"];
            if (Array.isArray(_data["accounts"])) {
                this.accounts = [] as any;
                for (let item of _data["accounts"])
                    this.accounts!.push(item);
            }
            if (Array.isArray(_data["productTypeIds"])) {
                this.productTypeIds = [] as any;
                for (let item of _data["productTypeIds"])
                    this.productTypeIds!.push(item);
            }
            if (Array.isArray(_data["assignedContactIds"])) {
                this.assignedContactIds = [] as any;
                for (let item of _data["assignedContactIds"])
                    this.assignedContactIds!.push(item);
            }
            this.orderBy = _data["orderBy"];
            this.orderDirection = _data["orderDirection"];
        }
    }

    static fromJS(data: any): AccountDeviceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AccountDeviceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["searchString"] = this.searchString;
        if (Array.isArray(this.accounts)) {
            data["accounts"] = [];
            for (let item of this.accounts)
                data["accounts"].push(item);
        }
        if (Array.isArray(this.productTypeIds)) {
            data["productTypeIds"] = [];
            for (let item of this.productTypeIds)
                data["productTypeIds"].push(item);
        }
        if (Array.isArray(this.assignedContactIds)) {
            data["assignedContactIds"] = [];
            for (let item of this.assignedContactIds)
                data["assignedContactIds"].push(item);
        }
        data["orderBy"] = this.orderBy;
        data["orderDirection"] = this.orderDirection;
        return data;
    }
}

export interface IAccountDeviceRequest {
    pageNumber?: number;
    pageSize?: number;
    searchString?: string | undefined;
    accounts?: number[] | undefined;
    productTypeIds?: number[] | undefined;
    assignedContactIds?: number[] | undefined;
    orderBy?: ConfigItemOrderBy;
    orderDirection?: ConfigItemOrderDirection;
}

export enum ConfigItemOrderBy {
    Id = "Id",
    AccountID = "AccountID",
    AccountPhysicalLocationID = "AccountPhysicalLocationID",
    ProductID = "ProductID",
    ContractID = "ContractID",
    ServiceID = "ServiceID",
    ServiceBundleID = "ServiceBundleID",
    ContactID = "ContactID",
    VendorID = "VendorID",
    InstalledByID = "InstalledByID",
    InstalledByContactID = "InstalledByContactID",
    ParentInstalledProductID = "ParentInstalledProductID",
    ContractServiceID = "ContractServiceID",
    ContractServiceBundleID = "ContractServiceBundleID",
    ServiceLevelAgreementID = "ServiceLevelAgreementID",
    Active = "Active",
    CreateDate = "CreateDate",
    InstallDate = "InstallDate",
    Notes = "Notes",
    ReferenceNumber = "ReferenceNumber",
    ReferenceTitle = "ReferenceTitle",
    SerialNumber = "SerialNumber",
    WarrantyExpirationDate = "WarrantyExpirationDate",
    Type = "Type",
    Location = "Location",
    LastModifiedTime = "LastModifiedTime",
    RMMDeviceID = "RMMDeviceID",
    RMMDeviceUID = "RMMDeviceUID",
    RMMDeviceAuditArchitectureID = "RMMDeviceAuditArchitectureID",
    RMMDeviceAuditDescription = "RMMDeviceAuditDescription",
    RMMDeviceAuditDisplayAdaptorID = "RMMDeviceAuditDisplayAdaptorID",
    RMMDeviceAuditDomainID = "RMMDeviceAuditDomainID",
    RMMDeviceAuditExternalIPAddress = "RMMDeviceAuditExternalIPAddress",
    RMMDeviceAuditHostname = "RMMDeviceAuditHostname",
    RMMDeviceAuditIPAddress = "RMMDeviceAuditIPAddress",
    RMMDeviceAuditMacAddress = "RMMDeviceAuditMacAddress",
    RMMDeviceAuditManufacturerID = "RMMDeviceAuditManufacturerID",
    RMMDeviceAuditMemoryBytes = "RMMDeviceAuditMemoryBytes",
    RMMDeviceAuditModelID = "RMMDeviceAuditModelID",
    RMMDeviceAuditMotherboardID = "RMMDeviceAuditMotherboardID",
    RMMDeviceAuditOperatingSystem = "RMMDeviceAuditOperatingSystem",
    RMMDeviceAuditProcessorID = "RMMDeviceAuditProcessorID",
    RMMDeviceAuditServicePackID = "RMMDeviceAuditServicePackID",
    RMMDeviceAuditStorageBytes = "RMMDeviceAuditStorageBytes",
    RMMDeviceAuditDeviceTypeID = "RMMDeviceAuditDeviceTypeID",
    RMMDeviceAuditSNMPLocation = "RMMDeviceAuditSNMPLocation",
    RMMDeviceAuditSNMPName = "RMMDeviceAuditSNMPName",
    RMMDeviceAuditSNMPContact = "RMMDeviceAuditSNMPContact",
    RMMDeviceAuditMobileNetworkOperatorID = "RMMDeviceAuditMobileNetworkOperatorID",
    RMMDeviceAuditMobileNumber = "RMMDeviceAuditMobileNumber",
    RMMDeviceAuditMissingPatchCount = "RMMDeviceAuditMissingPatchCount",
    RMMOpenAlertCount = "RMMOpenAlertCount",
    RMMDeviceAuditLastUser = "RMMDeviceAuditLastUser",
    DattoSerialNumber = "DattoSerialNumber",
    DattoInternalIP = "DattoInternalIP",
    DattoRemoteIP = "DattoRemoteIP",
    DattoHostname = "DattoHostname",
    DattoProtectedKilobytes = "DattoProtectedKilobytes",
    DattoUsedKilobytes = "DattoUsedKilobytes",
    DattoAvailableKilobytes = "DattoAvailableKilobytes",
    DattoPercentageUsed = "DattoPercentageUsed",
    DattoOffsiteUsedBytes = "DattoOffsiteUsedBytes",
    DattoOSVersionID = "DattoOSVersionID",
    DattoZFSVersionID = "DattoZFSVersionID",
    DattoKernelVersionID = "DattoKernelVersionID",
    DattoNICSpeedKilobitsPerSecond = "DattoNICSpeedKilobitsPerSecond",
    DattoDeviceMemoryMegabytes = "DattoDeviceMemoryMegabytes",
    DattoUptimeSeconds = "DattoUptimeSeconds",
    DattoNumberOfAgents = "DattoNumberOfAgents",
    DattoNumberOfDrives = "DattoNumberOfDrives",
    DattoDrivesErrors = "DattoDrivesErrors",
    DattoNumberOfVolumes = "DattoNumberOfVolumes",
    DattoLastCheckInDateTime = "DattoLastCheckInDateTime",
    UserDefinedFieldsJson = "UserDefinedFieldsJson",
    NumberOfUsers = "NumberOfUsers",
}

export enum ConfigItemOrderDirection {
    ASC = "ASC",
    DESC = "DESC",
}

export class ToggleManualEmailRequest implements IToggleManualEmailRequest {
    accountId?: number;
    noManualAuthRequired?: boolean;

    constructor(data?: IToggleManualEmailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.noManualAuthRequired = _data["noManualAuthRequired"];
        }
    }

    static fromJS(data: any): ToggleManualEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ToggleManualEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["noManualAuthRequired"] = this.noManualAuthRequired;
        return data;
    }
}

export interface IToggleManualEmailRequest {
    accountId?: number;
    noManualAuthRequired?: boolean;
}

export class UserProfilesRequest implements IUserProfilesRequest {
    searchString?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    accounts?: number[] | undefined;

    constructor(data?: IUserProfilesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchString = _data["searchString"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["accounts"])) {
                this.accounts = [] as any;
                for (let item of _data["accounts"])
                    this.accounts!.push(item);
            }
        }
    }

    static fromJS(data: any): UserProfilesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfilesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchString"] = this.searchString;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.accounts)) {
            data["accounts"] = [];
            for (let item of this.accounts)
                data["accounts"].push(item);
        }
        return data;
    }
}

export interface IUserProfilesRequest {
    searchString?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    accounts?: number[] | undefined;
}

export class GroupStatement implements IGroupStatement {
    effect?: string | undefined;
    action?: string[] | undefined;
    resources?: string[] | undefined;

    constructor(data?: IGroupStatement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.effect = _data["effect"];
            if (Array.isArray(_data["action"])) {
                this.action = [] as any;
                for (let item of _data["action"])
                    this.action!.push(item);
            }
            if (Array.isArray(_data["resources"])) {
                this.resources = [] as any;
                for (let item of _data["resources"])
                    this.resources!.push(item);
            }
        }
    }

    static fromJS(data: any): GroupStatement {
        data = typeof data === 'object' ? data : {};
        let result = new GroupStatement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["effect"] = this.effect;
        if (Array.isArray(this.action)) {
            data["action"] = [];
            for (let item of this.action)
                data["action"].push(item);
        }
        if (Array.isArray(this.resources)) {
            data["resources"] = [];
            for (let item of this.resources)
                data["resources"].push(item);
        }
        return data;
    }
}

export interface IGroupStatement {
    effect?: string | undefined;
    action?: string[] | undefined;
    resources?: string[] | undefined;
}

export class PermissionsReturn implements IPermissionsReturn {
    teamId?: number;
    currentStatements?: GroupStatement[] | undefined;
    resourceDefinitions?: ResourceDefinition[] | undefined;

    constructor(data?: IPermissionsReturn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamId = _data["teamId"];
            if (Array.isArray(_data["currentStatements"])) {
                this.currentStatements = [] as any;
                for (let item of _data["currentStatements"])
                    this.currentStatements!.push(GroupStatement.fromJS(item));
            }
            if (Array.isArray(_data["resourceDefinitions"])) {
                this.resourceDefinitions = [] as any;
                for (let item of _data["resourceDefinitions"])
                    this.resourceDefinitions!.push(ResourceDefinition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionsReturn {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionsReturn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamId"] = this.teamId;
        if (Array.isArray(this.currentStatements)) {
            data["currentStatements"] = [];
            for (let item of this.currentStatements)
                data["currentStatements"].push(item.toJSON());
        }
        if (Array.isArray(this.resourceDefinitions)) {
            data["resourceDefinitions"] = [];
            for (let item of this.resourceDefinitions)
                data["resourceDefinitions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPermissionsReturn {
    teamId?: number;
    currentStatements?: GroupStatement[] | undefined;
    resourceDefinitions?: ResourceDefinition[] | undefined;
}

export class ResourceAction implements IResourceAction {
    displayName?: string | undefined;
    actionName?: string | undefined;

    constructor(data?: IResourceAction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.actionName = _data["actionName"];
        }
    }

    static fromJS(data: any): ResourceAction {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["actionName"] = this.actionName;
        return data;
    }
}

export interface IResourceAction {
    displayName?: string | undefined;
    actionName?: string | undefined;
}

export class ResourceDefinition implements IResourceDefinition {
    resourceName?: string | undefined;
    displayName?: string | undefined;
    configurationType?: PermissionConfigurationType;
    actions?: ResourceAction[] | undefined;

    constructor(data?: IResourceDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resourceName = _data["resourceName"];
            this.displayName = _data["displayName"];
            this.configurationType = _data["configurationType"];
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(ResourceAction.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResourceDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resourceName"] = this.resourceName;
        data["displayName"] = this.displayName;
        data["configurationType"] = this.configurationType;
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResourceDefinition {
    resourceName?: string | undefined;
    displayName?: string | undefined;
    configurationType?: PermissionConfigurationType;
    actions?: ResourceAction[] | undefined;
}

export class SelfServiceReportingIntegrationMetadata extends IntegrationMetadata implements ISelfServiceReportingIntegrationMetadata {
    axAccount?: string | undefined;
    workspaceId?: string | undefined;
    accountName?: string | undefined;
    datasetCategories?: DatasetCategories[] | undefined;

    constructor(data?: ISelfServiceReportingIntegrationMetadata) {
        super(data);
        this._discriminator = "SelfServiceReportingIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.axAccount = _data["axAccount"];
            this.workspaceId = _data["workspaceId"];
            this.accountName = _data["accountName"];
            if (Array.isArray(_data["datasetCategories"])) {
                this.datasetCategories = [] as any;
                for (let item of _data["datasetCategories"])
                    this.datasetCategories!.push(item);
            }
        }
    }

    static override fromJS(data: any): SelfServiceReportingIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new SelfServiceReportingIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccount"] = this.axAccount;
        data["workspaceId"] = this.workspaceId;
        data["accountName"] = this.accountName;
        if (Array.isArray(this.datasetCategories)) {
            data["datasetCategories"] = [];
            for (let item of this.datasetCategories)
                data["datasetCategories"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISelfServiceReportingIntegrationMetadata extends IIntegrationMetadata {
    axAccount?: string | undefined;
    workspaceId?: string | undefined;
    accountName?: string | undefined;
    datasetCategories?: DatasetCategories[] | undefined;
}

export class ServiceRequestDownloadRequest implements IServiceRequestDownloadRequest {
    query?: ServiceRequestBaseElasticQueryRequest;
    gridDefinitions?: ExcelDownloadDefinition[] | undefined;
    queryString?: string | undefined;

    constructor(data?: IServiceRequestDownloadRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.query = _data["query"] ? ServiceRequestBaseElasticQueryRequest.fromJS(_data["query"]) : <any>undefined;
            if (Array.isArray(_data["gridDefinitions"])) {
                this.gridDefinitions = [] as any;
                for (let item of _data["gridDefinitions"])
                    this.gridDefinitions!.push(ExcelDownloadDefinition.fromJS(item));
            }
            this.queryString = _data["queryString"];
        }
    }

    static fromJS(data: any): ServiceRequestDownloadRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestDownloadRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query ? this.query.toJSON() : <any>undefined;
        if (Array.isArray(this.gridDefinitions)) {
            data["gridDefinitions"] = [];
            for (let item of this.gridDefinitions)
                data["gridDefinitions"].push(item.toJSON());
        }
        data["queryString"] = this.queryString;
        return data;
    }
}

export interface IServiceRequestDownloadRequest {
    query?: ServiceRequestBaseElasticQueryRequest;
    gridDefinitions?: ExcelDownloadDefinition[] | undefined;
    queryString?: string | undefined;
}

export enum ServiceRequestLandingPageIconColor {
    ServiceRequestColor = "ServiceRequestColor",
    IncidentColor = "IncidentColor",
    ChangeRequestColor = "ChangeRequestColor",
}

export class ServiceRequestLandingPageItemDto implements IServiceRequestLandingPageItemDto {
    title?: string | undefined;
    description?: string | undefined;
    icon?: string | undefined;
    landingPageUrl?: string | undefined;
    targetUrl?: string | undefined;
    iconColorCategory?: ServiceRequestLandingPageIconColor;
    contractId?: number | undefined;
    issueTypeId?: number | undefined;
    subIssueTypeId?: number | undefined;
    collectTitle?: boolean;
    collectDescription?: boolean;
    categoryId?: number | undefined;
    serviceRequestMappingId?: number;
    iconColor?: string | undefined;

    constructor(data?: IServiceRequestLandingPageItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.icon = _data["icon"];
            this.landingPageUrl = _data["landingPageUrl"];
            this.targetUrl = _data["targetUrl"];
            this.iconColorCategory = _data["iconColorCategory"];
            this.contractId = _data["contractId"];
            this.issueTypeId = _data["issueTypeId"];
            this.subIssueTypeId = _data["subIssueTypeId"];
            this.collectTitle = _data["collectTitle"];
            this.collectDescription = _data["collectDescription"];
            this.categoryId = _data["categoryId"];
            this.serviceRequestMappingId = _data["serviceRequestMappingId"];
            this.iconColor = _data["iconColor"];
        }
    }

    static fromJS(data: any): ServiceRequestLandingPageItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestLandingPageItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["icon"] = this.icon;
        data["landingPageUrl"] = this.landingPageUrl;
        data["targetUrl"] = this.targetUrl;
        data["iconColorCategory"] = this.iconColorCategory;
        data["contractId"] = this.contractId;
        data["issueTypeId"] = this.issueTypeId;
        data["subIssueTypeId"] = this.subIssueTypeId;
        data["collectTitle"] = this.collectTitle;
        data["collectDescription"] = this.collectDescription;
        data["categoryId"] = this.categoryId;
        data["serviceRequestMappingId"] = this.serviceRequestMappingId;
        data["iconColor"] = this.iconColor;
        return data;
    }
}

export interface IServiceRequestLandingPageItemDto {
    title?: string | undefined;
    description?: string | undefined;
    icon?: string | undefined;
    landingPageUrl?: string | undefined;
    targetUrl?: string | undefined;
    iconColorCategory?: ServiceRequestLandingPageIconColor;
    contractId?: number | undefined;
    issueTypeId?: number | undefined;
    subIssueTypeId?: number | undefined;
    collectTitle?: boolean;
    collectDescription?: boolean;
    categoryId?: number | undefined;
    serviceRequestMappingId?: number;
    iconColor?: string | undefined;
}

export class ServiceRequestsRequest implements IServiceRequestsRequest {
    searchString?: string | undefined;
    requestType?: number | undefined;
    status?: number[] | undefined;
    priority?: number | undefined;
    ticketCategory?: number[] | undefined;
    issueType?: number | undefined;
    createdBefore?: Date | undefined;
    createdAfter?: Date | undefined;
    lastUpdatedBefore?: Date | undefined;
    lastUpdatedAfter?: Date | undefined;
    orderBy?: string | undefined;
    orderDirection?: string | undefined;
    skip?: number;
    take?: number;

    protected _discriminator: string;

    constructor(data?: IServiceRequestsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "ServiceRequestsRequest";
    }

    init(_data?: any) {
        if (_data) {
            this.searchString = _data["searchString"];
            this.requestType = _data["requestType"];
            if (Array.isArray(_data["status"])) {
                this.status = [] as any;
                for (let item of _data["status"])
                    this.status!.push(item);
            }
            this.priority = _data["priority"];
            if (Array.isArray(_data["ticketCategory"])) {
                this.ticketCategory = [] as any;
                for (let item of _data["ticketCategory"])
                    this.ticketCategory!.push(item);
            }
            this.issueType = _data["issueType"];
            this.createdBefore = _data["createdBefore"] ? new Date(_data["createdBefore"].toString()) : <any>undefined;
            this.createdAfter = _data["createdAfter"] ? new Date(_data["createdAfter"].toString()) : <any>undefined;
            this.lastUpdatedBefore = _data["lastUpdatedBefore"] ? new Date(_data["lastUpdatedBefore"].toString()) : <any>undefined;
            this.lastUpdatedAfter = _data["lastUpdatedAfter"] ? new Date(_data["lastUpdatedAfter"].toString()) : <any>undefined;
            this.orderBy = _data["orderBy"];
            this.orderDirection = _data["orderDirection"];
            this.skip = _data["skip"];
            this.take = _data["take"];
        }
    }

    static fromJS(data: any): ServiceRequestsRequest {
        data = typeof data === 'object' ? data : {};
        if (data["typeName"] === "TicketQueryRequest") {
            let result = new TicketQueryRequest();
            result.init(data);
            return result;
        }
        let result = new ServiceRequestsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeName"] = this._discriminator;
        data["searchString"] = this.searchString;
        data["requestType"] = this.requestType;
        if (Array.isArray(this.status)) {
            data["status"] = [];
            for (let item of this.status)
                data["status"].push(item);
        }
        data["priority"] = this.priority;
        if (Array.isArray(this.ticketCategory)) {
            data["ticketCategory"] = [];
            for (let item of this.ticketCategory)
                data["ticketCategory"].push(item);
        }
        data["issueType"] = this.issueType;
        data["createdBefore"] = this.createdBefore ? this.createdBefore.toISOString() : <any>undefined;
        data["createdAfter"] = this.createdAfter ? this.createdAfter.toISOString() : <any>undefined;
        data["lastUpdatedBefore"] = this.lastUpdatedBefore ? this.lastUpdatedBefore.toISOString() : <any>undefined;
        data["lastUpdatedAfter"] = this.lastUpdatedAfter ? this.lastUpdatedAfter.toISOString() : <any>undefined;
        data["orderBy"] = this.orderBy;
        data["orderDirection"] = this.orderDirection;
        data["skip"] = this.skip;
        data["take"] = this.take;
        return data;
    }
}

export interface IServiceRequestsRequest {
    searchString?: string | undefined;
    requestType?: number | undefined;
    status?: number[] | undefined;
    priority?: number | undefined;
    ticketCategory?: number[] | undefined;
    issueType?: number | undefined;
    createdBefore?: Date | undefined;
    createdAfter?: Date | undefined;
    lastUpdatedBefore?: Date | undefined;
    lastUpdatedAfter?: Date | undefined;
    orderBy?: string | undefined;
    orderDirection?: string | undefined;
    skip?: number;
    take?: number;
}

export class AXBillingAddressDTO implements IAXBillingAddressDTO {
    axAccountNumber?: string | undefined;
    readonly addresses?: string[] | undefined;

    constructor(data?: IAXBillingAddressDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.axAccountNumber = _data["axAccountNumber"];
            if (Array.isArray(_data["addresses"])) {
                (<any>this).addresses = [] as any;
                for (let item of _data["addresses"])
                    (<any>this).addresses!.push(item);
            }
        }
    }

    static fromJS(data: any): AXBillingAddressDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AXBillingAddressDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccountNumber"] = this.axAccountNumber;
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item);
        }
        return data;
    }
}

export interface IAXBillingAddressDTO {
    axAccountNumber?: string | undefined;
    addresses?: string[] | undefined;
}

export class AXProjectInvoicesResponse implements IAXProjectInvoicesResponse {
    message?: string | undefined;
    projectInvoices?: ProjectInvoice[] | undefined;

    constructor(data?: IAXProjectInvoicesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            if (Array.isArray(_data["projectInvoices"])) {
                this.projectInvoices = [] as any;
                for (let item of _data["projectInvoices"])
                    this.projectInvoices!.push(ProjectInvoice.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AXProjectInvoicesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AXProjectInvoicesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        if (Array.isArray(this.projectInvoices)) {
            data["projectInvoices"] = [];
            for (let item of this.projectInvoices)
                data["projectInvoices"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAXProjectInvoicesResponse {
    message?: string | undefined;
    projectInvoices?: ProjectInvoice[] | undefined;
}

export class Invoice implements IInvoice {
    invoiceId?: string | undefined;
    invoiceDate?: string | undefined;
    customerPo?: string | undefined;
    customerRequisition?: string | undefined;
    invoiceAmount?: number;
    tagFilter?: string | undefined;
    tag?: string | undefined;
    tenant?: string | undefined;
    serviceProjectName?: string | undefined;

    constructor(data?: IInvoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["invoiceId"];
            this.invoiceDate = _data["invoiceDate"];
            this.customerPo = _data["customerPo"];
            this.customerRequisition = _data["customerRequisition"];
            this.invoiceAmount = _data["invoiceAmount"];
            this.tagFilter = _data["tagFilter"];
            this.tag = _data["tag"];
            this.tenant = _data["tenant"];
            this.serviceProjectName = _data["serviceProjectName"];
        }
    }

    static fromJS(data: any): Invoice {
        data = typeof data === 'object' ? data : {};
        let result = new Invoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceId"] = this.invoiceId;
        data["invoiceDate"] = this.invoiceDate;
        data["customerPo"] = this.customerPo;
        data["customerRequisition"] = this.customerRequisition;
        data["invoiceAmount"] = this.invoiceAmount;
        data["tagFilter"] = this.tagFilter;
        data["tag"] = this.tag;
        data["tenant"] = this.tenant;
        data["serviceProjectName"] = this.serviceProjectName;
        return data;
    }
}

export interface IInvoice {
    invoiceId?: string | undefined;
    invoiceDate?: string | undefined;
    customerPo?: string | undefined;
    customerRequisition?: string | undefined;
    invoiceAmount?: number;
    tagFilter?: string | undefined;
    tag?: string | undefined;
    tenant?: string | undefined;
    serviceProjectName?: string | undefined;
}

export class Invoice_Response implements IInvoice_Response {
    accountId?: number;
    hasError?: boolean | undefined;
    message?: string | undefined;
    invoices?: Invoice[] | undefined;

    constructor(data?: IInvoice_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.hasError = _data["hasError"];
            this.message = _data["message"];
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices!.push(Invoice.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Invoice_Response {
        data = typeof data === 'object' ? data : {};
        let result = new Invoice_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["hasError"] = this.hasError;
        data["message"] = this.message;
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInvoice_Response {
    accountId?: number;
    hasError?: boolean | undefined;
    message?: string | undefined;
    invoices?: Invoice[] | undefined;
}

export class InvoiceEmail implements IInvoiceEmail {
    statusCode?: number;
    invoiceId?: string | undefined;
    message?: string | undefined;

    constructor(data?: IInvoiceEmail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.invoiceId = _data["invoiceId"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): InvoiceEmail {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceEmail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["invoiceId"] = this.invoiceId;
        data["message"] = this.message;
        return data;
    }
}

export interface IInvoiceEmail {
    statusCode?: number;
    invoiceId?: string | undefined;
    message?: string | undefined;
}

export class InvoiceEmail_Request implements IInvoiceEmail_Request {
    invoiceIds?: string[] | undefined;
    emailAddress?: string | undefined;

    constructor(data?: IInvoiceEmail_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["invoiceIds"])) {
                this.invoiceIds = [] as any;
                for (let item of _data["invoiceIds"])
                    this.invoiceIds!.push(item);
            }
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): InvoiceEmail_Request {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceEmail_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.invoiceIds)) {
            data["invoiceIds"] = [];
            for (let item of this.invoiceIds)
                data["invoiceIds"].push(item);
        }
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface IInvoiceEmail_Request {
    invoiceIds?: string[] | undefined;
    emailAddress?: string | undefined;
}

export class InvoiceEmail_Response implements IInvoiceEmail_Response {
    allSuccessful?: boolean;
    message?: string | undefined;
    hasError?: boolean;
    responseStatus?: number;
    invoiceResponses?: InvoiceEmail[] | undefined;

    constructor(data?: IInvoiceEmail_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allSuccessful = _data["allSuccessful"];
            this.message = _data["message"];
            this.hasError = _data["hasError"];
            this.responseStatus = _data["responseStatus"];
            if (Array.isArray(_data["invoiceResponses"])) {
                this.invoiceResponses = [] as any;
                for (let item of _data["invoiceResponses"])
                    this.invoiceResponses!.push(InvoiceEmail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvoiceEmail_Response {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceEmail_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allSuccessful"] = this.allSuccessful;
        data["message"] = this.message;
        data["hasError"] = this.hasError;
        data["responseStatus"] = this.responseStatus;
        if (Array.isArray(this.invoiceResponses)) {
            data["invoiceResponses"] = [];
            for (let item of this.invoiceResponses)
                data["invoiceResponses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInvoiceEmail_Response {
    allSuccessful?: boolean;
    message?: string | undefined;
    hasError?: boolean;
    responseStatus?: number;
    invoiceResponses?: InvoiceEmail[] | undefined;
}

export class ProjectInvoice implements IProjectInvoice {
    invoiceId?: string | undefined;
    invoiceDate?: string | undefined;
    invoiceAmount?: number;
    customerPo?: string | undefined;
    tag?: string | undefined;
    serviceProjectName?: string | undefined;

    constructor(data?: IProjectInvoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["invoiceId"];
            this.invoiceDate = _data["invoiceDate"];
            this.invoiceAmount = _data["invoiceAmount"];
            this.customerPo = _data["customerPo"];
            this.tag = _data["tag"];
            this.serviceProjectName = _data["serviceProjectName"];
        }
    }

    static fromJS(data: any): ProjectInvoice {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectInvoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceId"] = this.invoiceId;
        data["invoiceDate"] = this.invoiceDate;
        data["invoiceAmount"] = this.invoiceAmount;
        data["customerPo"] = this.customerPo;
        data["tag"] = this.tag;
        data["serviceProjectName"] = this.serviceProjectName;
        return data;
    }
}

export interface IProjectInvoice {
    invoiceId?: string | undefined;
    invoiceDate?: string | undefined;
    invoiceAmount?: number;
    customerPo?: string | undefined;
    tag?: string | undefined;
    serviceProjectName?: string | undefined;
}

export class UsageDataReportRequest implements IUsageDataReportRequest {
    backupServiceId?: string | undefined;
    startDate!: Date;
    endDate!: Date;
    reportType?: number;

    constructor(data?: IUsageDataReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.backupServiceId = _data["backupServiceId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.reportType = _data["reportType"];
        }
    }

    static fromJS(data: any): UsageDataReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UsageDataReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["backupServiceId"] = this.backupServiceId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["reportType"] = this.reportType;
        return data;
    }
}

export interface IUsageDataReportRequest {
    backupServiceId?: string | undefined;
    startDate: Date;
    endDate: Date;
    reportType?: number;
}

export class AXNumberEdit implements IAXNumberEdit {
    accountId?: number;
    axReferences?: AXReference[] | undefined;

    constructor(data?: IAXNumberEdit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            if (Array.isArray(_data["axReferences"])) {
                this.axReferences = [] as any;
                for (let item of _data["axReferences"])
                    this.axReferences!.push(AXReference.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AXNumberEdit {
        data = typeof data === 'object' ? data : {};
        let result = new AXNumberEdit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        if (Array.isArray(this.axReferences)) {
            data["axReferences"] = [];
            for (let item of this.axReferences)
                data["axReferences"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAXNumberEdit {
    accountId?: number;
    axReferences?: AXReference[] | undefined;
}

export class AccountNotifications implements IAccountNotifications {
    usersAwaitingApproval?: number;
    contractsWithoutGroups?: number;
    contractsWithoutGroupsList?: NotificationContract[] | undefined;
    cloudAccountsWithoutGroups?: number;
    cloudAccountsWithoutGroupsList?: NotificationCloudAccount[] | undefined;
    teamsEnabled?: boolean;

    constructor(data?: IAccountNotifications) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.usersAwaitingApproval = _data["usersAwaitingApproval"];
            this.contractsWithoutGroups = _data["contractsWithoutGroups"];
            if (Array.isArray(_data["contractsWithoutGroupsList"])) {
                this.contractsWithoutGroupsList = [] as any;
                for (let item of _data["contractsWithoutGroupsList"])
                    this.contractsWithoutGroupsList!.push(NotificationContract.fromJS(item));
            }
            this.cloudAccountsWithoutGroups = _data["cloudAccountsWithoutGroups"];
            if (Array.isArray(_data["cloudAccountsWithoutGroupsList"])) {
                this.cloudAccountsWithoutGroupsList = [] as any;
                for (let item of _data["cloudAccountsWithoutGroupsList"])
                    this.cloudAccountsWithoutGroupsList!.push(NotificationCloudAccount.fromJS(item));
            }
            this.teamsEnabled = _data["teamsEnabled"];
        }
    }

    static fromJS(data: any): AccountNotifications {
        data = typeof data === 'object' ? data : {};
        let result = new AccountNotifications();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["usersAwaitingApproval"] = this.usersAwaitingApproval;
        data["contractsWithoutGroups"] = this.contractsWithoutGroups;
        if (Array.isArray(this.contractsWithoutGroupsList)) {
            data["contractsWithoutGroupsList"] = [];
            for (let item of this.contractsWithoutGroupsList)
                data["contractsWithoutGroupsList"].push(item.toJSON());
        }
        data["cloudAccountsWithoutGroups"] = this.cloudAccountsWithoutGroups;
        if (Array.isArray(this.cloudAccountsWithoutGroupsList)) {
            data["cloudAccountsWithoutGroupsList"] = [];
            for (let item of this.cloudAccountsWithoutGroupsList)
                data["cloudAccountsWithoutGroupsList"].push(item.toJSON());
        }
        data["teamsEnabled"] = this.teamsEnabled;
        return data;
    }
}

export interface IAccountNotifications {
    usersAwaitingApproval?: number;
    contractsWithoutGroups?: number;
    contractsWithoutGroupsList?: NotificationContract[] | undefined;
    cloudAccountsWithoutGroups?: number;
    cloudAccountsWithoutGroupsList?: NotificationCloudAccount[] | undefined;
    teamsEnabled?: boolean;
}

export class AccountResponse implements IAccountResponse {
    responseStatus?: number;
    errorMessage?: string | undefined;
    accounts?: Account[] | undefined;

    constructor(data?: IAccountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseStatus = _data["responseStatus"];
            this.errorMessage = _data["errorMessage"];
            if (Array.isArray(_data["accounts"])) {
                this.accounts = [] as any;
                for (let item of _data["accounts"])
                    this.accounts!.push(Account.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AccountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseStatus"] = this.responseStatus;
        data["errorMessage"] = this.errorMessage;
        if (Array.isArray(this.accounts)) {
            data["accounts"] = [];
            for (let item of this.accounts)
                data["accounts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAccountResponse {
    responseStatus?: number;
    errorMessage?: string | undefined;
    accounts?: Account[] | undefined;
}

export class AccountSwitcherResponse implements IAccountSwitcherResponse {
    total?: number;
    currentPage?: number;
    currentOffset?: number;
    accounts?: SwitcherAccount[] | undefined;

    constructor(data?: IAccountSwitcherResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.currentPage = _data["currentPage"];
            this.currentOffset = _data["currentOffset"];
            if (Array.isArray(_data["accounts"])) {
                this.accounts = [] as any;
                for (let item of _data["accounts"])
                    this.accounts!.push(SwitcherAccount.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccountSwitcherResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AccountSwitcherResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["currentPage"] = this.currentPage;
        data["currentOffset"] = this.currentOffset;
        if (Array.isArray(this.accounts)) {
            data["accounts"] = [];
            for (let item of this.accounts)
                data["accounts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAccountSwitcherResponse {
    total?: number;
    currentPage?: number;
    currentOffset?: number;
    accounts?: SwitcherAccount[] | undefined;
}

export class AccountTeamMemberResponse implements IAccountTeamMemberResponse {
    responseStatus?: number;
    errorMessage?: string | undefined;
    accountTeamMembers?: AccountTeamMember[] | undefined;
    accountTeamMember?: AccountTeamMember;

    constructor(data?: IAccountTeamMemberResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseStatus = _data["responseStatus"];
            this.errorMessage = _data["errorMessage"];
            if (Array.isArray(_data["accountTeamMembers"])) {
                this.accountTeamMembers = [] as any;
                for (let item of _data["accountTeamMembers"])
                    this.accountTeamMembers!.push(AccountTeamMember.fromJS(item));
            }
            this.accountTeamMember = _data["accountTeamMember"] ? AccountTeamMember.fromJS(_data["accountTeamMember"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AccountTeamMemberResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AccountTeamMemberResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseStatus"] = this.responseStatus;
        data["errorMessage"] = this.errorMessage;
        if (Array.isArray(this.accountTeamMembers)) {
            data["accountTeamMembers"] = [];
            for (let item of this.accountTeamMembers)
                data["accountTeamMembers"].push(item.toJSON());
        }
        data["accountTeamMember"] = this.accountTeamMember ? this.accountTeamMember.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAccountTeamMemberResponse {
    responseStatus?: number;
    errorMessage?: string | undefined;
    accountTeamMembers?: AccountTeamMember[] | undefined;
    accountTeamMember?: AccountTeamMember;
}

export class AccountTypeUpdate implements IAccountTypeUpdate {
    accountId?: number;
    accountType?: number;

    constructor(data?: IAccountTypeUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.accountType = _data["accountType"];
        }
    }

    static fromJS(data: any): AccountTypeUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new AccountTypeUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["accountType"] = this.accountType;
        return data;
    }
}

export interface IAccountTypeUpdate {
    accountId?: number;
    accountType?: number;
}

export class AccountUserCount implements IAccountUserCount {
    accountId?: number;
    count?: number;

    constructor(data?: IAccountUserCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): AccountUserCount {
        data = typeof data === 'object' ? data : {};
        let result = new AccountUserCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["count"] = this.count;
        return data;
    }
}

export interface IAccountUserCount {
    accountId?: number;
    count?: number;
}

export class ActiveRequestsReport implements IActiveRequestsReport {
    accountId?: number;
    openRequests?: OpenRequests[] | undefined;
    companyName?: string | undefined;
    severityCounts?: KeyValuePair_2OfInt32AndInt32[] | undefined;
    ticketTypeCounts?: KeyValuePair_2OfInt32AndInt32[] | undefined;

    constructor(data?: IActiveRequestsReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            if (Array.isArray(_data["openRequests"])) {
                this.openRequests = [] as any;
                for (let item of _data["openRequests"])
                    this.openRequests!.push(OpenRequests.fromJS(item));
            }
            this.companyName = _data["companyName"];
            if (Array.isArray(_data["severityCounts"])) {
                this.severityCounts = [] as any;
                for (let item of _data["severityCounts"])
                    this.severityCounts!.push(KeyValuePair_2OfInt32AndInt32.fromJS(item));
            }
            if (Array.isArray(_data["ticketTypeCounts"])) {
                this.ticketTypeCounts = [] as any;
                for (let item of _data["ticketTypeCounts"])
                    this.ticketTypeCounts!.push(KeyValuePair_2OfInt32AndInt32.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActiveRequestsReport {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveRequestsReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        if (Array.isArray(this.openRequests)) {
            data["openRequests"] = [];
            for (let item of this.openRequests)
                data["openRequests"].push(item.toJSON());
        }
        data["companyName"] = this.companyName;
        if (Array.isArray(this.severityCounts)) {
            data["severityCounts"] = [];
            for (let item of this.severityCounts)
                data["severityCounts"].push(item.toJSON());
        }
        if (Array.isArray(this.ticketTypeCounts)) {
            data["ticketTypeCounts"] = [];
            for (let item of this.ticketTypeCounts)
                data["ticketTypeCounts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IActiveRequestsReport {
    accountId?: number;
    openRequests?: OpenRequests[] | undefined;
    companyName?: string | undefined;
    severityCounts?: KeyValuePair_2OfInt32AndInt32[] | undefined;
    ticketTypeCounts?: KeyValuePair_2OfInt32AndInt32[] | undefined;
}

export class AdminDashboardReports implements IAdminDashboardReports {
    responseStatus?: number;
    errorMessage?: string | undefined;
    requestsReports?: ActiveRequestsReport[] | undefined;
    threeMonthReport?: MonthReport[] | undefined;
    deviceReports?: DeviceReport;
    contractReports?: ContractReport;
    projectReports?: ProjectReport;

    constructor(data?: IAdminDashboardReports) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseStatus = _data["responseStatus"];
            this.errorMessage = _data["errorMessage"];
            if (Array.isArray(_data["requestsReports"])) {
                this.requestsReports = [] as any;
                for (let item of _data["requestsReports"])
                    this.requestsReports!.push(ActiveRequestsReport.fromJS(item));
            }
            if (Array.isArray(_data["threeMonthReport"])) {
                this.threeMonthReport = [] as any;
                for (let item of _data["threeMonthReport"])
                    this.threeMonthReport!.push(MonthReport.fromJS(item));
            }
            this.deviceReports = _data["deviceReports"] ? DeviceReport.fromJS(_data["deviceReports"]) : <any>undefined;
            this.contractReports = _data["contractReports"] ? ContractReport.fromJS(_data["contractReports"]) : <any>undefined;
            this.projectReports = _data["projectReports"] ? ProjectReport.fromJS(_data["projectReports"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AdminDashboardReports {
        data = typeof data === 'object' ? data : {};
        let result = new AdminDashboardReports();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseStatus"] = this.responseStatus;
        data["errorMessage"] = this.errorMessage;
        if (Array.isArray(this.requestsReports)) {
            data["requestsReports"] = [];
            for (let item of this.requestsReports)
                data["requestsReports"].push(item.toJSON());
        }
        if (Array.isArray(this.threeMonthReport)) {
            data["threeMonthReport"] = [];
            for (let item of this.threeMonthReport)
                data["threeMonthReport"].push(item.toJSON());
        }
        data["deviceReports"] = this.deviceReports ? this.deviceReports.toJSON() : <any>undefined;
        data["contractReports"] = this.contractReports ? this.contractReports.toJSON() : <any>undefined;
        data["projectReports"] = this.projectReports ? this.projectReports.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAdminDashboardReports {
    responseStatus?: number;
    errorMessage?: string | undefined;
    requestsReports?: ActiveRequestsReport[] | undefined;
    threeMonthReport?: MonthReport[] | undefined;
    deviceReports?: DeviceReport;
    contractReports?: ContractReport;
    projectReports?: ProjectReport;
}

export class AllServiceRequestsResponse implements IAllServiceRequestsResponse {
    resultInfo?: PagedResultData;
    resultData?: ServiceRequestDTO[] | undefined;
    resultContacts?: Contact[] | undefined;
    resultResources?: Resource[] | undefined;
    resultIssueTypes?: number[] | undefined;

    constructor(data?: IAllServiceRequestsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultInfo = _data["resultInfo"] ? PagedResultData.fromJS(_data["resultInfo"]) : <any>undefined;
            if (Array.isArray(_data["resultData"])) {
                this.resultData = [] as any;
                for (let item of _data["resultData"])
                    this.resultData!.push(ServiceRequestDTO.fromJS(item));
            }
            if (Array.isArray(_data["resultContacts"])) {
                this.resultContacts = [] as any;
                for (let item of _data["resultContacts"])
                    this.resultContacts!.push(Contact.fromJS(item));
            }
            if (Array.isArray(_data["resultResources"])) {
                this.resultResources = [] as any;
                for (let item of _data["resultResources"])
                    this.resultResources!.push(Resource.fromJS(item));
            }
            if (Array.isArray(_data["resultIssueTypes"])) {
                this.resultIssueTypes = [] as any;
                for (let item of _data["resultIssueTypes"])
                    this.resultIssueTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): AllServiceRequestsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AllServiceRequestsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultInfo"] = this.resultInfo ? this.resultInfo.toJSON() : <any>undefined;
        if (Array.isArray(this.resultData)) {
            data["resultData"] = [];
            for (let item of this.resultData)
                data["resultData"].push(item.toJSON());
        }
        if (Array.isArray(this.resultContacts)) {
            data["resultContacts"] = [];
            for (let item of this.resultContacts)
                data["resultContacts"].push(item.toJSON());
        }
        if (Array.isArray(this.resultResources)) {
            data["resultResources"] = [];
            for (let item of this.resultResources)
                data["resultResources"].push(item.toJSON());
        }
        if (Array.isArray(this.resultIssueTypes)) {
            data["resultIssueTypes"] = [];
            for (let item of this.resultIssueTypes)
                data["resultIssueTypes"].push(item);
        }
        return data;
    }
}

export interface IAllServiceRequestsResponse {
    resultInfo?: PagedResultData;
    resultData?: ServiceRequestDTO[] | undefined;
    resultContacts?: Contact[] | undefined;
    resultResources?: Resource[] | undefined;
    resultIssueTypes?: number[] | undefined;
}

export class ApprovalResponse implements IApprovalResponse {
    responseStatus?: number;
    message?: string | undefined;
    updatedUserProfiles?: UserProfile[] | undefined;
    updatedContacts?: Contact[] | undefined;

    constructor(data?: IApprovalResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseStatus = _data["responseStatus"];
            this.message = _data["message"];
            if (Array.isArray(_data["updatedUserProfiles"])) {
                this.updatedUserProfiles = [] as any;
                for (let item of _data["updatedUserProfiles"])
                    this.updatedUserProfiles!.push(UserProfile.fromJS(item));
            }
            if (Array.isArray(_data["updatedContacts"])) {
                this.updatedContacts = [] as any;
                for (let item of _data["updatedContacts"])
                    this.updatedContacts!.push(Contact.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApprovalResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovalResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseStatus"] = this.responseStatus;
        data["message"] = this.message;
        if (Array.isArray(this.updatedUserProfiles)) {
            data["updatedUserProfiles"] = [];
            for (let item of this.updatedUserProfiles)
                data["updatedUserProfiles"].push(item.toJSON());
        }
        if (Array.isArray(this.updatedContacts)) {
            data["updatedContacts"] = [];
            for (let item of this.updatedContacts)
                data["updatedContacts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IApprovalResponse {
    responseStatus?: number;
    message?: string | undefined;
    updatedUserProfiles?: UserProfile[] | undefined;
    updatedContacts?: Contact[] | undefined;
}

export class CloudAccount implements ICloudAccount {
    cloudAccountName?: string | undefined;
    cloud?: string | undefined;
    cloudAccountID?: string | undefined;
    cloudAccountCreateDate?: string | undefined;
    cloudAccountStatus?: string | undefined;
    userDefinedFieldsJson?: string | undefined;
    serviceLevel?: string | undefined;
    licenseCount?: number;
    configurationItem?: ConfigurationItem;
    account?: Account;
    contractId?: number;
    configurationItemId?: number;

    constructor(data?: ICloudAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cloudAccountName = _data["cloudAccountName"];
            this.cloud = _data["cloud"];
            this.cloudAccountID = _data["cloudAccountID"];
            this.cloudAccountCreateDate = _data["cloudAccountCreateDate"];
            this.cloudAccountStatus = _data["cloudAccountStatus"];
            this.userDefinedFieldsJson = _data["userDefinedFieldsJson"];
            this.serviceLevel = _data["serviceLevel"];
            this.licenseCount = _data["licenseCount"];
            this.configurationItem = _data["configurationItem"] ? ConfigurationItem.fromJS(_data["configurationItem"]) : <any>undefined;
            this.account = _data["account"] ? Account.fromJS(_data["account"]) : <any>undefined;
            this.contractId = _data["contractId"];
            this.configurationItemId = _data["configurationItemId"];
        }
    }

    static fromJS(data: any): CloudAccount {
        data = typeof data === 'object' ? data : {};
        let result = new CloudAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cloudAccountName"] = this.cloudAccountName;
        data["cloud"] = this.cloud;
        data["cloudAccountID"] = this.cloudAccountID;
        data["cloudAccountCreateDate"] = this.cloudAccountCreateDate;
        data["cloudAccountStatus"] = this.cloudAccountStatus;
        data["userDefinedFieldsJson"] = this.userDefinedFieldsJson;
        data["serviceLevel"] = this.serviceLevel;
        data["licenseCount"] = this.licenseCount;
        data["configurationItem"] = this.configurationItem ? this.configurationItem.toJSON() : <any>undefined;
        data["account"] = this.account ? this.account.toJSON() : <any>undefined;
        data["contractId"] = this.contractId;
        data["configurationItemId"] = this.configurationItemId;
        return data;
    }
}

export interface ICloudAccount {
    cloudAccountName?: string | undefined;
    cloud?: string | undefined;
    cloudAccountID?: string | undefined;
    cloudAccountCreateDate?: string | undefined;
    cloudAccountStatus?: string | undefined;
    userDefinedFieldsJson?: string | undefined;
    serviceLevel?: string | undefined;
    licenseCount?: number;
    configurationItem?: ConfigurationItem;
    account?: Account;
    contractId?: number;
    configurationItemId?: number;
}

export class ConfigurationItemCacheResponse implements IConfigurationItemCacheResponse {
    configurationItem?: ConfigurationItem;
    configurationItemId?: number | undefined;
    responseStatus?: number;
    message?: string | undefined;
    syncErrorOccurred?: boolean;
    syncErrorMessage?: string | undefined;

    constructor(data?: IConfigurationItemCacheResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configurationItem = _data["configurationItem"] ? ConfigurationItem.fromJS(_data["configurationItem"]) : <any>undefined;
            this.configurationItemId = _data["configurationItemId"];
            this.responseStatus = _data["responseStatus"];
            this.message = _data["message"];
            this.syncErrorOccurred = _data["syncErrorOccurred"];
            this.syncErrorMessage = _data["syncErrorMessage"];
        }
    }

    static fromJS(data: any): ConfigurationItemCacheResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationItemCacheResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configurationItem"] = this.configurationItem ? this.configurationItem.toJSON() : <any>undefined;
        data["configurationItemId"] = this.configurationItemId;
        data["responseStatus"] = this.responseStatus;
        data["message"] = this.message;
        data["syncErrorOccurred"] = this.syncErrorOccurred;
        data["syncErrorMessage"] = this.syncErrorMessage;
        return data;
    }
}

export interface IConfigurationItemCacheResponse {
    configurationItem?: ConfigurationItem;
    configurationItemId?: number | undefined;
    responseStatus?: number;
    message?: string | undefined;
    syncErrorOccurred?: boolean;
    syncErrorMessage?: string | undefined;
}

export class ConfigurationItemsCacheResponse implements IConfigurationItemsCacheResponse {
    createdConfigurationItems?: ConfigurationItem[] | undefined;
    updatedConfigurationItems?: ConfigurationItem[] | undefined;
    inactivatedConfigurationItems?: ConfigurationItem[] | undefined;
    configurationItemIds?: number[] | undefined;
    responseStatus?: number;
    message?: string | undefined;
    syncErrorOccurred?: boolean;
    syncErrorMessage?: string | undefined;

    constructor(data?: IConfigurationItemsCacheResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["createdConfigurationItems"])) {
                this.createdConfigurationItems = [] as any;
                for (let item of _data["createdConfigurationItems"])
                    this.createdConfigurationItems!.push(ConfigurationItem.fromJS(item));
            }
            if (Array.isArray(_data["updatedConfigurationItems"])) {
                this.updatedConfigurationItems = [] as any;
                for (let item of _data["updatedConfigurationItems"])
                    this.updatedConfigurationItems!.push(ConfigurationItem.fromJS(item));
            }
            if (Array.isArray(_data["inactivatedConfigurationItems"])) {
                this.inactivatedConfigurationItems = [] as any;
                for (let item of _data["inactivatedConfigurationItems"])
                    this.inactivatedConfigurationItems!.push(ConfigurationItem.fromJS(item));
            }
            if (Array.isArray(_data["configurationItemIds"])) {
                this.configurationItemIds = [] as any;
                for (let item of _data["configurationItemIds"])
                    this.configurationItemIds!.push(item);
            }
            this.responseStatus = _data["responseStatus"];
            this.message = _data["message"];
            this.syncErrorOccurred = _data["syncErrorOccurred"];
            this.syncErrorMessage = _data["syncErrorMessage"];
        }
    }

    static fromJS(data: any): ConfigurationItemsCacheResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationItemsCacheResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.createdConfigurationItems)) {
            data["createdConfigurationItems"] = [];
            for (let item of this.createdConfigurationItems)
                data["createdConfigurationItems"].push(item.toJSON());
        }
        if (Array.isArray(this.updatedConfigurationItems)) {
            data["updatedConfigurationItems"] = [];
            for (let item of this.updatedConfigurationItems)
                data["updatedConfigurationItems"].push(item.toJSON());
        }
        if (Array.isArray(this.inactivatedConfigurationItems)) {
            data["inactivatedConfigurationItems"] = [];
            for (let item of this.inactivatedConfigurationItems)
                data["inactivatedConfigurationItems"].push(item.toJSON());
        }
        if (Array.isArray(this.configurationItemIds)) {
            data["configurationItemIds"] = [];
            for (let item of this.configurationItemIds)
                data["configurationItemIds"].push(item);
        }
        data["responseStatus"] = this.responseStatus;
        data["message"] = this.message;
        data["syncErrorOccurred"] = this.syncErrorOccurred;
        data["syncErrorMessage"] = this.syncErrorMessage;
        return data;
    }
}

export interface IConfigurationItemsCacheResponse {
    createdConfigurationItems?: ConfigurationItem[] | undefined;
    updatedConfigurationItems?: ConfigurationItem[] | undefined;
    inactivatedConfigurationItems?: ConfigurationItem[] | undefined;
    configurationItemIds?: number[] | undefined;
    responseStatus?: number;
    message?: string | undefined;
    syncErrorOccurred?: boolean;
    syncErrorMessage?: string | undefined;
}

export class ContractCacheResponse implements IContractCacheResponse {
    contract?: ContractModel;
    contractID?: number | undefined;
    responseStatus?: number | undefined;
    errorMessage?: string | undefined;
    shiOneContract?: Contract;
    contracts?: Contract[] | undefined;
    simpleCloudContracts?: SimpleCloudContract[] | undefined;
    contractServices?: ContractServiceRecord[] | undefined;
    services?: ServiceRecord[] | undefined;

    constructor(data?: IContractCacheResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contract = _data["contract"] ? ContractModel.fromJS(_data["contract"]) : <any>undefined;
            this.contractID = _data["contractID"];
            this.responseStatus = _data["responseStatus"];
            this.errorMessage = _data["errorMessage"];
            this.shiOneContract = _data["shiOneContract"] ? Contract.fromJS(_data["shiOneContract"]) : <any>undefined;
            if (Array.isArray(_data["contracts"])) {
                this.contracts = [] as any;
                for (let item of _data["contracts"])
                    this.contracts!.push(Contract.fromJS(item));
            }
            if (Array.isArray(_data["simpleCloudContracts"])) {
                this.simpleCloudContracts = [] as any;
                for (let item of _data["simpleCloudContracts"])
                    this.simpleCloudContracts!.push(SimpleCloudContract.fromJS(item));
            }
            if (Array.isArray(_data["contractServices"])) {
                this.contractServices = [] as any;
                for (let item of _data["contractServices"])
                    this.contractServices!.push(ContractServiceRecord.fromJS(item));
            }
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(ServiceRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContractCacheResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ContractCacheResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contract"] = this.contract ? this.contract.toJSON() : <any>undefined;
        data["contractID"] = this.contractID;
        data["responseStatus"] = this.responseStatus;
        data["errorMessage"] = this.errorMessage;
        data["shiOneContract"] = this.shiOneContract ? this.shiOneContract.toJSON() : <any>undefined;
        if (Array.isArray(this.contracts)) {
            data["contracts"] = [];
            for (let item of this.contracts)
                data["contracts"].push(item.toJSON());
        }
        if (Array.isArray(this.simpleCloudContracts)) {
            data["simpleCloudContracts"] = [];
            for (let item of this.simpleCloudContracts)
                data["simpleCloudContracts"].push(item.toJSON());
        }
        if (Array.isArray(this.contractServices)) {
            data["contractServices"] = [];
            for (let item of this.contractServices)
                data["contractServices"].push(item.toJSON());
        }
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item.toJSON());
        }
        return data;
    }
}

export interface IContractCacheResponse {
    contract?: ContractModel;
    contractID?: number | undefined;
    responseStatus?: number | undefined;
    errorMessage?: string | undefined;
    shiOneContract?: Contract;
    contracts?: Contract[] | undefined;
    simpleCloudContracts?: SimpleCloudContract[] | undefined;
    contractServices?: ContractServiceRecord[] | undefined;
    services?: ServiceRecord[] | undefined;
}

export class ContractModel implements IContractModel {
    systemGuid!: string;
    cloudSourceId!: string;
    cloudAccountName!: string;
    axNumber!: number;
    autotaskAccountId!: number;
    autotaskContractId?: number | undefined;
    contractCategory!: string;
    parentSystemGuid?: string | undefined;
    startDate!: Date;
    endDate?: Date;
    serviceLevelAgreement!: string;
    active!: boolean;

    constructor(data?: IContractModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.systemGuid = _data["systemGuid"];
            this.cloudSourceId = _data["cloudSourceId"];
            this.cloudAccountName = _data["cloudAccountName"];
            this.axNumber = _data["axNumber"];
            this.autotaskAccountId = _data["autotaskAccountId"];
            this.autotaskContractId = _data["autotaskContractId"];
            this.contractCategory = _data["contractCategory"];
            this.parentSystemGuid = _data["parentSystemGuid"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.serviceLevelAgreement = _data["serviceLevelAgreement"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): ContractModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContractModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["systemGuid"] = this.systemGuid;
        data["cloudSourceId"] = this.cloudSourceId;
        data["cloudAccountName"] = this.cloudAccountName;
        data["axNumber"] = this.axNumber;
        data["autotaskAccountId"] = this.autotaskAccountId;
        data["autotaskContractId"] = this.autotaskContractId;
        data["contractCategory"] = this.contractCategory;
        data["parentSystemGuid"] = this.parentSystemGuid;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["serviceLevelAgreement"] = this.serviceLevelAgreement;
        data["active"] = this.active;
        return data;
    }
}

export interface IContractModel {
    systemGuid: string;
    cloudSourceId: string;
    cloudAccountName: string;
    axNumber: number;
    autotaskAccountId: number;
    autotaskContractId?: number | undefined;
    contractCategory: string;
    parentSystemGuid?: string | undefined;
    startDate: Date;
    endDate?: Date;
    serviceLevelAgreement: string;
    active: boolean;
}

export class ContractSchema implements IContractSchema {
    title?: string | undefined;
    description?: string | undefined;
    properties?: ContractSchema_ContractDetails;
    required?: string[] | undefined;

    constructor(data?: IContractSchema) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.properties = _data["properties"] ? ContractSchema_ContractDetails.fromJS(_data["properties"]) : <any>undefined;
            if (Array.isArray(_data["required"])) {
                this.required = [] as any;
                for (let item of _data["required"])
                    this.required!.push(item);
            }
        }
    }

    static fromJS(data: any): ContractSchema {
        data = typeof data === 'object' ? data : {};
        let result = new ContractSchema();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["properties"] = this.properties ? this.properties.toJSON() : <any>undefined;
        if (Array.isArray(this.required)) {
            data["required"] = [];
            for (let item of this.required)
                data["required"].push(item);
        }
        return data;
    }
}

export interface IContractSchema {
    title?: string | undefined;
    description?: string | undefined;
    properties?: ContractSchema_ContractDetails;
    required?: string[] | undefined;
}

export class ContractSchema_ContractDetails implements IContractSchema_ContractDetails {
    systemGuid!: ContractSchema_ContractDetails_Details;
    parentSystemGuid?: ContractSchema_ContractDetails_Details;
    cloudSourceId!: ContractSchema_ContractDetails_Details;
    cloudAccountName!: ContractSchema_ContractDetails_Details;
    axNumber!: ContractSchema_ContractDetails_Details;
    autotaskAccountId!: ContractSchema_ContractDetails_Details;
    contractCategory!: ContractSchema_ContractDetails_Details;
    startDate!: ContractSchema_ContractDetails_Details;
    endDate?: ContractSchema_ContractDetails_Details;
    serviceLevelAgreement!: ContractSchema_ContractDetails_Details;
    cloudAccountActive?: ContractSchema_ContractDetails_Details;

    constructor(data?: IContractSchema_ContractDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.systemGuid = new ContractSchema_ContractDetails_Details();
            this.cloudSourceId = new ContractSchema_ContractDetails_Details();
            this.cloudAccountName = new ContractSchema_ContractDetails_Details();
            this.axNumber = new ContractSchema_ContractDetails_Details();
            this.autotaskAccountId = new ContractSchema_ContractDetails_Details();
            this.contractCategory = new ContractSchema_ContractDetails_Details();
            this.startDate = new ContractSchema_ContractDetails_Details();
            this.serviceLevelAgreement = new ContractSchema_ContractDetails_Details();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.systemGuid = _data["systemGuid"] ? ContractSchema_ContractDetails_Details.fromJS(_data["systemGuid"]) : new ContractSchema_ContractDetails_Details();
            this.parentSystemGuid = _data["parentSystemGuid"] ? ContractSchema_ContractDetails_Details.fromJS(_data["parentSystemGuid"]) : <any>undefined;
            this.cloudSourceId = _data["cloudSourceId"] ? ContractSchema_ContractDetails_Details.fromJS(_data["cloudSourceId"]) : new ContractSchema_ContractDetails_Details();
            this.cloudAccountName = _data["cloudAccountName"] ? ContractSchema_ContractDetails_Details.fromJS(_data["cloudAccountName"]) : new ContractSchema_ContractDetails_Details();
            this.axNumber = _data["axNumber"] ? ContractSchema_ContractDetails_Details.fromJS(_data["axNumber"]) : new ContractSchema_ContractDetails_Details();
            this.autotaskAccountId = _data["autotaskAccountId"] ? ContractSchema_ContractDetails_Details.fromJS(_data["autotaskAccountId"]) : new ContractSchema_ContractDetails_Details();
            this.contractCategory = _data["contractCategory"] ? ContractSchema_ContractDetails_Details.fromJS(_data["contractCategory"]) : new ContractSchema_ContractDetails_Details();
            this.startDate = _data["startDate"] ? ContractSchema_ContractDetails_Details.fromJS(_data["startDate"]) : new ContractSchema_ContractDetails_Details();
            this.endDate = _data["endDate"] ? ContractSchema_ContractDetails_Details.fromJS(_data["endDate"]) : <any>undefined;
            this.serviceLevelAgreement = _data["serviceLevelAgreement"] ? ContractSchema_ContractDetails_Details.fromJS(_data["serviceLevelAgreement"]) : new ContractSchema_ContractDetails_Details();
            this.cloudAccountActive = _data["cloudAccountActive"] ? ContractSchema_ContractDetails_Details.fromJS(_data["cloudAccountActive"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ContractSchema_ContractDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ContractSchema_ContractDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["systemGuid"] = this.systemGuid ? this.systemGuid.toJSON() : <any>undefined;
        data["parentSystemGuid"] = this.parentSystemGuid ? this.parentSystemGuid.toJSON() : <any>undefined;
        data["cloudSourceId"] = this.cloudSourceId ? this.cloudSourceId.toJSON() : <any>undefined;
        data["cloudAccountName"] = this.cloudAccountName ? this.cloudAccountName.toJSON() : <any>undefined;
        data["axNumber"] = this.axNumber ? this.axNumber.toJSON() : <any>undefined;
        data["autotaskAccountId"] = this.autotaskAccountId ? this.autotaskAccountId.toJSON() : <any>undefined;
        data["contractCategory"] = this.contractCategory ? this.contractCategory.toJSON() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toJSON() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toJSON() : <any>undefined;
        data["serviceLevelAgreement"] = this.serviceLevelAgreement ? this.serviceLevelAgreement.toJSON() : <any>undefined;
        data["cloudAccountActive"] = this.cloudAccountActive ? this.cloudAccountActive.toJSON() : <any>undefined;
        return data;
    }
}

export interface IContractSchema_ContractDetails {
    systemGuid: ContractSchema_ContractDetails_Details;
    parentSystemGuid?: ContractSchema_ContractDetails_Details;
    cloudSourceId: ContractSchema_ContractDetails_Details;
    cloudAccountName: ContractSchema_ContractDetails_Details;
    axNumber: ContractSchema_ContractDetails_Details;
    autotaskAccountId: ContractSchema_ContractDetails_Details;
    contractCategory: ContractSchema_ContractDetails_Details;
    startDate: ContractSchema_ContractDetails_Details;
    endDate?: ContractSchema_ContractDetails_Details;
    serviceLevelAgreement: ContractSchema_ContractDetails_Details;
    cloudAccountActive?: ContractSchema_ContractDetails_Details;
}

export class ContractSchema_ContractDetails_Details implements IContractSchema_ContractDetails_Details {
    description?: string | undefined;
    type?: string | undefined;
    enum?: string[] | undefined;

    constructor(data?: IContractSchema_ContractDetails_Details) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.type = _data["type"];
            if (Array.isArray(_data["enum"])) {
                this.enum = [] as any;
                for (let item of _data["enum"])
                    this.enum!.push(item);
            }
        }
    }

    static fromJS(data: any): ContractSchema_ContractDetails_Details {
        data = typeof data === 'object' ? data : {};
        let result = new ContractSchema_ContractDetails_Details();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["type"] = this.type;
        if (Array.isArray(this.enum)) {
            data["enum"] = [];
            for (let item of this.enum)
                data["enum"].push(item);
        }
        return data;
    }
}

export interface IContractSchema_ContractDetails_Details {
    description?: string | undefined;
    type?: string | undefined;
    enum?: string[] | undefined;
}

export class CreateGuestUserProfile implements ICreateGuestUserProfile {
    accountId?: number;
    emailAddress?: string | undefined;

    constructor(data?: ICreateGuestUserProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): CreateGuestUserProfile {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGuestUserProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ICreateGuestUserProfile {
    accountId?: number;
    emailAddress?: string | undefined;
}

export class CreateProfile implements ICreateProfile {
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    extension?: string | undefined;

    constructor(data?: ICreateProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.extension = _data["extension"];
        }
    }

    static fromJS(data: any): CreateProfile {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["extension"] = this.extension;
        return data;
    }
}

export interface ICreateProfile {
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    extension?: string | undefined;
}

export class CreateTeam implements ICreateTeam {
    teamName?: string | undefined;
    accountId?: number;

    constructor(data?: ICreateTeam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamName = _data["teamName"];
            this.accountId = _data["accountId"];
        }
    }

    static fromJS(data: any): CreateTeam {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTeam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamName"] = this.teamName;
        data["accountId"] = this.accountId;
        return data;
    }
}

export interface ICreateTeam {
    teamName?: string | undefined;
    accountId?: number;
}

export class CustomerAccountMapping implements ICustomerAccountMapping {
    axAccountNo?: string | undefined;
    companyName?: string | undefined;
    payerAccountId?: string | undefined;

    constructor(data?: ICustomerAccountMapping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.axAccountNo = _data["axAccountNo"];
            this.companyName = _data["companyName"];
            this.payerAccountId = _data["payerAccountId"];
        }
    }

    static fromJS(data: any): CustomerAccountMapping {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAccountMapping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccountNo"] = this.axAccountNo;
        data["companyName"] = this.companyName;
        data["payerAccountId"] = this.payerAccountId;
        return data;
    }
}

export interface ICustomerAccountMapping {
    axAccountNo?: string | undefined;
    companyName?: string | undefined;
    payerAccountId?: string | undefined;
}

export class CustomerAccountMappingResponse implements ICustomerAccountMappingResponse {
    customerAccountMappings?: CustomerAccountMapping[] | undefined;

    constructor(data?: ICustomerAccountMappingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["customerAccountMappings"])) {
                this.customerAccountMappings = [] as any;
                for (let item of _data["customerAccountMappings"])
                    this.customerAccountMappings!.push(CustomerAccountMapping.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerAccountMappingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAccountMappingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.customerAccountMappings)) {
            data["customerAccountMappings"] = [];
            for (let item of this.customerAccountMappings)
                data["customerAccountMappings"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomerAccountMappingResponse {
    customerAccountMappings?: CustomerAccountMapping[] | undefined;
}

export enum ELinkType2 {
    Article = "Article",
    Image = "Image",
    Video = "Video",
}

export class EmailVerificationRequest implements IEmailVerificationRequest {
    guid?: string | undefined;
    email?: string | undefined;
    code?: number;

    constructor(data?: IEmailVerificationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.email = _data["email"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): EmailVerificationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EmailVerificationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["email"] = this.email;
        data["code"] = this.code;
        return data;
    }
}

export interface IEmailVerificationRequest {
    guid?: string | undefined;
    email?: string | undefined;
    code?: number;
}

export class FSACacheResponse implements IFSACacheResponse {
    responseStatus?: number | undefined;
    errorMessage?: string | undefined;
    flexibleServicesAgreements?: FlexibleServicesAgreementDTO[] | undefined;

    constructor(data?: IFSACacheResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseStatus = _data["responseStatus"];
            this.errorMessage = _data["errorMessage"];
            if (Array.isArray(_data["flexibleServicesAgreements"])) {
                this.flexibleServicesAgreements = [] as any;
                for (let item of _data["flexibleServicesAgreements"])
                    this.flexibleServicesAgreements!.push(FlexibleServicesAgreementDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FSACacheResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FSACacheResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseStatus"] = this.responseStatus;
        data["errorMessage"] = this.errorMessage;
        if (Array.isArray(this.flexibleServicesAgreements)) {
            data["flexibleServicesAgreements"] = [];
            for (let item of this.flexibleServicesAgreements)
                data["flexibleServicesAgreements"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFSACacheResponse {
    responseStatus?: number | undefined;
    errorMessage?: string | undefined;
    flexibleServicesAgreements?: FlexibleServicesAgreementDTO[] | undefined;
}

export class GuestUserProfile implements IGuestUserProfile {
    accountId?: number | undefined;
    emailAddress?: string | undefined;
    isGuestUser?: boolean;

    constructor(data?: IGuestUserProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.emailAddress = _data["emailAddress"];
            this.isGuestUser = _data["isGuestUser"];
        }
    }

    static fromJS(data: any): GuestUserProfile {
        data = typeof data === 'object' ? data : {};
        let result = new GuestUserProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["emailAddress"] = this.emailAddress;
        data["isGuestUser"] = this.isGuestUser;
        return data;
    }
}

export interface IGuestUserProfile {
    accountId?: number | undefined;
    emailAddress?: string | undefined;
    isGuestUser?: boolean;
}

export class Lab implements ILab {
    id?: number;
    productName?: string | undefined;
    practice?: string[] | undefined;
    platform?: string[] | undefined;
    labLinks?: LabLink[] | undefined;
    partners?: PartnerLogo[] | undefined;
    overview?: string | undefined;
    deliverables?: string | undefined;
    technology?: string | undefined;
    duration?: string | undefined;

    constructor(data?: ILab) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productName = _data["productName"];
            if (Array.isArray(_data["practice"])) {
                this.practice = [] as any;
                for (let item of _data["practice"])
                    this.practice!.push(item);
            }
            if (Array.isArray(_data["platform"])) {
                this.platform = [] as any;
                for (let item of _data["platform"])
                    this.platform!.push(item);
            }
            if (Array.isArray(_data["labLinks"])) {
                this.labLinks = [] as any;
                for (let item of _data["labLinks"])
                    this.labLinks!.push(LabLink.fromJS(item));
            }
            if (Array.isArray(_data["partners"])) {
                this.partners = [] as any;
                for (let item of _data["partners"])
                    this.partners!.push(PartnerLogo.fromJS(item));
            }
            this.overview = _data["overview"];
            this.deliverables = _data["deliverables"];
            this.technology = _data["technology"];
            this.duration = _data["duration"];
        }
    }

    static fromJS(data: any): Lab {
        data = typeof data === 'object' ? data : {};
        let result = new Lab();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productName"] = this.productName;
        if (Array.isArray(this.practice)) {
            data["practice"] = [];
            for (let item of this.practice)
                data["practice"].push(item);
        }
        if (Array.isArray(this.platform)) {
            data["platform"] = [];
            for (let item of this.platform)
                data["platform"].push(item);
        }
        if (Array.isArray(this.labLinks)) {
            data["labLinks"] = [];
            for (let item of this.labLinks)
                data["labLinks"].push(item.toJSON());
        }
        if (Array.isArray(this.partners)) {
            data["partners"] = [];
            for (let item of this.partners)
                data["partners"].push(item.toJSON());
        }
        data["overview"] = this.overview;
        data["deliverables"] = this.deliverables;
        data["technology"] = this.technology;
        data["duration"] = this.duration;
        return data;
    }
}

export interface ILab {
    id?: number;
    productName?: string | undefined;
    practice?: string[] | undefined;
    platform?: string[] | undefined;
    labLinks?: LabLink[] | undefined;
    partners?: PartnerLogo[] | undefined;
    overview?: string | undefined;
    deliverables?: string | undefined;
    technology?: string | undefined;
    duration?: string | undefined;
}

export class LabLink implements ILabLink {
    id?: number;
    linkCaption?: string | undefined;
    description?: string | undefined;
    link?: string | undefined;
    linkType?: ELinkType2;

    constructor(data?: ILabLink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.linkCaption = _data["linkCaption"];
            this.description = _data["description"];
            this.link = _data["link"];
            this.linkType = _data["linkType"];
        }
    }

    static fromJS(data: any): LabLink {
        data = typeof data === 'object' ? data : {};
        let result = new LabLink();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["linkCaption"] = this.linkCaption;
        data["description"] = this.description;
        data["link"] = this.link;
        data["linkType"] = this.linkType;
        return data;
    }
}

export interface ILabLink {
    id?: number;
    linkCaption?: string | undefined;
    description?: string | undefined;
    link?: string | undefined;
    linkType?: ELinkType2;
}

export class LinkedAccount_CancelRequest implements ILinkedAccount_CancelRequest {
    operationId!: string;
    payerAccountId!: string;
    requesterEmail!: string;
    autotaskAccountId!: number;
    autotaskContractId!: number;
    cancelNotes?: string | undefined;
    cancelAccountId?: string | undefined;
    cancelEmail?: string | undefined;

    constructor(data?: ILinkedAccount_CancelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operationId = _data["operationId"];
            this.payerAccountId = _data["payerAccountId"];
            this.requesterEmail = _data["requesterEmail"];
            this.autotaskAccountId = _data["autotaskAccountId"];
            this.autotaskContractId = _data["autotaskContractId"];
            this.cancelNotes = _data["cancelNotes"];
            this.cancelAccountId = _data["cancelAccountId"];
            this.cancelEmail = _data["cancelEmail"];
        }
    }

    static fromJS(data: any): LinkedAccount_CancelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedAccount_CancelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operationId"] = this.operationId;
        data["payerAccountId"] = this.payerAccountId;
        data["requesterEmail"] = this.requesterEmail;
        data["autotaskAccountId"] = this.autotaskAccountId;
        data["autotaskContractId"] = this.autotaskContractId;
        data["cancelNotes"] = this.cancelNotes;
        data["cancelAccountId"] = this.cancelAccountId;
        data["cancelEmail"] = this.cancelEmail;
        return data;
    }
}

export interface ILinkedAccount_CancelRequest {
    operationId: string;
    payerAccountId: string;
    requesterEmail: string;
    autotaskAccountId: number;
    autotaskContractId: number;
    cancelNotes?: string | undefined;
    cancelAccountId?: string | undefined;
    cancelEmail?: string | undefined;
}

export class LinkedAccount_CompleteCancelRequest implements ILinkedAccount_CompleteCancelRequest {
    operationId?: string | undefined;

    constructor(data?: ILinkedAccount_CompleteCancelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operationId = _data["operationId"];
        }
    }

    static fromJS(data: any): LinkedAccount_CompleteCancelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedAccount_CompleteCancelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operationId"] = this.operationId;
        return data;
    }
}

export interface ILinkedAccount_CompleteCancelRequest {
    operationId?: string | undefined;
}

export class LinkedAccount_CreateRequest implements ILinkedAccount_CreateRequest {
    serviceDescription!: string;
    autotaskAccountId!: number;
    autotaskContractId!: number;
    requesterEmail!: string;
    payerAccountId!: string;
    newAccountName!: string;
    newAccountEmail!: string;

    constructor(data?: ILinkedAccount_CreateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceDescription = _data["serviceDescription"];
            this.autotaskAccountId = _data["autotaskAccountId"];
            this.autotaskContractId = _data["autotaskContractId"];
            this.requesterEmail = _data["requesterEmail"];
            this.payerAccountId = _data["payerAccountId"];
            this.newAccountName = _data["newAccountName"];
            this.newAccountEmail = _data["newAccountEmail"];
        }
    }

    static fromJS(data: any): LinkedAccount_CreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedAccount_CreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceDescription"] = this.serviceDescription;
        data["autotaskAccountId"] = this.autotaskAccountId;
        data["autotaskContractId"] = this.autotaskContractId;
        data["requesterEmail"] = this.requesterEmail;
        data["payerAccountId"] = this.payerAccountId;
        data["newAccountName"] = this.newAccountName;
        data["newAccountEmail"] = this.newAccountEmail;
        return data;
    }
}

export interface ILinkedAccount_CreateRequest {
    serviceDescription: string;
    autotaskAccountId: number;
    autotaskContractId: number;
    requesterEmail: string;
    payerAccountId: string;
    newAccountName: string;
    newAccountEmail: string;
}

export class LinkedAccount_InviteRequest implements ILinkedAccount_InviteRequest {
    serviceDescription!: string;
    autotaskAccountId!: number;
    autotaskContractId!: number;
    requesterEmail!: string;
    payerAccountId!: string;
    invitationNotes?: string | undefined;
    inviteAccountId?: string | undefined;
    inviteAccountEmail?: string | undefined;

    constructor(data?: ILinkedAccount_InviteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceDescription = _data["serviceDescription"];
            this.autotaskAccountId = _data["autotaskAccountId"];
            this.autotaskContractId = _data["autotaskContractId"];
            this.requesterEmail = _data["requesterEmail"];
            this.payerAccountId = _data["payerAccountId"];
            this.invitationNotes = _data["invitationNotes"];
            this.inviteAccountId = _data["inviteAccountId"];
            this.inviteAccountEmail = _data["inviteAccountEmail"];
        }
    }

    static fromJS(data: any): LinkedAccount_InviteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedAccount_InviteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceDescription"] = this.serviceDescription;
        data["autotaskAccountId"] = this.autotaskAccountId;
        data["autotaskContractId"] = this.autotaskContractId;
        data["requesterEmail"] = this.requesterEmail;
        data["payerAccountId"] = this.payerAccountId;
        data["invitationNotes"] = this.invitationNotes;
        data["inviteAccountId"] = this.inviteAccountId;
        data["inviteAccountEmail"] = this.inviteAccountEmail;
        return data;
    }
}

export interface ILinkedAccount_InviteRequest {
    serviceDescription: string;
    autotaskAccountId: number;
    autotaskContractId: number;
    requesterEmail: string;
    payerAccountId: string;
    invitationNotes?: string | undefined;
    inviteAccountId?: string | undefined;
    inviteAccountEmail?: string | undefined;
}

export class LinkedAccount_StatusRequest implements ILinkedAccount_StatusRequest {
    autotaskAccountId!: number;
    autotaskContractId!: number;
    requesterEmail!: string;
    payerAccountId!: string;
    operationId?: string | undefined;
    inviteAccountId?: string | undefined;
    inviteAccountEmail?: string | undefined;
    newAccountName?: string | undefined;
    newAccountEmail?: string | undefined;

    constructor(data?: ILinkedAccount_StatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.autotaskAccountId = _data["autotaskAccountId"];
            this.autotaskContractId = _data["autotaskContractId"];
            this.requesterEmail = _data["requesterEmail"];
            this.payerAccountId = _data["payerAccountId"];
            this.operationId = _data["operationId"];
            this.inviteAccountId = _data["inviteAccountId"];
            this.inviteAccountEmail = _data["inviteAccountEmail"];
            this.newAccountName = _data["newAccountName"];
            this.newAccountEmail = _data["newAccountEmail"];
        }
    }

    static fromJS(data: any): LinkedAccount_StatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedAccount_StatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["autotaskAccountId"] = this.autotaskAccountId;
        data["autotaskContractId"] = this.autotaskContractId;
        data["requesterEmail"] = this.requesterEmail;
        data["payerAccountId"] = this.payerAccountId;
        data["operationId"] = this.operationId;
        data["inviteAccountId"] = this.inviteAccountId;
        data["inviteAccountEmail"] = this.inviteAccountEmail;
        data["newAccountName"] = this.newAccountName;
        data["newAccountEmail"] = this.newAccountEmail;
        return data;
    }
}

export interface ILinkedAccount_StatusRequest {
    autotaskAccountId: number;
    autotaskContractId: number;
    requesterEmail: string;
    payerAccountId: string;
    operationId?: string | undefined;
    inviteAccountId?: string | undefined;
    inviteAccountEmail?: string | undefined;
    newAccountName?: string | undefined;
    newAccountEmail?: string | undefined;
}

export class LinkedAccountResponse implements ILinkedAccountResponse {
    accountInviteResponse?: LinkedAccountResponse_InviteResponse;
    accountCreateResponse?: LinkedAccountResponse_CreateResponse;
    accountStatusResponse?: LinkedAccountResponse_StatusResponse;
    accountCancelResponse?: LinkedAccountResponse_CancelResponse;
    accountCompleteCancelResponse?: LinkedAccountResponse_CompleteCancelResponse;
    responseStatus?: number;
    errorMessage?: string | undefined;
    logEventId?: number;

    constructor(data?: ILinkedAccountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountInviteResponse = _data["accountInviteResponse"] ? LinkedAccountResponse_InviteResponse.fromJS(_data["accountInviteResponse"]) : <any>undefined;
            this.accountCreateResponse = _data["accountCreateResponse"] ? LinkedAccountResponse_CreateResponse.fromJS(_data["accountCreateResponse"]) : <any>undefined;
            this.accountStatusResponse = _data["accountStatusResponse"] ? LinkedAccountResponse_StatusResponse.fromJS(_data["accountStatusResponse"]) : <any>undefined;
            this.accountCancelResponse = _data["accountCancelResponse"] ? LinkedAccountResponse_CancelResponse.fromJS(_data["accountCancelResponse"]) : <any>undefined;
            this.accountCompleteCancelResponse = _data["accountCompleteCancelResponse"] ? LinkedAccountResponse_CompleteCancelResponse.fromJS(_data["accountCompleteCancelResponse"]) : <any>undefined;
            this.responseStatus = _data["responseStatus"];
            this.errorMessage = _data["errorMessage"];
            this.logEventId = _data["logEventId"];
        }
    }

    static fromJS(data: any): LinkedAccountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedAccountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountInviteResponse"] = this.accountInviteResponse ? this.accountInviteResponse.toJSON() : <any>undefined;
        data["accountCreateResponse"] = this.accountCreateResponse ? this.accountCreateResponse.toJSON() : <any>undefined;
        data["accountStatusResponse"] = this.accountStatusResponse ? this.accountStatusResponse.toJSON() : <any>undefined;
        data["accountCancelResponse"] = this.accountCancelResponse ? this.accountCancelResponse.toJSON() : <any>undefined;
        data["accountCompleteCancelResponse"] = this.accountCompleteCancelResponse ? this.accountCompleteCancelResponse.toJSON() : <any>undefined;
        data["responseStatus"] = this.responseStatus;
        data["errorMessage"] = this.errorMessage;
        data["logEventId"] = this.logEventId;
        return data;
    }
}

export interface ILinkedAccountResponse {
    accountInviteResponse?: LinkedAccountResponse_InviteResponse;
    accountCreateResponse?: LinkedAccountResponse_CreateResponse;
    accountStatusResponse?: LinkedAccountResponse_StatusResponse;
    accountCancelResponse?: LinkedAccountResponse_CancelResponse;
    accountCompleteCancelResponse?: LinkedAccountResponse_CompleteCancelResponse;
    responseStatus?: number;
    errorMessage?: string | undefined;
    logEventId?: number;
}

export class LinkedAccountResponse_AllStatusesResponse implements ILinkedAccountResponse_AllStatusesResponse {
    errorMessage?: string | undefined;
    responseStatus?: number | undefined;
    statusInformation?: LinkedAccountResponse_StatusResponse[] | undefined;

    constructor(data?: ILinkedAccountResponse_AllStatusesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.responseStatus = _data["responseStatus"];
            if (Array.isArray(_data["statusInformation"])) {
                this.statusInformation = [] as any;
                for (let item of _data["statusInformation"])
                    this.statusInformation!.push(LinkedAccountResponse_StatusResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LinkedAccountResponse_AllStatusesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedAccountResponse_AllStatusesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["responseStatus"] = this.responseStatus;
        if (Array.isArray(this.statusInformation)) {
            data["statusInformation"] = [];
            for (let item of this.statusInformation)
                data["statusInformation"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILinkedAccountResponse_AllStatusesResponse {
    errorMessage?: string | undefined;
    responseStatus?: number | undefined;
    statusInformation?: LinkedAccountResponse_StatusResponse[] | undefined;
}

export class LinkedAccountResponse_CancelResponse implements ILinkedAccountResponse_CancelResponse {
    actionType?: string | undefined;
    expirationTimestamp?: string | undefined;
    parties?: Party[] | undefined;
    exceptionOccured?: boolean;
    state?: string | undefined;
    operationId?: string | undefined;
    exceptionMessage?: string | undefined;
    message?: string | undefined;

    constructor(data?: ILinkedAccountResponse_CancelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionType = _data["actionType"];
            this.expirationTimestamp = _data["expirationTimestamp"];
            if (Array.isArray(_data["parties"])) {
                this.parties = [] as any;
                for (let item of _data["parties"])
                    this.parties!.push(Party.fromJS(item));
            }
            this.exceptionOccured = _data["exceptionOccured"];
            this.state = _data["state"];
            this.operationId = _data["operationId"];
            this.exceptionMessage = _data["exceptionMessage"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): LinkedAccountResponse_CancelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedAccountResponse_CancelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionType"] = this.actionType;
        data["expirationTimestamp"] = this.expirationTimestamp;
        if (Array.isArray(this.parties)) {
            data["parties"] = [];
            for (let item of this.parties)
                data["parties"].push(item.toJSON());
        }
        data["exceptionOccured"] = this.exceptionOccured;
        data["state"] = this.state;
        data["operationId"] = this.operationId;
        data["exceptionMessage"] = this.exceptionMessage;
        data["message"] = this.message;
        return data;
    }
}

export interface ILinkedAccountResponse_CancelResponse {
    actionType?: string | undefined;
    expirationTimestamp?: string | undefined;
    parties?: Party[] | undefined;
    exceptionOccured?: boolean;
    state?: string | undefined;
    operationId?: string | undefined;
    exceptionMessage?: string | undefined;
    message?: string | undefined;
}

export class LinkedAccountResponse_CompleteCancelResponse implements ILinkedAccountResponse_CompleteCancelResponse {
    state?: string | undefined;
    operationId?: string | undefined;
    exceptionOccurred?: boolean;
    exceptionMessage?: string | undefined;
    message?: string | undefined;

    constructor(data?: ILinkedAccountResponse_CompleteCancelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.operationId = _data["operationId"];
            this.exceptionOccurred = _data["exceptionOccurred"];
            this.exceptionMessage = _data["exceptionMessage"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): LinkedAccountResponse_CompleteCancelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedAccountResponse_CompleteCancelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["operationId"] = this.operationId;
        data["exceptionOccurred"] = this.exceptionOccurred;
        data["exceptionMessage"] = this.exceptionMessage;
        data["message"] = this.message;
        return data;
    }
}

export interface ILinkedAccountResponse_CompleteCancelResponse {
    state?: string | undefined;
    operationId?: string | undefined;
    exceptionOccurred?: boolean;
    exceptionMessage?: string | undefined;
    message?: string | undefined;
}

export class LinkedAccountResponse_CreateResponse implements ILinkedAccountResponse_CreateResponse {
    newAccountId?: string | undefined;
    accountName?: string | undefined;
    requestFailed?: boolean;
    failureReason?: string | undefined;
    state?: string | undefined;
    operationId?: string | undefined;
    exceptionMessage?: string | undefined;
    message?: string | undefined;
    exceptionOccurred?: boolean;

    constructor(data?: ILinkedAccountResponse_CreateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newAccountId = _data["newAccountId"];
            this.accountName = _data["accountName"];
            this.requestFailed = _data["requestFailed"];
            this.failureReason = _data["failureReason"];
            this.state = _data["state"];
            this.operationId = _data["operationId"];
            this.exceptionMessage = _data["exceptionMessage"];
            this.message = _data["message"];
            this.exceptionOccurred = _data["exceptionOccurred"];
        }
    }

    static fromJS(data: any): LinkedAccountResponse_CreateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedAccountResponse_CreateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newAccountId"] = this.newAccountId;
        data["accountName"] = this.accountName;
        data["requestFailed"] = this.requestFailed;
        data["failureReason"] = this.failureReason;
        data["state"] = this.state;
        data["operationId"] = this.operationId;
        data["exceptionMessage"] = this.exceptionMessage;
        data["message"] = this.message;
        data["exceptionOccurred"] = this.exceptionOccurred;
        return data;
    }
}

export interface ILinkedAccountResponse_CreateResponse {
    newAccountId?: string | undefined;
    accountName?: string | undefined;
    requestFailed?: boolean;
    failureReason?: string | undefined;
    state?: string | undefined;
    operationId?: string | undefined;
    exceptionMessage?: string | undefined;
    message?: string | undefined;
    exceptionOccurred?: boolean;
}

export class LinkedAccountResponse_InviteResponse implements ILinkedAccountResponse_InviteResponse {
    parties?: Party[] | undefined;
    operationId?: string | undefined;
    actionType?: string | undefined;
    expirationTimestamp?: string | undefined;
    state?: string | undefined;
    exceptionMessage?: string | undefined;
    exceptionOccurred?: boolean;

    constructor(data?: ILinkedAccountResponse_InviteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["parties"])) {
                this.parties = [] as any;
                for (let item of _data["parties"])
                    this.parties!.push(Party.fromJS(item));
            }
            this.operationId = _data["operationId"];
            this.actionType = _data["actionType"];
            this.expirationTimestamp = _data["expirationTimestamp"];
            this.state = _data["state"];
            this.exceptionMessage = _data["exceptionMessage"];
            this.exceptionOccurred = _data["exceptionOccurred"];
        }
    }

    static fromJS(data: any): LinkedAccountResponse_InviteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedAccountResponse_InviteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.parties)) {
            data["parties"] = [];
            for (let item of this.parties)
                data["parties"].push(item.toJSON());
        }
        data["operationId"] = this.operationId;
        data["actionType"] = this.actionType;
        data["expirationTimestamp"] = this.expirationTimestamp;
        data["state"] = this.state;
        data["exceptionMessage"] = this.exceptionMessage;
        data["exceptionOccurred"] = this.exceptionOccurred;
        return data;
    }
}

export interface ILinkedAccountResponse_InviteResponse {
    parties?: Party[] | undefined;
    operationId?: string | undefined;
    actionType?: string | undefined;
    expirationTimestamp?: string | undefined;
    state?: string | undefined;
    exceptionMessage?: string | undefined;
    exceptionOccurred?: boolean;
}

export class LinkedAccountResponse_StatusResponse implements ILinkedAccountResponse_StatusResponse {
    expirationTimestamp?: string | undefined;
    newAccountId?: string | undefined;
    autotaskAccountId?: number | undefined;
    autotaskContractId?: number | undefined;
    accountName?: string | undefined;
    requestFailed?: boolean;
    requestType?: string | undefined;
    payerAccountId?: string | undefined;
    requestedAccountEmail?: string | undefined;
    requestedAccountId?: string | undefined;
    failureReason?: string | undefined;
    state?: string | undefined;
    operationId?: string | undefined;
    message?: string | undefined;
    exceptionMessage?: string | undefined;
    exceptionOccurred?: boolean | undefined;

    constructor(data?: ILinkedAccountResponse_StatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expirationTimestamp = _data["expirationTimestamp"];
            this.newAccountId = _data["newAccountId"];
            this.autotaskAccountId = _data["autotaskAccountId"];
            this.autotaskContractId = _data["autotaskContractId"];
            this.accountName = _data["accountName"];
            this.requestFailed = _data["requestFailed"];
            this.requestType = _data["requestType"];
            this.payerAccountId = _data["payerAccountId"];
            this.requestedAccountEmail = _data["requestedAccountEmail"];
            this.requestedAccountId = _data["requestedAccountId"];
            this.failureReason = _data["failureReason"];
            this.state = _data["state"];
            this.operationId = _data["operationId"];
            this.message = _data["message"];
            this.exceptionMessage = _data["exceptionMessage"];
            this.exceptionOccurred = _data["exceptionOccurred"];
        }
    }

    static fromJS(data: any): LinkedAccountResponse_StatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedAccountResponse_StatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expirationTimestamp"] = this.expirationTimestamp;
        data["newAccountId"] = this.newAccountId;
        data["autotaskAccountId"] = this.autotaskAccountId;
        data["autotaskContractId"] = this.autotaskContractId;
        data["accountName"] = this.accountName;
        data["requestFailed"] = this.requestFailed;
        data["requestType"] = this.requestType;
        data["payerAccountId"] = this.payerAccountId;
        data["requestedAccountEmail"] = this.requestedAccountEmail;
        data["requestedAccountId"] = this.requestedAccountId;
        data["failureReason"] = this.failureReason;
        data["state"] = this.state;
        data["operationId"] = this.operationId;
        data["message"] = this.message;
        data["exceptionMessage"] = this.exceptionMessage;
        data["exceptionOccurred"] = this.exceptionOccurred;
        return data;
    }
}

export interface ILinkedAccountResponse_StatusResponse {
    expirationTimestamp?: string | undefined;
    newAccountId?: string | undefined;
    autotaskAccountId?: number | undefined;
    autotaskContractId?: number | undefined;
    accountName?: string | undefined;
    requestFailed?: boolean;
    requestType?: string | undefined;
    payerAccountId?: string | undefined;
    requestedAccountEmail?: string | undefined;
    requestedAccountId?: string | undefined;
    failureReason?: string | undefined;
    state?: string | undefined;
    operationId?: string | undefined;
    message?: string | undefined;
    exceptionMessage?: string | undefined;
    exceptionOccurred?: boolean | undefined;
}

export class MonitoringAlert implements IMonitoringAlert {
    serviceRequestId?: number;
    ticketId?: number;
    ticketNumber?: string | undefined;
    title?: string | undefined;
    priority?: number;
    status?: number;
    source?: number;
    contractName?: string | undefined;
    contractId?: number;
    resourceFirstName?: string | undefined;
    resourceLastName?: string | undefined;
    configurationItemName?: string | undefined;
    configurationItemId?: number;
    configurationItemReferenceNumber?: string | undefined;
    contactId?: number;
    contactName?: string | undefined;
    contactEmail?: string | undefined;
    created?: Date;
    contractType?: number;

    constructor(data?: IMonitoringAlert) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceRequestId = _data["serviceRequestId"];
            this.ticketId = _data["ticketId"];
            this.ticketNumber = _data["ticketNumber"];
            this.title = _data["title"];
            this.priority = _data["priority"];
            this.status = _data["status"];
            this.source = _data["source"];
            this.contractName = _data["contractName"];
            this.contractId = _data["contractId"];
            this.resourceFirstName = _data["resourceFirstName"];
            this.resourceLastName = _data["resourceLastName"];
            this.configurationItemName = _data["configurationItemName"];
            this.configurationItemId = _data["configurationItemId"];
            this.configurationItemReferenceNumber = _data["configurationItemReferenceNumber"];
            this.contactId = _data["contactId"];
            this.contactName = _data["contactName"];
            this.contactEmail = _data["contactEmail"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.contractType = _data["contractType"];
        }
    }

    static fromJS(data: any): MonitoringAlert {
        data = typeof data === 'object' ? data : {};
        let result = new MonitoringAlert();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceRequestId"] = this.serviceRequestId;
        data["ticketId"] = this.ticketId;
        data["ticketNumber"] = this.ticketNumber;
        data["title"] = this.title;
        data["priority"] = this.priority;
        data["status"] = this.status;
        data["source"] = this.source;
        data["contractName"] = this.contractName;
        data["contractId"] = this.contractId;
        data["resourceFirstName"] = this.resourceFirstName;
        data["resourceLastName"] = this.resourceLastName;
        data["configurationItemName"] = this.configurationItemName;
        data["configurationItemId"] = this.configurationItemId;
        data["configurationItemReferenceNumber"] = this.configurationItemReferenceNumber;
        data["contactId"] = this.contactId;
        data["contactName"] = this.contactName;
        data["contactEmail"] = this.contactEmail;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["contractType"] = this.contractType;
        return data;
    }
}

export interface IMonitoringAlert {
    serviceRequestId?: number;
    ticketId?: number;
    ticketNumber?: string | undefined;
    title?: string | undefined;
    priority?: number;
    status?: number;
    source?: number;
    contractName?: string | undefined;
    contractId?: number;
    resourceFirstName?: string | undefined;
    resourceLastName?: string | undefined;
    configurationItemName?: string | undefined;
    configurationItemId?: number;
    configurationItemReferenceNumber?: string | undefined;
    contactId?: number;
    contactName?: string | undefined;
    contactEmail?: string | undefined;
    created?: Date;
    contractType?: number;
}

export class MonthReport implements IMonthReport {
    month?: number;
    createdTickets?: number;
    completedTickets?: number;
    createdTicketsParentOnly?: number;
    completedTicketsParentOnly?: number;
    monthDate?: Date;
    monthName?: string | undefined;
    monthNameShort?: string | undefined;

    constructor(data?: IMonthReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data["month"];
            this.createdTickets = _data["createdTickets"];
            this.completedTickets = _data["completedTickets"];
            this.createdTicketsParentOnly = _data["createdTicketsParentOnly"];
            this.completedTicketsParentOnly = _data["completedTicketsParentOnly"];
            this.monthDate = _data["monthDate"] ? new Date(_data["monthDate"].toString()) : <any>undefined;
            this.monthName = _data["monthName"];
            this.monthNameShort = _data["monthNameShort"];
        }
    }

    static fromJS(data: any): MonthReport {
        data = typeof data === 'object' ? data : {};
        let result = new MonthReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        data["createdTickets"] = this.createdTickets;
        data["completedTickets"] = this.completedTickets;
        data["createdTicketsParentOnly"] = this.createdTicketsParentOnly;
        data["completedTicketsParentOnly"] = this.completedTicketsParentOnly;
        data["monthDate"] = this.monthDate ? this.monthDate.toISOString() : <any>undefined;
        data["monthName"] = this.monthName;
        data["monthNameShort"] = this.monthNameShort;
        return data;
    }
}

export interface IMonthReport {
    month?: number;
    createdTickets?: number;
    completedTickets?: number;
    createdTicketsParentOnly?: number;
    completedTicketsParentOnly?: number;
    monthDate?: Date;
    monthName?: string | undefined;
    monthNameShort?: string | undefined;
}

export class NotificationCloudAccount implements INotificationCloudAccount {
    configurationItemId?: number;
    contractId?: number;
    contractName?: string | undefined;
    contractServiceLevelAgreementId?: number;
    cloudAccountName?: string | undefined;
    cloudAccountId?: string | undefined;

    constructor(data?: INotificationCloudAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configurationItemId = _data["configurationItemId"];
            this.contractId = _data["contractId"];
            this.contractName = _data["contractName"];
            this.contractServiceLevelAgreementId = _data["contractServiceLevelAgreementId"];
            this.cloudAccountName = _data["cloudAccountName"];
            this.cloudAccountId = _data["cloudAccountId"];
        }
    }

    static fromJS(data: any): NotificationCloudAccount {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationCloudAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configurationItemId"] = this.configurationItemId;
        data["contractId"] = this.contractId;
        data["contractName"] = this.contractName;
        data["contractServiceLevelAgreementId"] = this.contractServiceLevelAgreementId;
        data["cloudAccountName"] = this.cloudAccountName;
        data["cloudAccountId"] = this.cloudAccountId;
        return data;
    }
}

export interface INotificationCloudAccount {
    configurationItemId?: number;
    contractId?: number;
    contractName?: string | undefined;
    contractServiceLevelAgreementId?: number;
    cloudAccountName?: string | undefined;
    cloudAccountId?: string | undefined;
}

export class NotificationContract implements INotificationContract {
    contractId?: number;
    contractName?: string | undefined;
    serviceLevelAgreementId?: number;

    constructor(data?: INotificationContract) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractId = _data["contractId"];
            this.contractName = _data["contractName"];
            this.serviceLevelAgreementId = _data["serviceLevelAgreementId"];
        }
    }

    static fromJS(data: any): NotificationContract {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationContract();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractId"] = this.contractId;
        data["contractName"] = this.contractName;
        data["serviceLevelAgreementId"] = this.serviceLevelAgreementId;
        return data;
    }
}

export interface INotificationContract {
    contractId?: number;
    contractName?: string | undefined;
    serviceLevelAgreementId?: number;
}

export class OnboardingAdmin implements IOnboardingAdmin {
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phone?: string | undefined;
    phoneExtension?: string | undefined;
    hasLoggedIn?: boolean;
    connectionsUsed?: string[] | undefined;

    constructor(data?: IOnboardingAdmin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phone = _data["phone"];
            this.phoneExtension = _data["phoneExtension"];
            this.hasLoggedIn = _data["hasLoggedIn"];
            if (Array.isArray(_data["connectionsUsed"])) {
                this.connectionsUsed = [] as any;
                for (let item of _data["connectionsUsed"])
                    this.connectionsUsed!.push(item);
            }
        }
    }

    static fromJS(data: any): OnboardingAdmin {
        data = typeof data === 'object' ? data : {};
        let result = new OnboardingAdmin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phone"] = this.phone;
        data["phoneExtension"] = this.phoneExtension;
        data["hasLoggedIn"] = this.hasLoggedIn;
        if (Array.isArray(this.connectionsUsed)) {
            data["connectionsUsed"] = [];
            for (let item of this.connectionsUsed)
                data["connectionsUsed"].push(item);
        }
        return data;
    }
}

export interface IOnboardingAdmin {
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phone?: string | undefined;
    phoneExtension?: string | undefined;
    hasLoggedIn?: boolean;
    connectionsUsed?: string[] | undefined;
}

export class OnboardingStatus implements IOnboardingStatus {
    accountId?: number;
    accountName?: string | undefined;
    contactCreationSuccessful?: boolean;
    welcomeLinkGuid?: string | undefined;
    domains?: string[] | undefined;
    existingAdmins?: OnboardingAdmin[] | undefined;
    firstAdmin?: OnboardingAdmin;
    connections?: string[] | undefined;

    constructor(data?: IOnboardingStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.accountName = _data["accountName"];
            this.contactCreationSuccessful = _data["contactCreationSuccessful"];
            this.welcomeLinkGuid = _data["welcomeLinkGuid"];
            if (Array.isArray(_data["domains"])) {
                this.domains = [] as any;
                for (let item of _data["domains"])
                    this.domains!.push(item);
            }
            if (Array.isArray(_data["existingAdmins"])) {
                this.existingAdmins = [] as any;
                for (let item of _data["existingAdmins"])
                    this.existingAdmins!.push(OnboardingAdmin.fromJS(item));
            }
            this.firstAdmin = _data["firstAdmin"] ? OnboardingAdmin.fromJS(_data["firstAdmin"]) : <any>undefined;
            if (Array.isArray(_data["connections"])) {
                this.connections = [] as any;
                for (let item of _data["connections"])
                    this.connections!.push(item);
            }
        }
    }

    static fromJS(data: any): OnboardingStatus {
        data = typeof data === 'object' ? data : {};
        let result = new OnboardingStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["accountName"] = this.accountName;
        data["contactCreationSuccessful"] = this.contactCreationSuccessful;
        data["welcomeLinkGuid"] = this.welcomeLinkGuid;
        if (Array.isArray(this.domains)) {
            data["domains"] = [];
            for (let item of this.domains)
                data["domains"].push(item);
        }
        if (Array.isArray(this.existingAdmins)) {
            data["existingAdmins"] = [];
            for (let item of this.existingAdmins)
                data["existingAdmins"].push(item.toJSON());
        }
        data["firstAdmin"] = this.firstAdmin ? this.firstAdmin.toJSON() : <any>undefined;
        if (Array.isArray(this.connections)) {
            data["connections"] = [];
            for (let item of this.connections)
                data["connections"].push(item);
        }
        return data;
    }
}

export interface IOnboardingStatus {
    accountId?: number;
    accountName?: string | undefined;
    contactCreationSuccessful?: boolean;
    welcomeLinkGuid?: string | undefined;
    domains?: string[] | undefined;
    existingAdmins?: OnboardingAdmin[] | undefined;
    firstAdmin?: OnboardingAdmin;
    connections?: string[] | undefined;
}

export class OpenRequests implements IOpenRequests {
    ticketCategory?: number;
    activeRequestCount?: number;

    constructor(data?: IOpenRequests) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketCategory = _data["ticketCategory"];
            this.activeRequestCount = _data["activeRequestCount"];
        }
    }

    static fromJS(data: any): OpenRequests {
        data = typeof data === 'object' ? data : {};
        let result = new OpenRequests();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketCategory"] = this.ticketCategory;
        data["activeRequestCount"] = this.activeRequestCount;
        return data;
    }
}

export interface IOpenRequests {
    ticketCategory?: number;
    activeRequestCount?: number;
}

export class PagedResultData implements IPagedResultData {
    currentPage?: number;
    totalPages?: number;
    pageSize?: number;
    totalCount?: number;
    hasPrevious?: boolean;
    hasNext?: boolean;

    constructor(data?: IPagedResultData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.hasPrevious = _data["hasPrevious"];
            this.hasNext = _data["hasNext"];
        }
    }

    static fromJS(data: any): PagedResultData {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["hasPrevious"] = this.hasPrevious;
        data["hasNext"] = this.hasNext;
        return data;
    }
}

export interface IPagedResultData {
    currentPage?: number;
    totalPages?: number;
    pageSize?: number;
    totalCount?: number;
    hasPrevious?: boolean;
    hasNext?: boolean;
}

export class PagedUserResponse_1OfContact implements IPagedUserResponse_1OfContact {
    users?: Contact[] | undefined;
    totalCount?: number | undefined;

    constructor(data?: IPagedUserResponse_1OfContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(Contact.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedUserResponse_1OfContact {
        data = typeof data === 'object' ? data : {};
        let result = new PagedUserResponse_1OfContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedUserResponse_1OfContact {
    users?: Contact[] | undefined;
    totalCount?: number | undefined;
}

export class PagedUserResponse_1OfUserProfileDTO implements IPagedUserResponse_1OfUserProfileDTO {
    users?: UserProfileDTO[] | undefined;
    totalCount?: number | undefined;

    constructor(data?: IPagedUserResponse_1OfUserProfileDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserProfileDTO.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedUserResponse_1OfUserProfileDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedUserResponse_1OfUserProfileDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedUserResponse_1OfUserProfileDTO {
    users?: UserProfileDTO[] | undefined;
    totalCount?: number | undefined;
}

export class PartnerLogo implements IPartnerLogo {
    partner?: string | undefined;
    logo?: string | undefined;

    constructor(data?: IPartnerLogo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partner = _data["partner"];
            this.logo = _data["logo"];
        }
    }

    static fromJS(data: any): PartnerLogo {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerLogo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partner"] = this.partner;
        data["logo"] = this.logo;
        return data;
    }
}

export interface IPartnerLogo {
    partner?: string | undefined;
    logo?: string | undefined;
}

export class Party implements IParty {
    id?: string | undefined;
    type?: string | undefined;
    isOrganization?: boolean;

    constructor(data?: IParty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.isOrganization = _data["isOrganization"];
        }
    }

    static fromJS(data: any): Party {
        data = typeof data === 'object' ? data : {};
        let result = new Party();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["isOrganization"] = this.isOrganization;
        return data;
    }
}

export interface IParty {
    id?: string | undefined;
    type?: string | undefined;
    isOrganization?: boolean;
}

export class ProfileApproval implements IProfileApproval {
    accountId?: number;
    admin?: boolean;
    approved?: boolean;
    id?: number;

    constructor(data?: IProfileApproval) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.admin = _data["admin"];
            this.approved = _data["approved"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProfileApproval {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileApproval();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["admin"] = this.admin;
        data["approved"] = this.approved;
        data["id"] = this.id;
        return data;
    }
}

export interface IProfileApproval {
    accountId?: number;
    admin?: boolean;
    approved?: boolean;
    id?: number;
}

export class ProfileApprovals implements IProfileApprovals {
    approvals?: ProfileApproval[] | undefined;

    constructor(data?: IProfileApprovals) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["approvals"])) {
                this.approvals = [] as any;
                for (let item of _data["approvals"])
                    this.approvals!.push(ProfileApproval.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProfileApprovals {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileApprovals();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.approvals)) {
            data["approvals"] = [];
            for (let item of this.approvals)
                data["approvals"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProfileApprovals {
    approvals?: ProfileApproval[] | undefined;
}

export class StatusResponse implements IStatusResponse {
    responseStatus?: ResponseStatusValues;
    errorMessage?: string | undefined;

    protected _discriminator: string;

    constructor(data?: IStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "StatusResponse";
    }

    init(_data?: any) {
        if (_data) {
            this.responseStatus = _data["responseStatus"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): StatusResponse {
        data = typeof data === 'object' ? data : {};
        if (data["typeName"] === "ServiceRequestResponse") {
            let result = new ServiceRequestResponse();
            result.init(data);
            return result;
        }
        let result = new StatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeName"] = this._discriminator;
        data["responseStatus"] = this.responseStatus;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IStatusResponse {
    responseStatus?: ResponseStatusValues;
    errorMessage?: string | undefined;
}

export class ServiceRequestResponse extends StatusResponse implements IServiceRequestResponse {
    serviceRequests?: ServiceRequestDTO[] | undefined;
    lastServiceRequestId?: number | undefined;
    lastAutotaskTicketId?: number | undefined;
    lastAutotaskTicketNumber?: string | undefined;

    constructor(data?: IServiceRequestResponse) {
        super(data);
        this._discriminator = "ServiceRequestResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["serviceRequests"])) {
                this.serviceRequests = [] as any;
                for (let item of _data["serviceRequests"])
                    this.serviceRequests!.push(ServiceRequestDTO.fromJS(item));
            }
            this.lastServiceRequestId = _data["lastServiceRequestId"];
            this.lastAutotaskTicketId = _data["lastAutotaskTicketId"];
            this.lastAutotaskTicketNumber = _data["lastAutotaskTicketNumber"];
        }
    }

    static override fromJS(data: any): ServiceRequestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.serviceRequests)) {
            data["serviceRequests"] = [];
            for (let item of this.serviceRequests)
                data["serviceRequests"].push(item.toJSON());
        }
        data["lastServiceRequestId"] = this.lastServiceRequestId;
        data["lastAutotaskTicketId"] = this.lastAutotaskTicketId;
        data["lastAutotaskTicketNumber"] = this.lastAutotaskTicketNumber;
        super.toJSON(data);
        return data;
    }
}

export interface IServiceRequestResponse extends IStatusResponse {
    serviceRequests?: ServiceRequestDTO[] | undefined;
    lastServiceRequestId?: number | undefined;
    lastAutotaskTicketId?: number | undefined;
    lastAutotaskTicketNumber?: string | undefined;
}

export class SwitcherAccount implements ISwitcherAccount {
    accountId?: number;
    accountName?: string | undefined;
    axNumber?: string | undefined;
    accountExecEmail?: string | undefined;
    canImpersonate?: boolean;
    successPlans?: number[] | undefined;
    accountType?: number;
    crmAccountGuid?: string | undefined;

    constructor(data?: ISwitcherAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.accountName = _data["accountName"];
            this.axNumber = _data["axNumber"];
            this.accountExecEmail = _data["accountExecEmail"];
            this.canImpersonate = _data["canImpersonate"];
            if (Array.isArray(_data["successPlans"])) {
                this.successPlans = [] as any;
                for (let item of _data["successPlans"])
                    this.successPlans!.push(item);
            }
            this.accountType = _data["accountType"];
            this.crmAccountGuid = _data["crmAccountGuid"];
        }
    }

    static fromJS(data: any): SwitcherAccount {
        data = typeof data === 'object' ? data : {};
        let result = new SwitcherAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["accountName"] = this.accountName;
        data["axNumber"] = this.axNumber;
        data["accountExecEmail"] = this.accountExecEmail;
        data["canImpersonate"] = this.canImpersonate;
        if (Array.isArray(this.successPlans)) {
            data["successPlans"] = [];
            for (let item of this.successPlans)
                data["successPlans"].push(item);
        }
        data["accountType"] = this.accountType;
        data["crmAccountGuid"] = this.crmAccountGuid;
        return data;
    }
}

export interface ISwitcherAccount {
    accountId?: number;
    accountName?: string | undefined;
    axNumber?: string | undefined;
    accountExecEmail?: string | undefined;
    canImpersonate?: boolean;
    successPlans?: number[] | undefined;
    accountType?: number;
    crmAccountGuid?: string | undefined;
}

export class TeamContractReponse implements ITeamContractReponse {
    teamsEnabled?: boolean;
    standardContracts?: Contract[] | undefined;
    cloudContracts?: Contract[] | undefined;
    cloudContractAccounts?: CloudAccount[] | undefined;

    constructor(data?: ITeamContractReponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamsEnabled = _data["teamsEnabled"];
            if (Array.isArray(_data["standardContracts"])) {
                this.standardContracts = [] as any;
                for (let item of _data["standardContracts"])
                    this.standardContracts!.push(Contract.fromJS(item));
            }
            if (Array.isArray(_data["cloudContracts"])) {
                this.cloudContracts = [] as any;
                for (let item of _data["cloudContracts"])
                    this.cloudContracts!.push(Contract.fromJS(item));
            }
            if (Array.isArray(_data["cloudContractAccounts"])) {
                this.cloudContractAccounts = [] as any;
                for (let item of _data["cloudContractAccounts"])
                    this.cloudContractAccounts!.push(CloudAccount.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TeamContractReponse {
        data = typeof data === 'object' ? data : {};
        let result = new TeamContractReponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamsEnabled"] = this.teamsEnabled;
        if (Array.isArray(this.standardContracts)) {
            data["standardContracts"] = [];
            for (let item of this.standardContracts)
                data["standardContracts"].push(item.toJSON());
        }
        if (Array.isArray(this.cloudContracts)) {
            data["cloudContracts"] = [];
            for (let item of this.cloudContracts)
                data["cloudContracts"].push(item.toJSON());
        }
        if (Array.isArray(this.cloudContractAccounts)) {
            data["cloudContractAccounts"] = [];
            for (let item of this.cloudContractAccounts)
                data["cloudContractAccounts"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITeamContractReponse {
    teamsEnabled?: boolean;
    standardContracts?: Contract[] | undefined;
    cloudContracts?: Contract[] | undefined;
    cloudContractAccounts?: CloudAccount[] | undefined;
}

export class TicketCacheResponse implements ITicketCacheResponse {
    expiry?: number | undefined;
    responseStatus?: number;
    errorMessage?: string | undefined;
    tickets?: TicketDTO[] | undefined;
    lastTicketNumber?: string | undefined;
    lastTicketId?: number;

    constructor(data?: ITicketCacheResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expiry = _data["expiry"];
            this.responseStatus = _data["responseStatus"];
            this.errorMessage = _data["errorMessage"];
            if (Array.isArray(_data["tickets"])) {
                this.tickets = [] as any;
                for (let item of _data["tickets"])
                    this.tickets!.push(TicketDTO.fromJS(item));
            }
            this.lastTicketNumber = _data["lastTicketNumber"];
            this.lastTicketId = _data["lastTicketId"];
        }
    }

    static fromJS(data: any): TicketCacheResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TicketCacheResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expiry"] = this.expiry;
        data["responseStatus"] = this.responseStatus;
        data["errorMessage"] = this.errorMessage;
        if (Array.isArray(this.tickets)) {
            data["tickets"] = [];
            for (let item of this.tickets)
                data["tickets"].push(item.toJSON());
        }
        data["lastTicketNumber"] = this.lastTicketNumber;
        data["lastTicketId"] = this.lastTicketId;
        return data;
    }
}

export interface ITicketCacheResponse {
    expiry?: number | undefined;
    responseStatus?: number;
    errorMessage?: string | undefined;
    tickets?: TicketDTO[] | undefined;
    lastTicketNumber?: string | undefined;
    lastTicketId?: number;
}

export class UnmappedContractSLA implements IUnmappedContractSLA {
    contractCategory?: number;
    serviceLevelAgreementID?: number;

    constructor(data?: IUnmappedContractSLA) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractCategory = _data["contractCategory"];
            this.serviceLevelAgreementID = _data["serviceLevelAgreementID"];
        }
    }

    static fromJS(data: any): UnmappedContractSLA {
        data = typeof data === 'object' ? data : {};
        let result = new UnmappedContractSLA();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractCategory"] = this.contractCategory;
        data["serviceLevelAgreementID"] = this.serviceLevelAgreementID;
        return data;
    }
}

export interface IUnmappedContractSLA {
    contractCategory?: number;
    serviceLevelAgreementID?: number;
}

export class UpdateUserObject implements IUpdateUserObject {
    contactId?: number;
    profileId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isAdmin?: boolean;
    active?: number;
    phone?: string | undefined;
    extension?: string | undefined;

    constructor(data?: IUpdateUserObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactId = _data["contactId"];
            this.profileId = _data["profileId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.isAdmin = _data["isAdmin"];
            this.active = _data["active"];
            this.phone = _data["phone"];
            this.extension = _data["extension"];
        }
    }

    static fromJS(data: any): UpdateUserObject {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["profileId"] = this.profileId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["isAdmin"] = this.isAdmin;
        data["active"] = this.active;
        data["phone"] = this.phone;
        data["extension"] = this.extension;
        return data;
    }
}

export interface IUpdateUserObject {
    contactId?: number;
    profileId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isAdmin?: boolean;
    active?: number;
    phone?: string | undefined;
    extension?: string | undefined;
}

export class UserManagementBasicInfo implements IUserManagementBasicInfo {
    approvedUsersTotal?: number;
    awaitingUsersTotal?: number;
    activeContactsTotal?: number;
    inactiveContactsTotal?: number;
    guestUserTotal?: number;
    confirmedEmailDomains?: string[] | undefined;
    accountUserTotal?: AccountUserCount[] | undefined;

    constructor(data?: IUserManagementBasicInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.approvedUsersTotal = _data["approvedUsersTotal"];
            this.awaitingUsersTotal = _data["awaitingUsersTotal"];
            this.activeContactsTotal = _data["activeContactsTotal"];
            this.inactiveContactsTotal = _data["inactiveContactsTotal"];
            this.guestUserTotal = _data["guestUserTotal"];
            if (Array.isArray(_data["confirmedEmailDomains"])) {
                this.confirmedEmailDomains = [] as any;
                for (let item of _data["confirmedEmailDomains"])
                    this.confirmedEmailDomains!.push(item);
            }
            if (Array.isArray(_data["accountUserTotal"])) {
                this.accountUserTotal = [] as any;
                for (let item of _data["accountUserTotal"])
                    this.accountUserTotal!.push(AccountUserCount.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserManagementBasicInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserManagementBasicInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approvedUsersTotal"] = this.approvedUsersTotal;
        data["awaitingUsersTotal"] = this.awaitingUsersTotal;
        data["activeContactsTotal"] = this.activeContactsTotal;
        data["inactiveContactsTotal"] = this.inactiveContactsTotal;
        data["guestUserTotal"] = this.guestUserTotal;
        if (Array.isArray(this.confirmedEmailDomains)) {
            data["confirmedEmailDomains"] = [];
            for (let item of this.confirmedEmailDomains)
                data["confirmedEmailDomains"].push(item);
        }
        if (Array.isArray(this.accountUserTotal)) {
            data["accountUserTotal"] = [];
            for (let item of this.accountUserTotal)
                data["accountUserTotal"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserManagementBasicInfo {
    approvedUsersTotal?: number;
    awaitingUsersTotal?: number;
    activeContactsTotal?: number;
    inactiveContactsTotal?: number;
    guestUserTotal?: number;
    confirmedEmailDomains?: string[] | undefined;
    accountUserTotal?: AccountUserCount[] | undefined;
}

export class UserProfileCacheResponse implements IUserProfileCacheResponse {
    expiry?: number | undefined;
    responseStatus?: number;
    errorMessage?: string | undefined;
    sitePrefix?: string | undefined;
    userProfile?: UserProfileDTO;
    shiProfile?: UserProfileDTO;
    myAdmins?: string[] | undefined;
    virtualAdmin?: boolean;
    isResource?: boolean;
    accountDivision?: string | undefined;
    accountDistrict?: string | undefined;
    segment?: string | undefined;

    constructor(data?: IUserProfileCacheResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expiry = _data["expiry"];
            this.responseStatus = _data["responseStatus"];
            this.errorMessage = _data["errorMessage"];
            this.sitePrefix = _data["sitePrefix"];
            this.userProfile = _data["userProfile"] ? UserProfileDTO.fromJS(_data["userProfile"]) : <any>undefined;
            this.shiProfile = _data["shiProfile"] ? UserProfileDTO.fromJS(_data["shiProfile"]) : <any>undefined;
            if (Array.isArray(_data["myAdmins"])) {
                this.myAdmins = [] as any;
                for (let item of _data["myAdmins"])
                    this.myAdmins!.push(item);
            }
            this.virtualAdmin = _data["virtualAdmin"];
            this.isResource = _data["isResource"];
            this.accountDivision = _data["accountDivision"];
            this.accountDistrict = _data["accountDistrict"];
            this.segment = _data["segment"];
        }
    }

    static fromJS(data: any): UserProfileCacheResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileCacheResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expiry"] = this.expiry;
        data["responseStatus"] = this.responseStatus;
        data["errorMessage"] = this.errorMessage;
        data["sitePrefix"] = this.sitePrefix;
        data["userProfile"] = this.userProfile ? this.userProfile.toJSON() : <any>undefined;
        data["shiProfile"] = this.shiProfile ? this.shiProfile.toJSON() : <any>undefined;
        if (Array.isArray(this.myAdmins)) {
            data["myAdmins"] = [];
            for (let item of this.myAdmins)
                data["myAdmins"].push(item);
        }
        data["virtualAdmin"] = this.virtualAdmin;
        data["isResource"] = this.isResource;
        data["accountDivision"] = this.accountDivision;
        data["accountDistrict"] = this.accountDistrict;
        data["segment"] = this.segment;
        return data;
    }
}

export interface IUserProfileCacheResponse {
    expiry?: number | undefined;
    responseStatus?: number;
    errorMessage?: string | undefined;
    sitePrefix?: string | undefined;
    userProfile?: UserProfileDTO;
    shiProfile?: UserProfileDTO;
    myAdmins?: string[] | undefined;
    virtualAdmin?: boolean;
    isResource?: boolean;
    accountDivision?: string | undefined;
    accountDistrict?: string | undefined;
    segment?: string | undefined;
}

export class UserProfileManager implements IUserProfileManager {
    mappedUserProfiles?: UserProfile[] | undefined;
    unmappedUserProfiles?: UserProfile[] | undefined;
    approvedUsers?: UserProfileDTO[] | undefined;
    confirmedEmailDomains?: string[] | undefined;
    contacts?: Contact[] | undefined;
    crmUserDetails?: CrmUserDetails[] | undefined;
    approvedUsersTotal?: number;
    contactsTotal?: number;
    inactiveUsers?: Contact[] | undefined;
    inactiveUsersTotal?: number;
    responseStatus?: number;
    errorMessage?: string | undefined;

    constructor(data?: IUserProfileManager) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mappedUserProfiles"])) {
                this.mappedUserProfiles = [] as any;
                for (let item of _data["mappedUserProfiles"])
                    this.mappedUserProfiles!.push(UserProfile.fromJS(item));
            }
            if (Array.isArray(_data["unmappedUserProfiles"])) {
                this.unmappedUserProfiles = [] as any;
                for (let item of _data["unmappedUserProfiles"])
                    this.unmappedUserProfiles!.push(UserProfile.fromJS(item));
            }
            if (Array.isArray(_data["approvedUsers"])) {
                this.approvedUsers = [] as any;
                for (let item of _data["approvedUsers"])
                    this.approvedUsers!.push(UserProfileDTO.fromJS(item));
            }
            if (Array.isArray(_data["confirmedEmailDomains"])) {
                this.confirmedEmailDomains = [] as any;
                for (let item of _data["confirmedEmailDomains"])
                    this.confirmedEmailDomains!.push(item);
            }
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(Contact.fromJS(item));
            }
            if (Array.isArray(_data["crmUserDetails"])) {
                this.crmUserDetails = [] as any;
                for (let item of _data["crmUserDetails"])
                    this.crmUserDetails!.push(CrmUserDetails.fromJS(item));
            }
            this.approvedUsersTotal = _data["approvedUsersTotal"];
            this.contactsTotal = _data["contactsTotal"];
            if (Array.isArray(_data["inactiveUsers"])) {
                this.inactiveUsers = [] as any;
                for (let item of _data["inactiveUsers"])
                    this.inactiveUsers!.push(Contact.fromJS(item));
            }
            this.inactiveUsersTotal = _data["inactiveUsersTotal"];
            this.responseStatus = _data["responseStatus"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): UserProfileManager {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileManager();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mappedUserProfiles)) {
            data["mappedUserProfiles"] = [];
            for (let item of this.mappedUserProfiles)
                data["mappedUserProfiles"].push(item.toJSON());
        }
        if (Array.isArray(this.unmappedUserProfiles)) {
            data["unmappedUserProfiles"] = [];
            for (let item of this.unmappedUserProfiles)
                data["unmappedUserProfiles"].push(item.toJSON());
        }
        if (Array.isArray(this.approvedUsers)) {
            data["approvedUsers"] = [];
            for (let item of this.approvedUsers)
                data["approvedUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.confirmedEmailDomains)) {
            data["confirmedEmailDomains"] = [];
            for (let item of this.confirmedEmailDomains)
                data["confirmedEmailDomains"].push(item);
        }
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        if (Array.isArray(this.crmUserDetails)) {
            data["crmUserDetails"] = [];
            for (let item of this.crmUserDetails)
                data["crmUserDetails"].push(item.toJSON());
        }
        data["approvedUsersTotal"] = this.approvedUsersTotal;
        data["contactsTotal"] = this.contactsTotal;
        if (Array.isArray(this.inactiveUsers)) {
            data["inactiveUsers"] = [];
            for (let item of this.inactiveUsers)
                data["inactiveUsers"].push(item.toJSON());
        }
        data["inactiveUsersTotal"] = this.inactiveUsersTotal;
        data["responseStatus"] = this.responseStatus;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IUserProfileManager {
    mappedUserProfiles?: UserProfile[] | undefined;
    unmappedUserProfiles?: UserProfile[] | undefined;
    approvedUsers?: UserProfileDTO[] | undefined;
    confirmedEmailDomains?: string[] | undefined;
    contacts?: Contact[] | undefined;
    crmUserDetails?: CrmUserDetails[] | undefined;
    approvedUsersTotal?: number;
    contactsTotal?: number;
    inactiveUsers?: Contact[] | undefined;
    inactiveUsersTotal?: number;
    responseStatus?: number;
    errorMessage?: string | undefined;
}

export class UserProfileValidation implements IUserProfileValidation {
    emailAddress?: string | undefined;
    userExists?: boolean;
    message?: string | undefined;

    constructor(data?: IUserProfileValidation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.userExists = _data["userExists"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): UserProfileValidation {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileValidation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["userExists"] = this.userExists;
        data["message"] = this.message;
        return data;
    }
}

export interface IUserProfileValidation {
    emailAddress?: string | undefined;
    userExists?: boolean;
    message?: string | undefined;
}

export class ValidateEmailStatus implements IValidateEmailStatus {
    emailSent?: boolean;
    codeGenerated?: boolean;
    validCode?: boolean;
    codeExpired?: boolean;
    guid?: string | undefined;

    constructor(data?: IValidateEmailStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailSent = _data["emailSent"];
            this.codeGenerated = _data["codeGenerated"];
            this.validCode = _data["validCode"];
            this.codeExpired = _data["codeExpired"];
            this.guid = _data["guid"];
        }
    }

    static fromJS(data: any): ValidateEmailStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateEmailStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailSent"] = this.emailSent;
        data["codeGenerated"] = this.codeGenerated;
        data["validCode"] = this.validCode;
        data["codeExpired"] = this.codeExpired;
        data["guid"] = this.guid;
        return data;
    }
}

export interface IValidateEmailStatus {
    emailSent?: boolean;
    codeGenerated?: boolean;
    validCode?: boolean;
    codeExpired?: boolean;
    guid?: string | undefined;
}

export class TicketQueryRequest extends ServiceRequestsRequest implements ITicketQueryRequest {
    contactId?: number | undefined;
    accountIds?: number[] | undefined;
    ticketIds?: number[] | undefined;

    constructor(data?: ITicketQueryRequest) {
        super(data);
        this._discriminator = "TicketQueryRequest";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contactId = _data["contactId"];
            if (Array.isArray(_data["accountIds"])) {
                this.accountIds = [] as any;
                for (let item of _data["accountIds"])
                    this.accountIds!.push(item);
            }
            if (Array.isArray(_data["ticketIds"])) {
                this.ticketIds = [] as any;
                for (let item of _data["ticketIds"])
                    this.ticketIds!.push(item);
            }
        }
    }

    static override fromJS(data: any): TicketQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TicketQueryRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        if (Array.isArray(this.accountIds)) {
            data["accountIds"] = [];
            for (let item of this.accountIds)
                data["accountIds"].push(item);
        }
        if (Array.isArray(this.ticketIds)) {
            data["ticketIds"] = [];
            for (let item of this.ticketIds)
                data["ticketIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITicketQueryRequest extends IServiceRequestsRequest {
    contactId?: number | undefined;
    accountIds?: number[] | undefined;
    ticketIds?: number[] | undefined;
}

export class ConfigContractSLAsResponse implements IConfigContractSLAsResponse {
    responseStatus?: number;
    errorMessage?: string | undefined;
    unmappedContractSLAs?: UnmappedContractSLA[] | undefined;
    mappedContractSLAs?: ConfigContractSLA[] | undefined;

    constructor(data?: IConfigContractSLAsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseStatus = _data["responseStatus"];
            this.errorMessage = _data["errorMessage"];
            if (Array.isArray(_data["unmappedContractSLAs"])) {
                this.unmappedContractSLAs = [] as any;
                for (let item of _data["unmappedContractSLAs"])
                    this.unmappedContractSLAs!.push(UnmappedContractSLA.fromJS(item));
            }
            if (Array.isArray(_data["mappedContractSLAs"])) {
                this.mappedContractSLAs = [] as any;
                for (let item of _data["mappedContractSLAs"])
                    this.mappedContractSLAs!.push(ConfigContractSLA.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConfigContractSLAsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigContractSLAsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseStatus"] = this.responseStatus;
        data["errorMessage"] = this.errorMessage;
        if (Array.isArray(this.unmappedContractSLAs)) {
            data["unmappedContractSLAs"] = [];
            for (let item of this.unmappedContractSLAs)
                data["unmappedContractSLAs"].push(item.toJSON());
        }
        if (Array.isArray(this.mappedContractSLAs)) {
            data["mappedContractSLAs"] = [];
            for (let item of this.mappedContractSLAs)
                data["mappedContractSLAs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IConfigContractSLAsResponse {
    responseStatus?: number;
    errorMessage?: string | undefined;
    unmappedContractSLAs?: UnmappedContractSLA[] | undefined;
    mappedContractSLAs?: ConfigContractSLA[] | undefined;
}

export class CreateConfigContractSLAResponse implements ICreateConfigContractSLAResponse {
    responseStatus?: number;
    errorMessage?: string | undefined;
    create?: ConfigContractSLA;

    constructor(data?: ICreateConfigContractSLAResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseStatus = _data["responseStatus"];
            this.errorMessage = _data["errorMessage"];
            this.create = _data["create"] ? ConfigContractSLA.fromJS(_data["create"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateConfigContractSLAResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateConfigContractSLAResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseStatus"] = this.responseStatus;
        data["errorMessage"] = this.errorMessage;
        data["create"] = this.create ? this.create.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateConfigContractSLAResponse {
    responseStatus?: number;
    errorMessage?: string | undefined;
    create?: ConfigContractSLA;
}

export class UpdateConfigContractSLAResponse implements IUpdateConfigContractSLAResponse {
    responseStatus?: number;
    errorMessage?: string | undefined;
    update?: ConfigContractSLA;

    constructor(data?: IUpdateConfigContractSLAResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseStatus = _data["responseStatus"];
            this.errorMessage = _data["errorMessage"];
            this.update = _data["update"] ? ConfigContractSLA.fromJS(_data["update"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateConfigContractSLAResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateConfigContractSLAResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseStatus"] = this.responseStatus;
        data["errorMessage"] = this.errorMessage;
        data["update"] = this.update ? this.update.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateConfigContractSLAResponse {
    responseStatus?: number;
    errorMessage?: string | undefined;
    update?: ConfigContractSLA;
}

export class ContractServiceRecord implements IContractServiceRecord {
    contractID?: any | undefined;
    serviceID?: any | undefined;
    unitPrice?: any | undefined;
    adjustedPrice?: any | undefined;
    invoiceDescription?: any | undefined;
    quoteItemID?: any | undefined;
    internalCurrencyUnitPrice?: any | undefined;
    internalCurrencyAdjustedPrice?: any | undefined;
    internalDescription?: any | undefined;
    unitCost?: any | undefined;
    fields?: AutotaskPicklistField[] | undefined;
    id?: number;
    userDefinedFields?: UDFNameValue[] | undefined;

    constructor(data?: IContractServiceRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractID = _data["contractID"];
            this.serviceID = _data["serviceID"];
            this.unitPrice = _data["unitPrice"];
            this.adjustedPrice = _data["adjustedPrice"];
            this.invoiceDescription = _data["invoiceDescription"];
            this.quoteItemID = _data["quoteItemID"];
            this.internalCurrencyUnitPrice = _data["internalCurrencyUnitPrice"];
            this.internalCurrencyAdjustedPrice = _data["internalCurrencyAdjustedPrice"];
            this.internalDescription = _data["internalDescription"];
            this.unitCost = _data["unitCost"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(AutotaskPicklistField.fromJS(item));
            }
            this.id = _data["id"];
            if (Array.isArray(_data["userDefinedFields"])) {
                this.userDefinedFields = [] as any;
                for (let item of _data["userDefinedFields"])
                    this.userDefinedFields!.push(UDFNameValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContractServiceRecord {
        data = typeof data === 'object' ? data : {};
        let result = new ContractServiceRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractID"] = this.contractID;
        data["serviceID"] = this.serviceID;
        data["unitPrice"] = this.unitPrice;
        data["adjustedPrice"] = this.adjustedPrice;
        data["invoiceDescription"] = this.invoiceDescription;
        data["quoteItemID"] = this.quoteItemID;
        data["internalCurrencyUnitPrice"] = this.internalCurrencyUnitPrice;
        data["internalCurrencyAdjustedPrice"] = this.internalCurrencyAdjustedPrice;
        data["internalDescription"] = this.internalDescription;
        data["unitCost"] = this.unitCost;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        data["id"] = this.id;
        if (Array.isArray(this.userDefinedFields)) {
            data["userDefinedFields"] = [];
            for (let item of this.userDefinedFields)
                data["userDefinedFields"].push(item.toJSON());
        }
        return data;
    }
}

export interface IContractServiceRecord {
    contractID?: any | undefined;
    serviceID?: any | undefined;
    unitPrice?: any | undefined;
    adjustedPrice?: any | undefined;
    invoiceDescription?: any | undefined;
    quoteItemID?: any | undefined;
    internalCurrencyUnitPrice?: any | undefined;
    internalCurrencyAdjustedPrice?: any | undefined;
    internalDescription?: any | undefined;
    unitCost?: any | undefined;
    fields?: AutotaskPicklistField[] | undefined;
    id?: number;
    userDefinedFields?: UDFNameValue[] | undefined;
}

export class CiscoReadyReportRecord implements ICiscoReadyReportRecord {
    instanceID?: string | undefined;
    assetType?: string | undefined;
    bestSiteCRPartyID?: string | undefined;
    bestSiteName?: string | undefined;
    bestSiteID?: string | undefined;
    bestSiteCity?: string | undefined;
    bestSiteState?: string | undefined;
    bestSiteCountry?: string | undefined;
    bestSitePostalCode?: string | undefined;
    businessEntity?: string | undefined;
    contract?: string | undefined;
    contractType?: string | undefined;
    coverage?: string | undefined;
    coveredLineStatus?: string | undefined;
    coveredLineStartDate?: string | undefined;
    coveredLineEndDate?: string | undefined;
    endOfProductSaleDate?: string | undefined;
    endOfSoftwareMaintenanceDate?: string | undefined;
    itemQuantity?: string | undefined;
    lDoS?: string | undefined;
    parentInstanceID?: string | undefined;
    productDescription?: string | undefined;
    productFamily?: string | undefined;
    productID?: string | undefined;
    productType?: string | undefined;
    serialNumber?: string | undefined;
    subBusinessEntity?: string | undefined;
    warrantyEndDate?: string | undefined;
    warrantyType?: string | undefined;

    constructor(data?: ICiscoReadyReportRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.instanceID = _data["instanceID"];
            this.assetType = _data["assetType"];
            this.bestSiteCRPartyID = _data["bestSiteCRPartyID"];
            this.bestSiteName = _data["bestSiteName"];
            this.bestSiteID = _data["bestSiteID"];
            this.bestSiteCity = _data["bestSiteCity"];
            this.bestSiteState = _data["bestSiteState"];
            this.bestSiteCountry = _data["bestSiteCountry"];
            this.bestSitePostalCode = _data["bestSitePostalCode"];
            this.businessEntity = _data["businessEntity"];
            this.contract = _data["contract"];
            this.contractType = _data["contractType"];
            this.coverage = _data["coverage"];
            this.coveredLineStatus = _data["coveredLineStatus"];
            this.coveredLineStartDate = _data["coveredLineStartDate"];
            this.coveredLineEndDate = _data["coveredLineEndDate"];
            this.endOfProductSaleDate = _data["endOfProductSaleDate"];
            this.endOfSoftwareMaintenanceDate = _data["endOfSoftwareMaintenanceDate"];
            this.itemQuantity = _data["itemQuantity"];
            this.lDoS = _data["lDoS"];
            this.parentInstanceID = _data["parentInstanceID"];
            this.productDescription = _data["productDescription"];
            this.productFamily = _data["productFamily"];
            this.productID = _data["productID"];
            this.productType = _data["productType"];
            this.serialNumber = _data["serialNumber"];
            this.subBusinessEntity = _data["subBusinessEntity"];
            this.warrantyEndDate = _data["warrantyEndDate"];
            this.warrantyType = _data["warrantyType"];
        }
    }

    static fromJS(data: any): CiscoReadyReportRecord {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoReadyReportRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["instanceID"] = this.instanceID;
        data["assetType"] = this.assetType;
        data["bestSiteCRPartyID"] = this.bestSiteCRPartyID;
        data["bestSiteName"] = this.bestSiteName;
        data["bestSiteID"] = this.bestSiteID;
        data["bestSiteCity"] = this.bestSiteCity;
        data["bestSiteState"] = this.bestSiteState;
        data["bestSiteCountry"] = this.bestSiteCountry;
        data["bestSitePostalCode"] = this.bestSitePostalCode;
        data["businessEntity"] = this.businessEntity;
        data["contract"] = this.contract;
        data["contractType"] = this.contractType;
        data["coverage"] = this.coverage;
        data["coveredLineStatus"] = this.coveredLineStatus;
        data["coveredLineStartDate"] = this.coveredLineStartDate;
        data["coveredLineEndDate"] = this.coveredLineEndDate;
        data["endOfProductSaleDate"] = this.endOfProductSaleDate;
        data["endOfSoftwareMaintenanceDate"] = this.endOfSoftwareMaintenanceDate;
        data["itemQuantity"] = this.itemQuantity;
        data["lDoS"] = this.lDoS;
        data["parentInstanceID"] = this.parentInstanceID;
        data["productDescription"] = this.productDescription;
        data["productFamily"] = this.productFamily;
        data["productID"] = this.productID;
        data["productType"] = this.productType;
        data["serialNumber"] = this.serialNumber;
        data["subBusinessEntity"] = this.subBusinessEntity;
        data["warrantyEndDate"] = this.warrantyEndDate;
        data["warrantyType"] = this.warrantyType;
        return data;
    }
}

export interface ICiscoReadyReportRecord {
    instanceID?: string | undefined;
    assetType?: string | undefined;
    bestSiteCRPartyID?: string | undefined;
    bestSiteName?: string | undefined;
    bestSiteID?: string | undefined;
    bestSiteCity?: string | undefined;
    bestSiteState?: string | undefined;
    bestSiteCountry?: string | undefined;
    bestSitePostalCode?: string | undefined;
    businessEntity?: string | undefined;
    contract?: string | undefined;
    contractType?: string | undefined;
    coverage?: string | undefined;
    coveredLineStatus?: string | undefined;
    coveredLineStartDate?: string | undefined;
    coveredLineEndDate?: string | undefined;
    endOfProductSaleDate?: string | undefined;
    endOfSoftwareMaintenanceDate?: string | undefined;
    itemQuantity?: string | undefined;
    lDoS?: string | undefined;
    parentInstanceID?: string | undefined;
    productDescription?: string | undefined;
    productFamily?: string | undefined;
    productID?: string | undefined;
    productType?: string | undefined;
    serialNumber?: string | undefined;
    subBusinessEntity?: string | undefined;
    warrantyEndDate?: string | undefined;
    warrantyType?: string | undefined;
}

export class EvaluatedCiscoReadyReportRecord implements IEvaluatedCiscoReadyReportRecord {
    errorMessages?: string[] | undefined;
    record?: CiscoReadyReportRecord;
    row?: number;

    constructor(data?: IEvaluatedCiscoReadyReportRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.record = _data["record"] ? CiscoReadyReportRecord.fromJS(_data["record"]) : <any>undefined;
            this.row = _data["row"];
        }
    }

    static fromJS(data: any): EvaluatedCiscoReadyReportRecord {
        data = typeof data === 'object' ? data : {};
        let result = new EvaluatedCiscoReadyReportRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["record"] = this.record ? this.record.toJSON() : <any>undefined;
        data["row"] = this.row;
        return data;
    }
}

export interface IEvaluatedCiscoReadyReportRecord {
    errorMessages?: string[] | undefined;
    record?: CiscoReadyReportRecord;
    row?: number;
}

export class OldField implements IOldField {
    name?: string | undefined;
    label?: string | undefined;
    type?: string | undefined;
    length?: number;
    description?: string | undefined;
    isRequired?: boolean;
    isReadOnly?: boolean;
    isQueryable?: boolean;
    isReference?: boolean;
    referenceEntityType?: string | undefined;
    isPickList?: boolean;
    picklistValues?: OldPickListValue[] | undefined;
    picklistParentValueField?: string | undefined;
    defaultValue?: string | undefined;
    isSupportedWebhookField?: boolean;

    constructor(data?: IOldField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.label = _data["label"];
            this.type = _data["type"];
            this.length = _data["length"];
            this.description = _data["description"];
            this.isRequired = _data["isRequired"];
            this.isReadOnly = _data["isReadOnly"];
            this.isQueryable = _data["isQueryable"];
            this.isReference = _data["isReference"];
            this.referenceEntityType = _data["referenceEntityType"];
            this.isPickList = _data["isPickList"];
            if (Array.isArray(_data["picklistValues"])) {
                this.picklistValues = [] as any;
                for (let item of _data["picklistValues"])
                    this.picklistValues!.push(OldPickListValue.fromJS(item));
            }
            this.picklistParentValueField = _data["picklistParentValueField"];
            this.defaultValue = _data["defaultValue"];
            this.isSupportedWebhookField = _data["isSupportedWebhookField"];
        }
    }

    static fromJS(data: any): OldField {
        data = typeof data === 'object' ? data : {};
        let result = new OldField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["label"] = this.label;
        data["type"] = this.type;
        data["length"] = this.length;
        data["description"] = this.description;
        data["isRequired"] = this.isRequired;
        data["isReadOnly"] = this.isReadOnly;
        data["isQueryable"] = this.isQueryable;
        data["isReference"] = this.isReference;
        data["referenceEntityType"] = this.referenceEntityType;
        data["isPickList"] = this.isPickList;
        if (Array.isArray(this.picklistValues)) {
            data["picklistValues"] = [];
            for (let item of this.picklistValues)
                data["picklistValues"].push(item.toJSON());
        }
        data["picklistParentValueField"] = this.picklistParentValueField;
        data["defaultValue"] = this.defaultValue;
        data["isSupportedWebhookField"] = this.isSupportedWebhookField;
        return data;
    }
}

export interface IOldField {
    name?: string | undefined;
    label?: string | undefined;
    type?: string | undefined;
    length?: number;
    description?: string | undefined;
    isRequired?: boolean;
    isReadOnly?: boolean;
    isQueryable?: boolean;
    isReference?: boolean;
    referenceEntityType?: string | undefined;
    isPickList?: boolean;
    picklistValues?: OldPickListValue[] | undefined;
    picklistParentValueField?: string | undefined;
    defaultValue?: string | undefined;
    isSupportedWebhookField?: boolean;
}

export class OldPickListValue implements IOldPickListValue {
    value?: string | undefined;
    label?: string | undefined;
    isDefaultValue?: boolean;
    sortOrder?: number;
    parentValue?: string | undefined;
    isActive?: boolean;
    isActiveSpecified?: boolean;
    isSystem?: boolean;
    isSystemSpecified?: boolean;

    constructor(data?: IOldPickListValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.label = _data["label"];
            this.isDefaultValue = _data["isDefaultValue"];
            this.sortOrder = _data["sortOrder"];
            this.parentValue = _data["parentValue"];
            this.isActive = _data["isActive"];
            this.isActiveSpecified = _data["isActiveSpecified"];
            this.isSystem = _data["isSystem"];
            this.isSystemSpecified = _data["isSystemSpecified"];
        }
    }

    static fromJS(data: any): OldPickListValue {
        data = typeof data === 'object' ? data : {};
        let result = new OldPickListValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["label"] = this.label;
        data["isDefaultValue"] = this.isDefaultValue;
        data["sortOrder"] = this.sortOrder;
        data["parentValue"] = this.parentValue;
        data["isActive"] = this.isActive;
        data["isActiveSpecified"] = this.isActiveSpecified;
        data["isSystem"] = this.isSystem;
        data["isSystemSpecified"] = this.isSystemSpecified;
        return data;
    }
}

export interface IOldPickListValue {
    value?: string | undefined;
    label?: string | undefined;
    isDefaultValue?: boolean;
    sortOrder?: number;
    parentValue?: string | undefined;
    isActive?: boolean;
    isActiveSpecified?: boolean;
    isSystem?: boolean;
    isSystemSpecified?: boolean;
}

export class OldPicklistValue implements IOldPicklistValue {
    entityType?: string | undefined;
    fields?: OldField[] | undefined;

    constructor(data?: IOldPicklistValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityType = _data["entityType"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(OldField.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OldPicklistValue {
        data = typeof data === 'object' ? data : {};
        let result = new OldPicklistValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityType"] = this.entityType;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOldPicklistValue {
    entityType?: string | undefined;
    fields?: OldField[] | undefined;
}

export class ServiceRecord implements IServiceRecord {
    id?: number;
    allocationCodeID?: number;
    createDate?: Date | undefined;
    creatorResourceId?: number | undefined;
    description?: string | undefined;
    invoiceDescription?: string | undefined;
    isActive?: boolean;
    lastModifiedDate?: Date | undefined;
    markupRate?: number | undefined;
    name?: string | undefined;
    periodType?: string | undefined;
    serviceLevelAgreementId?: number | undefined;
    unitCost?: number | undefined;
    unitPrice?: number;
    updateResourceId?: number | undefined;
    vendorAccountId?: number | undefined;

    constructor(data?: IServiceRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.allocationCodeID = _data["allocationCodeID"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.creatorResourceId = _data["creatorResourceId"];
            this.description = _data["description"];
            this.invoiceDescription = _data["invoiceDescription"];
            this.isActive = _data["isActive"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            this.markupRate = _data["markupRate"];
            this.name = _data["name"];
            this.periodType = _data["periodType"];
            this.serviceLevelAgreementId = _data["serviceLevelAgreementId"];
            this.unitCost = _data["unitCost"];
            this.unitPrice = _data["unitPrice"];
            this.updateResourceId = _data["updateResourceId"];
            this.vendorAccountId = _data["vendorAccountId"];
        }
    }

    static fromJS(data: any): ServiceRecord {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["allocationCodeID"] = this.allocationCodeID;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["creatorResourceId"] = this.creatorResourceId;
        data["description"] = this.description;
        data["invoiceDescription"] = this.invoiceDescription;
        data["isActive"] = this.isActive;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["markupRate"] = this.markupRate;
        data["name"] = this.name;
        data["periodType"] = this.periodType;
        data["serviceLevelAgreementId"] = this.serviceLevelAgreementId;
        data["unitCost"] = this.unitCost;
        data["unitPrice"] = this.unitPrice;
        data["updateResourceId"] = this.updateResourceId;
        data["vendorAccountId"] = this.vendorAccountId;
        return data;
    }
}

export interface IServiceRecord {
    id?: number;
    allocationCodeID?: number;
    createDate?: Date | undefined;
    creatorResourceId?: number | undefined;
    description?: string | undefined;
    invoiceDescription?: string | undefined;
    isActive?: boolean;
    lastModifiedDate?: Date | undefined;
    markupRate?: number | undefined;
    name?: string | undefined;
    periodType?: string | undefined;
    serviceLevelAgreementId?: number | undefined;
    unitCost?: number | undefined;
    unitPrice?: number;
    updateResourceId?: number | undefined;
    vendorAccountId?: number | undefined;
}

export class UDFNameValue implements IUDFNameValue {
    name?: string | undefined;
    value?: string | undefined;

    constructor(data?: IUDFNameValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UDFNameValue {
        data = typeof data === 'object' ? data : {};
        let result = new UDFNameValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IUDFNameValue {
    name?: string | undefined;
    value?: string | undefined;
}

export class KeyValuePair_2OfInt32AndInt32 implements IKeyValuePair_2OfInt32AndInt32 {
    key?: number;
    value?: number;

    constructor(data?: IKeyValuePair_2OfInt32AndInt32) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): KeyValuePair_2OfInt32AndInt32 {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValuePair_2OfInt32AndInt32();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IKeyValuePair_2OfInt32AndInt32 {
    key?: number;
    value?: number;
}

export class KeyValuePair_2OfStringAndIEnumerable_1OfString implements IKeyValuePair_2OfStringAndIEnumerable_1OfString {
    key?: string | undefined;
    value?: string[] | undefined;

    constructor(data?: IKeyValuePair_2OfStringAndIEnumerable_1OfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(item);
            }
        }
    }

    static fromJS(data: any): KeyValuePair_2OfStringAndIEnumerable_1OfString {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValuePair_2OfStringAndIEnumerable_1OfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item);
        }
        return data;
    }
}

export interface IKeyValuePair_2OfStringAndIEnumerable_1OfString {
    key?: string | undefined;
    value?: string[] | undefined;
}

export class HttpContent implements IHttpContent {
    readonly headers?: KeyValuePair_2OfStringAndIEnumerable_1OfString[] | undefined;

    constructor(data?: IHttpContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["headers"])) {
                (<any>this).headers = [] as any;
                for (let item of _data["headers"])
                    (<any>this).headers!.push(KeyValuePair_2OfStringAndIEnumerable_1OfString.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HttpContent {
        data = typeof data === 'object' ? data : {};
        let result = new HttpContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.headers)) {
            data["headers"] = [];
            for (let item of this.headers)
                data["headers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHttpContent {
    headers?: KeyValuePair_2OfStringAndIEnumerable_1OfString[] | undefined;
}

export enum HttpStatusCode {
    Continue = "Continue",
    SwitchingProtocols = "SwitchingProtocols",
    Processing = "Processing",
    EarlyHints = "EarlyHints",
    OK = "OK",
    Created = "Created",
    Accepted = "Accepted",
    NonAuthoritativeInformation = "NonAuthoritativeInformation",
    NoContent = "NoContent",
    ResetContent = "ResetContent",
    PartialContent = "PartialContent",
    MultiStatus = "MultiStatus",
    AlreadyReported = "AlreadyReported",
    IMUsed = "IMUsed",
    MultipleChoices = "MultipleChoices",
    MovedPermanently = "MovedPermanently",
    Found = "Found",
    SeeOther = "SeeOther",
    NotModified = "NotModified",
    UseProxy = "UseProxy",
    Unused = "Unused",
    RedirectKeepVerb = "RedirectKeepVerb",
    PermanentRedirect = "PermanentRedirect",
    BadRequest = "BadRequest",
    Unauthorized = "Unauthorized",
    PaymentRequired = "PaymentRequired",
    Forbidden = "Forbidden",
    NotFound = "NotFound",
    MethodNotAllowed = "MethodNotAllowed",
    NotAcceptable = "NotAcceptable",
    ProxyAuthenticationRequired = "ProxyAuthenticationRequired",
    RequestTimeout = "RequestTimeout",
    Conflict = "Conflict",
    Gone = "Gone",
    LengthRequired = "LengthRequired",
    PreconditionFailed = "PreconditionFailed",
    RequestEntityTooLarge = "RequestEntityTooLarge",
    RequestUriTooLong = "RequestUriTooLong",
    UnsupportedMediaType = "UnsupportedMediaType",
    RequestedRangeNotSatisfiable = "RequestedRangeNotSatisfiable",
    ExpectationFailed = "ExpectationFailed",
    MisdirectedRequest = "MisdirectedRequest",
    UnprocessableEntity = "UnprocessableEntity",
    Locked = "Locked",
    FailedDependency = "FailedDependency",
    UpgradeRequired = "UpgradeRequired",
    PreconditionRequired = "PreconditionRequired",
    TooManyRequests = "TooManyRequests",
    RequestHeaderFieldsTooLarge = "RequestHeaderFieldsTooLarge",
    UnavailableForLegalReasons = "UnavailableForLegalReasons",
    InternalServerError = "InternalServerError",
    NotImplemented = "NotImplemented",
    BadGateway = "BadGateway",
    ServiceUnavailable = "ServiceUnavailable",
    GatewayTimeout = "GatewayTimeout",
    HttpVersionNotSupported = "HttpVersionNotSupported",
    VariantAlsoNegotiates = "VariantAlsoNegotiates",
    InsufficientStorage = "InsufficientStorage",
    LoopDetected = "LoopDetected",
    NotExtended = "NotExtended",
    NetworkAuthenticationRequired = "NetworkAuthenticationRequired",
}

export class Body implements IBody {
    attachments?: string[];

    [key: string]: any;

    constructor(data?: IBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(item);
            }
        }
    }

    static fromJS(data: any): Body {
        data = typeof data === 'object' ? data : {};
        let result = new Body();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item);
        }
        return data;
    }
}

export interface IBody {
    attachments?: string[];

    [key: string]: any;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}